webpackJsonp([0],[
/* 0 */
/***/ (function(module, exports) {

/* globals __VUE_SSR_CONTEXT__ */

// this module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle

module.exports = function normalizeComponent (
  rawScriptExports,
  compiledTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */
) {
  var esModule
  var scriptExports = rawScriptExports = rawScriptExports || {}

  // ES6 modules interop
  var type = typeof rawScriptExports.default
  if (type === 'object' || type === 'function') {
    esModule = rawScriptExports
    scriptExports = rawScriptExports.default
  }

  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (compiledTemplate) {
    options.render = compiledTemplate.render
    options.staticRenderFns = compiledTemplate.staticRenderFns
  }

  // scopedId
  if (scopeId) {
    options._scopeId = scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = injectStyles
  }

  if (hook) {
    var functional = options.functional
    var existing = functional
      ? options.render
      : options.beforeCreate
    if (!functional) {
      // inject component registration as beforeCreate hook
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    } else {
      // register for functioal component in vue file
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return existing(h, context)
      }
    }
  }

  return {
    esModule: esModule,
    exports: scriptExports,
    options: options
  }
}


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(8);

/*global toString:true*/

// utils is a library of generic helper functions non-specific to axios

var toString = Object.prototype.toString;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */
function isArray(val) {
  return toString.call(val) === '[object Array]';
}

/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */
function isUndefined(val) {
  return typeof val === 'undefined';
}

/**
 * Determine if a value is a Buffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Buffer, otherwise false
 */
function isBuffer(val) {
  return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor)
    && typeof val.constructor.isBuffer === 'function' && val.constructor.isBuffer(val);
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
function isArrayBuffer(val) {
  return toString.call(val) === '[object ArrayBuffer]';
}

/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */
function isFormData(val) {
  return (typeof FormData !== 'undefined') && (val instanceof FormData);
}

/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  var result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */
function isString(val) {
  return typeof val === 'string';
}

/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */
function isNumber(val) {
  return typeof val === 'number';
}

/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */
function isObject(val) {
  return val !== null && typeof val === 'object';
}

/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */
function isDate(val) {
  return toString.call(val) === '[object Date]';
}

/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
function isFile(val) {
  return toString.call(val) === '[object File]';
}

/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */
function isBlob(val) {
  return toString.call(val) === '[object Blob]';
}

/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
function isFunction(val) {
  return toString.call(val) === '[object Function]';
}

/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */
function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
}

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
function isURLSearchParams(val) {
  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
}

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */
function trim(str) {
  return str.replace(/^\s*/, '').replace(/\s*$/, '');
}

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 */
function isStandardBrowserEnv() {
  if (typeof navigator !== 'undefined' && (navigator.product === 'ReactNative' ||
                                           navigator.product === 'NativeScript' ||
                                           navigator.product === 'NS')) {
    return false;
  }
  return (
    typeof window !== 'undefined' &&
    typeof document !== 'undefined'
  );
}

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */
function forEach(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (typeof result[key] === 'object' && typeof val === 'object') {
      result[key] = merge(result[key], val);
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Function equal to merge with the difference being that no reference
 * to original objects is kept.
 *
 * @see merge
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function deepMerge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (typeof result[key] === 'object' && typeof val === 'object') {
      result[key] = deepMerge(result[key], val);
    } else if (typeof val === 'object') {
      result[key] = deepMerge({}, val);
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */
function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}

module.exports = {
  isArray: isArray,
  isArrayBuffer: isArrayBuffer,
  isBuffer: isBuffer,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString,
  isNumber: isNumber,
  isObject: isObject,
  isUndefined: isUndefined,
  isDate: isDate,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach,
  merge: merge,
  deepMerge: deepMerge,
  extend: extend,
  trim: trim
};


/***/ }),
/* 2 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, setImmediate) {/*!
 * Vue.js v2.6.12
 * (c) 2014-2020 Evan You
 * Released under the MIT License.
 */
/*  */

var emptyObject = Object.freeze({});

// These helpers produce better VM code in JS engines due to their
// explicitness and function inlining.
function isUndef (v) {
  return v === undefined || v === null
}

function isDef (v) {
  return v !== undefined && v !== null
}

function isTrue (v) {
  return v === true
}

function isFalse (v) {
  return v === false
}

/**
 * Check if value is primitive.
 */
function isPrimitive (value) {
  return (
    typeof value === 'string' ||
    typeof value === 'number' ||
    // $flow-disable-line
    typeof value === 'symbol' ||
    typeof value === 'boolean'
  )
}

/**
 * Quick object check - this is primarily used to tell
 * Objects from primitive values when we know the value
 * is a JSON-compliant type.
 */
function isObject (obj) {
  return obj !== null && typeof obj === 'object'
}

/**
 * Get the raw type string of a value, e.g., [object Object].
 */
var _toString = Object.prototype.toString;

function toRawType (value) {
  return _toString.call(value).slice(8, -1)
}

/**
 * Strict object type check. Only returns true
 * for plain JavaScript objects.
 */
function isPlainObject (obj) {
  return _toString.call(obj) === '[object Object]'
}

function isRegExp (v) {
  return _toString.call(v) === '[object RegExp]'
}

/**
 * Check if val is a valid array index.
 */
function isValidArrayIndex (val) {
  var n = parseFloat(String(val));
  return n >= 0 && Math.floor(n) === n && isFinite(val)
}

function isPromise (val) {
  return (
    isDef(val) &&
    typeof val.then === 'function' &&
    typeof val.catch === 'function'
  )
}

/**
 * Convert a value to a string that is actually rendered.
 */
function toString (val) {
  return val == null
    ? ''
    : Array.isArray(val) || (isPlainObject(val) && val.toString === _toString)
      ? JSON.stringify(val, null, 2)
      : String(val)
}

/**
 * Convert an input value to a number for persistence.
 * If the conversion fails, return original string.
 */
function toNumber (val) {
  var n = parseFloat(val);
  return isNaN(n) ? val : n
}

/**
 * Make a map and return a function for checking if a key
 * is in that map.
 */
function makeMap (
  str,
  expectsLowerCase
) {
  var map = Object.create(null);
  var list = str.split(',');
  for (var i = 0; i < list.length; i++) {
    map[list[i]] = true;
  }
  return expectsLowerCase
    ? function (val) { return map[val.toLowerCase()]; }
    : function (val) { return map[val]; }
}

/**
 * Check if a tag is a built-in tag.
 */
var isBuiltInTag = makeMap('slot,component', true);

/**
 * Check if an attribute is a reserved attribute.
 */
var isReservedAttribute = makeMap('key,ref,slot,slot-scope,is');

/**
 * Remove an item from an array.
 */
function remove (arr, item) {
  if (arr.length) {
    var index = arr.indexOf(item);
    if (index > -1) {
      return arr.splice(index, 1)
    }
  }
}

/**
 * Check whether an object has the property.
 */
var hasOwnProperty = Object.prototype.hasOwnProperty;
function hasOwn (obj, key) {
  return hasOwnProperty.call(obj, key)
}

/**
 * Create a cached version of a pure function.
 */
function cached (fn) {
  var cache = Object.create(null);
  return (function cachedFn (str) {
    var hit = cache[str];
    return hit || (cache[str] = fn(str))
  })
}

/**
 * Camelize a hyphen-delimited string.
 */
var camelizeRE = /-(\w)/g;
var camelize = cached(function (str) {
  return str.replace(camelizeRE, function (_, c) { return c ? c.toUpperCase() : ''; })
});

/**
 * Capitalize a string.
 */
var capitalize = cached(function (str) {
  return str.charAt(0).toUpperCase() + str.slice(1)
});

/**
 * Hyphenate a camelCase string.
 */
var hyphenateRE = /\B([A-Z])/g;
var hyphenate = cached(function (str) {
  return str.replace(hyphenateRE, '-$1').toLowerCase()
});

/**
 * Simple bind polyfill for environments that do not support it,
 * e.g., PhantomJS 1.x. Technically, we don't need this anymore
 * since native bind is now performant enough in most browsers.
 * But removing it would mean breaking code that was able to run in
 * PhantomJS 1.x, so this must be kept for backward compatibility.
 */

/* istanbul ignore next */
function polyfillBind (fn, ctx) {
  function boundFn (a) {
    var l = arguments.length;
    return l
      ? l > 1
        ? fn.apply(ctx, arguments)
        : fn.call(ctx, a)
      : fn.call(ctx)
  }

  boundFn._length = fn.length;
  return boundFn
}

function nativeBind (fn, ctx) {
  return fn.bind(ctx)
}

var bind = Function.prototype.bind
  ? nativeBind
  : polyfillBind;

/**
 * Convert an Array-like object to a real Array.
 */
function toArray (list, start) {
  start = start || 0;
  var i = list.length - start;
  var ret = new Array(i);
  while (i--) {
    ret[i] = list[i + start];
  }
  return ret
}

/**
 * Mix properties into target object.
 */
function extend (to, _from) {
  for (var key in _from) {
    to[key] = _from[key];
  }
  return to
}

/**
 * Merge an Array of Objects into a single Object.
 */
function toObject (arr) {
  var res = {};
  for (var i = 0; i < arr.length; i++) {
    if (arr[i]) {
      extend(res, arr[i]);
    }
  }
  return res
}

/* eslint-disable no-unused-vars */

/**
 * Perform no operation.
 * Stubbing args to make Flow happy without leaving useless transpiled code
 * with ...rest (https://flow.org/blog/2017/05/07/Strict-Function-Call-Arity/).
 */
function noop (a, b, c) {}

/**
 * Always return false.
 */
var no = function (a, b, c) { return false; };

/* eslint-enable no-unused-vars */

/**
 * Return the same value.
 */
var identity = function (_) { return _; };

/**
 * Generate a string containing static keys from compiler modules.
 */
function genStaticKeys (modules) {
  return modules.reduce(function (keys, m) {
    return keys.concat(m.staticKeys || [])
  }, []).join(',')
}

/**
 * Check if two values are loosely equal - that is,
 * if they are plain objects, do they have the same shape?
 */
function looseEqual (a, b) {
  if (a === b) { return true }
  var isObjectA = isObject(a);
  var isObjectB = isObject(b);
  if (isObjectA && isObjectB) {
    try {
      var isArrayA = Array.isArray(a);
      var isArrayB = Array.isArray(b);
      if (isArrayA && isArrayB) {
        return a.length === b.length && a.every(function (e, i) {
          return looseEqual(e, b[i])
        })
      } else if (a instanceof Date && b instanceof Date) {
        return a.getTime() === b.getTime()
      } else if (!isArrayA && !isArrayB) {
        var keysA = Object.keys(a);
        var keysB = Object.keys(b);
        return keysA.length === keysB.length && keysA.every(function (key) {
          return looseEqual(a[key], b[key])
        })
      } else {
        /* istanbul ignore next */
        return false
      }
    } catch (e) {
      /* istanbul ignore next */
      return false
    }
  } else if (!isObjectA && !isObjectB) {
    return String(a) === String(b)
  } else {
    return false
  }
}

/**
 * Return the first index at which a loosely equal value can be
 * found in the array (if value is a plain object, the array must
 * contain an object of the same shape), or -1 if it is not present.
 */
function looseIndexOf (arr, val) {
  for (var i = 0; i < arr.length; i++) {
    if (looseEqual(arr[i], val)) { return i }
  }
  return -1
}

/**
 * Ensure a function is called only once.
 */
function once (fn) {
  var called = false;
  return function () {
    if (!called) {
      called = true;
      fn.apply(this, arguments);
    }
  }
}

var SSR_ATTR = 'data-server-rendered';

var ASSET_TYPES = [
  'component',
  'directive',
  'filter'
];

var LIFECYCLE_HOOKS = [
  'beforeCreate',
  'created',
  'beforeMount',
  'mounted',
  'beforeUpdate',
  'updated',
  'beforeDestroy',
  'destroyed',
  'activated',
  'deactivated',
  'errorCaptured',
  'serverPrefetch'
];

/*  */



var config = ({
  /**
   * Option merge strategies (used in core/util/options)
   */
  // $flow-disable-line
  optionMergeStrategies: Object.create(null),

  /**
   * Whether to suppress warnings.
   */
  silent: false,

  /**
   * Show production mode tip message on boot?
   */
  productionTip: "production" !== 'production',

  /**
   * Whether to enable devtools
   */
  devtools: "production" !== 'production',

  /**
   * Whether to record perf
   */
  performance: false,

  /**
   * Error handler for watcher errors
   */
  errorHandler: null,

  /**
   * Warn handler for watcher warns
   */
  warnHandler: null,

  /**
   * Ignore certain custom elements
   */
  ignoredElements: [],

  /**
   * Custom user key aliases for v-on
   */
  // $flow-disable-line
  keyCodes: Object.create(null),

  /**
   * Check if a tag is reserved so that it cannot be registered as a
   * component. This is platform-dependent and may be overwritten.
   */
  isReservedTag: no,

  /**
   * Check if an attribute is reserved so that it cannot be used as a component
   * prop. This is platform-dependent and may be overwritten.
   */
  isReservedAttr: no,

  /**
   * Check if a tag is an unknown element.
   * Platform-dependent.
   */
  isUnknownElement: no,

  /**
   * Get the namespace of an element
   */
  getTagNamespace: noop,

  /**
   * Parse the real tag name for the specific platform.
   */
  parsePlatformTagName: identity,

  /**
   * Check if an attribute must be bound using property, e.g. value
   * Platform-dependent.
   */
  mustUseProp: no,

  /**
   * Perform updates asynchronously. Intended to be used by Vue Test Utils
   * This will significantly reduce performance if set to false.
   */
  async: true,

  /**
   * Exposed for legacy reasons
   */
  _lifecycleHooks: LIFECYCLE_HOOKS
});

/*  */

/**
 * unicode letters used for parsing html tags, component names and property paths.
 * using https://www.w3.org/TR/html53/semantics-scripting.html#potentialcustomelementname
 * skipping \u10000-\uEFFFF due to it freezing up PhantomJS
 */
var unicodeRegExp = /a-zA-Z\u00B7\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u037D\u037F-\u1FFF\u200C-\u200D\u203F-\u2040\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD/;

/**
 * Check if a string starts with $ or _
 */
function isReserved (str) {
  var c = (str + '').charCodeAt(0);
  return c === 0x24 || c === 0x5F
}

/**
 * Define a property.
 */
function def (obj, key, val, enumerable) {
  Object.defineProperty(obj, key, {
    value: val,
    enumerable: !!enumerable,
    writable: true,
    configurable: true
  });
}

/**
 * Parse simple path.
 */
var bailRE = new RegExp(("[^" + (unicodeRegExp.source) + ".$_\\d]"));
function parsePath (path) {
  if (bailRE.test(path)) {
    return
  }
  var segments = path.split('.');
  return function (obj) {
    for (var i = 0; i < segments.length; i++) {
      if (!obj) { return }
      obj = obj[segments[i]];
    }
    return obj
  }
}

/*  */

// can we use __proto__?
var hasProto = '__proto__' in {};

// Browser environment sniffing
var inBrowser = typeof window !== 'undefined';
var inWeex = typeof WXEnvironment !== 'undefined' && !!WXEnvironment.platform;
var weexPlatform = inWeex && WXEnvironment.platform.toLowerCase();
var UA = inBrowser && window.navigator.userAgent.toLowerCase();
var isIE = UA && /msie|trident/.test(UA);
var isIE9 = UA && UA.indexOf('msie 9.0') > 0;
var isEdge = UA && UA.indexOf('edge/') > 0;
var isAndroid = (UA && UA.indexOf('android') > 0) || (weexPlatform === 'android');
var isIOS = (UA && /iphone|ipad|ipod|ios/.test(UA)) || (weexPlatform === 'ios');
var isChrome = UA && /chrome\/\d+/.test(UA) && !isEdge;
var isPhantomJS = UA && /phantomjs/.test(UA);
var isFF = UA && UA.match(/firefox\/(\d+)/);

// Firefox has a "watch" function on Object.prototype...
var nativeWatch = ({}).watch;

var supportsPassive = false;
if (inBrowser) {
  try {
    var opts = {};
    Object.defineProperty(opts, 'passive', ({
      get: function get () {
        /* istanbul ignore next */
        supportsPassive = true;
      }
    })); // https://github.com/facebook/flow/issues/285
    window.addEventListener('test-passive', null, opts);
  } catch (e) {}
}

// this needs to be lazy-evaled because vue may be required before
// vue-server-renderer can set VUE_ENV
var _isServer;
var isServerRendering = function () {
  if (_isServer === undefined) {
    /* istanbul ignore if */
    if (!inBrowser && !inWeex && typeof global !== 'undefined') {
      // detect presence of vue-server-renderer and avoid
      // Webpack shimming the process
      _isServer = global['process'] && global['process'].env.VUE_ENV === 'server';
    } else {
      _isServer = false;
    }
  }
  return _isServer
};

// detect devtools
var devtools = inBrowser && window.__VUE_DEVTOOLS_GLOBAL_HOOK__;

/* istanbul ignore next */
function isNative (Ctor) {
  return typeof Ctor === 'function' && /native code/.test(Ctor.toString())
}

var hasSymbol =
  typeof Symbol !== 'undefined' && isNative(Symbol) &&
  typeof Reflect !== 'undefined' && isNative(Reflect.ownKeys);

var _Set;
/* istanbul ignore if */ // $flow-disable-line
if (typeof Set !== 'undefined' && isNative(Set)) {
  // use native Set when available.
  _Set = Set;
} else {
  // a non-standard Set polyfill that only works with primitive keys.
  _Set = /*@__PURE__*/(function () {
    function Set () {
      this.set = Object.create(null);
    }
    Set.prototype.has = function has (key) {
      return this.set[key] === true
    };
    Set.prototype.add = function add (key) {
      this.set[key] = true;
    };
    Set.prototype.clear = function clear () {
      this.set = Object.create(null);
    };

    return Set;
  }());
}

/*  */

var warn = noop;
var tip = noop;
var generateComponentTrace = (noop); // work around flow check
var formatComponentName = (noop);

if (false) {
  var hasConsole = typeof console !== 'undefined';
  var classifyRE = /(?:^|[-_])(\w)/g;
  var classify = function (str) { return str
    .replace(classifyRE, function (c) { return c.toUpperCase(); })
    .replace(/[-_]/g, ''); };

  warn = function (msg, vm) {
    var trace = vm ? generateComponentTrace(vm) : '';

    if (config.warnHandler) {
      config.warnHandler.call(null, msg, vm, trace);
    } else if (hasConsole && (!config.silent)) {
      console.error(("[Vue warn]: " + msg + trace));
    }
  };

  tip = function (msg, vm) {
    if (hasConsole && (!config.silent)) {
      console.warn("[Vue tip]: " + msg + (
        vm ? generateComponentTrace(vm) : ''
      ));
    }
  };

  formatComponentName = function (vm, includeFile) {
    if (vm.$root === vm) {
      return '<Root>'
    }
    var options = typeof vm === 'function' && vm.cid != null
      ? vm.options
      : vm._isVue
        ? vm.$options || vm.constructor.options
        : vm;
    var name = options.name || options._componentTag;
    var file = options.__file;
    if (!name && file) {
      var match = file.match(/([^/\\]+)\.vue$/);
      name = match && match[1];
    }

    return (
      (name ? ("<" + (classify(name)) + ">") : "<Anonymous>") +
      (file && includeFile !== false ? (" at " + file) : '')
    )
  };

  var repeat = function (str, n) {
    var res = '';
    while (n) {
      if (n % 2 === 1) { res += str; }
      if (n > 1) { str += str; }
      n >>= 1;
    }
    return res
  };

  generateComponentTrace = function (vm) {
    if (vm._isVue && vm.$parent) {
      var tree = [];
      var currentRecursiveSequence = 0;
      while (vm) {
        if (tree.length > 0) {
          var last = tree[tree.length - 1];
          if (last.constructor === vm.constructor) {
            currentRecursiveSequence++;
            vm = vm.$parent;
            continue
          } else if (currentRecursiveSequence > 0) {
            tree[tree.length - 1] = [last, currentRecursiveSequence];
            currentRecursiveSequence = 0;
          }
        }
        tree.push(vm);
        vm = vm.$parent;
      }
      return '\n\nfound in\n\n' + tree
        .map(function (vm, i) { return ("" + (i === 0 ? '---> ' : repeat(' ', 5 + i * 2)) + (Array.isArray(vm)
            ? ((formatComponentName(vm[0])) + "... (" + (vm[1]) + " recursive calls)")
            : formatComponentName(vm))); })
        .join('\n')
    } else {
      return ("\n\n(found in " + (formatComponentName(vm)) + ")")
    }
  };
}

/*  */

var uid = 0;

/**
 * A dep is an observable that can have multiple
 * directives subscribing to it.
 */
var Dep = function Dep () {
  this.id = uid++;
  this.subs = [];
};

Dep.prototype.addSub = function addSub (sub) {
  this.subs.push(sub);
};

Dep.prototype.removeSub = function removeSub (sub) {
  remove(this.subs, sub);
};

Dep.prototype.depend = function depend () {
  if (Dep.target) {
    Dep.target.addDep(this);
  }
};

Dep.prototype.notify = function notify () {
  // stabilize the subscriber list first
  var subs = this.subs.slice();
  if (false) {
    // subs aren't sorted in scheduler if not running async
    // we need to sort them now to make sure they fire in correct
    // order
    subs.sort(function (a, b) { return a.id - b.id; });
  }
  for (var i = 0, l = subs.length; i < l; i++) {
    subs[i].update();
  }
};

// The current target watcher being evaluated.
// This is globally unique because only one watcher
// can be evaluated at a time.
Dep.target = null;
var targetStack = [];

function pushTarget (target) {
  targetStack.push(target);
  Dep.target = target;
}

function popTarget () {
  targetStack.pop();
  Dep.target = targetStack[targetStack.length - 1];
}

/*  */

var VNode = function VNode (
  tag,
  data,
  children,
  text,
  elm,
  context,
  componentOptions,
  asyncFactory
) {
  this.tag = tag;
  this.data = data;
  this.children = children;
  this.text = text;
  this.elm = elm;
  this.ns = undefined;
  this.context = context;
  this.fnContext = undefined;
  this.fnOptions = undefined;
  this.fnScopeId = undefined;
  this.key = data && data.key;
  this.componentOptions = componentOptions;
  this.componentInstance = undefined;
  this.parent = undefined;
  this.raw = false;
  this.isStatic = false;
  this.isRootInsert = true;
  this.isComment = false;
  this.isCloned = false;
  this.isOnce = false;
  this.asyncFactory = asyncFactory;
  this.asyncMeta = undefined;
  this.isAsyncPlaceholder = false;
};

var prototypeAccessors = { child: { configurable: true } };

// DEPRECATED: alias for componentInstance for backwards compat.
/* istanbul ignore next */
prototypeAccessors.child.get = function () {
  return this.componentInstance
};

Object.defineProperties( VNode.prototype, prototypeAccessors );

var createEmptyVNode = function (text) {
  if ( text === void 0 ) text = '';

  var node = new VNode();
  node.text = text;
  node.isComment = true;
  return node
};

function createTextVNode (val) {
  return new VNode(undefined, undefined, undefined, String(val))
}

// optimized shallow clone
// used for static nodes and slot nodes because they may be reused across
// multiple renders, cloning them avoids errors when DOM manipulations rely
// on their elm reference.
function cloneVNode (vnode) {
  var cloned = new VNode(
    vnode.tag,
    vnode.data,
    // #7975
    // clone children array to avoid mutating original in case of cloning
    // a child.
    vnode.children && vnode.children.slice(),
    vnode.text,
    vnode.elm,
    vnode.context,
    vnode.componentOptions,
    vnode.asyncFactory
  );
  cloned.ns = vnode.ns;
  cloned.isStatic = vnode.isStatic;
  cloned.key = vnode.key;
  cloned.isComment = vnode.isComment;
  cloned.fnContext = vnode.fnContext;
  cloned.fnOptions = vnode.fnOptions;
  cloned.fnScopeId = vnode.fnScopeId;
  cloned.asyncMeta = vnode.asyncMeta;
  cloned.isCloned = true;
  return cloned
}

/*
 * not type checking this file because flow doesn't play well with
 * dynamically accessing methods on Array prototype
 */

var arrayProto = Array.prototype;
var arrayMethods = Object.create(arrayProto);

var methodsToPatch = [
  'push',
  'pop',
  'shift',
  'unshift',
  'splice',
  'sort',
  'reverse'
];

/**
 * Intercept mutating methods and emit events
 */
methodsToPatch.forEach(function (method) {
  // cache original method
  var original = arrayProto[method];
  def(arrayMethods, method, function mutator () {
    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];

    var result = original.apply(this, args);
    var ob = this.__ob__;
    var inserted;
    switch (method) {
      case 'push':
      case 'unshift':
        inserted = args;
        break
      case 'splice':
        inserted = args.slice(2);
        break
    }
    if (inserted) { ob.observeArray(inserted); }
    // notify change
    ob.dep.notify();
    return result
  });
});

/*  */

var arrayKeys = Object.getOwnPropertyNames(arrayMethods);

/**
 * In some cases we may want to disable observation inside a component's
 * update computation.
 */
var shouldObserve = true;

function toggleObserving (value) {
  shouldObserve = value;
}

/**
 * Observer class that is attached to each observed
 * object. Once attached, the observer converts the target
 * object's property keys into getter/setters that
 * collect dependencies and dispatch updates.
 */
var Observer = function Observer (value) {
  this.value = value;
  this.dep = new Dep();
  this.vmCount = 0;
  def(value, '__ob__', this);
  if (Array.isArray(value)) {
    if (hasProto) {
      protoAugment(value, arrayMethods);
    } else {
      copyAugment(value, arrayMethods, arrayKeys);
    }
    this.observeArray(value);
  } else {
    this.walk(value);
  }
};

/**
 * Walk through all properties and convert them into
 * getter/setters. This method should only be called when
 * value type is Object.
 */
Observer.prototype.walk = function walk (obj) {
  var keys = Object.keys(obj);
  for (var i = 0; i < keys.length; i++) {
    defineReactive$$1(obj, keys[i]);
  }
};

/**
 * Observe a list of Array items.
 */
Observer.prototype.observeArray = function observeArray (items) {
  for (var i = 0, l = items.length; i < l; i++) {
    observe(items[i]);
  }
};

// helpers

/**
 * Augment a target Object or Array by intercepting
 * the prototype chain using __proto__
 */
function protoAugment (target, src) {
  /* eslint-disable no-proto */
  target.__proto__ = src;
  /* eslint-enable no-proto */
}

/**
 * Augment a target Object or Array by defining
 * hidden properties.
 */
/* istanbul ignore next */
function copyAugment (target, src, keys) {
  for (var i = 0, l = keys.length; i < l; i++) {
    var key = keys[i];
    def(target, key, src[key]);
  }
}

/**
 * Attempt to create an observer instance for a value,
 * returns the new observer if successfully observed,
 * or the existing observer if the value already has one.
 */
function observe (value, asRootData) {
  if (!isObject(value) || value instanceof VNode) {
    return
  }
  var ob;
  if (hasOwn(value, '__ob__') && value.__ob__ instanceof Observer) {
    ob = value.__ob__;
  } else if (
    shouldObserve &&
    !isServerRendering() &&
    (Array.isArray(value) || isPlainObject(value)) &&
    Object.isExtensible(value) &&
    !value._isVue
  ) {
    ob = new Observer(value);
  }
  if (asRootData && ob) {
    ob.vmCount++;
  }
  return ob
}

/**
 * Define a reactive property on an Object.
 */
function defineReactive$$1 (
  obj,
  key,
  val,
  customSetter,
  shallow
) {
  var dep = new Dep();

  var property = Object.getOwnPropertyDescriptor(obj, key);
  if (property && property.configurable === false) {
    return
  }

  // cater for pre-defined getter/setters
  var getter = property && property.get;
  var setter = property && property.set;
  if ((!getter || setter) && arguments.length === 2) {
    val = obj[key];
  }

  var childOb = !shallow && observe(val);
  Object.defineProperty(obj, key, {
    enumerable: true,
    configurable: true,
    get: function reactiveGetter () {
      var value = getter ? getter.call(obj) : val;
      if (Dep.target) {
        dep.depend();
        if (childOb) {
          childOb.dep.depend();
          if (Array.isArray(value)) {
            dependArray(value);
          }
        }
      }
      return value
    },
    set: function reactiveSetter (newVal) {
      var value = getter ? getter.call(obj) : val;
      /* eslint-disable no-self-compare */
      if (newVal === value || (newVal !== newVal && value !== value)) {
        return
      }
      /* eslint-enable no-self-compare */
      if (false) {
        customSetter();
      }
      // #7981: for accessor properties without setter
      if (getter && !setter) { return }
      if (setter) {
        setter.call(obj, newVal);
      } else {
        val = newVal;
      }
      childOb = !shallow && observe(newVal);
      dep.notify();
    }
  });
}

/**
 * Set a property on an object. Adds the new property and
 * triggers change notification if the property doesn't
 * already exist.
 */
function set (target, key, val) {
  if (false
  ) {
    warn(("Cannot set reactive property on undefined, null, or primitive value: " + ((target))));
  }
  if (Array.isArray(target) && isValidArrayIndex(key)) {
    target.length = Math.max(target.length, key);
    target.splice(key, 1, val);
    return val
  }
  if (key in target && !(key in Object.prototype)) {
    target[key] = val;
    return val
  }
  var ob = (target).__ob__;
  if (target._isVue || (ob && ob.vmCount)) {
    "production" !== 'production' && warn(
      'Avoid adding reactive properties to a Vue instance or its root $data ' +
      'at runtime - declare it upfront in the data option.'
    );
    return val
  }
  if (!ob) {
    target[key] = val;
    return val
  }
  defineReactive$$1(ob.value, key, val);
  ob.dep.notify();
  return val
}

/**
 * Delete a property and trigger change if necessary.
 */
function del (target, key) {
  if (false
  ) {
    warn(("Cannot delete reactive property on undefined, null, or primitive value: " + ((target))));
  }
  if (Array.isArray(target) && isValidArrayIndex(key)) {
    target.splice(key, 1);
    return
  }
  var ob = (target).__ob__;
  if (target._isVue || (ob && ob.vmCount)) {
    "production" !== 'production' && warn(
      'Avoid deleting properties on a Vue instance or its root $data ' +
      '- just set it to null.'
    );
    return
  }
  if (!hasOwn(target, key)) {
    return
  }
  delete target[key];
  if (!ob) {
    return
  }
  ob.dep.notify();
}

/**
 * Collect dependencies on array elements when the array is touched, since
 * we cannot intercept array element access like property getters.
 */
function dependArray (value) {
  for (var e = (void 0), i = 0, l = value.length; i < l; i++) {
    e = value[i];
    e && e.__ob__ && e.__ob__.dep.depend();
    if (Array.isArray(e)) {
      dependArray(e);
    }
  }
}

/*  */

/**
 * Option overwriting strategies are functions that handle
 * how to merge a parent option value and a child option
 * value into the final value.
 */
var strats = config.optionMergeStrategies;

/**
 * Options with restrictions
 */
if (false) {
  strats.el = strats.propsData = function (parent, child, vm, key) {
    if (!vm) {
      warn(
        "option \"" + key + "\" can only be used during instance " +
        'creation with the `new` keyword.'
      );
    }
    return defaultStrat(parent, child)
  };
}

/**
 * Helper that recursively merges two data objects together.
 */
function mergeData (to, from) {
  if (!from) { return to }
  var key, toVal, fromVal;

  var keys = hasSymbol
    ? Reflect.ownKeys(from)
    : Object.keys(from);

  for (var i = 0; i < keys.length; i++) {
    key = keys[i];
    // in case the object is already observed...
    if (key === '__ob__') { continue }
    toVal = to[key];
    fromVal = from[key];
    if (!hasOwn(to, key)) {
      set(to, key, fromVal);
    } else if (
      toVal !== fromVal &&
      isPlainObject(toVal) &&
      isPlainObject(fromVal)
    ) {
      mergeData(toVal, fromVal);
    }
  }
  return to
}

/**
 * Data
 */
function mergeDataOrFn (
  parentVal,
  childVal,
  vm
) {
  if (!vm) {
    // in a Vue.extend merge, both should be functions
    if (!childVal) {
      return parentVal
    }
    if (!parentVal) {
      return childVal
    }
    // when parentVal & childVal are both present,
    // we need to return a function that returns the
    // merged result of both functions... no need to
    // check if parentVal is a function here because
    // it has to be a function to pass previous merges.
    return function mergedDataFn () {
      return mergeData(
        typeof childVal === 'function' ? childVal.call(this, this) : childVal,
        typeof parentVal === 'function' ? parentVal.call(this, this) : parentVal
      )
    }
  } else {
    return function mergedInstanceDataFn () {
      // instance merge
      var instanceData = typeof childVal === 'function'
        ? childVal.call(vm, vm)
        : childVal;
      var defaultData = typeof parentVal === 'function'
        ? parentVal.call(vm, vm)
        : parentVal;
      if (instanceData) {
        return mergeData(instanceData, defaultData)
      } else {
        return defaultData
      }
    }
  }
}

strats.data = function (
  parentVal,
  childVal,
  vm
) {
  if (!vm) {
    if (childVal && typeof childVal !== 'function') {
      "production" !== 'production' && warn(
        'The "data" option should be a function ' +
        'that returns a per-instance value in component ' +
        'definitions.',
        vm
      );

      return parentVal
    }
    return mergeDataOrFn(parentVal, childVal)
  }

  return mergeDataOrFn(parentVal, childVal, vm)
};

/**
 * Hooks and props are merged as arrays.
 */
function mergeHook (
  parentVal,
  childVal
) {
  var res = childVal
    ? parentVal
      ? parentVal.concat(childVal)
      : Array.isArray(childVal)
        ? childVal
        : [childVal]
    : parentVal;
  return res
    ? dedupeHooks(res)
    : res
}

function dedupeHooks (hooks) {
  var res = [];
  for (var i = 0; i < hooks.length; i++) {
    if (res.indexOf(hooks[i]) === -1) {
      res.push(hooks[i]);
    }
  }
  return res
}

LIFECYCLE_HOOKS.forEach(function (hook) {
  strats[hook] = mergeHook;
});

/**
 * Assets
 *
 * When a vm is present (instance creation), we need to do
 * a three-way merge between constructor options, instance
 * options and parent options.
 */
function mergeAssets (
  parentVal,
  childVal,
  vm,
  key
) {
  var res = Object.create(parentVal || null);
  if (childVal) {
    "production" !== 'production' && assertObjectType(key, childVal, vm);
    return extend(res, childVal)
  } else {
    return res
  }
}

ASSET_TYPES.forEach(function (type) {
  strats[type + 's'] = mergeAssets;
});

/**
 * Watchers.
 *
 * Watchers hashes should not overwrite one
 * another, so we merge them as arrays.
 */
strats.watch = function (
  parentVal,
  childVal,
  vm,
  key
) {
  // work around Firefox's Object.prototype.watch...
  if (parentVal === nativeWatch) { parentVal = undefined; }
  if (childVal === nativeWatch) { childVal = undefined; }
  /* istanbul ignore if */
  if (!childVal) { return Object.create(parentVal || null) }
  if (false) {
    assertObjectType(key, childVal, vm);
  }
  if (!parentVal) { return childVal }
  var ret = {};
  extend(ret, parentVal);
  for (var key$1 in childVal) {
    var parent = ret[key$1];
    var child = childVal[key$1];
    if (parent && !Array.isArray(parent)) {
      parent = [parent];
    }
    ret[key$1] = parent
      ? parent.concat(child)
      : Array.isArray(child) ? child : [child];
  }
  return ret
};

/**
 * Other object hashes.
 */
strats.props =
strats.methods =
strats.inject =
strats.computed = function (
  parentVal,
  childVal,
  vm,
  key
) {
  if (childVal && "production" !== 'production') {
    assertObjectType(key, childVal, vm);
  }
  if (!parentVal) { return childVal }
  var ret = Object.create(null);
  extend(ret, parentVal);
  if (childVal) { extend(ret, childVal); }
  return ret
};
strats.provide = mergeDataOrFn;

/**
 * Default strategy.
 */
var defaultStrat = function (parentVal, childVal) {
  return childVal === undefined
    ? parentVal
    : childVal
};

/**
 * Validate component names
 */
function checkComponents (options) {
  for (var key in options.components) {
    validateComponentName(key);
  }
}

function validateComponentName (name) {
  if (!new RegExp(("^[a-zA-Z][\\-\\.0-9_" + (unicodeRegExp.source) + "]*$")).test(name)) {
    warn(
      'Invalid component name: "' + name + '". Component names ' +
      'should conform to valid custom element name in html5 specification.'
    );
  }
  if (isBuiltInTag(name) || config.isReservedTag(name)) {
    warn(
      'Do not use built-in or reserved HTML elements as component ' +
      'id: ' + name
    );
  }
}

/**
 * Ensure all props option syntax are normalized into the
 * Object-based format.
 */
function normalizeProps (options, vm) {
  var props = options.props;
  if (!props) { return }
  var res = {};
  var i, val, name;
  if (Array.isArray(props)) {
    i = props.length;
    while (i--) {
      val = props[i];
      if (typeof val === 'string') {
        name = camelize(val);
        res[name] = { type: null };
      } else if (false) {
        warn('props must be strings when using array syntax.');
      }
    }
  } else if (isPlainObject(props)) {
    for (var key in props) {
      val = props[key];
      name = camelize(key);
      res[name] = isPlainObject(val)
        ? val
        : { type: val };
    }
  } else if (false) {
    warn(
      "Invalid value for option \"props\": expected an Array or an Object, " +
      "but got " + (toRawType(props)) + ".",
      vm
    );
  }
  options.props = res;
}

/**
 * Normalize all injections into Object-based format
 */
function normalizeInject (options, vm) {
  var inject = options.inject;
  if (!inject) { return }
  var normalized = options.inject = {};
  if (Array.isArray(inject)) {
    for (var i = 0; i < inject.length; i++) {
      normalized[inject[i]] = { from: inject[i] };
    }
  } else if (isPlainObject(inject)) {
    for (var key in inject) {
      var val = inject[key];
      normalized[key] = isPlainObject(val)
        ? extend({ from: key }, val)
        : { from: val };
    }
  } else if (false) {
    warn(
      "Invalid value for option \"inject\": expected an Array or an Object, " +
      "but got " + (toRawType(inject)) + ".",
      vm
    );
  }
}

/**
 * Normalize raw function directives into object format.
 */
function normalizeDirectives (options) {
  var dirs = options.directives;
  if (dirs) {
    for (var key in dirs) {
      var def$$1 = dirs[key];
      if (typeof def$$1 === 'function') {
        dirs[key] = { bind: def$$1, update: def$$1 };
      }
    }
  }
}

function assertObjectType (name, value, vm) {
  if (!isPlainObject(value)) {
    warn(
      "Invalid value for option \"" + name + "\": expected an Object, " +
      "but got " + (toRawType(value)) + ".",
      vm
    );
  }
}

/**
 * Merge two option objects into a new one.
 * Core utility used in both instantiation and inheritance.
 */
function mergeOptions (
  parent,
  child,
  vm
) {
  if (false) {
    checkComponents(child);
  }

  if (typeof child === 'function') {
    child = child.options;
  }

  normalizeProps(child, vm);
  normalizeInject(child, vm);
  normalizeDirectives(child);

  // Apply extends and mixins on the child options,
  // but only if it is a raw options object that isn't
  // the result of another mergeOptions call.
  // Only merged options has the _base property.
  if (!child._base) {
    if (child.extends) {
      parent = mergeOptions(parent, child.extends, vm);
    }
    if (child.mixins) {
      for (var i = 0, l = child.mixins.length; i < l; i++) {
        parent = mergeOptions(parent, child.mixins[i], vm);
      }
    }
  }

  var options = {};
  var key;
  for (key in parent) {
    mergeField(key);
  }
  for (key in child) {
    if (!hasOwn(parent, key)) {
      mergeField(key);
    }
  }
  function mergeField (key) {
    var strat = strats[key] || defaultStrat;
    options[key] = strat(parent[key], child[key], vm, key);
  }
  return options
}

/**
 * Resolve an asset.
 * This function is used because child instances need access
 * to assets defined in its ancestor chain.
 */
function resolveAsset (
  options,
  type,
  id,
  warnMissing
) {
  /* istanbul ignore if */
  if (typeof id !== 'string') {
    return
  }
  var assets = options[type];
  // check local registration variations first
  if (hasOwn(assets, id)) { return assets[id] }
  var camelizedId = camelize(id);
  if (hasOwn(assets, camelizedId)) { return assets[camelizedId] }
  var PascalCaseId = capitalize(camelizedId);
  if (hasOwn(assets, PascalCaseId)) { return assets[PascalCaseId] }
  // fallback to prototype chain
  var res = assets[id] || assets[camelizedId] || assets[PascalCaseId];
  if (false) {
    warn(
      'Failed to resolve ' + type.slice(0, -1) + ': ' + id,
      options
    );
  }
  return res
}

/*  */



function validateProp (
  key,
  propOptions,
  propsData,
  vm
) {
  var prop = propOptions[key];
  var absent = !hasOwn(propsData, key);
  var value = propsData[key];
  // boolean casting
  var booleanIndex = getTypeIndex(Boolean, prop.type);
  if (booleanIndex > -1) {
    if (absent && !hasOwn(prop, 'default')) {
      value = false;
    } else if (value === '' || value === hyphenate(key)) {
      // only cast empty string / same name to boolean if
      // boolean has higher priority
      var stringIndex = getTypeIndex(String, prop.type);
      if (stringIndex < 0 || booleanIndex < stringIndex) {
        value = true;
      }
    }
  }
  // check default value
  if (value === undefined) {
    value = getPropDefaultValue(vm, prop, key);
    // since the default value is a fresh copy,
    // make sure to observe it.
    var prevShouldObserve = shouldObserve;
    toggleObserving(true);
    observe(value);
    toggleObserving(prevShouldObserve);
  }
  if (
    false
  ) {
    assertProp(prop, key, value, vm, absent);
  }
  return value
}

/**
 * Get the default value of a prop.
 */
function getPropDefaultValue (vm, prop, key) {
  // no default, return undefined
  if (!hasOwn(prop, 'default')) {
    return undefined
  }
  var def = prop.default;
  // warn against non-factory defaults for Object & Array
  if (false) {
    warn(
      'Invalid default value for prop "' + key + '": ' +
      'Props with type Object/Array must use a factory function ' +
      'to return the default value.',
      vm
    );
  }
  // the raw prop value was also undefined from previous render,
  // return previous default value to avoid unnecessary watcher trigger
  if (vm && vm.$options.propsData &&
    vm.$options.propsData[key] === undefined &&
    vm._props[key] !== undefined
  ) {
    return vm._props[key]
  }
  // call factory function for non-Function types
  // a value is Function if its prototype is function even across different execution context
  return typeof def === 'function' && getType(prop.type) !== 'Function'
    ? def.call(vm)
    : def
}

/**
 * Assert whether a prop is valid.
 */
function assertProp (
  prop,
  name,
  value,
  vm,
  absent
) {
  if (prop.required && absent) {
    warn(
      'Missing required prop: "' + name + '"',
      vm
    );
    return
  }
  if (value == null && !prop.required) {
    return
  }
  var type = prop.type;
  var valid = !type || type === true;
  var expectedTypes = [];
  if (type) {
    if (!Array.isArray(type)) {
      type = [type];
    }
    for (var i = 0; i < type.length && !valid; i++) {
      var assertedType = assertType(value, type[i]);
      expectedTypes.push(assertedType.expectedType || '');
      valid = assertedType.valid;
    }
  }

  if (!valid) {
    warn(
      getInvalidTypeMessage(name, value, expectedTypes),
      vm
    );
    return
  }
  var validator = prop.validator;
  if (validator) {
    if (!validator(value)) {
      warn(
        'Invalid prop: custom validator check failed for prop "' + name + '".',
        vm
      );
    }
  }
}

var simpleCheckRE = /^(String|Number|Boolean|Function|Symbol)$/;

function assertType (value, type) {
  var valid;
  var expectedType = getType(type);
  if (simpleCheckRE.test(expectedType)) {
    var t = typeof value;
    valid = t === expectedType.toLowerCase();
    // for primitive wrapper objects
    if (!valid && t === 'object') {
      valid = value instanceof type;
    }
  } else if (expectedType === 'Object') {
    valid = isPlainObject(value);
  } else if (expectedType === 'Array') {
    valid = Array.isArray(value);
  } else {
    valid = value instanceof type;
  }
  return {
    valid: valid,
    expectedType: expectedType
  }
}

/**
 * Use function string name to check built-in types,
 * because a simple equality check will fail when running
 * across different vms / iframes.
 */
function getType (fn) {
  var match = fn && fn.toString().match(/^\s*function (\w+)/);
  return match ? match[1] : ''
}

function isSameType (a, b) {
  return getType(a) === getType(b)
}

function getTypeIndex (type, expectedTypes) {
  if (!Array.isArray(expectedTypes)) {
    return isSameType(expectedTypes, type) ? 0 : -1
  }
  for (var i = 0, len = expectedTypes.length; i < len; i++) {
    if (isSameType(expectedTypes[i], type)) {
      return i
    }
  }
  return -1
}

function getInvalidTypeMessage (name, value, expectedTypes) {
  var message = "Invalid prop: type check failed for prop \"" + name + "\"." +
    " Expected " + (expectedTypes.map(capitalize).join(', '));
  var expectedType = expectedTypes[0];
  var receivedType = toRawType(value);
  var expectedValue = styleValue(value, expectedType);
  var receivedValue = styleValue(value, receivedType);
  // check if we need to specify expected value
  if (expectedTypes.length === 1 &&
      isExplicable(expectedType) &&
      !isBoolean(expectedType, receivedType)) {
    message += " with value " + expectedValue;
  }
  message += ", got " + receivedType + " ";
  // check if we need to specify received value
  if (isExplicable(receivedType)) {
    message += "with value " + receivedValue + ".";
  }
  return message
}

function styleValue (value, type) {
  if (type === 'String') {
    return ("\"" + value + "\"")
  } else if (type === 'Number') {
    return ("" + (Number(value)))
  } else {
    return ("" + value)
  }
}

function isExplicable (value) {
  var explicitTypes = ['string', 'number', 'boolean'];
  return explicitTypes.some(function (elem) { return value.toLowerCase() === elem; })
}

function isBoolean () {
  var args = [], len = arguments.length;
  while ( len-- ) args[ len ] = arguments[ len ];

  return args.some(function (elem) { return elem.toLowerCase() === 'boolean'; })
}

/*  */

function handleError (err, vm, info) {
  // Deactivate deps tracking while processing error handler to avoid possible infinite rendering.
  // See: https://github.com/vuejs/vuex/issues/1505
  pushTarget();
  try {
    if (vm) {
      var cur = vm;
      while ((cur = cur.$parent)) {
        var hooks = cur.$options.errorCaptured;
        if (hooks) {
          for (var i = 0; i < hooks.length; i++) {
            try {
              var capture = hooks[i].call(cur, err, vm, info) === false;
              if (capture) { return }
            } catch (e) {
              globalHandleError(e, cur, 'errorCaptured hook');
            }
          }
        }
      }
    }
    globalHandleError(err, vm, info);
  } finally {
    popTarget();
  }
}

function invokeWithErrorHandling (
  handler,
  context,
  args,
  vm,
  info
) {
  var res;
  try {
    res = args ? handler.apply(context, args) : handler.call(context);
    if (res && !res._isVue && isPromise(res) && !res._handled) {
      res.catch(function (e) { return handleError(e, vm, info + " (Promise/async)"); });
      // issue #9511
      // avoid catch triggering multiple times when nested calls
      res._handled = true;
    }
  } catch (e) {
    handleError(e, vm, info);
  }
  return res
}

function globalHandleError (err, vm, info) {
  if (config.errorHandler) {
    try {
      return config.errorHandler.call(null, err, vm, info)
    } catch (e) {
      // if the user intentionally throws the original error in the handler,
      // do not log it twice
      if (e !== err) {
        logError(e, null, 'config.errorHandler');
      }
    }
  }
  logError(err, vm, info);
}

function logError (err, vm, info) {
  if (false) {
    warn(("Error in " + info + ": \"" + (err.toString()) + "\""), vm);
  }
  /* istanbul ignore else */
  if ((inBrowser || inWeex) && typeof console !== 'undefined') {
    console.error(err);
  } else {
    throw err
  }
}

/*  */

var isUsingMicroTask = false;

var callbacks = [];
var pending = false;

function flushCallbacks () {
  pending = false;
  var copies = callbacks.slice(0);
  callbacks.length = 0;
  for (var i = 0; i < copies.length; i++) {
    copies[i]();
  }
}

// Here we have async deferring wrappers using microtasks.
// In 2.5 we used (macro) tasks (in combination with microtasks).
// However, it has subtle problems when state is changed right before repaint
// (e.g. #6813, out-in transitions).
// Also, using (macro) tasks in event handler would cause some weird behaviors
// that cannot be circumvented (e.g. #7109, #7153, #7546, #7834, #8109).
// So we now use microtasks everywhere, again.
// A major drawback of this tradeoff is that there are some scenarios
// where microtasks have too high a priority and fire in between supposedly
// sequential events (e.g. #4521, #6690, which have workarounds)
// or even between bubbling of the same event (#6566).
var timerFunc;

// The nextTick behavior leverages the microtask queue, which can be accessed
// via either native Promise.then or MutationObserver.
// MutationObserver has wider support, however it is seriously bugged in
// UIWebView in iOS >= 9.3.3 when triggered in touch event handlers. It
// completely stops working after triggering a few times... so, if native
// Promise is available, we will use it:
/* istanbul ignore next, $flow-disable-line */
if (typeof Promise !== 'undefined' && isNative(Promise)) {
  var p = Promise.resolve();
  timerFunc = function () {
    p.then(flushCallbacks);
    // In problematic UIWebViews, Promise.then doesn't completely break, but
    // it can get stuck in a weird state where callbacks are pushed into the
    // microtask queue but the queue isn't being flushed, until the browser
    // needs to do some other work, e.g. handle a timer. Therefore we can
    // "force" the microtask queue to be flushed by adding an empty timer.
    if (isIOS) { setTimeout(noop); }
  };
  isUsingMicroTask = true;
} else if (!isIE && typeof MutationObserver !== 'undefined' && (
  isNative(MutationObserver) ||
  // PhantomJS and iOS 7.x
  MutationObserver.toString() === '[object MutationObserverConstructor]'
)) {
  // Use MutationObserver where native Promise is not available,
  // e.g. PhantomJS, iOS7, Android 4.4
  // (#6466 MutationObserver is unreliable in IE11)
  var counter = 1;
  var observer = new MutationObserver(flushCallbacks);
  var textNode = document.createTextNode(String(counter));
  observer.observe(textNode, {
    characterData: true
  });
  timerFunc = function () {
    counter = (counter + 1) % 2;
    textNode.data = String(counter);
  };
  isUsingMicroTask = true;
} else if (typeof setImmediate !== 'undefined' && isNative(setImmediate)) {
  // Fallback to setImmediate.
  // Technically it leverages the (macro) task queue,
  // but it is still a better choice than setTimeout.
  timerFunc = function () {
    setImmediate(flushCallbacks);
  };
} else {
  // Fallback to setTimeout.
  timerFunc = function () {
    setTimeout(flushCallbacks, 0);
  };
}

function nextTick (cb, ctx) {
  var _resolve;
  callbacks.push(function () {
    if (cb) {
      try {
        cb.call(ctx);
      } catch (e) {
        handleError(e, ctx, 'nextTick');
      }
    } else if (_resolve) {
      _resolve(ctx);
    }
  });
  if (!pending) {
    pending = true;
    timerFunc();
  }
  // $flow-disable-line
  if (!cb && typeof Promise !== 'undefined') {
    return new Promise(function (resolve) {
      _resolve = resolve;
    })
  }
}

/*  */

var mark;
var measure;

if (false) {
  var perf = inBrowser && window.performance;
  /* istanbul ignore if */
  if (
    perf &&
    perf.mark &&
    perf.measure &&
    perf.clearMarks &&
    perf.clearMeasures
  ) {
    mark = function (tag) { return perf.mark(tag); };
    measure = function (name, startTag, endTag) {
      perf.measure(name, startTag, endTag);
      perf.clearMarks(startTag);
      perf.clearMarks(endTag);
      // perf.clearMeasures(name)
    };
  }
}

/* not type checking this file because flow doesn't play well with Proxy */

var initProxy;

if (false) {
  var allowedGlobals = makeMap(
    'Infinity,undefined,NaN,isFinite,isNaN,' +
    'parseFloat,parseInt,decodeURI,decodeURIComponent,encodeURI,encodeURIComponent,' +
    'Math,Number,Date,Array,Object,Boolean,String,RegExp,Map,Set,JSON,Intl,' +
    'require' // for Webpack/Browserify
  );

  var warnNonPresent = function (target, key) {
    warn(
      "Property or method \"" + key + "\" is not defined on the instance but " +
      'referenced during render. Make sure that this property is reactive, ' +
      'either in the data option, or for class-based components, by ' +
      'initializing the property. ' +
      'See: https://vuejs.org/v2/guide/reactivity.html#Declaring-Reactive-Properties.',
      target
    );
  };

  var warnReservedPrefix = function (target, key) {
    warn(
      "Property \"" + key + "\" must be accessed with \"$data." + key + "\" because " +
      'properties starting with "$" or "_" are not proxied in the Vue instance to ' +
      'prevent conflicts with Vue internals. ' +
      'See: https://vuejs.org/v2/api/#data',
      target
    );
  };

  var hasProxy =
    typeof Proxy !== 'undefined' && isNative(Proxy);

  if (hasProxy) {
    var isBuiltInModifier = makeMap('stop,prevent,self,ctrl,shift,alt,meta,exact');
    config.keyCodes = new Proxy(config.keyCodes, {
      set: function set (target, key, value) {
        if (isBuiltInModifier(key)) {
          warn(("Avoid overwriting built-in modifier in config.keyCodes: ." + key));
          return false
        } else {
          target[key] = value;
          return true
        }
      }
    });
  }

  var hasHandler = {
    has: function has (target, key) {
      var has = key in target;
      var isAllowed = allowedGlobals(key) ||
        (typeof key === 'string' && key.charAt(0) === '_' && !(key in target.$data));
      if (!has && !isAllowed) {
        if (key in target.$data) { warnReservedPrefix(target, key); }
        else { warnNonPresent(target, key); }
      }
      return has || !isAllowed
    }
  };

  var getHandler = {
    get: function get (target, key) {
      if (typeof key === 'string' && !(key in target)) {
        if (key in target.$data) { warnReservedPrefix(target, key); }
        else { warnNonPresent(target, key); }
      }
      return target[key]
    }
  };

  initProxy = function initProxy (vm) {
    if (hasProxy) {
      // determine which proxy handler to use
      var options = vm.$options;
      var handlers = options.render && options.render._withStripped
        ? getHandler
        : hasHandler;
      vm._renderProxy = new Proxy(vm, handlers);
    } else {
      vm._renderProxy = vm;
    }
  };
}

/*  */

var seenObjects = new _Set();

/**
 * Recursively traverse an object to evoke all converted
 * getters, so that every nested property inside the object
 * is collected as a "deep" dependency.
 */
function traverse (val) {
  _traverse(val, seenObjects);
  seenObjects.clear();
}

function _traverse (val, seen) {
  var i, keys;
  var isA = Array.isArray(val);
  if ((!isA && !isObject(val)) || Object.isFrozen(val) || val instanceof VNode) {
    return
  }
  if (val.__ob__) {
    var depId = val.__ob__.dep.id;
    if (seen.has(depId)) {
      return
    }
    seen.add(depId);
  }
  if (isA) {
    i = val.length;
    while (i--) { _traverse(val[i], seen); }
  } else {
    keys = Object.keys(val);
    i = keys.length;
    while (i--) { _traverse(val[keys[i]], seen); }
  }
}

/*  */

var normalizeEvent = cached(function (name) {
  var passive = name.charAt(0) === '&';
  name = passive ? name.slice(1) : name;
  var once$$1 = name.charAt(0) === '~'; // Prefixed last, checked first
  name = once$$1 ? name.slice(1) : name;
  var capture = name.charAt(0) === '!';
  name = capture ? name.slice(1) : name;
  return {
    name: name,
    once: once$$1,
    capture: capture,
    passive: passive
  }
});

function createFnInvoker (fns, vm) {
  function invoker () {
    var arguments$1 = arguments;

    var fns = invoker.fns;
    if (Array.isArray(fns)) {
      var cloned = fns.slice();
      for (var i = 0; i < cloned.length; i++) {
        invokeWithErrorHandling(cloned[i], null, arguments$1, vm, "v-on handler");
      }
    } else {
      // return handler return value for single handlers
      return invokeWithErrorHandling(fns, null, arguments, vm, "v-on handler")
    }
  }
  invoker.fns = fns;
  return invoker
}

function updateListeners (
  on,
  oldOn,
  add,
  remove$$1,
  createOnceHandler,
  vm
) {
  var name, def$$1, cur, old, event;
  for (name in on) {
    def$$1 = cur = on[name];
    old = oldOn[name];
    event = normalizeEvent(name);
    if (isUndef(cur)) {
      "production" !== 'production' && warn(
        "Invalid handler for event \"" + (event.name) + "\": got " + String(cur),
        vm
      );
    } else if (isUndef(old)) {
      if (isUndef(cur.fns)) {
        cur = on[name] = createFnInvoker(cur, vm);
      }
      if (isTrue(event.once)) {
        cur = on[name] = createOnceHandler(event.name, cur, event.capture);
      }
      add(event.name, cur, event.capture, event.passive, event.params);
    } else if (cur !== old) {
      old.fns = cur;
      on[name] = old;
    }
  }
  for (name in oldOn) {
    if (isUndef(on[name])) {
      event = normalizeEvent(name);
      remove$$1(event.name, oldOn[name], event.capture);
    }
  }
}

/*  */

function mergeVNodeHook (def, hookKey, hook) {
  if (def instanceof VNode) {
    def = def.data.hook || (def.data.hook = {});
  }
  var invoker;
  var oldHook = def[hookKey];

  function wrappedHook () {
    hook.apply(this, arguments);
    // important: remove merged hook to ensure it's called only once
    // and prevent memory leak
    remove(invoker.fns, wrappedHook);
  }

  if (isUndef(oldHook)) {
    // no existing hook
    invoker = createFnInvoker([wrappedHook]);
  } else {
    /* istanbul ignore if */
    if (isDef(oldHook.fns) && isTrue(oldHook.merged)) {
      // already a merged invoker
      invoker = oldHook;
      invoker.fns.push(wrappedHook);
    } else {
      // existing plain hook
      invoker = createFnInvoker([oldHook, wrappedHook]);
    }
  }

  invoker.merged = true;
  def[hookKey] = invoker;
}

/*  */

function extractPropsFromVNodeData (
  data,
  Ctor,
  tag
) {
  // we are only extracting raw values here.
  // validation and default values are handled in the child
  // component itself.
  var propOptions = Ctor.options.props;
  if (isUndef(propOptions)) {
    return
  }
  var res = {};
  var attrs = data.attrs;
  var props = data.props;
  if (isDef(attrs) || isDef(props)) {
    for (var key in propOptions) {
      var altKey = hyphenate(key);
      if (false) {
        var keyInLowerCase = key.toLowerCase();
        if (
          key !== keyInLowerCase &&
          attrs && hasOwn(attrs, keyInLowerCase)
        ) {
          tip(
            "Prop \"" + keyInLowerCase + "\" is passed to component " +
            (formatComponentName(tag || Ctor)) + ", but the declared prop name is" +
            " \"" + key + "\". " +
            "Note that HTML attributes are case-insensitive and camelCased " +
            "props need to use their kebab-case equivalents when using in-DOM " +
            "templates. You should probably use \"" + altKey + "\" instead of \"" + key + "\"."
          );
        }
      }
      checkProp(res, props, key, altKey, true) ||
      checkProp(res, attrs, key, altKey, false);
    }
  }
  return res
}

function checkProp (
  res,
  hash,
  key,
  altKey,
  preserve
) {
  if (isDef(hash)) {
    if (hasOwn(hash, key)) {
      res[key] = hash[key];
      if (!preserve) {
        delete hash[key];
      }
      return true
    } else if (hasOwn(hash, altKey)) {
      res[key] = hash[altKey];
      if (!preserve) {
        delete hash[altKey];
      }
      return true
    }
  }
  return false
}

/*  */

// The template compiler attempts to minimize the need for normalization by
// statically analyzing the template at compile time.
//
// For plain HTML markup, normalization can be completely skipped because the
// generated render function is guaranteed to return Array<VNode>. There are
// two cases where extra normalization is needed:

// 1. When the children contains components - because a functional component
// may return an Array instead of a single root. In this case, just a simple
// normalization is needed - if any child is an Array, we flatten the whole
// thing with Array.prototype.concat. It is guaranteed to be only 1-level deep
// because functional components already normalize their own children.
function simpleNormalizeChildren (children) {
  for (var i = 0; i < children.length; i++) {
    if (Array.isArray(children[i])) {
      return Array.prototype.concat.apply([], children)
    }
  }
  return children
}

// 2. When the children contains constructs that always generated nested Arrays,
// e.g. <template>, <slot>, v-for, or when the children is provided by user
// with hand-written render functions / JSX. In such cases a full normalization
// is needed to cater to all possible types of children values.
function normalizeChildren (children) {
  return isPrimitive(children)
    ? [createTextVNode(children)]
    : Array.isArray(children)
      ? normalizeArrayChildren(children)
      : undefined
}

function isTextNode (node) {
  return isDef(node) && isDef(node.text) && isFalse(node.isComment)
}

function normalizeArrayChildren (children, nestedIndex) {
  var res = [];
  var i, c, lastIndex, last;
  for (i = 0; i < children.length; i++) {
    c = children[i];
    if (isUndef(c) || typeof c === 'boolean') { continue }
    lastIndex = res.length - 1;
    last = res[lastIndex];
    //  nested
    if (Array.isArray(c)) {
      if (c.length > 0) {
        c = normalizeArrayChildren(c, ((nestedIndex || '') + "_" + i));
        // merge adjacent text nodes
        if (isTextNode(c[0]) && isTextNode(last)) {
          res[lastIndex] = createTextVNode(last.text + (c[0]).text);
          c.shift();
        }
        res.push.apply(res, c);
      }
    } else if (isPrimitive(c)) {
      if (isTextNode(last)) {
        // merge adjacent text nodes
        // this is necessary for SSR hydration because text nodes are
        // essentially merged when rendered to HTML strings
        res[lastIndex] = createTextVNode(last.text + c);
      } else if (c !== '') {
        // convert primitive to vnode
        res.push(createTextVNode(c));
      }
    } else {
      if (isTextNode(c) && isTextNode(last)) {
        // merge adjacent text nodes
        res[lastIndex] = createTextVNode(last.text + c.text);
      } else {
        // default key for nested array children (likely generated by v-for)
        if (isTrue(children._isVList) &&
          isDef(c.tag) &&
          isUndef(c.key) &&
          isDef(nestedIndex)) {
          c.key = "__vlist" + nestedIndex + "_" + i + "__";
        }
        res.push(c);
      }
    }
  }
  return res
}

/*  */

function initProvide (vm) {
  var provide = vm.$options.provide;
  if (provide) {
    vm._provided = typeof provide === 'function'
      ? provide.call(vm)
      : provide;
  }
}

function initInjections (vm) {
  var result = resolveInject(vm.$options.inject, vm);
  if (result) {
    toggleObserving(false);
    Object.keys(result).forEach(function (key) {
      /* istanbul ignore else */
      if (false) {
        defineReactive$$1(vm, key, result[key], function () {
          warn(
            "Avoid mutating an injected value directly since the changes will be " +
            "overwritten whenever the provided component re-renders. " +
            "injection being mutated: \"" + key + "\"",
            vm
          );
        });
      } else {
        defineReactive$$1(vm, key, result[key]);
      }
    });
    toggleObserving(true);
  }
}

function resolveInject (inject, vm) {
  if (inject) {
    // inject is :any because flow is not smart enough to figure out cached
    var result = Object.create(null);
    var keys = hasSymbol
      ? Reflect.ownKeys(inject)
      : Object.keys(inject);

    for (var i = 0; i < keys.length; i++) {
      var key = keys[i];
      // #6574 in case the inject object is observed...
      if (key === '__ob__') { continue }
      var provideKey = inject[key].from;
      var source = vm;
      while (source) {
        if (source._provided && hasOwn(source._provided, provideKey)) {
          result[key] = source._provided[provideKey];
          break
        }
        source = source.$parent;
      }
      if (!source) {
        if ('default' in inject[key]) {
          var provideDefault = inject[key].default;
          result[key] = typeof provideDefault === 'function'
            ? provideDefault.call(vm)
            : provideDefault;
        } else if (false) {
          warn(("Injection \"" + key + "\" not found"), vm);
        }
      }
    }
    return result
  }
}

/*  */



/**
 * Runtime helper for resolving raw children VNodes into a slot object.
 */
function resolveSlots (
  children,
  context
) {
  if (!children || !children.length) {
    return {}
  }
  var slots = {};
  for (var i = 0, l = children.length; i < l; i++) {
    var child = children[i];
    var data = child.data;
    // remove slot attribute if the node is resolved as a Vue slot node
    if (data && data.attrs && data.attrs.slot) {
      delete data.attrs.slot;
    }
    // named slots should only be respected if the vnode was rendered in the
    // same context.
    if ((child.context === context || child.fnContext === context) &&
      data && data.slot != null
    ) {
      var name = data.slot;
      var slot = (slots[name] || (slots[name] = []));
      if (child.tag === 'template') {
        slot.push.apply(slot, child.children || []);
      } else {
        slot.push(child);
      }
    } else {
      (slots.default || (slots.default = [])).push(child);
    }
  }
  // ignore slots that contains only whitespace
  for (var name$1 in slots) {
    if (slots[name$1].every(isWhitespace)) {
      delete slots[name$1];
    }
  }
  return slots
}

function isWhitespace (node) {
  return (node.isComment && !node.asyncFactory) || node.text === ' '
}

/*  */

function normalizeScopedSlots (
  slots,
  normalSlots,
  prevSlots
) {
  var res;
  var hasNormalSlots = Object.keys(normalSlots).length > 0;
  var isStable = slots ? !!slots.$stable : !hasNormalSlots;
  var key = slots && slots.$key;
  if (!slots) {
    res = {};
  } else if (slots._normalized) {
    // fast path 1: child component re-render only, parent did not change
    return slots._normalized
  } else if (
    isStable &&
    prevSlots &&
    prevSlots !== emptyObject &&
    key === prevSlots.$key &&
    !hasNormalSlots &&
    !prevSlots.$hasNormal
  ) {
    // fast path 2: stable scoped slots w/ no normal slots to proxy,
    // only need to normalize once
    return prevSlots
  } else {
    res = {};
    for (var key$1 in slots) {
      if (slots[key$1] && key$1[0] !== '$') {
        res[key$1] = normalizeScopedSlot(normalSlots, key$1, slots[key$1]);
      }
    }
  }
  // expose normal slots on scopedSlots
  for (var key$2 in normalSlots) {
    if (!(key$2 in res)) {
      res[key$2] = proxyNormalSlot(normalSlots, key$2);
    }
  }
  // avoriaz seems to mock a non-extensible $scopedSlots object
  // and when that is passed down this would cause an error
  if (slots && Object.isExtensible(slots)) {
    (slots)._normalized = res;
  }
  def(res, '$stable', isStable);
  def(res, '$key', key);
  def(res, '$hasNormal', hasNormalSlots);
  return res
}

function normalizeScopedSlot(normalSlots, key, fn) {
  var normalized = function () {
    var res = arguments.length ? fn.apply(null, arguments) : fn({});
    res = res && typeof res === 'object' && !Array.isArray(res)
      ? [res] // single vnode
      : normalizeChildren(res);
    return res && (
      res.length === 0 ||
      (res.length === 1 && res[0].isComment) // #9658
    ) ? undefined
      : res
  };
  // this is a slot using the new v-slot syntax without scope. although it is
  // compiled as a scoped slot, render fn users would expect it to be present
  // on this.$slots because the usage is semantically a normal slot.
  if (fn.proxy) {
    Object.defineProperty(normalSlots, key, {
      get: normalized,
      enumerable: true,
      configurable: true
    });
  }
  return normalized
}

function proxyNormalSlot(slots, key) {
  return function () { return slots[key]; }
}

/*  */

/**
 * Runtime helper for rendering v-for lists.
 */
function renderList (
  val,
  render
) {
  var ret, i, l, keys, key;
  if (Array.isArray(val) || typeof val === 'string') {
    ret = new Array(val.length);
    for (i = 0, l = val.length; i < l; i++) {
      ret[i] = render(val[i], i);
    }
  } else if (typeof val === 'number') {
    ret = new Array(val);
    for (i = 0; i < val; i++) {
      ret[i] = render(i + 1, i);
    }
  } else if (isObject(val)) {
    if (hasSymbol && val[Symbol.iterator]) {
      ret = [];
      var iterator = val[Symbol.iterator]();
      var result = iterator.next();
      while (!result.done) {
        ret.push(render(result.value, ret.length));
        result = iterator.next();
      }
    } else {
      keys = Object.keys(val);
      ret = new Array(keys.length);
      for (i = 0, l = keys.length; i < l; i++) {
        key = keys[i];
        ret[i] = render(val[key], key, i);
      }
    }
  }
  if (!isDef(ret)) {
    ret = [];
  }
  (ret)._isVList = true;
  return ret
}

/*  */

/**
 * Runtime helper for rendering <slot>
 */
function renderSlot (
  name,
  fallback,
  props,
  bindObject
) {
  var scopedSlotFn = this.$scopedSlots[name];
  var nodes;
  if (scopedSlotFn) { // scoped slot
    props = props || {};
    if (bindObject) {
      if (false) {
        warn(
          'slot v-bind without argument expects an Object',
          this
        );
      }
      props = extend(extend({}, bindObject), props);
    }
    nodes = scopedSlotFn(props) || fallback;
  } else {
    nodes = this.$slots[name] || fallback;
  }

  var target = props && props.slot;
  if (target) {
    return this.$createElement('template', { slot: target }, nodes)
  } else {
    return nodes
  }
}

/*  */

/**
 * Runtime helper for resolving filters
 */
function resolveFilter (id) {
  return resolveAsset(this.$options, 'filters', id, true) || identity
}

/*  */

function isKeyNotMatch (expect, actual) {
  if (Array.isArray(expect)) {
    return expect.indexOf(actual) === -1
  } else {
    return expect !== actual
  }
}

/**
 * Runtime helper for checking keyCodes from config.
 * exposed as Vue.prototype._k
 * passing in eventKeyName as last argument separately for backwards compat
 */
function checkKeyCodes (
  eventKeyCode,
  key,
  builtInKeyCode,
  eventKeyName,
  builtInKeyName
) {
  var mappedKeyCode = config.keyCodes[key] || builtInKeyCode;
  if (builtInKeyName && eventKeyName && !config.keyCodes[key]) {
    return isKeyNotMatch(builtInKeyName, eventKeyName)
  } else if (mappedKeyCode) {
    return isKeyNotMatch(mappedKeyCode, eventKeyCode)
  } else if (eventKeyName) {
    return hyphenate(eventKeyName) !== key
  }
}

/*  */

/**
 * Runtime helper for merging v-bind="object" into a VNode's data.
 */
function bindObjectProps (
  data,
  tag,
  value,
  asProp,
  isSync
) {
  if (value) {
    if (!isObject(value)) {
      "production" !== 'production' && warn(
        'v-bind without argument expects an Object or Array value',
        this
      );
    } else {
      if (Array.isArray(value)) {
        value = toObject(value);
      }
      var hash;
      var loop = function ( key ) {
        if (
          key === 'class' ||
          key === 'style' ||
          isReservedAttribute(key)
        ) {
          hash = data;
        } else {
          var type = data.attrs && data.attrs.type;
          hash = asProp || config.mustUseProp(tag, type, key)
            ? data.domProps || (data.domProps = {})
            : data.attrs || (data.attrs = {});
        }
        var camelizedKey = camelize(key);
        var hyphenatedKey = hyphenate(key);
        if (!(camelizedKey in hash) && !(hyphenatedKey in hash)) {
          hash[key] = value[key];

          if (isSync) {
            var on = data.on || (data.on = {});
            on[("update:" + key)] = function ($event) {
              value[key] = $event;
            };
          }
        }
      };

      for (var key in value) loop( key );
    }
  }
  return data
}

/*  */

/**
 * Runtime helper for rendering static trees.
 */
function renderStatic (
  index,
  isInFor
) {
  var cached = this._staticTrees || (this._staticTrees = []);
  var tree = cached[index];
  // if has already-rendered static tree and not inside v-for,
  // we can reuse the same tree.
  if (tree && !isInFor) {
    return tree
  }
  // otherwise, render a fresh tree.
  tree = cached[index] = this.$options.staticRenderFns[index].call(
    this._renderProxy,
    null,
    this // for render fns generated for functional component templates
  );
  markStatic(tree, ("__static__" + index), false);
  return tree
}

/**
 * Runtime helper for v-once.
 * Effectively it means marking the node as static with a unique key.
 */
function markOnce (
  tree,
  index,
  key
) {
  markStatic(tree, ("__once__" + index + (key ? ("_" + key) : "")), true);
  return tree
}

function markStatic (
  tree,
  key,
  isOnce
) {
  if (Array.isArray(tree)) {
    for (var i = 0; i < tree.length; i++) {
      if (tree[i] && typeof tree[i] !== 'string') {
        markStaticNode(tree[i], (key + "_" + i), isOnce);
      }
    }
  } else {
    markStaticNode(tree, key, isOnce);
  }
}

function markStaticNode (node, key, isOnce) {
  node.isStatic = true;
  node.key = key;
  node.isOnce = isOnce;
}

/*  */

function bindObjectListeners (data, value) {
  if (value) {
    if (!isPlainObject(value)) {
      "production" !== 'production' && warn(
        'v-on without argument expects an Object value',
        this
      );
    } else {
      var on = data.on = data.on ? extend({}, data.on) : {};
      for (var key in value) {
        var existing = on[key];
        var ours = value[key];
        on[key] = existing ? [].concat(existing, ours) : ours;
      }
    }
  }
  return data
}

/*  */

function resolveScopedSlots (
  fns, // see flow/vnode
  res,
  // the following are added in 2.6
  hasDynamicKeys,
  contentHashKey
) {
  res = res || { $stable: !hasDynamicKeys };
  for (var i = 0; i < fns.length; i++) {
    var slot = fns[i];
    if (Array.isArray(slot)) {
      resolveScopedSlots(slot, res, hasDynamicKeys);
    } else if (slot) {
      // marker for reverse proxying v-slot without scope on this.$slots
      if (slot.proxy) {
        slot.fn.proxy = true;
      }
      res[slot.key] = slot.fn;
    }
  }
  if (contentHashKey) {
    (res).$key = contentHashKey;
  }
  return res
}

/*  */

function bindDynamicKeys (baseObj, values) {
  for (var i = 0; i < values.length; i += 2) {
    var key = values[i];
    if (typeof key === 'string' && key) {
      baseObj[values[i]] = values[i + 1];
    } else if (false) {
      // null is a special value for explicitly removing a binding
      warn(
        ("Invalid value for dynamic directive argument (expected string or null): " + key),
        this
      );
    }
  }
  return baseObj
}

// helper to dynamically append modifier runtime markers to event names.
// ensure only append when value is already string, otherwise it will be cast
// to string and cause the type check to miss.
function prependModifier (value, symbol) {
  return typeof value === 'string' ? symbol + value : value
}

/*  */

function installRenderHelpers (target) {
  target._o = markOnce;
  target._n = toNumber;
  target._s = toString;
  target._l = renderList;
  target._t = renderSlot;
  target._q = looseEqual;
  target._i = looseIndexOf;
  target._m = renderStatic;
  target._f = resolveFilter;
  target._k = checkKeyCodes;
  target._b = bindObjectProps;
  target._v = createTextVNode;
  target._e = createEmptyVNode;
  target._u = resolveScopedSlots;
  target._g = bindObjectListeners;
  target._d = bindDynamicKeys;
  target._p = prependModifier;
}

/*  */

function FunctionalRenderContext (
  data,
  props,
  children,
  parent,
  Ctor
) {
  var this$1 = this;

  var options = Ctor.options;
  // ensure the createElement function in functional components
  // gets a unique context - this is necessary for correct named slot check
  var contextVm;
  if (hasOwn(parent, '_uid')) {
    contextVm = Object.create(parent);
    // $flow-disable-line
    contextVm._original = parent;
  } else {
    // the context vm passed in is a functional context as well.
    // in this case we want to make sure we are able to get a hold to the
    // real context instance.
    contextVm = parent;
    // $flow-disable-line
    parent = parent._original;
  }
  var isCompiled = isTrue(options._compiled);
  var needNormalization = !isCompiled;

  this.data = data;
  this.props = props;
  this.children = children;
  this.parent = parent;
  this.listeners = data.on || emptyObject;
  this.injections = resolveInject(options.inject, parent);
  this.slots = function () {
    if (!this$1.$slots) {
      normalizeScopedSlots(
        data.scopedSlots,
        this$1.$slots = resolveSlots(children, parent)
      );
    }
    return this$1.$slots
  };

  Object.defineProperty(this, 'scopedSlots', ({
    enumerable: true,
    get: function get () {
      return normalizeScopedSlots(data.scopedSlots, this.slots())
    }
  }));

  // support for compiled functional template
  if (isCompiled) {
    // exposing $options for renderStatic()
    this.$options = options;
    // pre-resolve slots for renderSlot()
    this.$slots = this.slots();
    this.$scopedSlots = normalizeScopedSlots(data.scopedSlots, this.$slots);
  }

  if (options._scopeId) {
    this._c = function (a, b, c, d) {
      var vnode = createElement(contextVm, a, b, c, d, needNormalization);
      if (vnode && !Array.isArray(vnode)) {
        vnode.fnScopeId = options._scopeId;
        vnode.fnContext = parent;
      }
      return vnode
    };
  } else {
    this._c = function (a, b, c, d) { return createElement(contextVm, a, b, c, d, needNormalization); };
  }
}

installRenderHelpers(FunctionalRenderContext.prototype);

function createFunctionalComponent (
  Ctor,
  propsData,
  data,
  contextVm,
  children
) {
  var options = Ctor.options;
  var props = {};
  var propOptions = options.props;
  if (isDef(propOptions)) {
    for (var key in propOptions) {
      props[key] = validateProp(key, propOptions, propsData || emptyObject);
    }
  } else {
    if (isDef(data.attrs)) { mergeProps(props, data.attrs); }
    if (isDef(data.props)) { mergeProps(props, data.props); }
  }

  var renderContext = new FunctionalRenderContext(
    data,
    props,
    children,
    contextVm,
    Ctor
  );

  var vnode = options.render.call(null, renderContext._c, renderContext);

  if (vnode instanceof VNode) {
    return cloneAndMarkFunctionalResult(vnode, data, renderContext.parent, options, renderContext)
  } else if (Array.isArray(vnode)) {
    var vnodes = normalizeChildren(vnode) || [];
    var res = new Array(vnodes.length);
    for (var i = 0; i < vnodes.length; i++) {
      res[i] = cloneAndMarkFunctionalResult(vnodes[i], data, renderContext.parent, options, renderContext);
    }
    return res
  }
}

function cloneAndMarkFunctionalResult (vnode, data, contextVm, options, renderContext) {
  // #7817 clone node before setting fnContext, otherwise if the node is reused
  // (e.g. it was from a cached normal slot) the fnContext causes named slots
  // that should not be matched to match.
  var clone = cloneVNode(vnode);
  clone.fnContext = contextVm;
  clone.fnOptions = options;
  if (false) {
    (clone.devtoolsMeta = clone.devtoolsMeta || {}).renderContext = renderContext;
  }
  if (data.slot) {
    (clone.data || (clone.data = {})).slot = data.slot;
  }
  return clone
}

function mergeProps (to, from) {
  for (var key in from) {
    to[camelize(key)] = from[key];
  }
}

/*  */

/*  */

/*  */

/*  */

// inline hooks to be invoked on component VNodes during patch
var componentVNodeHooks = {
  init: function init (vnode, hydrating) {
    if (
      vnode.componentInstance &&
      !vnode.componentInstance._isDestroyed &&
      vnode.data.keepAlive
    ) {
      // kept-alive components, treat as a patch
      var mountedNode = vnode; // work around flow
      componentVNodeHooks.prepatch(mountedNode, mountedNode);
    } else {
      var child = vnode.componentInstance = createComponentInstanceForVnode(
        vnode,
        activeInstance
      );
      child.$mount(hydrating ? vnode.elm : undefined, hydrating);
    }
  },

  prepatch: function prepatch (oldVnode, vnode) {
    var options = vnode.componentOptions;
    var child = vnode.componentInstance = oldVnode.componentInstance;
    updateChildComponent(
      child,
      options.propsData, // updated props
      options.listeners, // updated listeners
      vnode, // new parent vnode
      options.children // new children
    );
  },

  insert: function insert (vnode) {
    var context = vnode.context;
    var componentInstance = vnode.componentInstance;
    if (!componentInstance._isMounted) {
      componentInstance._isMounted = true;
      callHook(componentInstance, 'mounted');
    }
    if (vnode.data.keepAlive) {
      if (context._isMounted) {
        // vue-router#1212
        // During updates, a kept-alive component's child components may
        // change, so directly walking the tree here may call activated hooks
        // on incorrect children. Instead we push them into a queue which will
        // be processed after the whole patch process ended.
        queueActivatedComponent(componentInstance);
      } else {
        activateChildComponent(componentInstance, true /* direct */);
      }
    }
  },

  destroy: function destroy (vnode) {
    var componentInstance = vnode.componentInstance;
    if (!componentInstance._isDestroyed) {
      if (!vnode.data.keepAlive) {
        componentInstance.$destroy();
      } else {
        deactivateChildComponent(componentInstance, true /* direct */);
      }
    }
  }
};

var hooksToMerge = Object.keys(componentVNodeHooks);

function createComponent (
  Ctor,
  data,
  context,
  children,
  tag
) {
  if (isUndef(Ctor)) {
    return
  }

  var baseCtor = context.$options._base;

  // plain options object: turn it into a constructor
  if (isObject(Ctor)) {
    Ctor = baseCtor.extend(Ctor);
  }

  // if at this stage it's not a constructor or an async component factory,
  // reject.
  if (typeof Ctor !== 'function') {
    if (false) {
      warn(("Invalid Component definition: " + (String(Ctor))), context);
    }
    return
  }

  // async component
  var asyncFactory;
  if (isUndef(Ctor.cid)) {
    asyncFactory = Ctor;
    Ctor = resolveAsyncComponent(asyncFactory, baseCtor);
    if (Ctor === undefined) {
      // return a placeholder node for async component, which is rendered
      // as a comment node but preserves all the raw information for the node.
      // the information will be used for async server-rendering and hydration.
      return createAsyncPlaceholder(
        asyncFactory,
        data,
        context,
        children,
        tag
      )
    }
  }

  data = data || {};

  // resolve constructor options in case global mixins are applied after
  // component constructor creation
  resolveConstructorOptions(Ctor);

  // transform component v-model data into props & events
  if (isDef(data.model)) {
    transformModel(Ctor.options, data);
  }

  // extract props
  var propsData = extractPropsFromVNodeData(data, Ctor, tag);

  // functional component
  if (isTrue(Ctor.options.functional)) {
    return createFunctionalComponent(Ctor, propsData, data, context, children)
  }

  // extract listeners, since these needs to be treated as
  // child component listeners instead of DOM listeners
  var listeners = data.on;
  // replace with listeners with .native modifier
  // so it gets processed during parent component patch.
  data.on = data.nativeOn;

  if (isTrue(Ctor.options.abstract)) {
    // abstract components do not keep anything
    // other than props & listeners & slot

    // work around flow
    var slot = data.slot;
    data = {};
    if (slot) {
      data.slot = slot;
    }
  }

  // install component management hooks onto the placeholder node
  installComponentHooks(data);

  // return a placeholder vnode
  var name = Ctor.options.name || tag;
  var vnode = new VNode(
    ("vue-component-" + (Ctor.cid) + (name ? ("-" + name) : '')),
    data, undefined, undefined, undefined, context,
    { Ctor: Ctor, propsData: propsData, listeners: listeners, tag: tag, children: children },
    asyncFactory
  );

  return vnode
}

function createComponentInstanceForVnode (
  vnode, // we know it's MountedComponentVNode but flow doesn't
  parent // activeInstance in lifecycle state
) {
  var options = {
    _isComponent: true,
    _parentVnode: vnode,
    parent: parent
  };
  // check inline-template render functions
  var inlineTemplate = vnode.data.inlineTemplate;
  if (isDef(inlineTemplate)) {
    options.render = inlineTemplate.render;
    options.staticRenderFns = inlineTemplate.staticRenderFns;
  }
  return new vnode.componentOptions.Ctor(options)
}

function installComponentHooks (data) {
  var hooks = data.hook || (data.hook = {});
  for (var i = 0; i < hooksToMerge.length; i++) {
    var key = hooksToMerge[i];
    var existing = hooks[key];
    var toMerge = componentVNodeHooks[key];
    if (existing !== toMerge && !(existing && existing._merged)) {
      hooks[key] = existing ? mergeHook$1(toMerge, existing) : toMerge;
    }
  }
}

function mergeHook$1 (f1, f2) {
  var merged = function (a, b) {
    // flow complains about extra args which is why we use any
    f1(a, b);
    f2(a, b);
  };
  merged._merged = true;
  return merged
}

// transform component v-model info (value and callback) into
// prop and event handler respectively.
function transformModel (options, data) {
  var prop = (options.model && options.model.prop) || 'value';
  var event = (options.model && options.model.event) || 'input'
  ;(data.attrs || (data.attrs = {}))[prop] = data.model.value;
  var on = data.on || (data.on = {});
  var existing = on[event];
  var callback = data.model.callback;
  if (isDef(existing)) {
    if (
      Array.isArray(existing)
        ? existing.indexOf(callback) === -1
        : existing !== callback
    ) {
      on[event] = [callback].concat(existing);
    }
  } else {
    on[event] = callback;
  }
}

/*  */

var SIMPLE_NORMALIZE = 1;
var ALWAYS_NORMALIZE = 2;

// wrapper function for providing a more flexible interface
// without getting yelled at by flow
function createElement (
  context,
  tag,
  data,
  children,
  normalizationType,
  alwaysNormalize
) {
  if (Array.isArray(data) || isPrimitive(data)) {
    normalizationType = children;
    children = data;
    data = undefined;
  }
  if (isTrue(alwaysNormalize)) {
    normalizationType = ALWAYS_NORMALIZE;
  }
  return _createElement(context, tag, data, children, normalizationType)
}

function _createElement (
  context,
  tag,
  data,
  children,
  normalizationType
) {
  if (isDef(data) && isDef((data).__ob__)) {
    "production" !== 'production' && warn(
      "Avoid using observed data object as vnode data: " + (JSON.stringify(data)) + "\n" +
      'Always create fresh vnode data objects in each render!',
      context
    );
    return createEmptyVNode()
  }
  // object syntax in v-bind
  if (isDef(data) && isDef(data.is)) {
    tag = data.is;
  }
  if (!tag) {
    // in case of component :is set to falsy value
    return createEmptyVNode()
  }
  // warn against non-primitive key
  if (false
  ) {
    {
      warn(
        'Avoid using non-primitive value as key, ' +
        'use string/number value instead.',
        context
      );
    }
  }
  // support single function children as default scoped slot
  if (Array.isArray(children) &&
    typeof children[0] === 'function'
  ) {
    data = data || {};
    data.scopedSlots = { default: children[0] };
    children.length = 0;
  }
  if (normalizationType === ALWAYS_NORMALIZE) {
    children = normalizeChildren(children);
  } else if (normalizationType === SIMPLE_NORMALIZE) {
    children = simpleNormalizeChildren(children);
  }
  var vnode, ns;
  if (typeof tag === 'string') {
    var Ctor;
    ns = (context.$vnode && context.$vnode.ns) || config.getTagNamespace(tag);
    if (config.isReservedTag(tag)) {
      // platform built-in elements
      if (false) {
        warn(
          ("The .native modifier for v-on is only valid on components but it was used on <" + tag + ">."),
          context
        );
      }
      vnode = new VNode(
        config.parsePlatformTagName(tag), data, children,
        undefined, undefined, context
      );
    } else if ((!data || !data.pre) && isDef(Ctor = resolveAsset(context.$options, 'components', tag))) {
      // component
      vnode = createComponent(Ctor, data, context, children, tag);
    } else {
      // unknown or unlisted namespaced elements
      // check at runtime because it may get assigned a namespace when its
      // parent normalizes children
      vnode = new VNode(
        tag, data, children,
        undefined, undefined, context
      );
    }
  } else {
    // direct component options / constructor
    vnode = createComponent(tag, data, context, children);
  }
  if (Array.isArray(vnode)) {
    return vnode
  } else if (isDef(vnode)) {
    if (isDef(ns)) { applyNS(vnode, ns); }
    if (isDef(data)) { registerDeepBindings(data); }
    return vnode
  } else {
    return createEmptyVNode()
  }
}

function applyNS (vnode, ns, force) {
  vnode.ns = ns;
  if (vnode.tag === 'foreignObject') {
    // use default namespace inside foreignObject
    ns = undefined;
    force = true;
  }
  if (isDef(vnode.children)) {
    for (var i = 0, l = vnode.children.length; i < l; i++) {
      var child = vnode.children[i];
      if (isDef(child.tag) && (
        isUndef(child.ns) || (isTrue(force) && child.tag !== 'svg'))) {
        applyNS(child, ns, force);
      }
    }
  }
}

// ref #5318
// necessary to ensure parent re-render when deep bindings like :style and
// :class are used on slot nodes
function registerDeepBindings (data) {
  if (isObject(data.style)) {
    traverse(data.style);
  }
  if (isObject(data.class)) {
    traverse(data.class);
  }
}

/*  */

function initRender (vm) {
  vm._vnode = null; // the root of the child tree
  vm._staticTrees = null; // v-once cached trees
  var options = vm.$options;
  var parentVnode = vm.$vnode = options._parentVnode; // the placeholder node in parent tree
  var renderContext = parentVnode && parentVnode.context;
  vm.$slots = resolveSlots(options._renderChildren, renderContext);
  vm.$scopedSlots = emptyObject;
  // bind the createElement fn to this instance
  // so that we get proper render context inside it.
  // args order: tag, data, children, normalizationType, alwaysNormalize
  // internal version is used by render functions compiled from templates
  vm._c = function (a, b, c, d) { return createElement(vm, a, b, c, d, false); };
  // normalization is always applied for the public version, used in
  // user-written render functions.
  vm.$createElement = function (a, b, c, d) { return createElement(vm, a, b, c, d, true); };

  // $attrs & $listeners are exposed for easier HOC creation.
  // they need to be reactive so that HOCs using them are always updated
  var parentData = parentVnode && parentVnode.data;

  /* istanbul ignore else */
  if (false) {
    defineReactive$$1(vm, '$attrs', parentData && parentData.attrs || emptyObject, function () {
      !isUpdatingChildComponent && warn("$attrs is readonly.", vm);
    }, true);
    defineReactive$$1(vm, '$listeners', options._parentListeners || emptyObject, function () {
      !isUpdatingChildComponent && warn("$listeners is readonly.", vm);
    }, true);
  } else {
    defineReactive$$1(vm, '$attrs', parentData && parentData.attrs || emptyObject, null, true);
    defineReactive$$1(vm, '$listeners', options._parentListeners || emptyObject, null, true);
  }
}

var currentRenderingInstance = null;

function renderMixin (Vue) {
  // install runtime convenience helpers
  installRenderHelpers(Vue.prototype);

  Vue.prototype.$nextTick = function (fn) {
    return nextTick(fn, this)
  };

  Vue.prototype._render = function () {
    var vm = this;
    var ref = vm.$options;
    var render = ref.render;
    var _parentVnode = ref._parentVnode;

    if (_parentVnode) {
      vm.$scopedSlots = normalizeScopedSlots(
        _parentVnode.data.scopedSlots,
        vm.$slots,
        vm.$scopedSlots
      );
    }

    // set parent vnode. this allows render functions to have access
    // to the data on the placeholder node.
    vm.$vnode = _parentVnode;
    // render self
    var vnode;
    try {
      // There's no need to maintain a stack because all render fns are called
      // separately from one another. Nested component's render fns are called
      // when parent component is patched.
      currentRenderingInstance = vm;
      vnode = render.call(vm._renderProxy, vm.$createElement);
    } catch (e) {
      handleError(e, vm, "render");
      // return error render result,
      // or previous vnode to prevent render error causing blank component
      /* istanbul ignore else */
      if (false) {
        try {
          vnode = vm.$options.renderError.call(vm._renderProxy, vm.$createElement, e);
        } catch (e) {
          handleError(e, vm, "renderError");
          vnode = vm._vnode;
        }
      } else {
        vnode = vm._vnode;
      }
    } finally {
      currentRenderingInstance = null;
    }
    // if the returned array contains only a single node, allow it
    if (Array.isArray(vnode) && vnode.length === 1) {
      vnode = vnode[0];
    }
    // return empty vnode in case the render function errored out
    if (!(vnode instanceof VNode)) {
      if (false) {
        warn(
          'Multiple root nodes returned from render function. Render function ' +
          'should return a single root node.',
          vm
        );
      }
      vnode = createEmptyVNode();
    }
    // set parent
    vnode.parent = _parentVnode;
    return vnode
  };
}

/*  */

function ensureCtor (comp, base) {
  if (
    comp.__esModule ||
    (hasSymbol && comp[Symbol.toStringTag] === 'Module')
  ) {
    comp = comp.default;
  }
  return isObject(comp)
    ? base.extend(comp)
    : comp
}

function createAsyncPlaceholder (
  factory,
  data,
  context,
  children,
  tag
) {
  var node = createEmptyVNode();
  node.asyncFactory = factory;
  node.asyncMeta = { data: data, context: context, children: children, tag: tag };
  return node
}

function resolveAsyncComponent (
  factory,
  baseCtor
) {
  if (isTrue(factory.error) && isDef(factory.errorComp)) {
    return factory.errorComp
  }

  if (isDef(factory.resolved)) {
    return factory.resolved
  }

  var owner = currentRenderingInstance;
  if (owner && isDef(factory.owners) && factory.owners.indexOf(owner) === -1) {
    // already pending
    factory.owners.push(owner);
  }

  if (isTrue(factory.loading) && isDef(factory.loadingComp)) {
    return factory.loadingComp
  }

  if (owner && !isDef(factory.owners)) {
    var owners = factory.owners = [owner];
    var sync = true;
    var timerLoading = null;
    var timerTimeout = null

    ;(owner).$on('hook:destroyed', function () { return remove(owners, owner); });

    var forceRender = function (renderCompleted) {
      for (var i = 0, l = owners.length; i < l; i++) {
        (owners[i]).$forceUpdate();
      }

      if (renderCompleted) {
        owners.length = 0;
        if (timerLoading !== null) {
          clearTimeout(timerLoading);
          timerLoading = null;
        }
        if (timerTimeout !== null) {
          clearTimeout(timerTimeout);
          timerTimeout = null;
        }
      }
    };

    var resolve = once(function (res) {
      // cache resolved
      factory.resolved = ensureCtor(res, baseCtor);
      // invoke callbacks only if this is not a synchronous resolve
      // (async resolves are shimmed as synchronous during SSR)
      if (!sync) {
        forceRender(true);
      } else {
        owners.length = 0;
      }
    });

    var reject = once(function (reason) {
      "production" !== 'production' && warn(
        "Failed to resolve async component: " + (String(factory)) +
        (reason ? ("\nReason: " + reason) : '')
      );
      if (isDef(factory.errorComp)) {
        factory.error = true;
        forceRender(true);
      }
    });

    var res = factory(resolve, reject);

    if (isObject(res)) {
      if (isPromise(res)) {
        // () => Promise
        if (isUndef(factory.resolved)) {
          res.then(resolve, reject);
        }
      } else if (isPromise(res.component)) {
        res.component.then(resolve, reject);

        if (isDef(res.error)) {
          factory.errorComp = ensureCtor(res.error, baseCtor);
        }

        if (isDef(res.loading)) {
          factory.loadingComp = ensureCtor(res.loading, baseCtor);
          if (res.delay === 0) {
            factory.loading = true;
          } else {
            timerLoading = setTimeout(function () {
              timerLoading = null;
              if (isUndef(factory.resolved) && isUndef(factory.error)) {
                factory.loading = true;
                forceRender(false);
              }
            }, res.delay || 200);
          }
        }

        if (isDef(res.timeout)) {
          timerTimeout = setTimeout(function () {
            timerTimeout = null;
            if (isUndef(factory.resolved)) {
              reject(
                 false
                  ? ("timeout (" + (res.timeout) + "ms)")
                  : null
              );
            }
          }, res.timeout);
        }
      }
    }

    sync = false;
    // return in case resolved synchronously
    return factory.loading
      ? factory.loadingComp
      : factory.resolved
  }
}

/*  */

function isAsyncPlaceholder (node) {
  return node.isComment && node.asyncFactory
}

/*  */

function getFirstComponentChild (children) {
  if (Array.isArray(children)) {
    for (var i = 0; i < children.length; i++) {
      var c = children[i];
      if (isDef(c) && (isDef(c.componentOptions) || isAsyncPlaceholder(c))) {
        return c
      }
    }
  }
}

/*  */

/*  */

function initEvents (vm) {
  vm._events = Object.create(null);
  vm._hasHookEvent = false;
  // init parent attached events
  var listeners = vm.$options._parentListeners;
  if (listeners) {
    updateComponentListeners(vm, listeners);
  }
}

var target;

function add (event, fn) {
  target.$on(event, fn);
}

function remove$1 (event, fn) {
  target.$off(event, fn);
}

function createOnceHandler (event, fn) {
  var _target = target;
  return function onceHandler () {
    var res = fn.apply(null, arguments);
    if (res !== null) {
      _target.$off(event, onceHandler);
    }
  }
}

function updateComponentListeners (
  vm,
  listeners,
  oldListeners
) {
  target = vm;
  updateListeners(listeners, oldListeners || {}, add, remove$1, createOnceHandler, vm);
  target = undefined;
}

function eventsMixin (Vue) {
  var hookRE = /^hook:/;
  Vue.prototype.$on = function (event, fn) {
    var vm = this;
    if (Array.isArray(event)) {
      for (var i = 0, l = event.length; i < l; i++) {
        vm.$on(event[i], fn);
      }
    } else {
      (vm._events[event] || (vm._events[event] = [])).push(fn);
      // optimize hook:event cost by using a boolean flag marked at registration
      // instead of a hash lookup
      if (hookRE.test(event)) {
        vm._hasHookEvent = true;
      }
    }
    return vm
  };

  Vue.prototype.$once = function (event, fn) {
    var vm = this;
    function on () {
      vm.$off(event, on);
      fn.apply(vm, arguments);
    }
    on.fn = fn;
    vm.$on(event, on);
    return vm
  };

  Vue.prototype.$off = function (event, fn) {
    var vm = this;
    // all
    if (!arguments.length) {
      vm._events = Object.create(null);
      return vm
    }
    // array of events
    if (Array.isArray(event)) {
      for (var i$1 = 0, l = event.length; i$1 < l; i$1++) {
        vm.$off(event[i$1], fn);
      }
      return vm
    }
    // specific event
    var cbs = vm._events[event];
    if (!cbs) {
      return vm
    }
    if (!fn) {
      vm._events[event] = null;
      return vm
    }
    // specific handler
    var cb;
    var i = cbs.length;
    while (i--) {
      cb = cbs[i];
      if (cb === fn || cb.fn === fn) {
        cbs.splice(i, 1);
        break
      }
    }
    return vm
  };

  Vue.prototype.$emit = function (event) {
    var vm = this;
    if (false) {
      var lowerCaseEvent = event.toLowerCase();
      if (lowerCaseEvent !== event && vm._events[lowerCaseEvent]) {
        tip(
          "Event \"" + lowerCaseEvent + "\" is emitted in component " +
          (formatComponentName(vm)) + " but the handler is registered for \"" + event + "\". " +
          "Note that HTML attributes are case-insensitive and you cannot use " +
          "v-on to listen to camelCase events when using in-DOM templates. " +
          "You should probably use \"" + (hyphenate(event)) + "\" instead of \"" + event + "\"."
        );
      }
    }
    var cbs = vm._events[event];
    if (cbs) {
      cbs = cbs.length > 1 ? toArray(cbs) : cbs;
      var args = toArray(arguments, 1);
      var info = "event handler for \"" + event + "\"";
      for (var i = 0, l = cbs.length; i < l; i++) {
        invokeWithErrorHandling(cbs[i], vm, args, vm, info);
      }
    }
    return vm
  };
}

/*  */

var activeInstance = null;
var isUpdatingChildComponent = false;

function setActiveInstance(vm) {
  var prevActiveInstance = activeInstance;
  activeInstance = vm;
  return function () {
    activeInstance = prevActiveInstance;
  }
}

function initLifecycle (vm) {
  var options = vm.$options;

  // locate first non-abstract parent
  var parent = options.parent;
  if (parent && !options.abstract) {
    while (parent.$options.abstract && parent.$parent) {
      parent = parent.$parent;
    }
    parent.$children.push(vm);
  }

  vm.$parent = parent;
  vm.$root = parent ? parent.$root : vm;

  vm.$children = [];
  vm.$refs = {};

  vm._watcher = null;
  vm._inactive = null;
  vm._directInactive = false;
  vm._isMounted = false;
  vm._isDestroyed = false;
  vm._isBeingDestroyed = false;
}

function lifecycleMixin (Vue) {
  Vue.prototype._update = function (vnode, hydrating) {
    var vm = this;
    var prevEl = vm.$el;
    var prevVnode = vm._vnode;
    var restoreActiveInstance = setActiveInstance(vm);
    vm._vnode = vnode;
    // Vue.prototype.__patch__ is injected in entry points
    // based on the rendering backend used.
    if (!prevVnode) {
      // initial render
      vm.$el = vm.__patch__(vm.$el, vnode, hydrating, false /* removeOnly */);
    } else {
      // updates
      vm.$el = vm.__patch__(prevVnode, vnode);
    }
    restoreActiveInstance();
    // update __vue__ reference
    if (prevEl) {
      prevEl.__vue__ = null;
    }
    if (vm.$el) {
      vm.$el.__vue__ = vm;
    }
    // if parent is an HOC, update its $el as well
    if (vm.$vnode && vm.$parent && vm.$vnode === vm.$parent._vnode) {
      vm.$parent.$el = vm.$el;
    }
    // updated hook is called by the scheduler to ensure that children are
    // updated in a parent's updated hook.
  };

  Vue.prototype.$forceUpdate = function () {
    var vm = this;
    if (vm._watcher) {
      vm._watcher.update();
    }
  };

  Vue.prototype.$destroy = function () {
    var vm = this;
    if (vm._isBeingDestroyed) {
      return
    }
    callHook(vm, 'beforeDestroy');
    vm._isBeingDestroyed = true;
    // remove self from parent
    var parent = vm.$parent;
    if (parent && !parent._isBeingDestroyed && !vm.$options.abstract) {
      remove(parent.$children, vm);
    }
    // teardown watchers
    if (vm._watcher) {
      vm._watcher.teardown();
    }
    var i = vm._watchers.length;
    while (i--) {
      vm._watchers[i].teardown();
    }
    // remove reference from data ob
    // frozen object may not have observer.
    if (vm._data.__ob__) {
      vm._data.__ob__.vmCount--;
    }
    // call the last hook...
    vm._isDestroyed = true;
    // invoke destroy hooks on current rendered tree
    vm.__patch__(vm._vnode, null);
    // fire destroyed hook
    callHook(vm, 'destroyed');
    // turn off all instance listeners.
    vm.$off();
    // remove __vue__ reference
    if (vm.$el) {
      vm.$el.__vue__ = null;
    }
    // release circular reference (#6759)
    if (vm.$vnode) {
      vm.$vnode.parent = null;
    }
  };
}

function mountComponent (
  vm,
  el,
  hydrating
) {
  vm.$el = el;
  if (!vm.$options.render) {
    vm.$options.render = createEmptyVNode;
    if (false) {
      /* istanbul ignore if */
      if ((vm.$options.template && vm.$options.template.charAt(0) !== '#') ||
        vm.$options.el || el) {
        warn(
          'You are using the runtime-only build of Vue where the template ' +
          'compiler is not available. Either pre-compile the templates into ' +
          'render functions, or use the compiler-included build.',
          vm
        );
      } else {
        warn(
          'Failed to mount component: template or render function not defined.',
          vm
        );
      }
    }
  }
  callHook(vm, 'beforeMount');

  var updateComponent;
  /* istanbul ignore if */
  if (false) {
    updateComponent = function () {
      var name = vm._name;
      var id = vm._uid;
      var startTag = "vue-perf-start:" + id;
      var endTag = "vue-perf-end:" + id;

      mark(startTag);
      var vnode = vm._render();
      mark(endTag);
      measure(("vue " + name + " render"), startTag, endTag);

      mark(startTag);
      vm._update(vnode, hydrating);
      mark(endTag);
      measure(("vue " + name + " patch"), startTag, endTag);
    };
  } else {
    updateComponent = function () {
      vm._update(vm._render(), hydrating);
    };
  }

  // we set this to vm._watcher inside the watcher's constructor
  // since the watcher's initial patch may call $forceUpdate (e.g. inside child
  // component's mounted hook), which relies on vm._watcher being already defined
  new Watcher(vm, updateComponent, noop, {
    before: function before () {
      if (vm._isMounted && !vm._isDestroyed) {
        callHook(vm, 'beforeUpdate');
      }
    }
  }, true /* isRenderWatcher */);
  hydrating = false;

  // manually mounted instance, call mounted on self
  // mounted is called for render-created child components in its inserted hook
  if (vm.$vnode == null) {
    vm._isMounted = true;
    callHook(vm, 'mounted');
  }
  return vm
}

function updateChildComponent (
  vm,
  propsData,
  listeners,
  parentVnode,
  renderChildren
) {
  if (false) {
    isUpdatingChildComponent = true;
  }

  // determine whether component has slot children
  // we need to do this before overwriting $options._renderChildren.

  // check if there are dynamic scopedSlots (hand-written or compiled but with
  // dynamic slot names). Static scoped slots compiled from template has the
  // "$stable" marker.
  var newScopedSlots = parentVnode.data.scopedSlots;
  var oldScopedSlots = vm.$scopedSlots;
  var hasDynamicScopedSlot = !!(
    (newScopedSlots && !newScopedSlots.$stable) ||
    (oldScopedSlots !== emptyObject && !oldScopedSlots.$stable) ||
    (newScopedSlots && vm.$scopedSlots.$key !== newScopedSlots.$key)
  );

  // Any static slot children from the parent may have changed during parent's
  // update. Dynamic scoped slots may also have changed. In such cases, a forced
  // update is necessary to ensure correctness.
  var needsForceUpdate = !!(
    renderChildren ||               // has new static slots
    vm.$options._renderChildren ||  // has old static slots
    hasDynamicScopedSlot
  );

  vm.$options._parentVnode = parentVnode;
  vm.$vnode = parentVnode; // update vm's placeholder node without re-render

  if (vm._vnode) { // update child tree's parent
    vm._vnode.parent = parentVnode;
  }
  vm.$options._renderChildren = renderChildren;

  // update $attrs and $listeners hash
  // these are also reactive so they may trigger child update if the child
  // used them during render
  vm.$attrs = parentVnode.data.attrs || emptyObject;
  vm.$listeners = listeners || emptyObject;

  // update props
  if (propsData && vm.$options.props) {
    toggleObserving(false);
    var props = vm._props;
    var propKeys = vm.$options._propKeys || [];
    for (var i = 0; i < propKeys.length; i++) {
      var key = propKeys[i];
      var propOptions = vm.$options.props; // wtf flow?
      props[key] = validateProp(key, propOptions, propsData, vm);
    }
    toggleObserving(true);
    // keep a copy of raw propsData
    vm.$options.propsData = propsData;
  }

  // update listeners
  listeners = listeners || emptyObject;
  var oldListeners = vm.$options._parentListeners;
  vm.$options._parentListeners = listeners;
  updateComponentListeners(vm, listeners, oldListeners);

  // resolve slots + force update if has children
  if (needsForceUpdate) {
    vm.$slots = resolveSlots(renderChildren, parentVnode.context);
    vm.$forceUpdate();
  }

  if (false) {
    isUpdatingChildComponent = false;
  }
}

function isInInactiveTree (vm) {
  while (vm && (vm = vm.$parent)) {
    if (vm._inactive) { return true }
  }
  return false
}

function activateChildComponent (vm, direct) {
  if (direct) {
    vm._directInactive = false;
    if (isInInactiveTree(vm)) {
      return
    }
  } else if (vm._directInactive) {
    return
  }
  if (vm._inactive || vm._inactive === null) {
    vm._inactive = false;
    for (var i = 0; i < vm.$children.length; i++) {
      activateChildComponent(vm.$children[i]);
    }
    callHook(vm, 'activated');
  }
}

function deactivateChildComponent (vm, direct) {
  if (direct) {
    vm._directInactive = true;
    if (isInInactiveTree(vm)) {
      return
    }
  }
  if (!vm._inactive) {
    vm._inactive = true;
    for (var i = 0; i < vm.$children.length; i++) {
      deactivateChildComponent(vm.$children[i]);
    }
    callHook(vm, 'deactivated');
  }
}

function callHook (vm, hook) {
  // #7573 disable dep collection when invoking lifecycle hooks
  pushTarget();
  var handlers = vm.$options[hook];
  var info = hook + " hook";
  if (handlers) {
    for (var i = 0, j = handlers.length; i < j; i++) {
      invokeWithErrorHandling(handlers[i], vm, null, vm, info);
    }
  }
  if (vm._hasHookEvent) {
    vm.$emit('hook:' + hook);
  }
  popTarget();
}

/*  */

var MAX_UPDATE_COUNT = 100;

var queue = [];
var activatedChildren = [];
var has = {};
var circular = {};
var waiting = false;
var flushing = false;
var index = 0;

/**
 * Reset the scheduler's state.
 */
function resetSchedulerState () {
  index = queue.length = activatedChildren.length = 0;
  has = {};
  if (false) {
    circular = {};
  }
  waiting = flushing = false;
}

// Async edge case #6566 requires saving the timestamp when event listeners are
// attached. However, calling performance.now() has a perf overhead especially
// if the page has thousands of event listeners. Instead, we take a timestamp
// every time the scheduler flushes and use that for all event listeners
// attached during that flush.
var currentFlushTimestamp = 0;

// Async edge case fix requires storing an event listener's attach timestamp.
var getNow = Date.now;

// Determine what event timestamp the browser is using. Annoyingly, the
// timestamp can either be hi-res (relative to page load) or low-res
// (relative to UNIX epoch), so in order to compare time we have to use the
// same timestamp type when saving the flush timestamp.
// All IE versions use low-res event timestamps, and have problematic clock
// implementations (#9632)
if (inBrowser && !isIE) {
  var performance = window.performance;
  if (
    performance &&
    typeof performance.now === 'function' &&
    getNow() > document.createEvent('Event').timeStamp
  ) {
    // if the event timestamp, although evaluated AFTER the Date.now(), is
    // smaller than it, it means the event is using a hi-res timestamp,
    // and we need to use the hi-res version for event listener timestamps as
    // well.
    getNow = function () { return performance.now(); };
  }
}

/**
 * Flush both queues and run the watchers.
 */
function flushSchedulerQueue () {
  currentFlushTimestamp = getNow();
  flushing = true;
  var watcher, id;

  // Sort queue before flush.
  // This ensures that:
  // 1. Components are updated from parent to child. (because parent is always
  //    created before the child)
  // 2. A component's user watchers are run before its render watcher (because
  //    user watchers are created before the render watcher)
  // 3. If a component is destroyed during a parent component's watcher run,
  //    its watchers can be skipped.
  queue.sort(function (a, b) { return a.id - b.id; });

  // do not cache length because more watchers might be pushed
  // as we run existing watchers
  for (index = 0; index < queue.length; index++) {
    watcher = queue[index];
    if (watcher.before) {
      watcher.before();
    }
    id = watcher.id;
    has[id] = null;
    watcher.run();
    // in dev build, check and stop circular updates.
    if (false) {
      circular[id] = (circular[id] || 0) + 1;
      if (circular[id] > MAX_UPDATE_COUNT) {
        warn(
          'You may have an infinite update loop ' + (
            watcher.user
              ? ("in watcher with expression \"" + (watcher.expression) + "\"")
              : "in a component render function."
          ),
          watcher.vm
        );
        break
      }
    }
  }

  // keep copies of post queues before resetting state
  var activatedQueue = activatedChildren.slice();
  var updatedQueue = queue.slice();

  resetSchedulerState();

  // call component updated and activated hooks
  callActivatedHooks(activatedQueue);
  callUpdatedHooks(updatedQueue);

  // devtool hook
  /* istanbul ignore if */
  if (devtools && config.devtools) {
    devtools.emit('flush');
  }
}

function callUpdatedHooks (queue) {
  var i = queue.length;
  while (i--) {
    var watcher = queue[i];
    var vm = watcher.vm;
    if (vm._watcher === watcher && vm._isMounted && !vm._isDestroyed) {
      callHook(vm, 'updated');
    }
  }
}

/**
 * Queue a kept-alive component that was activated during patch.
 * The queue will be processed after the entire tree has been patched.
 */
function queueActivatedComponent (vm) {
  // setting _inactive to false here so that a render function can
  // rely on checking whether it's in an inactive tree (e.g. router-view)
  vm._inactive = false;
  activatedChildren.push(vm);
}

function callActivatedHooks (queue) {
  for (var i = 0; i < queue.length; i++) {
    queue[i]._inactive = true;
    activateChildComponent(queue[i], true /* true */);
  }
}

/**
 * Push a watcher into the watcher queue.
 * Jobs with duplicate IDs will be skipped unless it's
 * pushed when the queue is being flushed.
 */
function queueWatcher (watcher) {
  var id = watcher.id;
  if (has[id] == null) {
    has[id] = true;
    if (!flushing) {
      queue.push(watcher);
    } else {
      // if already flushing, splice the watcher based on its id
      // if already past its id, it will be run next immediately.
      var i = queue.length - 1;
      while (i > index && queue[i].id > watcher.id) {
        i--;
      }
      queue.splice(i + 1, 0, watcher);
    }
    // queue the flush
    if (!waiting) {
      waiting = true;

      if (false) {
        flushSchedulerQueue();
        return
      }
      nextTick(flushSchedulerQueue);
    }
  }
}

/*  */



var uid$2 = 0;

/**
 * A watcher parses an expression, collects dependencies,
 * and fires callback when the expression value changes.
 * This is used for both the $watch() api and directives.
 */
var Watcher = function Watcher (
  vm,
  expOrFn,
  cb,
  options,
  isRenderWatcher
) {
  this.vm = vm;
  if (isRenderWatcher) {
    vm._watcher = this;
  }
  vm._watchers.push(this);
  // options
  if (options) {
    this.deep = !!options.deep;
    this.user = !!options.user;
    this.lazy = !!options.lazy;
    this.sync = !!options.sync;
    this.before = options.before;
  } else {
    this.deep = this.user = this.lazy = this.sync = false;
  }
  this.cb = cb;
  this.id = ++uid$2; // uid for batching
  this.active = true;
  this.dirty = this.lazy; // for lazy watchers
  this.deps = [];
  this.newDeps = [];
  this.depIds = new _Set();
  this.newDepIds = new _Set();
  this.expression =  false
    ? expOrFn.toString()
    : '';
  // parse expression for getter
  if (typeof expOrFn === 'function') {
    this.getter = expOrFn;
  } else {
    this.getter = parsePath(expOrFn);
    if (!this.getter) {
      this.getter = noop;
      "production" !== 'production' && warn(
        "Failed watching path: \"" + expOrFn + "\" " +
        'Watcher only accepts simple dot-delimited paths. ' +
        'For full control, use a function instead.',
        vm
      );
    }
  }
  this.value = this.lazy
    ? undefined
    : this.get();
};

/**
 * Evaluate the getter, and re-collect dependencies.
 */
Watcher.prototype.get = function get () {
  pushTarget(this);
  var value;
  var vm = this.vm;
  try {
    value = this.getter.call(vm, vm);
  } catch (e) {
    if (this.user) {
      handleError(e, vm, ("getter for watcher \"" + (this.expression) + "\""));
    } else {
      throw e
    }
  } finally {
    // "touch" every property so they are all tracked as
    // dependencies for deep watching
    if (this.deep) {
      traverse(value);
    }
    popTarget();
    this.cleanupDeps();
  }
  return value
};

/**
 * Add a dependency to this directive.
 */
Watcher.prototype.addDep = function addDep (dep) {
  var id = dep.id;
  if (!this.newDepIds.has(id)) {
    this.newDepIds.add(id);
    this.newDeps.push(dep);
    if (!this.depIds.has(id)) {
      dep.addSub(this);
    }
  }
};

/**
 * Clean up for dependency collection.
 */
Watcher.prototype.cleanupDeps = function cleanupDeps () {
  var i = this.deps.length;
  while (i--) {
    var dep = this.deps[i];
    if (!this.newDepIds.has(dep.id)) {
      dep.removeSub(this);
    }
  }
  var tmp = this.depIds;
  this.depIds = this.newDepIds;
  this.newDepIds = tmp;
  this.newDepIds.clear();
  tmp = this.deps;
  this.deps = this.newDeps;
  this.newDeps = tmp;
  this.newDeps.length = 0;
};

/**
 * Subscriber interface.
 * Will be called when a dependency changes.
 */
Watcher.prototype.update = function update () {
  /* istanbul ignore else */
  if (this.lazy) {
    this.dirty = true;
  } else if (this.sync) {
    this.run();
  } else {
    queueWatcher(this);
  }
};

/**
 * Scheduler job interface.
 * Will be called by the scheduler.
 */
Watcher.prototype.run = function run () {
  if (this.active) {
    var value = this.get();
    if (
      value !== this.value ||
      // Deep watchers and watchers on Object/Arrays should fire even
      // when the value is the same, because the value may
      // have mutated.
      isObject(value) ||
      this.deep
    ) {
      // set new value
      var oldValue = this.value;
      this.value = value;
      if (this.user) {
        try {
          this.cb.call(this.vm, value, oldValue);
        } catch (e) {
          handleError(e, this.vm, ("callback for watcher \"" + (this.expression) + "\""));
        }
      } else {
        this.cb.call(this.vm, value, oldValue);
      }
    }
  }
};

/**
 * Evaluate the value of the watcher.
 * This only gets called for lazy watchers.
 */
Watcher.prototype.evaluate = function evaluate () {
  this.value = this.get();
  this.dirty = false;
};

/**
 * Depend on all deps collected by this watcher.
 */
Watcher.prototype.depend = function depend () {
  var i = this.deps.length;
  while (i--) {
    this.deps[i].depend();
  }
};

/**
 * Remove self from all dependencies' subscriber list.
 */
Watcher.prototype.teardown = function teardown () {
  if (this.active) {
    // remove self from vm's watcher list
    // this is a somewhat expensive operation so we skip it
    // if the vm is being destroyed.
    if (!this.vm._isBeingDestroyed) {
      remove(this.vm._watchers, this);
    }
    var i = this.deps.length;
    while (i--) {
      this.deps[i].removeSub(this);
    }
    this.active = false;
  }
};

/*  */

var sharedPropertyDefinition = {
  enumerable: true,
  configurable: true,
  get: noop,
  set: noop
};

function proxy (target, sourceKey, key) {
  sharedPropertyDefinition.get = function proxyGetter () {
    return this[sourceKey][key]
  };
  sharedPropertyDefinition.set = function proxySetter (val) {
    this[sourceKey][key] = val;
  };
  Object.defineProperty(target, key, sharedPropertyDefinition);
}

function initState (vm) {
  vm._watchers = [];
  var opts = vm.$options;
  if (opts.props) { initProps(vm, opts.props); }
  if (opts.methods) { initMethods(vm, opts.methods); }
  if (opts.data) {
    initData(vm);
  } else {
    observe(vm._data = {}, true /* asRootData */);
  }
  if (opts.computed) { initComputed(vm, opts.computed); }
  if (opts.watch && opts.watch !== nativeWatch) {
    initWatch(vm, opts.watch);
  }
}

function initProps (vm, propsOptions) {
  var propsData = vm.$options.propsData || {};
  var props = vm._props = {};
  // cache prop keys so that future props updates can iterate using Array
  // instead of dynamic object key enumeration.
  var keys = vm.$options._propKeys = [];
  var isRoot = !vm.$parent;
  // root instance props should be converted
  if (!isRoot) {
    toggleObserving(false);
  }
  var loop = function ( key ) {
    keys.push(key);
    var value = validateProp(key, propsOptions, propsData, vm);
    /* istanbul ignore else */
    if (false) {
      var hyphenatedKey = hyphenate(key);
      if (isReservedAttribute(hyphenatedKey) ||
          config.isReservedAttr(hyphenatedKey)) {
        warn(
          ("\"" + hyphenatedKey + "\" is a reserved attribute and cannot be used as component prop."),
          vm
        );
      }
      defineReactive$$1(props, key, value, function () {
        if (!isRoot && !isUpdatingChildComponent) {
          warn(
            "Avoid mutating a prop directly since the value will be " +
            "overwritten whenever the parent component re-renders. " +
            "Instead, use a data or computed property based on the prop's " +
            "value. Prop being mutated: \"" + key + "\"",
            vm
          );
        }
      });
    } else {
      defineReactive$$1(props, key, value);
    }
    // static props are already proxied on the component's prototype
    // during Vue.extend(). We only need to proxy props defined at
    // instantiation here.
    if (!(key in vm)) {
      proxy(vm, "_props", key);
    }
  };

  for (var key in propsOptions) loop( key );
  toggleObserving(true);
}

function initData (vm) {
  var data = vm.$options.data;
  data = vm._data = typeof data === 'function'
    ? getData(data, vm)
    : data || {};
  if (!isPlainObject(data)) {
    data = {};
    "production" !== 'production' && warn(
      'data functions should return an object:\n' +
      'https://vuejs.org/v2/guide/components.html#data-Must-Be-a-Function',
      vm
    );
  }
  // proxy data on instance
  var keys = Object.keys(data);
  var props = vm.$options.props;
  var methods = vm.$options.methods;
  var i = keys.length;
  while (i--) {
    var key = keys[i];
    if (false) {
      if (methods && hasOwn(methods, key)) {
        warn(
          ("Method \"" + key + "\" has already been defined as a data property."),
          vm
        );
      }
    }
    if (props && hasOwn(props, key)) {
      "production" !== 'production' && warn(
        "The data property \"" + key + "\" is already declared as a prop. " +
        "Use prop default value instead.",
        vm
      );
    } else if (!isReserved(key)) {
      proxy(vm, "_data", key);
    }
  }
  // observe data
  observe(data, true /* asRootData */);
}

function getData (data, vm) {
  // #7573 disable dep collection when invoking data getters
  pushTarget();
  try {
    return data.call(vm, vm)
  } catch (e) {
    handleError(e, vm, "data()");
    return {}
  } finally {
    popTarget();
  }
}

var computedWatcherOptions = { lazy: true };

function initComputed (vm, computed) {
  // $flow-disable-line
  var watchers = vm._computedWatchers = Object.create(null);
  // computed properties are just getters during SSR
  var isSSR = isServerRendering();

  for (var key in computed) {
    var userDef = computed[key];
    var getter = typeof userDef === 'function' ? userDef : userDef.get;
    if (false) {
      warn(
        ("Getter is missing for computed property \"" + key + "\"."),
        vm
      );
    }

    if (!isSSR) {
      // create internal watcher for the computed property.
      watchers[key] = new Watcher(
        vm,
        getter || noop,
        noop,
        computedWatcherOptions
      );
    }

    // component-defined computed properties are already defined on the
    // component prototype. We only need to define computed properties defined
    // at instantiation here.
    if (!(key in vm)) {
      defineComputed(vm, key, userDef);
    } else if (false) {
      if (key in vm.$data) {
        warn(("The computed property \"" + key + "\" is already defined in data."), vm);
      } else if (vm.$options.props && key in vm.$options.props) {
        warn(("The computed property \"" + key + "\" is already defined as a prop."), vm);
      }
    }
  }
}

function defineComputed (
  target,
  key,
  userDef
) {
  var shouldCache = !isServerRendering();
  if (typeof userDef === 'function') {
    sharedPropertyDefinition.get = shouldCache
      ? createComputedGetter(key)
      : createGetterInvoker(userDef);
    sharedPropertyDefinition.set = noop;
  } else {
    sharedPropertyDefinition.get = userDef.get
      ? shouldCache && userDef.cache !== false
        ? createComputedGetter(key)
        : createGetterInvoker(userDef.get)
      : noop;
    sharedPropertyDefinition.set = userDef.set || noop;
  }
  if (false) {
    sharedPropertyDefinition.set = function () {
      warn(
        ("Computed property \"" + key + "\" was assigned to but it has no setter."),
        this
      );
    };
  }
  Object.defineProperty(target, key, sharedPropertyDefinition);
}

function createComputedGetter (key) {
  return function computedGetter () {
    var watcher = this._computedWatchers && this._computedWatchers[key];
    if (watcher) {
      if (watcher.dirty) {
        watcher.evaluate();
      }
      if (Dep.target) {
        watcher.depend();
      }
      return watcher.value
    }
  }
}

function createGetterInvoker(fn) {
  return function computedGetter () {
    return fn.call(this, this)
  }
}

function initMethods (vm, methods) {
  var props = vm.$options.props;
  for (var key in methods) {
    if (false) {
      if (typeof methods[key] !== 'function') {
        warn(
          "Method \"" + key + "\" has type \"" + (typeof methods[key]) + "\" in the component definition. " +
          "Did you reference the function correctly?",
          vm
        );
      }
      if (props && hasOwn(props, key)) {
        warn(
          ("Method \"" + key + "\" has already been defined as a prop."),
          vm
        );
      }
      if ((key in vm) && isReserved(key)) {
        warn(
          "Method \"" + key + "\" conflicts with an existing Vue instance method. " +
          "Avoid defining component methods that start with _ or $."
        );
      }
    }
    vm[key] = typeof methods[key] !== 'function' ? noop : bind(methods[key], vm);
  }
}

function initWatch (vm, watch) {
  for (var key in watch) {
    var handler = watch[key];
    if (Array.isArray(handler)) {
      for (var i = 0; i < handler.length; i++) {
        createWatcher(vm, key, handler[i]);
      }
    } else {
      createWatcher(vm, key, handler);
    }
  }
}

function createWatcher (
  vm,
  expOrFn,
  handler,
  options
) {
  if (isPlainObject(handler)) {
    options = handler;
    handler = handler.handler;
  }
  if (typeof handler === 'string') {
    handler = vm[handler];
  }
  return vm.$watch(expOrFn, handler, options)
}

function stateMixin (Vue) {
  // flow somehow has problems with directly declared definition object
  // when using Object.defineProperty, so we have to procedurally build up
  // the object here.
  var dataDef = {};
  dataDef.get = function () { return this._data };
  var propsDef = {};
  propsDef.get = function () { return this._props };
  if (false) {
    dataDef.set = function () {
      warn(
        'Avoid replacing instance root $data. ' +
        'Use nested data properties instead.',
        this
      );
    };
    propsDef.set = function () {
      warn("$props is readonly.", this);
    };
  }
  Object.defineProperty(Vue.prototype, '$data', dataDef);
  Object.defineProperty(Vue.prototype, '$props', propsDef);

  Vue.prototype.$set = set;
  Vue.prototype.$delete = del;

  Vue.prototype.$watch = function (
    expOrFn,
    cb,
    options
  ) {
    var vm = this;
    if (isPlainObject(cb)) {
      return createWatcher(vm, expOrFn, cb, options)
    }
    options = options || {};
    options.user = true;
    var watcher = new Watcher(vm, expOrFn, cb, options);
    if (options.immediate) {
      try {
        cb.call(vm, watcher.value);
      } catch (error) {
        handleError(error, vm, ("callback for immediate watcher \"" + (watcher.expression) + "\""));
      }
    }
    return function unwatchFn () {
      watcher.teardown();
    }
  };
}

/*  */

var uid$3 = 0;

function initMixin (Vue) {
  Vue.prototype._init = function (options) {
    var vm = this;
    // a uid
    vm._uid = uid$3++;

    var startTag, endTag;
    /* istanbul ignore if */
    if (false) {
      startTag = "vue-perf-start:" + (vm._uid);
      endTag = "vue-perf-end:" + (vm._uid);
      mark(startTag);
    }

    // a flag to avoid this being observed
    vm._isVue = true;
    // merge options
    if (options && options._isComponent) {
      // optimize internal component instantiation
      // since dynamic options merging is pretty slow, and none of the
      // internal component options needs special treatment.
      initInternalComponent(vm, options);
    } else {
      vm.$options = mergeOptions(
        resolveConstructorOptions(vm.constructor),
        options || {},
        vm
      );
    }
    /* istanbul ignore else */
    if (false) {
      initProxy(vm);
    } else {
      vm._renderProxy = vm;
    }
    // expose real self
    vm._self = vm;
    initLifecycle(vm);
    initEvents(vm);
    initRender(vm);
    callHook(vm, 'beforeCreate');
    initInjections(vm); // resolve injections before data/props
    initState(vm);
    initProvide(vm); // resolve provide after data/props
    callHook(vm, 'created');

    /* istanbul ignore if */
    if (false) {
      vm._name = formatComponentName(vm, false);
      mark(endTag);
      measure(("vue " + (vm._name) + " init"), startTag, endTag);
    }

    if (vm.$options.el) {
      vm.$mount(vm.$options.el);
    }
  };
}

function initInternalComponent (vm, options) {
  var opts = vm.$options = Object.create(vm.constructor.options);
  // doing this because it's faster than dynamic enumeration.
  var parentVnode = options._parentVnode;
  opts.parent = options.parent;
  opts._parentVnode = parentVnode;

  var vnodeComponentOptions = parentVnode.componentOptions;
  opts.propsData = vnodeComponentOptions.propsData;
  opts._parentListeners = vnodeComponentOptions.listeners;
  opts._renderChildren = vnodeComponentOptions.children;
  opts._componentTag = vnodeComponentOptions.tag;

  if (options.render) {
    opts.render = options.render;
    opts.staticRenderFns = options.staticRenderFns;
  }
}

function resolveConstructorOptions (Ctor) {
  var options = Ctor.options;
  if (Ctor.super) {
    var superOptions = resolveConstructorOptions(Ctor.super);
    var cachedSuperOptions = Ctor.superOptions;
    if (superOptions !== cachedSuperOptions) {
      // super option changed,
      // need to resolve new options.
      Ctor.superOptions = superOptions;
      // check if there are any late-modified/attached options (#4976)
      var modifiedOptions = resolveModifiedOptions(Ctor);
      // update base extend options
      if (modifiedOptions) {
        extend(Ctor.extendOptions, modifiedOptions);
      }
      options = Ctor.options = mergeOptions(superOptions, Ctor.extendOptions);
      if (options.name) {
        options.components[options.name] = Ctor;
      }
    }
  }
  return options
}

function resolveModifiedOptions (Ctor) {
  var modified;
  var latest = Ctor.options;
  var sealed = Ctor.sealedOptions;
  for (var key in latest) {
    if (latest[key] !== sealed[key]) {
      if (!modified) { modified = {}; }
      modified[key] = latest[key];
    }
  }
  return modified
}

function Vue (options) {
  if (false
  ) {
    warn('Vue is a constructor and should be called with the `new` keyword');
  }
  this._init(options);
}

initMixin(Vue);
stateMixin(Vue);
eventsMixin(Vue);
lifecycleMixin(Vue);
renderMixin(Vue);

/*  */

function initUse (Vue) {
  Vue.use = function (plugin) {
    var installedPlugins = (this._installedPlugins || (this._installedPlugins = []));
    if (installedPlugins.indexOf(plugin) > -1) {
      return this
    }

    // additional parameters
    var args = toArray(arguments, 1);
    args.unshift(this);
    if (typeof plugin.install === 'function') {
      plugin.install.apply(plugin, args);
    } else if (typeof plugin === 'function') {
      plugin.apply(null, args);
    }
    installedPlugins.push(plugin);
    return this
  };
}

/*  */

function initMixin$1 (Vue) {
  Vue.mixin = function (mixin) {
    this.options = mergeOptions(this.options, mixin);
    return this
  };
}

/*  */

function initExtend (Vue) {
  /**
   * Each instance constructor, including Vue, has a unique
   * cid. This enables us to create wrapped "child
   * constructors" for prototypal inheritance and cache them.
   */
  Vue.cid = 0;
  var cid = 1;

  /**
   * Class inheritance
   */
  Vue.extend = function (extendOptions) {
    extendOptions = extendOptions || {};
    var Super = this;
    var SuperId = Super.cid;
    var cachedCtors = extendOptions._Ctor || (extendOptions._Ctor = {});
    if (cachedCtors[SuperId]) {
      return cachedCtors[SuperId]
    }

    var name = extendOptions.name || Super.options.name;
    if (false) {
      validateComponentName(name);
    }

    var Sub = function VueComponent (options) {
      this._init(options);
    };
    Sub.prototype = Object.create(Super.prototype);
    Sub.prototype.constructor = Sub;
    Sub.cid = cid++;
    Sub.options = mergeOptions(
      Super.options,
      extendOptions
    );
    Sub['super'] = Super;

    // For props and computed properties, we define the proxy getters on
    // the Vue instances at extension time, on the extended prototype. This
    // avoids Object.defineProperty calls for each instance created.
    if (Sub.options.props) {
      initProps$1(Sub);
    }
    if (Sub.options.computed) {
      initComputed$1(Sub);
    }

    // allow further extension/mixin/plugin usage
    Sub.extend = Super.extend;
    Sub.mixin = Super.mixin;
    Sub.use = Super.use;

    // create asset registers, so extended classes
    // can have their private assets too.
    ASSET_TYPES.forEach(function (type) {
      Sub[type] = Super[type];
    });
    // enable recursive self-lookup
    if (name) {
      Sub.options.components[name] = Sub;
    }

    // keep a reference to the super options at extension time.
    // later at instantiation we can check if Super's options have
    // been updated.
    Sub.superOptions = Super.options;
    Sub.extendOptions = extendOptions;
    Sub.sealedOptions = extend({}, Sub.options);

    // cache constructor
    cachedCtors[SuperId] = Sub;
    return Sub
  };
}

function initProps$1 (Comp) {
  var props = Comp.options.props;
  for (var key in props) {
    proxy(Comp.prototype, "_props", key);
  }
}

function initComputed$1 (Comp) {
  var computed = Comp.options.computed;
  for (var key in computed) {
    defineComputed(Comp.prototype, key, computed[key]);
  }
}

/*  */

function initAssetRegisters (Vue) {
  /**
   * Create asset registration methods.
   */
  ASSET_TYPES.forEach(function (type) {
    Vue[type] = function (
      id,
      definition
    ) {
      if (!definition) {
        return this.options[type + 's'][id]
      } else {
        /* istanbul ignore if */
        if (false) {
          validateComponentName(id);
        }
        if (type === 'component' && isPlainObject(definition)) {
          definition.name = definition.name || id;
          definition = this.options._base.extend(definition);
        }
        if (type === 'directive' && typeof definition === 'function') {
          definition = { bind: definition, update: definition };
        }
        this.options[type + 's'][id] = definition;
        return definition
      }
    };
  });
}

/*  */



function getComponentName (opts) {
  return opts && (opts.Ctor.options.name || opts.tag)
}

function matches (pattern, name) {
  if (Array.isArray(pattern)) {
    return pattern.indexOf(name) > -1
  } else if (typeof pattern === 'string') {
    return pattern.split(',').indexOf(name) > -1
  } else if (isRegExp(pattern)) {
    return pattern.test(name)
  }
  /* istanbul ignore next */
  return false
}

function pruneCache (keepAliveInstance, filter) {
  var cache = keepAliveInstance.cache;
  var keys = keepAliveInstance.keys;
  var _vnode = keepAliveInstance._vnode;
  for (var key in cache) {
    var cachedNode = cache[key];
    if (cachedNode) {
      var name = getComponentName(cachedNode.componentOptions);
      if (name && !filter(name)) {
        pruneCacheEntry(cache, key, keys, _vnode);
      }
    }
  }
}

function pruneCacheEntry (
  cache,
  key,
  keys,
  current
) {
  var cached$$1 = cache[key];
  if (cached$$1 && (!current || cached$$1.tag !== current.tag)) {
    cached$$1.componentInstance.$destroy();
  }
  cache[key] = null;
  remove(keys, key);
}

var patternTypes = [String, RegExp, Array];

var KeepAlive = {
  name: 'keep-alive',
  abstract: true,

  props: {
    include: patternTypes,
    exclude: patternTypes,
    max: [String, Number]
  },

  created: function created () {
    this.cache = Object.create(null);
    this.keys = [];
  },

  destroyed: function destroyed () {
    for (var key in this.cache) {
      pruneCacheEntry(this.cache, key, this.keys);
    }
  },

  mounted: function mounted () {
    var this$1 = this;

    this.$watch('include', function (val) {
      pruneCache(this$1, function (name) { return matches(val, name); });
    });
    this.$watch('exclude', function (val) {
      pruneCache(this$1, function (name) { return !matches(val, name); });
    });
  },

  render: function render () {
    var slot = this.$slots.default;
    var vnode = getFirstComponentChild(slot);
    var componentOptions = vnode && vnode.componentOptions;
    if (componentOptions) {
      // check pattern
      var name = getComponentName(componentOptions);
      var ref = this;
      var include = ref.include;
      var exclude = ref.exclude;
      if (
        // not included
        (include && (!name || !matches(include, name))) ||
        // excluded
        (exclude && name && matches(exclude, name))
      ) {
        return vnode
      }

      var ref$1 = this;
      var cache = ref$1.cache;
      var keys = ref$1.keys;
      var key = vnode.key == null
        // same constructor may get registered as different local components
        // so cid alone is not enough (#3269)
        ? componentOptions.Ctor.cid + (componentOptions.tag ? ("::" + (componentOptions.tag)) : '')
        : vnode.key;
      if (cache[key]) {
        vnode.componentInstance = cache[key].componentInstance;
        // make current key freshest
        remove(keys, key);
        keys.push(key);
      } else {
        cache[key] = vnode;
        keys.push(key);
        // prune oldest entry
        if (this.max && keys.length > parseInt(this.max)) {
          pruneCacheEntry(cache, keys[0], keys, this._vnode);
        }
      }

      vnode.data.keepAlive = true;
    }
    return vnode || (slot && slot[0])
  }
};

var builtInComponents = {
  KeepAlive: KeepAlive
};

/*  */

function initGlobalAPI (Vue) {
  // config
  var configDef = {};
  configDef.get = function () { return config; };
  if (false) {
    configDef.set = function () {
      warn(
        'Do not replace the Vue.config object, set individual fields instead.'
      );
    };
  }
  Object.defineProperty(Vue, 'config', configDef);

  // exposed util methods.
  // NOTE: these are not considered part of the public API - avoid relying on
  // them unless you are aware of the risk.
  Vue.util = {
    warn: warn,
    extend: extend,
    mergeOptions: mergeOptions,
    defineReactive: defineReactive$$1
  };

  Vue.set = set;
  Vue.delete = del;
  Vue.nextTick = nextTick;

  // 2.6 explicit observable API
  Vue.observable = function (obj) {
    observe(obj);
    return obj
  };

  Vue.options = Object.create(null);
  ASSET_TYPES.forEach(function (type) {
    Vue.options[type + 's'] = Object.create(null);
  });

  // this is used to identify the "base" constructor to extend all plain-object
  // components with in Weex's multi-instance scenarios.
  Vue.options._base = Vue;

  extend(Vue.options.components, builtInComponents);

  initUse(Vue);
  initMixin$1(Vue);
  initExtend(Vue);
  initAssetRegisters(Vue);
}

initGlobalAPI(Vue);

Object.defineProperty(Vue.prototype, '$isServer', {
  get: isServerRendering
});

Object.defineProperty(Vue.prototype, '$ssrContext', {
  get: function get () {
    /* istanbul ignore next */
    return this.$vnode && this.$vnode.ssrContext
  }
});

// expose FunctionalRenderContext for ssr runtime helper installation
Object.defineProperty(Vue, 'FunctionalRenderContext', {
  value: FunctionalRenderContext
});

Vue.version = '2.6.12';

/*  */

// these are reserved for web because they are directly compiled away
// during template compilation
var isReservedAttr = makeMap('style,class');

// attributes that should be using props for binding
var acceptValue = makeMap('input,textarea,option,select,progress');
var mustUseProp = function (tag, type, attr) {
  return (
    (attr === 'value' && acceptValue(tag)) && type !== 'button' ||
    (attr === 'selected' && tag === 'option') ||
    (attr === 'checked' && tag === 'input') ||
    (attr === 'muted' && tag === 'video')
  )
};

var isEnumeratedAttr = makeMap('contenteditable,draggable,spellcheck');

var isValidContentEditableValue = makeMap('events,caret,typing,plaintext-only');

var convertEnumeratedValue = function (key, value) {
  return isFalsyAttrValue(value) || value === 'false'
    ? 'false'
    // allow arbitrary string value for contenteditable
    : key === 'contenteditable' && isValidContentEditableValue(value)
      ? value
      : 'true'
};

var isBooleanAttr = makeMap(
  'allowfullscreen,async,autofocus,autoplay,checked,compact,controls,declare,' +
  'default,defaultchecked,defaultmuted,defaultselected,defer,disabled,' +
  'enabled,formnovalidate,hidden,indeterminate,inert,ismap,itemscope,loop,multiple,' +
  'muted,nohref,noresize,noshade,novalidate,nowrap,open,pauseonexit,readonly,' +
  'required,reversed,scoped,seamless,selected,sortable,translate,' +
  'truespeed,typemustmatch,visible'
);

var xlinkNS = 'http://www.w3.org/1999/xlink';

var isXlink = function (name) {
  return name.charAt(5) === ':' && name.slice(0, 5) === 'xlink'
};

var getXlinkProp = function (name) {
  return isXlink(name) ? name.slice(6, name.length) : ''
};

var isFalsyAttrValue = function (val) {
  return val == null || val === false
};

/*  */

function genClassForVnode (vnode) {
  var data = vnode.data;
  var parentNode = vnode;
  var childNode = vnode;
  while (isDef(childNode.componentInstance)) {
    childNode = childNode.componentInstance._vnode;
    if (childNode && childNode.data) {
      data = mergeClassData(childNode.data, data);
    }
  }
  while (isDef(parentNode = parentNode.parent)) {
    if (parentNode && parentNode.data) {
      data = mergeClassData(data, parentNode.data);
    }
  }
  return renderClass(data.staticClass, data.class)
}

function mergeClassData (child, parent) {
  return {
    staticClass: concat(child.staticClass, parent.staticClass),
    class: isDef(child.class)
      ? [child.class, parent.class]
      : parent.class
  }
}

function renderClass (
  staticClass,
  dynamicClass
) {
  if (isDef(staticClass) || isDef(dynamicClass)) {
    return concat(staticClass, stringifyClass(dynamicClass))
  }
  /* istanbul ignore next */
  return ''
}

function concat (a, b) {
  return a ? b ? (a + ' ' + b) : a : (b || '')
}

function stringifyClass (value) {
  if (Array.isArray(value)) {
    return stringifyArray(value)
  }
  if (isObject(value)) {
    return stringifyObject(value)
  }
  if (typeof value === 'string') {
    return value
  }
  /* istanbul ignore next */
  return ''
}

function stringifyArray (value) {
  var res = '';
  var stringified;
  for (var i = 0, l = value.length; i < l; i++) {
    if (isDef(stringified = stringifyClass(value[i])) && stringified !== '') {
      if (res) { res += ' '; }
      res += stringified;
    }
  }
  return res
}

function stringifyObject (value) {
  var res = '';
  for (var key in value) {
    if (value[key]) {
      if (res) { res += ' '; }
      res += key;
    }
  }
  return res
}

/*  */

var namespaceMap = {
  svg: 'http://www.w3.org/2000/svg',
  math: 'http://www.w3.org/1998/Math/MathML'
};

var isHTMLTag = makeMap(
  'html,body,base,head,link,meta,style,title,' +
  'address,article,aside,footer,header,h1,h2,h3,h4,h5,h6,hgroup,nav,section,' +
  'div,dd,dl,dt,figcaption,figure,picture,hr,img,li,main,ol,p,pre,ul,' +
  'a,b,abbr,bdi,bdo,br,cite,code,data,dfn,em,i,kbd,mark,q,rp,rt,rtc,ruby,' +
  's,samp,small,span,strong,sub,sup,time,u,var,wbr,area,audio,map,track,video,' +
  'embed,object,param,source,canvas,script,noscript,del,ins,' +
  'caption,col,colgroup,table,thead,tbody,td,th,tr,' +
  'button,datalist,fieldset,form,input,label,legend,meter,optgroup,option,' +
  'output,progress,select,textarea,' +
  'details,dialog,menu,menuitem,summary,' +
  'content,element,shadow,template,blockquote,iframe,tfoot'
);

// this map is intentionally selective, only covering SVG elements that may
// contain child elements.
var isSVG = makeMap(
  'svg,animate,circle,clippath,cursor,defs,desc,ellipse,filter,font-face,' +
  'foreignObject,g,glyph,image,line,marker,mask,missing-glyph,path,pattern,' +
  'polygon,polyline,rect,switch,symbol,text,textpath,tspan,use,view',
  true
);

var isPreTag = function (tag) { return tag === 'pre'; };

var isReservedTag = function (tag) {
  return isHTMLTag(tag) || isSVG(tag)
};

function getTagNamespace (tag) {
  if (isSVG(tag)) {
    return 'svg'
  }
  // basic support for MathML
  // note it doesn't support other MathML elements being component roots
  if (tag === 'math') {
    return 'math'
  }
}

var unknownElementCache = Object.create(null);
function isUnknownElement (tag) {
  /* istanbul ignore if */
  if (!inBrowser) {
    return true
  }
  if (isReservedTag(tag)) {
    return false
  }
  tag = tag.toLowerCase();
  /* istanbul ignore if */
  if (unknownElementCache[tag] != null) {
    return unknownElementCache[tag]
  }
  var el = document.createElement(tag);
  if (tag.indexOf('-') > -1) {
    // http://stackoverflow.com/a/28210364/1070244
    return (unknownElementCache[tag] = (
      el.constructor === window.HTMLUnknownElement ||
      el.constructor === window.HTMLElement
    ))
  } else {
    return (unknownElementCache[tag] = /HTMLUnknownElement/.test(el.toString()))
  }
}

var isTextInputType = makeMap('text,number,password,search,email,tel,url');

/*  */

/**
 * Query an element selector if it's not an element already.
 */
function query (el) {
  if (typeof el === 'string') {
    var selected = document.querySelector(el);
    if (!selected) {
      "production" !== 'production' && warn(
        'Cannot find element: ' + el
      );
      return document.createElement('div')
    }
    return selected
  } else {
    return el
  }
}

/*  */

function createElement$1 (tagName, vnode) {
  var elm = document.createElement(tagName);
  if (tagName !== 'select') {
    return elm
  }
  // false or null will remove the attribute but undefined will not
  if (vnode.data && vnode.data.attrs && vnode.data.attrs.multiple !== undefined) {
    elm.setAttribute('multiple', 'multiple');
  }
  return elm
}

function createElementNS (namespace, tagName) {
  return document.createElementNS(namespaceMap[namespace], tagName)
}

function createTextNode (text) {
  return document.createTextNode(text)
}

function createComment (text) {
  return document.createComment(text)
}

function insertBefore (parentNode, newNode, referenceNode) {
  parentNode.insertBefore(newNode, referenceNode);
}

function removeChild (node, child) {
  node.removeChild(child);
}

function appendChild (node, child) {
  node.appendChild(child);
}

function parentNode (node) {
  return node.parentNode
}

function nextSibling (node) {
  return node.nextSibling
}

function tagName (node) {
  return node.tagName
}

function setTextContent (node, text) {
  node.textContent = text;
}

function setStyleScope (node, scopeId) {
  node.setAttribute(scopeId, '');
}

var nodeOps = /*#__PURE__*/Object.freeze({
  createElement: createElement$1,
  createElementNS: createElementNS,
  createTextNode: createTextNode,
  createComment: createComment,
  insertBefore: insertBefore,
  removeChild: removeChild,
  appendChild: appendChild,
  parentNode: parentNode,
  nextSibling: nextSibling,
  tagName: tagName,
  setTextContent: setTextContent,
  setStyleScope: setStyleScope
});

/*  */

var ref = {
  create: function create (_, vnode) {
    registerRef(vnode);
  },
  update: function update (oldVnode, vnode) {
    if (oldVnode.data.ref !== vnode.data.ref) {
      registerRef(oldVnode, true);
      registerRef(vnode);
    }
  },
  destroy: function destroy (vnode) {
    registerRef(vnode, true);
  }
};

function registerRef (vnode, isRemoval) {
  var key = vnode.data.ref;
  if (!isDef(key)) { return }

  var vm = vnode.context;
  var ref = vnode.componentInstance || vnode.elm;
  var refs = vm.$refs;
  if (isRemoval) {
    if (Array.isArray(refs[key])) {
      remove(refs[key], ref);
    } else if (refs[key] === ref) {
      refs[key] = undefined;
    }
  } else {
    if (vnode.data.refInFor) {
      if (!Array.isArray(refs[key])) {
        refs[key] = [ref];
      } else if (refs[key].indexOf(ref) < 0) {
        // $flow-disable-line
        refs[key].push(ref);
      }
    } else {
      refs[key] = ref;
    }
  }
}

/**
 * Virtual DOM patching algorithm based on Snabbdom by
 * Simon Friis Vindum (@paldepind)
 * Licensed under the MIT License
 * https://github.com/paldepind/snabbdom/blob/master/LICENSE
 *
 * modified by Evan You (@yyx990803)
 *
 * Not type-checking this because this file is perf-critical and the cost
 * of making flow understand it is not worth it.
 */

var emptyNode = new VNode('', {}, []);

var hooks = ['create', 'activate', 'update', 'remove', 'destroy'];

function sameVnode (a, b) {
  return (
    a.key === b.key && (
      (
        a.tag === b.tag &&
        a.isComment === b.isComment &&
        isDef(a.data) === isDef(b.data) &&
        sameInputType(a, b)
      ) || (
        isTrue(a.isAsyncPlaceholder) &&
        a.asyncFactory === b.asyncFactory &&
        isUndef(b.asyncFactory.error)
      )
    )
  )
}

function sameInputType (a, b) {
  if (a.tag !== 'input') { return true }
  var i;
  var typeA = isDef(i = a.data) && isDef(i = i.attrs) && i.type;
  var typeB = isDef(i = b.data) && isDef(i = i.attrs) && i.type;
  return typeA === typeB || isTextInputType(typeA) && isTextInputType(typeB)
}

function createKeyToOldIdx (children, beginIdx, endIdx) {
  var i, key;
  var map = {};
  for (i = beginIdx; i <= endIdx; ++i) {
    key = children[i].key;
    if (isDef(key)) { map[key] = i; }
  }
  return map
}

function createPatchFunction (backend) {
  var i, j;
  var cbs = {};

  var modules = backend.modules;
  var nodeOps = backend.nodeOps;

  for (i = 0; i < hooks.length; ++i) {
    cbs[hooks[i]] = [];
    for (j = 0; j < modules.length; ++j) {
      if (isDef(modules[j][hooks[i]])) {
        cbs[hooks[i]].push(modules[j][hooks[i]]);
      }
    }
  }

  function emptyNodeAt (elm) {
    return new VNode(nodeOps.tagName(elm).toLowerCase(), {}, [], undefined, elm)
  }

  function createRmCb (childElm, listeners) {
    function remove$$1 () {
      if (--remove$$1.listeners === 0) {
        removeNode(childElm);
      }
    }
    remove$$1.listeners = listeners;
    return remove$$1
  }

  function removeNode (el) {
    var parent = nodeOps.parentNode(el);
    // element may have already been removed due to v-html / v-text
    if (isDef(parent)) {
      nodeOps.removeChild(parent, el);
    }
  }

  function isUnknownElement$$1 (vnode, inVPre) {
    return (
      !inVPre &&
      !vnode.ns &&
      !(
        config.ignoredElements.length &&
        config.ignoredElements.some(function (ignore) {
          return isRegExp(ignore)
            ? ignore.test(vnode.tag)
            : ignore === vnode.tag
        })
      ) &&
      config.isUnknownElement(vnode.tag)
    )
  }

  var creatingElmInVPre = 0;

  function createElm (
    vnode,
    insertedVnodeQueue,
    parentElm,
    refElm,
    nested,
    ownerArray,
    index
  ) {
    if (isDef(vnode.elm) && isDef(ownerArray)) {
      // This vnode was used in a previous render!
      // now it's used as a new node, overwriting its elm would cause
      // potential patch errors down the road when it's used as an insertion
      // reference node. Instead, we clone the node on-demand before creating
      // associated DOM element for it.
      vnode = ownerArray[index] = cloneVNode(vnode);
    }

    vnode.isRootInsert = !nested; // for transition enter check
    if (createComponent(vnode, insertedVnodeQueue, parentElm, refElm)) {
      return
    }

    var data = vnode.data;
    var children = vnode.children;
    var tag = vnode.tag;
    if (isDef(tag)) {
      if (false) {
        if (data && data.pre) {
          creatingElmInVPre++;
        }
        if (isUnknownElement$$1(vnode, creatingElmInVPre)) {
          warn(
            'Unknown custom element: <' + tag + '> - did you ' +
            'register the component correctly? For recursive components, ' +
            'make sure to provide the "name" option.',
            vnode.context
          );
        }
      }

      vnode.elm = vnode.ns
        ? nodeOps.createElementNS(vnode.ns, tag)
        : nodeOps.createElement(tag, vnode);
      setScope(vnode);

      /* istanbul ignore if */
      {
        createChildren(vnode, children, insertedVnodeQueue);
        if (isDef(data)) {
          invokeCreateHooks(vnode, insertedVnodeQueue);
        }
        insert(parentElm, vnode.elm, refElm);
      }

      if (false) {
        creatingElmInVPre--;
      }
    } else if (isTrue(vnode.isComment)) {
      vnode.elm = nodeOps.createComment(vnode.text);
      insert(parentElm, vnode.elm, refElm);
    } else {
      vnode.elm = nodeOps.createTextNode(vnode.text);
      insert(parentElm, vnode.elm, refElm);
    }
  }

  function createComponent (vnode, insertedVnodeQueue, parentElm, refElm) {
    var i = vnode.data;
    if (isDef(i)) {
      var isReactivated = isDef(vnode.componentInstance) && i.keepAlive;
      if (isDef(i = i.hook) && isDef(i = i.init)) {
        i(vnode, false /* hydrating */);
      }
      // after calling the init hook, if the vnode is a child component
      // it should've created a child instance and mounted it. the child
      // component also has set the placeholder vnode's elm.
      // in that case we can just return the element and be done.
      if (isDef(vnode.componentInstance)) {
        initComponent(vnode, insertedVnodeQueue);
        insert(parentElm, vnode.elm, refElm);
        if (isTrue(isReactivated)) {
          reactivateComponent(vnode, insertedVnodeQueue, parentElm, refElm);
        }
        return true
      }
    }
  }

  function initComponent (vnode, insertedVnodeQueue) {
    if (isDef(vnode.data.pendingInsert)) {
      insertedVnodeQueue.push.apply(insertedVnodeQueue, vnode.data.pendingInsert);
      vnode.data.pendingInsert = null;
    }
    vnode.elm = vnode.componentInstance.$el;
    if (isPatchable(vnode)) {
      invokeCreateHooks(vnode, insertedVnodeQueue);
      setScope(vnode);
    } else {
      // empty component root.
      // skip all element-related modules except for ref (#3455)
      registerRef(vnode);
      // make sure to invoke the insert hook
      insertedVnodeQueue.push(vnode);
    }
  }

  function reactivateComponent (vnode, insertedVnodeQueue, parentElm, refElm) {
    var i;
    // hack for #4339: a reactivated component with inner transition
    // does not trigger because the inner node's created hooks are not called
    // again. It's not ideal to involve module-specific logic in here but
    // there doesn't seem to be a better way to do it.
    var innerNode = vnode;
    while (innerNode.componentInstance) {
      innerNode = innerNode.componentInstance._vnode;
      if (isDef(i = innerNode.data) && isDef(i = i.transition)) {
        for (i = 0; i < cbs.activate.length; ++i) {
          cbs.activate[i](emptyNode, innerNode);
        }
        insertedVnodeQueue.push(innerNode);
        break
      }
    }
    // unlike a newly created component,
    // a reactivated keep-alive component doesn't insert itself
    insert(parentElm, vnode.elm, refElm);
  }

  function insert (parent, elm, ref$$1) {
    if (isDef(parent)) {
      if (isDef(ref$$1)) {
        if (nodeOps.parentNode(ref$$1) === parent) {
          nodeOps.insertBefore(parent, elm, ref$$1);
        }
      } else {
        nodeOps.appendChild(parent, elm);
      }
    }
  }

  function createChildren (vnode, children, insertedVnodeQueue) {
    if (Array.isArray(children)) {
      if (false) {
        checkDuplicateKeys(children);
      }
      for (var i = 0; i < children.length; ++i) {
        createElm(children[i], insertedVnodeQueue, vnode.elm, null, true, children, i);
      }
    } else if (isPrimitive(vnode.text)) {
      nodeOps.appendChild(vnode.elm, nodeOps.createTextNode(String(vnode.text)));
    }
  }

  function isPatchable (vnode) {
    while (vnode.componentInstance) {
      vnode = vnode.componentInstance._vnode;
    }
    return isDef(vnode.tag)
  }

  function invokeCreateHooks (vnode, insertedVnodeQueue) {
    for (var i$1 = 0; i$1 < cbs.create.length; ++i$1) {
      cbs.create[i$1](emptyNode, vnode);
    }
    i = vnode.data.hook; // Reuse variable
    if (isDef(i)) {
      if (isDef(i.create)) { i.create(emptyNode, vnode); }
      if (isDef(i.insert)) { insertedVnodeQueue.push(vnode); }
    }
  }

  // set scope id attribute for scoped CSS.
  // this is implemented as a special case to avoid the overhead
  // of going through the normal attribute patching process.
  function setScope (vnode) {
    var i;
    if (isDef(i = vnode.fnScopeId)) {
      nodeOps.setStyleScope(vnode.elm, i);
    } else {
      var ancestor = vnode;
      while (ancestor) {
        if (isDef(i = ancestor.context) && isDef(i = i.$options._scopeId)) {
          nodeOps.setStyleScope(vnode.elm, i);
        }
        ancestor = ancestor.parent;
      }
    }
    // for slot content they should also get the scopeId from the host instance.
    if (isDef(i = activeInstance) &&
      i !== vnode.context &&
      i !== vnode.fnContext &&
      isDef(i = i.$options._scopeId)
    ) {
      nodeOps.setStyleScope(vnode.elm, i);
    }
  }

  function addVnodes (parentElm, refElm, vnodes, startIdx, endIdx, insertedVnodeQueue) {
    for (; startIdx <= endIdx; ++startIdx) {
      createElm(vnodes[startIdx], insertedVnodeQueue, parentElm, refElm, false, vnodes, startIdx);
    }
  }

  function invokeDestroyHook (vnode) {
    var i, j;
    var data = vnode.data;
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.destroy)) { i(vnode); }
      for (i = 0; i < cbs.destroy.length; ++i) { cbs.destroy[i](vnode); }
    }
    if (isDef(i = vnode.children)) {
      for (j = 0; j < vnode.children.length; ++j) {
        invokeDestroyHook(vnode.children[j]);
      }
    }
  }

  function removeVnodes (vnodes, startIdx, endIdx) {
    for (; startIdx <= endIdx; ++startIdx) {
      var ch = vnodes[startIdx];
      if (isDef(ch)) {
        if (isDef(ch.tag)) {
          removeAndInvokeRemoveHook(ch);
          invokeDestroyHook(ch);
        } else { // Text node
          removeNode(ch.elm);
        }
      }
    }
  }

  function removeAndInvokeRemoveHook (vnode, rm) {
    if (isDef(rm) || isDef(vnode.data)) {
      var i;
      var listeners = cbs.remove.length + 1;
      if (isDef(rm)) {
        // we have a recursively passed down rm callback
        // increase the listeners count
        rm.listeners += listeners;
      } else {
        // directly removing
        rm = createRmCb(vnode.elm, listeners);
      }
      // recursively invoke hooks on child component root node
      if (isDef(i = vnode.componentInstance) && isDef(i = i._vnode) && isDef(i.data)) {
        removeAndInvokeRemoveHook(i, rm);
      }
      for (i = 0; i < cbs.remove.length; ++i) {
        cbs.remove[i](vnode, rm);
      }
      if (isDef(i = vnode.data.hook) && isDef(i = i.remove)) {
        i(vnode, rm);
      } else {
        rm();
      }
    } else {
      removeNode(vnode.elm);
    }
  }

  function updateChildren (parentElm, oldCh, newCh, insertedVnodeQueue, removeOnly) {
    var oldStartIdx = 0;
    var newStartIdx = 0;
    var oldEndIdx = oldCh.length - 1;
    var oldStartVnode = oldCh[0];
    var oldEndVnode = oldCh[oldEndIdx];
    var newEndIdx = newCh.length - 1;
    var newStartVnode = newCh[0];
    var newEndVnode = newCh[newEndIdx];
    var oldKeyToIdx, idxInOld, vnodeToMove, refElm;

    // removeOnly is a special flag used only by <transition-group>
    // to ensure removed elements stay in correct relative positions
    // during leaving transitions
    var canMove = !removeOnly;

    if (false) {
      checkDuplicateKeys(newCh);
    }

    while (oldStartIdx <= oldEndIdx && newStartIdx <= newEndIdx) {
      if (isUndef(oldStartVnode)) {
        oldStartVnode = oldCh[++oldStartIdx]; // Vnode has been moved left
      } else if (isUndef(oldEndVnode)) {
        oldEndVnode = oldCh[--oldEndIdx];
      } else if (sameVnode(oldStartVnode, newStartVnode)) {
        patchVnode(oldStartVnode, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
        oldStartVnode = oldCh[++oldStartIdx];
        newStartVnode = newCh[++newStartIdx];
      } else if (sameVnode(oldEndVnode, newEndVnode)) {
        patchVnode(oldEndVnode, newEndVnode, insertedVnodeQueue, newCh, newEndIdx);
        oldEndVnode = oldCh[--oldEndIdx];
        newEndVnode = newCh[--newEndIdx];
      } else if (sameVnode(oldStartVnode, newEndVnode)) { // Vnode moved right
        patchVnode(oldStartVnode, newEndVnode, insertedVnodeQueue, newCh, newEndIdx);
        canMove && nodeOps.insertBefore(parentElm, oldStartVnode.elm, nodeOps.nextSibling(oldEndVnode.elm));
        oldStartVnode = oldCh[++oldStartIdx];
        newEndVnode = newCh[--newEndIdx];
      } else if (sameVnode(oldEndVnode, newStartVnode)) { // Vnode moved left
        patchVnode(oldEndVnode, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
        canMove && nodeOps.insertBefore(parentElm, oldEndVnode.elm, oldStartVnode.elm);
        oldEndVnode = oldCh[--oldEndIdx];
        newStartVnode = newCh[++newStartIdx];
      } else {
        if (isUndef(oldKeyToIdx)) { oldKeyToIdx = createKeyToOldIdx(oldCh, oldStartIdx, oldEndIdx); }
        idxInOld = isDef(newStartVnode.key)
          ? oldKeyToIdx[newStartVnode.key]
          : findIdxInOld(newStartVnode, oldCh, oldStartIdx, oldEndIdx);
        if (isUndef(idxInOld)) { // New element
          createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm, false, newCh, newStartIdx);
        } else {
          vnodeToMove = oldCh[idxInOld];
          if (sameVnode(vnodeToMove, newStartVnode)) {
            patchVnode(vnodeToMove, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
            oldCh[idxInOld] = undefined;
            canMove && nodeOps.insertBefore(parentElm, vnodeToMove.elm, oldStartVnode.elm);
          } else {
            // same key but different element. treat as new element
            createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm, false, newCh, newStartIdx);
          }
        }
        newStartVnode = newCh[++newStartIdx];
      }
    }
    if (oldStartIdx > oldEndIdx) {
      refElm = isUndef(newCh[newEndIdx + 1]) ? null : newCh[newEndIdx + 1].elm;
      addVnodes(parentElm, refElm, newCh, newStartIdx, newEndIdx, insertedVnodeQueue);
    } else if (newStartIdx > newEndIdx) {
      removeVnodes(oldCh, oldStartIdx, oldEndIdx);
    }
  }

  function checkDuplicateKeys (children) {
    var seenKeys = {};
    for (var i = 0; i < children.length; i++) {
      var vnode = children[i];
      var key = vnode.key;
      if (isDef(key)) {
        if (seenKeys[key]) {
          warn(
            ("Duplicate keys detected: '" + key + "'. This may cause an update error."),
            vnode.context
          );
        } else {
          seenKeys[key] = true;
        }
      }
    }
  }

  function findIdxInOld (node, oldCh, start, end) {
    for (var i = start; i < end; i++) {
      var c = oldCh[i];
      if (isDef(c) && sameVnode(node, c)) { return i }
    }
  }

  function patchVnode (
    oldVnode,
    vnode,
    insertedVnodeQueue,
    ownerArray,
    index,
    removeOnly
  ) {
    if (oldVnode === vnode) {
      return
    }

    if (isDef(vnode.elm) && isDef(ownerArray)) {
      // clone reused vnode
      vnode = ownerArray[index] = cloneVNode(vnode);
    }

    var elm = vnode.elm = oldVnode.elm;

    if (isTrue(oldVnode.isAsyncPlaceholder)) {
      if (isDef(vnode.asyncFactory.resolved)) {
        hydrate(oldVnode.elm, vnode, insertedVnodeQueue);
      } else {
        vnode.isAsyncPlaceholder = true;
      }
      return
    }

    // reuse element for static trees.
    // note we only do this if the vnode is cloned -
    // if the new node is not cloned it means the render functions have been
    // reset by the hot-reload-api and we need to do a proper re-render.
    if (isTrue(vnode.isStatic) &&
      isTrue(oldVnode.isStatic) &&
      vnode.key === oldVnode.key &&
      (isTrue(vnode.isCloned) || isTrue(vnode.isOnce))
    ) {
      vnode.componentInstance = oldVnode.componentInstance;
      return
    }

    var i;
    var data = vnode.data;
    if (isDef(data) && isDef(i = data.hook) && isDef(i = i.prepatch)) {
      i(oldVnode, vnode);
    }

    var oldCh = oldVnode.children;
    var ch = vnode.children;
    if (isDef(data) && isPatchable(vnode)) {
      for (i = 0; i < cbs.update.length; ++i) { cbs.update[i](oldVnode, vnode); }
      if (isDef(i = data.hook) && isDef(i = i.update)) { i(oldVnode, vnode); }
    }
    if (isUndef(vnode.text)) {
      if (isDef(oldCh) && isDef(ch)) {
        if (oldCh !== ch) { updateChildren(elm, oldCh, ch, insertedVnodeQueue, removeOnly); }
      } else if (isDef(ch)) {
        if (false) {
          checkDuplicateKeys(ch);
        }
        if (isDef(oldVnode.text)) { nodeOps.setTextContent(elm, ''); }
        addVnodes(elm, null, ch, 0, ch.length - 1, insertedVnodeQueue);
      } else if (isDef(oldCh)) {
        removeVnodes(oldCh, 0, oldCh.length - 1);
      } else if (isDef(oldVnode.text)) {
        nodeOps.setTextContent(elm, '');
      }
    } else if (oldVnode.text !== vnode.text) {
      nodeOps.setTextContent(elm, vnode.text);
    }
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.postpatch)) { i(oldVnode, vnode); }
    }
  }

  function invokeInsertHook (vnode, queue, initial) {
    // delay insert hooks for component root nodes, invoke them after the
    // element is really inserted
    if (isTrue(initial) && isDef(vnode.parent)) {
      vnode.parent.data.pendingInsert = queue;
    } else {
      for (var i = 0; i < queue.length; ++i) {
        queue[i].data.hook.insert(queue[i]);
      }
    }
  }

  var hydrationBailed = false;
  // list of modules that can skip create hook during hydration because they
  // are already rendered on the client or has no need for initialization
  // Note: style is excluded because it relies on initial clone for future
  // deep updates (#7063).
  var isRenderedModule = makeMap('attrs,class,staticClass,staticStyle,key');

  // Note: this is a browser-only function so we can assume elms are DOM nodes.
  function hydrate (elm, vnode, insertedVnodeQueue, inVPre) {
    var i;
    var tag = vnode.tag;
    var data = vnode.data;
    var children = vnode.children;
    inVPre = inVPre || (data && data.pre);
    vnode.elm = elm;

    if (isTrue(vnode.isComment) && isDef(vnode.asyncFactory)) {
      vnode.isAsyncPlaceholder = true;
      return true
    }
    // assert node match
    if (false) {
      if (!assertNodeMatch(elm, vnode, inVPre)) {
        return false
      }
    }
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.init)) { i(vnode, true /* hydrating */); }
      if (isDef(i = vnode.componentInstance)) {
        // child component. it should have hydrated its own tree.
        initComponent(vnode, insertedVnodeQueue);
        return true
      }
    }
    if (isDef(tag)) {
      if (isDef(children)) {
        // empty element, allow client to pick up and populate children
        if (!elm.hasChildNodes()) {
          createChildren(vnode, children, insertedVnodeQueue);
        } else {
          // v-html and domProps: innerHTML
          if (isDef(i = data) && isDef(i = i.domProps) && isDef(i = i.innerHTML)) {
            if (i !== elm.innerHTML) {
              /* istanbul ignore if */
              if (false
              ) {
                hydrationBailed = true;
                console.warn('Parent: ', elm);
                console.warn('server innerHTML: ', i);
                console.warn('client innerHTML: ', elm.innerHTML);
              }
              return false
            }
          } else {
            // iterate and compare children lists
            var childrenMatch = true;
            var childNode = elm.firstChild;
            for (var i$1 = 0; i$1 < children.length; i$1++) {
              if (!childNode || !hydrate(childNode, children[i$1], insertedVnodeQueue, inVPre)) {
                childrenMatch = false;
                break
              }
              childNode = childNode.nextSibling;
            }
            // if childNode is not null, it means the actual childNodes list is
            // longer than the virtual children list.
            if (!childrenMatch || childNode) {
              /* istanbul ignore if */
              if (false
              ) {
                hydrationBailed = true;
                console.warn('Parent: ', elm);
                console.warn('Mismatching childNodes vs. VNodes: ', elm.childNodes, children);
              }
              return false
            }
          }
        }
      }
      if (isDef(data)) {
        var fullInvoke = false;
        for (var key in data) {
          if (!isRenderedModule(key)) {
            fullInvoke = true;
            invokeCreateHooks(vnode, insertedVnodeQueue);
            break
          }
        }
        if (!fullInvoke && data['class']) {
          // ensure collecting deps for deep class bindings for future updates
          traverse(data['class']);
        }
      }
    } else if (elm.data !== vnode.text) {
      elm.data = vnode.text;
    }
    return true
  }

  function assertNodeMatch (node, vnode, inVPre) {
    if (isDef(vnode.tag)) {
      return vnode.tag.indexOf('vue-component') === 0 || (
        !isUnknownElement$$1(vnode, inVPre) &&
        vnode.tag.toLowerCase() === (node.tagName && node.tagName.toLowerCase())
      )
    } else {
      return node.nodeType === (vnode.isComment ? 8 : 3)
    }
  }

  return function patch (oldVnode, vnode, hydrating, removeOnly) {
    if (isUndef(vnode)) {
      if (isDef(oldVnode)) { invokeDestroyHook(oldVnode); }
      return
    }

    var isInitialPatch = false;
    var insertedVnodeQueue = [];

    if (isUndef(oldVnode)) {
      // empty mount (likely as component), create new root element
      isInitialPatch = true;
      createElm(vnode, insertedVnodeQueue);
    } else {
      var isRealElement = isDef(oldVnode.nodeType);
      if (!isRealElement && sameVnode(oldVnode, vnode)) {
        // patch existing root node
        patchVnode(oldVnode, vnode, insertedVnodeQueue, null, null, removeOnly);
      } else {
        if (isRealElement) {
          // mounting to a real element
          // check if this is server-rendered content and if we can perform
          // a successful hydration.
          if (oldVnode.nodeType === 1 && oldVnode.hasAttribute(SSR_ATTR)) {
            oldVnode.removeAttribute(SSR_ATTR);
            hydrating = true;
          }
          if (isTrue(hydrating)) {
            if (hydrate(oldVnode, vnode, insertedVnodeQueue)) {
              invokeInsertHook(vnode, insertedVnodeQueue, true);
              return oldVnode
            } else if (false) {
              warn(
                'The client-side rendered virtual DOM tree is not matching ' +
                'server-rendered content. This is likely caused by incorrect ' +
                'HTML markup, for example nesting block-level elements inside ' +
                '<p>, or missing <tbody>. Bailing hydration and performing ' +
                'full client-side render.'
              );
            }
          }
          // either not server-rendered, or hydration failed.
          // create an empty node and replace it
          oldVnode = emptyNodeAt(oldVnode);
        }

        // replacing existing element
        var oldElm = oldVnode.elm;
        var parentElm = nodeOps.parentNode(oldElm);

        // create new node
        createElm(
          vnode,
          insertedVnodeQueue,
          // extremely rare edge case: do not insert if old element is in a
          // leaving transition. Only happens when combining transition +
          // keep-alive + HOCs. (#4590)
          oldElm._leaveCb ? null : parentElm,
          nodeOps.nextSibling(oldElm)
        );

        // update parent placeholder node element, recursively
        if (isDef(vnode.parent)) {
          var ancestor = vnode.parent;
          var patchable = isPatchable(vnode);
          while (ancestor) {
            for (var i = 0; i < cbs.destroy.length; ++i) {
              cbs.destroy[i](ancestor);
            }
            ancestor.elm = vnode.elm;
            if (patchable) {
              for (var i$1 = 0; i$1 < cbs.create.length; ++i$1) {
                cbs.create[i$1](emptyNode, ancestor);
              }
              // #6513
              // invoke insert hooks that may have been merged by create hooks.
              // e.g. for directives that uses the "inserted" hook.
              var insert = ancestor.data.hook.insert;
              if (insert.merged) {
                // start at index 1 to avoid re-invoking component mounted hook
                for (var i$2 = 1; i$2 < insert.fns.length; i$2++) {
                  insert.fns[i$2]();
                }
              }
            } else {
              registerRef(ancestor);
            }
            ancestor = ancestor.parent;
          }
        }

        // destroy old node
        if (isDef(parentElm)) {
          removeVnodes([oldVnode], 0, 0);
        } else if (isDef(oldVnode.tag)) {
          invokeDestroyHook(oldVnode);
        }
      }
    }

    invokeInsertHook(vnode, insertedVnodeQueue, isInitialPatch);
    return vnode.elm
  }
}

/*  */

var directives = {
  create: updateDirectives,
  update: updateDirectives,
  destroy: function unbindDirectives (vnode) {
    updateDirectives(vnode, emptyNode);
  }
};

function updateDirectives (oldVnode, vnode) {
  if (oldVnode.data.directives || vnode.data.directives) {
    _update(oldVnode, vnode);
  }
}

function _update (oldVnode, vnode) {
  var isCreate = oldVnode === emptyNode;
  var isDestroy = vnode === emptyNode;
  var oldDirs = normalizeDirectives$1(oldVnode.data.directives, oldVnode.context);
  var newDirs = normalizeDirectives$1(vnode.data.directives, vnode.context);

  var dirsWithInsert = [];
  var dirsWithPostpatch = [];

  var key, oldDir, dir;
  for (key in newDirs) {
    oldDir = oldDirs[key];
    dir = newDirs[key];
    if (!oldDir) {
      // new directive, bind
      callHook$1(dir, 'bind', vnode, oldVnode);
      if (dir.def && dir.def.inserted) {
        dirsWithInsert.push(dir);
      }
    } else {
      // existing directive, update
      dir.oldValue = oldDir.value;
      dir.oldArg = oldDir.arg;
      callHook$1(dir, 'update', vnode, oldVnode);
      if (dir.def && dir.def.componentUpdated) {
        dirsWithPostpatch.push(dir);
      }
    }
  }

  if (dirsWithInsert.length) {
    var callInsert = function () {
      for (var i = 0; i < dirsWithInsert.length; i++) {
        callHook$1(dirsWithInsert[i], 'inserted', vnode, oldVnode);
      }
    };
    if (isCreate) {
      mergeVNodeHook(vnode, 'insert', callInsert);
    } else {
      callInsert();
    }
  }

  if (dirsWithPostpatch.length) {
    mergeVNodeHook(vnode, 'postpatch', function () {
      for (var i = 0; i < dirsWithPostpatch.length; i++) {
        callHook$1(dirsWithPostpatch[i], 'componentUpdated', vnode, oldVnode);
      }
    });
  }

  if (!isCreate) {
    for (key in oldDirs) {
      if (!newDirs[key]) {
        // no longer present, unbind
        callHook$1(oldDirs[key], 'unbind', oldVnode, oldVnode, isDestroy);
      }
    }
  }
}

var emptyModifiers = Object.create(null);

function normalizeDirectives$1 (
  dirs,
  vm
) {
  var res = Object.create(null);
  if (!dirs) {
    // $flow-disable-line
    return res
  }
  var i, dir;
  for (i = 0; i < dirs.length; i++) {
    dir = dirs[i];
    if (!dir.modifiers) {
      // $flow-disable-line
      dir.modifiers = emptyModifiers;
    }
    res[getRawDirName(dir)] = dir;
    dir.def = resolveAsset(vm.$options, 'directives', dir.name, true);
  }
  // $flow-disable-line
  return res
}

function getRawDirName (dir) {
  return dir.rawName || ((dir.name) + "." + (Object.keys(dir.modifiers || {}).join('.')))
}

function callHook$1 (dir, hook, vnode, oldVnode, isDestroy) {
  var fn = dir.def && dir.def[hook];
  if (fn) {
    try {
      fn(vnode.elm, dir, vnode, oldVnode, isDestroy);
    } catch (e) {
      handleError(e, vnode.context, ("directive " + (dir.name) + " " + hook + " hook"));
    }
  }
}

var baseModules = [
  ref,
  directives
];

/*  */

function updateAttrs (oldVnode, vnode) {
  var opts = vnode.componentOptions;
  if (isDef(opts) && opts.Ctor.options.inheritAttrs === false) {
    return
  }
  if (isUndef(oldVnode.data.attrs) && isUndef(vnode.data.attrs)) {
    return
  }
  var key, cur, old;
  var elm = vnode.elm;
  var oldAttrs = oldVnode.data.attrs || {};
  var attrs = vnode.data.attrs || {};
  // clone observed objects, as the user probably wants to mutate it
  if (isDef(attrs.__ob__)) {
    attrs = vnode.data.attrs = extend({}, attrs);
  }

  for (key in attrs) {
    cur = attrs[key];
    old = oldAttrs[key];
    if (old !== cur) {
      setAttr(elm, key, cur);
    }
  }
  // #4391: in IE9, setting type can reset value for input[type=radio]
  // #6666: IE/Edge forces progress value down to 1 before setting a max
  /* istanbul ignore if */
  if ((isIE || isEdge) && attrs.value !== oldAttrs.value) {
    setAttr(elm, 'value', attrs.value);
  }
  for (key in oldAttrs) {
    if (isUndef(attrs[key])) {
      if (isXlink(key)) {
        elm.removeAttributeNS(xlinkNS, getXlinkProp(key));
      } else if (!isEnumeratedAttr(key)) {
        elm.removeAttribute(key);
      }
    }
  }
}

function setAttr (el, key, value) {
  if (el.tagName.indexOf('-') > -1) {
    baseSetAttr(el, key, value);
  } else if (isBooleanAttr(key)) {
    // set attribute for blank value
    // e.g. <option disabled>Select one</option>
    if (isFalsyAttrValue(value)) {
      el.removeAttribute(key);
    } else {
      // technically allowfullscreen is a boolean attribute for <iframe>,
      // but Flash expects a value of "true" when used on <embed> tag
      value = key === 'allowfullscreen' && el.tagName === 'EMBED'
        ? 'true'
        : key;
      el.setAttribute(key, value);
    }
  } else if (isEnumeratedAttr(key)) {
    el.setAttribute(key, convertEnumeratedValue(key, value));
  } else if (isXlink(key)) {
    if (isFalsyAttrValue(value)) {
      el.removeAttributeNS(xlinkNS, getXlinkProp(key));
    } else {
      el.setAttributeNS(xlinkNS, key, value);
    }
  } else {
    baseSetAttr(el, key, value);
  }
}

function baseSetAttr (el, key, value) {
  if (isFalsyAttrValue(value)) {
    el.removeAttribute(key);
  } else {
    // #7138: IE10 & 11 fires input event when setting placeholder on
    // <textarea>... block the first input event and remove the blocker
    // immediately.
    /* istanbul ignore if */
    if (
      isIE && !isIE9 &&
      el.tagName === 'TEXTAREA' &&
      key === 'placeholder' && value !== '' && !el.__ieph
    ) {
      var blocker = function (e) {
        e.stopImmediatePropagation();
        el.removeEventListener('input', blocker);
      };
      el.addEventListener('input', blocker);
      // $flow-disable-line
      el.__ieph = true; /* IE placeholder patched */
    }
    el.setAttribute(key, value);
  }
}

var attrs = {
  create: updateAttrs,
  update: updateAttrs
};

/*  */

function updateClass (oldVnode, vnode) {
  var el = vnode.elm;
  var data = vnode.data;
  var oldData = oldVnode.data;
  if (
    isUndef(data.staticClass) &&
    isUndef(data.class) && (
      isUndef(oldData) || (
        isUndef(oldData.staticClass) &&
        isUndef(oldData.class)
      )
    )
  ) {
    return
  }

  var cls = genClassForVnode(vnode);

  // handle transition classes
  var transitionClass = el._transitionClasses;
  if (isDef(transitionClass)) {
    cls = concat(cls, stringifyClass(transitionClass));
  }

  // set the class
  if (cls !== el._prevClass) {
    el.setAttribute('class', cls);
    el._prevClass = cls;
  }
}

var klass = {
  create: updateClass,
  update: updateClass
};

/*  */

var validDivisionCharRE = /[\w).+\-_$\]]/;

function parseFilters (exp) {
  var inSingle = false;
  var inDouble = false;
  var inTemplateString = false;
  var inRegex = false;
  var curly = 0;
  var square = 0;
  var paren = 0;
  var lastFilterIndex = 0;
  var c, prev, i, expression, filters;

  for (i = 0; i < exp.length; i++) {
    prev = c;
    c = exp.charCodeAt(i);
    if (inSingle) {
      if (c === 0x27 && prev !== 0x5C) { inSingle = false; }
    } else if (inDouble) {
      if (c === 0x22 && prev !== 0x5C) { inDouble = false; }
    } else if (inTemplateString) {
      if (c === 0x60 && prev !== 0x5C) { inTemplateString = false; }
    } else if (inRegex) {
      if (c === 0x2f && prev !== 0x5C) { inRegex = false; }
    } else if (
      c === 0x7C && // pipe
      exp.charCodeAt(i + 1) !== 0x7C &&
      exp.charCodeAt(i - 1) !== 0x7C &&
      !curly && !square && !paren
    ) {
      if (expression === undefined) {
        // first filter, end of expression
        lastFilterIndex = i + 1;
        expression = exp.slice(0, i).trim();
      } else {
        pushFilter();
      }
    } else {
      switch (c) {
        case 0x22: inDouble = true; break         // "
        case 0x27: inSingle = true; break         // '
        case 0x60: inTemplateString = true; break // `
        case 0x28: paren++; break                 // (
        case 0x29: paren--; break                 // )
        case 0x5B: square++; break                // [
        case 0x5D: square--; break                // ]
        case 0x7B: curly++; break                 // {
        case 0x7D: curly--; break                 // }
      }
      if (c === 0x2f) { // /
        var j = i - 1;
        var p = (void 0);
        // find first non-whitespace prev char
        for (; j >= 0; j--) {
          p = exp.charAt(j);
          if (p !== ' ') { break }
        }
        if (!p || !validDivisionCharRE.test(p)) {
          inRegex = true;
        }
      }
    }
  }

  if (expression === undefined) {
    expression = exp.slice(0, i).trim();
  } else if (lastFilterIndex !== 0) {
    pushFilter();
  }

  function pushFilter () {
    (filters || (filters = [])).push(exp.slice(lastFilterIndex, i).trim());
    lastFilterIndex = i + 1;
  }

  if (filters) {
    for (i = 0; i < filters.length; i++) {
      expression = wrapFilter(expression, filters[i]);
    }
  }

  return expression
}

function wrapFilter (exp, filter) {
  var i = filter.indexOf('(');
  if (i < 0) {
    // _f: resolveFilter
    return ("_f(\"" + filter + "\")(" + exp + ")")
  } else {
    var name = filter.slice(0, i);
    var args = filter.slice(i + 1);
    return ("_f(\"" + name + "\")(" + exp + (args !== ')' ? ',' + args : args))
  }
}

/*  */



/* eslint-disable no-unused-vars */
function baseWarn (msg, range) {
  console.error(("[Vue compiler]: " + msg));
}
/* eslint-enable no-unused-vars */

function pluckModuleFunction (
  modules,
  key
) {
  return modules
    ? modules.map(function (m) { return m[key]; }).filter(function (_) { return _; })
    : []
}

function addProp (el, name, value, range, dynamic) {
  (el.props || (el.props = [])).push(rangeSetItem({ name: name, value: value, dynamic: dynamic }, range));
  el.plain = false;
}

function addAttr (el, name, value, range, dynamic) {
  var attrs = dynamic
    ? (el.dynamicAttrs || (el.dynamicAttrs = []))
    : (el.attrs || (el.attrs = []));
  attrs.push(rangeSetItem({ name: name, value: value, dynamic: dynamic }, range));
  el.plain = false;
}

// add a raw attr (use this in preTransforms)
function addRawAttr (el, name, value, range) {
  el.attrsMap[name] = value;
  el.attrsList.push(rangeSetItem({ name: name, value: value }, range));
}

function addDirective (
  el,
  name,
  rawName,
  value,
  arg,
  isDynamicArg,
  modifiers,
  range
) {
  (el.directives || (el.directives = [])).push(rangeSetItem({
    name: name,
    rawName: rawName,
    value: value,
    arg: arg,
    isDynamicArg: isDynamicArg,
    modifiers: modifiers
  }, range));
  el.plain = false;
}

function prependModifierMarker (symbol, name, dynamic) {
  return dynamic
    ? ("_p(" + name + ",\"" + symbol + "\")")
    : symbol + name // mark the event as captured
}

function addHandler (
  el,
  name,
  value,
  modifiers,
  important,
  warn,
  range,
  dynamic
) {
  modifiers = modifiers || emptyObject;
  // warn prevent and passive modifier
  /* istanbul ignore if */
  if (
    false
  ) {
    warn(
      'passive and prevent can\'t be used together. ' +
      'Passive handler can\'t prevent default event.',
      range
    );
  }

  // normalize click.right and click.middle since they don't actually fire
  // this is technically browser-specific, but at least for now browsers are
  // the only target envs that have right/middle clicks.
  if (modifiers.right) {
    if (dynamic) {
      name = "(" + name + ")==='click'?'contextmenu':(" + name + ")";
    } else if (name === 'click') {
      name = 'contextmenu';
      delete modifiers.right;
    }
  } else if (modifiers.middle) {
    if (dynamic) {
      name = "(" + name + ")==='click'?'mouseup':(" + name + ")";
    } else if (name === 'click') {
      name = 'mouseup';
    }
  }

  // check capture modifier
  if (modifiers.capture) {
    delete modifiers.capture;
    name = prependModifierMarker('!', name, dynamic);
  }
  if (modifiers.once) {
    delete modifiers.once;
    name = prependModifierMarker('~', name, dynamic);
  }
  /* istanbul ignore if */
  if (modifiers.passive) {
    delete modifiers.passive;
    name = prependModifierMarker('&', name, dynamic);
  }

  var events;
  if (modifiers.native) {
    delete modifiers.native;
    events = el.nativeEvents || (el.nativeEvents = {});
  } else {
    events = el.events || (el.events = {});
  }

  var newHandler = rangeSetItem({ value: value.trim(), dynamic: dynamic }, range);
  if (modifiers !== emptyObject) {
    newHandler.modifiers = modifiers;
  }

  var handlers = events[name];
  /* istanbul ignore if */
  if (Array.isArray(handlers)) {
    important ? handlers.unshift(newHandler) : handlers.push(newHandler);
  } else if (handlers) {
    events[name] = important ? [newHandler, handlers] : [handlers, newHandler];
  } else {
    events[name] = newHandler;
  }

  el.plain = false;
}

function getRawBindingAttr (
  el,
  name
) {
  return el.rawAttrsMap[':' + name] ||
    el.rawAttrsMap['v-bind:' + name] ||
    el.rawAttrsMap[name]
}

function getBindingAttr (
  el,
  name,
  getStatic
) {
  var dynamicValue =
    getAndRemoveAttr(el, ':' + name) ||
    getAndRemoveAttr(el, 'v-bind:' + name);
  if (dynamicValue != null) {
    return parseFilters(dynamicValue)
  } else if (getStatic !== false) {
    var staticValue = getAndRemoveAttr(el, name);
    if (staticValue != null) {
      return JSON.stringify(staticValue)
    }
  }
}

// note: this only removes the attr from the Array (attrsList) so that it
// doesn't get processed by processAttrs.
// By default it does NOT remove it from the map (attrsMap) because the map is
// needed during codegen.
function getAndRemoveAttr (
  el,
  name,
  removeFromMap
) {
  var val;
  if ((val = el.attrsMap[name]) != null) {
    var list = el.attrsList;
    for (var i = 0, l = list.length; i < l; i++) {
      if (list[i].name === name) {
        list.splice(i, 1);
        break
      }
    }
  }
  if (removeFromMap) {
    delete el.attrsMap[name];
  }
  return val
}

function getAndRemoveAttrByRegex (
  el,
  name
) {
  var list = el.attrsList;
  for (var i = 0, l = list.length; i < l; i++) {
    var attr = list[i];
    if (name.test(attr.name)) {
      list.splice(i, 1);
      return attr
    }
  }
}

function rangeSetItem (
  item,
  range
) {
  if (range) {
    if (range.start != null) {
      item.start = range.start;
    }
    if (range.end != null) {
      item.end = range.end;
    }
  }
  return item
}

/*  */

/**
 * Cross-platform code generation for component v-model
 */
function genComponentModel (
  el,
  value,
  modifiers
) {
  var ref = modifiers || {};
  var number = ref.number;
  var trim = ref.trim;

  var baseValueExpression = '$$v';
  var valueExpression = baseValueExpression;
  if (trim) {
    valueExpression =
      "(typeof " + baseValueExpression + " === 'string'" +
      "? " + baseValueExpression + ".trim()" +
      ": " + baseValueExpression + ")";
  }
  if (number) {
    valueExpression = "_n(" + valueExpression + ")";
  }
  var assignment = genAssignmentCode(value, valueExpression);

  el.model = {
    value: ("(" + value + ")"),
    expression: JSON.stringify(value),
    callback: ("function (" + baseValueExpression + ") {" + assignment + "}")
  };
}

/**
 * Cross-platform codegen helper for generating v-model value assignment code.
 */
function genAssignmentCode (
  value,
  assignment
) {
  var res = parseModel(value);
  if (res.key === null) {
    return (value + "=" + assignment)
  } else {
    return ("$set(" + (res.exp) + ", " + (res.key) + ", " + assignment + ")")
  }
}

/**
 * Parse a v-model expression into a base path and a final key segment.
 * Handles both dot-path and possible square brackets.
 *
 * Possible cases:
 *
 * - test
 * - test[key]
 * - test[test1[key]]
 * - test["a"][key]
 * - xxx.test[a[a].test1[key]]
 * - test.xxx.a["asa"][test1[key]]
 *
 */

var len, str, chr, index$1, expressionPos, expressionEndPos;



function parseModel (val) {
  // Fix https://github.com/vuejs/vue/pull/7730
  // allow v-model="obj.val " (trailing whitespace)
  val = val.trim();
  len = val.length;

  if (val.indexOf('[') < 0 || val.lastIndexOf(']') < len - 1) {
    index$1 = val.lastIndexOf('.');
    if (index$1 > -1) {
      return {
        exp: val.slice(0, index$1),
        key: '"' + val.slice(index$1 + 1) + '"'
      }
    } else {
      return {
        exp: val,
        key: null
      }
    }
  }

  str = val;
  index$1 = expressionPos = expressionEndPos = 0;

  while (!eof()) {
    chr = next();
    /* istanbul ignore if */
    if (isStringStart(chr)) {
      parseString(chr);
    } else if (chr === 0x5B) {
      parseBracket(chr);
    }
  }

  return {
    exp: val.slice(0, expressionPos),
    key: val.slice(expressionPos + 1, expressionEndPos)
  }
}

function next () {
  return str.charCodeAt(++index$1)
}

function eof () {
  return index$1 >= len
}

function isStringStart (chr) {
  return chr === 0x22 || chr === 0x27
}

function parseBracket (chr) {
  var inBracket = 1;
  expressionPos = index$1;
  while (!eof()) {
    chr = next();
    if (isStringStart(chr)) {
      parseString(chr);
      continue
    }
    if (chr === 0x5B) { inBracket++; }
    if (chr === 0x5D) { inBracket--; }
    if (inBracket === 0) {
      expressionEndPos = index$1;
      break
    }
  }
}

function parseString (chr) {
  var stringQuote = chr;
  while (!eof()) {
    chr = next();
    if (chr === stringQuote) {
      break
    }
  }
}

/*  */

var warn$1;

// in some cases, the event used has to be determined at runtime
// so we used some reserved tokens during compile.
var RANGE_TOKEN = '__r';
var CHECKBOX_RADIO_TOKEN = '__c';

function model (
  el,
  dir,
  _warn
) {
  warn$1 = _warn;
  var value = dir.value;
  var modifiers = dir.modifiers;
  var tag = el.tag;
  var type = el.attrsMap.type;

  if (false) {
    // inputs with type="file" are read only and setting the input's
    // value will throw an error.
    if (tag === 'input' && type === 'file') {
      warn$1(
        "<" + (el.tag) + " v-model=\"" + value + "\" type=\"file\">:\n" +
        "File inputs are read only. Use a v-on:change listener instead.",
        el.rawAttrsMap['v-model']
      );
    }
  }

  if (el.component) {
    genComponentModel(el, value, modifiers);
    // component v-model doesn't need extra runtime
    return false
  } else if (tag === 'select') {
    genSelect(el, value, modifiers);
  } else if (tag === 'input' && type === 'checkbox') {
    genCheckboxModel(el, value, modifiers);
  } else if (tag === 'input' && type === 'radio') {
    genRadioModel(el, value, modifiers);
  } else if (tag === 'input' || tag === 'textarea') {
    genDefaultModel(el, value, modifiers);
  } else if (!config.isReservedTag(tag)) {
    genComponentModel(el, value, modifiers);
    // component v-model doesn't need extra runtime
    return false
  } else if (false) {
    warn$1(
      "<" + (el.tag) + " v-model=\"" + value + "\">: " +
      "v-model is not supported on this element type. " +
      'If you are working with contenteditable, it\'s recommended to ' +
      'wrap a library dedicated for that purpose inside a custom component.',
      el.rawAttrsMap['v-model']
    );
  }

  // ensure runtime directive metadata
  return true
}

function genCheckboxModel (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var valueBinding = getBindingAttr(el, 'value') || 'null';
  var trueValueBinding = getBindingAttr(el, 'true-value') || 'true';
  var falseValueBinding = getBindingAttr(el, 'false-value') || 'false';
  addProp(el, 'checked',
    "Array.isArray(" + value + ")" +
    "?_i(" + value + "," + valueBinding + ")>-1" + (
      trueValueBinding === 'true'
        ? (":(" + value + ")")
        : (":_q(" + value + "," + trueValueBinding + ")")
    )
  );
  addHandler(el, 'change',
    "var $$a=" + value + "," +
        '$$el=$event.target,' +
        "$$c=$$el.checked?(" + trueValueBinding + "):(" + falseValueBinding + ");" +
    'if(Array.isArray($$a)){' +
      "var $$v=" + (number ? '_n(' + valueBinding + ')' : valueBinding) + "," +
          '$$i=_i($$a,$$v);' +
      "if($$el.checked){$$i<0&&(" + (genAssignmentCode(value, '$$a.concat([$$v])')) + ")}" +
      "else{$$i>-1&&(" + (genAssignmentCode(value, '$$a.slice(0,$$i).concat($$a.slice($$i+1))')) + ")}" +
    "}else{" + (genAssignmentCode(value, '$$c')) + "}",
    null, true
  );
}

function genRadioModel (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var valueBinding = getBindingAttr(el, 'value') || 'null';
  valueBinding = number ? ("_n(" + valueBinding + ")") : valueBinding;
  addProp(el, 'checked', ("_q(" + value + "," + valueBinding + ")"));
  addHandler(el, 'change', genAssignmentCode(value, valueBinding), null, true);
}

function genSelect (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var selectedVal = "Array.prototype.filter" +
    ".call($event.target.options,function(o){return o.selected})" +
    ".map(function(o){var val = \"_value\" in o ? o._value : o.value;" +
    "return " + (number ? '_n(val)' : 'val') + "})";

  var assignment = '$event.target.multiple ? $$selectedVal : $$selectedVal[0]';
  var code = "var $$selectedVal = " + selectedVal + ";";
  code = code + " " + (genAssignmentCode(value, assignment));
  addHandler(el, 'change', code, null, true);
}

function genDefaultModel (
  el,
  value,
  modifiers
) {
  var type = el.attrsMap.type;

  // warn if v-bind:value conflicts with v-model
  // except for inputs with v-bind:type
  if (false) {
    var value$1 = el.attrsMap['v-bind:value'] || el.attrsMap[':value'];
    var typeBinding = el.attrsMap['v-bind:type'] || el.attrsMap[':type'];
    if (value$1 && !typeBinding) {
      var binding = el.attrsMap['v-bind:value'] ? 'v-bind:value' : ':value';
      warn$1(
        binding + "=\"" + value$1 + "\" conflicts with v-model on the same element " +
        'because the latter already expands to a value binding internally',
        el.rawAttrsMap[binding]
      );
    }
  }

  var ref = modifiers || {};
  var lazy = ref.lazy;
  var number = ref.number;
  var trim = ref.trim;
  var needCompositionGuard = !lazy && type !== 'range';
  var event = lazy
    ? 'change'
    : type === 'range'
      ? RANGE_TOKEN
      : 'input';

  var valueExpression = '$event.target.value';
  if (trim) {
    valueExpression = "$event.target.value.trim()";
  }
  if (number) {
    valueExpression = "_n(" + valueExpression + ")";
  }

  var code = genAssignmentCode(value, valueExpression);
  if (needCompositionGuard) {
    code = "if($event.target.composing)return;" + code;
  }

  addProp(el, 'value', ("(" + value + ")"));
  addHandler(el, event, code, null, true);
  if (trim || number) {
    addHandler(el, 'blur', '$forceUpdate()');
  }
}

/*  */

// normalize v-model event tokens that can only be determined at runtime.
// it's important to place the event as the first in the array because
// the whole point is ensuring the v-model callback gets called before
// user-attached handlers.
function normalizeEvents (on) {
  /* istanbul ignore if */
  if (isDef(on[RANGE_TOKEN])) {
    // IE input[type=range] only supports `change` event
    var event = isIE ? 'change' : 'input';
    on[event] = [].concat(on[RANGE_TOKEN], on[event] || []);
    delete on[RANGE_TOKEN];
  }
  // This was originally intended to fix #4521 but no longer necessary
  // after 2.5. Keeping it for backwards compat with generated code from < 2.4
  /* istanbul ignore if */
  if (isDef(on[CHECKBOX_RADIO_TOKEN])) {
    on.change = [].concat(on[CHECKBOX_RADIO_TOKEN], on.change || []);
    delete on[CHECKBOX_RADIO_TOKEN];
  }
}

var target$1;

function createOnceHandler$1 (event, handler, capture) {
  var _target = target$1; // save current target element in closure
  return function onceHandler () {
    var res = handler.apply(null, arguments);
    if (res !== null) {
      remove$2(event, onceHandler, capture, _target);
    }
  }
}

// #9446: Firefox <= 53 (in particular, ESR 52) has incorrect Event.timeStamp
// implementation and does not fire microtasks in between event propagation, so
// safe to exclude.
var useMicrotaskFix = isUsingMicroTask && !(isFF && Number(isFF[1]) <= 53);

function add$1 (
  name,
  handler,
  capture,
  passive
) {
  // async edge case #6566: inner click event triggers patch, event handler
  // attached to outer element during patch, and triggered again. This
  // happens because browsers fire microtask ticks between event propagation.
  // the solution is simple: we save the timestamp when a handler is attached,
  // and the handler would only fire if the event passed to it was fired
  // AFTER it was attached.
  if (useMicrotaskFix) {
    var attachedTimestamp = currentFlushTimestamp;
    var original = handler;
    handler = original._wrapper = function (e) {
      if (
        // no bubbling, should always fire.
        // this is just a safety net in case event.timeStamp is unreliable in
        // certain weird environments...
        e.target === e.currentTarget ||
        // event is fired after handler attachment
        e.timeStamp >= attachedTimestamp ||
        // bail for environments that have buggy event.timeStamp implementations
        // #9462 iOS 9 bug: event.timeStamp is 0 after history.pushState
        // #9681 QtWebEngine event.timeStamp is negative value
        e.timeStamp <= 0 ||
        // #9448 bail if event is fired in another document in a multi-page
        // electron/nw.js app, since event.timeStamp will be using a different
        // starting reference
        e.target.ownerDocument !== document
      ) {
        return original.apply(this, arguments)
      }
    };
  }
  target$1.addEventListener(
    name,
    handler,
    supportsPassive
      ? { capture: capture, passive: passive }
      : capture
  );
}

function remove$2 (
  name,
  handler,
  capture,
  _target
) {
  (_target || target$1).removeEventListener(
    name,
    handler._wrapper || handler,
    capture
  );
}

function updateDOMListeners (oldVnode, vnode) {
  if (isUndef(oldVnode.data.on) && isUndef(vnode.data.on)) {
    return
  }
  var on = vnode.data.on || {};
  var oldOn = oldVnode.data.on || {};
  target$1 = vnode.elm;
  normalizeEvents(on);
  updateListeners(on, oldOn, add$1, remove$2, createOnceHandler$1, vnode.context);
  target$1 = undefined;
}

var events = {
  create: updateDOMListeners,
  update: updateDOMListeners
};

/*  */

var svgContainer;

function updateDOMProps (oldVnode, vnode) {
  if (isUndef(oldVnode.data.domProps) && isUndef(vnode.data.domProps)) {
    return
  }
  var key, cur;
  var elm = vnode.elm;
  var oldProps = oldVnode.data.domProps || {};
  var props = vnode.data.domProps || {};
  // clone observed objects, as the user probably wants to mutate it
  if (isDef(props.__ob__)) {
    props = vnode.data.domProps = extend({}, props);
  }

  for (key in oldProps) {
    if (!(key in props)) {
      elm[key] = '';
    }
  }

  for (key in props) {
    cur = props[key];
    // ignore children if the node has textContent or innerHTML,
    // as these will throw away existing DOM nodes and cause removal errors
    // on subsequent patches (#3360)
    if (key === 'textContent' || key === 'innerHTML') {
      if (vnode.children) { vnode.children.length = 0; }
      if (cur === oldProps[key]) { continue }
      // #6601 work around Chrome version <= 55 bug where single textNode
      // replaced by innerHTML/textContent retains its parentNode property
      if (elm.childNodes.length === 1) {
        elm.removeChild(elm.childNodes[0]);
      }
    }

    if (key === 'value' && elm.tagName !== 'PROGRESS') {
      // store value as _value as well since
      // non-string values will be stringified
      elm._value = cur;
      // avoid resetting cursor position when value is the same
      var strCur = isUndef(cur) ? '' : String(cur);
      if (shouldUpdateValue(elm, strCur)) {
        elm.value = strCur;
      }
    } else if (key === 'innerHTML' && isSVG(elm.tagName) && isUndef(elm.innerHTML)) {
      // IE doesn't support innerHTML for SVG elements
      svgContainer = svgContainer || document.createElement('div');
      svgContainer.innerHTML = "<svg>" + cur + "</svg>";
      var svg = svgContainer.firstChild;
      while (elm.firstChild) {
        elm.removeChild(elm.firstChild);
      }
      while (svg.firstChild) {
        elm.appendChild(svg.firstChild);
      }
    } else if (
      // skip the update if old and new VDOM state is the same.
      // `value` is handled separately because the DOM value may be temporarily
      // out of sync with VDOM state due to focus, composition and modifiers.
      // This  #4521 by skipping the unnecessary `checked` update.
      cur !== oldProps[key]
    ) {
      // some property updates can throw
      // e.g. `value` on <progress> w/ non-finite value
      try {
        elm[key] = cur;
      } catch (e) {}
    }
  }
}

// check platforms/web/util/attrs.js acceptValue


function shouldUpdateValue (elm, checkVal) {
  return (!elm.composing && (
    elm.tagName === 'OPTION' ||
    isNotInFocusAndDirty(elm, checkVal) ||
    isDirtyWithModifiers(elm, checkVal)
  ))
}

function isNotInFocusAndDirty (elm, checkVal) {
  // return true when textbox (.number and .trim) loses focus and its value is
  // not equal to the updated value
  var notInFocus = true;
  // #6157
  // work around IE bug when accessing document.activeElement in an iframe
  try { notInFocus = document.activeElement !== elm; } catch (e) {}
  return notInFocus && elm.value !== checkVal
}

function isDirtyWithModifiers (elm, newVal) {
  var value = elm.value;
  var modifiers = elm._vModifiers; // injected by v-model runtime
  if (isDef(modifiers)) {
    if (modifiers.number) {
      return toNumber(value) !== toNumber(newVal)
    }
    if (modifiers.trim) {
      return value.trim() !== newVal.trim()
    }
  }
  return value !== newVal
}

var domProps = {
  create: updateDOMProps,
  update: updateDOMProps
};

/*  */

var parseStyleText = cached(function (cssText) {
  var res = {};
  var listDelimiter = /;(?![^(]*\))/g;
  var propertyDelimiter = /:(.+)/;
  cssText.split(listDelimiter).forEach(function (item) {
    if (item) {
      var tmp = item.split(propertyDelimiter);
      tmp.length > 1 && (res[tmp[0].trim()] = tmp[1].trim());
    }
  });
  return res
});

// merge static and dynamic style data on the same vnode
function normalizeStyleData (data) {
  var style = normalizeStyleBinding(data.style);
  // static style is pre-processed into an object during compilation
  // and is always a fresh object, so it's safe to merge into it
  return data.staticStyle
    ? extend(data.staticStyle, style)
    : style
}

// normalize possible array / string values into Object
function normalizeStyleBinding (bindingStyle) {
  if (Array.isArray(bindingStyle)) {
    return toObject(bindingStyle)
  }
  if (typeof bindingStyle === 'string') {
    return parseStyleText(bindingStyle)
  }
  return bindingStyle
}

/**
 * parent component style should be after child's
 * so that parent component's style could override it
 */
function getStyle (vnode, checkChild) {
  var res = {};
  var styleData;

  if (checkChild) {
    var childNode = vnode;
    while (childNode.componentInstance) {
      childNode = childNode.componentInstance._vnode;
      if (
        childNode && childNode.data &&
        (styleData = normalizeStyleData(childNode.data))
      ) {
        extend(res, styleData);
      }
    }
  }

  if ((styleData = normalizeStyleData(vnode.data))) {
    extend(res, styleData);
  }

  var parentNode = vnode;
  while ((parentNode = parentNode.parent)) {
    if (parentNode.data && (styleData = normalizeStyleData(parentNode.data))) {
      extend(res, styleData);
    }
  }
  return res
}

/*  */

var cssVarRE = /^--/;
var importantRE = /\s*!important$/;
var setProp = function (el, name, val) {
  /* istanbul ignore if */
  if (cssVarRE.test(name)) {
    el.style.setProperty(name, val);
  } else if (importantRE.test(val)) {
    el.style.setProperty(hyphenate(name), val.replace(importantRE, ''), 'important');
  } else {
    var normalizedName = normalize(name);
    if (Array.isArray(val)) {
      // Support values array created by autoprefixer, e.g.
      // {display: ["-webkit-box", "-ms-flexbox", "flex"]}
      // Set them one by one, and the browser will only set those it can recognize
      for (var i = 0, len = val.length; i < len; i++) {
        el.style[normalizedName] = val[i];
      }
    } else {
      el.style[normalizedName] = val;
    }
  }
};

var vendorNames = ['Webkit', 'Moz', 'ms'];

var emptyStyle;
var normalize = cached(function (prop) {
  emptyStyle = emptyStyle || document.createElement('div').style;
  prop = camelize(prop);
  if (prop !== 'filter' && (prop in emptyStyle)) {
    return prop
  }
  var capName = prop.charAt(0).toUpperCase() + prop.slice(1);
  for (var i = 0; i < vendorNames.length; i++) {
    var name = vendorNames[i] + capName;
    if (name in emptyStyle) {
      return name
    }
  }
});

function updateStyle (oldVnode, vnode) {
  var data = vnode.data;
  var oldData = oldVnode.data;

  if (isUndef(data.staticStyle) && isUndef(data.style) &&
    isUndef(oldData.staticStyle) && isUndef(oldData.style)
  ) {
    return
  }

  var cur, name;
  var el = vnode.elm;
  var oldStaticStyle = oldData.staticStyle;
  var oldStyleBinding = oldData.normalizedStyle || oldData.style || {};

  // if static style exists, stylebinding already merged into it when doing normalizeStyleData
  var oldStyle = oldStaticStyle || oldStyleBinding;

  var style = normalizeStyleBinding(vnode.data.style) || {};

  // store normalized style under a different key for next diff
  // make sure to clone it if it's reactive, since the user likely wants
  // to mutate it.
  vnode.data.normalizedStyle = isDef(style.__ob__)
    ? extend({}, style)
    : style;

  var newStyle = getStyle(vnode, true);

  for (name in oldStyle) {
    if (isUndef(newStyle[name])) {
      setProp(el, name, '');
    }
  }
  for (name in newStyle) {
    cur = newStyle[name];
    if (cur !== oldStyle[name]) {
      // ie9 setting to null has no effect, must use empty string
      setProp(el, name, cur == null ? '' : cur);
    }
  }
}

var style = {
  create: updateStyle,
  update: updateStyle
};

/*  */

var whitespaceRE = /\s+/;

/**
 * Add class with compatibility for SVG since classList is not supported on
 * SVG elements in IE
 */
function addClass (el, cls) {
  /* istanbul ignore if */
  if (!cls || !(cls = cls.trim())) {
    return
  }

  /* istanbul ignore else */
  if (el.classList) {
    if (cls.indexOf(' ') > -1) {
      cls.split(whitespaceRE).forEach(function (c) { return el.classList.add(c); });
    } else {
      el.classList.add(cls);
    }
  } else {
    var cur = " " + (el.getAttribute('class') || '') + " ";
    if (cur.indexOf(' ' + cls + ' ') < 0) {
      el.setAttribute('class', (cur + cls).trim());
    }
  }
}

/**
 * Remove class with compatibility for SVG since classList is not supported on
 * SVG elements in IE
 */
function removeClass (el, cls) {
  /* istanbul ignore if */
  if (!cls || !(cls = cls.trim())) {
    return
  }

  /* istanbul ignore else */
  if (el.classList) {
    if (cls.indexOf(' ') > -1) {
      cls.split(whitespaceRE).forEach(function (c) { return el.classList.remove(c); });
    } else {
      el.classList.remove(cls);
    }
    if (!el.classList.length) {
      el.removeAttribute('class');
    }
  } else {
    var cur = " " + (el.getAttribute('class') || '') + " ";
    var tar = ' ' + cls + ' ';
    while (cur.indexOf(tar) >= 0) {
      cur = cur.replace(tar, ' ');
    }
    cur = cur.trim();
    if (cur) {
      el.setAttribute('class', cur);
    } else {
      el.removeAttribute('class');
    }
  }
}

/*  */

function resolveTransition (def$$1) {
  if (!def$$1) {
    return
  }
  /* istanbul ignore else */
  if (typeof def$$1 === 'object') {
    var res = {};
    if (def$$1.css !== false) {
      extend(res, autoCssTransition(def$$1.name || 'v'));
    }
    extend(res, def$$1);
    return res
  } else if (typeof def$$1 === 'string') {
    return autoCssTransition(def$$1)
  }
}

var autoCssTransition = cached(function (name) {
  return {
    enterClass: (name + "-enter"),
    enterToClass: (name + "-enter-to"),
    enterActiveClass: (name + "-enter-active"),
    leaveClass: (name + "-leave"),
    leaveToClass: (name + "-leave-to"),
    leaveActiveClass: (name + "-leave-active")
  }
});

var hasTransition = inBrowser && !isIE9;
var TRANSITION = 'transition';
var ANIMATION = 'animation';

// Transition property/event sniffing
var transitionProp = 'transition';
var transitionEndEvent = 'transitionend';
var animationProp = 'animation';
var animationEndEvent = 'animationend';
if (hasTransition) {
  /* istanbul ignore if */
  if (window.ontransitionend === undefined &&
    window.onwebkittransitionend !== undefined
  ) {
    transitionProp = 'WebkitTransition';
    transitionEndEvent = 'webkitTransitionEnd';
  }
  if (window.onanimationend === undefined &&
    window.onwebkitanimationend !== undefined
  ) {
    animationProp = 'WebkitAnimation';
    animationEndEvent = 'webkitAnimationEnd';
  }
}

// binding to window is necessary to make hot reload work in IE in strict mode
var raf = inBrowser
  ? window.requestAnimationFrame
    ? window.requestAnimationFrame.bind(window)
    : setTimeout
  : /* istanbul ignore next */ function (fn) { return fn(); };

function nextFrame (fn) {
  raf(function () {
    raf(fn);
  });
}

function addTransitionClass (el, cls) {
  var transitionClasses = el._transitionClasses || (el._transitionClasses = []);
  if (transitionClasses.indexOf(cls) < 0) {
    transitionClasses.push(cls);
    addClass(el, cls);
  }
}

function removeTransitionClass (el, cls) {
  if (el._transitionClasses) {
    remove(el._transitionClasses, cls);
  }
  removeClass(el, cls);
}

function whenTransitionEnds (
  el,
  expectedType,
  cb
) {
  var ref = getTransitionInfo(el, expectedType);
  var type = ref.type;
  var timeout = ref.timeout;
  var propCount = ref.propCount;
  if (!type) { return cb() }
  var event = type === TRANSITION ? transitionEndEvent : animationEndEvent;
  var ended = 0;
  var end = function () {
    el.removeEventListener(event, onEnd);
    cb();
  };
  var onEnd = function (e) {
    if (e.target === el) {
      if (++ended >= propCount) {
        end();
      }
    }
  };
  setTimeout(function () {
    if (ended < propCount) {
      end();
    }
  }, timeout + 1);
  el.addEventListener(event, onEnd);
}

var transformRE = /\b(transform|all)(,|$)/;

function getTransitionInfo (el, expectedType) {
  var styles = window.getComputedStyle(el);
  // JSDOM may return undefined for transition properties
  var transitionDelays = (styles[transitionProp + 'Delay'] || '').split(', ');
  var transitionDurations = (styles[transitionProp + 'Duration'] || '').split(', ');
  var transitionTimeout = getTimeout(transitionDelays, transitionDurations);
  var animationDelays = (styles[animationProp + 'Delay'] || '').split(', ');
  var animationDurations = (styles[animationProp + 'Duration'] || '').split(', ');
  var animationTimeout = getTimeout(animationDelays, animationDurations);

  var type;
  var timeout = 0;
  var propCount = 0;
  /* istanbul ignore if */
  if (expectedType === TRANSITION) {
    if (transitionTimeout > 0) {
      type = TRANSITION;
      timeout = transitionTimeout;
      propCount = transitionDurations.length;
    }
  } else if (expectedType === ANIMATION) {
    if (animationTimeout > 0) {
      type = ANIMATION;
      timeout = animationTimeout;
      propCount = animationDurations.length;
    }
  } else {
    timeout = Math.max(transitionTimeout, animationTimeout);
    type = timeout > 0
      ? transitionTimeout > animationTimeout
        ? TRANSITION
        : ANIMATION
      : null;
    propCount = type
      ? type === TRANSITION
        ? transitionDurations.length
        : animationDurations.length
      : 0;
  }
  var hasTransform =
    type === TRANSITION &&
    transformRE.test(styles[transitionProp + 'Property']);
  return {
    type: type,
    timeout: timeout,
    propCount: propCount,
    hasTransform: hasTransform
  }
}

function getTimeout (delays, durations) {
  /* istanbul ignore next */
  while (delays.length < durations.length) {
    delays = delays.concat(delays);
  }

  return Math.max.apply(null, durations.map(function (d, i) {
    return toMs(d) + toMs(delays[i])
  }))
}

// Old versions of Chromium (below 61.0.3163.100) formats floating pointer numbers
// in a locale-dependent way, using a comma instead of a dot.
// If comma is not replaced with a dot, the input will be rounded down (i.e. acting
// as a floor function) causing unexpected behaviors
function toMs (s) {
  return Number(s.slice(0, -1).replace(',', '.')) * 1000
}

/*  */

function enter (vnode, toggleDisplay) {
  var el = vnode.elm;

  // call leave callback now
  if (isDef(el._leaveCb)) {
    el._leaveCb.cancelled = true;
    el._leaveCb();
  }

  var data = resolveTransition(vnode.data.transition);
  if (isUndef(data)) {
    return
  }

  /* istanbul ignore if */
  if (isDef(el._enterCb) || el.nodeType !== 1) {
    return
  }

  var css = data.css;
  var type = data.type;
  var enterClass = data.enterClass;
  var enterToClass = data.enterToClass;
  var enterActiveClass = data.enterActiveClass;
  var appearClass = data.appearClass;
  var appearToClass = data.appearToClass;
  var appearActiveClass = data.appearActiveClass;
  var beforeEnter = data.beforeEnter;
  var enter = data.enter;
  var afterEnter = data.afterEnter;
  var enterCancelled = data.enterCancelled;
  var beforeAppear = data.beforeAppear;
  var appear = data.appear;
  var afterAppear = data.afterAppear;
  var appearCancelled = data.appearCancelled;
  var duration = data.duration;

  // activeInstance will always be the <transition> component managing this
  // transition. One edge case to check is when the <transition> is placed
  // as the root node of a child component. In that case we need to check
  // <transition>'s parent for appear check.
  var context = activeInstance;
  var transitionNode = activeInstance.$vnode;
  while (transitionNode && transitionNode.parent) {
    context = transitionNode.context;
    transitionNode = transitionNode.parent;
  }

  var isAppear = !context._isMounted || !vnode.isRootInsert;

  if (isAppear && !appear && appear !== '') {
    return
  }

  var startClass = isAppear && appearClass
    ? appearClass
    : enterClass;
  var activeClass = isAppear && appearActiveClass
    ? appearActiveClass
    : enterActiveClass;
  var toClass = isAppear && appearToClass
    ? appearToClass
    : enterToClass;

  var beforeEnterHook = isAppear
    ? (beforeAppear || beforeEnter)
    : beforeEnter;
  var enterHook = isAppear
    ? (typeof appear === 'function' ? appear : enter)
    : enter;
  var afterEnterHook = isAppear
    ? (afterAppear || afterEnter)
    : afterEnter;
  var enterCancelledHook = isAppear
    ? (appearCancelled || enterCancelled)
    : enterCancelled;

  var explicitEnterDuration = toNumber(
    isObject(duration)
      ? duration.enter
      : duration
  );

  if (false) {
    checkDuration(explicitEnterDuration, 'enter', vnode);
  }

  var expectsCSS = css !== false && !isIE9;
  var userWantsControl = getHookArgumentsLength(enterHook);

  var cb = el._enterCb = once(function () {
    if (expectsCSS) {
      removeTransitionClass(el, toClass);
      removeTransitionClass(el, activeClass);
    }
    if (cb.cancelled) {
      if (expectsCSS) {
        removeTransitionClass(el, startClass);
      }
      enterCancelledHook && enterCancelledHook(el);
    } else {
      afterEnterHook && afterEnterHook(el);
    }
    el._enterCb = null;
  });

  if (!vnode.data.show) {
    // remove pending leave element on enter by injecting an insert hook
    mergeVNodeHook(vnode, 'insert', function () {
      var parent = el.parentNode;
      var pendingNode = parent && parent._pending && parent._pending[vnode.key];
      if (pendingNode &&
        pendingNode.tag === vnode.tag &&
        pendingNode.elm._leaveCb
      ) {
        pendingNode.elm._leaveCb();
      }
      enterHook && enterHook(el, cb);
    });
  }

  // start enter transition
  beforeEnterHook && beforeEnterHook(el);
  if (expectsCSS) {
    addTransitionClass(el, startClass);
    addTransitionClass(el, activeClass);
    nextFrame(function () {
      removeTransitionClass(el, startClass);
      if (!cb.cancelled) {
        addTransitionClass(el, toClass);
        if (!userWantsControl) {
          if (isValidDuration(explicitEnterDuration)) {
            setTimeout(cb, explicitEnterDuration);
          } else {
            whenTransitionEnds(el, type, cb);
          }
        }
      }
    });
  }

  if (vnode.data.show) {
    toggleDisplay && toggleDisplay();
    enterHook && enterHook(el, cb);
  }

  if (!expectsCSS && !userWantsControl) {
    cb();
  }
}

function leave (vnode, rm) {
  var el = vnode.elm;

  // call enter callback now
  if (isDef(el._enterCb)) {
    el._enterCb.cancelled = true;
    el._enterCb();
  }

  var data = resolveTransition(vnode.data.transition);
  if (isUndef(data) || el.nodeType !== 1) {
    return rm()
  }

  /* istanbul ignore if */
  if (isDef(el._leaveCb)) {
    return
  }

  var css = data.css;
  var type = data.type;
  var leaveClass = data.leaveClass;
  var leaveToClass = data.leaveToClass;
  var leaveActiveClass = data.leaveActiveClass;
  var beforeLeave = data.beforeLeave;
  var leave = data.leave;
  var afterLeave = data.afterLeave;
  var leaveCancelled = data.leaveCancelled;
  var delayLeave = data.delayLeave;
  var duration = data.duration;

  var expectsCSS = css !== false && !isIE9;
  var userWantsControl = getHookArgumentsLength(leave);

  var explicitLeaveDuration = toNumber(
    isObject(duration)
      ? duration.leave
      : duration
  );

  if (false) {
    checkDuration(explicitLeaveDuration, 'leave', vnode);
  }

  var cb = el._leaveCb = once(function () {
    if (el.parentNode && el.parentNode._pending) {
      el.parentNode._pending[vnode.key] = null;
    }
    if (expectsCSS) {
      removeTransitionClass(el, leaveToClass);
      removeTransitionClass(el, leaveActiveClass);
    }
    if (cb.cancelled) {
      if (expectsCSS) {
        removeTransitionClass(el, leaveClass);
      }
      leaveCancelled && leaveCancelled(el);
    } else {
      rm();
      afterLeave && afterLeave(el);
    }
    el._leaveCb = null;
  });

  if (delayLeave) {
    delayLeave(performLeave);
  } else {
    performLeave();
  }

  function performLeave () {
    // the delayed leave may have already been cancelled
    if (cb.cancelled) {
      return
    }
    // record leaving element
    if (!vnode.data.show && el.parentNode) {
      (el.parentNode._pending || (el.parentNode._pending = {}))[(vnode.key)] = vnode;
    }
    beforeLeave && beforeLeave(el);
    if (expectsCSS) {
      addTransitionClass(el, leaveClass);
      addTransitionClass(el, leaveActiveClass);
      nextFrame(function () {
        removeTransitionClass(el, leaveClass);
        if (!cb.cancelled) {
          addTransitionClass(el, leaveToClass);
          if (!userWantsControl) {
            if (isValidDuration(explicitLeaveDuration)) {
              setTimeout(cb, explicitLeaveDuration);
            } else {
              whenTransitionEnds(el, type, cb);
            }
          }
        }
      });
    }
    leave && leave(el, cb);
    if (!expectsCSS && !userWantsControl) {
      cb();
    }
  }
}

// only used in dev mode
function checkDuration (val, name, vnode) {
  if (typeof val !== 'number') {
    warn(
      "<transition> explicit " + name + " duration is not a valid number - " +
      "got " + (JSON.stringify(val)) + ".",
      vnode.context
    );
  } else if (isNaN(val)) {
    warn(
      "<transition> explicit " + name + " duration is NaN - " +
      'the duration expression might be incorrect.',
      vnode.context
    );
  }
}

function isValidDuration (val) {
  return typeof val === 'number' && !isNaN(val)
}

/**
 * Normalize a transition hook's argument length. The hook may be:
 * - a merged hook (invoker) with the original in .fns
 * - a wrapped component method (check ._length)
 * - a plain function (.length)
 */
function getHookArgumentsLength (fn) {
  if (isUndef(fn)) {
    return false
  }
  var invokerFns = fn.fns;
  if (isDef(invokerFns)) {
    // invoker
    return getHookArgumentsLength(
      Array.isArray(invokerFns)
        ? invokerFns[0]
        : invokerFns
    )
  } else {
    return (fn._length || fn.length) > 1
  }
}

function _enter (_, vnode) {
  if (vnode.data.show !== true) {
    enter(vnode);
  }
}

var transition = inBrowser ? {
  create: _enter,
  activate: _enter,
  remove: function remove$$1 (vnode, rm) {
    /* istanbul ignore else */
    if (vnode.data.show !== true) {
      leave(vnode, rm);
    } else {
      rm();
    }
  }
} : {};

var platformModules = [
  attrs,
  klass,
  events,
  domProps,
  style,
  transition
];

/*  */

// the directive module should be applied last, after all
// built-in modules have been applied.
var modules = platformModules.concat(baseModules);

var patch = createPatchFunction({ nodeOps: nodeOps, modules: modules });

/**
 * Not type checking this file because flow doesn't like attaching
 * properties to Elements.
 */

/* istanbul ignore if */
if (isIE9) {
  // http://www.matts411.com/post/internet-explorer-9-oninput/
  document.addEventListener('selectionchange', function () {
    var el = document.activeElement;
    if (el && el.vmodel) {
      trigger(el, 'input');
    }
  });
}

var directive = {
  inserted: function inserted (el, binding, vnode, oldVnode) {
    if (vnode.tag === 'select') {
      // #6903
      if (oldVnode.elm && !oldVnode.elm._vOptions) {
        mergeVNodeHook(vnode, 'postpatch', function () {
          directive.componentUpdated(el, binding, vnode);
        });
      } else {
        setSelected(el, binding, vnode.context);
      }
      el._vOptions = [].map.call(el.options, getValue);
    } else if (vnode.tag === 'textarea' || isTextInputType(el.type)) {
      el._vModifiers = binding.modifiers;
      if (!binding.modifiers.lazy) {
        el.addEventListener('compositionstart', onCompositionStart);
        el.addEventListener('compositionend', onCompositionEnd);
        // Safari < 10.2 & UIWebView doesn't fire compositionend when
        // switching focus before confirming composition choice
        // this also fixes the issue where some browsers e.g. iOS Chrome
        // fires "change" instead of "input" on autocomplete.
        el.addEventListener('change', onCompositionEnd);
        /* istanbul ignore if */
        if (isIE9) {
          el.vmodel = true;
        }
      }
    }
  },

  componentUpdated: function componentUpdated (el, binding, vnode) {
    if (vnode.tag === 'select') {
      setSelected(el, binding, vnode.context);
      // in case the options rendered by v-for have changed,
      // it's possible that the value is out-of-sync with the rendered options.
      // detect such cases and filter out values that no longer has a matching
      // option in the DOM.
      var prevOptions = el._vOptions;
      var curOptions = el._vOptions = [].map.call(el.options, getValue);
      if (curOptions.some(function (o, i) { return !looseEqual(o, prevOptions[i]); })) {
        // trigger change event if
        // no matching option found for at least one value
        var needReset = el.multiple
          ? binding.value.some(function (v) { return hasNoMatchingOption(v, curOptions); })
          : binding.value !== binding.oldValue && hasNoMatchingOption(binding.value, curOptions);
        if (needReset) {
          trigger(el, 'change');
        }
      }
    }
  }
};

function setSelected (el, binding, vm) {
  actuallySetSelected(el, binding, vm);
  /* istanbul ignore if */
  if (isIE || isEdge) {
    setTimeout(function () {
      actuallySetSelected(el, binding, vm);
    }, 0);
  }
}

function actuallySetSelected (el, binding, vm) {
  var value = binding.value;
  var isMultiple = el.multiple;
  if (isMultiple && !Array.isArray(value)) {
    "production" !== 'production' && warn(
      "<select multiple v-model=\"" + (binding.expression) + "\"> " +
      "expects an Array value for its binding, but got " + (Object.prototype.toString.call(value).slice(8, -1)),
      vm
    );
    return
  }
  var selected, option;
  for (var i = 0, l = el.options.length; i < l; i++) {
    option = el.options[i];
    if (isMultiple) {
      selected = looseIndexOf(value, getValue(option)) > -1;
      if (option.selected !== selected) {
        option.selected = selected;
      }
    } else {
      if (looseEqual(getValue(option), value)) {
        if (el.selectedIndex !== i) {
          el.selectedIndex = i;
        }
        return
      }
    }
  }
  if (!isMultiple) {
    el.selectedIndex = -1;
  }
}

function hasNoMatchingOption (value, options) {
  return options.every(function (o) { return !looseEqual(o, value); })
}

function getValue (option) {
  return '_value' in option
    ? option._value
    : option.value
}

function onCompositionStart (e) {
  e.target.composing = true;
}

function onCompositionEnd (e) {
  // prevent triggering an input event for no reason
  if (!e.target.composing) { return }
  e.target.composing = false;
  trigger(e.target, 'input');
}

function trigger (el, type) {
  var e = document.createEvent('HTMLEvents');
  e.initEvent(type, true, true);
  el.dispatchEvent(e);
}

/*  */

// recursively search for possible transition defined inside the component root
function locateNode (vnode) {
  return vnode.componentInstance && (!vnode.data || !vnode.data.transition)
    ? locateNode(vnode.componentInstance._vnode)
    : vnode
}

var show = {
  bind: function bind (el, ref, vnode) {
    var value = ref.value;

    vnode = locateNode(vnode);
    var transition$$1 = vnode.data && vnode.data.transition;
    var originalDisplay = el.__vOriginalDisplay =
      el.style.display === 'none' ? '' : el.style.display;
    if (value && transition$$1) {
      vnode.data.show = true;
      enter(vnode, function () {
        el.style.display = originalDisplay;
      });
    } else {
      el.style.display = value ? originalDisplay : 'none';
    }
  },

  update: function update (el, ref, vnode) {
    var value = ref.value;
    var oldValue = ref.oldValue;

    /* istanbul ignore if */
    if (!value === !oldValue) { return }
    vnode = locateNode(vnode);
    var transition$$1 = vnode.data && vnode.data.transition;
    if (transition$$1) {
      vnode.data.show = true;
      if (value) {
        enter(vnode, function () {
          el.style.display = el.__vOriginalDisplay;
        });
      } else {
        leave(vnode, function () {
          el.style.display = 'none';
        });
      }
    } else {
      el.style.display = value ? el.__vOriginalDisplay : 'none';
    }
  },

  unbind: function unbind (
    el,
    binding,
    vnode,
    oldVnode,
    isDestroy
  ) {
    if (!isDestroy) {
      el.style.display = el.__vOriginalDisplay;
    }
  }
};

var platformDirectives = {
  model: directive,
  show: show
};

/*  */

var transitionProps = {
  name: String,
  appear: Boolean,
  css: Boolean,
  mode: String,
  type: String,
  enterClass: String,
  leaveClass: String,
  enterToClass: String,
  leaveToClass: String,
  enterActiveClass: String,
  leaveActiveClass: String,
  appearClass: String,
  appearActiveClass: String,
  appearToClass: String,
  duration: [Number, String, Object]
};

// in case the child is also an abstract component, e.g. <keep-alive>
// we want to recursively retrieve the real component to be rendered
function getRealChild (vnode) {
  var compOptions = vnode && vnode.componentOptions;
  if (compOptions && compOptions.Ctor.options.abstract) {
    return getRealChild(getFirstComponentChild(compOptions.children))
  } else {
    return vnode
  }
}

function extractTransitionData (comp) {
  var data = {};
  var options = comp.$options;
  // props
  for (var key in options.propsData) {
    data[key] = comp[key];
  }
  // events.
  // extract listeners and pass them directly to the transition methods
  var listeners = options._parentListeners;
  for (var key$1 in listeners) {
    data[camelize(key$1)] = listeners[key$1];
  }
  return data
}

function placeholder (h, rawChild) {
  if (/\d-keep-alive$/.test(rawChild.tag)) {
    return h('keep-alive', {
      props: rawChild.componentOptions.propsData
    })
  }
}

function hasParentTransition (vnode) {
  while ((vnode = vnode.parent)) {
    if (vnode.data.transition) {
      return true
    }
  }
}

function isSameChild (child, oldChild) {
  return oldChild.key === child.key && oldChild.tag === child.tag
}

var isNotTextNode = function (c) { return c.tag || isAsyncPlaceholder(c); };

var isVShowDirective = function (d) { return d.name === 'show'; };

var Transition = {
  name: 'transition',
  props: transitionProps,
  abstract: true,

  render: function render (h) {
    var this$1 = this;

    var children = this.$slots.default;
    if (!children) {
      return
    }

    // filter out text nodes (possible whitespaces)
    children = children.filter(isNotTextNode);
    /* istanbul ignore if */
    if (!children.length) {
      return
    }

    // warn multiple elements
    if (false) {
      warn(
        '<transition> can only be used on a single element. Use ' +
        '<transition-group> for lists.',
        this.$parent
      );
    }

    var mode = this.mode;

    // warn invalid mode
    if (false
    ) {
      warn(
        'invalid <transition> mode: ' + mode,
        this.$parent
      );
    }

    var rawChild = children[0];

    // if this is a component root node and the component's
    // parent container node also has transition, skip.
    if (hasParentTransition(this.$vnode)) {
      return rawChild
    }

    // apply transition data to child
    // use getRealChild() to ignore abstract components e.g. keep-alive
    var child = getRealChild(rawChild);
    /* istanbul ignore if */
    if (!child) {
      return rawChild
    }

    if (this._leaving) {
      return placeholder(h, rawChild)
    }

    // ensure a key that is unique to the vnode type and to this transition
    // component instance. This key will be used to remove pending leaving nodes
    // during entering.
    var id = "__transition-" + (this._uid) + "-";
    child.key = child.key == null
      ? child.isComment
        ? id + 'comment'
        : id + child.tag
      : isPrimitive(child.key)
        ? (String(child.key).indexOf(id) === 0 ? child.key : id + child.key)
        : child.key;

    var data = (child.data || (child.data = {})).transition = extractTransitionData(this);
    var oldRawChild = this._vnode;
    var oldChild = getRealChild(oldRawChild);

    // mark v-show
    // so that the transition module can hand over the control to the directive
    if (child.data.directives && child.data.directives.some(isVShowDirective)) {
      child.data.show = true;
    }

    if (
      oldChild &&
      oldChild.data &&
      !isSameChild(child, oldChild) &&
      !isAsyncPlaceholder(oldChild) &&
      // #6687 component root is a comment node
      !(oldChild.componentInstance && oldChild.componentInstance._vnode.isComment)
    ) {
      // replace old child transition data with fresh one
      // important for dynamic transitions!
      var oldData = oldChild.data.transition = extend({}, data);
      // handle transition mode
      if (mode === 'out-in') {
        // return placeholder node and queue update when leave finishes
        this._leaving = true;
        mergeVNodeHook(oldData, 'afterLeave', function () {
          this$1._leaving = false;
          this$1.$forceUpdate();
        });
        return placeholder(h, rawChild)
      } else if (mode === 'in-out') {
        if (isAsyncPlaceholder(child)) {
          return oldRawChild
        }
        var delayedLeave;
        var performLeave = function () { delayedLeave(); };
        mergeVNodeHook(data, 'afterEnter', performLeave);
        mergeVNodeHook(data, 'enterCancelled', performLeave);
        mergeVNodeHook(oldData, 'delayLeave', function (leave) { delayedLeave = leave; });
      }
    }

    return rawChild
  }
};

/*  */

var props = extend({
  tag: String,
  moveClass: String
}, transitionProps);

delete props.mode;

var TransitionGroup = {
  props: props,

  beforeMount: function beforeMount () {
    var this$1 = this;

    var update = this._update;
    this._update = function (vnode, hydrating) {
      var restoreActiveInstance = setActiveInstance(this$1);
      // force removing pass
      this$1.__patch__(
        this$1._vnode,
        this$1.kept,
        false, // hydrating
        true // removeOnly (!important, avoids unnecessary moves)
      );
      this$1._vnode = this$1.kept;
      restoreActiveInstance();
      update.call(this$1, vnode, hydrating);
    };
  },

  render: function render (h) {
    var tag = this.tag || this.$vnode.data.tag || 'span';
    var map = Object.create(null);
    var prevChildren = this.prevChildren = this.children;
    var rawChildren = this.$slots.default || [];
    var children = this.children = [];
    var transitionData = extractTransitionData(this);

    for (var i = 0; i < rawChildren.length; i++) {
      var c = rawChildren[i];
      if (c.tag) {
        if (c.key != null && String(c.key).indexOf('__vlist') !== 0) {
          children.push(c);
          map[c.key] = c
          ;(c.data || (c.data = {})).transition = transitionData;
        } else if (false) {
          var opts = c.componentOptions;
          var name = opts ? (opts.Ctor.options.name || opts.tag || '') : c.tag;
          warn(("<transition-group> children must be keyed: <" + name + ">"));
        }
      }
    }

    if (prevChildren) {
      var kept = [];
      var removed = [];
      for (var i$1 = 0; i$1 < prevChildren.length; i$1++) {
        var c$1 = prevChildren[i$1];
        c$1.data.transition = transitionData;
        c$1.data.pos = c$1.elm.getBoundingClientRect();
        if (map[c$1.key]) {
          kept.push(c$1);
        } else {
          removed.push(c$1);
        }
      }
      this.kept = h(tag, null, kept);
      this.removed = removed;
    }

    return h(tag, null, children)
  },

  updated: function updated () {
    var children = this.prevChildren;
    var moveClass = this.moveClass || ((this.name || 'v') + '-move');
    if (!children.length || !this.hasMove(children[0].elm, moveClass)) {
      return
    }

    // we divide the work into three loops to avoid mixing DOM reads and writes
    // in each iteration - which helps prevent layout thrashing.
    children.forEach(callPendingCbs);
    children.forEach(recordPosition);
    children.forEach(applyTranslation);

    // force reflow to put everything in position
    // assign to this to avoid being removed in tree-shaking
    // $flow-disable-line
    this._reflow = document.body.offsetHeight;

    children.forEach(function (c) {
      if (c.data.moved) {
        var el = c.elm;
        var s = el.style;
        addTransitionClass(el, moveClass);
        s.transform = s.WebkitTransform = s.transitionDuration = '';
        el.addEventListener(transitionEndEvent, el._moveCb = function cb (e) {
          if (e && e.target !== el) {
            return
          }
          if (!e || /transform$/.test(e.propertyName)) {
            el.removeEventListener(transitionEndEvent, cb);
            el._moveCb = null;
            removeTransitionClass(el, moveClass);
          }
        });
      }
    });
  },

  methods: {
    hasMove: function hasMove (el, moveClass) {
      /* istanbul ignore if */
      if (!hasTransition) {
        return false
      }
      /* istanbul ignore if */
      if (this._hasMove) {
        return this._hasMove
      }
      // Detect whether an element with the move class applied has
      // CSS transitions. Since the element may be inside an entering
      // transition at this very moment, we make a clone of it and remove
      // all other transition classes applied to ensure only the move class
      // is applied.
      var clone = el.cloneNode();
      if (el._transitionClasses) {
        el._transitionClasses.forEach(function (cls) { removeClass(clone, cls); });
      }
      addClass(clone, moveClass);
      clone.style.display = 'none';
      this.$el.appendChild(clone);
      var info = getTransitionInfo(clone);
      this.$el.removeChild(clone);
      return (this._hasMove = info.hasTransform)
    }
  }
};

function callPendingCbs (c) {
  /* istanbul ignore if */
  if (c.elm._moveCb) {
    c.elm._moveCb();
  }
  /* istanbul ignore if */
  if (c.elm._enterCb) {
    c.elm._enterCb();
  }
}

function recordPosition (c) {
  c.data.newPos = c.elm.getBoundingClientRect();
}

function applyTranslation (c) {
  var oldPos = c.data.pos;
  var newPos = c.data.newPos;
  var dx = oldPos.left - newPos.left;
  var dy = oldPos.top - newPos.top;
  if (dx || dy) {
    c.data.moved = true;
    var s = c.elm.style;
    s.transform = s.WebkitTransform = "translate(" + dx + "px," + dy + "px)";
    s.transitionDuration = '0s';
  }
}

var platformComponents = {
  Transition: Transition,
  TransitionGroup: TransitionGroup
};

/*  */

// install platform specific utils
Vue.config.mustUseProp = mustUseProp;
Vue.config.isReservedTag = isReservedTag;
Vue.config.isReservedAttr = isReservedAttr;
Vue.config.getTagNamespace = getTagNamespace;
Vue.config.isUnknownElement = isUnknownElement;

// install platform runtime directives & components
extend(Vue.options.directives, platformDirectives);
extend(Vue.options.components, platformComponents);

// install platform patch function
Vue.prototype.__patch__ = inBrowser ? patch : noop;

// public mount method
Vue.prototype.$mount = function (
  el,
  hydrating
) {
  el = el && inBrowser ? query(el) : undefined;
  return mountComponent(this, el, hydrating)
};

// devtools global hook
/* istanbul ignore next */
if (inBrowser) {
  setTimeout(function () {
    if (config.devtools) {
      if (devtools) {
        devtools.emit('init', Vue);
      } else if (
        false
      ) {
        console[console.info ? 'info' : 'log'](
          'Download the Vue Devtools extension for a better development experience:\n' +
          'https://github.com/vuejs/vue-devtools'
        );
      }
    }
    if (false
    ) {
      console[console.info ? 'info' : 'log'](
        "You are running Vue in development mode.\n" +
        "Make sure to turn on production mode when deploying for production.\n" +
        "See more tips at https://vuejs.org/guide/deployment.html"
      );
    }
  }, 0);
}

/*  */

var defaultTagRE = /\{\{((?:.|\r?\n)+?)\}\}/g;
var regexEscapeRE = /[-.*+?^${}()|[\]\/\\]/g;

var buildRegex = cached(function (delimiters) {
  var open = delimiters[0].replace(regexEscapeRE, '\\$&');
  var close = delimiters[1].replace(regexEscapeRE, '\\$&');
  return new RegExp(open + '((?:.|\\n)+?)' + close, 'g')
});



function parseText (
  text,
  delimiters
) {
  var tagRE = delimiters ? buildRegex(delimiters) : defaultTagRE;
  if (!tagRE.test(text)) {
    return
  }
  var tokens = [];
  var rawTokens = [];
  var lastIndex = tagRE.lastIndex = 0;
  var match, index, tokenValue;
  while ((match = tagRE.exec(text))) {
    index = match.index;
    // push text token
    if (index > lastIndex) {
      rawTokens.push(tokenValue = text.slice(lastIndex, index));
      tokens.push(JSON.stringify(tokenValue));
    }
    // tag token
    var exp = parseFilters(match[1].trim());
    tokens.push(("_s(" + exp + ")"));
    rawTokens.push({ '@binding': exp });
    lastIndex = index + match[0].length;
  }
  if (lastIndex < text.length) {
    rawTokens.push(tokenValue = text.slice(lastIndex));
    tokens.push(JSON.stringify(tokenValue));
  }
  return {
    expression: tokens.join('+'),
    tokens: rawTokens
  }
}

/*  */

function transformNode (el, options) {
  var warn = options.warn || baseWarn;
  var staticClass = getAndRemoveAttr(el, 'class');
  if (false) {
    var res = parseText(staticClass, options.delimiters);
    if (res) {
      warn(
        "class=\"" + staticClass + "\": " +
        'Interpolation inside attributes has been removed. ' +
        'Use v-bind or the colon shorthand instead. For example, ' +
        'instead of <div class="{{ val }}">, use <div :class="val">.',
        el.rawAttrsMap['class']
      );
    }
  }
  if (staticClass) {
    el.staticClass = JSON.stringify(staticClass);
  }
  var classBinding = getBindingAttr(el, 'class', false /* getStatic */);
  if (classBinding) {
    el.classBinding = classBinding;
  }
}

function genData (el) {
  var data = '';
  if (el.staticClass) {
    data += "staticClass:" + (el.staticClass) + ",";
  }
  if (el.classBinding) {
    data += "class:" + (el.classBinding) + ",";
  }
  return data
}

var klass$1 = {
  staticKeys: ['staticClass'],
  transformNode: transformNode,
  genData: genData
};

/*  */

function transformNode$1 (el, options) {
  var warn = options.warn || baseWarn;
  var staticStyle = getAndRemoveAttr(el, 'style');
  if (staticStyle) {
    /* istanbul ignore if */
    if (false) {
      var res = parseText(staticStyle, options.delimiters);
      if (res) {
        warn(
          "style=\"" + staticStyle + "\": " +
          'Interpolation inside attributes has been removed. ' +
          'Use v-bind or the colon shorthand instead. For example, ' +
          'instead of <div style="{{ val }}">, use <div :style="val">.',
          el.rawAttrsMap['style']
        );
      }
    }
    el.staticStyle = JSON.stringify(parseStyleText(staticStyle));
  }

  var styleBinding = getBindingAttr(el, 'style', false /* getStatic */);
  if (styleBinding) {
    el.styleBinding = styleBinding;
  }
}

function genData$1 (el) {
  var data = '';
  if (el.staticStyle) {
    data += "staticStyle:" + (el.staticStyle) + ",";
  }
  if (el.styleBinding) {
    data += "style:(" + (el.styleBinding) + "),";
  }
  return data
}

var style$1 = {
  staticKeys: ['staticStyle'],
  transformNode: transformNode$1,
  genData: genData$1
};

/*  */

var decoder;

var he = {
  decode: function decode (html) {
    decoder = decoder || document.createElement('div');
    decoder.innerHTML = html;
    return decoder.textContent
  }
};

/*  */

var isUnaryTag = makeMap(
  'area,base,br,col,embed,frame,hr,img,input,isindex,keygen,' +
  'link,meta,param,source,track,wbr'
);

// Elements that you can, intentionally, leave open
// (and which close themselves)
var canBeLeftOpenTag = makeMap(
  'colgroup,dd,dt,li,options,p,td,tfoot,th,thead,tr,source'
);

// HTML5 tags https://html.spec.whatwg.org/multipage/indices.html#elements-3
// Phrasing Content https://html.spec.whatwg.org/multipage/dom.html#phrasing-content
var isNonPhrasingTag = makeMap(
  'address,article,aside,base,blockquote,body,caption,col,colgroup,dd,' +
  'details,dialog,div,dl,dt,fieldset,figcaption,figure,footer,form,' +
  'h1,h2,h3,h4,h5,h6,head,header,hgroup,hr,html,legend,li,menuitem,meta,' +
  'optgroup,option,param,rp,rt,source,style,summary,tbody,td,tfoot,th,thead,' +
  'title,tr,track'
);

/**
 * Not type-checking this file because it's mostly vendor code.
 */

// Regular Expressions for parsing tags and attributes
var attribute = /^\s*([^\s"'<>\/=]+)(?:\s*(=)\s*(?:"([^"]*)"+|'([^']*)'+|([^\s"'=<>`]+)))?/;
var dynamicArgAttribute = /^\s*((?:v-[\w-]+:|@|:|#)\[[^=]+\][^\s"'<>\/=]*)(?:\s*(=)\s*(?:"([^"]*)"+|'([^']*)'+|([^\s"'=<>`]+)))?/;
var ncname = "[a-zA-Z_][\\-\\.0-9_a-zA-Z" + (unicodeRegExp.source) + "]*";
var qnameCapture = "((?:" + ncname + "\\:)?" + ncname + ")";
var startTagOpen = new RegExp(("^<" + qnameCapture));
var startTagClose = /^\s*(\/?)>/;
var endTag = new RegExp(("^<\\/" + qnameCapture + "[^>]*>"));
var doctype = /^<!DOCTYPE [^>]+>/i;
// #7298: escape - to avoid being passed as HTML comment when inlined in page
var comment = /^<!\--/;
var conditionalComment = /^<!\[/;

// Special Elements (can contain anything)
var isPlainTextElement = makeMap('script,style,textarea', true);
var reCache = {};

var decodingMap = {
  '&lt;': '<',
  '&gt;': '>',
  '&quot;': '"',
  '&amp;': '&',
  '&#10;': '\n',
  '&#9;': '\t',
  '&#39;': "'"
};
var encodedAttr = /&(?:lt|gt|quot|amp|#39);/g;
var encodedAttrWithNewLines = /&(?:lt|gt|quot|amp|#39|#10|#9);/g;

// #5992
var isIgnoreNewlineTag = makeMap('pre,textarea', true);
var shouldIgnoreFirstNewline = function (tag, html) { return tag && isIgnoreNewlineTag(tag) && html[0] === '\n'; };

function decodeAttr (value, shouldDecodeNewlines) {
  var re = shouldDecodeNewlines ? encodedAttrWithNewLines : encodedAttr;
  return value.replace(re, function (match) { return decodingMap[match]; })
}

function parseHTML (html, options) {
  var stack = [];
  var expectHTML = options.expectHTML;
  var isUnaryTag$$1 = options.isUnaryTag || no;
  var canBeLeftOpenTag$$1 = options.canBeLeftOpenTag || no;
  var index = 0;
  var last, lastTag;
  while (html) {
    last = html;
    // Make sure we're not in a plaintext content element like script/style
    if (!lastTag || !isPlainTextElement(lastTag)) {
      var textEnd = html.indexOf('<');
      if (textEnd === 0) {
        // Comment:
        if (comment.test(html)) {
          var commentEnd = html.indexOf('-->');

          if (commentEnd >= 0) {
            if (options.shouldKeepComment) {
              options.comment(html.substring(4, commentEnd), index, index + commentEnd + 3);
            }
            advance(commentEnd + 3);
            continue
          }
        }

        // http://en.wikipedia.org/wiki/Conditional_comment#Downlevel-revealed_conditional_comment
        if (conditionalComment.test(html)) {
          var conditionalEnd = html.indexOf(']>');

          if (conditionalEnd >= 0) {
            advance(conditionalEnd + 2);
            continue
          }
        }

        // Doctype:
        var doctypeMatch = html.match(doctype);
        if (doctypeMatch) {
          advance(doctypeMatch[0].length);
          continue
        }

        // End tag:
        var endTagMatch = html.match(endTag);
        if (endTagMatch) {
          var curIndex = index;
          advance(endTagMatch[0].length);
          parseEndTag(endTagMatch[1], curIndex, index);
          continue
        }

        // Start tag:
        var startTagMatch = parseStartTag();
        if (startTagMatch) {
          handleStartTag(startTagMatch);
          if (shouldIgnoreFirstNewline(startTagMatch.tagName, html)) {
            advance(1);
          }
          continue
        }
      }

      var text = (void 0), rest = (void 0), next = (void 0);
      if (textEnd >= 0) {
        rest = html.slice(textEnd);
        while (
          !endTag.test(rest) &&
          !startTagOpen.test(rest) &&
          !comment.test(rest) &&
          !conditionalComment.test(rest)
        ) {
          // < in plain text, be forgiving and treat it as text
          next = rest.indexOf('<', 1);
          if (next < 0) { break }
          textEnd += next;
          rest = html.slice(textEnd);
        }
        text = html.substring(0, textEnd);
      }

      if (textEnd < 0) {
        text = html;
      }

      if (text) {
        advance(text.length);
      }

      if (options.chars && text) {
        options.chars(text, index - text.length, index);
      }
    } else {
      var endTagLength = 0;
      var stackedTag = lastTag.toLowerCase();
      var reStackedTag = reCache[stackedTag] || (reCache[stackedTag] = new RegExp('([\\s\\S]*?)(</' + stackedTag + '[^>]*>)', 'i'));
      var rest$1 = html.replace(reStackedTag, function (all, text, endTag) {
        endTagLength = endTag.length;
        if (!isPlainTextElement(stackedTag) && stackedTag !== 'noscript') {
          text = text
            .replace(/<!\--([\s\S]*?)-->/g, '$1') // #7298
            .replace(/<!\[CDATA\[([\s\S]*?)]]>/g, '$1');
        }
        if (shouldIgnoreFirstNewline(stackedTag, text)) {
          text = text.slice(1);
        }
        if (options.chars) {
          options.chars(text);
        }
        return ''
      });
      index += html.length - rest$1.length;
      html = rest$1;
      parseEndTag(stackedTag, index - endTagLength, index);
    }

    if (html === last) {
      options.chars && options.chars(html);
      if (false) {
        options.warn(("Mal-formatted tag at end of template: \"" + html + "\""), { start: index + html.length });
      }
      break
    }
  }

  // Clean up any remaining tags
  parseEndTag();

  function advance (n) {
    index += n;
    html = html.substring(n);
  }

  function parseStartTag () {
    var start = html.match(startTagOpen);
    if (start) {
      var match = {
        tagName: start[1],
        attrs: [],
        start: index
      };
      advance(start[0].length);
      var end, attr;
      while (!(end = html.match(startTagClose)) && (attr = html.match(dynamicArgAttribute) || html.match(attribute))) {
        attr.start = index;
        advance(attr[0].length);
        attr.end = index;
        match.attrs.push(attr);
      }
      if (end) {
        match.unarySlash = end[1];
        advance(end[0].length);
        match.end = index;
        return match
      }
    }
  }

  function handleStartTag (match) {
    var tagName = match.tagName;
    var unarySlash = match.unarySlash;

    if (expectHTML) {
      if (lastTag === 'p' && isNonPhrasingTag(tagName)) {
        parseEndTag(lastTag);
      }
      if (canBeLeftOpenTag$$1(tagName) && lastTag === tagName) {
        parseEndTag(tagName);
      }
    }

    var unary = isUnaryTag$$1(tagName) || !!unarySlash;

    var l = match.attrs.length;
    var attrs = new Array(l);
    for (var i = 0; i < l; i++) {
      var args = match.attrs[i];
      var value = args[3] || args[4] || args[5] || '';
      var shouldDecodeNewlines = tagName === 'a' && args[1] === 'href'
        ? options.shouldDecodeNewlinesForHref
        : options.shouldDecodeNewlines;
      attrs[i] = {
        name: args[1],
        value: decodeAttr(value, shouldDecodeNewlines)
      };
      if (false) {
        attrs[i].start = args.start + args[0].match(/^\s*/).length;
        attrs[i].end = args.end;
      }
    }

    if (!unary) {
      stack.push({ tag: tagName, lowerCasedTag: tagName.toLowerCase(), attrs: attrs, start: match.start, end: match.end });
      lastTag = tagName;
    }

    if (options.start) {
      options.start(tagName, attrs, unary, match.start, match.end);
    }
  }

  function parseEndTag (tagName, start, end) {
    var pos, lowerCasedTagName;
    if (start == null) { start = index; }
    if (end == null) { end = index; }

    // Find the closest opened tag of the same type
    if (tagName) {
      lowerCasedTagName = tagName.toLowerCase();
      for (pos = stack.length - 1; pos >= 0; pos--) {
        if (stack[pos].lowerCasedTag === lowerCasedTagName) {
          break
        }
      }
    } else {
      // If no tag name is provided, clean shop
      pos = 0;
    }

    if (pos >= 0) {
      // Close all the open elements, up the stack
      for (var i = stack.length - 1; i >= pos; i--) {
        if (false
        ) {
          options.warn(
            ("tag <" + (stack[i].tag) + "> has no matching end tag."),
            { start: stack[i].start, end: stack[i].end }
          );
        }
        if (options.end) {
          options.end(stack[i].tag, start, end);
        }
      }

      // Remove the open elements from the stack
      stack.length = pos;
      lastTag = pos && stack[pos - 1].tag;
    } else if (lowerCasedTagName === 'br') {
      if (options.start) {
        options.start(tagName, [], true, start, end);
      }
    } else if (lowerCasedTagName === 'p') {
      if (options.start) {
        options.start(tagName, [], false, start, end);
      }
      if (options.end) {
        options.end(tagName, start, end);
      }
    }
  }
}

/*  */

var onRE = /^@|^v-on:/;
var dirRE = /^v-|^@|^:|^#/;
var forAliasRE = /([\s\S]*?)\s+(?:in|of)\s+([\s\S]*)/;
var forIteratorRE = /,([^,\}\]]*)(?:,([^,\}\]]*))?$/;
var stripParensRE = /^\(|\)$/g;
var dynamicArgRE = /^\[.*\]$/;

var argRE = /:(.*)$/;
var bindRE = /^:|^\.|^v-bind:/;
var modifierRE = /\.[^.\]]+(?=[^\]]*$)/g;

var slotRE = /^v-slot(:|$)|^#/;

var lineBreakRE = /[\r\n]/;
var whitespaceRE$1 = /\s+/g;

var invalidAttributeRE = /[\s"'<>\/=]/;

var decodeHTMLCached = cached(he.decode);

var emptySlotScopeToken = "_empty_";

// configurable state
var warn$2;
var delimiters;
var transforms;
var preTransforms;
var postTransforms;
var platformIsPreTag;
var platformMustUseProp;
var platformGetTagNamespace;
var maybeComponent;

function createASTElement (
  tag,
  attrs,
  parent
) {
  return {
    type: 1,
    tag: tag,
    attrsList: attrs,
    attrsMap: makeAttrsMap(attrs),
    rawAttrsMap: {},
    parent: parent,
    children: []
  }
}

/**
 * Convert HTML string to AST.
 */
function parse (
  template,
  options
) {
  warn$2 = options.warn || baseWarn;

  platformIsPreTag = options.isPreTag || no;
  platformMustUseProp = options.mustUseProp || no;
  platformGetTagNamespace = options.getTagNamespace || no;
  var isReservedTag = options.isReservedTag || no;
  maybeComponent = function (el) { return !!el.component || !isReservedTag(el.tag); };

  transforms = pluckModuleFunction(options.modules, 'transformNode');
  preTransforms = pluckModuleFunction(options.modules, 'preTransformNode');
  postTransforms = pluckModuleFunction(options.modules, 'postTransformNode');

  delimiters = options.delimiters;

  var stack = [];
  var preserveWhitespace = options.preserveWhitespace !== false;
  var whitespaceOption = options.whitespace;
  var root;
  var currentParent;
  var inVPre = false;
  var inPre = false;
  var warned = false;

  function warnOnce (msg, range) {
    if (!warned) {
      warned = true;
      warn$2(msg, range);
    }
  }

  function closeElement (element) {
    trimEndingWhitespace(element);
    if (!inVPre && !element.processed) {
      element = processElement(element, options);
    }
    // tree management
    if (!stack.length && element !== root) {
      // allow root elements with v-if, v-else-if and v-else
      if (root.if && (element.elseif || element.else)) {
        if (false) {
          checkRootConstraints(element);
        }
        addIfCondition(root, {
          exp: element.elseif,
          block: element
        });
      } else if (false) {
        warnOnce(
          "Component template should contain exactly one root element. " +
          "If you are using v-if on multiple elements, " +
          "use v-else-if to chain them instead.",
          { start: element.start }
        );
      }
    }
    if (currentParent && !element.forbidden) {
      if (element.elseif || element.else) {
        processIfConditions(element, currentParent);
      } else {
        if (element.slotScope) {
          // scoped slot
          // keep it in the children list so that v-else(-if) conditions can
          // find it as the prev node.
          var name = element.slotTarget || '"default"'
          ;(currentParent.scopedSlots || (currentParent.scopedSlots = {}))[name] = element;
        }
        currentParent.children.push(element);
        element.parent = currentParent;
      }
    }

    // final children cleanup
    // filter out scoped slots
    element.children = element.children.filter(function (c) { return !(c).slotScope; });
    // remove trailing whitespace node again
    trimEndingWhitespace(element);

    // check pre state
    if (element.pre) {
      inVPre = false;
    }
    if (platformIsPreTag(element.tag)) {
      inPre = false;
    }
    // apply post-transforms
    for (var i = 0; i < postTransforms.length; i++) {
      postTransforms[i](element, options);
    }
  }

  function trimEndingWhitespace (el) {
    // remove trailing whitespace node
    if (!inPre) {
      var lastNode;
      while (
        (lastNode = el.children[el.children.length - 1]) &&
        lastNode.type === 3 &&
        lastNode.text === ' '
      ) {
        el.children.pop();
      }
    }
  }

  function checkRootConstraints (el) {
    if (el.tag === 'slot' || el.tag === 'template') {
      warnOnce(
        "Cannot use <" + (el.tag) + "> as component root element because it may " +
        'contain multiple nodes.',
        { start: el.start }
      );
    }
    if (el.attrsMap.hasOwnProperty('v-for')) {
      warnOnce(
        'Cannot use v-for on stateful component root element because ' +
        'it renders multiple elements.',
        el.rawAttrsMap['v-for']
      );
    }
  }

  parseHTML(template, {
    warn: warn$2,
    expectHTML: options.expectHTML,
    isUnaryTag: options.isUnaryTag,
    canBeLeftOpenTag: options.canBeLeftOpenTag,
    shouldDecodeNewlines: options.shouldDecodeNewlines,
    shouldDecodeNewlinesForHref: options.shouldDecodeNewlinesForHref,
    shouldKeepComment: options.comments,
    outputSourceRange: options.outputSourceRange,
    start: function start (tag, attrs, unary, start$1, end) {
      // check namespace.
      // inherit parent ns if there is one
      var ns = (currentParent && currentParent.ns) || platformGetTagNamespace(tag);

      // handle IE svg bug
      /* istanbul ignore if */
      if (isIE && ns === 'svg') {
        attrs = guardIESVGBug(attrs);
      }

      var element = createASTElement(tag, attrs, currentParent);
      if (ns) {
        element.ns = ns;
      }

      if (false) {
        if (options.outputSourceRange) {
          element.start = start$1;
          element.end = end;
          element.rawAttrsMap = element.attrsList.reduce(function (cumulated, attr) {
            cumulated[attr.name] = attr;
            return cumulated
          }, {});
        }
        attrs.forEach(function (attr) {
          if (invalidAttributeRE.test(attr.name)) {
            warn$2(
              "Invalid dynamic argument expression: attribute names cannot contain " +
              "spaces, quotes, <, >, / or =.",
              {
                start: attr.start + attr.name.indexOf("["),
                end: attr.start + attr.name.length
              }
            );
          }
        });
      }

      if (isForbiddenTag(element) && !isServerRendering()) {
        element.forbidden = true;
        "production" !== 'production' && warn$2(
          'Templates should only be responsible for mapping the state to the ' +
          'UI. Avoid placing tags with side-effects in your templates, such as ' +
          "<" + tag + ">" + ', as they will not be parsed.',
          { start: element.start }
        );
      }

      // apply pre-transforms
      for (var i = 0; i < preTransforms.length; i++) {
        element = preTransforms[i](element, options) || element;
      }

      if (!inVPre) {
        processPre(element);
        if (element.pre) {
          inVPre = true;
        }
      }
      if (platformIsPreTag(element.tag)) {
        inPre = true;
      }
      if (inVPre) {
        processRawAttrs(element);
      } else if (!element.processed) {
        // structural directives
        processFor(element);
        processIf(element);
        processOnce(element);
      }

      if (!root) {
        root = element;
        if (false) {
          checkRootConstraints(root);
        }
      }

      if (!unary) {
        currentParent = element;
        stack.push(element);
      } else {
        closeElement(element);
      }
    },

    end: function end (tag, start, end$1) {
      var element = stack[stack.length - 1];
      // pop stack
      stack.length -= 1;
      currentParent = stack[stack.length - 1];
      if (false) {
        element.end = end$1;
      }
      closeElement(element);
    },

    chars: function chars (text, start, end) {
      if (!currentParent) {
        if (false) {
          if (text === template) {
            warnOnce(
              'Component template requires a root element, rather than just text.',
              { start: start }
            );
          } else if ((text = text.trim())) {
            warnOnce(
              ("text \"" + text + "\" outside root element will be ignored."),
              { start: start }
            );
          }
        }
        return
      }
      // IE textarea placeholder bug
      /* istanbul ignore if */
      if (isIE &&
        currentParent.tag === 'textarea' &&
        currentParent.attrsMap.placeholder === text
      ) {
        return
      }
      var children = currentParent.children;
      if (inPre || text.trim()) {
        text = isTextTag(currentParent) ? text : decodeHTMLCached(text);
      } else if (!children.length) {
        // remove the whitespace-only node right after an opening tag
        text = '';
      } else if (whitespaceOption) {
        if (whitespaceOption === 'condense') {
          // in condense mode, remove the whitespace node if it contains
          // line break, otherwise condense to a single space
          text = lineBreakRE.test(text) ? '' : ' ';
        } else {
          text = ' ';
        }
      } else {
        text = preserveWhitespace ? ' ' : '';
      }
      if (text) {
        if (!inPre && whitespaceOption === 'condense') {
          // condense consecutive whitespaces into single space
          text = text.replace(whitespaceRE$1, ' ');
        }
        var res;
        var child;
        if (!inVPre && text !== ' ' && (res = parseText(text, delimiters))) {
          child = {
            type: 2,
            expression: res.expression,
            tokens: res.tokens,
            text: text
          };
        } else if (text !== ' ' || !children.length || children[children.length - 1].text !== ' ') {
          child = {
            type: 3,
            text: text
          };
        }
        if (child) {
          if (false) {
            child.start = start;
            child.end = end;
          }
          children.push(child);
        }
      }
    },
    comment: function comment (text, start, end) {
      // adding anything as a sibling to the root node is forbidden
      // comments should still be allowed, but ignored
      if (currentParent) {
        var child = {
          type: 3,
          text: text,
          isComment: true
        };
        if (false) {
          child.start = start;
          child.end = end;
        }
        currentParent.children.push(child);
      }
    }
  });
  return root
}

function processPre (el) {
  if (getAndRemoveAttr(el, 'v-pre') != null) {
    el.pre = true;
  }
}

function processRawAttrs (el) {
  var list = el.attrsList;
  var len = list.length;
  if (len) {
    var attrs = el.attrs = new Array(len);
    for (var i = 0; i < len; i++) {
      attrs[i] = {
        name: list[i].name,
        value: JSON.stringify(list[i].value)
      };
      if (list[i].start != null) {
        attrs[i].start = list[i].start;
        attrs[i].end = list[i].end;
      }
    }
  } else if (!el.pre) {
    // non root node in pre blocks with no attributes
    el.plain = true;
  }
}

function processElement (
  element,
  options
) {
  processKey(element);

  // determine whether this is a plain element after
  // removing structural attributes
  element.plain = (
    !element.key &&
    !element.scopedSlots &&
    !element.attrsList.length
  );

  processRef(element);
  processSlotContent(element);
  processSlotOutlet(element);
  processComponent(element);
  for (var i = 0; i < transforms.length; i++) {
    element = transforms[i](element, options) || element;
  }
  processAttrs(element);
  return element
}

function processKey (el) {
  var exp = getBindingAttr(el, 'key');
  if (exp) {
    if (false) {
      if (el.tag === 'template') {
        warn$2(
          "<template> cannot be keyed. Place the key on real elements instead.",
          getRawBindingAttr(el, 'key')
        );
      }
      if (el.for) {
        var iterator = el.iterator2 || el.iterator1;
        var parent = el.parent;
        if (iterator && iterator === exp && parent && parent.tag === 'transition-group') {
          warn$2(
            "Do not use v-for index as key on <transition-group> children, " +
            "this is the same as not using keys.",
            getRawBindingAttr(el, 'key'),
            true /* tip */
          );
        }
      }
    }
    el.key = exp;
  }
}

function processRef (el) {
  var ref = getBindingAttr(el, 'ref');
  if (ref) {
    el.ref = ref;
    el.refInFor = checkInFor(el);
  }
}

function processFor (el) {
  var exp;
  if ((exp = getAndRemoveAttr(el, 'v-for'))) {
    var res = parseFor(exp);
    if (res) {
      extend(el, res);
    } else if (false) {
      warn$2(
        ("Invalid v-for expression: " + exp),
        el.rawAttrsMap['v-for']
      );
    }
  }
}



function parseFor (exp) {
  var inMatch = exp.match(forAliasRE);
  if (!inMatch) { return }
  var res = {};
  res.for = inMatch[2].trim();
  var alias = inMatch[1].trim().replace(stripParensRE, '');
  var iteratorMatch = alias.match(forIteratorRE);
  if (iteratorMatch) {
    res.alias = alias.replace(forIteratorRE, '').trim();
    res.iterator1 = iteratorMatch[1].trim();
    if (iteratorMatch[2]) {
      res.iterator2 = iteratorMatch[2].trim();
    }
  } else {
    res.alias = alias;
  }
  return res
}

function processIf (el) {
  var exp = getAndRemoveAttr(el, 'v-if');
  if (exp) {
    el.if = exp;
    addIfCondition(el, {
      exp: exp,
      block: el
    });
  } else {
    if (getAndRemoveAttr(el, 'v-else') != null) {
      el.else = true;
    }
    var elseif = getAndRemoveAttr(el, 'v-else-if');
    if (elseif) {
      el.elseif = elseif;
    }
  }
}

function processIfConditions (el, parent) {
  var prev = findPrevElement(parent.children);
  if (prev && prev.if) {
    addIfCondition(prev, {
      exp: el.elseif,
      block: el
    });
  } else if (false) {
    warn$2(
      "v-" + (el.elseif ? ('else-if="' + el.elseif + '"') : 'else') + " " +
      "used on element <" + (el.tag) + "> without corresponding v-if.",
      el.rawAttrsMap[el.elseif ? 'v-else-if' : 'v-else']
    );
  }
}

function findPrevElement (children) {
  var i = children.length;
  while (i--) {
    if (children[i].type === 1) {
      return children[i]
    } else {
      if (false) {
        warn$2(
          "text \"" + (children[i].text.trim()) + "\" between v-if and v-else(-if) " +
          "will be ignored.",
          children[i]
        );
      }
      children.pop();
    }
  }
}

function addIfCondition (el, condition) {
  if (!el.ifConditions) {
    el.ifConditions = [];
  }
  el.ifConditions.push(condition);
}

function processOnce (el) {
  var once$$1 = getAndRemoveAttr(el, 'v-once');
  if (once$$1 != null) {
    el.once = true;
  }
}

// handle content being passed to a component as slot,
// e.g. <template slot="xxx">, <div slot-scope="xxx">
function processSlotContent (el) {
  var slotScope;
  if (el.tag === 'template') {
    slotScope = getAndRemoveAttr(el, 'scope');
    /* istanbul ignore if */
    if (false) {
      warn$2(
        "the \"scope\" attribute for scoped slots have been deprecated and " +
        "replaced by \"slot-scope\" since 2.5. The new \"slot-scope\" attribute " +
        "can also be used on plain elements in addition to <template> to " +
        "denote scoped slots.",
        el.rawAttrsMap['scope'],
        true
      );
    }
    el.slotScope = slotScope || getAndRemoveAttr(el, 'slot-scope');
  } else if ((slotScope = getAndRemoveAttr(el, 'slot-scope'))) {
    /* istanbul ignore if */
    if (false) {
      warn$2(
        "Ambiguous combined usage of slot-scope and v-for on <" + (el.tag) + "> " +
        "(v-for takes higher priority). Use a wrapper <template> for the " +
        "scoped slot to make it clearer.",
        el.rawAttrsMap['slot-scope'],
        true
      );
    }
    el.slotScope = slotScope;
  }

  // slot="xxx"
  var slotTarget = getBindingAttr(el, 'slot');
  if (slotTarget) {
    el.slotTarget = slotTarget === '""' ? '"default"' : slotTarget;
    el.slotTargetDynamic = !!(el.attrsMap[':slot'] || el.attrsMap['v-bind:slot']);
    // preserve slot as an attribute for native shadow DOM compat
    // only for non-scoped slots.
    if (el.tag !== 'template' && !el.slotScope) {
      addAttr(el, 'slot', slotTarget, getRawBindingAttr(el, 'slot'));
    }
  }

  // 2.6 v-slot syntax
  {
    if (el.tag === 'template') {
      // v-slot on <template>
      var slotBinding = getAndRemoveAttrByRegex(el, slotRE);
      if (slotBinding) {
        if (false) {
          if (el.slotTarget || el.slotScope) {
            warn$2(
              "Unexpected mixed usage of different slot syntaxes.",
              el
            );
          }
          if (el.parent && !maybeComponent(el.parent)) {
            warn$2(
              "<template v-slot> can only appear at the root level inside " +
              "the receiving component",
              el
            );
          }
        }
        var ref = getSlotName(slotBinding);
        var name = ref.name;
        var dynamic = ref.dynamic;
        el.slotTarget = name;
        el.slotTargetDynamic = dynamic;
        el.slotScope = slotBinding.value || emptySlotScopeToken; // force it into a scoped slot for perf
      }
    } else {
      // v-slot on component, denotes default slot
      var slotBinding$1 = getAndRemoveAttrByRegex(el, slotRE);
      if (slotBinding$1) {
        if (false) {
          if (!maybeComponent(el)) {
            warn$2(
              "v-slot can only be used on components or <template>.",
              slotBinding$1
            );
          }
          if (el.slotScope || el.slotTarget) {
            warn$2(
              "Unexpected mixed usage of different slot syntaxes.",
              el
            );
          }
          if (el.scopedSlots) {
            warn$2(
              "To avoid scope ambiguity, the default slot should also use " +
              "<template> syntax when there are other named slots.",
              slotBinding$1
            );
          }
        }
        // add the component's children to its default slot
        var slots = el.scopedSlots || (el.scopedSlots = {});
        var ref$1 = getSlotName(slotBinding$1);
        var name$1 = ref$1.name;
        var dynamic$1 = ref$1.dynamic;
        var slotContainer = slots[name$1] = createASTElement('template', [], el);
        slotContainer.slotTarget = name$1;
        slotContainer.slotTargetDynamic = dynamic$1;
        slotContainer.children = el.children.filter(function (c) {
          if (!c.slotScope) {
            c.parent = slotContainer;
            return true
          }
        });
        slotContainer.slotScope = slotBinding$1.value || emptySlotScopeToken;
        // remove children as they are returned from scopedSlots now
        el.children = [];
        // mark el non-plain so data gets generated
        el.plain = false;
      }
    }
  }
}

function getSlotName (binding) {
  var name = binding.name.replace(slotRE, '');
  if (!name) {
    if (binding.name[0] !== '#') {
      name = 'default';
    } else if (false) {
      warn$2(
        "v-slot shorthand syntax requires a slot name.",
        binding
      );
    }
  }
  return dynamicArgRE.test(name)
    // dynamic [name]
    ? { name: name.slice(1, -1), dynamic: true }
    // static name
    : { name: ("\"" + name + "\""), dynamic: false }
}

// handle <slot/> outlets
function processSlotOutlet (el) {
  if (el.tag === 'slot') {
    el.slotName = getBindingAttr(el, 'name');
    if (false) {
      warn$2(
        "`key` does not work on <slot> because slots are abstract outlets " +
        "and can possibly expand into multiple elements. " +
        "Use the key on a wrapping element instead.",
        getRawBindingAttr(el, 'key')
      );
    }
  }
}

function processComponent (el) {
  var binding;
  if ((binding = getBindingAttr(el, 'is'))) {
    el.component = binding;
  }
  if (getAndRemoveAttr(el, 'inline-template') != null) {
    el.inlineTemplate = true;
  }
}

function processAttrs (el) {
  var list = el.attrsList;
  var i, l, name, rawName, value, modifiers, syncGen, isDynamic;
  for (i = 0, l = list.length; i < l; i++) {
    name = rawName = list[i].name;
    value = list[i].value;
    if (dirRE.test(name)) {
      // mark element as dynamic
      el.hasBindings = true;
      // modifiers
      modifiers = parseModifiers(name.replace(dirRE, ''));
      // support .foo shorthand syntax for the .prop modifier
      if (modifiers) {
        name = name.replace(modifierRE, '');
      }
      if (bindRE.test(name)) { // v-bind
        name = name.replace(bindRE, '');
        value = parseFilters(value);
        isDynamic = dynamicArgRE.test(name);
        if (isDynamic) {
          name = name.slice(1, -1);
        }
        if (
          false
        ) {
          warn$2(
            ("The value for a v-bind expression cannot be empty. Found in \"v-bind:" + name + "\"")
          );
        }
        if (modifiers) {
          if (modifiers.prop && !isDynamic) {
            name = camelize(name);
            if (name === 'innerHtml') { name = 'innerHTML'; }
          }
          if (modifiers.camel && !isDynamic) {
            name = camelize(name);
          }
          if (modifiers.sync) {
            syncGen = genAssignmentCode(value, "$event");
            if (!isDynamic) {
              addHandler(
                el,
                ("update:" + (camelize(name))),
                syncGen,
                null,
                false,
                warn$2,
                list[i]
              );
              if (hyphenate(name) !== camelize(name)) {
                addHandler(
                  el,
                  ("update:" + (hyphenate(name))),
                  syncGen,
                  null,
                  false,
                  warn$2,
                  list[i]
                );
              }
            } else {
              // handler w/ dynamic event name
              addHandler(
                el,
                ("\"update:\"+(" + name + ")"),
                syncGen,
                null,
                false,
                warn$2,
                list[i],
                true // dynamic
              );
            }
          }
        }
        if ((modifiers && modifiers.prop) || (
          !el.component && platformMustUseProp(el.tag, el.attrsMap.type, name)
        )) {
          addProp(el, name, value, list[i], isDynamic);
        } else {
          addAttr(el, name, value, list[i], isDynamic);
        }
      } else if (onRE.test(name)) { // v-on
        name = name.replace(onRE, '');
        isDynamic = dynamicArgRE.test(name);
        if (isDynamic) {
          name = name.slice(1, -1);
        }
        addHandler(el, name, value, modifiers, false, warn$2, list[i], isDynamic);
      } else { // normal directives
        name = name.replace(dirRE, '');
        // parse arg
        var argMatch = name.match(argRE);
        var arg = argMatch && argMatch[1];
        isDynamic = false;
        if (arg) {
          name = name.slice(0, -(arg.length + 1));
          if (dynamicArgRE.test(arg)) {
            arg = arg.slice(1, -1);
            isDynamic = true;
          }
        }
        addDirective(el, name, rawName, value, arg, isDynamic, modifiers, list[i]);
        if (false) {
          checkForAliasModel(el, value);
        }
      }
    } else {
      // literal attribute
      if (false) {
        var res = parseText(value, delimiters);
        if (res) {
          warn$2(
            name + "=\"" + value + "\": " +
            'Interpolation inside attributes has been removed. ' +
            'Use v-bind or the colon shorthand instead. For example, ' +
            'instead of <div id="{{ val }}">, use <div :id="val">.',
            list[i]
          );
        }
      }
      addAttr(el, name, JSON.stringify(value), list[i]);
      // #6887 firefox doesn't update muted state if set via attribute
      // even immediately after element creation
      if (!el.component &&
          name === 'muted' &&
          platformMustUseProp(el.tag, el.attrsMap.type, name)) {
        addProp(el, name, 'true', list[i]);
      }
    }
  }
}

function checkInFor (el) {
  var parent = el;
  while (parent) {
    if (parent.for !== undefined) {
      return true
    }
    parent = parent.parent;
  }
  return false
}

function parseModifiers (name) {
  var match = name.match(modifierRE);
  if (match) {
    var ret = {};
    match.forEach(function (m) { ret[m.slice(1)] = true; });
    return ret
  }
}

function makeAttrsMap (attrs) {
  var map = {};
  for (var i = 0, l = attrs.length; i < l; i++) {
    if (
      false
    ) {
      warn$2('duplicate attribute: ' + attrs[i].name, attrs[i]);
    }
    map[attrs[i].name] = attrs[i].value;
  }
  return map
}

// for script (e.g. type="x/template") or style, do not decode content
function isTextTag (el) {
  return el.tag === 'script' || el.tag === 'style'
}

function isForbiddenTag (el) {
  return (
    el.tag === 'style' ||
    (el.tag === 'script' && (
      !el.attrsMap.type ||
      el.attrsMap.type === 'text/javascript'
    ))
  )
}

var ieNSBug = /^xmlns:NS\d+/;
var ieNSPrefix = /^NS\d+:/;

/* istanbul ignore next */
function guardIESVGBug (attrs) {
  var res = [];
  for (var i = 0; i < attrs.length; i++) {
    var attr = attrs[i];
    if (!ieNSBug.test(attr.name)) {
      attr.name = attr.name.replace(ieNSPrefix, '');
      res.push(attr);
    }
  }
  return res
}

function checkForAliasModel (el, value) {
  var _el = el;
  while (_el) {
    if (_el.for && _el.alias === value) {
      warn$2(
        "<" + (el.tag) + " v-model=\"" + value + "\">: " +
        "You are binding v-model directly to a v-for iteration alias. " +
        "This will not be able to modify the v-for source array because " +
        "writing to the alias is like modifying a function local variable. " +
        "Consider using an array of objects and use v-model on an object property instead.",
        el.rawAttrsMap['v-model']
      );
    }
    _el = _el.parent;
  }
}

/*  */

function preTransformNode (el, options) {
  if (el.tag === 'input') {
    var map = el.attrsMap;
    if (!map['v-model']) {
      return
    }

    var typeBinding;
    if (map[':type'] || map['v-bind:type']) {
      typeBinding = getBindingAttr(el, 'type');
    }
    if (!map.type && !typeBinding && map['v-bind']) {
      typeBinding = "(" + (map['v-bind']) + ").type";
    }

    if (typeBinding) {
      var ifCondition = getAndRemoveAttr(el, 'v-if', true);
      var ifConditionExtra = ifCondition ? ("&&(" + ifCondition + ")") : "";
      var hasElse = getAndRemoveAttr(el, 'v-else', true) != null;
      var elseIfCondition = getAndRemoveAttr(el, 'v-else-if', true);
      // 1. checkbox
      var branch0 = cloneASTElement(el);
      // process for on the main node
      processFor(branch0);
      addRawAttr(branch0, 'type', 'checkbox');
      processElement(branch0, options);
      branch0.processed = true; // prevent it from double-processed
      branch0.if = "(" + typeBinding + ")==='checkbox'" + ifConditionExtra;
      addIfCondition(branch0, {
        exp: branch0.if,
        block: branch0
      });
      // 2. add radio else-if condition
      var branch1 = cloneASTElement(el);
      getAndRemoveAttr(branch1, 'v-for', true);
      addRawAttr(branch1, 'type', 'radio');
      processElement(branch1, options);
      addIfCondition(branch0, {
        exp: "(" + typeBinding + ")==='radio'" + ifConditionExtra,
        block: branch1
      });
      // 3. other
      var branch2 = cloneASTElement(el);
      getAndRemoveAttr(branch2, 'v-for', true);
      addRawAttr(branch2, ':type', typeBinding);
      processElement(branch2, options);
      addIfCondition(branch0, {
        exp: ifCondition,
        block: branch2
      });

      if (hasElse) {
        branch0.else = true;
      } else if (elseIfCondition) {
        branch0.elseif = elseIfCondition;
      }

      return branch0
    }
  }
}

function cloneASTElement (el) {
  return createASTElement(el.tag, el.attrsList.slice(), el.parent)
}

var model$1 = {
  preTransformNode: preTransformNode
};

var modules$1 = [
  klass$1,
  style$1,
  model$1
];

/*  */

function text (el, dir) {
  if (dir.value) {
    addProp(el, 'textContent', ("_s(" + (dir.value) + ")"), dir);
  }
}

/*  */

function html (el, dir) {
  if (dir.value) {
    addProp(el, 'innerHTML', ("_s(" + (dir.value) + ")"), dir);
  }
}

var directives$1 = {
  model: model,
  text: text,
  html: html
};

/*  */

var baseOptions = {
  expectHTML: true,
  modules: modules$1,
  directives: directives$1,
  isPreTag: isPreTag,
  isUnaryTag: isUnaryTag,
  mustUseProp: mustUseProp,
  canBeLeftOpenTag: canBeLeftOpenTag,
  isReservedTag: isReservedTag,
  getTagNamespace: getTagNamespace,
  staticKeys: genStaticKeys(modules$1)
};

/*  */

var isStaticKey;
var isPlatformReservedTag;

var genStaticKeysCached = cached(genStaticKeys$1);

/**
 * Goal of the optimizer: walk the generated template AST tree
 * and detect sub-trees that are purely static, i.e. parts of
 * the DOM that never needs to change.
 *
 * Once we detect these sub-trees, we can:
 *
 * 1. Hoist them into constants, so that we no longer need to
 *    create fresh nodes for them on each re-render;
 * 2. Completely skip them in the patching process.
 */
function optimize (root, options) {
  if (!root) { return }
  isStaticKey = genStaticKeysCached(options.staticKeys || '');
  isPlatformReservedTag = options.isReservedTag || no;
  // first pass: mark all non-static nodes.
  markStatic$1(root);
  // second pass: mark static roots.
  markStaticRoots(root, false);
}

function genStaticKeys$1 (keys) {
  return makeMap(
    'type,tag,attrsList,attrsMap,plain,parent,children,attrs,start,end,rawAttrsMap' +
    (keys ? ',' + keys : '')
  )
}

function markStatic$1 (node) {
  node.static = isStatic(node);
  if (node.type === 1) {
    // do not make component slot content static. this avoids
    // 1. components not able to mutate slot nodes
    // 2. static slot content fails for hot-reloading
    if (
      !isPlatformReservedTag(node.tag) &&
      node.tag !== 'slot' &&
      node.attrsMap['inline-template'] == null
    ) {
      return
    }
    for (var i = 0, l = node.children.length; i < l; i++) {
      var child = node.children[i];
      markStatic$1(child);
      if (!child.static) {
        node.static = false;
      }
    }
    if (node.ifConditions) {
      for (var i$1 = 1, l$1 = node.ifConditions.length; i$1 < l$1; i$1++) {
        var block = node.ifConditions[i$1].block;
        markStatic$1(block);
        if (!block.static) {
          node.static = false;
        }
      }
    }
  }
}

function markStaticRoots (node, isInFor) {
  if (node.type === 1) {
    if (node.static || node.once) {
      node.staticInFor = isInFor;
    }
    // For a node to qualify as a static root, it should have children that
    // are not just static text. Otherwise the cost of hoisting out will
    // outweigh the benefits and it's better off to just always render it fresh.
    if (node.static && node.children.length && !(
      node.children.length === 1 &&
      node.children[0].type === 3
    )) {
      node.staticRoot = true;
      return
    } else {
      node.staticRoot = false;
    }
    if (node.children) {
      for (var i = 0, l = node.children.length; i < l; i++) {
        markStaticRoots(node.children[i], isInFor || !!node.for);
      }
    }
    if (node.ifConditions) {
      for (var i$1 = 1, l$1 = node.ifConditions.length; i$1 < l$1; i$1++) {
        markStaticRoots(node.ifConditions[i$1].block, isInFor);
      }
    }
  }
}

function isStatic (node) {
  if (node.type === 2) { // expression
    return false
  }
  if (node.type === 3) { // text
    return true
  }
  return !!(node.pre || (
    !node.hasBindings && // no dynamic bindings
    !node.if && !node.for && // not v-if or v-for or v-else
    !isBuiltInTag(node.tag) && // not a built-in
    isPlatformReservedTag(node.tag) && // not a component
    !isDirectChildOfTemplateFor(node) &&
    Object.keys(node).every(isStaticKey)
  ))
}

function isDirectChildOfTemplateFor (node) {
  while (node.parent) {
    node = node.parent;
    if (node.tag !== 'template') {
      return false
    }
    if (node.for) {
      return true
    }
  }
  return false
}

/*  */

var fnExpRE = /^([\w$_]+|\([^)]*?\))\s*=>|^function(?:\s+[\w$]+)?\s*\(/;
var fnInvokeRE = /\([^)]*?\);*$/;
var simplePathRE = /^[A-Za-z_$][\w$]*(?:\.[A-Za-z_$][\w$]*|\['[^']*?']|\["[^"]*?"]|\[\d+]|\[[A-Za-z_$][\w$]*])*$/;

// KeyboardEvent.keyCode aliases
var keyCodes = {
  esc: 27,
  tab: 9,
  enter: 13,
  space: 32,
  up: 38,
  left: 37,
  right: 39,
  down: 40,
  'delete': [8, 46]
};

// KeyboardEvent.key aliases
var keyNames = {
  // #7880: IE11 and Edge use `Esc` for Escape key name.
  esc: ['Esc', 'Escape'],
  tab: 'Tab',
  enter: 'Enter',
  // #9112: IE11 uses `Spacebar` for Space key name.
  space: [' ', 'Spacebar'],
  // #7806: IE11 uses key names without `Arrow` prefix for arrow keys.
  up: ['Up', 'ArrowUp'],
  left: ['Left', 'ArrowLeft'],
  right: ['Right', 'ArrowRight'],
  down: ['Down', 'ArrowDown'],
  // #9112: IE11 uses `Del` for Delete key name.
  'delete': ['Backspace', 'Delete', 'Del']
};

// #4868: modifiers that prevent the execution of the listener
// need to explicitly return null so that we can determine whether to remove
// the listener for .once
var genGuard = function (condition) { return ("if(" + condition + ")return null;"); };

var modifierCode = {
  stop: '$event.stopPropagation();',
  prevent: '$event.preventDefault();',
  self: genGuard("$event.target !== $event.currentTarget"),
  ctrl: genGuard("!$event.ctrlKey"),
  shift: genGuard("!$event.shiftKey"),
  alt: genGuard("!$event.altKey"),
  meta: genGuard("!$event.metaKey"),
  left: genGuard("'button' in $event && $event.button !== 0"),
  middle: genGuard("'button' in $event && $event.button !== 1"),
  right: genGuard("'button' in $event && $event.button !== 2")
};

function genHandlers (
  events,
  isNative
) {
  var prefix = isNative ? 'nativeOn:' : 'on:';
  var staticHandlers = "";
  var dynamicHandlers = "";
  for (var name in events) {
    var handlerCode = genHandler(events[name]);
    if (events[name] && events[name].dynamic) {
      dynamicHandlers += name + "," + handlerCode + ",";
    } else {
      staticHandlers += "\"" + name + "\":" + handlerCode + ",";
    }
  }
  staticHandlers = "{" + (staticHandlers.slice(0, -1)) + "}";
  if (dynamicHandlers) {
    return prefix + "_d(" + staticHandlers + ",[" + (dynamicHandlers.slice(0, -1)) + "])"
  } else {
    return prefix + staticHandlers
  }
}

function genHandler (handler) {
  if (!handler) {
    return 'function(){}'
  }

  if (Array.isArray(handler)) {
    return ("[" + (handler.map(function (handler) { return genHandler(handler); }).join(',')) + "]")
  }

  var isMethodPath = simplePathRE.test(handler.value);
  var isFunctionExpression = fnExpRE.test(handler.value);
  var isFunctionInvocation = simplePathRE.test(handler.value.replace(fnInvokeRE, ''));

  if (!handler.modifiers) {
    if (isMethodPath || isFunctionExpression) {
      return handler.value
    }
    return ("function($event){" + (isFunctionInvocation ? ("return " + (handler.value)) : handler.value) + "}") // inline statement
  } else {
    var code = '';
    var genModifierCode = '';
    var keys = [];
    for (var key in handler.modifiers) {
      if (modifierCode[key]) {
        genModifierCode += modifierCode[key];
        // left/right
        if (keyCodes[key]) {
          keys.push(key);
        }
      } else if (key === 'exact') {
        var modifiers = (handler.modifiers);
        genModifierCode += genGuard(
          ['ctrl', 'shift', 'alt', 'meta']
            .filter(function (keyModifier) { return !modifiers[keyModifier]; })
            .map(function (keyModifier) { return ("$event." + keyModifier + "Key"); })
            .join('||')
        );
      } else {
        keys.push(key);
      }
    }
    if (keys.length) {
      code += genKeyFilter(keys);
    }
    // Make sure modifiers like prevent and stop get executed after key filtering
    if (genModifierCode) {
      code += genModifierCode;
    }
    var handlerCode = isMethodPath
      ? ("return " + (handler.value) + "($event)")
      : isFunctionExpression
        ? ("return (" + (handler.value) + ")($event)")
        : isFunctionInvocation
          ? ("return " + (handler.value))
          : handler.value;
    return ("function($event){" + code + handlerCode + "}")
  }
}

function genKeyFilter (keys) {
  return (
    // make sure the key filters only apply to KeyboardEvents
    // #9441: can't use 'keyCode' in $event because Chrome autofill fires fake
    // key events that do not have keyCode property...
    "if(!$event.type.indexOf('key')&&" +
    (keys.map(genFilterCode).join('&&')) + ")return null;"
  )
}

function genFilterCode (key) {
  var keyVal = parseInt(key, 10);
  if (keyVal) {
    return ("$event.keyCode!==" + keyVal)
  }
  var keyCode = keyCodes[key];
  var keyName = keyNames[key];
  return (
    "_k($event.keyCode," +
    (JSON.stringify(key)) + "," +
    (JSON.stringify(keyCode)) + "," +
    "$event.key," +
    "" + (JSON.stringify(keyName)) +
    ")"
  )
}

/*  */

function on (el, dir) {
  if (false) {
    warn("v-on without argument does not support modifiers.");
  }
  el.wrapListeners = function (code) { return ("_g(" + code + "," + (dir.value) + ")"); };
}

/*  */

function bind$1 (el, dir) {
  el.wrapData = function (code) {
    return ("_b(" + code + ",'" + (el.tag) + "'," + (dir.value) + "," + (dir.modifiers && dir.modifiers.prop ? 'true' : 'false') + (dir.modifiers && dir.modifiers.sync ? ',true' : '') + ")")
  };
}

/*  */

var baseDirectives = {
  on: on,
  bind: bind$1,
  cloak: noop
};

/*  */





var CodegenState = function CodegenState (options) {
  this.options = options;
  this.warn = options.warn || baseWarn;
  this.transforms = pluckModuleFunction(options.modules, 'transformCode');
  this.dataGenFns = pluckModuleFunction(options.modules, 'genData');
  this.directives = extend(extend({}, baseDirectives), options.directives);
  var isReservedTag = options.isReservedTag || no;
  this.maybeComponent = function (el) { return !!el.component || !isReservedTag(el.tag); };
  this.onceId = 0;
  this.staticRenderFns = [];
  this.pre = false;
};



function generate (
  ast,
  options
) {
  var state = new CodegenState(options);
  var code = ast ? genElement(ast, state) : '_c("div")';
  return {
    render: ("with(this){return " + code + "}"),
    staticRenderFns: state.staticRenderFns
  }
}

function genElement (el, state) {
  if (el.parent) {
    el.pre = el.pre || el.parent.pre;
  }

  if (el.staticRoot && !el.staticProcessed) {
    return genStatic(el, state)
  } else if (el.once && !el.onceProcessed) {
    return genOnce(el, state)
  } else if (el.for && !el.forProcessed) {
    return genFor(el, state)
  } else if (el.if && !el.ifProcessed) {
    return genIf(el, state)
  } else if (el.tag === 'template' && !el.slotTarget && !state.pre) {
    return genChildren(el, state) || 'void 0'
  } else if (el.tag === 'slot') {
    return genSlot(el, state)
  } else {
    // component or element
    var code;
    if (el.component) {
      code = genComponent(el.component, el, state);
    } else {
      var data;
      if (!el.plain || (el.pre && state.maybeComponent(el))) {
        data = genData$2(el, state);
      }

      var children = el.inlineTemplate ? null : genChildren(el, state, true);
      code = "_c('" + (el.tag) + "'" + (data ? ("," + data) : '') + (children ? ("," + children) : '') + ")";
    }
    // module transforms
    for (var i = 0; i < state.transforms.length; i++) {
      code = state.transforms[i](el, code);
    }
    return code
  }
}

// hoist static sub-trees out
function genStatic (el, state) {
  el.staticProcessed = true;
  // Some elements (templates) need to behave differently inside of a v-pre
  // node.  All pre nodes are static roots, so we can use this as a location to
  // wrap a state change and reset it upon exiting the pre node.
  var originalPreState = state.pre;
  if (el.pre) {
    state.pre = el.pre;
  }
  state.staticRenderFns.push(("with(this){return " + (genElement(el, state)) + "}"));
  state.pre = originalPreState;
  return ("_m(" + (state.staticRenderFns.length - 1) + (el.staticInFor ? ',true' : '') + ")")
}

// v-once
function genOnce (el, state) {
  el.onceProcessed = true;
  if (el.if && !el.ifProcessed) {
    return genIf(el, state)
  } else if (el.staticInFor) {
    var key = '';
    var parent = el.parent;
    while (parent) {
      if (parent.for) {
        key = parent.key;
        break
      }
      parent = parent.parent;
    }
    if (!key) {
      "production" !== 'production' && state.warn(
        "v-once can only be used inside v-for that is keyed. ",
        el.rawAttrsMap['v-once']
      );
      return genElement(el, state)
    }
    return ("_o(" + (genElement(el, state)) + "," + (state.onceId++) + "," + key + ")")
  } else {
    return genStatic(el, state)
  }
}

function genIf (
  el,
  state,
  altGen,
  altEmpty
) {
  el.ifProcessed = true; // avoid recursion
  return genIfConditions(el.ifConditions.slice(), state, altGen, altEmpty)
}

function genIfConditions (
  conditions,
  state,
  altGen,
  altEmpty
) {
  if (!conditions.length) {
    return altEmpty || '_e()'
  }

  var condition = conditions.shift();
  if (condition.exp) {
    return ("(" + (condition.exp) + ")?" + (genTernaryExp(condition.block)) + ":" + (genIfConditions(conditions, state, altGen, altEmpty)))
  } else {
    return ("" + (genTernaryExp(condition.block)))
  }

  // v-if with v-once should generate code like (a)?_m(0):_m(1)
  function genTernaryExp (el) {
    return altGen
      ? altGen(el, state)
      : el.once
        ? genOnce(el, state)
        : genElement(el, state)
  }
}

function genFor (
  el,
  state,
  altGen,
  altHelper
) {
  var exp = el.for;
  var alias = el.alias;
  var iterator1 = el.iterator1 ? ("," + (el.iterator1)) : '';
  var iterator2 = el.iterator2 ? ("," + (el.iterator2)) : '';

  if (false
  ) {
    state.warn(
      "<" + (el.tag) + " v-for=\"" + alias + " in " + exp + "\">: component lists rendered with " +
      "v-for should have explicit keys. " +
      "See https://vuejs.org/guide/list.html#key for more info.",
      el.rawAttrsMap['v-for'],
      true /* tip */
    );
  }

  el.forProcessed = true; // avoid recursion
  return (altHelper || '_l') + "((" + exp + ")," +
    "function(" + alias + iterator1 + iterator2 + "){" +
      "return " + ((altGen || genElement)(el, state)) +
    '})'
}

function genData$2 (el, state) {
  var data = '{';

  // directives first.
  // directives may mutate the el's other properties before they are generated.
  var dirs = genDirectives(el, state);
  if (dirs) { data += dirs + ','; }

  // key
  if (el.key) {
    data += "key:" + (el.key) + ",";
  }
  // ref
  if (el.ref) {
    data += "ref:" + (el.ref) + ",";
  }
  if (el.refInFor) {
    data += "refInFor:true,";
  }
  // pre
  if (el.pre) {
    data += "pre:true,";
  }
  // record original tag name for components using "is" attribute
  if (el.component) {
    data += "tag:\"" + (el.tag) + "\",";
  }
  // module data generation functions
  for (var i = 0; i < state.dataGenFns.length; i++) {
    data += state.dataGenFns[i](el);
  }
  // attributes
  if (el.attrs) {
    data += "attrs:" + (genProps(el.attrs)) + ",";
  }
  // DOM props
  if (el.props) {
    data += "domProps:" + (genProps(el.props)) + ",";
  }
  // event handlers
  if (el.events) {
    data += (genHandlers(el.events, false)) + ",";
  }
  if (el.nativeEvents) {
    data += (genHandlers(el.nativeEvents, true)) + ",";
  }
  // slot target
  // only for non-scoped slots
  if (el.slotTarget && !el.slotScope) {
    data += "slot:" + (el.slotTarget) + ",";
  }
  // scoped slots
  if (el.scopedSlots) {
    data += (genScopedSlots(el, el.scopedSlots, state)) + ",";
  }
  // component v-model
  if (el.model) {
    data += "model:{value:" + (el.model.value) + ",callback:" + (el.model.callback) + ",expression:" + (el.model.expression) + "},";
  }
  // inline-template
  if (el.inlineTemplate) {
    var inlineTemplate = genInlineTemplate(el, state);
    if (inlineTemplate) {
      data += inlineTemplate + ",";
    }
  }
  data = data.replace(/,$/, '') + '}';
  // v-bind dynamic argument wrap
  // v-bind with dynamic arguments must be applied using the same v-bind object
  // merge helper so that class/style/mustUseProp attrs are handled correctly.
  if (el.dynamicAttrs) {
    data = "_b(" + data + ",\"" + (el.tag) + "\"," + (genProps(el.dynamicAttrs)) + ")";
  }
  // v-bind data wrap
  if (el.wrapData) {
    data = el.wrapData(data);
  }
  // v-on data wrap
  if (el.wrapListeners) {
    data = el.wrapListeners(data);
  }
  return data
}

function genDirectives (el, state) {
  var dirs = el.directives;
  if (!dirs) { return }
  var res = 'directives:[';
  var hasRuntime = false;
  var i, l, dir, needRuntime;
  for (i = 0, l = dirs.length; i < l; i++) {
    dir = dirs[i];
    needRuntime = true;
    var gen = state.directives[dir.name];
    if (gen) {
      // compile-time directive that manipulates AST.
      // returns true if it also needs a runtime counterpart.
      needRuntime = !!gen(el, dir, state.warn);
    }
    if (needRuntime) {
      hasRuntime = true;
      res += "{name:\"" + (dir.name) + "\",rawName:\"" + (dir.rawName) + "\"" + (dir.value ? (",value:(" + (dir.value) + "),expression:" + (JSON.stringify(dir.value))) : '') + (dir.arg ? (",arg:" + (dir.isDynamicArg ? dir.arg : ("\"" + (dir.arg) + "\""))) : '') + (dir.modifiers ? (",modifiers:" + (JSON.stringify(dir.modifiers))) : '') + "},";
    }
  }
  if (hasRuntime) {
    return res.slice(0, -1) + ']'
  }
}

function genInlineTemplate (el, state) {
  var ast = el.children[0];
  if (false) {
    state.warn(
      'Inline-template components must have exactly one child element.',
      { start: el.start }
    );
  }
  if (ast && ast.type === 1) {
    var inlineRenderFns = generate(ast, state.options);
    return ("inlineTemplate:{render:function(){" + (inlineRenderFns.render) + "},staticRenderFns:[" + (inlineRenderFns.staticRenderFns.map(function (code) { return ("function(){" + code + "}"); }).join(',')) + "]}")
  }
}

function genScopedSlots (
  el,
  slots,
  state
) {
  // by default scoped slots are considered "stable", this allows child
  // components with only scoped slots to skip forced updates from parent.
  // but in some cases we have to bail-out of this optimization
  // for example if the slot contains dynamic names, has v-if or v-for on them...
  var needsForceUpdate = el.for || Object.keys(slots).some(function (key) {
    var slot = slots[key];
    return (
      slot.slotTargetDynamic ||
      slot.if ||
      slot.for ||
      containsSlotChild(slot) // is passing down slot from parent which may be dynamic
    )
  });

  // #9534: if a component with scoped slots is inside a conditional branch,
  // it's possible for the same component to be reused but with different
  // compiled slot content. To avoid that, we generate a unique key based on
  // the generated code of all the slot contents.
  var needsKey = !!el.if;

  // OR when it is inside another scoped slot or v-for (the reactivity may be
  // disconnected due to the intermediate scope variable)
  // #9438, #9506
  // TODO: this can be further optimized by properly analyzing in-scope bindings
  // and skip force updating ones that do not actually use scope variables.
  if (!needsForceUpdate) {
    var parent = el.parent;
    while (parent) {
      if (
        (parent.slotScope && parent.slotScope !== emptySlotScopeToken) ||
        parent.for
      ) {
        needsForceUpdate = true;
        break
      }
      if (parent.if) {
        needsKey = true;
      }
      parent = parent.parent;
    }
  }

  var generatedSlots = Object.keys(slots)
    .map(function (key) { return genScopedSlot(slots[key], state); })
    .join(',');

  return ("scopedSlots:_u([" + generatedSlots + "]" + (needsForceUpdate ? ",null,true" : "") + (!needsForceUpdate && needsKey ? (",null,false," + (hash(generatedSlots))) : "") + ")")
}

function hash(str) {
  var hash = 5381;
  var i = str.length;
  while(i) {
    hash = (hash * 33) ^ str.charCodeAt(--i);
  }
  return hash >>> 0
}

function containsSlotChild (el) {
  if (el.type === 1) {
    if (el.tag === 'slot') {
      return true
    }
    return el.children.some(containsSlotChild)
  }
  return false
}

function genScopedSlot (
  el,
  state
) {
  var isLegacySyntax = el.attrsMap['slot-scope'];
  if (el.if && !el.ifProcessed && !isLegacySyntax) {
    return genIf(el, state, genScopedSlot, "null")
  }
  if (el.for && !el.forProcessed) {
    return genFor(el, state, genScopedSlot)
  }
  var slotScope = el.slotScope === emptySlotScopeToken
    ? ""
    : String(el.slotScope);
  var fn = "function(" + slotScope + "){" +
    "return " + (el.tag === 'template'
      ? el.if && isLegacySyntax
        ? ("(" + (el.if) + ")?" + (genChildren(el, state) || 'undefined') + ":undefined")
        : genChildren(el, state) || 'undefined'
      : genElement(el, state)) + "}";
  // reverse proxy v-slot without scope on this.$slots
  var reverseProxy = slotScope ? "" : ",proxy:true";
  return ("{key:" + (el.slotTarget || "\"default\"") + ",fn:" + fn + reverseProxy + "}")
}

function genChildren (
  el,
  state,
  checkSkip,
  altGenElement,
  altGenNode
) {
  var children = el.children;
  if (children.length) {
    var el$1 = children[0];
    // optimize single v-for
    if (children.length === 1 &&
      el$1.for &&
      el$1.tag !== 'template' &&
      el$1.tag !== 'slot'
    ) {
      var normalizationType = checkSkip
        ? state.maybeComponent(el$1) ? ",1" : ",0"
        : "";
      return ("" + ((altGenElement || genElement)(el$1, state)) + normalizationType)
    }
    var normalizationType$1 = checkSkip
      ? getNormalizationType(children, state.maybeComponent)
      : 0;
    var gen = altGenNode || genNode;
    return ("[" + (children.map(function (c) { return gen(c, state); }).join(',')) + "]" + (normalizationType$1 ? ("," + normalizationType$1) : ''))
  }
}

// determine the normalization needed for the children array.
// 0: no normalization needed
// 1: simple normalization needed (possible 1-level deep nested array)
// 2: full normalization needed
function getNormalizationType (
  children,
  maybeComponent
) {
  var res = 0;
  for (var i = 0; i < children.length; i++) {
    var el = children[i];
    if (el.type !== 1) {
      continue
    }
    if (needsNormalization(el) ||
        (el.ifConditions && el.ifConditions.some(function (c) { return needsNormalization(c.block); }))) {
      res = 2;
      break
    }
    if (maybeComponent(el) ||
        (el.ifConditions && el.ifConditions.some(function (c) { return maybeComponent(c.block); }))) {
      res = 1;
    }
  }
  return res
}

function needsNormalization (el) {
  return el.for !== undefined || el.tag === 'template' || el.tag === 'slot'
}

function genNode (node, state) {
  if (node.type === 1) {
    return genElement(node, state)
  } else if (node.type === 3 && node.isComment) {
    return genComment(node)
  } else {
    return genText(node)
  }
}

function genText (text) {
  return ("_v(" + (text.type === 2
    ? text.expression // no need for () because already wrapped in _s()
    : transformSpecialNewlines(JSON.stringify(text.text))) + ")")
}

function genComment (comment) {
  return ("_e(" + (JSON.stringify(comment.text)) + ")")
}

function genSlot (el, state) {
  var slotName = el.slotName || '"default"';
  var children = genChildren(el, state);
  var res = "_t(" + slotName + (children ? ("," + children) : '');
  var attrs = el.attrs || el.dynamicAttrs
    ? genProps((el.attrs || []).concat(el.dynamicAttrs || []).map(function (attr) { return ({
        // slot props are camelized
        name: camelize(attr.name),
        value: attr.value,
        dynamic: attr.dynamic
      }); }))
    : null;
  var bind$$1 = el.attrsMap['v-bind'];
  if ((attrs || bind$$1) && !children) {
    res += ",null";
  }
  if (attrs) {
    res += "," + attrs;
  }
  if (bind$$1) {
    res += (attrs ? '' : ',null') + "," + bind$$1;
  }
  return res + ')'
}

// componentName is el.component, take it as argument to shun flow's pessimistic refinement
function genComponent (
  componentName,
  el,
  state
) {
  var children = el.inlineTemplate ? null : genChildren(el, state, true);
  return ("_c(" + componentName + "," + (genData$2(el, state)) + (children ? ("," + children) : '') + ")")
}

function genProps (props) {
  var staticProps = "";
  var dynamicProps = "";
  for (var i = 0; i < props.length; i++) {
    var prop = props[i];
    var value = transformSpecialNewlines(prop.value);
    if (prop.dynamic) {
      dynamicProps += (prop.name) + "," + value + ",";
    } else {
      staticProps += "\"" + (prop.name) + "\":" + value + ",";
    }
  }
  staticProps = "{" + (staticProps.slice(0, -1)) + "}";
  if (dynamicProps) {
    return ("_d(" + staticProps + ",[" + (dynamicProps.slice(0, -1)) + "])")
  } else {
    return staticProps
  }
}

// #3895, #4268
function transformSpecialNewlines (text) {
  return text
    .replace(/\u2028/g, '\\u2028')
    .replace(/\u2029/g, '\\u2029')
}

/*  */



// these keywords should not appear inside expressions, but operators like
// typeof, instanceof and in are allowed
var prohibitedKeywordRE = new RegExp('\\b' + (
  'do,if,for,let,new,try,var,case,else,with,await,break,catch,class,const,' +
  'super,throw,while,yield,delete,export,import,return,switch,default,' +
  'extends,finally,continue,debugger,function,arguments'
).split(',').join('\\b|\\b') + '\\b');

// these unary operators should not be used as property/method names
var unaryOperatorsRE = new RegExp('\\b' + (
  'delete,typeof,void'
).split(',').join('\\s*\\([^\\)]*\\)|\\b') + '\\s*\\([^\\)]*\\)');

// strip strings in expressions
var stripStringRE = /'(?:[^'\\]|\\.)*'|"(?:[^"\\]|\\.)*"|`(?:[^`\\]|\\.)*\$\{|\}(?:[^`\\]|\\.)*`|`(?:[^`\\]|\\.)*`/g;

// detect problematic expressions in a template
function detectErrors (ast, warn) {
  if (ast) {
    checkNode(ast, warn);
  }
}

function checkNode (node, warn) {
  if (node.type === 1) {
    for (var name in node.attrsMap) {
      if (dirRE.test(name)) {
        var value = node.attrsMap[name];
        if (value) {
          var range = node.rawAttrsMap[name];
          if (name === 'v-for') {
            checkFor(node, ("v-for=\"" + value + "\""), warn, range);
          } else if (name === 'v-slot' || name[0] === '#') {
            checkFunctionParameterExpression(value, (name + "=\"" + value + "\""), warn, range);
          } else if (onRE.test(name)) {
            checkEvent(value, (name + "=\"" + value + "\""), warn, range);
          } else {
            checkExpression(value, (name + "=\"" + value + "\""), warn, range);
          }
        }
      }
    }
    if (node.children) {
      for (var i = 0; i < node.children.length; i++) {
        checkNode(node.children[i], warn);
      }
    }
  } else if (node.type === 2) {
    checkExpression(node.expression, node.text, warn, node);
  }
}

function checkEvent (exp, text, warn, range) {
  var stripped = exp.replace(stripStringRE, '');
  var keywordMatch = stripped.match(unaryOperatorsRE);
  if (keywordMatch && stripped.charAt(keywordMatch.index - 1) !== '$') {
    warn(
      "avoid using JavaScript unary operator as property name: " +
      "\"" + (keywordMatch[0]) + "\" in expression " + (text.trim()),
      range
    );
  }
  checkExpression(exp, text, warn, range);
}

function checkFor (node, text, warn, range) {
  checkExpression(node.for || '', text, warn, range);
  checkIdentifier(node.alias, 'v-for alias', text, warn, range);
  checkIdentifier(node.iterator1, 'v-for iterator', text, warn, range);
  checkIdentifier(node.iterator2, 'v-for iterator', text, warn, range);
}

function checkIdentifier (
  ident,
  type,
  text,
  warn,
  range
) {
  if (typeof ident === 'string') {
    try {
      new Function(("var " + ident + "=_"));
    } catch (e) {
      warn(("invalid " + type + " \"" + ident + "\" in expression: " + (text.trim())), range);
    }
  }
}

function checkExpression (exp, text, warn, range) {
  try {
    new Function(("return " + exp));
  } catch (e) {
    var keywordMatch = exp.replace(stripStringRE, '').match(prohibitedKeywordRE);
    if (keywordMatch) {
      warn(
        "avoid using JavaScript keyword as property name: " +
        "\"" + (keywordMatch[0]) + "\"\n  Raw expression: " + (text.trim()),
        range
      );
    } else {
      warn(
        "invalid expression: " + (e.message) + " in\n\n" +
        "    " + exp + "\n\n" +
        "  Raw expression: " + (text.trim()) + "\n",
        range
      );
    }
  }
}

function checkFunctionParameterExpression (exp, text, warn, range) {
  try {
    new Function(exp, '');
  } catch (e) {
    warn(
      "invalid function parameter expression: " + (e.message) + " in\n\n" +
      "    " + exp + "\n\n" +
      "  Raw expression: " + (text.trim()) + "\n",
      range
    );
  }
}

/*  */

var range = 2;

function generateCodeFrame (
  source,
  start,
  end
) {
  if ( start === void 0 ) start = 0;
  if ( end === void 0 ) end = source.length;

  var lines = source.split(/\r?\n/);
  var count = 0;
  var res = [];
  for (var i = 0; i < lines.length; i++) {
    count += lines[i].length + 1;
    if (count >= start) {
      for (var j = i - range; j <= i + range || end > count; j++) {
        if (j < 0 || j >= lines.length) { continue }
        res.push(("" + (j + 1) + (repeat$1(" ", 3 - String(j + 1).length)) + "|  " + (lines[j])));
        var lineLength = lines[j].length;
        if (j === i) {
          // push underline
          var pad = start - (count - lineLength) + 1;
          var length = end > count ? lineLength - pad : end - start;
          res.push("   |  " + repeat$1(" ", pad) + repeat$1("^", length));
        } else if (j > i) {
          if (end > count) {
            var length$1 = Math.min(end - count, lineLength);
            res.push("   |  " + repeat$1("^", length$1));
          }
          count += lineLength + 1;
        }
      }
      break
    }
  }
  return res.join('\n')
}

function repeat$1 (str, n) {
  var result = '';
  if (n > 0) {
    while (true) { // eslint-disable-line
      if (n & 1) { result += str; }
      n >>>= 1;
      if (n <= 0) { break }
      str += str;
    }
  }
  return result
}

/*  */



function createFunction (code, errors) {
  try {
    return new Function(code)
  } catch (err) {
    errors.push({ err: err, code: code });
    return noop
  }
}

function createCompileToFunctionFn (compile) {
  var cache = Object.create(null);

  return function compileToFunctions (
    template,
    options,
    vm
  ) {
    options = extend({}, options);
    var warn$$1 = options.warn || warn;
    delete options.warn;

    /* istanbul ignore if */
    if (false) {
      // detect possible CSP restriction
      try {
        new Function('return 1');
      } catch (e) {
        if (e.toString().match(/unsafe-eval|CSP/)) {
          warn$$1(
            'It seems you are using the standalone build of Vue.js in an ' +
            'environment with Content Security Policy that prohibits unsafe-eval. ' +
            'The template compiler cannot work in this environment. Consider ' +
            'relaxing the policy to allow unsafe-eval or pre-compiling your ' +
            'templates into render functions.'
          );
        }
      }
    }

    // check cache
    var key = options.delimiters
      ? String(options.delimiters) + template
      : template;
    if (cache[key]) {
      return cache[key]
    }

    // compile
    var compiled = compile(template, options);

    // check compilation errors/tips
    if (false) {
      if (compiled.errors && compiled.errors.length) {
        if (options.outputSourceRange) {
          compiled.errors.forEach(function (e) {
            warn$$1(
              "Error compiling template:\n\n" + (e.msg) + "\n\n" +
              generateCodeFrame(template, e.start, e.end),
              vm
            );
          });
        } else {
          warn$$1(
            "Error compiling template:\n\n" + template + "\n\n" +
            compiled.errors.map(function (e) { return ("- " + e); }).join('\n') + '\n',
            vm
          );
        }
      }
      if (compiled.tips && compiled.tips.length) {
        if (options.outputSourceRange) {
          compiled.tips.forEach(function (e) { return tip(e.msg, vm); });
        } else {
          compiled.tips.forEach(function (msg) { return tip(msg, vm); });
        }
      }
    }

    // turn code into functions
    var res = {};
    var fnGenErrors = [];
    res.render = createFunction(compiled.render, fnGenErrors);
    res.staticRenderFns = compiled.staticRenderFns.map(function (code) {
      return createFunction(code, fnGenErrors)
    });

    // check function generation errors.
    // this should only happen if there is a bug in the compiler itself.
    // mostly for codegen development use
    /* istanbul ignore if */
    if (false) {
      if ((!compiled.errors || !compiled.errors.length) && fnGenErrors.length) {
        warn$$1(
          "Failed to generate render function:\n\n" +
          fnGenErrors.map(function (ref) {
            var err = ref.err;
            var code = ref.code;

            return ((err.toString()) + " in\n\n" + code + "\n");
        }).join('\n'),
          vm
        );
      }
    }

    return (cache[key] = res)
  }
}

/*  */

function createCompilerCreator (baseCompile) {
  return function createCompiler (baseOptions) {
    function compile (
      template,
      options
    ) {
      var finalOptions = Object.create(baseOptions);
      var errors = [];
      var tips = [];

      var warn = function (msg, range, tip) {
        (tip ? tips : errors).push(msg);
      };

      if (options) {
        if (false) {
          // $flow-disable-line
          var leadingSpaceLength = template.match(/^\s*/)[0].length;

          warn = function (msg, range, tip) {
            var data = { msg: msg };
            if (range) {
              if (range.start != null) {
                data.start = range.start + leadingSpaceLength;
              }
              if (range.end != null) {
                data.end = range.end + leadingSpaceLength;
              }
            }
            (tip ? tips : errors).push(data);
          };
        }
        // merge custom modules
        if (options.modules) {
          finalOptions.modules =
            (baseOptions.modules || []).concat(options.modules);
        }
        // merge custom directives
        if (options.directives) {
          finalOptions.directives = extend(
            Object.create(baseOptions.directives || null),
            options.directives
          );
        }
        // copy other options
        for (var key in options) {
          if (key !== 'modules' && key !== 'directives') {
            finalOptions[key] = options[key];
          }
        }
      }

      finalOptions.warn = warn;

      var compiled = baseCompile(template.trim(), finalOptions);
      if (false) {
        detectErrors(compiled.ast, warn);
      }
      compiled.errors = errors;
      compiled.tips = tips;
      return compiled
    }

    return {
      compile: compile,
      compileToFunctions: createCompileToFunctionFn(compile)
    }
  }
}

/*  */

// `createCompilerCreator` allows creating compilers that use alternative
// parser/optimizer/codegen, e.g the SSR optimizing compiler.
// Here we just export a default compiler using the default parts.
var createCompiler = createCompilerCreator(function baseCompile (
  template,
  options
) {
  var ast = parse(template.trim(), options);
  if (options.optimize !== false) {
    optimize(ast, options);
  }
  var code = generate(ast, options);
  return {
    ast: ast,
    render: code.render,
    staticRenderFns: code.staticRenderFns
  }
});

/*  */

var ref$1 = createCompiler(baseOptions);
var compile = ref$1.compile;
var compileToFunctions = ref$1.compileToFunctions;

/*  */

// check whether current browser encodes a char inside attribute values
var div;
function getShouldDecode (href) {
  div = div || document.createElement('div');
  div.innerHTML = href ? "<a href=\"\n\"/>" : "<div a=\"\n\"/>";
  return div.innerHTML.indexOf('&#10;') > 0
}

// #3663: IE encodes newlines inside attribute values while other browsers don't
var shouldDecodeNewlines = inBrowser ? getShouldDecode(false) : false;
// #6828: chrome encodes content in a[href]
var shouldDecodeNewlinesForHref = inBrowser ? getShouldDecode(true) : false;

/*  */

var idToTemplate = cached(function (id) {
  var el = query(id);
  return el && el.innerHTML
});

var mount = Vue.prototype.$mount;
Vue.prototype.$mount = function (
  el,
  hydrating
) {
  el = el && query(el);

  /* istanbul ignore if */
  if (el === document.body || el === document.documentElement) {
    "production" !== 'production' && warn(
      "Do not mount Vue to <html> or <body> - mount to normal elements instead."
    );
    return this
  }

  var options = this.$options;
  // resolve template/el and convert to render function
  if (!options.render) {
    var template = options.template;
    if (template) {
      if (typeof template === 'string') {
        if (template.charAt(0) === '#') {
          template = idToTemplate(template);
          /* istanbul ignore if */
          if (false) {
            warn(
              ("Template element not found or is empty: " + (options.template)),
              this
            );
          }
        }
      } else if (template.nodeType) {
        template = template.innerHTML;
      } else {
        if (false) {
          warn('invalid template option:' + template, this);
        }
        return this
      }
    } else if (el) {
      template = getOuterHTML(el);
    }
    if (template) {
      /* istanbul ignore if */
      if (false) {
        mark('compile');
      }

      var ref = compileToFunctions(template, {
        outputSourceRange: "production" !== 'production',
        shouldDecodeNewlines: shouldDecodeNewlines,
        shouldDecodeNewlinesForHref: shouldDecodeNewlinesForHref,
        delimiters: options.delimiters,
        comments: options.comments
      }, this);
      var render = ref.render;
      var staticRenderFns = ref.staticRenderFns;
      options.render = render;
      options.staticRenderFns = staticRenderFns;

      /* istanbul ignore if */
      if (false) {
        mark('compile end');
        measure(("vue " + (this._name) + " compile"), 'compile', 'compile end');
      }
    }
  }
  return mount.call(this, el, hydrating)
};

/**
 * Get outerHTML of elements, taking care
 * of SVG elements in IE as well.
 */
function getOuterHTML (el) {
  if (el.outerHTML) {
    return el.outerHTML
  } else {
    var container = document.createElement('div');
    container.appendChild(el.cloneNode(true));
    return container.innerHTML
  }
}

Vue.compile = compileToFunctions;

/* harmony default export */ __webpack_exports__["a"] = (Vue);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4), __webpack_require__(18).setImmediate))

/***/ }),
/* 4 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]());

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(25),
  /* template */
  __webpack_require__(28),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(26),
  /* template */
  __webpack_require__(27),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};


/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

function encode(val) {
  return encodeURIComponent(val).
    replace(/%40/gi, '@').
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */
module.exports = function buildURL(url, params, paramsSerializer) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }

  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];

    utils.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }

      if (utils.isArray(val)) {
        key = key + '[]';
      } else {
        val = [val];
      }

      utils.forEach(val, function parseValue(v) {
        if (utils.isDate(v)) {
          v = v.toISOString();
        } else if (utils.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode(key) + '=' + encode(v));
      });
    });

    serializedParams = parts.join('&');
  }

  if (serializedParams) {
    var hashmarkIndex = url.indexOf('#');
    if (hashmarkIndex !== -1) {
      url = url.slice(0, hashmarkIndex);
    }

    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
};


/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};


/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

var utils = __webpack_require__(1);
var normalizeHeaderName = __webpack_require__(35);

var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};

function setContentTypeIfUnset(headers, value) {
  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}

function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== 'undefined') {
    // For browsers use XHR adapter
    adapter = __webpack_require__(12);
  } else if (typeof process !== 'undefined' && Object.prototype.toString.call(process) === '[object process]') {
    // For node use HTTP adapter
    adapter = __webpack_require__(12);
  }
  return adapter;
}

var defaults = {
  adapter: getDefaultAdapter(),

  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName(headers, 'Accept');
    normalizeHeaderName(headers, 'Content-Type');
    if (utils.isFormData(data) ||
      utils.isArrayBuffer(data) ||
      utils.isBuffer(data) ||
      utils.isStream(data) ||
      utils.isFile(data) ||
      utils.isBlob(data)
    ) {
      return data;
    }
    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
      return data.toString();
    }
    if (utils.isObject(data)) {
      setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
      return JSON.stringify(data);
    }
    return data;
  }],

  transformResponse: [function transformResponse(data) {
    /*eslint no-param-reassign:0*/
    if (typeof data === 'string') {
      try {
        data = JSON.parse(data);
      } catch (e) { /* Ignore */ }
    }
    return data;
  }],

  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  }
};

defaults.headers = {
  common: {
    'Accept': 'application/json, text/plain, */*'
  }
};

utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults.headers[method] = {};
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
});

module.exports = defaults;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);
var settle = __webpack_require__(36);
var buildURL = __webpack_require__(9);
var buildFullPath = __webpack_require__(38);
var parseHeaders = __webpack_require__(41);
var isURLSameOrigin = __webpack_require__(42);
var createError = __webpack_require__(13);

module.exports = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;

    if (utils.isFormData(requestData)) {
      delete requestHeaders['Content-Type']; // Let the browser set it
    }

    var request = new XMLHttpRequest();

    // HTTP basic authentication
    if (config.auth) {
      var username = config.auth.username || '';
      var password = config.auth.password || '';
      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
    }

    var fullPath = buildFullPath(config.baseURL, config.url);
    request.open(config.method.toUpperCase(), buildURL(fullPath, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    // Listen for ready state
    request.onreadystatechange = function handleLoad() {
      if (!request || request.readyState !== 4) {
        return;
      }

      // The request errored out and we didn't get a response, this will be
      // handled by onerror instead
      // With one exception: request that using file: protocol, most browsers
      // will return status as 0 even though it's a successful request
      if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
        return;
      }

      // Prepare the response
      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
      var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
      var response = {
        data: responseData,
        status: request.status,
        statusText: request.statusText,
        headers: responseHeaders,
        config: config,
        request: request
      };

      settle(resolve, reject, response);

      // Clean up request
      request = null;
    };

    // Handle browser request cancellation (as opposed to a manual cancellation)
    request.onabort = function handleAbort() {
      if (!request) {
        return;
      }

      reject(createError('Request aborted', config, 'ECONNABORTED', request));

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(createError('Network Error', config, null, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      var timeoutErrorMessage = 'timeout of ' + config.timeout + 'ms exceeded';
      if (config.timeoutErrorMessage) {
        timeoutErrorMessage = config.timeoutErrorMessage;
      }
      reject(createError(timeoutErrorMessage, config, 'ECONNABORTED',
        request));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if (utils.isStandardBrowserEnv()) {
      var cookies = __webpack_require__(43);

      // Add xsrf header
      var xsrfValue = (config.withCredentials || isURLSameOrigin(fullPath)) && config.xsrfCookieName ?
        cookies.read(config.xsrfCookieName) :
        undefined;

      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    }

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
          // Remove Content-Type if data is undefined
          delete requestHeaders[key];
        } else {
          // Otherwise add header to the request
          request.setRequestHeader(key, val);
        }
      });
    }

    // Add withCredentials to request if needed
    if (!utils.isUndefined(config.withCredentials)) {
      request.withCredentials = !!config.withCredentials;
    }

    // Add responseType to request if needed
    if (config.responseType) {
      try {
        request.responseType = config.responseType;
      } catch (e) {
        // Expected DOMException thrown by browsers not compatible XMLHttpRequest Level 2.
        // But, this can be suppressed for 'json' type as it can be parsed by default 'transformResponse' function.
        if (config.responseType !== 'json') {
          throw e;
        }
      }
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', config.onDownloadProgress);
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', config.onUploadProgress);
    }

    if (config.cancelToken) {
      // Handle cancellation
      config.cancelToken.promise.then(function onCanceled(cancel) {
        if (!request) {
          return;
        }

        request.abort();
        reject(cancel);
        // Clean up request
        request = null;
      });
    }

    if (requestData === undefined) {
      requestData = null;
    }

    // Send the request
    request.send(requestData);
  });
};


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var enhanceError = __webpack_require__(37);

/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */
module.exports = function createError(message, config, code, request, response) {
  var error = new Error(message);
  return enhanceError(error, config, code, request, response);
};


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 * @returns {Object} New object resulting from merging config2 to config1
 */
module.exports = function mergeConfig(config1, config2) {
  // eslint-disable-next-line no-param-reassign
  config2 = config2 || {};
  var config = {};

  var valueFromConfig2Keys = ['url', 'method', 'params', 'data'];
  var mergeDeepPropertiesKeys = ['headers', 'auth', 'proxy'];
  var defaultToConfig2Keys = [
    'baseURL', 'url', 'transformRequest', 'transformResponse', 'paramsSerializer',
    'timeout', 'withCredentials', 'adapter', 'responseType', 'xsrfCookieName',
    'xsrfHeaderName', 'onUploadProgress', 'onDownloadProgress',
    'maxContentLength', 'validateStatus', 'maxRedirects', 'httpAgent',
    'httpsAgent', 'cancelToken', 'socketPath'
  ];

  utils.forEach(valueFromConfig2Keys, function valueFromConfig2(prop) {
    if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    }
  });

  utils.forEach(mergeDeepPropertiesKeys, function mergeDeepProperties(prop) {
    if (utils.isObject(config2[prop])) {
      config[prop] = utils.deepMerge(config1[prop], config2[prop]);
    } else if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    } else if (utils.isObject(config1[prop])) {
      config[prop] = utils.deepMerge(config1[prop]);
    } else if (typeof config1[prop] !== 'undefined') {
      config[prop] = config1[prop];
    }
  });

  utils.forEach(defaultToConfig2Keys, function defaultToConfig2(prop) {
    if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    } else if (typeof config1[prop] !== 'undefined') {
      config[prop] = config1[prop];
    }
  });

  var axiosKeys = valueFromConfig2Keys
    .concat(mergeDeepPropertiesKeys)
    .concat(defaultToConfig2Keys);

  var otherKeys = Object
    .keys(config2)
    .filter(function filterAxiosKeys(key) {
      return axiosKeys.indexOf(key) === -1;
    });

  utils.forEach(otherKeys, function otherKeysDefaultToConfig2(prop) {
    if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    } else if (typeof config1[prop] !== 'undefined') {
      config[prop] = config1[prop];
    }
  });

  return config;
};


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */
function Cancel(message) {
  this.message = message;
}

Cancel.prototype.toString = function toString() {
  return 'Cancel' + (this.message ? ': ' + this.message : '');
};

Cancel.prototype.__CANCEL__ = true;

module.exports = Cancel;


/***/ }),
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuetify__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuetify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuetify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_shortkey__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_shortkey___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_shortkey__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_touch__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_touch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_touch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_resource__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_analytics__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_analytics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_analytics__);
/*jshint esversion: 6 */
/* The Vue build version to load with the `import` command
(runtime-only or standalone) has been set in webpack.base.conf with an alias. */

var path = __webpack_require__(17);










__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_vuetify___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_4_vue_shortkey___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_6_vue_resource__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_5_vue_touch___default.a.config.swipe = {
  direction: 'horizontal',
  threshold: 10,
  velocity: 0.3,
  pointers: 1
};

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_5_vue_touch___default.a, { name: 'v-touch' });

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_7_vue_analytics___default.a, {
  id: ['UA-137347938-1', 'UA-64435914-1'],
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  autoTracking: {
    pageviewTemplate: function pageviewTemplate(route) {
      return {
        page: path.join(window.location.pathname, route.path),
        title: document.title,
        location: window.location.href
      };
    }
  },
  debug: {
    enabled: false
  }
});

var app = new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  data: {},
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_1__App___default.a);
  }
}).$mount('#app');

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {// .dirname, .basename, and .extname methods are extracted from Node.js v8.11.1,
// backported and transplited with Babel, with backwards-compat fixes

// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// resolves . and .. elements in a path array with directory names there
// must be no slashes, empty elements, or device names (c:\) in the array
// (so also no leading and trailing slashes - it does not distinguish
// relative and absolute paths)
function normalizeArray(parts, allowAboveRoot) {
  // if the path tries to go above the root, `up` ends up > 0
  var up = 0;
  for (var i = parts.length - 1; i >= 0; i--) {
    var last = parts[i];
    if (last === '.') {
      parts.splice(i, 1);
    } else if (last === '..') {
      parts.splice(i, 1);
      up++;
    } else if (up) {
      parts.splice(i, 1);
      up--;
    }
  }

  // if the path is allowed to go above the root, restore leading ..s
  if (allowAboveRoot) {
    for (; up--; up) {
      parts.unshift('..');
    }
  }

  return parts;
}

// path.resolve([from ...], to)
// posix version
exports.resolve = function() {
  var resolvedPath = '',
      resolvedAbsolute = false;

  for (var i = arguments.length - 1; i >= -1 && !resolvedAbsolute; i--) {
    var path = (i >= 0) ? arguments[i] : process.cwd();

    // Skip empty and invalid entries
    if (typeof path !== 'string') {
      throw new TypeError('Arguments to path.resolve must be strings');
    } else if (!path) {
      continue;
    }

    resolvedPath = path + '/' + resolvedPath;
    resolvedAbsolute = path.charAt(0) === '/';
  }

  // At this point the path should be resolved to a full absolute path, but
  // handle relative paths to be safe (might happen when process.cwd() fails)

  // Normalize the path
  resolvedPath = normalizeArray(filter(resolvedPath.split('/'), function(p) {
    return !!p;
  }), !resolvedAbsolute).join('/');

  return ((resolvedAbsolute ? '/' : '') + resolvedPath) || '.';
};

// path.normalize(path)
// posix version
exports.normalize = function(path) {
  var isAbsolute = exports.isAbsolute(path),
      trailingSlash = substr(path, -1) === '/';

  // Normalize the path
  path = normalizeArray(filter(path.split('/'), function(p) {
    return !!p;
  }), !isAbsolute).join('/');

  if (!path && !isAbsolute) {
    path = '.';
  }
  if (path && trailingSlash) {
    path += '/';
  }

  return (isAbsolute ? '/' : '') + path;
};

// posix version
exports.isAbsolute = function(path) {
  return path.charAt(0) === '/';
};

// posix version
exports.join = function() {
  var paths = Array.prototype.slice.call(arguments, 0);
  return exports.normalize(filter(paths, function(p, index) {
    if (typeof p !== 'string') {
      throw new TypeError('Arguments to path.join must be strings');
    }
    return p;
  }).join('/'));
};


// path.relative(from, to)
// posix version
exports.relative = function(from, to) {
  from = exports.resolve(from).substr(1);
  to = exports.resolve(to).substr(1);

  function trim(arr) {
    var start = 0;
    for (; start < arr.length; start++) {
      if (arr[start] !== '') break;
    }

    var end = arr.length - 1;
    for (; end >= 0; end--) {
      if (arr[end] !== '') break;
    }

    if (start > end) return [];
    return arr.slice(start, end - start + 1);
  }

  var fromParts = trim(from.split('/'));
  var toParts = trim(to.split('/'));

  var length = Math.min(fromParts.length, toParts.length);
  var samePartsLength = length;
  for (var i = 0; i < length; i++) {
    if (fromParts[i] !== toParts[i]) {
      samePartsLength = i;
      break;
    }
  }

  var outputParts = [];
  for (var i = samePartsLength; i < fromParts.length; i++) {
    outputParts.push('..');
  }

  outputParts = outputParts.concat(toParts.slice(samePartsLength));

  return outputParts.join('/');
};

exports.sep = '/';
exports.delimiter = ':';

exports.dirname = function (path) {
  if (typeof path !== 'string') path = path + '';
  if (path.length === 0) return '.';
  var code = path.charCodeAt(0);
  var hasRoot = code === 47 /*/*/;
  var end = -1;
  var matchedSlash = true;
  for (var i = path.length - 1; i >= 1; --i) {
    code = path.charCodeAt(i);
    if (code === 47 /*/*/) {
        if (!matchedSlash) {
          end = i;
          break;
        }
      } else {
      // We saw the first non-path separator
      matchedSlash = false;
    }
  }

  if (end === -1) return hasRoot ? '/' : '.';
  if (hasRoot && end === 1) {
    // return '//';
    // Backwards-compat fix:
    return '/';
  }
  return path.slice(0, end);
};

function basename(path) {
  if (typeof path !== 'string') path = path + '';

  var start = 0;
  var end = -1;
  var matchedSlash = true;
  var i;

  for (i = path.length - 1; i >= 0; --i) {
    if (path.charCodeAt(i) === 47 /*/*/) {
        // If we reached a path separator that was not part of a set of path
        // separators at the end of the string, stop now
        if (!matchedSlash) {
          start = i + 1;
          break;
        }
      } else if (end === -1) {
      // We saw the first non-path separator, mark this as the end of our
      // path component
      matchedSlash = false;
      end = i + 1;
    }
  }

  if (end === -1) return '';
  return path.slice(start, end);
}

// Uses a mixed approach for backwards-compatibility, as ext behavior changed
// in new Node.js versions, so only basename() above is backported here
exports.basename = function (path, ext) {
  var f = basename(path);
  if (ext && f.substr(-1 * ext.length) === ext) {
    f = f.substr(0, f.length - ext.length);
  }
  return f;
};

exports.extname = function (path) {
  if (typeof path !== 'string') path = path + '';
  var startDot = -1;
  var startPart = 0;
  var end = -1;
  var matchedSlash = true;
  // Track the state of characters (if any) we see before our first dot and
  // after any path separator we find
  var preDotState = 0;
  for (var i = path.length - 1; i >= 0; --i) {
    var code = path.charCodeAt(i);
    if (code === 47 /*/*/) {
        // If we reached a path separator that was not part of a set of path
        // separators at the end of the string, stop now
        if (!matchedSlash) {
          startPart = i + 1;
          break;
        }
        continue;
      }
    if (end === -1) {
      // We saw the first non-path separator, mark this as the end of our
      // extension
      matchedSlash = false;
      end = i + 1;
    }
    if (code === 46 /*.*/) {
        // If this is our first dot, mark it as the start of our extension
        if (startDot === -1)
          startDot = i;
        else if (preDotState !== 1)
          preDotState = 1;
    } else if (startDot !== -1) {
      // We saw a non-dot and non-path separator before our dot, so we should
      // have a good chance at having a non-empty extension
      preDotState = -1;
    }
  }

  if (startDot === -1 || end === -1 ||
      // We saw a non-dot character immediately before the dot
      preDotState === 0 ||
      // The (right-most) trimmed path component is exactly '..'
      preDotState === 1 && startDot === end - 1 && startDot === startPart + 1) {
    return '';
  }
  return path.slice(startDot, end);
};

function filter (xs, f) {
    if (xs.filter) return xs.filter(f);
    var res = [];
    for (var i = 0; i < xs.length; i++) {
        if (f(xs[i], i, xs)) res.push(xs[i]);
    }
    return res;
}

// String.prototype.substr - negative index don't work in IE8
var substr = 'ab'.substr(-1) === 'b'
    ? function (str, start, len) { return str.substr(start, len) }
    : function (str, start, len) {
        if (start < 0) start = str.length + start;
        return str.substr(start, len);
    }
;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var scope = (typeof global !== "undefined" && global) ||
            (typeof self !== "undefined" && self) ||
            window;
var apply = Function.prototype.apply;

// DOM APIs, for completeness

exports.setTimeout = function() {
  return new Timeout(apply.call(setTimeout, scope, arguments), clearTimeout);
};
exports.setInterval = function() {
  return new Timeout(apply.call(setInterval, scope, arguments), clearInterval);
};
exports.clearTimeout =
exports.clearInterval = function(timeout) {
  if (timeout) {
    timeout.close();
  }
};

function Timeout(id, clearFn) {
  this._id = id;
  this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function() {};
Timeout.prototype.close = function() {
  this._clearFn.call(scope, this._id);
};

// Does not start the time, just sets up the members needed.
exports.enroll = function(item, msecs) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = msecs;
};

exports.unenroll = function(item) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = -1;
};

exports._unrefActive = exports.active = function(item) {
  clearTimeout(item._idleTimeoutId);

  var msecs = item._idleTimeout;
  if (msecs >= 0) {
    item._idleTimeoutId = setTimeout(function onTimeout() {
      if (item._onTimeout)
        item._onTimeout();
    }, msecs);
  }
};

// setimmediate attaches itself to the global object
__webpack_require__(19);
// On some exotic environments, it's not clear which object `setimmediate` was
// able to install onto.  Search each possibility in the same order as the
// `setimmediate` library.
exports.setImmediate = (typeof self !== "undefined" && self.setImmediate) ||
                       (typeof global !== "undefined" && global.setImmediate) ||
                       (this && this.setImmediate);
exports.clearImmediate = (typeof self !== "undefined" && self.clearImmediate) ||
                         (typeof global !== "undefined" && global.clearImmediate) ||
                         (this && this.clearImmediate);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
    "use strict";

    if (global.setImmediate) {
        return;
    }

    var nextHandle = 1; // Spec says greater than zero
    var tasksByHandle = {};
    var currentlyRunningATask = false;
    var doc = global.document;
    var registerImmediate;

    function setImmediate(callback) {
      // Callback can either be a function or a string
      if (typeof callback !== "function") {
        callback = new Function("" + callback);
      }
      // Copy function arguments
      var args = new Array(arguments.length - 1);
      for (var i = 0; i < args.length; i++) {
          args[i] = arguments[i + 1];
      }
      // Store and register the task
      var task = { callback: callback, args: args };
      tasksByHandle[nextHandle] = task;
      registerImmediate(nextHandle);
      return nextHandle++;
    }

    function clearImmediate(handle) {
        delete tasksByHandle[handle];
    }

    function run(task) {
        var callback = task.callback;
        var args = task.args;
        switch (args.length) {
        case 0:
            callback();
            break;
        case 1:
            callback(args[0]);
            break;
        case 2:
            callback(args[0], args[1]);
            break;
        case 3:
            callback(args[0], args[1], args[2]);
            break;
        default:
            callback.apply(undefined, args);
            break;
        }
    }

    function runIfPresent(handle) {
        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
        // So if we're currently running a task, we'll need to delay this invocation.
        if (currentlyRunningATask) {
            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
            // "too much recursion" error.
            setTimeout(runIfPresent, 0, handle);
        } else {
            var task = tasksByHandle[handle];
            if (task) {
                currentlyRunningATask = true;
                try {
                    run(task);
                } finally {
                    clearImmediate(handle);
                    currentlyRunningATask = false;
                }
            }
        }
    }

    function installNextTickImplementation() {
        registerImmediate = function(handle) {
            process.nextTick(function () { runIfPresent(handle); });
        };
    }

    function canUsePostMessage() {
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `global.postMessage` means something completely different and can't be used for this purpose.
        if (global.postMessage && !global.importScripts) {
            var postMessageIsAsynchronous = true;
            var oldOnMessage = global.onmessage;
            global.onmessage = function() {
                postMessageIsAsynchronous = false;
            };
            global.postMessage("", "*");
            global.onmessage = oldOnMessage;
            return postMessageIsAsynchronous;
        }
    }

    function installPostMessageImplementation() {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages

        var messagePrefix = "setImmediate$" + Math.random() + "$";
        var onGlobalMessage = function(event) {
            if (event.source === global &&
                typeof event.data === "string" &&
                event.data.indexOf(messagePrefix) === 0) {
                runIfPresent(+event.data.slice(messagePrefix.length));
            }
        };

        if (global.addEventListener) {
            global.addEventListener("message", onGlobalMessage, false);
        } else {
            global.attachEvent("onmessage", onGlobalMessage);
        }

        registerImmediate = function(handle) {
            global.postMessage(messagePrefix + handle, "*");
        };
    }

    function installMessageChannelImplementation() {
        var channel = new MessageChannel();
        channel.port1.onmessage = function(event) {
            var handle = event.data;
            runIfPresent(handle);
        };

        registerImmediate = function(handle) {
            channel.port2.postMessage(handle);
        };
    }

    function installReadyStateChangeImplementation() {
        var html = doc.documentElement;
        registerImmediate = function(handle) {
            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
            var script = doc.createElement("script");
            script.onreadystatechange = function () {
                runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
        };
    }

    function installSetTimeoutImplementation() {
        registerImmediate = function(handle) {
            setTimeout(runIfPresent, 0, handle);
        };
    }

    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;

    // Don't get fooled by e.g. browserify environments.
    if ({}.toString.call(global.process) === "[object process]") {
        // For Node.js before 0.9
        installNextTickImplementation();

    } else if (canUsePostMessage()) {
        // For non-IE10 modern browsers
        installPostMessageImplementation();

    } else if (global.MessageChannel) {
        // For web workers, where supported
        installMessageChannelImplementation();

    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
        // For IE 6–8
        installReadyStateChangeImplementation();

    } else {
        // For older browsers
        installSetTimeoutImplementation();
    }

    attachTo.setImmediate = setImmediate;
    attachTo.clearImmediate = clearImmediate;
}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4), __webpack_require__(2)))

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(21)
  __webpack_require__(22)
  __webpack_require__(23)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(24),
  /* template */
  __webpack_require__(46),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 21 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 22 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 23 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Reader_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Reader_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Reader_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Settings_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Settings_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Settings_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__event_hub_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    pageNum: {
      type: Number,
      default: 0
    },
    ttlPages: {
      type: Number,
      default: 0
    }
  },
  data: function data() {
    return {
      pageNumber: this.pageNum,
      totalPages: this.ttlPages,
      info: false,
      buyBar: true,
      buyMenu: false,
      socialMenu: false,
      otherBooks: false,
      focused: false,
      dialogBuy: false,
      dialogShare: false,
      notifications: false,
      sound: true,
      widgets: false,
      show: false,
      iSize: 50,
      selectBook: "Books",
      home: this.$route.path,
      drawer: false,
      drawerRight: false,
      items: [],
      books: [],
      booksChanged: '',
      socials: [{
        title: "LinkedIn",
        img: "static/img/linkedin-logo.svg",
        url: "https://www.linkedin.com/shareArticle?mini=true&url=https://textcafe.co/books/20YyQW/%3F1689450778405&title=Thirst%20at%20Night&summary=Transport%20yourself%20to%20Transylvania%20in%20the%2014th%20century%20with%20t&source=LinkedIn",
        icon: "ion-social-linkedin"
      }, {
        title: "Facebook",
        img: "static/img/facebook-logo.svg",
        url: "https://www.facebook.com/sharer/sharer.php?u=https://textcafe.co/books/20YyQW/%3F1689450778405",
        icon: "ion-social-facebook"
      }, {
        title: "Twitter",
        img: "static/img/twitter-logo-silhouette.svg",
        url: "https://twitter.com/intent/tweet?text=Get%20%23Free%20%23Sample%20of%20Thirst%20at%20Night%20%0Dhttps://textcafe.co/books/20YyQW/%3F1689450778405&amp;via=textcafecom",
        icon: "ion-social-twitter"
      }, {
        title: "Tumblr",
        img: "static/img/tumblr-letter-logo.svg",
        url: "https://www.tumblr.com/widgets/share/tool?canonicalUrl=https://textcafe.co/books/20YyQW/%3F1689450778405&posttype=link&caption=Transport%20yourself%20to%20Transylvania%20in%20the%2014th%20century%20with%20t",
        icon: "ion-social-tumblr"
      }, {
        title: "Pinterest",
        img: "static/img/pinterest-logo.svg",
        url: "http://www.pinterest.com/pin/create/button/?url=https://textcafe.co/books/20YyQW/%3F1689450778405&description=Transport%20yourself%20to%20Transylvania%20in%20the%2014th%20century%20with%20t&media=https://textcafe.co/books/20YyQW/media/FC-9798886937848.jpg",
        icon: "ion-social-pinterest"
      }],
      buys: [{
        title: 'Amazon UK',
        img: 'https://textcafe.co/domain-icons/Amazon.com_A_Smile.svg',
        url: 'https://www.amazon.co.uk/s?k=9798886937848&i=stripbooks&linkCode=qs&tag=mobilebookcom-20',
        alt: ''
      }, {
        title: 'Google Play',
        img: 'https://textcafe.co/global-css/img/Google_Play_symbol.svg',
        url: 'https://play.google.com/store/books/details?id=KjjFEAAAQBAJ&amp;rdid=book-KjjFEAAAQBAJ&amp;rdot=1&amp;source=gbs_atb&amp;pcampaignid=books_booksearch_atb&gl=gb',
        alt: ''
      }],
      right: null,
      left: null
    };
  },
  mounted: function mounted() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('https://www.textcafe.com/widget/get-samples.json?related=9798886937848').then(function (response) {
      return _this.books = response.data.map(function (item) {
        return {
          title: item.title,
          img: item.coverImagePath,
          url: item.socialUrl,
          alt: "This image is the cover for the book " + item.title
        };
      });
    }).catch(function (error) {
      return (
        // handle error
        console.log(error)
      );
    });
  },

  created: function created() {
    var _this2 = this;

    this.$router.options.routes.forEach(function (route) {
      _this2.items.push({
        path: route.path,
        name: route.name,
        component: route.component,
        //image: "static/img/ilG6Mf.jpg"
        image: '/books/20YyQW/media/FC-9798886937848.jpg?1689450778405',
        alt: 'Thirst at Night'
      });
    });
    __WEBPACK_IMPORTED_MODULE_2__event_hub_js__["a" /* default */].$on("pageNum", function (newValue) {
      _this2.pageNum = newValue;
    });
    __WEBPACK_IMPORTED_MODULE_2__event_hub_js__["a" /* default */].$on("ttlPages", function (newValue) {
      _this2.ttlPages = newValue;
    });
  },
  watch: {
    $route: function $route(to, from) {
      if (to.path === "/") {
        this.home = this.$route.path;
      } else {
        this.home = null;
      }
    },

    iSize: function iSize(newValue) {
      __WEBPACK_IMPORTED_MODULE_2__event_hub_js__["a" /* default */].$emit("iSizeChanged", newValue);
    },
    books: function books(newValue) {
      __WEBPACK_IMPORTED_MODULE_2__event_hub_js__["a" /* default */].$emit("booksChanged", Date.now());
    }
  },
  methods: {
    resetScroll: function resetScroll() {
      var page = this.$el.querySelector(".book-page");
      page.scrollLeft = 0;
    },
    onBlur: function onBlur() {
      if (this.show === true) {
        this.show = false;
        this.$emit("blur");
      }
    },
    onFocus: function onFocus() {
      if (this.show === false) {
        this.show = true;
        this.$el.querySelector(".book-page").$emit("focus");
      }
    },
    buyClick: function buyClick(url) {
      //const url = '/foo/bar'
      // this.$ga.query('send', 'event', 'outbound', 'click', url, {
      //     transport: 'beacon',
      //     hitCallback () {
      //        //document.location = url
      //     }
      // })
      this.$ga.event({
        eventCategory: 'purchase',
        eventAction: 'click',
        eventLabel: url
        // eventValue: 123
      });
    },
    shareClick: function shareClick(network) {
      this.$ga.event({
        eventCategory: 'share',
        eventAction: 'click',
        eventLabel: network
        // eventValue: 123
      });
    }
  },
  components: {
    settings: __WEBPACK_IMPORTED_MODULE_1__components_Settings_vue___default.a,
    reader: __WEBPACK_IMPORTED_MODULE_0__components_Reader_vue___default.a
  }
});

/***/ }),
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__event_hub_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Settings__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Settings___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Settings__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var SLIDE_TIME = document.documentElement.clientWidth > 480 ? 500 : 300;

/* harmony default export */ __webpack_exports__["default"] = ({
  name: "reader",
  props: {
    value1: {
      type: Number,
      default: 22
    },
    selected: {
      type: String
    },
    ex8: {
      type: String,
      default: "Auto"
    },
    value2: {
      type: Number
    },
    value3: {
      type: Number,
      default: 100
    }
  },
  data: function data() {
    return {
      pageNum: 0,
      pageNumber: 1,
      ttlPages: 0,
      totalPages: 0,
      home: false,
      div: 0,
      prevX: null,
      xDownEnd: null,
      fontSize: this.value1,
      fontFamily: this.selected,
      columns: this.ex8,
      widthSize: this.value2,
      brightness: this.value3,
      currentColor: "#f3f3f3",
      cols: "2 220px",
      position: { scrollTop: 0, scrollLeft: 0 },
      offset: null,
      height: 0,
      isOver: false,
      routeNames: ["home", "nav", "text/ch001", "text/ch002", "text/ch003", "text/ch004", "text/ch005", "text/ch006", "text/ch007", "text/ch008", "last"],
      routeTransition: "slide-left",
      rest: true,
      selectedView: "Book1",
      progress: 0,
      hiddenEl: false,
      brandReaderUrl: "",
      brandLogoUrl: "",
      currentUrl: "https://textcafe.co/books/20YyQW/",
      waiting: false
    };
  },

  created: function created() {
    var _this = this;

    document.addEventListener("mousewheel", this.onScroll, false);
    window.addEventListener('resize', this.resize);
    this.resize();
    this.getTtlPages();

    if (document.documentElement.offsetWidth >= 768) {
      this.hiddenEl = true;
    } else {
      this.hiddenEl = false;
    }

    this.$router.options.routes.forEach(function (route) {
      _this.routeNames.push(route.name);
    });
    __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$on("fontSizeChanged", function (newValue) {
      _this.fontSize = newValue;
    });
    __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$on("fontFamilyChanged", function (newValue) {
      _this.fontFamily = newValue;
    });
    __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$on("columnsCountChanged", function (newValue) {
      _this.columns = newValue;
      if (_this.columns === "Single") {
        _this.cols = "1 auto";
      } else if (_this.columns === "Auto") {
        _this.cols = "2 220px";
      }
    });
    __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$on("widthChanged", function (newValue) {
      _this.widthSize = newValue;
    });
    __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$on("brightnessChanged", function (newValue) {
      _this.brightness = newValue;
    });
  },

  destroyed: function destroyed() {
    document.removeEventListener("mousewheel", this.onScroll, false);
    document.removeEventListener("resize", this.resize, false);
  },
  updated: function updated() {
    this.getTtlPages();
    this.resize();
    var links = document.getElementsByTagName("a");
    for (var i = 0; i < links.length; i++) {
      var that = this;
      var url = "/" + document.location.hash.split("#/")[1];
      if (links[i].href.split("#")[1] === url) {
        links[i].style.textDecoration = "underline";
        links[i].style.textDecorationStyle = "dotted";
        links[i].onclick = function (e) {
          e.preventDefault();
          var refr = this.href.split("#")[2];
          that.linkTo(refr);
        };
      };
    };
  },
  mounted: function mounted() {
    this.resize();

    var links = document.getElementsByTagName("a");
    for (var i = 0; i < links.length; i++) {
      var that = this;
      var url = "/" + document.location.hash.split("#/")[1];
      if (links[i].href.split("#")[1] === url) {
        links[i].style.textDecoration = "underline";
        links[i].style.textDecorationStyle = "dotted";
        links[i].onclick = function (e) {
          e.preventDefault();
          var refr = this.href.split("#")[2];
          that.linkTo(refr);
        };
      };
    };

    this.getTtlPages();

    var bgColor = document.getElementsByClassName("book-content")[0].style.backgroundColor,
        hexDigits = new Array("0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "a", "b", "c", "d", "e", "f");
    function rgb2hex(rgb) {
      rgb = rgb.match(/^rgb\((\d+),\s*(\d+),\s*(\d+)\)$/);
      return "#" + hex(rgb[1]) + hex(rgb[2]) + hex(rgb[3]);
    }
    function hex(x) {
      return isNaN(x) ? "00" : hexDigits[(x - x % 16) / 16] + hexDigits[x % 16];
    }
    this.currentColor = rgb2hex(bgColor);
  },

  watch: {
    $route: function $route(to, from, next) {
      var toDepth = this.routeNames.indexOf(to.name);
      var fromDepth = this.routeNames.indexOf(from.name);
      this.routeTransition = toDepth < fromDepth ? "slide-right" : "slide-left";

      this.progress = 0;
      this.pageNumber = 1;
    },

    pageNum: function pageNum(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("pageNum", newValue);
    },
    ttlPages: function ttlPages(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("ttlPages", newValue);
    }
  },
  methods: {
    resize: function resize() {
      this.height = document.documentElement.clientHeight;
    },
    linkTo: function linkTo(refName) {
      var element = document.getElementById(refName);
      var elementOffset = Math.ceil(element.offsetLeft);
      var page = this.$el.querySelector(".book-page");
      var gap = parseInt(window.getComputedStyle(page).getPropertyValue("column-gap"), 10);
      var onStart = Math.ceil(page.scrollLeft);
      var destinationOffset = Math.floor(elementOffset / (page.offsetWidth + gap));
      var target = destinationOffset * (page.offsetWidth + gap) - onStart;
      if (destinationOffset + 1 !== this.pageNumber) {
        this.scrollIt(target, 300, "easeOutQuad", false);
        var scrollArea = page.scrollWidth - page.offsetWidth;
        var pctScrolled = Math.floor(destinationOffset * (page.offsetWidth + gap) / scrollArea * 100);
        this.progress = pctScrolled;
        this.pageNumber = destinationOffset + 1;
      }
    },
    getTtlPages: function getTtlPages() {
      this.$nextTick(function () {
        var page = this.$el.querySelector(".book-page");

        var gap = parseInt(window.getComputedStyle(page).getPropertyValue("column-gap"), 10);

        var scrollArea = page.scrollWidth - page.offsetWidth;
        var ttlPages = Math.round(scrollArea / (page.offsetWidth + gap));
        this.ttlPages = ttlPages;
        this.totalPages = this.ttlPages + 1;
      });
    },
    tapped: function tapped() {
      var el = this.$el.querySelector(".touch-swipe");
      this.hiddenEl = !this.hiddenEl;
    },
    tappedIn: function tappedIn() {
      var el = this.$el.querySelector(".touch-swipe");
      this.hiddenEl = !this.hiddenEl;
    },
    scrollIt: function scrollIt(destination) {
      var duration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 200;

      var _this2 = this;

      var easing = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "easeInOutQuart";
      var callback = arguments[3];

      var easings = {
        linear: function linear(t) {
          return t;
        },
        easeInQuad: function easeInQuad(t) {
          return t * t;
        },
        easeOutQuad: function easeOutQuad(t) {
          return t * (2 - t);
        },
        easeInOutQuad: function easeInOutQuad(t) {
          return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
        },
        easeInCubic: function easeInCubic(t) {
          return t * t * t;
        },
        easeOutCubic: function easeOutCubic(t) {
          return --t * t * t + 1;
        },
        easeInOutCubic: function easeInOutCubic(t) {
          return t < 0.5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1;
        },
        easeInQuart: function easeInQuart(t) {
          return t * t * t * t;
        },
        easeOutQuart: function easeOutQuart(t) {
          return 1 - --t * t * t * t;
        },
        easeInOutQuart: function easeInOutQuart(t) {
          return t < 0.5 ? 8 * t * t * t * t : 1 - 8 * --t * t * t * t;
        },
        easeInQuint: function easeInQuint(t) {
          return t * t * t * t * t;
        },
        easeOutQuint: function easeOutQuint(t) {
          return 1 + --t * t * t * t * t;
        },
        easeInOutQuint: function easeInOutQuint(t) {
          return t < 0.5 ? 16 * t * t * t * t * t : 1 + 16 * --t * t * t * t * t;
        }
      };

      var page = this.$el.querySelector(".book-page");
      var gap = parseInt(window.getComputedStyle(page).getPropertyValue("column-gap"), 10),
          offset = page.offsetWidth + gap;

      var start = Math.ceil(page.scrollLeft);

      var startTime = "now" in window.performance ? performance.now() : new Date().getTime();

      var documentWidth = Math.max(page.scrollWidth || page.offsetWidth || page.clientWidth);

      var windowWidth = window.innerWidth || window.clientWidth;

      var destinationOffsetToScroll = start + destination;

      function scroll() {
        var now = "now" in window.performance ? performance.now() : new Date().getTime();
        var time = Math.min(1, (now - startTime) / duration);
        var timeFunction = easings[easing](time);
        page.scroll(Math.ceil(timeFunction * (destinationOffsetToScroll - start) + start), 0);
        if (timeFunction === 1 || start === destinationOffsetToScroll) {
          if (callback) {
            callback();
          }
          return;
        }
        requestAnimationFrame(scroll);
      }
      scroll();
      setTimeout(function () {
        _this2.waiting = false;
      }, 250);
    },


    next: function next(e) {
      var el = this.$el.querySelector(".touch-swipe");
      if (el) el.style.pointerEvents = "auto";
      var book = this.$el.querySelector(".book-content");
      var page = this.$el.querySelector(".book-page"),
          gap = parseInt(window.getComputedStyle(page).getPropertyValue("column-gap"), 10),
          offset = page.offsetWidth + gap,
          index = this.routeNames.indexOf(this.$route.name);

      var scrollArea = page.scrollWidth - page.offsetWidth;
      var windowWidth = window.innerWidth || window.clientWidth;
      var trackLength = scrollArea - (page.offsetWidth + gap);

      // var pageNum = Math.floor(page.scrollLeft / (page.offsetWidth + gap));
      var scrollLeft = Math.ceil(page.scrollLeft);
      var pageNum = Math.floor(scrollLeft / (page.offsetWidth + gap));

      this.pageNum = pageNum;

      pageNum += 1;

      this.pageNumber += 1;

      if (page.scrollWidth - (scrollLeft + page.offsetWidth) !== 0 && pctScrolled !== 100) {
        var currentPage = Math.floor(pageNum * (page.offsetWidth + gap));

        var nextPage = Math.floor(pageNum * (page.offsetWidth + gap));

        var destination = nextPage - scrollLeft;

        this.scrollIt(destination, 300, "easeOutQuad", false);
      } else {
        this.$router.push({ name: this.routeNames[index + 1] });

        this.pageNumber = 1;
        pageNum = 0;
        var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
        this.progress = pctScrolled;
      }
      var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
      this.progress = pctScrolled;
    },
    prev: function prev(e) {
      var el = this.$el.querySelector(".touch-swipe");
      if (el) el.style.pointerEvents = "auto";

      var page = this.$el.querySelector(".book-page"),
          gap = parseInt(window.getComputedStyle(page).getPropertyValue("column-gap"), 10),
          offset = page.offsetWidth + gap,
          index = this.routeNames.indexOf(this.$route.name);

      var scrollArea = page.scrollWidth - page.offsetWidth;

      var scrollLeft = Math.ceil(page.scrollLeft);
      var pageNum = Math.round(scrollLeft / (page.offsetWidth + gap));
      var ttlPages = Math.round(scrollArea / (page.offsetWidth + gap));

      this.pageNum = pageNum;

      this.pageNumber -= 1;

      var currentPage = Math.floor(pageNum * (page.offsetWidth + gap));

      if (scrollLeft !== 0 && pageNum !== 0) {
        var pageNum = Math.round(scrollLeft / (page.offsetWidth + gap));
        var pageNumber = Math.floor(scrollLeft / (page.offsetWidth + gap));

        pageNum -= 1;
        var prevPage = Math.floor(pageNum * (page.offsetWidth + gap));

        var destination = -1 * (scrollLeft - prevPage);

        this.scrollIt(destination, 300, "easeOutQuad", false);
      } else {
        this.$router.push({ name: this.routeNames[index - 1] });

        this.pageNumber = 1;

        pageNum = 0;
        var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
        this.progress = pctScrolled;
      }
      var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
      this.progress = pctScrolled;
    },
    over: function over() {
      this.isOver = true;
    },
    out: function out() {
      this.isOver = false;
    },
    onScroll: function onScroll(e, position) {
      this.position = position;
      if (this.isOver === true) {
        var page = this.$el.querySelector(".book-page"),
            gap = parseInt(window.getComputedStyle(page).getPropertyValue("column-gap"), 10),
            deltaX = Math.max(-1, Math.min(1, e.wheelDelta || -e.detail)),
            end = page.scrollWidth - (page.scrollLeft + page.offsetWidth),
            offset = page.offsetWidth + gap;

        var scrollArea = page.scrollWidth - page.offsetWidth;
        var pageNum = Math.round(page.scrollLeft / (page.offsetWidth + gap));

        var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
        this.progress = pctScrolled;

        if (deltaX === 1) {
          if (page.scrollLeft !== 0) {
            if (this.waiting) {
              return;
            }
            this.waiting = true;

            pageNum -= 1;

            this.pageNumber -= 1;
            var prevPage = Math.floor(pageNum * (page.offsetWidth + gap));

            var destination = -1 * (page.scrollLeft - prevPage);

            this.scrollIt(destination, 300, "easeOutQuad", false);

            var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
            this.progress = pctScrolled;
          }
        } else if (deltaX === -1) {
          if (page.scrollWidth - (page.scrollLeft + page.offsetWidth) !== 0) {
            if (this.waiting) {
              return;
            }
            this.waiting = true;

            pageNum += 1;

            this.pageNumber += 1;
            var nextPage = Math.floor(pageNum * (page.offsetWidth + gap));

            var destination = nextPage - page.scrollLeft;

            this.scrollIt(destination, 300, "easeOutQuad", false);

            var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
            this.progress = pctScrolled;
          }
        }
      } else {
        return;
      }
    },
    fadeIn: function fadeIn() {
      var page = this.$el.querySelector(".book-page");
      page.style.opacity = 0;
      var last = +new Date();
      var tick = function tick() {
        page.style.opacity = +page.style.opacity + (new Date() - last) / 400;
        last = +new Date();
        if (+page.style.opacity < 1) {
          window.requestAnimationFrame && requestAnimationFrame(tick) || setTimeout(tick, 16);
        }
      };
      tick();
    },

    resetScroll: function resetScroll() {
      var page = this.$el.querySelector(".book-page");
      page.scrollLeft = 0;
    }
  },
  computed: {
    isMobile: function isMobile() {
      var check = false;
      (function (a) {
        if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true;
      })(navigator.userAgent || navigator.vendor || window.opera);
      return check;
    }
  },
  components: {
    Settings: __WEBPACK_IMPORTED_MODULE_1__components_Settings___default.a
  }
});

/***/ }),
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__event_hub_js__ = __webpack_require__(5);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: "settings",
  data: function data() {
    return {
      events: [],
      value1: 22,
      value2: 70,
      value3: 100,
      ex8: "Auto",
      selected: "Old-Cabin",
      fonts: ["Old-Cabin", "Raleway-Bitter", "Ubuntu-Abel", "Droid-Abril", "Garamond-Clicker", "Alice-Playfair", "Judson-Quando"],
      classes: ["white", "black", "sepia"]
    };
  },

  watch: {
    value1: function value1(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("fontSizeChanged", newValue);
    },
    selected: function selected(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("fontFamilyChanged", newValue);
    },
    ex8: function ex8(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("columnsCountChanged", newValue);
    },
    value2: function value2(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("widthChanged", newValue);
    },
    value3: function value3(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("brightnessChanged", newValue);
    }
  },
  methods: {
    reloadBook: function reloadBook() {
      window.location.reload(true);
    },
    changeClassWhite: function changeClassWhite() {
      var el = document.getElementsByClassName("book-content")[0];
      var el2 = document.getElementsByClassName("nav-btn")[0];
      var el3 = document.getElementsByClassName("nav-btn")[1];
      var el4 = document.getElementsByTagName("footer")[0];
      console.log(document.getElementsByTagName("footer")[0]);
      if (el.classList && el2.classList && el3.classList && el4.classList) {
        el.classList.remove("black");
        el2.classList.remove("black");
        el3.classList.remove("black");
        el4.classList.remove("black");
        el.classList.remove("sepia");
        el2.classList.remove("sepia");
        el3.classList.remove("sepia");
        el4.classList.remove("sepia");
        el.classList.add("white");
        el2.classList.add("white");
        el3.classList.add("white");
        el4.classList.add("white");
      } else {
        el.className += " white";
        el2.className += " white";
        el3.className += " white";
        el4.className += " white";
      }
    },
    changeClassBlack: function changeClassBlack() {
      var el = document.getElementsByClassName("book-content")[0];
      var el2 = document.getElementsByClassName("nav-btn")[0];
      var el3 = document.getElementsByClassName("nav-btn")[1];
      var el4 = document.getElementsByTagName("footer")[0];
      if (el.classList && el2.classList && el3.classList && el4.classList) {
        el.classList.remove("white");
        el2.classList.remove("white");
        el3.classList.remove("white");
        el4.classList.remove("white");
        el.classList.remove("sepia");
        el2.classList.remove("sepia");
        el3.classList.remove("sepia");
        el4.classList.remove("sepia");
        el.classList.add("black");
        el2.classList.add("black");
        el3.classList.add("black");
        el4.classList.add("black");
      } else {
        el.className += " black";
        el2.className += " black";
        el3.className += " black";
        el4.className += " black";
      }
    },
    changeClassSepia: function changeClassSepia() {
      var el = document.getElementsByClassName("book-content")[0];
      var el2 = document.getElementsByClassName("nav-btn")[0];
      var el3 = document.getElementsByClassName("nav-btn")[1];
      var el4 = document.getElementsByTagName("footer")[0];
      if (el.classList && el2.classList && el3.classList && el4.classList) {
        el.classList.remove("black");
        el2.classList.remove("black");
        el3.classList.remove("black");
        el4.classList.remove("black");
        el.classList.remove("white");
        el2.classList.remove("white");
        el3.classList.remove("white");
        el4.classList.remove("white");
        el.classList.add("sepia");
        el2.classList.add("sepia");
        el3.classList.add("sepia");
        el4.classList.add("sepia");
      } else {
        el.className += " sepia";
        el2.className += " sepia";
        el3.className += " sepia";
        el4.className += " sepia";
      }
    }
  }
});

/***/ }),
/* 27 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "settings"
  }, [_c('ul', {
    staticClass: "settings-list"
  }, [_c('li', [_c('span', [_vm._v("Reload book: ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "id": "reloadBookBtn",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.reloadBook()
      }
    }
  }, [_c('v-icon', [_vm._v("ion-ios-loop-strong")])], 1)], 1), _vm._v(" "), _c('li', [_c('span', [_vm._v("Font:")]), _vm._v(" "), _c('v-select', {
    attrs: {
      "items": _vm.fonts,
      "overflow": "",
      "single-line": "",
      "return-objectauto": "",
      "append-icon": "ion-ios-arrow-down",
      "hide-details": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawerRight = true
      }
    },
    model: {
      value: (_vm.selected),
      callback: function($$v) {
        _vm.selected = $$v
      },
      expression: "selected"
    }
  })], 1), _vm._v(" "), _c('li', [_c('span', [_vm._v("Font size:")]), _vm._v(" "), _c('p', {
    staticClass: "bold-font",
    domProps: {
      "innerHTML": _vm._s(_vm.value1 + 'px' || null)
    }
  }), _vm._v(" "), _c('v-slider', {
    attrs: {
      "min": 17,
      "max": 27,
      "step": 1
    },
    model: {
      value: (_vm.value1),
      callback: function($$v) {
        _vm.value1 = $$v
      },
      expression: "value1"
    }
  })], 1), _vm._v(" "), _c('li', {
    staticClass: "columns-setting"
  }, [_c('span', [_vm._v("Page columns:")]), _c('br'), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": "Auto",
      "value": "Auto",
      "flat": "",
      "ripple": false,
      "prepend-icon": ""
    },
    model: {
      value: (_vm.ex8),
      callback: function($$v) {
        _vm.ex8 = $$v
      },
      expression: "ex8"
    }
  }), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": "Single",
      "value": "Single",
      "flat": "",
      "ripple": false,
      "prepend-icon": ""
    },
    model: {
      value: (_vm.ex8),
      callback: function($$v) {
        _vm.ex8 = $$v
      },
      expression: "ex8"
    }
  })], 1), _vm._v(" "), _c('li', {
    staticClass: "width-setting"
  }, [_c('span', [_vm._v("Page width:")]), _vm._v(" "), _c('p', {
    staticClass: "bold-font",
    domProps: {
      "innerHTML": _vm._s(_vm.value2 + '%' || null)
    }
  }), _vm._v(" "), _c('v-slider', {
    attrs: {
      "min": 50,
      "max": 90
    },
    model: {
      value: (_vm.value2),
      callback: function($$v) {
        _vm.value2 = $$v
      },
      expression: "value2"
    }
  })], 1), _vm._v(" "), _c('li', [_c('span', [_vm._v("Brightness:")]), _vm._v(" "), _c('p', {
    staticClass: "bold-font",
    domProps: {
      "innerHTML": _vm._s((_vm.value3 - 100) + '%' || null)
    }
  }), _vm._v(" "), _c('v-slider', {
    attrs: {
      "step": 1,
      "min": 0,
      "max": 200
    },
    model: {
      value: (_vm.value3),
      callback: function($$v) {
        _vm.value3 = $$v
      },
      expression: "value3"
    }
  })], 1), _vm._v(" "), _c('li', [_c('span', [_vm._v("Color mode:")]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    attrs: {
      "id": "colors"
    }
  }, [_c('v-btn', {
    attrs: {
      "flat": "",
      "id": "white",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.changeClassWhite()
      }
    }
  }, [_vm._v("\n          White\n        ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "id": "black",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.changeClassBlack()
      }
    }
  }, [_vm._v("\n          Black\n        ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "id": "sepia",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.changeClassSepia()
      }
    }
  }, [_vm._v("\n          Sepia\n        ")])], 1)])])])
},staticRenderFns: []}

/***/ }),
/* 28 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrap",
    style: ({
      'filter': 'brightness(' + _vm.brightness + '%)',
      'height': _vm.height - 49 + 'px'
    })
  }, [_c('v-progress-linear', {
    model: {
      value: (_vm.progress),
      callback: function($$v) {
        _vm.progress = $$v
      },
      expression: "progress"
    }
  }), _vm._v(" "), _c('v-btn', {
    directives: [{
      name: "shortkey",
      rawName: "v-shortkey",
      value: (['arrowleft']),
      expression: "['arrowleft']"
    }],
    staticClass: "nav-btn left",
    style: ({
      width: (100 - _vm.widthSize) + '%'
    }),
    attrs: {
      "ripple": false
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.prev($event)
      },
      "shortkey": _vm.prev
    }
  }, [_c('v-icon', {
    style: ({
      'left': (_vm.widthSize / 3.5) + '%'
    })
  }, [_vm._v("ion-ios-arrow-left")])], 1), _vm._v(" "), _c('v-btn', {
    directives: [{
      name: "shortkey",
      rawName: "v-shortkey",
      value: (['arrowright']),
      expression: "['arrowright']"
    }],
    staticClass: "nav-btn right",
    style: ({
      width: (100 - _vm.widthSize) + '%'
    }),
    attrs: {
      "ripple": false
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.next($event)
      },
      "shortkey": _vm.next
    }
  }, [_c('v-icon', {
    style: ({
      'right': (_vm.widthSize / 3.5) + '%'
    })
  }, [_vm._v("ion-ios-arrow-right")])], 1), _vm._v(" "), _c('div', {
    staticClass: "book-content",
    style: ({
      'width': _vm.widthSize + '%',
      'background-color': _vm.currentColor,
      'height': _vm.height - 78 + 'px'
    }),
    on: {
      "mouseenter": _vm.over,
      "mouseleave": _vm.out
    }
  }, [(_vm.isMobile) ? _c('v-touch', {
    staticClass: "touch-swipe",
    class: {
      active: _vm.hiddenEl
    },
    on: {
      "swipeleft": _vm.next,
      "swiperight": _vm.prev,
      "tap": _vm.tapped
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    key: _vm.div,
    staticClass: "book-page",
    class: _vm.fontFamily,
    style: ({
      'font-size': _vm.fontSize + 'px',
      'columns': _vm.cols
    }),
    attrs: {
      "enable-resize-watcher": ""
    },
    on: {
      "tap": _vm.tappedIn,
      "swipe": _vm.tappedIn,
      "click": _vm.tappedIn
    }
  }, [_c('transition', {
    attrs: {
      "name": _vm.routeTransition,
      "mode": "out-in"
    }
  }, [_c('router-view', {
    key: _vm.$route.name,
    staticClass: "view"
  })], 1)], 1)], 1), _vm._v(" "), _c('footer', {
    class: _vm.fontFamily,
    style: ({
      'font-size': (_vm.fontSize - 5) + 'px'
    })
  }, [(_vm.brandReaderUrl) ? _c('div', [_c('v-btn', {
    staticClass: "HC-footer-button",
    attrs: {
      "flat": "",
      "ripple": false,
      "tag": "a",
      "href": _vm.brandReaderUrl,
      "target": "_blank"
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawer = false, _vm.info = false, _vm.buyMenu = false, _vm.socialMenu = false, _vm.drawerRight = false, _vm.otherBooks = false
      }
    }
  }, [_c('i', [_c('img', {
    attrs: {
      "src": _vm.brandLogoUrl
    }
  })])])], 1) : _vm._e(), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('div', {
    staticClass: "foots"
  }, [_c('span', [_c('em', [_vm._v(_vm._s(this.$route.name))])]), _vm._v(" - page "), _c('span', [_c('em', [_vm._v(_vm._s(this.pageNumber))])]), _vm._v(" "), (this.totalPages > 1) ? _c('span', [_c('em', [_vm._v(_vm._s("/ " + this.totalPages))])]) : _vm._e()]), _vm._v(" "), _c('v-spacer')], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(30);

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);
var bind = __webpack_require__(8);
var Axios = __webpack_require__(31);
var mergeConfig = __webpack_require__(14);
var defaults = __webpack_require__(11);

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  var context = new Axios(defaultConfig);
  var instance = bind(Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, Axios.prototype, context);

  // Copy context to instance
  utils.extend(instance, context);

  return instance;
}

// Create the default instance to be exported
var axios = createInstance(defaults);

// Expose Axios class to allow class inheritance
axios.Axios = Axios;

// Factory for creating new instances
axios.create = function create(instanceConfig) {
  return createInstance(mergeConfig(axios.defaults, instanceConfig));
};

// Expose Cancel & CancelToken
axios.Cancel = __webpack_require__(15);
axios.CancelToken = __webpack_require__(44);
axios.isCancel = __webpack_require__(10);

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};
axios.spread = __webpack_require__(45);

module.exports = axios;

// Allow use of default import syntax in TypeScript
module.exports.default = axios;


/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);
var buildURL = __webpack_require__(9);
var InterceptorManager = __webpack_require__(32);
var dispatchRequest = __webpack_require__(33);
var mergeConfig = __webpack_require__(14);

/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */
function Axios(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}

/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */
Axios.prototype.request = function request(config) {
  /*eslint no-param-reassign:0*/
  // Allow for axios('example/url'[, config]) a la fetch API
  if (typeof config === 'string') {
    config = arguments[1] || {};
    config.url = arguments[0];
  } else {
    config = config || {};
  }

  config = mergeConfig(this.defaults, config);

  // Set config.method
  if (config.method) {
    config.method = config.method.toLowerCase();
  } else if (this.defaults.method) {
    config.method = this.defaults.method.toLowerCase();
  } else {
    config.method = 'get';
  }

  // Hook up interceptors middleware
  var chain = [dispatchRequest, undefined];
  var promise = Promise.resolve(config);

  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    chain.unshift(interceptor.fulfilled, interceptor.rejected);
  });

  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    chain.push(interceptor.fulfilled, interceptor.rejected);
  });

  while (chain.length) {
    promise = promise.then(chain.shift(), chain.shift());
  }

  return promise;
};

Axios.prototype.getUri = function getUri(config) {
  config = mergeConfig(this.defaults, config);
  return buildURL(config.url, config.params, config.paramsSerializer).replace(/^\?/, '');
};

// Provide aliases for supported request methods
utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url
    }));
  };
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, data, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url,
      data: data
    }));
  };
});

module.exports = Axios;


/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

function InterceptorManager() {
  this.handlers = [];
}

/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */
InterceptorManager.prototype.use = function use(fulfilled, rejected) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected
  });
  return this.handlers.length - 1;
};

/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */
InterceptorManager.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};

/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */
InterceptorManager.prototype.forEach = function forEach(fn) {
  utils.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};

module.exports = InterceptorManager;


/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);
var transformData = __webpack_require__(34);
var isCancel = __webpack_require__(10);
var defaults = __webpack_require__(11);

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */
module.exports = function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  // Ensure headers exist
  config.headers = config.headers || {};

  // Transform request data
  config.data = transformData(
    config.data,
    config.headers,
    config.transformRequest
  );

  // Flatten headers
  config.headers = utils.merge(
    config.headers.common || {},
    config.headers[config.method] || {},
    config.headers
  );

  utils.forEach(
    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
    function cleanHeaderConfig(method) {
      delete config.headers[method];
    }
  );

  var adapter = config.adapter || defaults.adapter;

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData(
      response.data,
      response.headers,
      config.transformResponse
    );

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData(
          reason.response.data,
          reason.response.headers,
          config.transformResponse
        );
      }
    }

    return Promise.reject(reason);
  });
};


/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */
module.exports = function transformData(data, headers, fns) {
  /*eslint no-param-reassign:0*/
  utils.forEach(fns, function transform(fn) {
    data = fn(data, headers);
  });

  return data;
};


/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

module.exports = function normalizeHeaderName(headers, normalizedName) {
  utils.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};


/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var createError = __webpack_require__(13);

/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */
module.exports = function settle(resolve, reject, response) {
  var validateStatus = response.config.validateStatus;
  if (!validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(createError(
      'Request failed with status code ' + response.status,
      response.config,
      null,
      response.request,
      response
    ));
  }
};


/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */
module.exports = function enhanceError(error, config, code, request, response) {
  error.config = config;
  if (code) {
    error.code = code;
  }

  error.request = request;
  error.response = response;
  error.isAxiosError = true;

  error.toJSON = function() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: this.config,
      code: this.code
    };
  };
  return error;
};


/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isAbsoluteURL = __webpack_require__(39);
var combineURLs = __webpack_require__(40);

/**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 * @returns {string} The combined full path
 */
module.exports = function buildFullPath(baseURL, requestedURL) {
  if (baseURL && !isAbsoluteURL(requestedURL)) {
    return combineURLs(baseURL, requestedURL);
  }
  return requestedURL;
};


/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
module.exports = function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};


/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */
module.exports = function combineURLs(baseURL, relativeURL) {
  return relativeURL
    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
    : baseURL;
};


/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var ignoreDuplicateOf = [
  'age', 'authorization', 'content-length', 'content-type', 'etag',
  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
  'referer', 'retry-after', 'user-agent'
];

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */
module.exports = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;

  if (!headers) { return parsed; }

  utils.forEach(headers.split('\n'), function parser(line) {
    i = line.indexOf(':');
    key = utils.trim(line.substr(0, i)).toLowerCase();
    val = utils.trim(line.substr(i + 1));

    if (key) {
      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
        return;
      }
      if (key === 'set-cookie') {
        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
      } else {
        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
      }
    }
  });

  return parsed;
};


/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
    (function standardBrowserEnv() {
      var msie = /(msie|trident)/i.test(navigator.userAgent);
      var urlParsingNode = document.createElement('a');
      var originURL;

      /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */
      function resolveURL(url) {
        var href = url;

        if (msie) {
        // IE needs attribute set twice to normalize properties
          urlParsingNode.setAttribute('href', href);
          href = urlParsingNode.href;
        }

        urlParsingNode.setAttribute('href', href);

        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
          href: urlParsingNode.href,
          protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
          host: urlParsingNode.host,
          search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
          hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
          hostname: urlParsingNode.hostname,
          port: urlParsingNode.port,
          pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
            urlParsingNode.pathname :
            '/' + urlParsingNode.pathname
        };
      }

      originURL = resolveURL(window.location.href);

      /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */
      return function isURLSameOrigin(requestURL) {
        var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
        return (parsed.protocol === originURL.protocol &&
            parsed.host === originURL.host);
      };
    })() :

  // Non standard browser envs (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return function isURLSameOrigin() {
        return true;
      };
    })()
);


/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs support document.cookie
    (function standardBrowserEnv() {
      return {
        write: function write(name, value, expires, path, domain, secure) {
          var cookie = [];
          cookie.push(name + '=' + encodeURIComponent(value));

          if (utils.isNumber(expires)) {
            cookie.push('expires=' + new Date(expires).toGMTString());
          }

          if (utils.isString(path)) {
            cookie.push('path=' + path);
          }

          if (utils.isString(domain)) {
            cookie.push('domain=' + domain);
          }

          if (secure === true) {
            cookie.push('secure');
          }

          document.cookie = cookie.join('; ');
        },

        read: function read(name) {
          var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
          return (match ? decodeURIComponent(match[3]) : null);
        },

        remove: function remove(name) {
          this.write(name, '', Date.now() - 86400000);
        }
      };
    })() :

  // Non standard browser env (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return {
        write: function write() {},
        read: function read() { return null; },
        remove: function remove() {}
      };
    })()
);


/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Cancel = __webpack_require__(15);

/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */
function CancelToken(executor) {
  if (typeof executor !== 'function') {
    throw new TypeError('executor must be a function.');
  }

  var resolvePromise;
  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });

  var token = this;
  executor(function cancel(message) {
    if (token.reason) {
      // Cancellation has already been requested
      return;
    }

    token.reason = new Cancel(message);
    resolvePromise(token.reason);
  });
}

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};

/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */
CancelToken.source = function source() {
  var cancel;
  var token = new CancelToken(function executor(c) {
    cancel = c;
  });
  return {
    token: token,
    cancel: cancel
  };
};

module.exports = CancelToken;


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */
module.exports = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};


/***/ }),
/* 46 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app', {
    attrs: {
      "toolbar": ""
    }
  }, [_c('v-dialog', {
    attrs: {
      "fullscreen": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.info = !_vm.info
      }
    },
    model: {
      value: (_vm.info),
      callback: function($$v) {
        _vm.info = $$v
      },
      expression: "info"
    }
  }, [_c('v-card', {
    staticClass: "infoDialog"
  }, [_c('div', {
    staticClass: "menuIns"
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-navicon")]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-ios-browsers-outline")])], 1), _vm._v(" "), _c('div', {
    staticClass: "menuInsTip"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Contents")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Navigate to book chapters")])]), _vm._v(" "), _c('div', {
    staticClass: "menuInsTip2"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Related Books")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Other books you might like")])]), _vm._v(" "), _c('div', {
    staticClass: "socMenu"
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-social-linkedin")]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-social-facebook")]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-social-twitter")]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-social-tumblr")]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-social-pinterest")])], 1), _vm._v(" "), _c('div', {
    staticClass: "socMenuMob"
  }, [_c('v-icon', [_vm._v("ion-android-share-alt")])], 1), _vm._v(" "), _c('div', {
    staticClass: "socMenuTip"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Share Book")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Share book to your social network")])]), _vm._v(" "), _c('div', {
    staticClass: "resize-settings"
  }, [_c('v-icon', [_vm._v("ion-ios-gear-outline")])], 1), _vm._v(" "), _c('div', {
    staticClass: "resize-settings-tip"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Settings button")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Change colors and fonts")])]), _vm._v(" "), _c('div', {
    staticClass: "left-button"
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-ios-arrow-left")])], 1), _vm._v(" "), _c('div', {
    staticClass: "left-button-tip"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Left/Previous")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Go to previous page or chapter in book view."), _c('br'), _vm._v("On touch screen swipe right.")])]), _vm._v(" "), _c('div', {
    staticClass: "right-button"
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-ios-arrow-right")])], 1), _vm._v(" "), _c('div', {
    staticClass: "right-button-tip"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Right/Next")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Go to next page or chapter in book view."), _c('br'), _vm._v("On touch screen swipe left.")])]), _vm._v(" "), _c('div', {
    staticClass: "buy-buttons"
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-bag")])], 1), _vm._v(" "), _c('div', {
    staticClass: "buy-buttons-mob"
  }, [_c('v-icon', [_vm._v("ion-bag")])], 1), _vm._v(" "), _c('div', {
    staticClass: "buy-buttons-tip"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Buy Book")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Click to stores where you can buy this book")])]), _vm._v(" "), _c('div', {
    staticClass: "headline"
  }, [_vm._v("Instructions")]), _vm._v(" "), _c('v-btn', {
    staticClass: "closeDialog",
    attrs: {
      "flat": "",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.info = false
      }
    }
  }, [_vm._v("Close")])], 1)], 1), _vm._v(" "), _c('v-navigation-drawer', {
    staticClass: "menu",
    attrs: {
      "temporary": "",
      "hide-overlay": "",
      "clipped": "",
      "enable-resize-watcher": "",
      "disable-route-watcher": "",
      "touchless": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawer = !_vm.drawer
      }
    },
    model: {
      value: (_vm.drawer),
      callback: function($$v) {
        _vm.drawer = $$v
      },
      expression: "drawer"
    }
  }, [_c('v-list', _vm._l((_vm.items), function(item) {
    return _c('v-list-tile', {
      key: item.name,
      attrs: {
        "href": item.path,
        "to": item.path,
        "exact": "",
        "ripple": false,
        "width": "100%"
      }
    }, [_c('v-list-tile-action', [_c('img', {
      attrs: {
        "height": "55px",
        "alt": item.alt,
        "src": item.image
      }
    })]), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', {
      attrs: {
        "active": ""
      }
    }, [_vm._v(_vm._s(item.name))])], 1)], 1)
  }), 1)], 1), _vm._v(" "), _c('v-navigation-drawer', {
    staticClass: "otherBooks",
    attrs: {
      "temporary": "",
      "hide-overlay": "",
      "clipped": "",
      "enable-resize-watcher": "",
      "disable-route-watcher": "",
      "touchless": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.otherBooks = !_vm.otherBooks
      }
    },
    model: {
      value: (_vm.otherBooks),
      callback: function($$v) {
        _vm.otherBooks = $$v
      },
      expression: "otherBooks"
    }
  }, [_c('v-list', [_c('h6', [_vm._v("Other books you might like:")]), _vm._v(" "), _vm._l((_vm.books), function(book) {
    return _c('v-list-tile', {
      key: book.title,
      attrs: {
        "href": book.url,
        "target": "_blank",
        "ripple": false,
        "width": "100%"
      }
    }, [_c('v-list-tile-action', [_c('img', {
      attrs: {
        "alt": book.alt,
        "src": book.img
      }
    })]), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', {
      attrs: {
        "active": ""
      }
    }, [_vm._v(_vm._s(book.title))])], 1)], 1)
  })], 2)], 1), _vm._v(" "), _c('v-navigation-drawer', {
    staticClass: "settings-drawer",
    attrs: {
      "temporary": "",
      "hide-overlay": "",
      "clipped": "",
      "right": "",
      "enable-resize-watcher": "",
      "touchless": ""
    },
    model: {
      value: (_vm.drawerRight),
      callback: function($$v) {
        _vm.drawerRight = $$v
      },
      expression: "drawerRight"
    }
  }, [_c('v-list', [_c('settings')], 1)], 1), _vm._v(" "), _c('v-navigation-drawer', {
    staticClass: "mini-bar",
    attrs: {
      "mini-variant": "",
      "enable-resize-watcher": "",
      "touchless": ""
    },
    model: {
      value: (_vm.buyBar),
      callback: function($$v) {
        _vm.buyBar = $$v
      },
      expression: "buyBar"
    }
  }, [_c('v-list', {
    attrs: {
      "ripple": false
    }
  }, [_vm._v("Shop:\n      "), _vm._l((_vm.buys), function(buy) {
    return _c('v-list-tile', {
      key: buy.title,
      attrs: {
        "href": buy.url,
        "target": "_blank"
      },
      on: {
        "click": function($event) {
          return _vm.buyClick(buy.url)
        }
      }
    }, [_c('img', {
      attrs: {
        "alt": buy.alt,
        "src": buy.img
      }
    })])
  })], 2)], 1), _vm._v(" "), _c('v-toolbar', {
    staticClass: "main-menu",
    attrs: {
      "fixed": "",
      "persistent": ""
    }
  }, [_c('v-btn', {
    staticClass: "main-menu-button",
    attrs: {
      "flat": "",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawer = !_vm.drawer, _vm.info = false, _vm.buyMenu = false, _vm.socialMenu = false, _vm.drawerRight = false, _vm.otherBooks = false
      }
    }
  }, [_c('v-icon', [_vm._v("ion-navicon")])], 1), _vm._v(" "), (_vm.books.length > 0) ? _c('v-btn', {
    key: _vm.booksChanged,
    staticClass: "otherBooks-button",
    attrs: {
      "flat": "",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.otherBooks = !_vm.otherBooks, _vm.info = false, _vm.buyMenu = false, _vm.socialMenu = false, _vm.drawerRight = false, _vm.drawer = false
      }
    }
  }, [_c('v-icon', [_vm._v("ion-ios-browsers-outline")])], 1) : _vm._e(), _vm._v(" "), _c('v-toolbar', {
    staticClass: "desktop-social-btn",
    staticStyle: {
      "margin-left": "5%"
    }
  }, _vm._l((_vm.socials), function(social) {
    return _c('v-btn', {
      key: social.title,
      attrs: {
        "flat": "",
        "href": social.url,
        "target": "_blank",
        "ripple": false
      },
      on: {
        "click": function($event) {
          return _vm.shareClick(social.title)
        }
      }
    }, [_c('v-icon', [_vm._v(_vm._s(social.icon))])], 1)
  }), 1), _vm._v(" "), _c('v-btn', {
    staticClass: "mobile-buy-btn",
    attrs: {
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.buyMenu = !_vm.buyMenu, _vm.info = false, _vm.drawer = false, _vm.socialMenu = false, _vm.drawerRight = false, _vm.otherBooks = false
      }
    }
  }, [_c('v-icon', [_vm._v("ion-bag")])], 1), _vm._v(" "), _c('v-navigation-drawer', {
    staticClass: "buy-menu",
    attrs: {
      "width": "100vw",
      "height": "auto",
      "hide-overlay": "",
      "temporary": "",
      "clipped": "",
      "disable-route-watcher": "",
      "touchless": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.buyMenu = !_vm.buyMenu
      }
    },
    model: {
      value: (_vm.buyMenu),
      callback: function($$v) {
        _vm.buyMenu = $$v
      },
      expression: "buyMenu"
    }
  }, [_c('v-list', [_c('span', [_vm._v("Purchase this book: ")]), _vm._v(" "), _vm._l((_vm.buys), function(buy) {
    return _c('v-list-tile', {
      key: buy.title,
      attrs: {
        "href": buy.url,
        "target": "_blank"
      },
      on: {
        "click": function($event) {
          return _vm.buyClick(buy.url)
        }
      }
    }, [_c('v-list-tile-action', [_c('img', {
      attrs: {
        "alt": buy.alt,
        "src": buy.img
      }
    })]), _vm._v(" "), _c('v-list-tile-title', {
      domProps: {
        "innerHTML": _vm._s(buy.title)
      }
    })], 1)
  })], 2)], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "mobile-social-btn",
    attrs: {
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.socialMenu = !_vm.socialMenu, _vm.info = false, _vm.buyMenu = false, _vm.drawer = false, _vm.drawerRight = false, _vm.otherBooks = false
      }
    }
  }, [_c('v-icon', [_vm._v("ion-android-share-alt")])], 1), _vm._v(" "), _c('v-navigation-drawer', {
    staticClass: "social-menu",
    attrs: {
      "width": "100vw",
      "height": "auto",
      "hide-overlay": "",
      "temporary": "",
      "clipped": "",
      "disable-route-watcher": "",
      "persistent": "",
      "touchless": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.socialMenu = !_vm.socialMenu
      }
    },
    model: {
      value: (_vm.socialMenu),
      callback: function($$v) {
        _vm.socialMenu = $$v
      },
      expression: "socialMenu"
    }
  }, [_c('v-list', [_c('span', [_vm._v("Share this book: ")]), _vm._v(" "), _vm._l((_vm.socials), function(social) {
    return _c('v-list-tile', {
      key: social.title,
      attrs: {
        "href": social.url,
        "target": "_blank"
      },
      on: {
        "click": function($event) {
          return _vm.shareClick(social.title)
        }
      }
    }, [_c('v-list-tile-action', [_c('v-icon', [_vm._v(_vm._s(social.icon))])], 1), _vm._v(" "), _c('v-list-tile-title', {
      domProps: {
        "innerHTML": _vm._s(social.title)
      }
    })], 1)
  })], 2)], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "info-btn",
    attrs: {
      "flat": "",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.info = !_vm.info, _vm.drawer = false, _vm.buyMenu = false, _vm.socialMenu = false, _vm.drawerRight = false
      }
    }
  }, [_c('v-icon', [_vm._v("ion-ios-information-outline")])], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "settings-button",
    attrs: {
      "flat": "",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawerRight = !_vm.drawerRight, _vm.info = false, _vm.buyMenu = false, _vm.socialMenu = false, _vm.drawer = false, _vm.otherBooks = false
      }
    }
  }, [_c('v-icon', [_vm._v("ion-ios-gear-outline")])], 1)], 1), _vm._v(" "), _c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('reader')], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Reader__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Reader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Reader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_home__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_home___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_home__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_text_cover__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_text_cover___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_text_cover__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_text_title_page__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_text_title_page___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_text_title_page__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_nav__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_nav___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_nav__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_text_ch001__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_text_ch001___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_text_ch001__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_text_ch002__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_text_ch002___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_text_ch002__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_text_ch003__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_text_ch003___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_text_ch003__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_text_ch004__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_text_ch004___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_text_ch004__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_text_ch005__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_text_ch005___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_text_ch005__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_text_ch006__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_text_ch006___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_text_ch006__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_text_ch007__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_text_ch007___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_text_ch007__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_text_ch008__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_text_ch008___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__components_text_ch008__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_last__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_last___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__components_last__);
/*jshint esversion: 6 */


















__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    "path": "/",
    "name": "home",
    "component": __WEBPACK_IMPORTED_MODULE_3__components_home___default.a
  }, {
    "path": "/nav",
    "name": "nav",
    "component": __WEBPACK_IMPORTED_MODULE_6__components_nav___default.a
  }, {
    "path": "/text/ch001",
    "name": "text/ch001",
    "component": __WEBPACK_IMPORTED_MODULE_7__components_text_ch001___default.a
  }, {
    "path": "/text/ch002",
    "name": "text/ch002",
    "component": __WEBPACK_IMPORTED_MODULE_8__components_text_ch002___default.a
  }, {
    "path": "/text/ch003",
    "name": "text/ch003",
    "component": __WEBPACK_IMPORTED_MODULE_9__components_text_ch003___default.a
  }, {
    "path": "/text/ch004",
    "name": "text/ch004",
    "component": __WEBPACK_IMPORTED_MODULE_10__components_text_ch004___default.a
  }, {
    "path": "/text/ch005",
    "name": "text/ch005",
    "component": __WEBPACK_IMPORTED_MODULE_11__components_text_ch005___default.a
  }, {
    "path": "/text/ch006",
    "name": "text/ch006",
    "component": __WEBPACK_IMPORTED_MODULE_12__components_text_ch006___default.a
  }, {
    "path": "/text/ch007",
    "name": "text/ch007",
    "component": __WEBPACK_IMPORTED_MODULE_13__components_text_ch007___default.a
  }, {
    "path": "/text/ch008",
    "name": "text/ch008",
    "component": __WEBPACK_IMPORTED_MODULE_14__components_text_ch008___default.a
  }, {
    "path": "/last",
    "name": "last",
    "component": __WEBPACK_IMPORTED_MODULE_15__components_last___default.a
  }]
}));

/***/ }),
/* 48 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
  * vue-router v2.8.1
  * (c) 2017 Evan You
  * @license MIT
  */
/*  */

function assert (condition, message) {
  if (!condition) {
    throw new Error(("[vue-router] " + message))
  }
}

function warn (condition, message) {
  if (false) {
    typeof console !== 'undefined' && console.warn(("[vue-router] " + message));
  }
}

function isError (err) {
  return Object.prototype.toString.call(err).indexOf('Error') > -1
}

var View = {
  name: 'router-view',
  functional: true,
  props: {
    name: {
      type: String,
      default: 'default'
    }
  },
  render: function render (_, ref) {
    var props = ref.props;
    var children = ref.children;
    var parent = ref.parent;
    var data = ref.data;

    data.routerView = true;

    // directly use parent context's createElement() function
    // so that components rendered by router-view can resolve named slots
    var h = parent.$createElement;
    var name = props.name;
    var route = parent.$route;
    var cache = parent._routerViewCache || (parent._routerViewCache = {});

    // determine current view depth, also check to see if the tree
    // has been toggled inactive but kept-alive.
    var depth = 0;
    var inactive = false;
    while (parent && parent._routerRoot !== parent) {
      if (parent.$vnode && parent.$vnode.data.routerView) {
        depth++;
      }
      if (parent._inactive) {
        inactive = true;
      }
      parent = parent.$parent;
    }
    data.routerViewDepth = depth;

    // render previous view if the tree is inactive and kept-alive
    if (inactive) {
      return h(cache[name], data, children)
    }

    var matched = route.matched[depth];
    // render empty node if no matched route
    if (!matched) {
      cache[name] = null;
      return h()
    }

    var component = cache[name] = matched.components[name];

    // attach instance registration hook
    // this will be called in the instance's injected lifecycle hooks
    data.registerRouteInstance = function (vm, val) {
      // val could be undefined for unregistration
      var current = matched.instances[name];
      if (
        (val && current !== vm) ||
        (!val && current === vm)
      ) {
        matched.instances[name] = val;
      }
    }

    // also register instance in prepatch hook
    // in case the same component instance is reused across different routes
    ;(data.hook || (data.hook = {})).prepatch = function (_, vnode) {
      matched.instances[name] = vnode.componentInstance;
    };

    // resolve props
    var propsToPass = data.props = resolveProps(route, matched.props && matched.props[name]);
    if (propsToPass) {
      // clone to prevent mutation
      propsToPass = data.props = extend({}, propsToPass);
      // pass non-declared props as attrs
      var attrs = data.attrs = data.attrs || {};
      for (var key in propsToPass) {
        if (!component.props || !(key in component.props)) {
          attrs[key] = propsToPass[key];
          delete propsToPass[key];
        }
      }
    }

    return h(component, data, children)
  }
};

function resolveProps (route, config) {
  switch (typeof config) {
    case 'undefined':
      return
    case 'object':
      return config
    case 'function':
      return config(route)
    case 'boolean':
      return config ? route.params : undefined
    default:
      if (false) {
        warn(
          false,
          "props in \"" + (route.path) + "\" is a " + (typeof config) + ", " +
          "expecting an object, function or boolean."
        );
      }
  }
}

function extend (to, from) {
  for (var key in from) {
    to[key] = from[key];
  }
  return to
}

/*  */

var encodeReserveRE = /[!'()*]/g;
var encodeReserveReplacer = function (c) { return '%' + c.charCodeAt(0).toString(16); };
var commaRE = /%2C/g;

// fixed encodeURIComponent which is more conformant to RFC3986:
// - escapes [!'()*]
// - preserve commas
var encode = function (str) { return encodeURIComponent(str)
  .replace(encodeReserveRE, encodeReserveReplacer)
  .replace(commaRE, ','); };

var decode = decodeURIComponent;

function resolveQuery (
  query,
  extraQuery,
  _parseQuery
) {
  if ( extraQuery === void 0 ) extraQuery = {};

  var parse = _parseQuery || parseQuery;
  var parsedQuery;
  try {
    parsedQuery = parse(query || '');
  } catch (e) {
    "production" !== 'production' && warn(false, e.message);
    parsedQuery = {};
  }
  for (var key in extraQuery) {
    parsedQuery[key] = extraQuery[key];
  }
  return parsedQuery
}

function parseQuery (query) {
  var res = {};

  query = query.trim().replace(/^(\?|#|&)/, '');

  if (!query) {
    return res
  }

  query.split('&').forEach(function (param) {
    var parts = param.replace(/\+/g, ' ').split('=');
    var key = decode(parts.shift());
    var val = parts.length > 0
      ? decode(parts.join('='))
      : null;

    if (res[key] === undefined) {
      res[key] = val;
    } else if (Array.isArray(res[key])) {
      res[key].push(val);
    } else {
      res[key] = [res[key], val];
    }
  });

  return res
}

function stringifyQuery (obj) {
  var res = obj ? Object.keys(obj).map(function (key) {
    var val = obj[key];

    if (val === undefined) {
      return ''
    }

    if (val === null) {
      return encode(key)
    }

    if (Array.isArray(val)) {
      var result = [];
      val.forEach(function (val2) {
        if (val2 === undefined) {
          return
        }
        if (val2 === null) {
          result.push(encode(key));
        } else {
          result.push(encode(key) + '=' + encode(val2));
        }
      });
      return result.join('&')
    }

    return encode(key) + '=' + encode(val)
  }).filter(function (x) { return x.length > 0; }).join('&') : null;
  return res ? ("?" + res) : ''
}

/*  */


var trailingSlashRE = /\/?$/;

function createRoute (
  record,
  location,
  redirectedFrom,
  router
) {
  var stringifyQuery$$1 = router && router.options.stringifyQuery;

  var query = location.query || {};
  try {
    query = clone(query);
  } catch (e) {}

  var route = {
    name: location.name || (record && record.name),
    meta: (record && record.meta) || {},
    path: location.path || '/',
    hash: location.hash || '',
    query: query,
    params: location.params || {},
    fullPath: getFullPath(location, stringifyQuery$$1),
    matched: record ? formatMatch(record) : []
  };
  if (redirectedFrom) {
    route.redirectedFrom = getFullPath(redirectedFrom, stringifyQuery$$1);
  }
  return Object.freeze(route)
}

function clone (value) {
  if (Array.isArray(value)) {
    return value.map(clone)
  } else if (value && typeof value === 'object') {
    var res = {};
    for (var key in value) {
      res[key] = clone(value[key]);
    }
    return res
  } else {
    return value
  }
}

// the starting route that represents the initial state
var START = createRoute(null, {
  path: '/'
});

function formatMatch (record) {
  var res = [];
  while (record) {
    res.unshift(record);
    record = record.parent;
  }
  return res
}

function getFullPath (
  ref,
  _stringifyQuery
) {
  var path = ref.path;
  var query = ref.query; if ( query === void 0 ) query = {};
  var hash = ref.hash; if ( hash === void 0 ) hash = '';

  var stringify = _stringifyQuery || stringifyQuery;
  return (path || '/') + stringify(query) + hash
}

function isSameRoute (a, b) {
  if (b === START) {
    return a === b
  } else if (!b) {
    return false
  } else if (a.path && b.path) {
    return (
      a.path.replace(trailingSlashRE, '') === b.path.replace(trailingSlashRE, '') &&
      a.hash === b.hash &&
      isObjectEqual(a.query, b.query)
    )
  } else if (a.name && b.name) {
    return (
      a.name === b.name &&
      a.hash === b.hash &&
      isObjectEqual(a.query, b.query) &&
      isObjectEqual(a.params, b.params)
    )
  } else {
    return false
  }
}

function isObjectEqual (a, b) {
  if ( a === void 0 ) a = {};
  if ( b === void 0 ) b = {};

  // handle null value #1566
  if (!a || !b) { return a === b }
  var aKeys = Object.keys(a);
  var bKeys = Object.keys(b);
  if (aKeys.length !== bKeys.length) {
    return false
  }
  return aKeys.every(function (key) {
    var aVal = a[key];
    var bVal = b[key];
    // check nested equality
    if (typeof aVal === 'object' && typeof bVal === 'object') {
      return isObjectEqual(aVal, bVal)
    }
    return String(aVal) === String(bVal)
  })
}

function isIncludedRoute (current, target) {
  return (
    current.path.replace(trailingSlashRE, '/').indexOf(
      target.path.replace(trailingSlashRE, '/')
    ) === 0 &&
    (!target.hash || current.hash === target.hash) &&
    queryIncludes(current.query, target.query)
  )
}

function queryIncludes (current, target) {
  for (var key in target) {
    if (!(key in current)) {
      return false
    }
  }
  return true
}

/*  */

// work around weird flow bug
var toTypes = [String, Object];
var eventTypes = [String, Array];

var Link = {
  name: 'router-link',
  props: {
    to: {
      type: toTypes,
      required: true
    },
    tag: {
      type: String,
      default: 'a'
    },
    exact: Boolean,
    append: Boolean,
    replace: Boolean,
    activeClass: String,
    exactActiveClass: String,
    event: {
      type: eventTypes,
      default: 'click'
    }
  },
  render: function render (h) {
    var this$1 = this;

    var router = this.$router;
    var current = this.$route;
    var ref = router.resolve(this.to, current, this.append);
    var location = ref.location;
    var route = ref.route;
    var href = ref.href;

    var classes = {};
    var globalActiveClass = router.options.linkActiveClass;
    var globalExactActiveClass = router.options.linkExactActiveClass;
    // Support global empty active class
    var activeClassFallback = globalActiveClass == null
            ? 'router-link-active'
            : globalActiveClass;
    var exactActiveClassFallback = globalExactActiveClass == null
            ? 'router-link-exact-active'
            : globalExactActiveClass;
    var activeClass = this.activeClass == null
            ? activeClassFallback
            : this.activeClass;
    var exactActiveClass = this.exactActiveClass == null
            ? exactActiveClassFallback
            : this.exactActiveClass;
    var compareTarget = location.path
      ? createRoute(null, location, null, router)
      : route;

    classes[exactActiveClass] = isSameRoute(current, compareTarget);
    classes[activeClass] = this.exact
      ? classes[exactActiveClass]
      : isIncludedRoute(current, compareTarget);

    var handler = function (e) {
      if (guardEvent(e)) {
        if (this$1.replace) {
          router.replace(location);
        } else {
          router.push(location);
        }
      }
    };

    var on = { click: guardEvent };
    if (Array.isArray(this.event)) {
      this.event.forEach(function (e) { on[e] = handler; });
    } else {
      on[this.event] = handler;
    }

    var data = {
      class: classes
    };

    if (this.tag === 'a') {
      data.on = on;
      data.attrs = { href: href };
    } else {
      // find the first <a> child and apply listener and href
      var a = findAnchor(this.$slots.default);
      if (a) {
        // in case the <a> is a static node
        a.isStatic = false;
        var extend = _Vue.util.extend;
        var aData = a.data = extend({}, a.data);
        aData.on = on;
        var aAttrs = a.data.attrs = extend({}, a.data.attrs);
        aAttrs.href = href;
      } else {
        // doesn't have <a> child, apply listener to self
        data.on = on;
      }
    }

    return h(this.tag, data, this.$slots.default)
  }
};

function guardEvent (e) {
  // don't redirect with control keys
  if (e.metaKey || e.altKey || e.ctrlKey || e.shiftKey) { return }
  // don't redirect when preventDefault called
  if (e.defaultPrevented) { return }
  // don't redirect on right click
  if (e.button !== undefined && e.button !== 0) { return }
  // don't redirect if `target="_blank"`
  if (e.currentTarget && e.currentTarget.getAttribute) {
    var target = e.currentTarget.getAttribute('target');
    if (/\b_blank\b/i.test(target)) { return }
  }
  // this may be a Weex event which doesn't have this method
  if (e.preventDefault) {
    e.preventDefault();
  }
  return true
}

function findAnchor (children) {
  if (children) {
    var child;
    for (var i = 0; i < children.length; i++) {
      child = children[i];
      if (child.tag === 'a') {
        return child
      }
      if (child.children && (child = findAnchor(child.children))) {
        return child
      }
    }
  }
}

var _Vue;

function install (Vue) {
  if (install.installed && _Vue === Vue) { return }
  install.installed = true;

  _Vue = Vue;

  var isDef = function (v) { return v !== undefined; };

  var registerInstance = function (vm, callVal) {
    var i = vm.$options._parentVnode;
    if (isDef(i) && isDef(i = i.data) && isDef(i = i.registerRouteInstance)) {
      i(vm, callVal);
    }
  };

  Vue.mixin({
    beforeCreate: function beforeCreate () {
      if (isDef(this.$options.router)) {
        this._routerRoot = this;
        this._router = this.$options.router;
        this._router.init(this);
        Vue.util.defineReactive(this, '_route', this._router.history.current);
      } else {
        this._routerRoot = (this.$parent && this.$parent._routerRoot) || this;
      }
      registerInstance(this, this);
    },
    destroyed: function destroyed () {
      registerInstance(this);
    }
  });

  Object.defineProperty(Vue.prototype, '$router', {
    get: function get () { return this._routerRoot._router }
  });

  Object.defineProperty(Vue.prototype, '$route', {
    get: function get () { return this._routerRoot._route }
  });

  Vue.component('router-view', View);
  Vue.component('router-link', Link);

  var strats = Vue.config.optionMergeStrategies;
  // use the same hook merging strategy for route hooks
  strats.beforeRouteEnter = strats.beforeRouteLeave = strats.beforeRouteUpdate = strats.created;
}

/*  */

var inBrowser = typeof window !== 'undefined';

/*  */

function resolvePath (
  relative,
  base,
  append
) {
  var firstChar = relative.charAt(0);
  if (firstChar === '/') {
    return relative
  }

  if (firstChar === '?' || firstChar === '#') {
    return base + relative
  }

  var stack = base.split('/');

  // remove trailing segment if:
  // - not appending
  // - appending to trailing slash (last segment is empty)
  if (!append || !stack[stack.length - 1]) {
    stack.pop();
  }

  // resolve relative path
  var segments = relative.replace(/^\//, '').split('/');
  for (var i = 0; i < segments.length; i++) {
    var segment = segments[i];
    if (segment === '..') {
      stack.pop();
    } else if (segment !== '.') {
      stack.push(segment);
    }
  }

  // ensure leading slash
  if (stack[0] !== '') {
    stack.unshift('');
  }

  return stack.join('/')
}

function parsePath (path) {
  var hash = '';
  var query = '';

  var hashIndex = path.indexOf('#');
  if (hashIndex >= 0) {
    hash = path.slice(hashIndex);
    path = path.slice(0, hashIndex);
  }

  var queryIndex = path.indexOf('?');
  if (queryIndex >= 0) {
    query = path.slice(queryIndex + 1);
    path = path.slice(0, queryIndex);
  }

  return {
    path: path,
    query: query,
    hash: hash
  }
}

function cleanPath (path) {
  return path.replace(/\/\//g, '/')
}

var isarray = Array.isArray || function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
};

/**
 * Expose `pathToRegexp`.
 */
var pathToRegexp_1 = pathToRegexp;
var parse_1 = parse;
var compile_1 = compile;
var tokensToFunction_1 = tokensToFunction;
var tokensToRegExp_1 = tokensToRegExp;

/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */
var PATH_REGEXP = new RegExp([
  // Match escaped characters that would otherwise appear in future matches.
  // This allows the user to escape special characters that won't transform.
  '(\\\\.)',
  // Match Express-style parameters and un-named parameters with a prefix
  // and optional suffixes. Matches appear as:
  //
  // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
  // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
  // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
  '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
].join('|'), 'g');

/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */
function parse (str, options) {
  var tokens = [];
  var key = 0;
  var index = 0;
  var path = '';
  var defaultDelimiter = options && options.delimiter || '/';
  var res;

  while ((res = PATH_REGEXP.exec(str)) != null) {
    var m = res[0];
    var escaped = res[1];
    var offset = res.index;
    path += str.slice(index, offset);
    index = offset + m.length;

    // Ignore already escaped sequences.
    if (escaped) {
      path += escaped[1];
      continue
    }

    var next = str[index];
    var prefix = res[2];
    var name = res[3];
    var capture = res[4];
    var group = res[5];
    var modifier = res[6];
    var asterisk = res[7];

    // Push the current path onto the tokens.
    if (path) {
      tokens.push(path);
      path = '';
    }

    var partial = prefix != null && next != null && next !== prefix;
    var repeat = modifier === '+' || modifier === '*';
    var optional = modifier === '?' || modifier === '*';
    var delimiter = res[2] || defaultDelimiter;
    var pattern = capture || group;

    tokens.push({
      name: name || key++,
      prefix: prefix || '',
      delimiter: delimiter,
      optional: optional,
      repeat: repeat,
      partial: partial,
      asterisk: !!asterisk,
      pattern: pattern ? escapeGroup(pattern) : (asterisk ? '.*' : '[^' + escapeString(delimiter) + ']+?')
    });
  }

  // Match any characters still remaining.
  if (index < str.length) {
    path += str.substr(index);
  }

  // If the path exists, push it onto the end.
  if (path) {
    tokens.push(path);
  }

  return tokens
}

/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */
function compile (str, options) {
  return tokensToFunction(parse(str, options))
}

/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */
function encodeURIComponentPretty (str) {
  return encodeURI(str).replace(/[\/?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */
function encodeAsterisk (str) {
  return encodeURI(str).replace(/[?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Expose a method for transforming tokens into the path function.
 */
function tokensToFunction (tokens) {
  // Compile all the tokens into regexps.
  var matches = new Array(tokens.length);

  // Compile all the patterns before compilation.
  for (var i = 0; i < tokens.length; i++) {
    if (typeof tokens[i] === 'object') {
      matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$');
    }
  }

  return function (obj, opts) {
    var path = '';
    var data = obj || {};
    var options = opts || {};
    var encode = options.pretty ? encodeURIComponentPretty : encodeURIComponent;

    for (var i = 0; i < tokens.length; i++) {
      var token = tokens[i];

      if (typeof token === 'string') {
        path += token;

        continue
      }

      var value = data[token.name];
      var segment;

      if (value == null) {
        if (token.optional) {
          // Prepend partial segment prefixes.
          if (token.partial) {
            path += token.prefix;
          }

          continue
        } else {
          throw new TypeError('Expected "' + token.name + '" to be defined')
        }
      }

      if (isarray(value)) {
        if (!token.repeat) {
          throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`')
        }

        if (value.length === 0) {
          if (token.optional) {
            continue
          } else {
            throw new TypeError('Expected "' + token.name + '" to not be empty')
          }
        }

        for (var j = 0; j < value.length; j++) {
          segment = encode(value[j]);

          if (!matches[i].test(segment)) {
            throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`')
          }

          path += (j === 0 ? token.prefix : token.delimiter) + segment;
        }

        continue
      }

      segment = token.asterisk ? encodeAsterisk(value) : encode(value);

      if (!matches[i].test(segment)) {
        throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"')
      }

      path += token.prefix + segment;
    }

    return path
  }
}

/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */
function escapeString (str) {
  return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1')
}

/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */
function escapeGroup (group) {
  return group.replace(/([=!:$\/()])/g, '\\$1')
}

/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */
function attachKeys (re, keys) {
  re.keys = keys;
  return re
}

/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */
function flags (options) {
  return options.sensitive ? '' : 'i'
}

/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */
function regexpToRegexp (path, keys) {
  // Use a negative lookahead to match only capturing groups.
  var groups = path.source.match(/\((?!\?)/g);

  if (groups) {
    for (var i = 0; i < groups.length; i++) {
      keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
      });
    }
  }

  return attachKeys(path, keys)
}

/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function arrayToRegexp (path, keys, options) {
  var parts = [];

  for (var i = 0; i < path.length; i++) {
    parts.push(pathToRegexp(path[i], keys, options).source);
  }

  var regexp = new RegExp('(?:' + parts.join('|') + ')', flags(options));

  return attachKeys(regexp, keys)
}

/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function stringToRegexp (path, keys, options) {
  return tokensToRegExp(parse(path, options), keys, options)
}

/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */
function tokensToRegExp (tokens, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options);
    keys = [];
  }

  options = options || {};

  var strict = options.strict;
  var end = options.end !== false;
  var route = '';

  // Iterate over the tokens and create our regexp string.
  for (var i = 0; i < tokens.length; i++) {
    var token = tokens[i];

    if (typeof token === 'string') {
      route += escapeString(token);
    } else {
      var prefix = escapeString(token.prefix);
      var capture = '(?:' + token.pattern + ')';

      keys.push(token);

      if (token.repeat) {
        capture += '(?:' + prefix + capture + ')*';
      }

      if (token.optional) {
        if (!token.partial) {
          capture = '(?:' + prefix + '(' + capture + '))?';
        } else {
          capture = prefix + '(' + capture + ')?';
        }
      } else {
        capture = prefix + '(' + capture + ')';
      }

      route += capture;
    }
  }

  var delimiter = escapeString(options.delimiter || '/');
  var endsWithDelimiter = route.slice(-delimiter.length) === delimiter;

  // In non-strict mode we allow a slash at the end of match. If the path to
  // match already ends with a slash, we remove it for consistency. The slash
  // is valid at the end of a path match, not in the middle. This is important
  // in non-ending mode, where "/test/" shouldn't match "/test//route".
  if (!strict) {
    route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?';
  }

  if (end) {
    route += '$';
  } else {
    // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)';
  }

  return attachKeys(new RegExp('^' + route, flags(options)), keys)
}

/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */
function pathToRegexp (path, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options);
    keys = [];
  }

  options = options || {};

  if (path instanceof RegExp) {
    return regexpToRegexp(path, /** @type {!Array} */ (keys))
  }

  if (isarray(path)) {
    return arrayToRegexp(/** @type {!Array} */ (path), /** @type {!Array} */ (keys), options)
  }

  return stringToRegexp(/** @type {string} */ (path), /** @type {!Array} */ (keys), options)
}

pathToRegexp_1.parse = parse_1;
pathToRegexp_1.compile = compile_1;
pathToRegexp_1.tokensToFunction = tokensToFunction_1;
pathToRegexp_1.tokensToRegExp = tokensToRegExp_1;

/*  */

// $flow-disable-line
var regexpCompileCache = Object.create(null);

function fillParams (
  path,
  params,
  routeMsg
) {
  try {
    var filler =
      regexpCompileCache[path] ||
      (regexpCompileCache[path] = pathToRegexp_1.compile(path));
    return filler(params || {}, { pretty: true })
  } catch (e) {
    if (false) {
      warn(false, ("missing param for " + routeMsg + ": " + (e.message)));
    }
    return ''
  }
}

/*  */

function createRouteMap (
  routes,
  oldPathList,
  oldPathMap,
  oldNameMap
) {
  // the path list is used to control path matching priority
  var pathList = oldPathList || [];
  // $flow-disable-line
  var pathMap = oldPathMap || Object.create(null);
  // $flow-disable-line
  var nameMap = oldNameMap || Object.create(null);

  routes.forEach(function (route) {
    addRouteRecord(pathList, pathMap, nameMap, route);
  });

  // ensure wildcard routes are always at the end
  for (var i = 0, l = pathList.length; i < l; i++) {
    if (pathList[i] === '*') {
      pathList.push(pathList.splice(i, 1)[0]);
      l--;
      i--;
    }
  }

  return {
    pathList: pathList,
    pathMap: pathMap,
    nameMap: nameMap
  }
}

function addRouteRecord (
  pathList,
  pathMap,
  nameMap,
  route,
  parent,
  matchAs
) {
  var path = route.path;
  var name = route.name;
  if (false) {
    assert(path != null, "\"path\" is required in a route configuration.");
    assert(
      typeof route.component !== 'string',
      "route config \"component\" for path: " + (String(path || name)) + " cannot be a " +
      "string id. Use an actual component instead."
    );
  }

  var pathToRegexpOptions = route.pathToRegexpOptions || {};
  var normalizedPath = normalizePath(
    path,
    parent,
    pathToRegexpOptions.strict
  );

  if (typeof route.caseSensitive === 'boolean') {
    pathToRegexpOptions.sensitive = route.caseSensitive;
  }

  var record = {
    path: normalizedPath,
    regex: compileRouteRegex(normalizedPath, pathToRegexpOptions),
    components: route.components || { default: route.component },
    instances: {},
    name: name,
    parent: parent,
    matchAs: matchAs,
    redirect: route.redirect,
    beforeEnter: route.beforeEnter,
    meta: route.meta || {},
    props: route.props == null
      ? {}
      : route.components
        ? route.props
        : { default: route.props }
  };

  if (route.children) {
    // Warn if route is named, does not redirect and has a default child route.
    // If users navigate to this route by name, the default child will
    // not be rendered (GH Issue #629)
    if (false) {
      if (route.name && !route.redirect && route.children.some(function (child) { return /^\/?$/.test(child.path); })) {
        warn(
          false,
          "Named Route '" + (route.name) + "' has a default child route. " +
          "When navigating to this named route (:to=\"{name: '" + (route.name) + "'\"), " +
          "the default child route will not be rendered. Remove the name from " +
          "this route and use the name of the default child route for named " +
          "links instead."
        );
      }
    }
    route.children.forEach(function (child) {
      var childMatchAs = matchAs
        ? cleanPath((matchAs + "/" + (child.path)))
        : undefined;
      addRouteRecord(pathList, pathMap, nameMap, child, record, childMatchAs);
    });
  }

  if (route.alias !== undefined) {
    var aliases = Array.isArray(route.alias)
      ? route.alias
      : [route.alias];

    aliases.forEach(function (alias) {
      var aliasRoute = {
        path: alias,
        children: route.children
      };
      addRouteRecord(
        pathList,
        pathMap,
        nameMap,
        aliasRoute,
        parent,
        record.path || '/' // matchAs
      );
    });
  }

  if (!pathMap[record.path]) {
    pathList.push(record.path);
    pathMap[record.path] = record;
  }

  if (name) {
    if (!nameMap[name]) {
      nameMap[name] = record;
    } else if (false) {
      warn(
        false,
        "Duplicate named routes definition: " +
        "{ name: \"" + name + "\", path: \"" + (record.path) + "\" }"
      );
    }
  }
}

function compileRouteRegex (path, pathToRegexpOptions) {
  var regex = pathToRegexp_1(path, [], pathToRegexpOptions);
  if (false) {
    var keys = Object.create(null);
    regex.keys.forEach(function (key) {
      warn(!keys[key.name], ("Duplicate param keys in route with path: \"" + path + "\""));
      keys[key.name] = true;
    });
  }
  return regex
}

function normalizePath (path, parent, strict) {
  if (!strict) { path = path.replace(/\/$/, ''); }
  if (path[0] === '/') { return path }
  if (parent == null) { return path }
  return cleanPath(((parent.path) + "/" + path))
}

/*  */


function normalizeLocation (
  raw,
  current,
  append,
  router
) {
  var next = typeof raw === 'string' ? { path: raw } : raw;
  // named target
  if (next.name || next._normalized) {
    return next
  }

  // relative params
  if (!next.path && next.params && current) {
    next = assign({}, next);
    next._normalized = true;
    var params = assign(assign({}, current.params), next.params);
    if (current.name) {
      next.name = current.name;
      next.params = params;
    } else if (current.matched.length) {
      var rawPath = current.matched[current.matched.length - 1].path;
      next.path = fillParams(rawPath, params, ("path " + (current.path)));
    } else if (false) {
      warn(false, "relative params navigation requires a current route.");
    }
    return next
  }

  var parsedPath = parsePath(next.path || '');
  var basePath = (current && current.path) || '/';
  var path = parsedPath.path
    ? resolvePath(parsedPath.path, basePath, append || next.append)
    : basePath;

  var query = resolveQuery(
    parsedPath.query,
    next.query,
    router && router.options.parseQuery
  );

  var hash = next.hash || parsedPath.hash;
  if (hash && hash.charAt(0) !== '#') {
    hash = "#" + hash;
  }

  return {
    _normalized: true,
    path: path,
    query: query,
    hash: hash
  }
}

function assign (a, b) {
  for (var key in b) {
    a[key] = b[key];
  }
  return a
}

/*  */


function createMatcher (
  routes,
  router
) {
  var ref = createRouteMap(routes);
  var pathList = ref.pathList;
  var pathMap = ref.pathMap;
  var nameMap = ref.nameMap;

  function addRoutes (routes) {
    createRouteMap(routes, pathList, pathMap, nameMap);
  }

  function match (
    raw,
    currentRoute,
    redirectedFrom
  ) {
    var location = normalizeLocation(raw, currentRoute, false, router);
    var name = location.name;

    if (name) {
      var record = nameMap[name];
      if (false) {
        warn(record, ("Route with name '" + name + "' does not exist"));
      }
      if (!record) { return _createRoute(null, location) }
      var paramNames = record.regex.keys
        .filter(function (key) { return !key.optional; })
        .map(function (key) { return key.name; });

      if (typeof location.params !== 'object') {
        location.params = {};
      }

      if (currentRoute && typeof currentRoute.params === 'object') {
        for (var key in currentRoute.params) {
          if (!(key in location.params) && paramNames.indexOf(key) > -1) {
            location.params[key] = currentRoute.params[key];
          }
        }
      }

      if (record) {
        location.path = fillParams(record.path, location.params, ("named route \"" + name + "\""));
        return _createRoute(record, location, redirectedFrom)
      }
    } else if (location.path) {
      location.params = {};
      for (var i = 0; i < pathList.length; i++) {
        var path = pathList[i];
        var record$1 = pathMap[path];
        if (matchRoute(record$1.regex, location.path, location.params)) {
          return _createRoute(record$1, location, redirectedFrom)
        }
      }
    }
    // no match
    return _createRoute(null, location)
  }

  function redirect (
    record,
    location
  ) {
    var originalRedirect = record.redirect;
    var redirect = typeof originalRedirect === 'function'
        ? originalRedirect(createRoute(record, location, null, router))
        : originalRedirect;

    if (typeof redirect === 'string') {
      redirect = { path: redirect };
    }

    if (!redirect || typeof redirect !== 'object') {
      if (false) {
        warn(
          false, ("invalid redirect option: " + (JSON.stringify(redirect)))
        );
      }
      return _createRoute(null, location)
    }

    var re = redirect;
    var name = re.name;
    var path = re.path;
    var query = location.query;
    var hash = location.hash;
    var params = location.params;
    query = re.hasOwnProperty('query') ? re.query : query;
    hash = re.hasOwnProperty('hash') ? re.hash : hash;
    params = re.hasOwnProperty('params') ? re.params : params;

    if (name) {
      // resolved named direct
      var targetRecord = nameMap[name];
      if (false) {
        assert(targetRecord, ("redirect failed: named route \"" + name + "\" not found."));
      }
      return match({
        _normalized: true,
        name: name,
        query: query,
        hash: hash,
        params: params
      }, undefined, location)
    } else if (path) {
      // 1. resolve relative redirect
      var rawPath = resolveRecordPath(path, record);
      // 2. resolve params
      var resolvedPath = fillParams(rawPath, params, ("redirect route with path \"" + rawPath + "\""));
      // 3. rematch with existing query and hash
      return match({
        _normalized: true,
        path: resolvedPath,
        query: query,
        hash: hash
      }, undefined, location)
    } else {
      if (false) {
        warn(false, ("invalid redirect option: " + (JSON.stringify(redirect))));
      }
      return _createRoute(null, location)
    }
  }

  function alias (
    record,
    location,
    matchAs
  ) {
    var aliasedPath = fillParams(matchAs, location.params, ("aliased route with path \"" + matchAs + "\""));
    var aliasedMatch = match({
      _normalized: true,
      path: aliasedPath
    });
    if (aliasedMatch) {
      var matched = aliasedMatch.matched;
      var aliasedRecord = matched[matched.length - 1];
      location.params = aliasedMatch.params;
      return _createRoute(aliasedRecord, location)
    }
    return _createRoute(null, location)
  }

  function _createRoute (
    record,
    location,
    redirectedFrom
  ) {
    if (record && record.redirect) {
      return redirect(record, redirectedFrom || location)
    }
    if (record && record.matchAs) {
      return alias(record, location, record.matchAs)
    }
    return createRoute(record, location, redirectedFrom, router)
  }

  return {
    match: match,
    addRoutes: addRoutes
  }
}

function matchRoute (
  regex,
  path,
  params
) {
  var m = path.match(regex);

  if (!m) {
    return false
  } else if (!params) {
    return true
  }

  for (var i = 1, len = m.length; i < len; ++i) {
    var key = regex.keys[i - 1];
    var val = typeof m[i] === 'string' ? decodeURIComponent(m[i]) : m[i];
    if (key) {
      params[key.name] = val;
    }
  }

  return true
}

function resolveRecordPath (path, record) {
  return resolvePath(path, record.parent ? record.parent.path : '/', true)
}

/*  */


var positionStore = Object.create(null);

function setupScroll () {
  // Fix for #1585 for Firefox
  window.history.replaceState({ key: getStateKey() }, '');
  window.addEventListener('popstate', function (e) {
    saveScrollPosition();
    if (e.state && e.state.key) {
      setStateKey(e.state.key);
    }
  });
}

function handleScroll (
  router,
  to,
  from,
  isPop
) {
  if (!router.app) {
    return
  }

  var behavior = router.options.scrollBehavior;
  if (!behavior) {
    return
  }

  if (false) {
    assert(typeof behavior === 'function', "scrollBehavior must be a function");
  }

  // wait until re-render finishes before scrolling
  router.app.$nextTick(function () {
    var position = getScrollPosition();
    var shouldScroll = behavior(to, from, isPop ? position : null);

    if (!shouldScroll) {
      return
    }

    if (typeof shouldScroll.then === 'function') {
      shouldScroll.then(function (shouldScroll) {
        scrollToPosition((shouldScroll), position);
      }).catch(function (err) {
        if (false) {
          assert(false, err.toString());
        }
      });
    } else {
      scrollToPosition(shouldScroll, position);
    }
  });
}

function saveScrollPosition () {
  var key = getStateKey();
  if (key) {
    positionStore[key] = {
      x: window.pageXOffset,
      y: window.pageYOffset
    };
  }
}

function getScrollPosition () {
  var key = getStateKey();
  if (key) {
    return positionStore[key]
  }
}

function getElementPosition (el, offset) {
  var docEl = document.documentElement;
  var docRect = docEl.getBoundingClientRect();
  var elRect = el.getBoundingClientRect();
  return {
    x: elRect.left - docRect.left - offset.x,
    y: elRect.top - docRect.top - offset.y
  }
}

function isValidPosition (obj) {
  return isNumber(obj.x) || isNumber(obj.y)
}

function normalizePosition (obj) {
  return {
    x: isNumber(obj.x) ? obj.x : window.pageXOffset,
    y: isNumber(obj.y) ? obj.y : window.pageYOffset
  }
}

function normalizeOffset (obj) {
  return {
    x: isNumber(obj.x) ? obj.x : 0,
    y: isNumber(obj.y) ? obj.y : 0
  }
}

function isNumber (v) {
  return typeof v === 'number'
}

function scrollToPosition (shouldScroll, position) {
  var isObject = typeof shouldScroll === 'object';
  if (isObject && typeof shouldScroll.selector === 'string') {
    var el = document.querySelector(shouldScroll.selector);
    if (el) {
      var offset = shouldScroll.offset && typeof shouldScroll.offset === 'object' ? shouldScroll.offset : {};
      offset = normalizeOffset(offset);
      position = getElementPosition(el, offset);
    } else if (isValidPosition(shouldScroll)) {
      position = normalizePosition(shouldScroll);
    }
  } else if (isObject && isValidPosition(shouldScroll)) {
    position = normalizePosition(shouldScroll);
  }

  if (position) {
    window.scrollTo(position.x, position.y);
  }
}

/*  */

var supportsPushState = inBrowser && (function () {
  var ua = window.navigator.userAgent;

  if (
    (ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) &&
    ua.indexOf('Mobile Safari') !== -1 &&
    ua.indexOf('Chrome') === -1 &&
    ua.indexOf('Windows Phone') === -1
  ) {
    return false
  }

  return window.history && 'pushState' in window.history
})();

// use User Timing api (if present) for more accurate key precision
var Time = inBrowser && window.performance && window.performance.now
  ? window.performance
  : Date;

var _key = genKey();

function genKey () {
  return Time.now().toFixed(3)
}

function getStateKey () {
  return _key
}

function setStateKey (key) {
  _key = key;
}

function pushState (url, replace) {
  saveScrollPosition();
  // try...catch the pushState call to get around Safari
  // DOM Exception 18 where it limits to 100 pushState calls
  var history = window.history;
  try {
    if (replace) {
      history.replaceState({ key: _key }, '', url);
    } else {
      _key = genKey();
      history.pushState({ key: _key }, '', url);
    }
  } catch (e) {
    window.location[replace ? 'replace' : 'assign'](url);
  }
}

function replaceState (url) {
  pushState(url, true);
}

/*  */

function runQueue (queue, fn, cb) {
  var step = function (index) {
    if (index >= queue.length) {
      cb();
    } else {
      if (queue[index]) {
        fn(queue[index], function () {
          step(index + 1);
        });
      } else {
        step(index + 1);
      }
    }
  };
  step(0);
}

/*  */

function resolveAsyncComponents (matched) {
  return function (to, from, next) {
    var hasAsync = false;
    var pending = 0;
    var error = null;

    flatMapComponents(matched, function (def, _, match, key) {
      // if it's a function and doesn't have cid attached,
      // assume it's an async component resolve function.
      // we are not using Vue's default async resolving mechanism because
      // we want to halt the navigation until the incoming component has been
      // resolved.
      if (typeof def === 'function' && def.cid === undefined) {
        hasAsync = true;
        pending++;

        var resolve = once(function (resolvedDef) {
          if (isESModule(resolvedDef)) {
            resolvedDef = resolvedDef.default;
          }
          // save resolved on async factory in case it's used elsewhere
          def.resolved = typeof resolvedDef === 'function'
            ? resolvedDef
            : _Vue.extend(resolvedDef);
          match.components[key] = resolvedDef;
          pending--;
          if (pending <= 0) {
            next();
          }
        });

        var reject = once(function (reason) {
          var msg = "Failed to resolve async component " + key + ": " + reason;
          "production" !== 'production' && warn(false, msg);
          if (!error) {
            error = isError(reason)
              ? reason
              : new Error(msg);
            next(error);
          }
        });

        var res;
        try {
          res = def(resolve, reject);
        } catch (e) {
          reject(e);
        }
        if (res) {
          if (typeof res.then === 'function') {
            res.then(resolve, reject);
          } else {
            // new syntax in Vue 2.3
            var comp = res.component;
            if (comp && typeof comp.then === 'function') {
              comp.then(resolve, reject);
            }
          }
        }
      }
    });

    if (!hasAsync) { next(); }
  }
}

function flatMapComponents (
  matched,
  fn
) {
  return flatten(matched.map(function (m) {
    return Object.keys(m.components).map(function (key) { return fn(
      m.components[key],
      m.instances[key],
      m, key
    ); })
  }))
}

function flatten (arr) {
  return Array.prototype.concat.apply([], arr)
}

var hasSymbol =
  typeof Symbol === 'function' &&
  typeof Symbol.toStringTag === 'symbol';

function isESModule (obj) {
  return obj.__esModule || (hasSymbol && obj[Symbol.toStringTag] === 'Module')
}

// in Webpack 2, require.ensure now also returns a Promise
// so the resolve/reject functions may get called an extra time
// if the user uses an arrow function shorthand that happens to
// return that Promise.
function once (fn) {
  var called = false;
  return function () {
    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];

    if (called) { return }
    called = true;
    return fn.apply(this, args)
  }
}

/*  */

var History = function History (router, base) {
  this.router = router;
  this.base = normalizeBase(base);
  // start with a route object that stands for "nowhere"
  this.current = START;
  this.pending = null;
  this.ready = false;
  this.readyCbs = [];
  this.readyErrorCbs = [];
  this.errorCbs = [];
};

History.prototype.listen = function listen (cb) {
  this.cb = cb;
};

History.prototype.onReady = function onReady (cb, errorCb) {
  if (this.ready) {
    cb();
  } else {
    this.readyCbs.push(cb);
    if (errorCb) {
      this.readyErrorCbs.push(errorCb);
    }
  }
};

History.prototype.onError = function onError (errorCb) {
  this.errorCbs.push(errorCb);
};

History.prototype.transitionTo = function transitionTo (location, onComplete, onAbort) {
    var this$1 = this;

  var route = this.router.match(location, this.current);
  this.confirmTransition(route, function () {
    this$1.updateRoute(route);
    onComplete && onComplete(route);
    this$1.ensureURL();

    // fire ready cbs once
    if (!this$1.ready) {
      this$1.ready = true;
      this$1.readyCbs.forEach(function (cb) { cb(route); });
    }
  }, function (err) {
    if (onAbort) {
      onAbort(err);
    }
    if (err && !this$1.ready) {
      this$1.ready = true;
      this$1.readyErrorCbs.forEach(function (cb) { cb(err); });
    }
  });
};

History.prototype.confirmTransition = function confirmTransition (route, onComplete, onAbort) {
    var this$1 = this;

  var current = this.current;
  var abort = function (err) {
    if (isError(err)) {
      if (this$1.errorCbs.length) {
        this$1.errorCbs.forEach(function (cb) { cb(err); });
      } else {
        warn(false, 'uncaught error during route navigation:');
        console.error(err);
      }
    }
    onAbort && onAbort(err);
  };
  if (
    isSameRoute(route, current) &&
    // in the case the route map has been dynamically appended to
    route.matched.length === current.matched.length
  ) {
    this.ensureURL();
    return abort()
  }

  var ref = resolveQueue(this.current.matched, route.matched);
    var updated = ref.updated;
    var deactivated = ref.deactivated;
    var activated = ref.activated;

  var queue = [].concat(
    // in-component leave guards
    extractLeaveGuards(deactivated),
    // global before hooks
    this.router.beforeHooks,
    // in-component update hooks
    extractUpdateHooks(updated),
    // in-config enter guards
    activated.map(function (m) { return m.beforeEnter; }),
    // async components
    resolveAsyncComponents(activated)
  );

  this.pending = route;
  var iterator = function (hook, next) {
    if (this$1.pending !== route) {
      return abort()
    }
    try {
      hook(route, current, function (to) {
        if (to === false || isError(to)) {
          // next(false) -> abort navigation, ensure current URL
          this$1.ensureURL(true);
          abort(to);
        } else if (
          typeof to === 'string' ||
          (typeof to === 'object' && (
            typeof to.path === 'string' ||
            typeof to.name === 'string'
          ))
        ) {
          // next('/') or next({ path: '/' }) -> redirect
          abort();
          if (typeof to === 'object' && to.replace) {
            this$1.replace(to);
          } else {
            this$1.push(to);
          }
        } else {
          // confirm transition and pass on the value
          next(to);
        }
      });
    } catch (e) {
      abort(e);
    }
  };

  runQueue(queue, iterator, function () {
    var postEnterCbs = [];
    var isValid = function () { return this$1.current === route; };
    // wait until async components are resolved before
    // extracting in-component enter guards
    var enterGuards = extractEnterGuards(activated, postEnterCbs, isValid);
    var queue = enterGuards.concat(this$1.router.resolveHooks);
    runQueue(queue, iterator, function () {
      if (this$1.pending !== route) {
        return abort()
      }
      this$1.pending = null;
      onComplete(route);
      if (this$1.router.app) {
        this$1.router.app.$nextTick(function () {
          postEnterCbs.forEach(function (cb) { cb(); });
        });
      }
    });
  });
};

History.prototype.updateRoute = function updateRoute (route) {
  var prev = this.current;
  this.current = route;
  this.cb && this.cb(route);
  this.router.afterHooks.forEach(function (hook) {
    hook && hook(route, prev);
  });
};

function normalizeBase (base) {
  if (!base) {
    if (inBrowser) {
      // respect <base> tag
      var baseEl = document.querySelector('base');
      base = (baseEl && baseEl.getAttribute('href')) || '/';
      // strip full URL origin
      base = base.replace(/^https?:\/\/[^\/]+/, '');
    } else {
      base = '/';
    }
  }
  // make sure there's the starting slash
  if (base.charAt(0) !== '/') {
    base = '/' + base;
  }
  // remove trailing slash
  return base.replace(/\/$/, '')
}

function resolveQueue (
  current,
  next
) {
  var i;
  var max = Math.max(current.length, next.length);
  for (i = 0; i < max; i++) {
    if (current[i] !== next[i]) {
      break
    }
  }
  return {
    updated: next.slice(0, i),
    activated: next.slice(i),
    deactivated: current.slice(i)
  }
}

function extractGuards (
  records,
  name,
  bind,
  reverse
) {
  var guards = flatMapComponents(records, function (def, instance, match, key) {
    var guard = extractGuard(def, name);
    if (guard) {
      return Array.isArray(guard)
        ? guard.map(function (guard) { return bind(guard, instance, match, key); })
        : bind(guard, instance, match, key)
    }
  });
  return flatten(reverse ? guards.reverse() : guards)
}

function extractGuard (
  def,
  key
) {
  if (typeof def !== 'function') {
    // extend now so that global mixins are applied.
    def = _Vue.extend(def);
  }
  return def.options[key]
}

function extractLeaveGuards (deactivated) {
  return extractGuards(deactivated, 'beforeRouteLeave', bindGuard, true)
}

function extractUpdateHooks (updated) {
  return extractGuards(updated, 'beforeRouteUpdate', bindGuard)
}

function bindGuard (guard, instance) {
  if (instance) {
    return function boundRouteGuard () {
      return guard.apply(instance, arguments)
    }
  }
}

function extractEnterGuards (
  activated,
  cbs,
  isValid
) {
  return extractGuards(activated, 'beforeRouteEnter', function (guard, _, match, key) {
    return bindEnterGuard(guard, match, key, cbs, isValid)
  })
}

function bindEnterGuard (
  guard,
  match,
  key,
  cbs,
  isValid
) {
  return function routeEnterGuard (to, from, next) {
    return guard(to, from, function (cb) {
      next(cb);
      if (typeof cb === 'function') {
        cbs.push(function () {
          // #750
          // if a router-view is wrapped with an out-in transition,
          // the instance may not have been registered at this time.
          // we will need to poll for registration until current route
          // is no longer valid.
          poll(cb, match.instances, key, isValid);
        });
      }
    })
  }
}

function poll (
  cb, // somehow flow cannot infer this is a function
  instances,
  key,
  isValid
) {
  if (instances[key]) {
    cb(instances[key]);
  } else if (isValid()) {
    setTimeout(function () {
      poll(cb, instances, key, isValid);
    }, 16);
  }
}

/*  */


var HTML5History = (function (History$$1) {
  function HTML5History (router, base) {
    var this$1 = this;

    History$$1.call(this, router, base);

    var expectScroll = router.options.scrollBehavior;

    if (expectScroll) {
      setupScroll();
    }

    var initLocation = getLocation(this.base);
    window.addEventListener('popstate', function (e) {
      var current = this$1.current;

      // Avoiding first `popstate` event dispatched in some browsers but first
      // history route not updated since async guard at the same time.
      var location = getLocation(this$1.base);
      if (this$1.current === START && location === initLocation) {
        return
      }

      this$1.transitionTo(location, function (route) {
        if (expectScroll) {
          handleScroll(router, route, current, true);
        }
      });
    });
  }

  if ( History$$1 ) HTML5History.__proto__ = History$$1;
  HTML5History.prototype = Object.create( History$$1 && History$$1.prototype );
  HTML5History.prototype.constructor = HTML5History;

  HTML5History.prototype.go = function go (n) {
    window.history.go(n);
  };

  HTML5History.prototype.push = function push (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      pushState(cleanPath(this$1.base + route.fullPath));
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HTML5History.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      replaceState(cleanPath(this$1.base + route.fullPath));
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HTML5History.prototype.ensureURL = function ensureURL (push) {
    if (getLocation(this.base) !== this.current.fullPath) {
      var current = cleanPath(this.base + this.current.fullPath);
      push ? pushState(current) : replaceState(current);
    }
  };

  HTML5History.prototype.getCurrentLocation = function getCurrentLocation () {
    return getLocation(this.base)
  };

  return HTML5History;
}(History));

function getLocation (base) {
  var path = window.location.pathname;
  if (base && path.indexOf(base) === 0) {
    path = path.slice(base.length);
  }
  return (path || '/') + window.location.search + window.location.hash
}

/*  */


var HashHistory = (function (History$$1) {
  function HashHistory (router, base, fallback) {
    History$$1.call(this, router, base);
    // check history fallback deeplinking
    if (fallback && checkFallback(this.base)) {
      return
    }
    ensureSlash();
  }

  if ( History$$1 ) HashHistory.__proto__ = History$$1;
  HashHistory.prototype = Object.create( History$$1 && History$$1.prototype );
  HashHistory.prototype.constructor = HashHistory;

  // this is delayed until the app mounts
  // to avoid the hashchange listener being fired too early
  HashHistory.prototype.setupListeners = function setupListeners () {
    var this$1 = this;

    var router = this.router;
    var expectScroll = router.options.scrollBehavior;
    var supportsScroll = supportsPushState && expectScroll;

    if (supportsScroll) {
      setupScroll();
    }

    window.addEventListener(supportsPushState ? 'popstate' : 'hashchange', function () {
      var current = this$1.current;
      if (!ensureSlash()) {
        return
      }
      this$1.transitionTo(getHash(), function (route) {
        if (supportsScroll) {
          handleScroll(this$1.router, route, current, true);
        }
        if (!supportsPushState) {
          replaceHash(route.fullPath);
        }
      });
    });
  };

  HashHistory.prototype.push = function push (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      pushHash(route.fullPath);
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HashHistory.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      replaceHash(route.fullPath);
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HashHistory.prototype.go = function go (n) {
    window.history.go(n);
  };

  HashHistory.prototype.ensureURL = function ensureURL (push) {
    var current = this.current.fullPath;
    if (getHash() !== current) {
      push ? pushHash(current) : replaceHash(current);
    }
  };

  HashHistory.prototype.getCurrentLocation = function getCurrentLocation () {
    return getHash()
  };

  return HashHistory;
}(History));

function checkFallback (base) {
  var location = getLocation(base);
  if (!/^\/#/.test(location)) {
    window.location.replace(
      cleanPath(base + '/#' + location)
    );
    return true
  }
}

function ensureSlash () {
  var path = getHash();
  if (path.charAt(0) === '/') {
    return true
  }
  replaceHash('/' + path);
  return false
}

function getHash () {
  // We can't use window.location.hash here because it's not
  // consistent across browsers - Firefox will pre-decode it!
  var href = window.location.href;
  var index = href.indexOf('#');
  return index === -1 ? '' : href.slice(index + 1)
}

function getUrl (path) {
  var href = window.location.href;
  var i = href.indexOf('#');
  var base = i >= 0 ? href.slice(0, i) : href;
  return (base + "#" + path)
}

function pushHash (path) {
  if (supportsPushState) {
    pushState(getUrl(path));
  } else {
    window.location.hash = path;
  }
}

function replaceHash (path) {
  if (supportsPushState) {
    replaceState(getUrl(path));
  } else {
    window.location.replace(getUrl(path));
  }
}

/*  */


var AbstractHistory = (function (History$$1) {
  function AbstractHistory (router, base) {
    History$$1.call(this, router, base);
    this.stack = [];
    this.index = -1;
  }

  if ( History$$1 ) AbstractHistory.__proto__ = History$$1;
  AbstractHistory.prototype = Object.create( History$$1 && History$$1.prototype );
  AbstractHistory.prototype.constructor = AbstractHistory;

  AbstractHistory.prototype.push = function push (location, onComplete, onAbort) {
    var this$1 = this;

    this.transitionTo(location, function (route) {
      this$1.stack = this$1.stack.slice(0, this$1.index + 1).concat(route);
      this$1.index++;
      onComplete && onComplete(route);
    }, onAbort);
  };

  AbstractHistory.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1 = this;

    this.transitionTo(location, function (route) {
      this$1.stack = this$1.stack.slice(0, this$1.index).concat(route);
      onComplete && onComplete(route);
    }, onAbort);
  };

  AbstractHistory.prototype.go = function go (n) {
    var this$1 = this;

    var targetIndex = this.index + n;
    if (targetIndex < 0 || targetIndex >= this.stack.length) {
      return
    }
    var route = this.stack[targetIndex];
    this.confirmTransition(route, function () {
      this$1.index = targetIndex;
      this$1.updateRoute(route);
    });
  };

  AbstractHistory.prototype.getCurrentLocation = function getCurrentLocation () {
    var current = this.stack[this.stack.length - 1];
    return current ? current.fullPath : '/'
  };

  AbstractHistory.prototype.ensureURL = function ensureURL () {
    // noop
  };

  return AbstractHistory;
}(History));

/*  */

var VueRouter = function VueRouter (options) {
  if ( options === void 0 ) options = {};

  this.app = null;
  this.apps = [];
  this.options = options;
  this.beforeHooks = [];
  this.resolveHooks = [];
  this.afterHooks = [];
  this.matcher = createMatcher(options.routes || [], this);

  var mode = options.mode || 'hash';
  this.fallback = mode === 'history' && !supportsPushState && options.fallback !== false;
  if (this.fallback) {
    mode = 'hash';
  }
  if (!inBrowser) {
    mode = 'abstract';
  }
  this.mode = mode;

  switch (mode) {
    case 'history':
      this.history = new HTML5History(this, options.base);
      break
    case 'hash':
      this.history = new HashHistory(this, options.base, this.fallback);
      break
    case 'abstract':
      this.history = new AbstractHistory(this, options.base);
      break
    default:
      if (false) {
        assert(false, ("invalid mode: " + mode));
      }
  }
};

var prototypeAccessors = { currentRoute: { configurable: true } };

VueRouter.prototype.match = function match (
  raw,
  current,
  redirectedFrom
) {
  return this.matcher.match(raw, current, redirectedFrom)
};

prototypeAccessors.currentRoute.get = function () {
  return this.history && this.history.current
};

VueRouter.prototype.init = function init (app /* Vue component instance */) {
    var this$1 = this;

  "production" !== 'production' && assert(
    install.installed,
    "not installed. Make sure to call `Vue.use(VueRouter)` " +
    "before creating root instance."
  );

  this.apps.push(app);

  // main app already initialized.
  if (this.app) {
    return
  }

  this.app = app;

  var history = this.history;

  if (history instanceof HTML5History) {
    history.transitionTo(history.getCurrentLocation());
  } else if (history instanceof HashHistory) {
    var setupHashListener = function () {
      history.setupListeners();
    };
    history.transitionTo(
      history.getCurrentLocation(),
      setupHashListener,
      setupHashListener
    );
  }

  history.listen(function (route) {
    this$1.apps.forEach(function (app) {
      app._route = route;
    });
  });
};

VueRouter.prototype.beforeEach = function beforeEach (fn) {
  return registerHook(this.beforeHooks, fn)
};

VueRouter.prototype.beforeResolve = function beforeResolve (fn) {
  return registerHook(this.resolveHooks, fn)
};

VueRouter.prototype.afterEach = function afterEach (fn) {
  return registerHook(this.afterHooks, fn)
};

VueRouter.prototype.onReady = function onReady (cb, errorCb) {
  this.history.onReady(cb, errorCb);
};

VueRouter.prototype.onError = function onError (errorCb) {
  this.history.onError(errorCb);
};

VueRouter.prototype.push = function push (location, onComplete, onAbort) {
  this.history.push(location, onComplete, onAbort);
};

VueRouter.prototype.replace = function replace (location, onComplete, onAbort) {
  this.history.replace(location, onComplete, onAbort);
};

VueRouter.prototype.go = function go (n) {
  this.history.go(n);
};

VueRouter.prototype.back = function back () {
  this.go(-1);
};

VueRouter.prototype.forward = function forward () {
  this.go(1);
};

VueRouter.prototype.getMatchedComponents = function getMatchedComponents (to) {
  var route = to
    ? to.matched
      ? to
      : this.resolve(to).route
    : this.currentRoute;
  if (!route) {
    return []
  }
  return [].concat.apply([], route.matched.map(function (m) {
    return Object.keys(m.components).map(function (key) {
      return m.components[key]
    })
  }))
};

VueRouter.prototype.resolve = function resolve (
  to,
  current,
  append
) {
  var location = normalizeLocation(
    to,
    current || this.history.current,
    append,
    this
  );
  var route = this.match(location, current);
  var fullPath = route.redirectedFrom || route.fullPath;
  var base = this.history.base;
  var href = createHref(base, fullPath, this.mode);
  return {
    location: location,
    route: route,
    href: href,
    // for backwards compat
    normalizedTo: location,
    resolved: route
  }
};

VueRouter.prototype.addRoutes = function addRoutes (routes) {
  this.matcher.addRoutes(routes);
  if (this.history.current !== START) {
    this.history.transitionTo(this.history.getCurrentLocation());
  }
};

Object.defineProperties( VueRouter.prototype, prototypeAccessors );

function registerHook (list, fn) {
  list.push(fn);
  return function () {
    var i = list.indexOf(fn);
    if (i > -1) { list.splice(i, 1); }
  }
}

function createHref (base, fullPath, mode) {
  var path = mode === 'hash' ? '#' + fullPath : fullPath;
  return base ? cleanPath(base + '/' + path) : path
}

VueRouter.install = install;
VueRouter.version = '2.8.1';

if (inBrowser && window.Vue) {
  window.Vue.use(VueRouter);
}

/* harmony default export */ __webpack_exports__["a"] = (VueRouter);


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(50),
  /* template */
  __webpack_require__(51),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import Navigation from '@/components/Navigation'
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'home',
  data: function data() {
    return {};
  },

  components: {
    // 'navigation': Navigation
  }
});

/***/ }),
/* 51 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/20YyQW/media/FC-9798886937848.jpg?1689450778405",
      "alt": "This image is the cover for the book Thirst at Night"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Thirst at Night\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', {
    staticStyle: {
      "margin-top": "0cm",
      "margin-right": "0cm",
      "margin-bottom": "8.0pt",
      "margin-left": "0cm",
      "font-size": "15px",
      "font-family": "\"Calibri\",sans-serif"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "16px",
      "font-family": "\"Arial Nova\",sans-serif"
    }
  }, [_vm._v("Transport yourself to Transylvania in the 14th century with this thrilling novel that combines fantasy, horror, and romance. With lords, dukes, duchesses, vampires, and pirates, this book has something for everyone!")])]), _c('p', {
    staticStyle: {
      "margin-top": "0cm",
      "margin-right": "0cm",
      "margin-bottom": "8.0pt",
      "margin-left": "0cm",
      "font-size": "15px",
      "font-family": "\"Calibri\",sans-serif"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "16px",
      "font-family": "\"Arial Nova\",sans-serif"
    }
  }, [_vm._v("Lord Armando, tired of his fruitless relations and visits to the tavern, finds himself drawn into the dangerous world of vampire slaying. Lady Roseabella, the eldest daughter of a duke and a duchess, longs to break free from her castle and explore the world beyond. And Garrett, Armando’s cousin, gets lost in the vampire life, leading to unexpected consequences.")])]), _c('p', {
    staticStyle: {
      "margin-top": "0cm",
      "margin-right": "0cm",
      "margin-bottom": "8.0pt",
      "margin-left": "0cm",
      "font-size": "15px",
      "font-family": "\"Calibri\",sans-serif"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "16px",
      "font-family": "\"Arial Nova\",sans-serif"
    }
  }, [_vm._v("But the characters don’t stop there. Meiga, the cook for the count’s castle, creates succulent meals that will make your mouth water. And her granddaughter, little Saige, possesses a powerful gift that will eventually help in the fight against the thirsty vampires.")])]), _c('p', {
    staticStyle: {
      "margin-top": "0cm",
      "margin-right": "0cm",
      "margin-bottom": "8.0pt",
      "margin-left": "0cm",
      "font-size": "15px",
      "font-family": "\"Calibri\",sans-serif"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "16px",
      "font-family": "\"Arial Nova\",sans-serif"
    }
  }, [_vm._v("This gripping and intense read will have you on the edge of your seat, balancing vampire fights with steamy romance and a classic nobility. And with strong themes of devotion and love for family, you’ll find yourself falling in love with the characters as they navigate the treacherous world of Transylvania.")])]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Bella Perry\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }), _c('p', {
    staticStyle: {
      "margin": "0cm",
      "margin-bottom": ".0001pt",
      "font-size": "15px",
      "font-family": "\"Calibri\",sans-serif",
      "text-align": "justify"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "\"Times New Roman\",serif"
    }
  }, [_vm._v("Bella and her husband and her family resides in NL, in a small-town call St. Albans. She comes from a family of 13 children, there are seven brothers and six sisters. She loves the outdoors and loves to spend time in her little cottage by a beautiful river that is famous of salmon fishing. She is a nature lover. In her dreams Bella always felt she was from the past, always on a horse with a war party defending her village a woman warrior. Her passion for telling stories and writing is contagious.")])]), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Austin Macauley Publishers\n   ")])])])
}]}

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(53),
  /* template */
  __webpack_require__(54),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 53 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 54 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [
    [_c('div', {
      staticClass: "chapter"
    }, [_c('div', {
      staticClass: "inner_page"
    }, [
      [_vm._m(0)]
    ], 2)])]
  ], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(56),
  /* template */
  __webpack_require__(57),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 56 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 57 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [
    [_c('div', {
      staticClass: "chapter"
    }, [_c('div', {
      staticClass: "inner_page"
    }, [
      [_vm._m(0)]
    ], 2)])]
  ], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(59),
  /* template */
  __webpack_require__(60),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 59 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 60 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "toc"
    }
  }, [_c('h1', {
    attrs: {
      "id": "toc-title"
    }
  }, [_vm._v("Thirst at Night")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch001#about-the-author"
    }
  }, [_vm._v("About the Author")])]), _c('li', {
    attrs: {
      "id": "toc-li-2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch002#dedication"
    }
  }, [_vm._v("Dedication")])]), _c('li', {
    attrs: {
      "id": "toc-li-3"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch003#copyright-information"
    }
  }, [_vm._v("Copyright Information ©")])]), _c('li', {
    attrs: {
      "id": "toc-li-4"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch004#acknowledgment"
    }
  }, [_vm._v("Acknowledgment")])]), _c('li', {
    attrs: {
      "id": "toc-li-5"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch005#characters"
    }
  }, [_vm._v("Characters")])]), _c('li', {
    attrs: {
      "id": "toc-li-6"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch006#finding-a-wife"
    }
  }, [_vm._v("Finding a Wife")])]), _c('li', {
    attrs: {
      "id": "toc-li-7"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch007#the-dukes-castle"
    }
  }, [_vm._v("The Duke’s Castle")])]), _c('li', {
    attrs: {
      "id": "toc-li-8"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch008#meeting-roseabella"
    }
  }, [_vm._v("Meeting Roseabella")])])])])])])
}]}

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(62),
  /* template */
  __webpack_require__(63),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 62 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 63 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "about-the-author"
    }
  }, [_c('h1', [_vm._v("About the Author")]), _vm._v(" "), _c('p', [_vm._v("Bella and her husband and her family resides in NL, in a small-town call St. Albans. She comes from a family of 13 children, there are seven brothers and six sisters. She loves the outdoors and loves to spend time in her little cottage by a beautiful river that is famous of salmon fishing. She is a nature lover. In her dreams Bella always felt she was from the past, always on a horse with a war party defending her village a woman warrior. Her passion for telling stories and writing is contagious.")])])])])
}]}

/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(65),
  /* template */
  __webpack_require__(66),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 65 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 66 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "dedication"
    }
  }, [_c('h1', [_vm._v("Dedication")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("I would like to dedicate to my sister, Marina, for believing in me, taking the time to read my work and getting it typed into the pdf file and to submit my work to publishing companies.")])])])])
}]}

/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(68),
  /* template */
  __webpack_require__(69),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 68 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 69 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "copyright-information"
    }
  }, [_c('h1', [_vm._v("Copyright Information ©")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Bella Perry 2023")])]), _c('br'), _vm._v(" "), _c('p', [_vm._v("All rights reserved. No part of this publication may be reproduced, distributed, or transmitted in any form or by any means, including photocopying, recording, or other electronic or mechanical methods, without the prior written permission of the publisher, except in the case of brief quotations embodied in critical reviews and certain other non-commercial uses permitted by copyright law. For permission requests, write to the publisher.")]), _c('br'), _vm._v(" "), _c('p', [_vm._v("Any person who commits any unauthorized act in relation to this publication may be liable to criminal prosecution and civil claims for damages.")]), _c('br'), _vm._v(" "), _c('p', [_vm._v("This is a work of fiction. Names, characters, businesses, places, events, locales, and incidents are either the products of the author’s imagination or used in a fictitious manner. Any resemblance to actual persons, living or dead, or actual events is purely coincidental.")]), _c('br'), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Ordering Information")])]), _vm._v(" "), _c('p', [_vm._v("Quantity sales: Special discounts are available on quantity purchases by corporations, associations, and others. For details, contact the publisher at the address below.")]), _c('br'), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Publisher’s Cataloging-in-Publication data")])]), _vm._v(" "), _c('p', [_vm._v("Perry, Bella")]), _vm._v(" "), _c('p', [_vm._v("Thirst at Night")]), _c('br'), _vm._v(" "), _c('p', [_vm._v("ISBN 9798886937831 (Paperback)")]), _vm._v(" "), _c('p', [_vm._v("ISBN 9798886937848 (ePub e-book)")]), _c('br'), _vm._v(" "), _c('p', [_vm._v("Library of Congress Control Number: 2023907373")]), _c('br'), _vm._v(" "), _c('p', [_vm._v("www.austinmacauley")]), _c('br'), _vm._v(" "), _c('p', [_vm._v("First Published 2023")]), _vm._v(" "), _c('p', [_vm._v("Austin Macauley Publishers LLC")]), _vm._v(" "), _c('p', [_vm._v("40 Wall Street, 33rd Floor, Suite 3302")]), _vm._v(" "), _c('p', [_vm._v("New York, NY 10005")]), _vm._v(" "), _c('p', [_vm._v("USA")]), _c('br'), _vm._v(" "), _c('p', [_vm._v("mail-usa@austinmacauley.com")]), _vm._v(" "), _c('p', [_vm._v("+1 (646) 5125767")])])])])
}]}

/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(71),
  /* template */
  __webpack_require__(72),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 71 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 72 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "acknowledgment"
    }
  }, [_c('h1', [_vm._v("Acknowledgment")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Again, to acknowledge my sister, Marina, who is now my manager for all that she did and still does for me. Her support and belief in"), _c('br'), _vm._v("\nme are outstanding.")])])])])
}]}

/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(74),
  /* template */
  __webpack_require__(75),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 74 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 75 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "characters"
    }
  }, [_c('h1', [_vm._v("Characters")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0em !important"
    }
  }, [_vm._v("Lord Armando")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0em !important"
    }
  }, [_vm._v("Sister Helewise")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0em !important"
    }
  }, [_vm._v("Duke of Landburg")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0em !important"
    }
  }, [_vm._v("Duchess Bella")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0em !important"
    }
  }, [_vm._v("Roseabella: Oldest daughter")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0em !important"
    }
  }, [_vm._v("Eder: Son of Duke and Duchess")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0em !important"
    }
  }, [_vm._v("Ardelean: Middle daughter of Duke and Duchess")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0em !important"
    }
  }, [_vm._v("Gretta: Youngest daughter of Duke and Duchess")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0em !important"
    }
  }, [_vm._v("Josiah: Son of Roseabella and Armando")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0em !important"
    }
  }, [_vm._v("Soneia and Armanda: twin daughters of Roseabella and Armando")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0em !important"
    }
  }, [_vm._v("Gerrold: Armando’s top man")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0em !important"
    }
  }, [_vm._v("Meiga: Wife of Gerrold")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0em !important"
    }
  }, [_vm._v("Saige: Granddaughter of Gerrold and Meiga")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0em !important"
    }
  }, [_vm._v("Father Strickland: Priest")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0em !important"
    }
  }, [_vm._v("Marga and Ragga: Twin slayers")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0em !important"
    }
  }, [_vm._v("Romane: Ship crew")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0em !important"
    }
  }, [_vm._v("Captain Morgan: Captain of the ship (who is in love with Helewise)")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0em !important"
    }
  }, [_vm._v("2 puppies bought in a port for supply run, on Armando’s ship, they grow huge and are trained as fighting dogs.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0em !important"
    }
  }, [_vm._v("Garrett: Cousin of Armando and Helewise who turns Vampire.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0em !important"
    }
  }, [_vm._v("Morgania: Vampire woman")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0em !important"
    }
  }, [_vm._v("Hatmanu: Slave to the Vampires")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0em !important"
    }
  }, [_vm._v("Rueband: Boy on Garrett’s ship")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0em !important"
    }
  }, [_vm._v("Bacia: Garrett’s top man")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0em !important"
    }
  }, [_vm._v("Manu: was whipped and fed to the sharks for attacking Rueband and Gretta")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0em !important"
    }
  }, [_vm._v("Dr. Bardue: Doctor on Garrett’s ship")])])])])
}]}

/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(77),
  /* template */
  __webpack_require__(78),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 77 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 78 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "finding-a-wife"
    }
  }, [_c('h1', [_vm._v("Finding a Wife")]), _vm._v(" "), _c('p', [_vm._v("Armando decided he was sick of chasing women. He needed a wife; a strong woman with striking looks, not beautiful and full of herself. Armando’s mother was a beautiful woman in her own way. She was in charge when his father was away from the castle. Now, there was only him and his sister, Helewise.")]), _vm._v(" "), _c('p', [_vm._v("His parents and two brothers all died within days from the plague. He and his baby sister, Heloise were the two survivors. Armando was invited to dine with the Duke and Duchess of Landburg. And all of Transylvania must know he was looking for a wife.")]), _vm._v(" "), _c('p', [_vm._v("So far, no one appealed to him. The Landburg’s castle was only one hour away on horseback. They were neighbors and friends of his parents.")])])])])
}]}

/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(80),
  /* template */
  __webpack_require__(81),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 80 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 81 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "the-dukes-castle"
    }
  }, [_c('h1', [_vm._v("The Duke’s Castle")]), _vm._v(" "), _c('p', [_vm._v("“Welcome to our home, my Lord.”")]), _vm._v(" "), _c('p', [_vm._v("“Thank you for the invite, sir.”")]), _vm._v(" "), _c('p', [_vm._v("“It’s been a while, yes, we haven’t seen you and your sister Helewise since the plague. How is your sister by the way?”")]), _vm._v(" "), _c('p', [_vm._v("“She is well but misses our parents dreadfully.”")]), _vm._v(" "), _c('p', [_vm._v("“How many years now since the deadly plague?”")]), _vm._v(" "), _c('p', [_vm._v("“It’s been five years. A hard and lonely five years of my life without them. That peddler came not only with his merchandise but also with the plague. It wiped out hundreds of our tenants also.”")]), _vm._v(" "), _c('p', [_vm._v("“It was a rough year, no one worked the fields or out fishing. What the plague didn’t take, starvation did.”")]), _vm._v(" "), _c('p', [_vm._v("“Dinner is ready to serve, my dear husband.”")]), _vm._v(" "), _c('p', [_vm._v("Their first course was fish chowder, very creamy with mussels and clams. The main course was a baked duck with Krispy glazed skin in orange sauce. Green beans sautéed with garlic, onion and baby carrots.")]), _vm._v(" "), _c('p', [_vm._v("The third course was a grilled trout stuffed with breadcrumbs, wild sage and onions. The trout was pink and flakey and full of juiciness. Dessert was a raisin pudding, cooked in brandy sauce.")]), _vm._v(" "), _c('p', [_vm._v("“Is everything alright, Sir Armando?”")]), _vm._v(" "), _c('p', [_vm._v("“Everything was magnificent, you have a wonderful cook, Duchess Bella.”")]), _vm._v(" "), _c('p', [_vm._v("“Yes, I think we will keep her. Sir Armando, we heard you were looking for a wife.”")]), _vm._v(" "), _c('p', [_vm._v("“News travel fast, I take it,”")]), _vm._v(" "), _c('p', [_vm._v("“Well yes, a rich man like yourself, it doesn’t take long.”")]), _vm._v(" "), _c('p', [_vm._v("“Yes, you are right, Duke.”")]), _vm._v(" "), _c('p', [_vm._v("“So far, I haven’t had any luck in that field.”")]), _vm._v(" "), _c('p', [_vm._v("“Would you mind if we introduced you to our daughter, Roseabella? She’ll be eighteen in a few months and will be ready to be wed. She is taught to manage a household. She’s not beautiful like her younger sisters but she carries herself well and has fine features.”")]), _vm._v(" "), _c('p', [_vm._v("“She has a beautiful name, your Duchess. If she looks like her mother, I won’t be disappointed.”")])])])])
}]}

/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(83),
  /* template */
  __webpack_require__(84),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 83 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 84 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "meeting-roseabella"
    }
  }, [_c('h1', [_vm._v("Meeting Roseabella")]), _vm._v(" "), _c('p', [_vm._v("“My Lord, it is so nice to meet you. We are neighbors but I have not met you until now. My parents don’t let us kids leave our castle.”")]), _vm._v(" "), _c('p', [_vm._v("Roseabella gave her parents cold looks.")]), _vm._v(" "), _c('p', [_vm._v("“Your father has good reasons not to. My sister Helewise is not permitted to leave the castle walls either.”")]), _vm._v(" "), _c('p', [_vm._v("“Her life must be as dull as mine.”")]), _vm._v(" "), _c('p', [_vm._v("“We do it for your protection, daughter. We will let you two get to know each other. Help yourself to more wine Armando.”")]), _vm._v(" "), _c('p', [_vm._v("“Thank you, sir.”")]), _vm._v(" "), _c('p', [_vm._v("“Would you care for some, Roseabella?”")]), _vm._v(" "), _c('p', [_vm._v("“Yes, I very much would. Thank you, my Lord.”")]), _vm._v(" "), _c('p', [_vm._v("“Call me Armando.”")]), _vm._v(" "), _c('p', [_vm._v("“Can we keep the wine between ourselves?”")]), _vm._v(" "), _c('p', [_vm._v("“You never drink wine with your meals?”")]), _vm._v(" "), _c('p', [_vm._v("“We do not eat with our parents, Sir. And there is no wine served at our table.”")]), _vm._v(" "), _c('p', [_vm._v("“My sister has wine twice a day when we dine.”")]), _vm._v(" "), _c('p', [_vm._v("“How old is your sister?”")]), _vm._v(" "), _c('p', [_vm._v("“She is fifteen.”")]), _vm._v(" "), _c('p', [_vm._v("“How nice of your sister to eat with a grown-up and drink wine daily.”")]), _vm._v(" "), _c('p', [_vm._v("“When you’re married, you will drink wine during meals and has you, please.”")]), _vm._v(" "), _c('p', [_vm._v("“I’m afraid, Sir Armando, I will never marry.”")]), _vm._v(" "), _c('p', [_vm._v("“A beautiful lady like yourself dreams of marrying.”")]), _vm._v(" "), _c('p', [_vm._v("“I am not beautiful, Sir Armando. I have been told that before and I know I am not ugly either.”")]), _vm._v(" "), _c('p', [_vm._v("“You’re are a very attractive woman. You would make any man proud to be your husband.”")]), _vm._v(" "), _c('p', [_vm._v("“Thank you for saying that. But as I said, I will not marry.”")]), _vm._v(" "), _c('p', [_vm._v("“Why wouldn’t you want to wed?”")]), _vm._v(" "), _c('p', [_vm._v("“I have not lived yet, Sir Armando! I have never been outside of the bloody castle. Please excuse my language. It can be frustrating sometimes.”")]), _vm._v(" "), _c('p', [_vm._v("“Your father has your best interest in you and your brother and sisters.”")]), _vm._v(" "), _c('p', [_vm._v("“There’s nothing out there in the daylight that will harm us.”")]), _vm._v(" "), _c('p', [_vm._v("“You know about the others?”")]), _vm._v(" "), _c('p', [_vm._v("“Of course, I like to eavesdrop on my father and his friends.”")]), _vm._v(" "), _c('p', [_vm._v("“What would you like to do in the daylight if you had a chance?”")]), _vm._v(" "), _c('p', [_vm._v("“I dream of running over the sand and jumping into the ocean. Ride a horse through town and see all the shops and inns. Get on a ship and move far away, maybe to England where you can stay out dancing all night long. And don’t have to worry about vamps.”")]), _vm._v(" "), _c('p', [_vm._v("(My god she reminded me of my mother, she was never scared and always wanted excitement around her, my mother would travel with father on business trips and sometime we would go with them but always returning before dark; they loved each other so much.)")]), _vm._v(" "), _c('p', [_vm._v("“I like you, Roseabella. You are a determined young lady. I am looking for a bright, mature, young woman. A virgin on our wedding night. She will have no other man in her bed until death do us part. My wife will be quite pleased in my bed. We will learn to love each other. I will want many children from our love-making; a tall strong bone-loving mother.”")]), _vm._v(" "), _c('p', [_vm._v("“Good for you, Sir Armando. I hope you find that perfect woman you’re looking for.”")]), _vm._v(" "), _c('p', [_vm._v("“My God, I have found her.”")]), _vm._v(" "), _c('p', [_vm._v("“I am happy for you Sir Armando, who is this lucky woman?”")]), _vm._v(" "), _c('p', [_vm._v("“Call me Armando and you, my dear Roseabella will be my wife.”")]), _vm._v(" "), _c('p', [_vm._v("In a daze, Roseabella swallowed down her wine and put up her chin, looked straight into his eyes only noticed for the first time they were so blue. Just like the blueberries that came from the village. Would his lips taste as sweet!")]), _vm._v(" "), _c('p', [_vm._v("My god, what is wrong with me, how could I think like that?")]), _vm._v(" "), _c('p', [_vm._v("“Sir, sorry I mean Armando, I must make myself clear. I told you before I do not wish to marry you or anyone.”")]), _vm._v(" "), _c('p', [_vm._v("“What don’t you like about me?”")]), _vm._v(" "), _c('p', [_vm._v("“Nothing personal; Armando, you are a very attractive and handsome man. You are tall like myself, very muscular with long strong arms and thighs. Oh dear, did I just say thighs? I meant legs.”")]), _vm._v(" "), _c('p', [_vm._v("“Are you blushing, my dear?”")]), _vm._v(" "), _c('p', [_vm._v("“No, it’s the wine making me hot!”")]), _vm._v(" "), _c('p', [_vm._v("“I think it’s so ladylike to blush.”")]), _vm._v(" "), _c('p', [_vm._v("“I told you it’s the wine.”")]), _vm._v(" "), _c('p', [_vm._v("“Would you like some more wine?”")]), _vm._v(" "), _c('p', [_vm._v("“Ah, maybe a little.”")]), _vm._v(" "), _c('p', [_vm._v("“So, tell me again why you won’t wed me?”")]), _vm._v(" "), _c('p', [_vm._v("“Didn’t I just explain to you, sir?”")]), _vm._v(" "), _c('p', [_vm._v("“You explained you have not lived. With me, you will enjoy life.”")]), _vm._v(" "), _c('p', [_vm._v("“Is that right now? How will I be happy with you?”")]), _vm._v(" "), _c('p', [_vm._v("“After we are married, we will have a celebration to show off my beautiful wife. We will have a picnic on the beaches and swim in the ocean nude, so we can make love; you’re blushing again, my dear.”")]), _vm._v(" "), _c('p', [_vm._v("“Yes, I know, it’s the wine.”")]), _vm._v(" "), _c('p', [_vm._v("“I like you already.”")]), _vm._v(" "), _c('p', [_vm._v("“You just met me.”")]), _vm._v(" "), _c('p', [_vm._v("“A man knows what he seeks in a woman. You are an honest, lovely young lady. You will be a good mother and teacher to our children.”")]), _vm._v(" "), _c('p', [_vm._v("“How would I know about being a parent? We have a nanny who showed us love but my parents love each other but don’t show us love. Never hugged or kissed us, only rules to be followed.”")]), _vm._v(" "), _c('p', [_vm._v("“I’m so sorry, I had lovable parents who doted their love on us. Some parents like yours find it hard to show affection to their children.”")]), _vm._v(" "), _c('p', [_vm._v("“Marry me and you will want for nothing. It won’t be a prison anymore in this castle.”")]), _vm._v(" "), _c('p', [_vm._v("“Is that a smile I see?”")]), _vm._v(" "), _c('p', [_vm._v("“No, well maybe a little one.”")]), _vm._v(" "), _c('p', [_vm._v("“You have a beautiful body, I can’t take my eyes off you, is it the wine making you hot again?”")]), _vm._v(" "), _c('p', [_vm._v("“No, this time you are making me blush.”")]), _vm._v(" "), _c('p', [_vm._v("“I’m glad to make your body hot for me, Roseabella.”")]), _vm._v(" "), _c('p', [_vm._v("“It all sounds so simple.”")]), _vm._v(" "), _c('p', [_vm._v("Roseabella could not stop thinking about this new life Armando could give her. The taste of freedom she dreamed about for years.")]), _vm._v(" "), _c('p', [_vm._v("“Are you telling me the truth, Sir Armando? Will I leave one prison to go to another?”")]), _vm._v(" "), _c('p', [_vm._v("“I speak the truth to you. After we become man and wife, would you let me kiss you and taste the wine on your lips? After our kiss, you will want to marry me. Be sure of yourself.”")]), _vm._v(" "), _c('p', [_vm._v("He grabbed her to him with force. He lightly touched her lips for a few seconds. He could not stand it anymore, so he crushed his mouth over hers; she let out a moan. He touched her tongue and what a taste she was. There was strong attraction there.")]), _vm._v(" "), _c('p', [_vm._v("Heat was coming from their bodies. She will make a good bed partner, no woman I ever wanted more. His cock was so hard.")]), _vm._v(" "), _c('p', [_vm._v("Roseabella felt like her mouth was being devoured. She felt wet between her legs and hunger she never thought existed. He broke away from her and they looked in each other’s eyes.")]), _vm._v(" "), _c('p', [_vm._v("“Roseabella, my beautiful Roseabella, would you do me the honor of being my wife?”")]), _vm._v(" "), _c('p', [_vm._v("Her heart was pounding so hard. Her legs, so weak, those eyes she could never say no to. Those ocean eyes.")]), _vm._v(" "), _c('p', [_vm._v("“I will be honored to be your wife, Armando; you make me feel desirable and I know we will grow to love each other.”")]), _vm._v(" "), _c('p', [_vm._v("He hugged her and kissed her neck down to her cleavage.")]), _vm._v(" "), _c('p', [_vm._v("“My dear, I think I’m in love with you already. We must be married as soon as possible. I want you in my bed, you’re the only woman for me. I will give you so much pleasure.”")]), _vm._v(" "), _c('p', [_vm._v("“Armando, I want to give you pleasure back. Will you teach me to satisfy you?”")]), _vm._v(" "), _c('p', [_vm._v("“Do not worry, darling; you already have me on fire. I have to leave soon before dark.”")]), _vm._v(" "), _c('p', [_vm._v("“Yes, you must before the bloodsuckers come out to feed.”")]), _vm._v(" "), _c('p', [_vm._v("“I will ask your family to bring you to me at first day light. Only leave when the sun is bright, they linger in the shade.”")]), _vm._v(" "), _c('p', [_vm._v("“Please be careful tonight, Armando.”")]), _vm._v(" "), _c('p', [_vm._v("“Now, I need to speak to your parent, we will be married in 3 days.”")]), _vm._v(" "), _c('p', [_vm._v("“3 days? Why so soon?”")]), _vm._v(" "), _c('p', [_vm._v("“I can’t wait any longer to make love, you will be a virgin on our wedding night.”")]), _vm._v(" "), _c('p', [_vm._v("“Ok, sounds exciting to me Armando.”")]), _vm._v(" "), _c('p', [_vm._v("They kissed once more before she left to get her parents.")]), _vm._v(" "), _c('p', [_vm._v("“Duke and Duchess of Land Burg, I would like your daughter Roseabella’s hand in marriage.”")]), _vm._v(" "), _c('p', [_vm._v("“But you just met.”")]), _vm._v(" "), _c('p', [_vm._v("“As soon as I saw your daughter, she was going to be my wife, I will make her happy and treat her with respect. We have so much in common.”")]), _vm._v(" "), _c('p', [_vm._v("“Did Roseabella accept?”")]), _vm._v(" "), _c('p', [_vm._v("“Yes, we will be married in 3 days.”")]), _vm._v(" "), _c('p', [_vm._v("“We can’t get a wedding dress in three days.”")]), _vm._v(" "), _c('p', [_vm._v("“I know a woman who already has wedding dresses made and for sale. She will come to the castle in two days and have her ready.”")]), _vm._v(" "), _c('p', [_vm._v("“What is the rush, Sir Armando?”")]), _vm._v(" "), _c('p', [_vm._v("“You of all people should know, my Duke that we are in a disease world. We take pleasure in life as soon as possible before it is taken from us, there are evil things out there in the dark, waiting for a chance to feed on humans; we must find a way to destroy them. It’s time for me to leave for they will be feeding on me.”")]), _vm._v(" "), _c('p', [_vm._v("“You will leave at first light, you will stay until after the wedding.”")]), _vm._v(" "), _c('p', [_vm._v("Roseabella was just listening to her parents and Armando making decisions on her future.")]), _vm._v(" "), _c('p', [_vm._v("“I never dreamed it would happen so fast, my child.”")]), _vm._v(" "), _c('p', [_vm._v("“Why, mother? Because I am not as beautiful as Greta and Ardelean?”")]), _vm._v(" "), _c('p', [_vm._v("“Of course not, you are pretty enough. You have good genes and will make healthy children.”")]), _vm._v(" "), _c('p', [_vm._v("“Thank you, mother, that’s the longest conversation we ever had.”")]), _vm._v(" "), _c('p', [_vm._v("“I’m sorry, Roseabella if we didn’t show love. When you are brought up with nannies and tutors and never see your parents, it’s hard to show affection to your own children.”")]), _vm._v(" "), _c('p', [_vm._v("“My children will be loved and cherished by me and my husband. They will eat their meals with us three times a day and be tucked in every night with a bedtime story.”")]), _vm._v(" "), _c('p', [_vm._v("“We are so sorry we failed you as parents.” said her father.")]), _vm._v(" "), _c('p', [_vm._v("“What’s done is done to me, father but you have three children upstairs who need you both. Spending time with you is all we ever wanted. One hug a day won’t kill you, I hope in time we can be close.”")]), _vm._v(" "), _c('p', [_vm._v("“Maybe, we’ll make good Grandparents.”")]), _vm._v(" "), _c('p', [_vm._v("“Yes, I agree with you father.”")]), _vm._v(" "), _c('p', [_vm._v("“I will promise to love my grandchildren and I hope you give me a second chance, someday.”")]), _vm._v(" "), _c('p', [_vm._v("“My love, you must go and pack all your things for tomorrow.”")]), _vm._v(" "), _c('p', [_vm._v("“Of course. Mother, will you help me?”")]), _vm._v(" "), _c('p', [_vm._v("Her mother looked at her with tears in her eyes.")]), _vm._v(" "), _c('p', [_vm._v("“I’d be happy to.”")]), _vm._v(" "), _c('p', [_vm._v("“I will walk you out, Armando, it will be dark soon.”")]), _vm._v(" "), _c('p', [_vm._v("“Yes, sir thank you for your daughter.”")]), _vm._v(" "), _c('p', [_vm._v("“I know she is in good hands. We will not be traveling to your castle in the morning, we will meet you half way. We will see you on your wedding day and spend the night.”")]), _vm._v(" "), _c('p', [_vm._v("“Of course, your Duke, we’ll meet at daylight.”")]), _vm._v(" "), _c('p', [_vm._v("Armando rode his horse as fast as he could. His horse seemed a little bit jittery.")]), _vm._v(" "), _c('p', [_vm._v("“It’s ok, Spirit, we’ll make it.”")]), _vm._v(" "), _c('p', [_vm._v("For a second, he could see movement under some big trees in the shade; "), _c('em', [_vm._v("Waiting for victims when the sun goes down,")]), _vm._v(" he thought to himself.")]), _vm._v(" "), _c('p', [_vm._v("“Come on Spirit, faster, faster, that’s my boy.”")]), _vm._v(" "), _c('p', [_vm._v("He could see his castle as he got closer and the gates were opening.")]), _vm._v(" "), _c('p', [_vm._v("“We made it Spirit, thank God.”")]), _vm._v(" "), _c('p', [_vm._v("“My Lord, I didn’t think you were going to make it. I and some men were about to look for you.”")]), _vm._v(" "), _c('p', [_vm._v("“I was late because I found myself a wife.”")]), _vm._v(" "), _c('p', [_vm._v("“My Lord, you found the right one then?”")]), _vm._v(" "), _c('p', [_vm._v("“Yes, I certainly did.”")]), _vm._v(" "), _c('p', [_vm._v("“Well then, I wish you all the luck. I hope you will be as happy as me and my Meiga.”")]), _vm._v(" "), _c('p', [_vm._v("“Wipe down my horse and we leave at first daylight to meet them.”")]), _vm._v(" "), _c('p', [_vm._v("“Yes, sir I’ll round up the men tonight to take with us.”")]), _vm._v(" "), _c('p', [_vm._v("“Now, I break the news to my sister Helewise.”")]), _vm._v(" "), _c('p', [_vm._v("“She has been so moody, sir and worried about you.”")]), _vm._v(" "), _c('p', [_vm._v("“What was so important you had to stay out after dark, my dear brother? Have you lost your common sense? All this wife-hunting is getting to your brain.”")]), _vm._v(" "), _c('p', [_vm._v("“It’s so nice of you to worry about me, my little sister. I can take care of myself, so do me a favor and relax.”")]), _vm._v(" "), _c('p', [_vm._v("“I worry you won’t come back and I’ll be alone.”")]), _vm._v(" "), _c('p', [_vm._v("“I’m sorry Helewise, I left it so late but I have good news, my dear.”")]), _vm._v(" "), _c('p', [_vm._v("“Good, I could use some good news, please tell.”")]), _vm._v(" "), _c('p', [_vm._v("“I am to be married in three days’ time.”")]), _vm._v(" "), _c('p', [_vm._v("“You are what?”")]), _vm._v(" "), _c('p', [_vm._v("“You heard me the first time.”")]), _vm._v(" "), _c('p', [_vm._v("“But you only went to the Duke and Duchess of Land Burg.”")]), _vm._v(" "), _c('p', [_vm._v("“Yes, you are exactly right.”")]), _vm._v(" "), _c('p', [_vm._v("“Is the duchess a widow now?”")]), _vm._v(" "), _c('p', [_vm._v("“Of course not, you little mouse.”")]), _vm._v(" "), _c('p', [_vm._v("“So, it’s one of her daughters? Aren’t they too young?”")]), _vm._v(" "), _c('p', [_vm._v("“The older one is seventeen and she is to become my wife.”")]), _vm._v(" "), _c('p', [_vm._v("“How long have you known her?”")]), _vm._v(" "), _c('p', [_vm._v("“Three hours and it’s long enough when you know she’s the one.”")]), _vm._v(" "), _c('p', [_vm._v("“You’re telling me after three hours you’re going to spend the rest of your life with this woman?”")]), _vm._v(" "), _c('p', [_vm._v("“Yes and her name is Roseabella.”")]), _vm._v(" "), _c('p', [_vm._v("“What kind of name is that?”")]), _vm._v(" "), _c('p', [_vm._v("“A beautiful name for a beautiful lady. I’m meeting her halfway in the morning, so I must get some sleep. Please show her some kindness, Helewise and make friends with her. She’s never been outside of their castle before.”")]), _vm._v(" "), _c('p', [_vm._v("“I know how she feels.”")]), _vm._v(" "), _c('p', [_vm._v("“You do go out on the bright sunny days.”")]), _vm._v(" "), _c('p', [_vm._v("“Oh, wow! What’s it been? Twice this year?”")]), _vm._v(" "), _c('p', [_vm._v("“I’m sorry I’ve been busy lately, dear sister. Now I have found a wife, we can spend more time together.”")]), _vm._v(" "), _c('p', [_vm._v("“The two of us like before?”")]), _vm._v(" "), _c('p', [_vm._v("“No, you silly mouse, it will be the three of us. After the wedding, we will teach Roseabella how to ride. We can go into the village and you two can go shopping. We will then meet up later for lunch. When the weather gets warmer, we will swim in the ocean. You see, Helewise; Roseabella has never left the castle.”")]), _vm._v(" "), _c('p', [_vm._v("“But, but whatever for? Is there something wrong with her that you are not telling me?”")]), _vm._v(" "), _c('p', [_vm._v("“No, no of course not. Roseabella’s father is very protective over his children. They are not allowed outside the castle walls.”")]), _vm._v(" "), _c('p', [_vm._v("“We go out in the daylight, my brother. Why can’t their family?”")]), _vm._v(" "), _c('p', [_vm._v("“The duke is afraid of dreary overcast skies and the sun clouding over. They are terrified of the vampires. So please Helewise, can you welcome her with open arms?”")]), _vm._v(" "), _c('p', [_vm._v("“My brother, I love you and I will give her a chance, as long as you don’t leave me out of your adventures.”")]), _vm._v(" "), _c('p', [_vm._v("“I promise you, little mouse. You will always be included. You’ll meet her tomorrow morning. Her parents, brother and two sisters will be here in two days.”")]), _vm._v(" "), _c('p', [_vm._v("“Good, this castle won’t be so boring for a while. How old is her brother?”")]), _vm._v(" "), _c('p', [_vm._v("“I’m not sure, probably your age.”")]), _vm._v(" "), _c('p', [_vm._v("“Is he nice looking?”")]), _vm._v(" "), _c('p', [_vm._v("“Never had time to meet them. Now, I must rest; tomorrow is a busy day for us all.”")]), _vm._v(" "), _c('p', [_vm._v("“Yes, I’m sorry to keep you from your bed. But the other night, I could not sleep.”")]), _vm._v(" "), _c('p', [_vm._v("“Don’t stop now, go on.”")]), _vm._v(" "), _c('p', [_vm._v("“Like I said, I could not sleep, so I walked up to the top of the tower.”")]), _vm._v(" "), _c('p', [_vm._v("“How many times have I told you to never leave your room in the nighttime?”")]), _vm._v(" "), _c('p', [_vm._v("“I’m so sorry, Armando but I was bored and sleep would not come to me.”")]), _vm._v(" "), _c('p', [_vm._v("“You must promise me never to do it again.”")]), _vm._v(" "), _c('p', [_vm._v("“Yes, I promise.”")]), _vm._v(" "), _c('p', [_vm._v("“Well then, please continue with the rest of your story.”")]), _vm._v(" "), _c('p', [_vm._v("“Brother yes, when I looked out through the bars, I thought I saw cousin Garrett, the moon was full and I could see him so clear. We looked at each other, his skin was white and his clothes was in rags. He looked like a vampire.”")]), _vm._v(" "), _c('p', [_vm._v("“When was this?”")]), _vm._v(" "), _c('p', [_vm._v("“Five nights ago.”")]), _vm._v(" "), _c('p', [_vm._v("“Why did you not did tell me before now?”")]), _vm._v(" "), _c('p', [_vm._v("“Brother, you are never around and you might think I’m seeing things. Will you please say something, Armando, tell me it wasn’t our cousin?”")]), _vm._v(" "), _c('p', [_vm._v("“I wish to God I could but I have seen him too in a distance.”")]), _vm._v(" "), _c('p', [_vm._v("“Oh, Armando what are we going to do?”")]), _vm._v(" "), _c('p', [_vm._v("“Listen to me Helewise, you are going to do nothing, understand? He is no longer Garrett; he is a vampire and would attack you if he gets a chance.”")]), _vm._v(" "), _c('p', [_vm._v("“But I loved him like a brother, he always made me laugh and brought me gifts.”")]), _vm._v(" "), _c('p', [_vm._v("“I know I miss him too, we were also like brothers.”")]), _vm._v(" "), _c('p', [_vm._v("“What’s going to happen to us, Armando? How long will it take before they get to us?”")]), _vm._v(" "), _c('p', [_vm._v("“One day, my sister, we will hunt them down and stake them in the heart and cut their heads off. I will help you, Armando.”")]), _vm._v(" "), _c('p', [_vm._v("“You will not, you are a girl and a child.”")]), _vm._v(" "), _c('p', [_vm._v("“Oh really, just two years younger than your precious Roseabella!”")]), _vm._v(" "), _c('p', [_vm._v("“You are right and I will train the both of you for protection inside these castle walls when I can’t do so.”")]), _vm._v(" "), _c('p', [_vm._v("“Thank you so much brother, sleep now, you need your rest.”")]), _vm._v(" "), _c('p', [_vm._v("“Sweet Mary and Jesus, should I really marry and bring innocent children into this world?”")]), _vm._v(" "), _c('p', [_vm._v("After a restless sleep that night, Armando and his men left to meet his bride-to-be. Traveling was good but slow because of the carriage to bring back his wife–to-be and her things. He saw her standing there on the grassy meadow.")]), _vm._v(" "), _c('p', [_vm._v("She was wrapped in a dyed red mink cape. Her hair was glowing under the bright sun. The red highlights were like fire. My god, she was not pretty, she was the most beautiful woman he ever saw.")]), _vm._v(" "), _c('p', [_vm._v("“How was your travel, Roseabella?”")]), _vm._v(" "), _c('p', [_vm._v("“Oh, Armando it was wonderful to leave my prison. To see trees, grass, and animals. Can’t wait to travel the rest of the way.”")]), _vm._v(" "), _c('p', [_vm._v("“You look lovely today my dear, red is your color.”")]), _vm._v(" "), _c('p', [_vm._v("“Thank you, sir. I am glad you made it home safe last night.”")]), _vm._v(" "), _c('p', [_vm._v("“It was close, got a tongue lashing from my sister.”")]), _vm._v(" "), _c('p', [_vm._v("“Good morning your Duke, we have nice weather to travel.”")]), _vm._v(" "), _c('p', [_vm._v("“Yes indeed. Shall we load her things in your wagon? I am anxious to get back to Duchess Bella, she gets nervous when I leave the castle.”")]), _vm._v(" "), _c('p', [_vm._v("“Armando, what you said last night about destroying the vampires, were you serious?”")]), _vm._v(" "), _c('p', [_vm._v("“Yes, your duke we can’t go on living this way. We have to fight back.”")]), _vm._v(" "), _c('p', [_vm._v("“After the wedding, I and my men will train night and day to fight these monsters. Aim for the heart or cut of the heads. I’m training your daughter and my sister also. They will need to defend themselves.”")]), _vm._v(" "), _c('p', [_vm._v("“My god Armando, I hope they never come face to face with one. But I will do the same with my other children.”")]), _vm._v(" "), _c('p', [_vm._v("“What about Duchess Bella, will she also train?”")]), _vm._v(" "), _c('p', [_vm._v("“No, my boy she faints at the sight of blood.”")]), _vm._v(" "), _c('p', [_vm._v("“Yes, most woman would, except my sister who wants to help hunt them.”")]), _vm._v(" "), _c('p', [_vm._v("Roseabella was taking in all the views. Now, it was mostly peat moss and rocks. She looked at Armando on his horse and what a gallant site he made. Can I be in love with him already? When I’m watching him now, my heart is beating out of my chest. He looks at me with hunger in his eyes the same way I look at him.")]), _vm._v(" "), _c('p', [_vm._v("I’m looking forward to our wedding night, I’m nervous but not scared. My mother told me last night that it hurts a little at first but it’s wonderful after. She said her mother, my grandmother told her nothing; only sex is for men who like to rut and I had to bear it. I was so nervous on my wedding night, I threw up.")]), _vm._v(" "), _c('p', [_vm._v("“Oh, mother, I’m sorry.”")]), _vm._v(" "), _c('p', [_vm._v("“She struck me often when I was not up to par and I swore to your father that our kids will not be beaten.”")]), _vm._v(" "), _c('p', [_vm._v("“I’m so glad you told me mother; I’m not feeling so hurt now about our relationship. Please come visit me mother, I think we will be friends.”")]), _vm._v(" "), _c('p', [_vm._v("Roseabella looked up from daydreaming and the gates of the castle opened. Men, women and children. All the little girls with flowers in their hands.")]), _vm._v(" "), _c('p', [_vm._v("“I see my sister and Meg have been busy.” said Armando.")]), _vm._v(" "), _c('p', [_vm._v("“What if they don’t like me, Armando? They must be expecting someone blond and beautiful.”")]), _vm._v(" "), _c('p', [_vm._v("“You are beautiful and I do not prefer blonds.”")]), _vm._v(" "), _c('p', [_vm._v("“You know how to make a woman feel good. Thank you so much.”")]), _vm._v(" "), _c('p', [_vm._v("“You are welcome, my Roseabella. Now, I would like to introduce my sister Helewise.”")]), _vm._v(" "), _c('p', [_vm._v("Helewise was tall for her age and had thick brown walnut hair and eyes. Like her brother, she had good poise about her and very pretty.")]), _vm._v(" "), _c('p', [_vm._v("“I’m so happy to meet Armando’s sister and I’m happy to meet my future sister-in-law.” Helewise looked at her brother, “And I hope we will be friends.”")]), _vm._v(" "), _c('p', [_vm._v("“I hope so too. Now, I like to introduce you to the staff and people of the village.”")]), _vm._v(" "), _c('p', [_vm._v("After shaking hands and loaded down with flowers, Roseabella was exhausted. A maid showed her to her quarters, put a clean night shift on her and tucked her into bed. She slept for hours. A knock on her door woke her. It was Armando, asking how she was feeling.")]), _vm._v(" "), _c('p', [_vm._v("“Oh Armando, I slept so soundly.”")]), _vm._v(" "), _c('p', [_vm._v("“Yes, you did my dear. In one hour, we will be dining and you must be hungry.”")]), _vm._v(" "), _c('p', [_vm._v("“Yes, I am starved.”")]), _vm._v(" "), _c('p', [_vm._v("“Only the two of us will dine tonight, we’ll get to know each other a bit more.”")]), _vm._v(" "), _c('p', [_vm._v("“That will be nice. What are you looking at Armando?”")]), _vm._v(" "), _c('p', [_vm._v("“Your shift is see-through.”")]), _vm._v(" "), _c('p', [_vm._v("“Oh my, I did not know.”")]), _vm._v(" "), _c('p', [_vm._v("“Don’t cover up. I want to look at you.”")]), _vm._v(" "), _c('p', [_vm._v("She got out of bed and stood up.")]), _vm._v(" "), _c('p', [_vm._v("“My dear god, you set my loins on fire. I will send in your maid or I’ll take you right this instant.”")]), _vm._v(" "), _c('p', [_vm._v("Now I know I’m blushing.")]), _vm._v(" "), _c('p', [_vm._v("“I will see you in an hour, Armando.”")]), _vm._v(" "), _c('p', [_vm._v("“Till then, my love.”")]), _vm._v(" "), _c('p', [_vm._v("Armando was pouring wine, he glanced up and saw her in a green lamb-wool dress. With a string of pearls around her neck.")]), _vm._v(" "), _c('p', [_vm._v("“You’re staring again.”")]), _vm._v(" "), _c('p', [_vm._v("“You look like an angel. Too pure to touch.”")]), _vm._v(" "), _c('p', [_vm._v("“Thank you, Armando but I’m no angel.”")]), _vm._v(" "), _c('p', [_vm._v("“I say what’s on my mind. So, you have beauty and brains.”")]), _vm._v(" "), _c('p', [_vm._v("She knew her cheeks were red from his compliments.")]), _vm._v(" "), _c('p', [_vm._v("“Would you like some wine?”")]), _vm._v(" "), _c('p', [_vm._v("“I would love some, thank you. Armando, it’s so delicious, it’s sweet and a little tarty. How did you make it so tasty?”")]), _vm._v(" "), _c('p', [_vm._v("“We let our grapes freeze on the vine for a month before we pick them.”")]), _vm._v(" "), _c('p', [_vm._v("“My father will like this one.”")]), _vm._v(" "), _c('p', [_vm._v("“Now my dear, let’s eat.”")]), _vm._v(" "), _c('p', [_vm._v("There were lamb chops, little potatoes with butter and herbs and cheese melted on top. Stuffed mushrooms and hot bread.")]), _vm._v(" "), _c('p', [_vm._v("“You certainly were hungry, your plate is cleaned.”")]), _vm._v(" "), _c('p', [_vm._v("“It was so delicious and now I’m stuffed.”")]), _vm._v(" "), _c('p', [_vm._v("“In my castle, we always eat dessert.”")]), _vm._v(" "), _c('p', [_vm._v("“I will try. What is it?”")]), _vm._v(" "), _c('p', [_vm._v("“It’s wild strawberry and cream over a sponge cake.”")]), _vm._v(" "), _c('p', [_vm._v("Armando dug into his dessert. When he finished, he looked over and so was she.")]), _vm._v(" "), _c('p', [_vm._v("“I never had sponge cake before. The strawberries and cream make it scrumptious. Please tell the cook how much I enjoyed the meal.”")]), _vm._v(" "), _c('p', [_vm._v("“Meg will be happy you cleaned your plate.”")]), _vm._v(" "), _c('p', [_vm._v("“Do you know how to play any games?”")]), _vm._v(" "), _c('p', [_vm._v("“We play cricket and hand ball inside the castle walls.”")]), _vm._v(" "), _c('p', [_vm._v("“How about card games?”")]), _vm._v(" "), _c('p', [_vm._v("“Yes, we play go fish and poker.” she said.")]), _vm._v(" "), _c('p', [_vm._v("“Poker it is then.”")]), _vm._v(" "), _c('p', [_vm._v("“I and my siblings play for marbles.”")]), _vm._v(" "), _c('p', [_vm._v("“Marbles is not what I had in mind my dear, we are going to play strip poker.”")]), _vm._v(" "), _c('p', [_vm._v("Feeling a little drunk and wanting to feel grown up, she said.")]), _vm._v(" "), _c('p', [_vm._v("“Your deal first, Sir Armando.”")]), _vm._v(" "), _c('p', [_vm._v("“Let’s see what you got.”")]), _vm._v(" "), _c('p', [_vm._v("She had two nines and two tens.")]), _vm._v(" "), _c('p', [_vm._v("“I have three queens, so I win this round. And since you already have your shoes off, I will take off your stocking.”")]), _vm._v(" "), _c('p', [_vm._v("Armando lifted her dress to her knees and slowly pulled it down.")]), _vm._v(" "), _c('p', [_vm._v("“What are you doing?”")]), _vm._v(" "), _c('p', [_vm._v("“I’m kissing your leg and now I’m kissing your toes.”")]), _vm._v(" "), _c('p', [_vm._v("She began to giggle from the wine and excitement.")]), _vm._v(" "), _c('p', [_vm._v("“May I deal now, sir?”")]), _vm._v(" "), _c('p', [_vm._v("“Yes, you may.”")]), _vm._v(" "), _c('p', [_vm._v("“Hope I’ll be lucky this time. I have 4 queens!”")]), _vm._v(" "), _c('p', [_vm._v("“And I, my dear, have 4 kings. So, let’s have that other stocking.”")]), _vm._v(" "), _c('p', [_vm._v("This time, Armando licked her leg down to her toes. She felt hot between her legs and butterflies in her stomach and she didn’t want him to stop.")]), _vm._v(" "), _c('p', [_vm._v("“My deal now, my love.” and this time, she was the winner. She looked at him and said.")]), _vm._v(" "), _c('p', [_vm._v("“Take off your shirt.” Off the shirt went. She went to the front of him and touched his powerful muscles. Slowly, she kissed his nipples and licked them.")]), _vm._v(" "), _c('p', [_vm._v("“Jesus Christ, what are you doing to me?”")]), _vm._v(" "), _c('p', [_vm._v("“The same you did to me.”")]), _vm._v(" "), _c('p', [_vm._v("“I don’t think so, my cock is bursting out of my pants. If we keep this up, you won’t be a virgin when we wed.”")]), _vm._v(" "), _c('p', [_vm._v("“One more round, Armando and we’ll call it a night. This time I have 4 deuces.”")]), _vm._v(" "), _c('p', [_vm._v("“And that’s good cards, my dear but I have four jacks.”")]), _vm._v(" "), _c('p', [_vm._v("“Are you cheating, sir?”")]), _vm._v(" "), _c('p', [_vm._v("“No, never. This time I’m going to take off your underwear.”")]), _vm._v(" "), _c('p', [_vm._v("Armando slowly moved his hand up to her leg past her thighs.")]), _vm._v(" "), _c('p', [_vm._v("“Holy mother of God, you are not wearing any!”")]), _vm._v(" "), _c('p', [_vm._v("“I forgot, when I play sport, I like the fresh air under my dress.”")]), _vm._v(" "), _c('p', [_vm._v("He moved his hand up and stroked between her legs.")]), _vm._v(" "), _c('p', [_vm._v("“You are wet for me.”")]), _vm._v(" "), _c('p', [_vm._v("“It feels so good,” she said, “please don’t stop.”")]), _vm._v(" "), _c('p', [_vm._v("“I could not stop now even if I wanted to. I got to have you now, do you understand?”")]), _vm._v(" "), _c('p', [_vm._v("“Yes, don’t stop, I want you too.”")]), _vm._v(" "), _c('p', [_vm._v("He took down his trousers. And she watched him.")]), _vm._v(" "), _c('p', [_vm._v("“You are brilliant, Armando.”")]), _vm._v(" "), _c('p', [_vm._v("He then laid her down on a bear rug, which was thick and soft. He kissed her hard and hungry. She kissed him back just as greedily. He lifted her dress off and left her pearls hanging down her breast.")]), _vm._v(" "), _c('p', [_vm._v("“You have a beautiful body; do you want me to stop?”")]), _vm._v(" "), _c('p', [_vm._v("“Please don’t stop, I want you.”")]), _vm._v(" "), _c('p', [_vm._v("He licked her nipples and she groaned and moaned with pleasure. Armando pushed his manhood up inside her little at a time.")]), _vm._v(" "), _c('p', [_vm._v("“It’s going to hurt but only for a bit.”")]), _vm._v(" "), _c('p', [_vm._v("“Yes, just do it. It feels good.”")]), _vm._v(" "), _c('p', [_vm._v("After a few more thrusts, she felt the pain and tightness. When he was all the way up, the pain was gone.")]), _vm._v(" "), _c('p', [_vm._v("“Roseabella, you are mine now and forever. You are so wet and tight.”")]), _vm._v(" "), _c('p', [_vm._v("He thrust into her harder and harder until they both cried out.")]), _vm._v(" "), _c('p', [_vm._v("“Did I hurt you, my love?”")]), _vm._v(" "), _c('p', [_vm._v("“No, it was wonderful, I felt like I was floating and then I felt a release that I never knew about.”")]), _vm._v(" "), _c('p', [_vm._v("He kissed her cheeks and mouth.")]), _vm._v(" "), _c('p', [_vm._v("“Are you disappointed you won’t be a virgin on our wedding night?”")]), _vm._v(" "), _c('p', [_vm._v("“No, my dear Armando, it was wonderful and so will every night with you.”")]), _vm._v(" "), _c('p', [_vm._v("“I love you already, Roseabella, I can feel it in my heart.”")]), _vm._v(" "), _c('p', [_vm._v("“I love you too Armando, tonight and always.”")]), _vm._v(" "), _c('p', [_vm._v("“Good morning, Roseabella.” said Helewise, “how was your evening with my brother?”")]), _vm._v(" "), _c('p', [_vm._v("“We had a pleasant evening, we talked a lot and got to know each other and the meal was delicious and this breakfast doesn’t look bad either.”")]), _vm._v(" "), _c('p', [_vm._v("She loaded her plate with kippers, bacon, eggs and kidneys.")]), _vm._v(" "), _c('p', [_vm._v("“You sure have a good appetite.”")]), _vm._v(" "), _c('p', [_vm._v("“This food I’ve never had before, we only had porridge, fruit and toast in the mornings.”")]), _vm._v(" "), _c('p', [_vm._v("“Oh, we never eat porridge but I could ask cook to make some.”")]), _vm._v(" "), _c('p', [_vm._v("“No, thank you, I enjoy this more.”")]), _vm._v(" "), _c('p', [_vm._v("“You’re fitting for the dress in half hour.”")]), _vm._v(" "), _c('p', [_vm._v("“I also brought my mother’s wedding dress just in case it’s short on me. My mother and I are the same size, it’s good to have something to fall back on. My mother is also bringing me a dress too of course, she has my measurements. So, if you excuse me, I think I would like to look around the castle.”")]), _vm._v(" "), _c('p', [_vm._v("“My brother did not show you around last night?”")]), _vm._v(" "), _c('p', [_vm._v("“No, I was a little tired.”")]), _vm._v(" "), _c('p', [_vm._v("“Well, you better hurry then, you have only twenty minutes left.”")]), _vm._v(" "), _c('p', [_vm._v("The paintings on the walls were scary-looking except a picture of his mother. She was so pretty and died a young life with her husband and sons. Also, lots of fireplaces and fur rugs. She got caught up in the beauty of it all.")]), _vm._v(" "), _c('p', [_vm._v("“There you are my dear, I’m your seamstress.”")]), _vm._v(" "), _c('p', [_vm._v("“It’s so nice of you to come on such short notice.”")]), _vm._v(" "), _c('p', [_vm._v("“Your luck, I had one already made. Spring brings weddings, my dear and I heard Sir Armando was looking for a wife months ago. Now, let’s try it on, shall we? The material is silk and it comes from a silk worm.”")]), _vm._v(" "), _c('p', [_vm._v("“A silk worm?”")]), _vm._v(" "), _c('p', [_vm._v("“Yes, a worm that spins silk.”")]), _vm._v(" "), _c('p', [_vm._v("“It is lovely, I have never seen anything like it.”")]), _vm._v(" "), _c('p', [_vm._v("“It came off a boat from China. Now, let’s put it over your head, that’s the girl. Put your arms up and let it fall down to the floor. Let me button it up and now turn around and let me see you. My god, it fits you to a tee.”")]), _vm._v(" "), _c('p', [_vm._v("“I love it and the pearls around the sleeves and my neck line. It’s the most beautiful dress I have even seen and so white, it shines.”")]), _vm._v(" "), _c('p', [_vm._v("“And of course it’s white dear, for a virgin on her wedding day. And you are indeed blushing like a virgin.”")]), _vm._v(" "), _c('p', [_vm._v("(Roseabella is thinking, "), _c('em', [_vm._v("If only she knew about our strip poker game last night.")]), _vm._v(")")]), _vm._v(" "), _c('p', [_vm._v("“My dear, I am off now to see lady Helewise for her fitting.”")]), _vm._v(" "), _c('p', [_vm._v("“Thank you so much Mrs….?”")]), _vm._v(" "), _c('p', [_vm._v("“Oh, you can call me Bancka and you are quite welcome.”")]), _vm._v(" "), _c('p', [_vm._v("Armando was waiting at the table for the second meal of the day.")]), _vm._v(" "), _c('p', [_vm._v("“Today, Roseabella my dear, you glow and I have made you blush.”")]), _vm._v(" "), _c('p', [_vm._v("“Seems I’m doing a lot of that lately.”")]), _vm._v(" "), _c('p', [_vm._v("“Only ladies blush, my love.”")]), _vm._v(" "), _c('p', [_vm._v("“I missed you at breakfast.”")]), _vm._v(" "), _c('p', [_vm._v("“Yes, I am sorry but I had important duties to attend to.”")]), _vm._v(" "), _c('p', [_vm._v("“You are forgiven. I know you are a busy man with responsibilities.”")]), _vm._v(" "), _c('p', [_vm._v("“And if only I could keep my mind on them, my dear; last night, I keep daydreaming about us.”")]), _vm._v(" "), _c('p', [_vm._v("“Oh Armando, I feel the same way!”")]), _vm._v(" "), _c('p', [_vm._v("“Now my dear, what do you want to eat? We have hot fresh bread and cheese. Rabbit pie and lamb stew.”")]), _vm._v(" "), _c('p', [_vm._v("“Everything looks so good. I will have to try some of everything.”")]), _vm._v(" "), _c('p', [_vm._v("“You have a good appetite like myself, my dear.”")]), _vm._v(" "), _c('p', [_vm._v("“At the castle, we were only served broth and sandwiches for lunch; dinnertime, we had 2 courses. Same thing every day.”")]), _vm._v(" "), _c('p', [_vm._v("“It must have been boring for you.”")]), _vm._v(" "), _c('p', [_vm._v("“Yes, it was sir and now thanks to you, I will put on 50 pounds.”")]), _vm._v(" "), _c('p', [_vm._v("“Oh, don’t worry about the weight my dear, you’ll burn it off in my bed.”")]), _vm._v(" "), _c('p', [_vm._v("“My Lord, the staff might over hear us.”")]), _vm._v(" "), _c('p', [_vm._v("“They won’t eavesdrop if they want to keep their jobs. Plus, you will keep in good shape with your training.”")]), _vm._v(" "), _c('p', [_vm._v("“My training? What are you saying?”")]), _vm._v(" "), _c('p', [_vm._v("“You and my sister and the younger women from my staff will learn to defend themselves against vampires.”")]), _vm._v(" "), _c('p', [_vm._v("“My god Armando, has it come to this?”")]), _vm._v(" "), _c('p', [_vm._v("“Yes, they will attack the castle and if they populate like they do, they may wipe us all out. When my men are trained, we will hunt them down. I will leave men with you and the women and children.”")]), _vm._v(" "), _c('p', [_vm._v("“Armando, I and my brother Eder used to practice each day with our wooden swords the grounds keeper made for us. I can handle myself, my lord.”")]), _vm._v(" "), _c('p', [_vm._v("“Can you also then stake a vampire in the heart and cut off his head?”")]), _vm._v(" "), _c('p', [_vm._v("“Yes, if I have to, I would.”")]), _vm._v(" "), _c('p', [_vm._v("“Roseabella, you are not only beautiful but also very brave.”")]), _vm._v(" "), _c('p', [_vm._v("“Glad you think so. Armando, if you think I am trained as good as the men, will you take me with you?”")]), _vm._v(" "), _c('p', [_vm._v("“What are you asking me Roseabella?”")]), _vm._v(" "), _c('p', [_vm._v("“That you give me a chance to be by your side.”")]), _vm._v(" "), _c('p', [_vm._v("“I will think about it.”")]), _vm._v(" "), _c('p', [_vm._v("She jumped up and sat in his lap and kissed him hard on his mouth.")]), _vm._v(" "), _c('p', [_vm._v("“You better get off my lap now or I am going to take you on this chair, then the staff will have something to talk about.”")]), _vm._v(" "), _c('p', [_vm._v("“I will see you at dinner, Armando.” and then made a run for it.")]), _vm._v(" "), _c('p', [_vm._v("“You’re are a tease, Roseabella!” (A charming woman. How will I tell her no, you cannot hunt with me? I’m going to have my hands full with that one)")]), _vm._v(" "), _c('p', [_vm._v("Roseabella went to the kitchen and spoke to Meiga.")]), _vm._v(" "), _c('p', [_vm._v("“I’m so pleased you and cooks do a pleasant job on the meals. And the cleaning staff, the castle is spotless.”")]), _vm._v(" "), _c('p', [_vm._v("“We are doing our best, my lady for your wedding day. Since you are here my lady, what courses would you like for your wedding supper?”")]), _vm._v(" "), _c('p', [_vm._v("“Well, those lamb chops were so good, with peas, carrots and baby potatoes cooked in rosemary and garlic. It would be lovely for the main course, Meiga I’ll leave it up to you for the first course and dessert.”")]), _vm._v(" "), _c('p', [_vm._v("“My lady, are you sure? Thank you, my lady it will be an honor.”")]), _vm._v(" "), _c('p', [_vm._v("“There’s only one thing you must do Meiga, is to put lots of wine on my mother’s and father’s table. And for my husband also, of course.”")]), _vm._v(" "), _c('p', [_vm._v("“My lady, I will do it myself and some strawberries and cream on the side.”")]), _vm._v(" "), _c('p', [_vm._v("“That would be wonderful. I have a feeling you and me are going to be friends, Meiga.”")]), _vm._v(" "), _c('p', [_vm._v("“Oh, I hope so too, my lady.”")]), _vm._v(" "), _c('p', [_vm._v("Roseabella went back to her room and laid down on her soft, comfortable bed. It wasn’t long before she was asleep and in dreamland. Her husband kissed her and their son good bye.")]), _vm._v(" "), _c('p', [_vm._v("“I’ll see you tonight, my beautiful Rose.”")]), _vm._v(" "), _c('p', [_vm._v("“I’ll be waiting my darling, with a glass of wine for us.”")]), _vm._v(" "), _c('p', [_vm._v("And then eight hours later, I and the baby were outside waiting for the men to return. The sun was going down and the gates opened, they ran and greeted Armando. When he looked at her, he was not her Armando. His eyes were black and his skin was white. He smiled and said.")]), _vm._v(" "), _c('p', [_vm._v("“I am here, Roseabella for my new family. We will go far away. You will love me like you do my cousin.”")]), _vm._v(" "), _c('p', [_vm._v("“No, no, no.” and then I saw the fangs. “NO, NO, NO!”")]), _vm._v(" "), _c('p', [_vm._v("“Roseabella, wake up, wake up, you’re having a bad dream.”")]), _vm._v(" "), _c('p', [_vm._v("“My god Helewise, it was so real. I was so scared.”")]), _vm._v(" "), _c('p', [_vm._v("“It’s ok now, you’ve been over doing it and haven’t had much sleep; when I’m over-tired, I have bad dreams too.”")]), _vm._v(" "), _c('p', [_vm._v("“I feel so silly screeching out like that.”")]), _vm._v(" "), _c('p', [_vm._v("“There’s nothing to be embarrassed about. I came to tell you dinner is in one hour.”")]), _vm._v(" "), _c('p', [_vm._v("“How long have I been asleep?”")]), _vm._v(" "), _c('p', [_vm._v("“Four hours.”")]), _vm._v(" "), _c('p', [_vm._v("“Oh my, I was tired.”")]), _vm._v(" "), _c('p', [_vm._v("“I’ll send in the maid to get you ready.”")]), _vm._v(" "), _c('p', [_vm._v("“Thank you very much, Helewise.”")]), _vm._v(" "), _c('p', [_vm._v("“Think nothing of it. See you in an hour then.”")]), _vm._v(" "), _c('p', [_vm._v("Roseabella still felt shaken at the dream. It was so real. I must stop thinking about it. When I saw Helewise at the dining table, I was embarrassed with the dress I wore. She looked beautiful in her dress, layers of ruffles hung down her waist, mutton sleeves and low neck line and a blue sapphire necklace. Her dress was blue like her eyes.")]), _vm._v(" "), _c('p', [_vm._v("“Roseabella, you look stunning.”")]), _vm._v(" "), _c('p', [_vm._v("“Thank you, Armando but your sister is the one that looks stunning.”")]), _vm._v(" "), _c('p', [_vm._v("“Thank you Roseabella and you look pretty as well.”")]), _vm._v(" "), _c('p', [_vm._v("“Would you like some wine my love?”")]), _vm._v(" "), _c('p', [_vm._v("“Yes, I would, it’s so tasty my darling.”")]), _vm._v(" "), _c('p', [_vm._v("“I’m glad you like it. How was your day darling, did you have a look around the castle?”")]), _vm._v(" "), _c('p', [_vm._v("“Yes, I did for a little while and I spoke to Meiga and we planned the supper for the wedding.”")]), _vm._v(" "), _c('p', [_vm._v("“I am so proud of you, Roseabella.”")]), _vm._v(" "), _c('p', [_vm._v("“Thank you, Armando. I also told Meiga to have extra wine on father’s table. I can’t wait for him to try it. My mother will also love it, Armando because it’s not so dry.”")]), _vm._v(" "), _c('p', [_vm._v("“What a good idea Roseabella, you will make a good planner for your future parties.”")]), _vm._v(" "), _c('p', [_vm._v("“My dear brother, isn’t my job to plan our dinner parties?”")]), _vm._v(" "), _c('p', [_vm._v("“I’m sorry Helewise but all you do is send out invitations. Meiga has to take care of everything else.”")]), _vm._v(" "), _c('p', [_vm._v("“That’s her job brother, anyway she won’t let me in the kitchen or go to the village and pick out produce.”")]), _vm._v(" "), _c('p', [_vm._v("“Helewise between us both, I’m sure we will manage a little dinner party. You must do the invitation because I know no one. We were not allowed to socialize with guest.”")]), _vm._v(" "), _c('p', [_vm._v("“Why not?”")]), _vm._v(" "), _c('p', [_vm._v("“My parent’s thought children were kept away from grown-ups.”")]), _vm._v(" "), _c('p', [_vm._v("“That is terrible, Roseabella.”")]), _vm._v(" "), _c('p', [_vm._v("“Yes, it was but my brother and I would sneak over the stairs and see them drink and dance.”")]), _vm._v(" "), _c('p', [_vm._v("“And how old is your brother?”")]), _vm._v(" "), _c('p', [_vm._v("“My brother Eder is 16, one year younger than me.”")]), _vm._v(" "), _c('p', [_vm._v("The servants came in with platters of food.")]), _vm._v(" "), _c('p', [_vm._v("“You have so many different dishes, my lord. I don’t know what to choose from.”")]), _vm._v(" "), _c('p', [_vm._v("“You must try them all, my dear and see what will be to your liking.”")]), _vm._v(" "), _c('p', [_vm._v("There was salmon, baked with herbs and lemon slices and stuffed with bacon. Bread and baby onions. A leg of lamb with Krispy skin and pink and juicy inside and a duck glazed with orange sauce.")]), _vm._v(" "), _c('p', [_vm._v("“I have not seen so much food before, my lord.”")]), _vm._v(" "), _c('p', [_vm._v("“If you call me my lord one more time, I will spank you.”")]), _vm._v(" "), _c('p', [_vm._v("“My brother speaks his mind, Roseabella.”")]), _vm._v(" "), _c('p', [_vm._v("Roseabella tried everything like Armando told her to do. She enjoyed all the dishes. The one she enjoyed the most was the duck and orange sauce.")]), _vm._v(" "), _c('p', [_vm._v("“I hope you left some room for dessert my dear.”")]), _vm._v(" "), _c('p', [_vm._v("“You do have a sweet tooth, don’t you Armando?”")]), _vm._v(" "), _c('p', [_vm._v("“Yes, I love my dessert.” He looked at her with mischief in his eyes.")]), _vm._v(" "), _c('p', [_vm._v("“Maybe I’ll look forward to our dessert too!”")]), _vm._v(" "), _c('p', [_vm._v("“Do you two want me to leave the table, have you noticed I’m at the table?”")]), _vm._v(" "), _c('p', [_vm._v("“I’m sorry Helewise for leaving you out of our conversation. Will we have dessert now, my sister?”")]), _vm._v(" "), _c('p', [_vm._v("For dessert, it was apple tarts and fresh cream.")]), _vm._v(" "), _c('p', [_vm._v("“Armando, those apples are the sweetest I ever tasted.”")]), _vm._v(" "), _c('p', [_vm._v("Again, Helewise was feeling left out.")]), _vm._v(" "), _c('p', [_vm._v("“Roseabella was having a nightmare today, brother when I went to check on her.”")]), _vm._v(" "), _c('p', [_vm._v("“I am so sorry my love, I was not with you. They say if you talk about it, you won’t dream about it again.”")]), _vm._v(" "), _c('p', [_vm._v("“Oh Armando, I feel so stupid now.”")]), _vm._v(" "), _c('p', [_vm._v("“Just tell us about it, Roseabella.”")]), _vm._v(" "), _c('p', [_vm._v("“If you insist Armando, I and my child and Helewise were waiting for you and when you returned, you were a vampire who looked like you but his eyes were black and his skin so white. He said: ‘Go on Roseabella.’ He said you were his cousin and he wanted your family. No, I told him and then he showed his fangs. Your sister woke me up from my screams.”")]), _vm._v(" "), _c('p', [_vm._v("Armando and Helewise looked at each other in shock. A few minutes went by and no one spoke.")]), _vm._v(" "), _c('p', [_vm._v("“Armando, you look white as a ghost. Please talk to me. Helewise, what is wrong?”")]), _vm._v(" "), _c('p', [_vm._v("“I do not know how to explain this to you and how our cousin got into your head, Roseabella.”")]), _vm._v(" "), _c('p', [_vm._v("“What my brother is trying to say is, Garret our cousin that looks like Armando is a vampire.”")]), _vm._v(" "), _c('p', [_vm._v("“But how would you know he is a vampire?”")]), _vm._v(" "), _c('p', [_vm._v("“We have both seen him, Roseabella.” Armando finally spoke. “We were close growing up, just like brothers. We were the same age. Our fathers were brothers, we went hunting and horse-racing together. We spent time at the ale house together and picked up a lot of women. I got tired of the whores, they were scarred and dirty.")]), _vm._v(" "), _c('p', [_vm._v("My cousin didn’t care as long as he could drink. When the vampires hung out at the inns in the night time for their victims, I stayed away. My cousin thought he could make it home every night before dark because he had a lodge in the village. We found him dead in the alley from the inn.”")]), _vm._v(" "), _c('p', [_vm._v("“I’m so sorry Armando. I know what a brother means to you.”")]), _vm._v(" "), _c('p', [_vm._v("“Roseabella my darling, you don’t know the slightest think about the dead. My uncle said he would cut off his head and put a wooden spike through his heart. The next morning after his funeral, they left the country. They did not care if he rose from the grave.”")]), _vm._v(" "), _c('p', [_vm._v("“Why would I dream about a man I never met?”")]), _vm._v(" "), _c('p', [_vm._v("“I’m sorry, Roseabella but they will try and get in your mind. Why don’t we concentrate on the wedding?”")]), _vm._v(" "), _c('p', [_vm._v("“But if her dream is true, we have a child to be born.” (You are right Helewise, in nine months.)")]), _vm._v(" "), _c('p', [_vm._v("“I will leave you both alone as it’s the last night you will be single.”")]), _vm._v(" "), _c('p', [_vm._v("“Good night Helewise.”")]), _vm._v(" "), _c('p', [_vm._v("“Goodnight sister.”")]), _vm._v(" "), _c('p', [_vm._v("“Do you think my dream and your cousin connect?” (Why would the woman I’m about to marry dream about my cousin she never met?)")]), _vm._v(" "), _c('p', [_vm._v("“I do not know my love but I know we will put extra guards on the castle walls.”")]), _vm._v(" "), _c('p', [_vm._v("“Armando, I will train hard as I can night and day; no one will take me as a prisoner.”")]), _vm._v(" "), _c('p', [_vm._v("“Oh Roseabella, I love you so much. I never thought I could feel about anyone until I met you.”")]), _vm._v(" "), _c('p', [_vm._v("“I feel the same way, Armando.”")]), _vm._v(" "), _c('p', [_vm._v("“After the wedding, we will train to kill the vampires and keep my cousin away from you. We will not have children until every last one is beheaded.”")]), _vm._v(" "), _c('p', [_vm._v("Armando walked Roseabella to her quarters and said he loved her and how he was looking forward to their wedding.")]), _vm._v(" "), _c('p', [_vm._v("“You need a good night’s sleep, Roseabella. Your family will be here tomorrow.”")]), _vm._v(" "), _c('p', [_vm._v("“I love you, Armando. I will be honored to fight by your side.”")]), _vm._v(" "), _c('p', [_vm._v("“Please Roseabella, I can’t think about it now. We’ll wait for after the wedding and your training.”")]), _vm._v(" "), _c('p', [_vm._v("“I won’t disappoint you Armando, I will work until I drop.”")]), _vm._v(" "), _c('p', [_vm._v("“You are worth a thousand men, my dear. Go to sleep and dream about our wedding day.”")]), _vm._v(" "), _c('p', [_vm._v("“Good night, Armando, you are the light in my life.”")]), _vm._v(" "), _c('p', [_vm._v("Roseabella’s family arrived at noon. They were shown to their quarters to relax and get ready for the big wedding. A knock came on her door, it was her two sisters.")]), _vm._v(" "), _c('p', [_vm._v("“Oh Roseabella, we missed you so much. We’re sorry we didn’t tell you how much you matter to us.”")]), _vm._v(" "), _c('p', [_vm._v("“It’s ok, I miss you too and our brother.”")]), _vm._v(" "), _c('p', [_vm._v("“A strange thing happened last night Roseabella, our parents came in our rooms; they hugged us and said they love us. Can you believe that?”")]), _vm._v(" "), _c('p', [_vm._v("“Yes, I do.”")]), _vm._v(" "), _c('p', [_vm._v("“You must have made a change in their lives when you left. After the wedding, we are allowed to dine with them.”")]), _vm._v(" "), _c('p', [_vm._v("When Sir Armando saw Roseabella walking up the aisle, she glowed like a diamond. His first thoughts were, I will want her in my bed till death do us part.")]), _vm._v(" "), _c('p', [_vm._v("“You may now kiss the bride. I have waited for this all-day, Roseabella.”")]), _vm._v(" "), _c('p', [_vm._v("“Oh Armando, so have I.”")]), _vm._v(" "), _c('p', [_vm._v("Her parents told her how beautiful she was. Her mother could not believe how beautiful her dress was.")]), _vm._v(" "), _c('p', [_vm._v("“I have not seen anything like it in my life.”")]), _vm._v(" "), _c('p', [_vm._v("“It is silk mother, from China.”")]), _vm._v(" "), _c('p', [_vm._v("And thinking to herself, "), _c('em', [_vm._v("The silk worm I will not explain.")])]), _vm._v(" "), _c('p', [_vm._v("“Dinner is now served.”")]), _vm._v(" "), _c('p', [_vm._v("The three-course meal was so excellent. Meiga done a wonderful job. Her father and mother both loved the wine. Her brother and sisters were also sneaking it.")]), _vm._v(" "), _c('p', [_vm._v("After everyone finished their meal, they were moved into the ball room. Roseabella and Armando had the first dance. A slow waltz. She could feel his hardness against her thigh.")]), _vm._v(" "), _c('p', [_vm._v("“I want you now, so bad I think I’m going to cum in my pants.”")]), _vm._v(" "), _c('p', [_vm._v("“I want you too darling but we have to dance with my parents. Then we can sneak away.”")]), _vm._v(" "), _c('p', [_vm._v("Roseabella’s brother and sisters laughed and seemed to be a bit drunk.")]), _vm._v(" "), _c('p', [_vm._v("“Mother and father, it has been a long day and my husband is tired and would like to turn in.”")]), _vm._v(" "), _c('p', [_vm._v("“My daughter, I know I haven’t said this to you before but I am proud to be your father.”")]), _vm._v(" "), _c('p', [_vm._v("She was spellbound.")]), _vm._v(" "), _c('p', [_vm._v("“Thank you, father. I know it took a lot to show your feelings. In the future, we will become a loving family.”")]), _vm._v(" "), _c('p', [_vm._v("“Now if you will excuse us Duke, we will say our goodnight.”")]), _vm._v(" "), _c('p', [_vm._v("“Thank you so much for a wonderful wedding day. I will cherish it for the rest of my life.”")]), _vm._v(" "), _c('p', [_vm._v("“The day was good but all I could think about was your naked body.”")]), _vm._v(" "), _c('p', [_vm._v("Roseabella could feel heat go through her body.")]), _vm._v(" "), _c('p', [_vm._v("“Turn around my dear, so I can undo the buttons.”")]), _vm._v(" "), _c('p', [_vm._v("She could feel his fingers slide down her back while he was undoing the buttons. He then slid the dress over the shoulders and let it drop to the floor. He turned her around and brought her toward his mouth and body.")]), _vm._v(" "), _c('p', [_vm._v("“Your skin is like silk and you taste of strawberries. You are the only woman for me.”")]), _vm._v(" "), _c('p', [_vm._v("He laid her down on his bed and made love to her like there was no tomorrow. She fell asleep in his arms. Armando could not stop thinking about her dream and his cousin. Tomorrow, they would start their training. It could not be postponed any longer, he would kill himself if he became one of them.")]), _vm._v(" "), _c('p', [_vm._v("Armando and Roseabella were up at daylight to say good bye to her family.")]), _vm._v(" "), _c('p', [_vm._v("“I’m going to miss all of you.”")]), _vm._v(" "), _c('p', [_vm._v("“We will see a lot of you my daughter, your brother and two sisters will train to fight also.”")]), _vm._v(" "), _c('p', [_vm._v("“That is a good idea, father. Armando and his men will do a good job.”")]), _vm._v(" "), _c('p', [_vm._v("“I’ll bring them for a few days next week. Starting tomorrow, I’ll train them myself also. Roseabella my dear daughter, your wedding went so smooth. The three-layer wedding cake; I never tasted anything like it.”")]), _vm._v(" "), _c('p', [_vm._v("“Would you mind if our cook traded recipes?”")]), _vm._v(" "), _c('p', [_vm._v("“I’m sure Meiga would not mind mother.”")]), _vm._v(" "), _c('p', [_vm._v("“Helewise my dear sister, would you explain to the women about protecting themselves when the men are hunting down the vampires? Pick out the women between fourteen and fifty that are in good shape.”")]), _vm._v(" "), _c('p', [_vm._v("“Yes Armando, the two twin sisters are quite good with the bow and arrow. And are good with the sword too.”")]), _vm._v(" "), _c('p', [_vm._v("“And how would you know this?”")]), _vm._v(" "), _c('p', [_vm._v("“After work, I practice with them and their brothers.”")]), _vm._v(" "), _c('p', [_vm._v("“Helewise, have I told you lately how proud I am of you, my sister?”")]), _vm._v(" "), _c('p', [_vm._v("“Not lately, Armando but I know a way you can make it up to me.”")]), _vm._v(" "), _c('p', [_vm._v("“Ok little mouse, what do you want?”")]), _vm._v(" "), _c('p', [_vm._v("“I and the two twin sisters want to go on a hunt with you.”")]), _vm._v(" "), _c('p', [_vm._v("“To hunt for deer, you mean?”")]), _vm._v(" "), _c('p', [_vm._v("“Of course not Armando, to hunt the blood suckers.”")]), _vm._v(" "), _c('p', [_vm._v("“My god, you’re just as bad as Roseabella.”")]), _vm._v(" "), _c('p', [_vm._v("“Does Roseabella want to hunt them too?”")]), _vm._v(" "), _c('p', [_vm._v("“Yes, she does.”")]), _vm._v(" "), _c('p', [_vm._v("“Can she also handle a sword?”")]), _vm._v(" "), _c('p', [_vm._v("“She said yes.”")]), _vm._v(" "), _c('p', [_vm._v("“Well, then I must round up the women and see!”")]), _vm._v(" "), _c('p', [_vm._v("“There are ten men waiting in the court yard with wooded swords and stakes to train you and the women and would you kindly let my wife know.”")]), _vm._v(" "), _c('p', [_vm._v("“Well of course, dear brother.” and thinking she can’t wait to kick Roseabella’s ass.")]), _vm._v(" "), _c('p', [_vm._v("“Sir Armando, one of the Dukes’ men is riding this way and on another horse, looks like two bodies.”")]), _vm._v(" "), _c('p', [_vm._v("“It’s sunlight, so opens the gates.”")]), _vm._v(" "), _c('p', [_vm._v("“Sir Armando, I have bad news I’m afraid.”")]), _vm._v(" "), _c('p', [_vm._v("“Out with it, man.”")]), _vm._v(" "), _c('p', [_vm._v("“We found two bodies on our way. The Duke said it was the Ederlyns. They are drained of blood and bite marks on their necks.”")]), _vm._v(" "), _c('p', [_vm._v("“We had a room for them, why in the hell did they leave? Poor devils, they thought they could beat the darkness.”")]), _vm._v(" "), _c('p', [_vm._v("“Meiga, I would like to thank you for the splendid wedding supper. The chicken soup and salad were a good choice for the first course. And oh, Meiga when I entered the dining room and saw a three-layer cake with baby breath on it, tears came to my eyes.”")]), _vm._v(" "), _c('p', [_vm._v("“Oh my lady, it was my pleasure.”")]), _vm._v(" "), _c('p', [_vm._v("“And who is this little girl sweeping the floors?”")]), _vm._v(" "), _c('p', [_vm._v("“This is my granddaughter, Saige.”")]), _vm._v(" "), _c('p', [_vm._v("And with a bow, she said.")]), _vm._v(" "), _c('p', [_vm._v("“It’s so nice to meet you, my ladyship.”")]), _vm._v(" "), _c('p', [_vm._v("“Very nice to meet you, Saige.”")]), _vm._v(" "), _c('p', [_vm._v("“I picked the strawberries for your wedding table.”")]), _vm._v(" "), _c('p', [_vm._v("“Thank you, Saige. Does your mother work here too?”")]), _vm._v(" "), _c('p', [_vm._v("“No my lady, her mother died giving birth to her.”")]), _vm._v(" "), _c('p', [_vm._v("“I’m so sorry Meiga.”")]), _vm._v(" "), _c('p', [_vm._v("“She was too young to give birth my lady.”")]), _vm._v(" "), _c('p', [_vm._v("Roseabella could not bring herself to ask how old she was.")]), _vm._v(" "), _c('p', [_vm._v("“Saige, would you like to show me your strawberry patch?”")]), _vm._v(" "), _c('p', [_vm._v("“I would love to, if it’s alright with my Gram.”")]), _vm._v(" "), _c('p', [_vm._v("“Go on then, you could use some sunshine, you are rather white today. And I can’t get her near the dining room.”")]), _vm._v(" "), _c('p', [_vm._v("“We’ll stop in my room on the way Saige, to get my wrap.”")]), _vm._v(" "), _c('p', [_vm._v("“Yes, ma’am. Oh, what a lovely room you have.”")]), _vm._v(" "), _c('p', [_vm._v("“Thank you. Your Gran said you didn’t want to go in the dining room, why is that Saige?”")]), _vm._v(" "), _c('p', [_vm._v("“I, I, can’t tell you, my lady because you might think I’m a witch.”")]), _vm._v(" "), _c('p', [_vm._v("Saige started to cry.")]), _vm._v(" "), _c('p', [_vm._v("“Oh Saige, I don’t believe in witches.”")]), _vm._v(" "), _c('p', [_vm._v("“Then why do I see things?”")]), _vm._v(" "), _c('p', [_vm._v("“I had a dream yesterday, Saige and it seem so real.”")]), _vm._v(" "), _c('p', [_vm._v("“No my lady, you don’t understand. I wasn’t asleep.”")]), _vm._v(" "), _c('p', [_vm._v("“Please tell me what you saw, Saige.”")]), _vm._v(" "), _c('p', [_vm._v("“Well, I stood outside of the dining room to get a peep of your wedding dress and the cake Gram made for you.”")]), _vm._v(" "), _c('p', [_vm._v("“Go on, little one.”")]), _vm._v(" "), _c('p', [_vm._v("“Then, I saw those two poor people sitting at one of the tables and they were white as flour. And their neck was covered in blood. Please don’t tell anyone, they will burn me alive.”")]), _vm._v(" "), _c('p', [_vm._v("“No one’s going to burn you, my love. I won’t tell a soul. Now, show me your strawberry patch.”")]), _vm._v(" "), _c('p', [_vm._v("“Yes, my lady. I feel so stupid for crying.”")]), _vm._v(" "), _c('p', [_vm._v("“We all cry sometimes, my dear girl.”")]), _vm._v(" "), _c('p', [_vm._v("“We’re almost there.”")]), _vm._v(" "), _c('p', [_vm._v("“Why are there so many people at the gate so early in the morning? I see Armando, let’s go to find out.”")]), _vm._v(" "), _c('p', [_vm._v("“Roseabella, I don’t want you to see this.”")]), _vm._v(" "), _c('p', [_vm._v("“And why not, husband?”")]), _vm._v(" "), _c('p', [_vm._v("“Last night, the Ederlyns left too late.”")]), _vm._v(" "), _c('p', [_vm._v("“What are you saying, Armando?”")]), _vm._v(" "), _c('p', [_vm._v("“They ran into the devil of the night.”")]), _vm._v(" "), _c('p', [_vm._v("Roseabella wasn’t a woman afraid to look at dead bodies, she had seen enough of them during the plague. Her husband had the bodies laid out in a cart, she lowered the blanket and saw the couple who was at their wedding. Laughing and dancing last night. She looked over at Saige and ran to catch her before she hit the ground.")]), _vm._v(" "), _c('p', [_vm._v("“Armando, bring her to my room. Get a maid and bring a rag and cold water.”")]), _vm._v(" "), _c('p', [_vm._v("“It was too much my dear, for a child her age to see.”")]), _vm._v(" "), _c('p', [_vm._v("Armando came back with the maid.")]), _vm._v(" "), _c('p', [_vm._v("“You can leave now and you too, Armando. I know what you have to do with the bodies before the family collects them.”")]), _vm._v(" "), _c('p', [_vm._v("“You are right, my dear.”")]), _vm._v(" "), _c('p', [_vm._v("Armando turns around and looks at her, she said.")]), _vm._v(" "), _c('p', [_vm._v("“Would it be a good time to do it in front of the women in training? So, they know what’s to be done.”")]), _vm._v(" "), _c('p', [_vm._v("“Yes, you are absolutely right. I will see you at dinner my dear.”")]), _vm._v(" "), _c('p', [_vm._v("Roseabella bathed the girl’s little face with water. Her hands were icy cold.")]), _vm._v(" "), _c('p', [_vm._v("“Let me rub them for you, little one. You need to come back to us Saige. Your Grams and Gramps need you; they are waiting for the doctor to arrive.”")]), _vm._v(" "), _c('p', [_vm._v("Saige’s eyes finally came open.")]), _vm._v(" "), _c('p', [_vm._v("“I’m sorry I took you with me. I didn’t know at the time it was dead bodies.”")]), _vm._v(" "), _c('p', [_vm._v("“It’s ok my lady, I seen them last night.”")]), _vm._v(" "), _c('p', [_vm._v("“Oh Saige, don’t be scared.”")]), _vm._v(" "), _c('p', [_vm._v("“Am I a witch, my lady?”")]), _vm._v(" "), _c('p', [_vm._v("“Can you fly on a broom, turn a frog into a prince?”")]), _vm._v(" "), _c('p', [_vm._v("“Well, no I can’t.”")]), _vm._v(" "), _c('p', [_vm._v("“Well then, you are not a witch.”")]), _vm._v(" "), _c('p', [_vm._v("“So, what is wrong with me?”")]), _vm._v(" "), _c('p', [_vm._v("“I don’t know for sure, my dear but I think you are blessed with the insight.”")]), _vm._v(" "), _c('p', [_vm._v("“What is the insight?”")]), _vm._v(" "), _c('p', [_vm._v("“You can see danger before it happens. Has there been any other episodes?”")]), _vm._v(" "), _c('p', [_vm._v("“Yes, once I saw Gramps thrown from his horse and hit his head on a rock.”")]), _vm._v(" "), _c('p', [_vm._v("“What did you do?”")]), _vm._v(" "), _c('p', [_vm._v("“I climbed on top of the gate and told the guards. They told me to leave at first and then they could see Gramps’ horse running toward the gate without him.”")]), _vm._v(" "), _c('p', [_vm._v("“You saved your grandfather’s life.”")]), _vm._v(" "), _c('p', [_vm._v("“My Gram and Gramps don’t want me to talk about it. Please don’t tell them. People don’t understand and they are all so superstitious.”")]), _vm._v(" "), _c('p', [_vm._v("“I’ll keep it a secret between us.”")]), _vm._v(" "), _c('p', [_vm._v("“Do you promise?”")]), _vm._v(" "), _c('p', [_vm._v("“Yes, I do, on one condition that you tell me when you have another vision. It could save lives. And I know you are young, Saige but I’d like you to train how to fight with the other girls.”")]), _vm._v(" "), _c('p', [_vm._v("“I’m already pretty good at it, my Gramps teaches me. My Gram calls me a tom boy.”")]), _vm._v(" "), _c('p', [_vm._v("“We all have some tom boy in us because I like to fight too. Now, I’ll bring you to your grandparents. They are anxious to see you.”")]), _vm._v(" "), _c('p', [_vm._v("“What will you tell them?”")]), _vm._v(" "), _c('p', [_vm._v("“That you fainted because the dead bodies were too scary for you.”")]), _vm._v(" "), _c('p', [_vm._v("Roseabella said to the grandparents.")]), _vm._v(" "), _c('p', [_vm._v("“You can come in now and the doctor won’t be necessary. She had a shock looking at the dead bodies, I’m afraid it was my fault.”")]), _vm._v(" "), _c('p', [_vm._v("“I feel a lot better now Gram, I will help you in the kitchen.”")]), _vm._v(" "), _c('p', [_vm._v("But Roseabella says, “No, she will have the rest of the day in bed with her meals served in her room.”")]), _vm._v(" "), _c('p', [_vm._v("“Thank you so much my lady, you are so kind to us.”")]), _vm._v(" "), _c('p', [_vm._v("“You and your family are welcome, Meiga.”")]), _vm._v(" "), _c('p', [_vm._v("After they left, a knock came on the door.")]), _vm._v(" "), _c('p', [_vm._v("“Come in.”")]), _vm._v(" "), _c('p', [_vm._v("“Good day, Roseabella. And I hate to interrupt you sister-in-law but your husband wants everyone from the castle outside in the court yard.”")]), _vm._v(" "), _c('p', [_vm._v("“I figured he would.”")]), _vm._v(" "), _c('p', [_vm._v("“Why would you know?”")]), _vm._v(" "), _c('p', [_vm._v("“I can’t say now but you will soon find out.”")]), _vm._v(" "), _c('p', [_vm._v("“Let’s go then, so I can see what’s up.”")]), _vm._v(" "), _c('p', [_vm._v("Armando was standing around the wagon. Everyone was gathered around him in a big circle.")]), _vm._v(" "), _c('p', [_vm._v("“What you see here today are two victims that left the castle last night who did not make it before dark. The Duke’s man sent the bodies to me to show every one of you how to kill a vampire.”")]), _vm._v(" "), _c('p', [_vm._v("Armando uncovered the victims. The people’s faces showed shock. The bodies were then tied up against a post.")]), _vm._v(" "), _c('p', [_vm._v("“First, we shall take this spike and put it through his heart and then he will be beheaded.”")]), _vm._v(" "), _c('p', [_vm._v("With all his strength, he stuck the spike through the man’s heart and before he lost his nerve, he swung his sword at the neck and it fell to the ground. The soldier took the head and body and laid it on the cart.")]), _vm._v(" "), _c('p', [_vm._v("“Who would like to volunteer to do the woman?”")]), _vm._v(" "), _c('p', [_vm._v("Everyone moved back, even the men.")]), _vm._v(" "), _c('p', [_vm._v("“When it gets dark, this woman will be looking for blood. All you women will be faced with this if they get in the castle.”")]), _vm._v(" "), _c('p', [_vm._v("Roseabella knew she had to show the women. If she didn’t do it, they had no chance.")]), _vm._v(" "), _c('p', [_vm._v("“I will do it.” she stepped forward.")]), _vm._v(" "), _c('p', [_vm._v("“Roseabella, please let one of the men do it!”")]), _vm._v(" "), _c('p', [_vm._v("“No Armando, I have to show them a woman can fight and how strong we are.”")]), _vm._v(" "), _c('p', [_vm._v("Helewise, feeling a little jealous of her sister-in-law, stepped up.")]), _vm._v(" "), _c('p', [_vm._v("“Roseabella, you spike her heart and I’ll take off her head.”")]), _vm._v(" "), _c('p', [_vm._v("Armando was speechless. Roseabella said a prayer, for God to take her in heaven. Armando then gave her the spike. She took a deep breath, ran for the body and pushed the spike as hard as she could in her heart.")]), _vm._v(" "), _c('p', [_vm._v("“Are you alright, my love?”")]), _vm._v(" "), _c('p', [_vm._v("“I will be ok.”")]), _vm._v(" "), _c('p', [_vm._v("“Now, it’s my turn.”")]), _vm._v(" "), _c('p', [_vm._v("Her brother gave her a sharp axe, he told her it would be easier. Helewise walked up to the body and with two chops, the head fell to the ground.")]), _vm._v(" "), _c('p', [_vm._v("“Well done, little mouse. You grew up overnight.”")]), _vm._v(" "), _c('p', [_vm._v("“Now big brother, you have no excuse for us to not go on the hunt!”")]), _vm._v(" "), _c('p', [_vm._v("“Come on you women, we have training to do. You will be given a wooded sword to practice. We don’t want you to cut each other’s hands off. Ten men will train twenty women. Let’s start training and kick their ass. Roseabella, you need to lie down for a while.”")]), _vm._v(" "), _c('p', [_vm._v("“No Armando, I need to train with the others. I need to fight with the men. You will tell them not to give me special treatment.”")]), _vm._v(" "), _c('p', [_vm._v("“I am so proud of you and it took a lot of guts what you did.”")]), _vm._v(" "), _c('p', [_vm._v("“You go now, Armando and train your men and I will see you at dinner.”")]), _vm._v(" "), _c('p', [_vm._v("Armando kissed her lips, “Until then, my wife.”")]), _vm._v(" "), _c('p', [_vm._v("Her arms and legs were paining and burning with bruises. They kept it up for three hours. Helewise called it a day.")]), _vm._v(" "), _c('p', [_vm._v("“Tomorrow, we practice two hours in the morning and three after the noon meal. Everyone, go to the kitchen, Meiga has soup and sandwiches waiting and glasses of ale.”")]), _vm._v(" "), _c('p', [_vm._v("They all took off running. Before Roseabella went to eat, she checked on Saige.")]), _vm._v(" "), _c('p', [_vm._v("“How are you feeling, little one?”")]), _vm._v(" "), _c('p', [_vm._v("“Much better, thank you my lady, one of the maids told me what you and Helewise did.”")]), _vm._v(" "), _c('p', [_vm._v("“Oh, and what do you think of what we did?”")]), _vm._v(" "), _c('p', [_vm._v("“You’re are the bravest women in the world.”")]), _vm._v(" "), _c('p', [_vm._v("“I wouldn’t go that far. We have to conquer our fears, Saige and learn to fight back.”")]), _vm._v(" "), _c('p', [_vm._v("“I want to be like you when I grow up.”")]), _vm._v(" "), _c('p', [_vm._v("“Oh you do, do ya! Saige, I want to tell you about my dream. In my dream, I saw a man like my husband, his hair was the same and his face was a lot alike but his eyes were black and his skin was white. He said he was Garrett, my husband’s cousin. And he came to take me and my baby.")]), _vm._v(" "), _c('p', [_vm._v("He wanted us for his family. When he smiled at me, he had fangs. I could not stop screaming until Helewise woke me up. Why I am telling you this is because I did not know my husband had a cousin and never seen him before, only in my dream.”")]), _vm._v(" "), _c('p', [_vm._v("“Oh, my lady I won’t let him take you, I hope I’ll have the vision to warn you in time, so you can hide.”")]), _vm._v(" "), _c('p', [_vm._v("“Oh Saige, you are a gift to us all.”")]), _vm._v(" "), _c('p', [_vm._v("“Thank you, my lady and I am no longer afraid of my visions.”")]), _vm._v(" "), _c('p', [_vm._v("“I’m glad to hear that. I have to go now and clean up.”")]), _vm._v(" "), _c('p', [_vm._v("“Would you like some wedding cake with strawberries on it?”")]), _vm._v(" "), _c('p', [_vm._v("“You are so kind, my lady.”")]), _vm._v(" "), _c('p', [_vm._v("Roseabella had her meal sent to her room and a jug of wine, she needed to be alone and to think about the day’s event. The maids had a tub of hot water with rose petals floating in it. After she finished her meal, she poured herself a glass of wine and lowered her body in the tub. Oh, this feels wonderful!")]), _vm._v(" "), _c('p', [_vm._v("“You look wonderful, my wife.”")]), _vm._v(" "), _c('p', [_vm._v("“Oh Armando, you scared me.”")]), _vm._v(" "), _c('p', [_vm._v("“I didn’t mean to but could you move your legs up?”")]), _vm._v(" "), _c('p', [_vm._v("She watched him undress and he then slipped in the tub.")]), _vm._v(" "), _c('p', [_vm._v("“Armando, what are you doing?”")]), _vm._v(" "), _c('p', [_vm._v("“If you turn around, I am going to wash your back.”")]), _vm._v(" "), _c('p', [_vm._v("She turned around as he ordered her. He lifted up her long hair and washed her neck and her back down to her bum.")]), _vm._v(" "), _c('p', [_vm._v("“That feels so good, Armando.”")]), _vm._v(" "), _c('p', [_vm._v("“You are the one who feels good, my love.”")]), _vm._v(" "), _c('p', [_vm._v("Next, he washed her throat and then her breasts. He squeezed her nipples and she let out a moan. He lowered his hand between her thighs.")]), _vm._v(" "), _c('p', [_vm._v("“Oh, Armando don’t stop.”")]), _vm._v(" "), _c('p', [_vm._v("He slipped his finger up inside of her.")]), _vm._v(" "), _c('p', [_vm._v("“You are so wet and I want you now, my wife.” he lifted her up and put her on top of his rod. He thrusted until every inch was inside her. Roseabella screamed out with pleasure, he buried his mouth in her hair and the back of her neck. With his hand on her breast, he fucked her so hard they both screamed out each other’s names and came at the same time.")]), _vm._v(" "), _c('p', [_vm._v("Roseabella leaned back in her husband’s arms and cried.")]), _vm._v(" "), _c('p', [_vm._v("“My love, did I hurt you? Was I too rough?”")]), _vm._v(" "), _c('p', [_vm._v("“No my darling, I needed a release and you gave it to me.”")]), _vm._v(" "), _c('p', [_vm._v("“I love you Roseabella, what you did today took courage. I am so proud of you. It’s going to be alright, my love as long as we have each other at the end of the day.”")]), _vm._v(" "), _c('p', [_vm._v("“Yes, you are right, husband but we better get ready for dinner before you sister starts banging on the door.”")]), _vm._v(" "), _c('p', [_vm._v("When they entered the dining room, Helewise was already there. She had on a loose plain dress.")]), _vm._v(" "), _c('p', [_vm._v("“Have you forgotten to dress for dinner?”")]), _vm._v(" "), _c('p', [_vm._v("“My brother, I ache from my teeth down to my toes. I cannot bear anything hot or tight against my body.”")]), _vm._v(" "), _c('p', [_vm._v("“Well, we feel much better since our hot bath.”")]), _vm._v(" "), _c('p', [_vm._v("“I did bathe, if not I wouldn’t have been able to walk.”")]), _vm._v(" "), _c('p', [_vm._v("“Meiga can get some horse liniment to rub on your sore bones.”")]), _vm._v(" "), _c('p', [_vm._v("“In case you don’t notice, I am not a horse.”")]), _vm._v(" "), _c('p', [_vm._v("“I use it every day after training. It doesn’t smell that bad. And anyway, if it didn’t smell bad it wouldn’t work!”")]), _vm._v(" "), _c('p', [_vm._v("“How are you feeling Helewise, emotionally after the ordeal? Are you afraid of nightmares tonight?”")]), _vm._v(" "), _c('p', [_vm._v("“I’m so tired and after a jug of wine, hopefully I’ll be dead to the world? And you sister-in-law?”")]), _vm._v(" "), _c('p', [_vm._v("“I’m going to be ok. It had to be done if we wanted respect from the women.”")]), _vm._v(" "), _c('p', [_vm._v("“I agree.”")]), _vm._v(" "), _c('p', [_vm._v("“And how is the little girl who fainted today?”")]), _vm._v(" "), _c('p', [_vm._v("“What girl, Armando?”")]), _vm._v(" "), _c('p', [_vm._v("“She is Meiga’s granddaughter.”")]), _vm._v(" "), _c('p', [_vm._v("“And why did she faint?”")]), _vm._v(" "), _c('p', [_vm._v("“It was my fault, she was taking me to the strawberry patch when we noticed Armando and we went over to see what everyone was looking at. I pulled back the blanket and just managed to catch her before she hit the ground.”")]), _vm._v(" "), _c('p', [_vm._v("“Poor little thing, how old is she?”")]), _vm._v(" "), _c('p', [_vm._v("“I think she is ten.”")]), _vm._v(" "), _c('p', [_vm._v("Helewise then said, “Did you know her mother died giving birth to her at the age of thirteen?”")]), _vm._v(" "), _c('p', [_vm._v("“Who is the father?”")]), _vm._v(" "), _c('p', [_vm._v("“A fortune teller’’ son, he got her drunk and took advantage of her.”")]), _vm._v(" "), _c('p', [_vm._v("“Does Saige know about her father and her grandmother?”")]), _vm._v(" "), _c('p', [_vm._v("“No, only us and of course, her grandparents.”")]), _vm._v(" "), _c('p', [_vm._v("“Was her grandmother a real fortune teller?”")]), _vm._v(" "), _c('p', [_vm._v("“Well, she took my fortune a couple of years ago in a village in town.”")]), _vm._v(" "), _c('p', [_vm._v("“Well, are you going to tell us sister or not about this fortune?”")]), _vm._v(" "), _c('p', [_vm._v("“You’re not going to believe me.”")]), _vm._v(" "), _c('p', [_vm._v("“And why not?”")]), _vm._v(" "), _c('p', [_vm._v("“She told me I was to become a vampire slayer.”")]), _vm._v(" "), _c('p', [_vm._v("No one spoke for a while.")]), _vm._v(" "), _c('p', [_vm._v("“Your dinner is served, my lord and my ladies.”")]), _vm._v(" "), _c('p', [_vm._v("“Meiga, why so many dishes of food?”")]), _vm._v(" "), _c('p', [_vm._v("“Well my lady, all the work you all done today, you deserve extra food and what you did for my Saige. This evening, she is perky like a bird and we haven’t seen her so happy in a long time.”")]), _vm._v(" "), _c('p', [_vm._v("“Tell her she can watch the women train at noon.”")]), _vm._v(" "), _c('p', [_vm._v("“Thank you my lady, she will be so happy. Now, enjoy your meal.”")]), _vm._v(" "), _c('p', [_vm._v("“Oh, she made my favorite. Fried chicken with mashed potatoes and gravy.”")]), _vm._v(" "), _c('p', [_vm._v("“Meiga made my favorite also, rabbit pie.” said Armando. Roseabella lifted the lid off the last dish and could not believe her eyes.")]), _vm._v(" "), _c('p', [_vm._v("“Chicken stew with dumplings, how could she know this is my favorite dish?”")]), _vm._v(" "), _c('p', [_vm._v("“I did see your mother in the kitchen before she left. Now we know why.”")]), _vm._v(" "), _c('p', [_vm._v("“My mother is starting to surprise me more and more.”")]), _vm._v(" "), _c('p', [_vm._v("“Try some of this chicken Roseabella, there is enough for three and more besides.”")]), _vm._v(" "), _c('p', [_vm._v("“Yes, thank you I will, I never had fried chicken before.”")]), _vm._v(" "), _c('p', [_vm._v("When she bit into the leg, juice burst into her mouth.")]), _vm._v(" "), _c('p', [_vm._v("“My god, this is wonderful. What makes it so tasty and crispy?”")]), _vm._v(" "), _c('p', [_vm._v("“She fries it in goose fat coated with flour and her secret herbs.”")]), _vm._v(" "), _c('p', [_vm._v("“I will ask her to prepare it for my brother and sisters when they come for training next week.”")]), _vm._v(" "), _c('p', [_vm._v("“How old is your brother and sisters?”")]), _vm._v(" "), _c('p', [_vm._v("“My brother is sixteen and my two sisters are fourteen and twelve.”")]), _vm._v(" "), _c('p', [_vm._v("“You and your brother are only a year apart.”")]), _vm._v(" "), _c('p', [_vm._v("“I will be eighteen in July.”")]), _vm._v(" "), _c('p', [_vm._v("“Why my love, we will have a birthday party and dancing.”")]), _vm._v(" "), _c('p', [_vm._v("“I’ll plan it dear brother. I shall send out invitations next month. We will have stuffed mushrooms, deep-fried mussels and clams and shrimp in peppery tomato sauce. We will also have thin slices of bread with cheese and smoked salmon and trout. Oh, and we can’t forget the strawberries and clotted cream.”")]), _vm._v(" "), _c('p', [_vm._v("“I see you have it all worked out, Helewise.”")]), _vm._v(" "), _c('p', [_vm._v("“You know me brother, grass doesn’t grow under my feet; especially when I can be a host with dancing and drinking involved.”")]), _vm._v(" "), _c('p', [_vm._v("“I can see we need to find a husband real soon, my dear before you scar your good name.”")]), _vm._v(" "), _c('p', [_vm._v("“I will not marry until I’m twenty-five. The same age as you.”")]), _vm._v(" "), _c('p', [_vm._v("“At twenty-five, a woman is considered an old maid.”")]), _vm._v(" "), _c('p', [_vm._v("“I don’t care and who would want to marry a vampire slayer anyway?”")]), _vm._v(" "), _c('p', [_vm._v("“Maybe a handsome, strong, rich, vampire killer himself.” said Roseabella.")]), _vm._v(" "), _c('p', [_vm._v("“Thank you, sister-in-law, I will take that into consideration.”")]), _vm._v(" "), _c('p', [_vm._v("“Your brother makes me happy and we are going to be both slayers.”")]), _vm._v(" "), _c('p', [_vm._v("“Now girls, just because you destroyed a dead body before it changed, doesn’t mean you’re ready for the live ones.”")]), _vm._v(" "), _c('p', [_vm._v("“When your sister and I are finished with our training Armando, we will be as good as the men.”")]), _vm._v(" "), _c('p', [_vm._v("“I’m out-numbered, I see. So, let’s have dessert and change the subject. Let’s see what’s on the dessert table.”")]), _vm._v(" "), _c('p', [_vm._v("There was a strawberry pie and rhubarb tarts and also apple slices and cheese.")]), _vm._v(" "), _c('p', [_vm._v("“Ok now, we are all stuffed, we need our rest and tomorrow is going to be another long day.”")]), _vm._v(" "), _c('p', [_vm._v("They said their good nights and returned to their rooms.")]), _vm._v(" "), _c('p', [_vm._v("“My love, I will join you in a moment. I need to check on the gates and see if the guards are sleeping on duty.”")]), _vm._v(" "), _c('p', [_vm._v("“Yes, my darling I will wait for you in our bed.”")]), _vm._v(" "), _c('p', [_vm._v("“That sounds good.”")]), _vm._v(" "), _c('p', [_vm._v("Roseabella jumped into bed and before she knew it, she was sound asleep. When Armando returned, she looked like an angel, her long hair down to her breasts, her skin so creamy and beautiful, red full lips, she was making him hard but she needed her sleep and strength for tomorrow’s training.")]), _vm._v(" "), _c('p', [_vm._v("He then thought about his cousin.")]), _vm._v(" "), _c('p', [_vm._v("“My dear cousin, why didn’t you stop whoring around after dark in the village inns? I will not let you hurt my family, Garrett. I will kill you to protect them.”")]), _vm._v(" "), _c('p', [_vm._v("Armando then heard the dogs barking and growling outside. He got up and looked outside of the bars placed in every window of the castle. There, he saw his cousin with two other vampires and they were dressed in expensive clothes and had swords in their hands. He went from rags to riches in five days, he and Garret looked in each other’s eyes.")]), _vm._v(" "), _c('p', [_vm._v("“The nerve you have, standing outside of the gates with two bloodsuckers.”")]), _vm._v(" "), _c('p', [_vm._v("His cousin looked up with a grin on his face. In an instant, one of the vampires was struck in the shoulder with an arrow. Garret and his friend took the wounded one and vanished through the night. Too bad it didn’t go through the heart. One less vamp feeding of the night.")]), _vm._v(" "), _c('p', [_vm._v("Roseabella woke up after a deep nights’ sleep and felt rested but alone. She knew her husband slept with her because she felt protected and warm in his arms throughout the night. I don’t want to leave my bed but I have training to do. After she was dressed in a pair of her husband’s pants and shirt, she found in a box amongst his old things. There was a knock on the door and she could hear arguing. Roseabella opened the door and it was her maid and Saige.")]), _vm._v(" "), _c('p', [_vm._v("“What seems to be the problem? Has anything happened?”")]), _vm._v(" "), _c('p', [_vm._v("“No my lady, Saige thinks she can see you anytime of the day.”")]), _vm._v(" "), _c('p', [_vm._v("“I gave Saige permission to see me when needed.”")]), _vm._v(" "), _c('p', [_vm._v("The maid looked at Saige with cold eyes and said:")]), _vm._v(" "), _c('p', [_vm._v("“Yes, my lady.” and left.")]), _vm._v(" "), _c('p', [_vm._v("“Are you alright, Saige?”")]), _vm._v(" "), _c('p', [_vm._v("“My lady, my lady, I had another vision. This time I was not scared.”")]), _vm._v(" "), _c('p', [_vm._v("“You are so brave, Saige. What was your vision?”")]), _vm._v(" "), _c('p', [_vm._v("“Our priest, Father Strickland was holding up his wooded cross in front of the vampires. They said, ‘Let us in, Father and you will join us until eternity. Invite us in Father, we cannot come in until you invite us.’ Father Strickland opened the church doors and put a cross in front of them. They backed away from the church and Father told them this is a sign of our Jesus Christ who died for us. He then threw holy water into one of the vampires’ face and it burned him so badly, smoke came from his burns.”")]), _vm._v(" "), _c('p', [_vm._v("“Oh, Saige my dear child, you are so brave because you wanted no one else hurt!”")]), _vm._v(" "), _c('p', [_vm._v("“Yes, my lady and you told me I have a gift to be proud of.”")]), _vm._v(" "), _c('p', [_vm._v("“And you do indeed, little one. We must go to the wood carvers who carve our furniture.”")]), _vm._v(" "), _c('p', [_vm._v("“Why my lady?”")]), _vm._v(" "), _c('p', [_vm._v("“Please call me lady Roseabella.”")]), _vm._v(" "), _c('p', [_vm._v("“Oh, I would be honored, my lady Roseabella.”")]), _vm._v(" "), _c('p', [_vm._v("“They have to make us crosses with rawhide that will go around our necks.”")]), _vm._v(" "), _c('p', [_vm._v("When Roseabella and Saige walked into the shop, they were taken back by all the bows and arrows that were made. There were also hundreds of sharp spikes to enter the vampire’s heart. All the men stood up and bowed down to her.")]), _vm._v(" "), _c('p', [_vm._v("“I see what a wonderful job you have done, my men.”")]), _vm._v(" "), _c('p', [_vm._v("“Thank you, my lady and my lady, we all think you and lady Helewise are two brave women; what you did yesterday. You put us old men to shame. We are too old now to battle you see but not too old to make weapons to kill those blood-thirsty demons.”")]), _vm._v(" "), _c('p', [_vm._v("“I’m happy to hear you say that because we need crosses made to put around our soldier’s neck and every living person in this castle.”")]), _vm._v(" "), _c('p', [_vm._v("“Why crosses my lady, if you don’t mind me asking?”")]), _vm._v(" "), _c('p', [_vm._v("“I don’t mind sir, Jesus died on a cross for our sins. When they see the cross, I hope they will run from it.”")]), _vm._v(" "), _c('p', [_vm._v("“As you wish my lady and I will pray that it will work.”")]), _vm._v(" "), _c('p', [_vm._v("“Good day, my men.”")]), _vm._v(" "), _c('p', [_vm._v("“Saige, we now have to visit the church to see Father Strickland.”")]), _vm._v(" "), _c('p', [_vm._v("“I think that will be a good idea lady, Roseabella. Will you tell him my vision?”")]), _vm._v(" "), _c('p', [_vm._v("“No, not right now unless you want him to know.”")]), _vm._v(" "), _c('p', [_vm._v("“No, my lady Roseabella, he might think I’m a witch, he is always so kind to me. When I go to the chapel to talk to my mother, he tells me story about God and angels.”")]), _vm._v(" "), _c('p', [_vm._v("“That is nice of him. Let’s go then.”")]), _vm._v(" "), _c('p', [_vm._v("“It’s nice of you to see us Father, on such a short notice.”")]), _vm._v(" "), _c('p', [_vm._v("“My dear, it’s a pleasure to see you again so soon. I always look forward to the visit to your castle to give service to your father and his family and workers, my lady.”")]), _vm._v(" "), _c('p', [_vm._v("“So did we father, you always had new stories about Jesus.”")]), _vm._v(" "), _c('p', [_vm._v("“So, what can I do for you, my lady and little Saige?”")]), _vm._v(" "), _c('p', [_vm._v("“Father, I notice you wear a cross around your neck and you have them all over the walls. Why is that father?”")]), _vm._v(" "), _c('p', [_vm._v("“It is to show how Jesus, our lord’s son died for us.”")]), _vm._v(" "), _c('p', [_vm._v("“That is what I thought, father. We ordered the wood carvers to carve crosses for everyone in the castle and we would like you to bless them when you put them around everyone’s neck.”")]), _vm._v(" "), _c('p', [_vm._v("“Why, my lady?”")]), _vm._v(" "), _c('p', [_vm._v("“Please father, call me Roseabella, you have known me since I was born.”")]), _vm._v(" "), _c('p', [_vm._v("“Of course, as you wish.”")]), _vm._v(" "), _c('p', [_vm._v("“Father, we are prisoners in our homes after dark. We live in fear. People go missing every day. They are hunted down for food. The vampire race is growing in numbers; my husband is training his men for a war against them and my father and his men also. When they leave to fight, I’d like something religious around their necks.”")]), _vm._v(" "), _c('p', [_vm._v("“Roseabella, you are so absolutely right.”")]), _vm._v(" "), _c('p', [_vm._v("“And father,” said Saige, “they will need as much holy water they can carry.”")]), _vm._v(" "), _c('p', [_vm._v("The priest looked at Saige and smiled.")]), _vm._v(" "), _c('p', [_vm._v("“You know Saige, I have a craving for some of those strawberries you take care of. Why don’t you go and pick some for Father?”")]), _vm._v(" "), _c('p', [_vm._v("“Yes, Lady Roseabella.”")]), _vm._v(" "), _c('p', [_vm._v("“She is such a good girl. I always kept a close eye on her ever since she was born and God took her mother.”")]), _vm._v(" "), _c('p', [_vm._v("“And why such an interest in her father, you want her to become a nun?”")]), _vm._v(" "), _c('p', [_vm._v("“Only if she wishes to. I baptized her in front of her mother, we knew her mother was not long in this world. And when I baptized her, I noticed she had a birthmark on her back.”")]), _vm._v(" "), _c('p', [_vm._v("“What kind of birthmark does she have, father?”")]), _vm._v(" "), _c('p', [_vm._v("“She has a birth mark of angel wings.”")]), _vm._v(" "), _c('p', [_vm._v("“Does she know?”")]), _vm._v(" "), _c('p', [_vm._v("“No, her grandparents and I are the only ones. Her grandparents are afraid for her life if the wrong people find out.”")]), _vm._v(" "), _c('p', [_vm._v("“Father, she has insight. Visions came to her about the couple who was brought in yesterday and drained of blood. At my wedding supper, she saw them dead and bloody.”")]), _vm._v(" "), _c('p', [_vm._v("“Did she tell you this, Roseabella?”")]), _vm._v(" "), _c('p', [_vm._v("“Yes father, she was so scared her grandmother said she would not go and sweep the dining room.”")]), _vm._v(" "), _c('p', [_vm._v("“The poor child, I could see why. I told her father she has a gift to help people.”")]), _vm._v(" "), _c('p', [_vm._v("“And that’s why we came here today, father. You were in a vision she had this morning.”")]), _vm._v(" "), _c('p', [_vm._v("“Me, Roseabella?”")]), _vm._v(" "), _c('p', [_vm._v("“Yes father, they asked you to invite them in, you opened the door with your cross in your hand. They backed away and you sprinkled holy water on one. His skin burned and Saige could see him scream and they left running. She also told me father, they cannot enter unless they are invited.”")]), _vm._v(" "), _c('p', [_vm._v("“God took her mother, Roseabella and sent us an angel. Her gypsy grandmother must never find out, they will try to claim her.”")]), _vm._v(" "), _c('p', [_vm._v("“She is starting to train with us father, her grandfather has already taught her some.”")]), _vm._v(" "), _c('p', [_vm._v("“Here are the strawberries, Father.”")]), _vm._v(" "), _c('p', [_vm._v("“Oh my dear, they are bigger than last year, Saige.”")]), _vm._v(" "), _c('p', [_vm._v("“My grandfather puts horse shit on them in the winter.”")]), _vm._v(" "), _c('p', [_vm._v("Roseabella and Father both laughed!")]), _vm._v(" "), _c('p', [_vm._v("“Thank you, Father, for your time, now we must train.”")]), _vm._v(" "), _c('p', [_vm._v("“Good day to you, my dears.”")]), _vm._v(" "), _c('p', [_vm._v("“I want you to watch us train, Saige and next week, you shall partner up with my sisters.”")]), _vm._v(" "), _c('p', [_vm._v("“As you wish, Lady Roseabella.”")]), _vm._v(" "), _c('p', [_vm._v("Roseabella went to the kitchen and wolfed down some corn cakes and a mug of tea.")]), _vm._v(" "), _c('p', [_vm._v("“Oh my lady, why aren’t you having breakfast with Helewise?”")]), _vm._v(" "), _c('p', [_vm._v("“I’m in a hurry and would like to speak with you. Let’s sit down, Meiga and pour yourself a cup of tea. Your granddaughter Saige is a miracle child. Saige no longer thinks she is a witch. When God took your daughter Meiga, they sent you and all the people in Transylvania an angel.”")]), _vm._v(" "), _c('p', [_vm._v("“Angel, my lady?”")]), _vm._v(" "), _c('p', [_vm._v("“Yes, Meiga. God has sent her to help take down the night devils. The creatures of the night.”")]), _vm._v(" "), _c('p', [_vm._v("“She is only a child, my lady.”")]), _vm._v(" "), _c('p', [_vm._v("“She is a child in age but has an old soul. And she is an intelligent girl. Saige is no longer afraid of her visions.”")]), _vm._v(" "), _c('p', [_vm._v("“She told you about them, my lady?”")]), _vm._v(" "), _c('p', [_vm._v("“Not willingly Meiga, your granddaughter had a vision on the night of my wedding, she saw the Ederlyns murder at the dining table.”")]), _vm._v(" "), _c('p', [_vm._v("“Oh, sweet god that’s why she was so white and wouldn’t go in there to sweep.”")]), _vm._v(" "), _c('p', [_vm._v("“Yes and after she saw their dead bodies outside, she fainted; after she came to, we had a long talk. Your granddaughter has an insight, a gift others would welcome. She is no longer afraid of her visions. She must always come to me only or Father Strickland.”")]), _vm._v(" "), _c('p', [_vm._v("“My lady, I just want her to be a normal girl and to have a normal life.”")]), _vm._v(" "), _c('p', [_vm._v("“Her life will not be normal but a very important one to us all. You and your husband must tell her how proud of her you are and not be ashamed of her visions.”")]), _vm._v(" "), _c('p', [_vm._v("“My lady, I thought she might have had some gypsy blood in her.”")]), _vm._v(" "), _c('p', [_vm._v("“A baby with bad blood was not borne with a set of angel wings as a birthmark.”")]), _vm._v(" "), _c('p', [_vm._v("“How do you know, my lady?”")]), _vm._v(" "), _c('p', [_vm._v("“Father Strickland has kept an eye on her since her birth. He told me after Saige had a vision of him. Because of Saige, Father will be ready for the vamps.”")]), _vm._v(" "), _c('p', [_vm._v("“Dear god, what are you saying she can save lives?”")]), _vm._v(" "), _c('p', [_vm._v("“Yes but you must not tell anyone, only your husband. If people find out, they will want her for themselves.”")]), _vm._v(" "), _c('p', [_vm._v("“No, my lady no one will ever know.”")]), _vm._v(" "), _c('p', [_vm._v("“Thank you Meiga, for our little talk. Now, I must start my training. Saige will watch us today and next week, she will train with my sisters.”")]), _vm._v(" "), _c('p', [_vm._v("“My lady, thank you so much for talking to Saige. She looks like she already has a great burden lifted off her shoulders.”")]), _vm._v(" "), _c('p', [_vm._v("“Yes, she does and again not afraid of her last vision.”")]), _vm._v(" "), _c('p', [_vm._v("“It’s about time Roseabella you got here.”")]), _vm._v(" "), _c('p', [_vm._v("“I’m sorry sister-in-law but I had a few important things to take care of.”")]), _vm._v(" "), _c('p', [_vm._v("“What was so important?”")]), _vm._v(" "), _c('p', [_vm._v("“I had a meeting with Father Strickland.”")]), _vm._v(" "), _c('p', [_vm._v("“Oh well, then today I will fight you. The men want to see how well we can fight.”")]), _vm._v(" "), _c('p', [_vm._v("“Ok, let’s show the other women also what we can do.”")]), _vm._v(" "), _c('p', [_vm._v("Helewise was quick with the sword. Roseabella kept her wits; she was used to fighting with her brother who was tall and solid. Her brother would not let her stop when she got tired. Her arms were muscled up and strong.")]), _vm._v(" "), _c('p', [_vm._v("Roseabella hit Helewise’s sword out of her hand. Then, she jumped up and knocked her off her feet, took out her spike and pretended to stake her. All the girls were amazed and clapped their hands. Roseabella helped up Helewise and told her to never let down your guard.")]), _vm._v(" "), _c('p', [_vm._v("“Who taught you how to fight and jump like that?”")]), _vm._v(" "), _c('p', [_vm._v("“My brother and I spent hours fighting every day. We watched my fathers’ men on sly.”")]), _vm._v(" "), _c('p', [_vm._v("“I would like your brother to train me.”")]), _vm._v(" "), _c('p', [_vm._v("“No, he must train with the men now and become a man.”")]), _vm._v(" "), _c('p', [_vm._v("“You are right, Roseabella; I will wait for him to become a man.” As she looked at Roseabella with a wicked grin on her face.")]), _vm._v(" "), _c('p', [_vm._v("“Ok now ladies, I would like for you all to run five laps around the court.”")]), _vm._v(" "), _c('p', [_vm._v("“Oh no,” moaned the women.")]), _vm._v(" "), _c('p', [_vm._v("“Well, you can’t fight if you’re in poor shape.”")]), _vm._v(" "), _c('p', [_vm._v("Saige ran her laps around the court without a drop of sweat and wasn’t winded like all the rest. Saige was finished long before the others.")]), _vm._v(" "), _c('p', [_vm._v("Helewise told her she ran like a young colt.")]), _vm._v(" "), _c('p', [_vm._v("“I love to run and jump. I can jump over six bales of hay side by side.”")]), _vm._v(" "), _c('p', [_vm._v("“No one can do that, Saige.”")]), _vm._v(" "), _c('p', [_vm._v("“It’s the truth lady Helewise, I would not lie to you.”")]), _vm._v(" "), _c('p', [_vm._v("“Ok, then let’s see you do it. You men go to the stables and bring six bales of hay and place them side by side.”")]), _vm._v(" "), _c('p', [_vm._v("“But why, my lady?”")]), _vm._v(" "), _c('p', [_vm._v("“Don’t ask why, just do it!”")]), _vm._v(" "), _c('p', [_vm._v("“Saige, are you sure you can do this?”")]), _vm._v(" "), _c('p', [_vm._v("“Yes, Lady Roseabella, when I run and jump, I feel like I’m flying.” (And if she only knew there was a set of wings on her back)")]), _vm._v(" "), _c('p', [_vm._v("“Try your best, little one and don’t hurt yourself.”")]), _vm._v(" "), _c('p', [_vm._v("“I won’t my lady, will you stand at the other end and wait for me to land on my feet?”")]), _vm._v(" "), _c('p', [_vm._v("“I would be most delighted to.”")]), _vm._v(" "), _c('p', [_vm._v("Roseabella went behind the last bale of hay. Saige took a running start with her legs; still in running motion, she landed on her feet in front of Roseabella who was still eight feet from the bales of hay. At first, everyone was in shock, then the two sisters jumped up and down and shouted three cheers for Saige. Everyone cheered for Saige and gave her hugs.")]), _vm._v(" "), _c('p', [_vm._v("“Well Saige, what else can you do that we don’t know about?”")]), _vm._v(" "), _c('p', [_vm._v("“I can climb any tree, my lady and throw a spear a long distance.”")]), _vm._v(" "), _c('p', [_vm._v("“What is a spear, Saige?” asked Roseabella.")]), _vm._v(" "), _c('p', [_vm._v("“It’s a long stick four times longer than an arrow. My grandfather made it for me to kill rats in the barn. But I like to throw it outside the gates in daylight. My grandfather goes with me and we have a contest to see who could hit some markers he made up.”")]), _vm._v(" "), _c('p', [_vm._v("Roseabella told Saige to go and get her spear.")]), _vm._v(" "), _c('p', [_vm._v("“You men pile up the bales of hay and draw a red circle on all six of them.”")]), _vm._v(" "), _c('p', [_vm._v("“Yes, my lady.”")]), _vm._v(" "), _c('p', [_vm._v("“And you there, you go tell Saige’s grandfather we need spears made for the women in training. Tell him to go to the wood shop and some of the men can help him.”")]), _vm._v(" "), _c('p', [_vm._v("“Yes, my lady.”")]), _vm._v(" "), _c('p', [_vm._v("Saige came back with her spear. Helewise looked at it from top to bottom.")]), _vm._v(" "), _c('p', [_vm._v("“May I try it, Saige?”")]), _vm._v(" "), _c('p', [_vm._v("“Yes, my lady.”")]), _vm._v(" "), _c('p', [_vm._v("Helewise threw the spear with all her strength, it flew through the air like a bird and landed in one of the bales of hay.")]), _vm._v(" "), _c('p', [_vm._v("“You have a good arm, lady Helewise.”")]), _vm._v(" "), _c('p', [_vm._v("“Ok, every one of you line up. Saige first will show you where to take hold of the spear and how to throw and to take aim.”")]), _vm._v(" "), _c('p', [_vm._v("For hours, they worked at throwing the spear, they learned how to tackle each other to the ground.")]), _vm._v(" "), _c('p', [_vm._v("“Tomorrow, we will concentrate on cutting of heads. You may go now and break for the second meal of the day and yes, there will be ale! You go with them Saige, you’re a part of the team now. They will be happy to have you on their side.”")]), _vm._v(" "), _c('p', [_vm._v("“Thank you so much, my ladies.”")]), _vm._v(" "), _c('p', [_vm._v("Saige ran off to join the others.")]), _vm._v(" "), _c('p', [_vm._v("“Her grandfather taught her well, Roseabella. I’ve never seen anyone jump that far. Do you think she could jump even further?”")]), _vm._v(" "), _c('p', [_vm._v("“It wouldn’t surprise me. Tomorrow we’ll give her targets to jump over.”")]), _vm._v(" "), _c('p', [_vm._v("After a hard day of training, Armando found his wife in the bath tub asleep. The days were not long enough for them. He massaged her head with soap and water. She opened her eyes and gave him a beautiful smile. He rinsed her hair with a jug of clean water by the tub.")]), _vm._v(" "), _c('p', [_vm._v("“Now, you get in and I will wash you all over, my husband.”")]), _vm._v(" "), _c('p', [_vm._v("“You do know how to make me hard, my wife.”")]), _vm._v(" "), _c('p', [_vm._v("He slipped out of his clothes and in front of her sat down. Roseabella stood on her knees with soap and a cloth in her hands, she washed his hair down to his neck, his chest down to his stomach. And last his manhood that was hard and waiting for her.")]), _vm._v(" "), _c('p', [_vm._v("She wrapped her legs around his waist. He lifted her bum up and lowered her on his cock. She put her arms around him and he sucked gently on her breast. She massaged his shoulders and he lifted her up and down on his manhood. Roseabella wrapped her legs around his waist.")]), _vm._v(" "), _c('p', [_vm._v("“Oh Roseabella, you feel so tight.”")]), _vm._v(" "), _c('p', [_vm._v("“You, my husband, are so big and hard.”")]), _vm._v(" "), _c('p', [_vm._v("She closed her eyes and screamed out his name.")]), _vm._v(" "), _c('p', [_vm._v("“You make me hot all over.”")]), _vm._v(" "), _c('p', [_vm._v("“Roseabella my love, I’m going to cum.”")]), _vm._v(" "), _c('p', [_vm._v("“And so am I, Armando!”")]), _vm._v(" "), _c('p', [_vm._v("They found each other’s mouth to keep out the cry of pleasure. They did not want people to hear them.")]), _vm._v(" "), _c('p', [_vm._v("“Is this our ritual to make love every day in the tub?”")]), _vm._v(" "), _c('p', [_vm._v("“Make love and bath at the same time, Armando and it’s so enjoyable. How was your day, Armando?”")]), _vm._v(" "), _c('p', [_vm._v("“Exhausting but the men are learning more every day. We are working on our kicking and throwing each other on the ground. They have to be quick with the spikes and swords.”")]), _vm._v(" "), _c('p', [_vm._v("“And how was your day darling?”")]), _vm._v(" "), _c('p', [_vm._v("“A lot like yours, Saige’s grandfather made her a spear; to spear rats in the barn and he taught her how to throw it in the field. She taught all the women today how to throw and we put up targets.”")]), _vm._v(" "), _c('p', [_vm._v("“Her grandfather? My friend Gerrold? Made it for Saige?”")]), _vm._v(" "), _c('p', [_vm._v("“Yes, my darling you must watch us with it. Gerrold is asked to make enough for the women. Today Armando, we ran five laps to get us in shape, Saige was finished first. I was second, Armando but she finished her five when I started my third.”")]), _vm._v(" "), _c('p', [_vm._v("“That’s because darling, she is so young and skinny.”")]), _vm._v(" "), _c('p', [_vm._v("“Yes that is true but can you explain how she jumped over six bales of hay all lined up. I stood eight feet from the bales of hay, Armando. She almost landed on my toes.”")]), _vm._v(" "), _c('p', [_vm._v("“Gerrold trained his granddaughter more than my men.”")]), _vm._v(" "), _c('p', [_vm._v("“Armando, she has the speed of a leopard.”")]), _vm._v(" "), _c('p', [_vm._v("“Do not ask me Roseabella, she will not be a slayer. She is too young and she is all Gerrold and Meiga have. He treats her like a tom boy.”")]), _vm._v(" "), _c('p', [_vm._v("“I will not put her in any danger, Armando. All I ask is for you to watch her perform.”")]), _vm._v(" "), _c('p', [_vm._v("“For you my dear, I’ll do anything. Now, this water has gone cold and we must get ready for the last meal of the day.”")]), _vm._v(" "), _c('p', [_vm._v("“Good evening sister.”")]), _vm._v(" "), _c('p', [_vm._v("“And to you and your wife, brother.”")]), _vm._v(" "), _c('p', [_vm._v("“Are you sore like you were last night, Helewise?”")]), _vm._v(" "), _c('p', [_vm._v("“No not so bad, although my arm is tender from throwing Saige’s spear. I told Gerrold to carve my name in mine, so I can use the same one to practice on.”")]), _vm._v(" "), _c('p', [_vm._v("“That is a good idea Helewise, I will ask the same. Armando is going to look in on us tomorrow.”")]), _vm._v(" "), _c('p', [_vm._v("“Roseabella, we are not that trained!”")]), _vm._v(" "), _c('p', [_vm._v("“I want him to watch Saige running, jumping and spear-throwing.”")]), _vm._v(" "), _c('p', [_vm._v("“Yes, she is quite a girl for her seasons.”")]), _vm._v(" "), _c('p', [_vm._v("“My wife thinks so as well. Let’s have some wine.”")]), _vm._v(" "), _c('p', [_vm._v("“That would be lovely, Armando. Well-deserved after hard training. My mother loves your wine Armando, she said it was smooth not rough like fathers’.”")]), _vm._v(" "), _c('p', [_vm._v("Armando refilled their glasses twice more.")]), _vm._v(" "), _c('p', [_vm._v("“Excuse me my lord and ladies, your meal is ready.”")]), _vm._v(" "), _c('p', [_vm._v("“Thank you Meiga, I’m hungry enough to eat a horse.”")]), _vm._v(" "), _c('p', [_vm._v("The slices of lamb were pink and tender and stuffed chicken with cranberry sauce and diced turnip and carrots with baked baby potatoes and a big bowl of gravy.")]), _vm._v(" "), _c('p', [_vm._v("“I’m never going to complain about Meiga’s cooking because she never ceases to amaze me. For dessert, it looks like a bread pudding with brown sugar sauce. What spices does she use?”")]), _vm._v(" "), _c('p', [_vm._v("“I can taste cinnamon, ginger and something else?”")]), _vm._v(" "), _c('p', [_vm._v("“It’s nutmeg! I’ve never had nutmeg before, it’s quite tasty.”")]), _vm._v(" "), _c('p', [_vm._v("“Meiga likes to experiment.”")]), _vm._v(" "), _c('p', [_vm._v("“Shall we turn in now, Armando? I can’t keep my eyes open.”")]), _vm._v(" "), _c('p', [_vm._v("“Of course, my darling; we’ll see you in the morning Helewise.”")]), _vm._v(" "), _c('p', [_vm._v("“Armando, could we take a break, not tomorrow but the next day.”")]), _vm._v(" "), _c('p', [_vm._v("“Of course, my dear, what would you like to do?”")]), _vm._v(" "), _c('p', [_vm._v("“Could we go to the village? I need to do some shopping and take in the scenery.”")]), _vm._v(" "), _c('p', [_vm._v("“Of course, Roseabella, we’ll take Helewise with us. She is due for an outing.”")]), _vm._v(" "), _c('p', [_vm._v("“You are so good to me, Armando. I never dreamed it would be so wonderful between us.”")]), _vm._v(" "), _c('p', [_vm._v("“Roseabella, you mean everything to me.”")]), _vm._v(" "), _c('p', [_vm._v("Armando undressed her and laid her on the bed. He made love to her gently and softly.")]), _vm._v(" "), _c('p', [_vm._v("“Roseabella, you are so breathtaking my dear.”")]), _vm._v(" "), _c('p', [_vm._v("Armando and Roseabella slept through the night; he was gone when she woke. Roseabella got dressed in her man clothes again. A knock came on the door, she opened it and it was Saige.")]), _vm._v(" "), _c('p', [_vm._v("“Lady Roseabella, I had another vision.”")]), _vm._v(" "), _c('p', [_vm._v("“Are you ok, dear girl?”")]), _vm._v(" "), _c('p', [_vm._v("“Yes, it was scary but I remember what you said, my visions will save lives.”")]), _vm._v(" "), _c('p', [_vm._v("“You are a brave girl, Saige.”")]), _vm._v(" "), _c('p', [_vm._v("“I saw vampires, there were ten of them. They entered this huge horse stable before it turned daylight.”")]), _vm._v(" "), _c('p', [_vm._v("“How do you know it was a horse stable?”")]), _vm._v(" "), _c('p', [_vm._v("“It was little rooms with hay in them. Stalls for keeping horses.”")]), _vm._v(" "), _c('p', [_vm._v("“Have you seen this barn before?”")]), _vm._v(" "), _c('p', [_vm._v("“Yes, it belongs to people who breed horses, they were found dead and their horses slaughtered. The soldiers beheaded the men and buried them; next they burned the horses.”")]), _vm._v(" "), _c('p', [_vm._v("“Oh, Saige I’m so proud of you. We must tell your grandfather.”")]), _vm._v(" "), _c('p', [_vm._v("“Yes, my lady my grandfather understands a little more since you spoke to Gram.”")]), _vm._v(" "), _c('p', [_vm._v("“You go for your training, Saige and I will talk to him alone.”")]), _vm._v(" "), _c('p', [_vm._v("“Good day to you, Gerrold.”")]), _vm._v(" "), _c('p', [_vm._v("“A good day to you, my lady. Are you here for the spears?”")]), _vm._v(" "), _c('p', [_vm._v("“No, I’d like to talk about Saige.”")]), _vm._v(" "), _c('p', [_vm._v("“What has she done wrong, my lady?”")]), _vm._v(" "), _c('p', [_vm._v("“Your Saige can do no wrong in my eyes, Gerrold. She’s been so happy lately and not scared anymore. Saige has visions which you already know, Gerrold. I helped young Saige to not be afraid of her visions. She has the insight. I and Father Strickland think she is a gift from God. Only four of us know about her.”")]), _vm._v(" "), _c('p', [_vm._v("“If anything happens to her, I will kill Meiga. We cannot bury another child. There are bad people out there my lady, who will use her for the insight.”")]), _vm._v(" "), _c('p', [_vm._v("“Gerrold, we will all protect her. Saige had a vision few hours ago. Do you know the horse breeding stables the one that’s been abandoned?”")]), _vm._v(" "), _c('p', [_vm._v("“Yes, I do. It’s been abandoned for a while now.”")]), _vm._v(" "), _c('p', [_vm._v("“Not any longer, Gerrold. Vampires have taken it over.”")]), _vm._v(" "), _c('p', [_vm._v("“My granddaughter has seen this?”")]), _vm._v(" "), _c('p', [_vm._v("“Yes, you and my husband will burn it down when the vampires are sleeping.”")]), _vm._v(" "), _c('p', [_vm._v("“Now I know, when your husband told me he found the perfect wife, he was right.”")]), _vm._v(" "), _c('p', [_vm._v("“Thank you and your wife is a perfect cook!”")]), _vm._v(" "), _c('p', [_vm._v("“And that she is my Meiga.”")]), _vm._v(" "), _c('p', [_vm._v("“And one other thing, don’t tell my husband about Saige’s insight. Tell him you have a feeling they could be using the barn.”")]), _vm._v(" "), _c('p', [_vm._v("“Yes, my lady I will talk to your husband right away.”")]), _vm._v(" "), _c('p', [_vm._v("Roseabella went to the court yard. Every woman there had their own spears.")]), _vm._v(" "), _c('p', [_vm._v("“This one is for you Roseabella; my gramps carved your name in it.”")]), _vm._v(" "), _c('p', [_vm._v("“You must thank him for me.”")]), _vm._v(" "), _c('p', [_vm._v("“Did you tell him about my vision?”")]), _vm._v(" "), _c('p', [_vm._v("“Yes, they will take care of the problem.”")]), _vm._v(" "), _c('p', [_vm._v("“Oh, lady Roseabella, I’m so glad to have a friend like you I can talk to.”")]), _vm._v(" "), _c('p', [_vm._v("“We will always be friends, little one. Now Saige, my husband wants to see you throw your spear and how fast you are at running and jumping.”")]), _vm._v(" "), _c('p', [_vm._v("“I would be honored, my lady.”")]), _vm._v(" "), _c('p', [_vm._v("Armando had never seen anyone run, jump and throw a spear so good before in his life. If Saige was a boy, he’d be included in the hunt. Armando watched his wife dressed in boys’ clothes. He didn’t like other men looking at the perfect body. He will speak to her tonight. Gerrold then came to see Armando.")]), _vm._v(" "), _c('p', [_vm._v("“Armando, I need to talk to you.”")]), _vm._v(" "), _c('p', [_vm._v("“Ok, talk to me then.”")]), _vm._v(" "), _c('p', [_vm._v("“We had a rider cone in today. He told me he saw vampires going into the old horse breeding barn. They went in before sunlight.”")]), _vm._v(" "), _c('p', [_vm._v("“Where is this man who told you this?”")]), _vm._v(" "), _c('p', [_vm._v("“Oh, he’s gone back to his family. Armando, we leave now and burn down the barns and have a lot of light on our way back.”")]), _vm._v(" "), _c('p', [_vm._v("“You are right, Gerrold. We leave right now.”")]), _vm._v(" "), _c('p', [_vm._v("“Why is Armando late for his evening meal?”")]), _vm._v(" "), _c('p', [_vm._v("“He and a few men left the castle early this morning. He never told you anything?”")]), _vm._v(" "), _c('p', [_vm._v("“No Helewise, he left a message with my maid that he will be late for supper.”")]), _vm._v(" "), _c('p', [_vm._v("“Oh, well let’s have some wine and relax.”")]), _vm._v(" "), _c('p', [_vm._v("“Yes, that would be nice. I have a thirst, there’s still dust in my throat from all the running.”")]), _vm._v(" "), _c('p', [_vm._v("“Me too, cheers to the girl slayers.”")]), _vm._v(" "), _c('p', [_vm._v("They were tipsy when Armando walked in.")]), _vm._v(" "), _c('p', [_vm._v("“Oh, Armando we have been worried about you.”")]), _vm._v(" "), _c('p', [_vm._v("“Nothing to worry about ladies. I had some business to take care of.”")]), _vm._v(" "), _c('p', [_vm._v("“And what business that you could not take us with you brother?”")]), _vm._v(" "), _c('p', [_vm._v("“Ok, I won’t get any rest unless I tell you sister. We received information this morning about vampires living in the old horse breeding barn. We burnt it down with the vampires in it. Some ran out into the sun and were turned to ashes, two ran out and after the fire, we beheaded eight.”")]), _vm._v(" "), _c('p', [_vm._v("“Oh, Armando do have some wine, you’ve had a long day.”")]), _vm._v(" "), _c('p', [_vm._v("“A long day but a progressive day.”")]), _vm._v(" "), _c('p', [_vm._v("“I am so proud of you, Armando.”")]), _vm._v(" "), _c('p', [_vm._v("“I am also proud of you, brother but you could have taken us with you!”")]), _vm._v(" "), _c('p', [_vm._v("“I’m sorry Helewise but I’m taking you both in the village tomorrow for shopping. Now, let’s eat our meal and get some sleep, we leave at day light.”")]), _vm._v(" "), _c('p', [_vm._v("“Oh, I can’t wait to get outside of these walls.”")]), _vm._v(" "), _c('p', [_vm._v("“I can’t wait to show you the shops, Roseabella!”")]), _vm._v(" "), _c('p', [_vm._v("“I look forward to it Helewise, we’ll see you in the morning.”")]), _vm._v(" "), _c('p', [_vm._v("When Roseabella came out of the water closet, Armando was fast asleep. Roseabella was feeling her wine. She walked over to the window for some fresh air. Their bedroom was on the top floor. She could look beyond the gate. Such a beautiful night with so many stars shining.")]), _vm._v(" "), _c('p', [_vm._v("Then she saw him. He looked so much like her husband. He was well dressed and a lot cleaner, his long dark hair had a shine to it. He looked at me with a smile on his face and his arms were loaded down with spring flowers. With his other hand, he blew her kisses. He laid down the flowers and backed away into the night.")]), _vm._v(" "), _c('p', [_vm._v("I whispered, “I’ll never be yours. We will fight you!”")]), _vm._v(" "), _c('p', [_vm._v("Helewise was up early and ready.")]), _vm._v(" "), _c('p', [_vm._v("“About time,” she said, “Meiga made us bread, cheese and boiled eggs to eat on our way and a bottle of goat’s milk. We will take the coach, so we can bring back your shopping and few supplies I need.”")]), _vm._v(" "), _c('p', [_vm._v("After they had something to eat and drink, Armando and Helewise fell asleep in the coach. Roseabella had to keep looking at the mountains, the flowers and the trees.")]), _vm._v(" "), _c('p', [_vm._v("“Armando, Armando wake up I think we’re here!”")]), _vm._v(" "), _c('p', [_vm._v("“Yes, my love we are.”")]), _vm._v(" "), _c('p', [_vm._v("“Oh, Helewise look at all the venders filled up with bread, cakes, pies and cheese. And look at the jewelry.”")]), _vm._v(" "), _c('p', [_vm._v("“It doesn’t take much to get you excited, sister-in-law.”")]), _vm._v(" "), _c('p', [_vm._v("“Helewise, this is the first time in my life that I have entered a village!”")]), _vm._v(" "), _c('p', [_vm._v("“Yes, I’m sorry I forgot.”")]), _vm._v(" "), _c('p', [_vm._v("“I’ll meet you ladies at the inn for our meal in two hours.”")]), _vm._v(" "), _c('p', [_vm._v("“Make it three, dear brother I have much to show your wife.”")]), _vm._v(" "), _c('p', [_vm._v("“Ok Roseabella, we must try on men’s boots for our training.”")]), _vm._v(" "), _c('p', [_vm._v("“Yes, my shoes kill my feet.”")]), _vm._v(" "), _c('p', [_vm._v("“Look at the long ones that laces up and has good grips on them. They certainly match our man’s clothes. Look at these leather vests. Won’t they look nice with the long boots?”")]), _vm._v(" "), _c('p', [_vm._v("“Yes, you are right. I like the black vest.”")]), _vm._v(" "), _c('p', [_vm._v("“Ok, I’ll take the brown one. Now we must see our dress maker for new dresses for your birthday party.”")]), _vm._v(" "), _c('p', [_vm._v("Three hours later with everything wrapped, they entered the Inn where Armando was waiting.")]), _vm._v(" "), _c('p', [_vm._v("“So, how was your morning my love?”")]), _vm._v(" "), _c('p', [_vm._v("“It was fun, Armando and very tiring.”")]), _vm._v(" "), _c('p', [_vm._v("“I ordered you both a glass of wine, so drink up my girls.”")]), _vm._v(" "), _c('p', [_vm._v("“Oh, Armando thank you so much. The wine was refreshing.”")]), _vm._v(" "), _c('p', [_vm._v("“I ordered Cornish hens and grilled vegetables. There’s not much to order, that or liver.”")]), _vm._v(" "), _c('p', [_vm._v("The Cornish hen was over cooked and the vegetables were hard.")]), _vm._v(" "), _c('p', [_vm._v("They did not complain because they were starving.")]), _vm._v(" "), _c('p', [_vm._v("“Thank you, Armando, for this special day. I’ll remember this day forever.”")]), _vm._v(" "), _c('p', [_vm._v("“It’s nice to see you happy.”")]), _vm._v(" "), _c('p', [_vm._v("“I am happy and looking forward to going home to our castle.”")]), _vm._v(" "), _c('p', [_vm._v("Roseabella this time slept all the way home. Armando went to look in on his men. Roseabella felt rested so she went to the court yard and joined the women. There were proud of their spears and were getting good at throwing. Saige was throwing her spear twice the distance as the other women. She will make a good slayer someday.")]), _vm._v(" "), _c('p', [_vm._v("After their evening meal, they returned to their room.")]), _vm._v(" "), _c('p', [_vm._v("“Armando, last night when you fell asleep before me, I went to the window to get some fresh air. Your cousin was out there, he had flowers in one arm and he blew kisses to me.”")]), _vm._v(" "), _c('p', [_vm._v("“Why didn’t you wake me?”")]), _vm._v(" "), _c('p', [_vm._v("“He was gone in a flash.”")]), _vm._v(" "), _c('p', [_vm._v("“I will hunt him down and kill him.”")]), _vm._v(" "), _c('p', [_vm._v("Days went fast, the women were improving.")]), _vm._v(" "), _c('p', [_vm._v("“Tomorrow, my family is coming for a visit. Can’t wait to see my sister’s training and my brother will be training with the men.”")]), _vm._v(" "), _c('p', [_vm._v("“Oh, mother it’s so nice to see you and the family.”")]), _vm._v(" "), _c('p', [_vm._v("“My dear, we miss you at our table.”")]), _vm._v(" "), _c('p', [_vm._v("“You eat meals as a family now?”")]), _vm._v(" "), _c('p', [_vm._v("“Yes, dear we do and should have been doing so a long time ago.”")]), _vm._v(" "), _c('p', [_vm._v("“I’m sure my brother and sisters enjoy it.”")]), _vm._v(" "), _c('p', [_vm._v("“Yes, they do and they talk about you every day.”")]), _vm._v(" "), _c('p', [_vm._v("“Thank you mother, now you must rest, we will meet you at the dining room for dinner tonight.”")]), _vm._v(" "), _c('p', [_vm._v("Roseabella hugged her siblings and father.")]), _vm._v(" "), _c('p', [_vm._v("“I’m so glad you came.”")]), _vm._v(" "), _c('p', [_vm._v("“We were counting the days.” Said her younger sister. “We couldn’t wait to get outside of the castle walls.”")]), _vm._v(" "), _c('p', [_vm._v("“Have you two been training?”")]), _vm._v(" "), _c('p', [_vm._v("“Yes, two hours every day.”")]), _vm._v(" "), _c('p', [_vm._v("“Tomorrow, you show me how good you are.”")]), _vm._v(" "), _c('p', [_vm._v("“How’s your training, Edder?”")]), _vm._v(" "), _c('p', [_vm._v("“My father’s men trained me so hard, I can hardly walk some days.”")]), _vm._v(" "), _c('p', [_vm._v("“I feel the same way most days.”")]), _vm._v(" "), _c('p', [_vm._v("Helewise walked in with her hair in ringlets and her face powdered. Her gown was yellow and she looked pretty.")]), _vm._v(" "), _c('p', [_vm._v("“It’s so nice to see your family again, Roseabella.”")]), _vm._v(" "), _c('p', [_vm._v("“And we are ever so glad to be here. You look lovely in yellow, Helewise.”")]), _vm._v(" "), _c('p', [_vm._v("“Why thank you, Edder. Why don’t you pour us some wine?”")]), _vm._v(" "), _c('p', [_vm._v("“Of course, Helewise, would you like some too, Roseabella?”")]), _vm._v(" "), _c('p', [_vm._v("“Yes, thank you brother.”")]), _vm._v(" "), _c('p', [_vm._v("“Father, can we have a glass too, please?”")]), _vm._v(" "), _c('p', [_vm._v("“Oh, alright just one glass.”")]), _vm._v(" "), _c('p', [_vm._v("“First course is ready, my lady and Sir Armando.”")]), _vm._v(" "), _c('p', [_vm._v("“Thank you, Meiga.”")]), _vm._v(" "), _c('p', [_vm._v("The first course was a tangy onion soup. Second course was rabbit pie. And third course was crispy fried chicken with mashed potatoes and gravy. There was a grilled salmon stuffed with bread and herbs.")]), _vm._v(" "), _c('p', [_vm._v("“Edder, did you hear about my brother burning down a barn with ten vampires in it?”")]), _vm._v(" "), _c('p', [_vm._v("“No, I did not, lady Helewise. But we did see the burnt barn.”")]), _vm._v(" "), _c('p', [_vm._v("“That’s wonderful news Armando, I wish I was there.” Said the Duke. “Ten less night feeders. What are your plans for the next attack?”")]), _vm._v(" "), _c('p', [_vm._v("“We’ll check the caves tomorrow in the day and set fire to them. If that doesn’t work, we’ll wait until they leave the cave and we will be ready to fight them.”")]), _vm._v(" "), _c('p', [_vm._v("“I and some of my men will be with you.” Said Edder.")]), _vm._v(" "), _c('p', [_vm._v("“As you wish, son.”")]), _vm._v(" "), _c('p', [_vm._v("Helewise squeezed his hand.")]), _vm._v(" "), _c('p', [_vm._v("“Good luck to you. Now, shall we have dessert?”")]), _vm._v(" "), _c('p', [_vm._v("There was sponge cake with strawberries and cream, apple pie and ginger bread cookies. After dessert, they all played cards. Helewise, Edder and his two sisters played go fish. Roseabella, Armando and her parents played poker.")]), _vm._v(" "), _c('p', [_vm._v("Armando won every hand. They retired early because the men were hunting tomorrow.")]), _vm._v(" "), _c('p', [_vm._v("“Wear this cross, this is a sign of Christ. You must not take them off your neck.” She told Armando, Edder and her father. “Father Strickland blessed all the crosses.”")]), _vm._v(" "), _c('p', [_vm._v("They looked at her as if she was crazy.")]), _vm._v(" "), _c('p', [_vm._v("“Roseabella, you should rest and spend a day indoors.”")]), _vm._v(" "), _c('p', [_vm._v("“I’m not crazy Armando, you promise never to take them off!”")]), _vm._v(" "), _c('p', [_vm._v("“Ok Roseabella, we will do it for you. We will be back late; if we can can’t burn them, we will wait for them to come out.”")]), _vm._v(" "), _c('p', [_vm._v("“Be safe!”")]), _vm._v(" "), _c('p', [_vm._v("A cave wasn’t going to burn like a barn. They decided to wait outside of the cave for them. Armando took a walk inside with his sword and a torch. The cave was longer on the inside but he could see at least twelve vamps. Counting himself, they were 24 against 12 vamps. The sun went down.")]), _vm._v(" "), _c('p', [_vm._v("Armando and his men waited behind a bank for all the vamps to come out. After Armando counted twelve of them, arrows were fired and screams were heard from the vamps. Armando’s men moved in with their swords. The vampires had no weapons, they stuck out their fangs. They were surrounded by soldiers. One jumped toward Armando but backed off when he saw the cross. They all backed away from the crosses.")]), _vm._v(" "), _c('p', [_vm._v("“Let’s cut off some heads and spike some hearts.”")]), _vm._v(" "), _c('p', [_vm._v("Every vampire turned to dust after being staked through the heart.")]), _vm._v(" "), _c('p', [_vm._v("“Now, we must hurry men and get through the gates.”")]), _vm._v(" "), _c('p', [_vm._v("They made it home in the dark and everyone was safe. The women were waiting form them inside Roseabella’s bedroom.")]), _vm._v(" "), _c('p', [_vm._v("“You have a view of everything, daughter.”")]), _vm._v(" "), _c('p', [_vm._v("“They’re coming in, the gates are open.”")]), _vm._v(" "), _c('p', [_vm._v("The women ran down three long steps of stairs and ran out in the night.")]), _vm._v(" "), _c('p', [_vm._v("“Oh Armando, you’re safe.”")]), _vm._v(" "), _c('p', [_vm._v("“Yes, my lady we all are.”")]), _vm._v(" "), _c('p', [_vm._v("“Oh Roseabella, your crosses worked and we slaughtered twelve vampires. They tried to run but we were around them and they were frightened of the crosses. There were no weapons on them. We had a lucky night.”")]), _vm._v(" "), _c('p', [_vm._v("“Come my husband, hot water waits for you and wine. We will eat in our room.”")]), _vm._v(" "), _c('p', [_vm._v("“Only if you join me in the tub.”")]), _vm._v(" "), _c('p', [_vm._v("“I think not my husband, you are covered in vampire blood.”")]), _vm._v(" "), _c('p', [_vm._v("“You are right my dear, you can wash my hair.”")]), _vm._v(" "), _c('p', [_vm._v("“Yes, I’ll do that and drink wine with you.”")]), _vm._v(" "), _c('p', [_vm._v("“You are a good woman, after I’m cleaned off, I want you naked in bed.”")]), _vm._v(" "), _c('p', [_vm._v("“It will be my pleasure, dear husband.”")]), _vm._v(" "), _c('p', [_vm._v("After two days visiting, the Duke and Duchess left for their own castle leaving the girls behind. Gretta and Ardelean were under her care.")]), _vm._v(" "), _c('p', [_vm._v("“Come on my sisters, see if you can catch up with me running.”")]), _vm._v(" "), _c('p', [_vm._v("They could not catch up, their legs were shorter and they both had gained weight since eating with their parents. They were good with the spears and knocking each other to the ground.")]), _vm._v(" "), _c('p', [_vm._v("“Saige, would you team up with my youngest sister Gretta and teach her everything you know. Show her how to be quick.”")]), _vm._v(" "), _c('p', [_vm._v("“I would like that very much lady, Roseabella.”")]), _vm._v(" "), _c('p', [_vm._v("“And Saige, don’t give into her excuses.”")]), _vm._v(" "), _c('p', [_vm._v("“As you wish, my lady.”")]), _vm._v(" "), _c('p', [_vm._v("Gretta was taken off her hands. Now, she must find someone for her sister Ardelean, someone she would listen to and become friends with. Yes of course, she looks up to Helewise and they are close in age.")]), _vm._v(" "), _c('p', [_vm._v("“Helewise, would you take my sister under your wing?”")]), _vm._v(" "), _c('p', [_vm._v("“And why would I do that?”")]), _vm._v(" "), _c('p', [_vm._v("“You and the twins are the best we got.”")]), _vm._v(" "), _c('p', [_vm._v("“Well, since you put it that way, I’d be glad to.”")]), _vm._v(" "), _c('p', [_vm._v("“Thank you Helewise, I owe you a favor.”")]), _vm._v(" "), _c('p', [_vm._v("“Now, I must meet your brother in the stables; he is teaching me how to ride horse back.”")]), _vm._v(" "), _c('p', [_vm._v("“I see you have new riding boots. I didn’t know they were made for women too.”")]), _vm._v(" "), _c('p', [_vm._v("“You know they are men’s, darling and so is the rest of the clothes I’m wearing. It’s hard to run and fight with dresses down to your ankles.”")]), _vm._v(" "), _c('p', [_vm._v("“You are certainly right. And your bum looks beautifully shaped in my old pants.”")]), _vm._v(" "), _c('p', [_vm._v("“You’re making me hot, my lord. Which horse is mine?”")]), _vm._v(" "), _c('p', [_vm._v("“Today, you will ride Cloud. She is gentle and good with people.”")]), _vm._v(" "), _c('p', [_vm._v("“Armando, she is white as the clouds and so beautiful! I won’t be riding a side saddle.”")]), _vm._v(" "), _c('p', [_vm._v("“My dear, all ladies sit side saddle.”")]), _vm._v(" "), _c('p', [_vm._v("“I am dressed to ride like you and besides, how can I throw a spear at a vampire when sitting on a side of a horse?”")]), _vm._v(" "), _c('p', [_vm._v("“You do have a point there, my love. Ok now, let’s put you on top of the horse. Steady there Cloud, ok I want you to give her a gentle ride. When you want her to slow down, pull on the reins.”")]), _vm._v(" "), _c('p', [_vm._v("Armando and Roseabella left the gates and on to the fields.")]), _vm._v(" "), _c('p', [_vm._v("“We have a nice day my wife.”")]), _vm._v(" "), _c('p', [_vm._v("“I can’t believe I’m riding.”")]), _vm._v(" "), _c('p', [_vm._v("“You’re doing well for a beginner. Move your body with hers, so you won’t be bumping up and down.”")]), _vm._v(" "), _c('p', [_vm._v("“Oh, like this?”")]), _vm._v(" "), _c('p', [_vm._v("“Yes, you got it.”")]), _vm._v(" "), _c('p', [_vm._v("“Can we go faster, Armando?”")]), _vm._v(" "), _c('p', [_vm._v("“Already Roseabella?”")]), _vm._v(" "), _c('p', [_vm._v("“Yes, Armando just a little faster.”")]), _vm._v(" "), _c('p', [_vm._v("“Ok, loosen the reins and give her a soft kick.”")]), _vm._v(" "), _c('p', [_vm._v("“Like this?”")]), _vm._v(" "), _c('p', [_vm._v("“Yes, that is good what you’re doing.”")]), _vm._v(" "), _c('p', [_vm._v("“Armando, I feel so free.”")]), _vm._v(" "), _c('p', [_vm._v("They rode for two hours and came across a pond.")]), _vm._v(" "), _c('p', [_vm._v("“Let’s take a break.”")]), _vm._v(" "), _c('p', [_vm._v("When Roseabella got off her horse, she could hardly walk.")]), _vm._v(" "), _c('p', [_vm._v("“You didn’t tell me Armando, horseback riding makes you a cripple.”")]), _vm._v(" "), _c('p', [_vm._v("“My dear, only the first few weeks.”")]), _vm._v(" "), _c('p', [_vm._v("“A few weeks?”")]), _vm._v(" "), _c('p', [_vm._v("“My dear, everyone has to pay the price for enjoyment!”")]), _vm._v(" "), _c('p', [_vm._v("“I know what will cure you and take out the stiffness.”")]), _vm._v(" "), _c('p', [_vm._v("“You do?”")]), _vm._v(" "), _c('p', [_vm._v("“Yes, first we remove our clothes and soak in the pond. In this pond, the waters are warm and refreshing.”")]), _vm._v(" "), _c('p', [_vm._v("Armando took off his clothes first. Roseabella took off her shirt and pants.")]), _vm._v(" "), _c('p', [_vm._v("“Where are your under garments?”")]), _vm._v(" "), _c('p', [_vm._v("“They make me dreadfully hot, Armando and its only you and me, so here I am!”")]), _vm._v(" "), _c('p', [_vm._v("Armando took her to the pond and gently laid her down.")]), _vm._v(" "), _c('p', [_vm._v("“You said the water was warm.”")]), _vm._v(" "), _c('p', [_vm._v("“Give it a few minutes, you’ll warm up. Can you swim Roseabella?”")]), _vm._v(" "), _c('p', [_vm._v("“Yes, father had a water pool for us in the garden. It was four feet deep, ten feet wide and twenty-four feet long. It’s made out of bricks.”")]), _vm._v(" "), _c('p', [_vm._v("“I’ll get your father’s blue prints and get one made.”")]), _vm._v(" "), _c('p', [_vm._v("Armando took her in his arms and kissed her mouth and sucked on her bottom lip.")]), _vm._v(" "), _c('p', [_vm._v("“Someone might see us!” Roseabella dove into the water, “Catch me if you can!”")]), _vm._v(" "), _c('p', [_vm._v("Armando dove in after her. She was a good swimmer but he caught up with her. He lifted her up and sucked on her nipples. He put her down.")]), _vm._v(" "), _c('p', [_vm._v("“I want you my wife, every day.”")]), _vm._v(" "), _c('p', [_vm._v("“Oh Armando, I want you too.”")]), _vm._v(" "), _c('p', [_vm._v("Armando moved toward a boulder; with his back against the boulder, he lifted her up until their bodies connected. He grabbed her by the buttocks and pumped his manhood in her. They devoured each other’s mouth. Sunshine on them and water on their skin. They were laughing and making love outside of the gates.")]), _vm._v(" "), _c('p', [_vm._v("Garrett watched from the opening of his cave. He came there at night to be alone. He had to get away from Morgania. She wanted him for herself. She was pretty with flaming red hair. Her skin white as snow and she was good in bed but he could not love her. He looked at his cousin and his wife. The sun shining down on them. They were giving each other pleasure.")]), _vm._v(" "), _c('p', [_vm._v("“I will have your wife Armando, with child or not. And you are killing the under-dog vampires. Kill them all Armando, the dirty animals. It won’t be so easy with the older and intelligent ones. They have weapons and sleep in luxury.")]), _vm._v(" "), _c('p', [_vm._v("I have plans to move away and take your wife with me. I come here to think and be alone. I found my parents’ nest egg buried in the rose garden. I will be gone when they return from traveling. Roseabella will be my bed partner soon.”")]), _vm._v(" "), _c('p', [_vm._v("Armando and Roseabella were enjoying their ride back the wind and sun dried their clothes on their bodies as they were riding. Roseabella gave the horse a little kick and she went gliding over the fields. Armando caught up with her and he told her she was meant to ride a horse.")]), _vm._v(" "), _c('p', [_vm._v("“And that’s because you are a good teacher.”")]), _vm._v(" "), _c('p', [_vm._v("“Gerrold and Saige will take you tomorrow and your sisters. Helewise would like to go as well, get cook to pack you a picnic.”")]), _vm._v(" "), _c('p', [_vm._v("“Oh, Armando, they would love it and I love you husband. I’ve never been so happy before in my life, until I met up with you. You kept your promises Armando, you are a good man.”")]), _vm._v(" "), _c('p', [_vm._v("“Why is our sister walking like that?”")]), _vm._v(" "), _c('p', [_vm._v("“Your poor sister has been horseback riding.” Said Helewise.")]), _vm._v(" "), _c('p', [_vm._v("“I thought horseback riding was fun.”")]), _vm._v(" "), _c('p', [_vm._v("“It will be after a few weeks when your body gets used to it.”")]), _vm._v(" "), _c('p', [_vm._v("“Let’s go say hi to her. Roseabella, how was your outing?”")]), _vm._v(" "), _c('p', [_vm._v("“Armando said I was meant to ride.”")]), _vm._v(" "), _c('p', [_vm._v("“Why are you walking like you are in pain?”")]), _vm._v(" "), _c('p', [_vm._v("“No pain, no gain. Think about it tomorrow when you have your first lesson.”")]), _vm._v(" "), _c('p', [_vm._v("“We don’t want to rush it, sister.”")]), _vm._v(" "), _c('p', [_vm._v("“Saige, Helewise, you two and me will leave after breakfast. Saige’s grandfather will take us. We will take a picnic and eat by the pond.”")]), _vm._v(" "), _c('p', [_vm._v("“I guess it sounds good.”")]), _vm._v(" "), _c('p', [_vm._v("“Here darling, drink this glass of wine, it will relax your muscles.”")]), _vm._v(" "), _c('p', [_vm._v("She took it and gulped it down and asked for a refill.")]), _vm._v(" "), _c('p', [_vm._v("“I hope we have fried chicken tonight, oh yes with mashed potatoes and gravy. All that training sure makes you hungry.”")]), _vm._v(" "), _c('p', [_vm._v("“Dinner is now being served, my lady.”")]), _vm._v(" "), _c('p', [_vm._v("“Thank you, Meiga.”")]), _vm._v(" "), _c('p', [_vm._v("Seafood chowder for first course, it was creamy and hot. Second course was a stuffed turkey, the skin was brown and crispy. The meat was so tender. Mashed vegetables and baked duff on top of the gravy and a pot of gravy for Helewise and her sisters.")]), _vm._v(" "), _c('p', [_vm._v("“Does anyone want some cranberry sauce? It’s so tangy!”")]), _vm._v(" "), _c('p', [_vm._v("“I’ll have some sweetheart before you eat it all.”")]), _vm._v(" "), _c('p', [_vm._v("“All that riding has given me a big appetite.”")]), _vm._v(" "), _c('p', [_vm._v("“Your sister caught on fast today. She’s going to make a good horseback rider.”")]), _vm._v(" "), _c('p', [_vm._v("“Wear our brothers’ clothes he gave you and his old boots. We’ll take measuring of your feet and get new ones in the village. I’ll send a messenger to the village with their sizes.”")]), _vm._v(" "), _c('p', [_vm._v("“Thank you, Armando. Now, who’s ready for dessert?”")]), _vm._v(" "), _c('p', [_vm._v("It was strawberry pie and baked apple with pastry over them.")]), _vm._v(" "), _c('p', [_vm._v("“It looks too good to pass up,” said Armando.")]), _vm._v(" "), _c('p', [_vm._v("“I’ll try both, of course, with clotted cream on top.”")]), _vm._v(" "), _c('p', [_vm._v("“Saige’s strawberry patch this year had great produce.”")]), _vm._v(" "), _c('p', [_vm._v("“She worked me hard today, Roseabella, she was like a fox. Who could keep up with her? Although she showed me how to throw a spear.”")]), _vm._v(" "), _c('p', [_vm._v("“Her grandfather’s been teaching her since she was old enough to walk.”")]), _vm._v(" "), _c('p', [_vm._v("“What else can this child do?”")]), _vm._v(" "), _c('p', [_vm._v("“Well,” said Helewise, “she is an excellent rider, she can climb trees faster than a monkey, run, jump and swim like a fish. She is a remarkable young lady. Ok girls, let’s get our rest for tomorrow. And bring something for swimming.”")]), _vm._v(" "), _c('p', [_vm._v("Everyone ate their breakfast as fast as they could. At the stables, Gerrold had them on their horses in no time.")]), _vm._v(" "), _c('p', [_vm._v("“Girls, I want you to let your horses walk you slowly across the field. They know all the trails. Now, pull on the reins and softly kick their side.”")]), _vm._v(" "), _c('p', [_vm._v("Gerrold brought along another man to ride behind the three sisters. So, he could stay on head with Helewise and Saige.")]), _vm._v(" "), _c('p', [_vm._v("“Slow down girls, we have beginners behind us.”")]), _vm._v(" "), _c('p', [_vm._v("“Yes, gramps but can’t I go on alone, it’s been weeks since I have been out riding.”")]), _vm._v(" "), _c('p', [_vm._v("“You and Helewise will a have a good run on the ride back.”")]), _vm._v(" "), _c('p', [_vm._v("Roseabella was so pleased to see her sister’s horseback riding, they both had smiles on their faces.")]), _vm._v(" "), _c('p', [_vm._v("“Can we go faster, Roseabella?”")]), _vm._v(" "), _c('p', [_vm._v("“Ok, loosen up the reins and give her a little kick.”")]), _vm._v(" "), _c('p', [_vm._v("“It’s about time they are catching up and riding a little faster.”")]), _vm._v(" "), _c('p', [_vm._v("“They are doing good gramps, for the first lesson. I saw Roseabella riding in yesterday, she was flying.”")]), _vm._v(" "), _c('p', [_vm._v("“My brother said she was meant to ride. There’s the pond finally, took us three hours instead of two.”")]), _vm._v(" "), _c('p', [_vm._v("The girls were hot, stiff and hungry. Gerrold and his helper took the horses over by the pond to drink and feed.")]), _vm._v(" "), _c('p', [_vm._v("“My legs and bum hurt.”")]), _vm._v(" "), _c('p', [_vm._v("“Mine too.” Said Gretta.")]), _vm._v(" "), _c('p', [_vm._v("“Stop complaining and help set up the picnic. Layout the plates, forks and knives. I will pick up the men’s plates of food for them.”")]), _vm._v(" "), _c('p', [_vm._v("Roseabella put fried chicken, hard boiled eggs, fresh bread and butter, a slab of cheese, cold turkey from last night and cold lemon tea.")]), _vm._v(" "), _c('p', [_vm._v("“Thank you, lady Roseabella you are too kind.”")]), _vm._v(" "), _c('p', [_vm._v("Roseabella noticed everyone had picked up their food except Saige.")]), _vm._v(" "), _c('p', [_vm._v("“Aren’t you hungry Saige?”")]), _vm._v(" "), _c('p', [_vm._v("“Yes, my lady but you need to eat first.”")]), _vm._v(" "), _c('p', [_vm._v("“Why don’t I get both of us a plateful? Do you like chicken, turkey and eggs?”")]), _vm._v(" "), _c('p', [_vm._v("“Yes, my lady, here you go and some fresh bread and butter.”")]), _vm._v(" "), _c('p', [_vm._v("“What a perfect picnic, tell your grandmother it was delicious.”")]), _vm._v(" "), _c('p', [_vm._v("“Yes, lady Helewise. Now who wants a ginger cookie?”")]), _vm._v(" "), _c('p', [_vm._v("“Me, me, me.” They all shouted. Roseabella gave them two cookies each.")]), _vm._v(" "), _c('p', [_vm._v("“Saige, can you take some cookies over to the men?”")]), _vm._v(" "), _c('p', [_vm._v("“Yes, there’re gramps’ favorite.”")]), _vm._v(" "), _c('p', [_vm._v("“Ok, last one in is a rotten egg!”")]), _vm._v(" "), _c('p', [_vm._v("The girls had their panty loon and long shirts on under their riding clothes. Saige was the first one in and Roseabella was the rotten egg.")]), _vm._v(" "), _c('p', [_vm._v("Gerrold packed away all the dishes and leftovers. Saige asked Gramps.")]), _vm._v(" "), _c('p', [_vm._v("“Where is the other man?”")]), _vm._v(" "), _c('p', [_vm._v("“He’s just gone in the little cave over there to cool off.”")]), _vm._v(" "), _c('p', [_vm._v("“I need to make my water.”")]), _vm._v(" "), _c('p', [_vm._v("“Go behind the bush, my girl.”")]), _vm._v(" "), _c('p', [_vm._v("And after relieving herself, she came back and said.")]), _vm._v(" "), _c('p', [_vm._v("“Grandfather, we have to leave, our guard is being torn apart inside the cave.”")]), _vm._v(" "), _c('p', [_vm._v("“How do you know Saige?”")]), _vm._v(" "), _c('p', [_vm._v("“I had a vision!”")]), _vm._v(" "), _c('p', [_vm._v("“I must help him.”")]), _vm._v(" "), _c('p', [_vm._v("“He’s dead gramps, he didn’t want to change him.”")]), _vm._v(" "), _c('p', [_vm._v("“Go get Roseabella.”")]), _vm._v(" "), _c('p', [_vm._v("“Yes gramps.”")]), _vm._v(" "), _c('p', [_vm._v("“What do you want, Gerrold?”")]), _vm._v(" "), _c('p', [_vm._v("“My man is being torn apart in that cave.”")]), _vm._v(" "), _c('p', [_vm._v("“How do you know?”")]), _vm._v(" "), _c('p', [_vm._v("“Saige had a vision.”")]), _vm._v(" "), _c('p', [_vm._v("“Dear god, what can we do for him?”")]), _vm._v(" "), _c('p', [_vm._v("“Saige said he’s dead and won’t change. So, I will walk over toward the cave and say, I heard our guard being murdered. And I’ll run back and tell everyone to leave now!”")]), _vm._v(" "), _c('p', [_vm._v("“Yes, please do that, Gerrold.”")]), _vm._v(" "), _c('p', [_vm._v("“Ladies, we have to go. Your guard is torn apart in the cave behind the bushes.”")]), _vm._v(" "), _c('p', [_vm._v("Everyone dressed as fast as possible.")]), _vm._v(" "), _c('p', [_vm._v("“Don’t panic, we have lots of sunlight. And why would that stupid man go in a dark cave? Not a good time for exploring.”")]), _vm._v(" "), _c('p', [_vm._v("Gerrold helped the girls on their horses.")]), _vm._v(" "), _c('p', [_vm._v("“Let’s stay in the same range.”")]), _vm._v(" "), _c('p', [_vm._v("“Roseabella, we should have brought our swords and worn our crosses and then went into the cave and cut off his head and stabbed him in the heart.”")]), _vm._v(" "), _c('p', [_vm._v("“Yes, I was thinking the same thing Helewise. We’ll know next time to carry our weapons.”")]), _vm._v(" "), _c('p', [_vm._v("When everyone made it through the gates, it was a relief to get her sisters’ home safe. They were a big responsibility. All the girls went straight to their rooms and fell deep in sleep.")]), _vm._v(" "), _c('p', [_vm._v("“I saw you yesterday Roseabella, in the pond mating with my cousin and today with your family and my little Helewise is becoming a woman. The other two girls looked a lot like you. They don’t have your extraordinary looks and beautiful body. What a good snack I had today. Your guard was sucked dry and torn apart. I’m coming for you Roseabella, sooner than you think.”")]), _vm._v(" "), _c('p', [_vm._v("Roseabella woke up screaming.")]), _vm._v(" "), _c('p', [_vm._v("“Roseabella, you are safe now my darling. You had a terrifying day.”")]), _vm._v(" "), _c('p', [_vm._v("“Armando, he was there yesterday.”")]), _vm._v(" "), _c('p', [_vm._v("“Who was?”")]), _vm._v(" "), _c('p', [_vm._v("“Garrett was there, watching us make love. Armando, he tore apart the guard after feeding from him. He’s coming for me soon.”")]), _vm._v(" "), _c('p', [_vm._v("“I will go after him now!”")]), _vm._v(" "), _c('p', [_vm._v("“It’s almost dark and he’s gone. You won’t find him.”")]), _vm._v(" "), _c('p', [_vm._v("“I will have our meal sent to our room. Let me pour you a glass of wine, drink up my darling; have another glass, it will calm you down.”")]), _vm._v(" "), _c('p', [_vm._v("“Thank you Armando, I’m feeling a little better.”")]), _vm._v(" "), _c('p', [_vm._v("“I’ll talk to Meiga about our meal.”")]), _vm._v(" "), _c('p', [_vm._v("“What would you like, dear?”")]), _vm._v(" "), _c('p', [_vm._v("“Well, we did already have a big picnic. Maybe some hot turkey soup and hot tea.”")]), _vm._v(" "), _c('p', [_vm._v("“Ok, I will be back in a while.”")]), _vm._v(" "), _c('p', [_vm._v("“Armando, please stay and have your meal with your sister. She’ll be alone. My two sisters are staying in their rooms. They were so scared today.”")]), _vm._v(" "), _c('p', [_vm._v("“Ok, my darling I’ll tell your maid to bring you your food.”")]), _vm._v(" "), _c('p', [_vm._v("“Where’s your wife?”")]), _vm._v(" "), _c('p', [_vm._v("“She had another bad dream, I’m afraid. Garrett was in the cave yesterday watching us in the pond. He told her he bled my guard dry and then tore him apart. And he’s coming for her soon.”")]), _vm._v(" "), _c('p', [_vm._v("“He wants what you have, my brother. You must not make her with child.”")]), _vm._v(" "), _c('p', [_vm._v("“Yes, we will need protection.”")]), _vm._v(" "), _c('p', [_vm._v("“Why does he want your wife and child? You were his best friend, Armando. He treats us like we meant nothing to him. And if I went close to that cave today, I would be dead now or worse would become a vampire! Promise me Armando if I ever get bitten, please cut off my head.”")]), _vm._v(" "), _c('p', [_vm._v("“Yes and you do the same for me Helewise.”")]), _vm._v(" "), _c('p', [_vm._v("“That’s a promise.”")]), _vm._v(" "), _c('p', [_vm._v("Roseabella was sound asleep when Armando returned to the bedroom.")]), _vm._v(" "), _c('p', [_vm._v("“My darling, my poor darling, I and my men will protect you from my cousin. He won’t get near you.” Armando laid down beside his wife. “Sleep my love, we will spend time together tomorrow.”")]), _vm._v(" "), _c('p', [_vm._v("The next morning, Armando was sat up in bed looking at her when she opened her eyes.")]), _vm._v(" "), _c('p', [_vm._v("“Armando, its daylight already?”")]), _vm._v(" "), _c('p', [_vm._v("“Yes, my dear you slept for twelve hours.”")]), _vm._v(" "), _c('p', [_vm._v("“My god, I’ve been so tired lately.”")]), _vm._v(" "), _c('p', [_vm._v("“Make no wonder with all that training. Roseabella, we need protection, so you won’t get pregnant.”")]), _vm._v(" "), _c('p', [_vm._v("She then thought about her monthly flow. Two weeks before I married and have been married now for six weeks.")]), _vm._v(" "), _c('p', [_vm._v("“Armando, we don’t need protection.”")]), _vm._v(" "), _c('p', [_vm._v("“Why not my wife?”")]), _vm._v(" "), _c('p', [_vm._v("“I’m already pregnant. Armando I’m so sorry.”")]), _vm._v(" "), _c('p', [_vm._v("He looked at his wife who had tears in her eyes.")]), _vm._v(" "), _c('p', [_vm._v("“We’ll get through this and our child will be loved and protected.”")]), _vm._v(" "), _c('p', [_vm._v("At the breakfast table, everyone was quiet.")]), _vm._v(" "), _c('p', [_vm._v("“Why the long faces?” said Helewise.")]), _vm._v(" "), _c('p', [_vm._v("“We’re still thinking about that poor man murdered yesterday.”")]), _vm._v(" "), _c('p', [_vm._v("“You two will practice every day. Why do you practice? To defend ourselves against vampires. Don’t waste your time about dead people; if Roseabella and I had our spears yesterday, we would have taken the vamp down.”")]), _vm._v(" "), _c('p', [_vm._v("“Helewise that is enough! They don’t have your skills and nerve. Not everyone wants to be a slayer.”")]), _vm._v(" "), _c('p', [_vm._v("“Thank God for that.”")]), _vm._v(" "), _c('p', [_vm._v("“And what does that mean?”")]), _vm._v(" "), _c('p', [_vm._v("“It means that you two would make poor slayers.” (I’ll show you-you show off, I’ll trip you up with my spear)")]), _vm._v(" "), _c('p', [_vm._v("“Roseabella, why are you so quiet?”")]), _vm._v(" "), _c('p', [_vm._v("“It’s hard to get a word in with all this arguing.”")]), _vm._v(" "), _c('p', [_vm._v("“We’re sorry, you do look a bit white though.”")]), _vm._v(" "), _c('p', [_vm._v("“Your sister’s fine, it’s all a part of being with child.”")]), _vm._v(" "), _c('p', [_vm._v("“I’m going to be an aunt?”")]), _vm._v(" "), _c('p', [_vm._v("“Roseabella, wait until mother and father finds out. They are going to be so proud of you.”")]), _vm._v(" "), _c('p', [_vm._v("“Ok, let’s get to the court yard. We need more training. You can’t train in your condition Roseabella you could harm the baby.”")]), _vm._v(" "), _c('p', [_vm._v("“Most women give birth in the fields Armando, where they work. And don’t miss a day’s work after the baby is born.”")]), _vm._v(" "), _c('p', [_vm._v("“This is our first child, please take it easy.”")]), _vm._v(" "), _c('p', [_vm._v("“I will my love, I promise.”")]), _vm._v(" "), _c('p', [_vm._v("“I’ll see you all tonight, girls.”")]), _vm._v(" "), _c('p', [_vm._v("“Yes, have a good day, Armando.”")]), _vm._v(" "), _c('p', [_vm._v("“Let’s do our laps.”")]), _vm._v(" "), _c('p', [_vm._v("“Should you?”")]), _vm._v(" "), _c('p', [_vm._v("“Yes of course but I’ll run a little slower.”")]), _vm._v(" "), _c('p', [_vm._v("The women were a lot faster with their running and not so out of breath.")]), _vm._v(" "), _c('p', [_vm._v("“Today you did well, the men are now going to push a stuffed dummy toward you. One at a time. You must run and jump for the heart while it’s moving. Helewise, you go first.”")]), _vm._v(" "), _c('p', [_vm._v("“Gladly, sister-in-law.” Helewise made a run for it and took a high jump and landed the spike into the heart and leaped out of the way before the men knocked her down. Everyone clapped.")]), _vm._v(" "), _c('p', [_vm._v("“Ok, next the twins will try.” The twins were broad-shouldered and muscled up. They had big hands for fighting. The oldest one with a mole on her face (it was the only way to tell them apart) she took the spear, ran a short distance and threw the spear right in the heart. Roseabella told the twin’s sister.")]), _vm._v(" "), _c('p', [_vm._v("“You are up next.”")]), _vm._v(" "), _c('p', [_vm._v("“Nothing to it.” She said. She took off running with the bow and arrow. She jumped up and released the arrow, it flew like a bird straight in the heart. Then Roseabella’s two sisters missed the heart but came close. One woman shot an arrow at the dummy and landed between his legs; they all had a great laugh at that one.")]), _vm._v(" "), _c('p', [_vm._v("Next up was little Saige.")]), _vm._v(" "), _c('p', [_vm._v("“How are you doing Saige after yesterday?”")]), _vm._v(" "), _c('p', [_vm._v("“I just wish I had my vision earlier, my lady. I could have saved him.”")]), _vm._v(" "), _c('p', [_vm._v("“Don’t think that way. People now know not to go in dark caves. And they will be extra careful watering their horses at the pond and there could be many more caves around the area. God knows what he is doing, Saige; he gave you the insight and perhaps not all you will understand. Now, go out there and show them what you can do.”")]), _vm._v(" "), _c('p', [_vm._v("Saige didn’t run, she just aimed 100 feet away from the target, her spear had feathers on top on four sides. She aimed, took one step and sent it up in the sky, then it came down and hit the heart. Everybody clapped even the men. One of the women shouted out.")]), _vm._v(" "), _c('p', [_vm._v("“It’s your turn now, our lady.”")]), _vm._v(" "), _c('p', [_vm._v("Roseabella hoped that Armando wasn’t looking. She took the guard’s steel blade and ran and jumped up and off went his head. Everyone cheered!")]), _vm._v(" "), _c('p', [_vm._v("“By God,” said one of the men, “we have a better team than Armando’s.”")]), _vm._v(" "), _c('p', [_vm._v("“My gramps is making all the men spears. Sir Armando saw us practicing with them and he said it works.”")]), _vm._v(" "), _c('p', [_vm._v("The next day, the women learned to throw their spears and shoot arrows from horseback. It was not easy. There were dead rabbits nailed to trees. First, we let them ride up slowly and aim. That got their confidence up. We did this a few times and got the hang of it.")]), _vm._v(" "), _c('p', [_vm._v("“Ok, speed up ladies and aim for your targets.”")]), _vm._v(" "), _c('p', [_vm._v("Half nailed it, half didn’t but we kept on practicing for a while.")]), _vm._v(" "), _c('p', [_vm._v("“Ok ladies.”")]), _vm._v(" "), _c('p', [_vm._v("“Who you calling a lady!”")]), _vm._v(" "), _c('p', [_vm._v("Everyone laughed, so Helewise tried again.")]), _vm._v(" "), _c('p', [_vm._v("“Ok you women, the kitchen has ale, wine, and food waiting. We will practice on the field tomorrow morning.”")]), _vm._v(" "), _c('p', [_vm._v("Roseabella was out like a light. The maid came in with hot water to bath. She got in the tub and fell asleep again.")]), _vm._v(" "), _c('p', [_vm._v("“My darling, are you alright?”")]), _vm._v(" "), _c('p', [_vm._v("“Yes, Armando just so tired.”")]), _vm._v(" "), _c('p', [_vm._v("He took her out of the tub and dried her off.")]), _vm._v(" "), _c('p', [_vm._v("“You lie down on the bed while I jump in the tub and clean the grime of me.”")]), _vm._v(" "), _c('p', [_vm._v("Armando was dressed and ready, waiting for the maid to dress Roseabella.")]), _vm._v(" "), _c('p', [_vm._v("“You look lovely, my wife.”")]), _vm._v(" "), _c('p', [_vm._v("“So do you, well not lovely but handsome.”")]), _vm._v(" "), _c('p', [_vm._v("“That sounds better. Let’s go I’m starving. You are eating for two!”")]), _vm._v(" "), _c('p', [_vm._v("“Would you like some wine, darling?”")]), _vm._v(" "), _c('p', [_vm._v("“Better not Armando, don’t want to get the baby drunk. I would like some cold lemon tea.”")]), _vm._v(" "), _c('p', [_vm._v("“Of course, I’ll send the servant for some.”")]), _vm._v(" "), _c('p', [_vm._v("The girls were treating themselves to some wine. (How much would they drink if I didn’t cut them off? They must be trying to drink more than Helewise)")]), _vm._v(" "), _c('p', [_vm._v("“Your lemon tea, my lady.”")]), _vm._v(" "), _c('p', [_vm._v("“Thank you, it’s so refreshing.”")]), _vm._v(" "), _c('p', [_vm._v("“I’m not as sore as yesterday, Roseabella. Meiga gave me some salve for sore muscles. We both used it and it worked miracles.”")]), _vm._v(" "), _c('p', [_vm._v("“I’m proud of your riding, little sisters.”")]), _vm._v(" "), _c('p', [_vm._v("“We love it, father has to let us ride when we leave.”")]), _vm._v(" "), _c('p', [_vm._v("“I’ll mention it to him.”")]), _vm._v(" "), _c('p', [_vm._v("“It would also be nice to have our own horses.”")]), _vm._v(" "), _c('p', [_vm._v("“Dinner is served, my lady ship.”")]), _vm._v(" "), _c('p', [_vm._v("“Oh, I can’t wait. Chicken and dumplings, my favorite.”")]), _vm._v(" "), _c('p', [_vm._v("The second course was a chicken pie and grilled trout.")]), _vm._v(" "), _c('p', [_vm._v("“Everything is so delicious.”")]), _vm._v(" "), _c('p', [_vm._v("Roseabella had seconds of everything. For dessert, it was a plum pudding and brown sugar sauce.")]), _vm._v(" "), _c('p', [_vm._v("“Sister-in-law you ate enough for triplets.”")]), _vm._v(" "), _c('p', [_vm._v("“Maybe Helewise but now I am so sleepy I can’t keep my eyes open. So, please excuse a woman pregnant with triplets!”")]), _vm._v(" "), _c('p', [_vm._v("“Good night, Roseabella.” Said her sisters.")]), _vm._v(" "), _c('p', [_vm._v("“You two girls finish the wine in your glass. Do not refill it.”")]), _vm._v(" "), _c('p', [_vm._v("“Oh, we won’t Roseabella.”")]), _vm._v(" "), _c('p', [_vm._v("When she left, Helewise told them:")]), _vm._v(" "), _c('p', [_vm._v("“One more glass won’t hurt you.”")]), _vm._v(" "), _c('p', [_vm._v("“We are starting to like you a little, Helewise.”")]), _vm._v(" "), _c('p', [_vm._v("“It’s good to have company, it gets boring here sometimes. You know what? I’m looking forward to the baby.”")]), _vm._v(" "), _c('p', [_vm._v("“Oh, so are we, we need to shop for the baby!”")]), _vm._v(" "), _c('p', [_vm._v("“Of course, you two need dresses for your sister’s birthday I’m hosting. We will go to the village next week.”")]), _vm._v(" "), _c('p', [_vm._v("“Oh, we can’t wait!”")]), _vm._v(" "), _c('p', [_vm._v("Armando and Roseabella made love. He was so gentle and caring.")]), _vm._v(" "), _c('p', [_vm._v("“My dear, your breasts are getting bigger.”")]), _vm._v(" "), _c('p', [_vm._v("“They feel tender.”")]), _vm._v(" "), _c('p', [_vm._v("“When are you due?”")]), _vm._v(" "), _c('p', [_vm._v("“Eight months’ time.”")]), _vm._v(" "), _c('p', [_vm._v("“Do you need to see a midwife or a doctor?”")]), _vm._v(" "), _c('p', [_vm._v("“So far so good, maybe in eight months.”")]), _vm._v(" "), _c('p', [_vm._v("“You are a strong and beautiful woman.”")]), _vm._v(" "), _c('p', [_vm._v("“Thank you and all I need now is more sleep.”")]), _vm._v(" "), _c('p', [_vm._v("Roseabella took two naps a day as the weeks went by. All the staff were excited about the baby. Meiga made Roseabella all her favorite foods. She ate like a horse and had a little baby bump.")]), _vm._v(" "), _c('p', [_vm._v("“I’m so happy for you and Armando, Roseabella. You will make good parents.”")]), _vm._v(" "), _c('p', [_vm._v("“Thank you, Saige. Would you help me some time with the baby when I’m busy?”")]), _vm._v(" "), _c('p', [_vm._v("“Oh, my lady, I would be glad to. My lady, I had another vision.”")]), _vm._v(" "), _c('p', [_vm._v("“Ok, tell me Saige, when you are ready.”")]), _vm._v(" "), _c('p', [_vm._v("“Vampires were waiting for victims outside of the inns who were drunk and some of the men just came to port on a big ship. After drinking and being with whores, they left to go on the wharf to get on their ship.")]), _vm._v(" "), _c('p', [_vm._v("They did not make it. These vampires were strong and had weapons. The sailors tried to fight them off but there were too many vamps. After bleeding them, they put them in a wagon. I could see an old castle with windows all barred up. The men were brought inside and put in the basement to turn. The castle was full of vampires.”")]), _vm._v(" "), _c('p', [_vm._v("“How many did you see, Saige?”")]), _vm._v(" "), _c('p', [_vm._v("“They were everywhere. At least two hundred.”")]), _vm._v(" "), _c('p', [_vm._v("“And where was this castle, can you remember?”")]), _vm._v(" "), _c('p', [_vm._v("“I could see them leave the village, there was a graveyard outside the gates.”")]), _vm._v(" "), _c('p', [_vm._v("“We must tell your grandfather.”")]), _vm._v(" "), _c('p', [_vm._v("“Yes, he will help.”")]), _vm._v(" "), _c('p', [_vm._v("“Do you know what castle they are hiding in, Gerrold?”")]), _vm._v(" "), _c('p', [_vm._v("“It’s got to be the castle everyone stays away from. The say it’s haunted. The young king went crazy, killed his wife and kids and all of his servants. In the night time, you can hear the mother and her babes crying for help.”")]), _vm._v(" "), _c('p', [_vm._v("“And how do we get in?”")]), _vm._v(" "), _c('p', [_vm._v("“We go in daylight. Open up all the windows to let in the sun. Wear our crosses and bring holy water and kill them.”")]), _vm._v(" "), _c('p', [_vm._v("“Now, you must make up a story to tell my husband.”")]), _vm._v(" "), _c('p', [_vm._v("“I’ll figure something out. My lady, I’d like to thank you for including Saige with her training and letting her sit and eat at the picnic those few weeks ago.”")]), _vm._v(" "), _c('p', [_vm._v("“Gerrold, she is a child from God and she deserves the best. She is the one training us.”")]), _vm._v(" "), _c('p', [_vm._v("“Good day my lady, I will talk to your husband now.”")]), _vm._v(" "), _c('p', [_vm._v("“Roseabella, we found another place where the vamps are living. We leave at day light and take out as many as we can. We will load up with weapons, wear our crosses and take barrels of holy water.”")]), _vm._v(" "), _c('p', [_vm._v("“Armando, let me go with you.”")]), _vm._v(" "), _c('p', [_vm._v("“You are not going anywhere; you are with child. After the baby is born, we can discuss it again.”")]), _vm._v(" "), _c('p', [_vm._v("“Please be back before dark tomorrow evening, Armando.”")]), _vm._v(" "), _c('p', [_vm._v("“Go to sleep Roseabella, you have nothing to worry about.”")]), _vm._v(" "), _c('p', [_vm._v("But she had nightmares all night of Armando and his men’s blood was everywhere.")]), _vm._v(" "), _c('p', [_vm._v("Armando left with a hundred men at day light. His sister Helewise was there waiting for him at the gate.")]), _vm._v(" "), _c('p', [_vm._v("“And where do you think you are going?”")]), _vm._v(" "), _c('p', [_vm._v("“I am trained just as well as your men.”")]), _vm._v(" "), _c('p', [_vm._v("“You are fifteen.”")]), _vm._v(" "), _c('p', [_vm._v("“Yes and soon to be sixteen.”")]), _vm._v(" "), _c('p', [_vm._v("“Helewise, I don’t have time to argue with you.”")]), _vm._v(" "), _c('p', [_vm._v("“Please Armando, let me come with you.”")]), _vm._v(" "), _c('p', [_vm._v("“My dear sister, if I do not return today—”")]), _vm._v(" "), _c('p', [_vm._v("“Please don’t say that, brother!”")]), _vm._v(" "), _c('p', [_vm._v("“Will you promise me you’ll take care of Roseabella and our baby?”")]), _vm._v(" "), _c('p', [_vm._v("“Yes brother but when I turn sixteen, I will make my own decisions.”")]), _vm._v(" "), _c('p', [_vm._v("Armando and his men and a cart in toll to carry their extra weapons and holy water left at daylight. They reached the old abandoned castle.")]), _vm._v(" "), _c('p', [_vm._v("“This castle is the biggest in Transylvania. No one will go near it because of ghosts. People are so superstitious, Gerrold.”")]), _vm._v(" "), _c('p', [_vm._v("“Twenty years ago, we did not believe vampires existed either, Armando.”")]), _vm._v(" "), _c('p', [_vm._v("“My god, now we have ghosts and vampires?”")]), _vm._v(" "), _c('p', [_vm._v("“No Armando, the vamps have driven away the ghosts, I’m sure.”")]), _vm._v(" "), _c('p', [_vm._v("The gate to the castle was locked. Armando told his men as quiet as possible to take down the boards on the windows.")]), _vm._v(" "), _c('p', [_vm._v("“Good thing we brought a ladder to get to the high windows but we still can’t reach the balconies.”")]), _vm._v(" "), _c('p', [_vm._v("“Give them the rope with the small anchor on it. The man on the top will throw the anchor and climb.”")]), _vm._v(" "), _c('p', [_vm._v("“Yes, that should work Armando. You men go up the ladder and climb up to get those windows bare.”")]), _vm._v(" "), _c('p', [_vm._v("Morgania was in deep sleep. She could hear a noise but was too tired to wake. She was very comfortable in her casket. She was exhausted from drinking wine and human blood.")]), _vm._v(" "), _c('p', [_vm._v("“I bet it’s that human boy, Hatmanu who Garrett is fond of. When Garrett’s away, I make him work like a dog and beg for his food. He must be trying to escape again. Tonight, I will drink his blood and feed him to the wild dogs. Yes, I will tell Garrett he ran away. You won’t get out boy, you are locked in.”")]), _vm._v(" "), _c('p', [_vm._v("Hatmanu was sleeping on his bed. He heard a noise coming from the window, in an instant sunlight poured through. A soldier was outside of his window, looking in.")]), _vm._v(" "), _c('p', [_vm._v("“There’s a kid in here, tied to a bed.”")]), _vm._v(" "), _c('p', [_vm._v("Gerrold was climbing over the balcony.")]), _vm._v(" "), _c('p', [_vm._v("“What did you say, Elnach?”")]), _vm._v(" "), _c('p', [_vm._v("“A kid, sir, tied to the bed and sunlight is shining on him.”")]), _vm._v(" "), _c('p', [_vm._v("“Hey you kid, are you one of them?”")]), _vm._v(" "), _c('p', [_vm._v("“No, my name is Hatmanu. I’m a prisoner.”")]), _vm._v(" "), _c('p', [_vm._v("Gerrold climbed in the window and checked him for bite marks. He cut the kid’s ropes and tied the rope to his waist then lowered him down to the ladder. Armando could not believe what he saw. A boy climbing down the ladder.")]), _vm._v(" "), _c('p', [_vm._v("“Who are you boy?”")]), _vm._v(" "), _c('p', [_vm._v("“I’m Hatmanu, a slave to the vamps. Morgania ties me up at day and makes me clean and cater to her.”")]), _vm._v(" "), _c('p', [_vm._v("“How long?”")]), _vm._v(" "), _c('p', [_vm._v("“Three summers, my lord.”")]), _vm._v(" "), _c('p', [_vm._v("“Ok, please keep out of our way. We are here to slaughter the vampires.”")]), _vm._v(" "), _c('p', [_vm._v("“Watch out sir, for Morgania, she is a devil.”")]), _vm._v(" "), _c('p', [_vm._v("“What room is she in?”")]), _vm._v(" "), _c('p', [_vm._v("“She sleeps in the basement in her casket by day. In the night time, she has a room on the top floor to get ready.”")]), _vm._v(" "), _c('p', [_vm._v("Gerrold quietly took off boards from one window and inside were two beds with bodies covered up with rugs and furs. He entered the room with six of his men. The covers were torn off their bodies. The vampires screamed as the sunlight struck them.")]), _vm._v(" "), _c('p', [_vm._v("“Cut their heads off before they wake up the whole castle.”")]), _vm._v(" "), _c('p', [_vm._v("“Eight down, check under the beds.”")]), _vm._v(" "), _c('p', [_vm._v("“Nothing there, sir.”")]), _vm._v(" "), _c('p', [_vm._v("Grosu opened the closet and was grabbed by his throat and pulled inside. Screams came from Grosu. The men entered with their swords and cut the heads off the two vampires. Grosu was bleeding from his neck.")]), _vm._v(" "), _c('p', [_vm._v("“We must stop the blood,” said one of the soldiers. “Drag him out by his feet. And do not touch him, he is one of them now. Hatmanu, you know what to do.”")]), _vm._v(" "), _c('p', [_vm._v("“Yes sir.” And with his spike, he drove it through his friend’s heat. “I’m so sorry Grosu.”")]), _vm._v(" "), _c('p', [_vm._v("It was the hardest thing he ever done. Next time we check under beds and closets, we use our spear. Grosu’s body was lowered down to the ground with a spike through his heart. His body was put in a cart to take back to his family.")]), _vm._v(" "), _c('p', [_vm._v("Armando and fifty of the men entered the front door of the castle. His men were ready with their swords. The open door let in a lot of light. The vampires who were asleep all over the floor and couches started to scream from burns.")]), _vm._v(" "), _c('p', [_vm._v("“Chop the heads off.”")]), _vm._v(" "), _c('p', [_vm._v("“Fifty vampires were beheaded, Sir Armando, some went up the stairs.”")]), _vm._v(" "), _c('p', [_vm._v("“Let’s follow them men.”")]), _vm._v(" "), _c('p', [_vm._v("Upstairs in the bedrooms was laid with vampires. Sunshine was now coming through open bedroom door. But the corridors were still dark. The vampires fought back with the knives they slept with. The soldiers threw their spears and rushed in with their swords. Some of Armando’s men were wounded by knives but no one was bitten.")]), _vm._v(" "), _c('p', [_vm._v("“Cut their heads off!”")]), _vm._v(" "), _c('p', [_vm._v("One made a run for Armando with his knife. The vampire looked at Armando’s cross and covered his eyes with his arms. Armando had his chance, he took his sword and sliced through his neck; with two chops, his head and body hit the floor. Armando spiked him through his heart and he caught on fire.")]), _vm._v(" "), _c('p', [_vm._v("“Everyone must spike them through the heart, after you cut off their head. They will burn to ashes.”")]), _vm._v(" "), _c('p', [_vm._v("Gerrold and his men had fifty vampires burnt to ashes. He met Armando and his men down on the next floor. The wounded men were taken outside and others replaced them. Rueba, their medicine woman tended to their injuries.")]), _vm._v(" "), _c('p', [_vm._v("“The top floor and the bottom floors are done, now we must clean out the middle floor. We will be going to the bedrooms and kill every last one.”")]), _vm._v(" "), _c('p', [_vm._v("“Some rooms don’t have windows, Armando.”")]), _vm._v(" "), _c('p', [_vm._v("“We will then open the doors and blind them with Father Strickland’s holy water.”")]), _vm._v(" "), _c('p', [_vm._v("Armando lit his torch and threw it on the bed. He then threw in some rags soaked in animal fat. The bed clothes went up in flames. The vampires were on fire. They came after the men with their clothes on fire. His men fought with their swords.")]), _vm._v(" "), _c('p', [_vm._v("The rooms were still dark and the only light was from the burning bed. One vampire came out of the closet with a sword and was killing the soldiers so quickly. Armando threw holy water into his face. The vampire was blinded. Armando took his spike and put it through his heart, which turned him to ashes.")]), _vm._v(" "), _c('p', [_vm._v("“Take out our wounded and dead, make sure there are no bite marks. If there are bite marks, then you know what to do.”")]), _vm._v(" "), _c('p', [_vm._v("When all the rooms were done, they went down to the cellar and the wine room.")]), _vm._v(" "), _c('p', [_vm._v("“This is where the old ones must sleep. It smells moldy and damp.”")]), _vm._v(" "), _c('p', [_vm._v("“Be quiet, you will wake them and there’s no windows with light. Ok, three men for every casket. When I give the signal, we open the same time. One, two, three, open!”")]), _vm._v(" "), _c('p', [_vm._v("The caskets were empty.")]), _vm._v(" "), _c('p', [_vm._v("“Where’d they go?” asked one of the soldiers, “They didn’t escape into the sunlight.”")]), _vm._v(" "), _c('p', [_vm._v("“Ok, men search for an escape door.”")]), _vm._v(" "), _c('p', [_vm._v("“Yes, over here Sir Armando, behind the barrels! There was a big hole that leads through tunnels. Shall we go after them?”")]), _vm._v(" "), _c('p', [_vm._v("“Should we go after the creatures?” Gerrold asked Armando.")]), _vm._v(" "), _c('p', [_vm._v("“No, we must leave now and get back to the castle before the sun goes down. Ok men, every one outside, except for you ten men; get torches and catch all the table, chairs, rugs and bedrooms on fire. Burn everything that can be burned. Also, torch the trees and the wooden gate. Let the elders see their castle in flames.”")]), _vm._v(" "), _c('p', [_vm._v("Armando and his army made it home a few minutes before dark. Meiga and Saige were waiting inside for Gerrold. Saige ran and jumped up into her grandfather’s arms. Meiga wrapped her arms around both of them.")]), _vm._v(" "), _c('p', [_vm._v("“Oh, gramps you’re alive, I prayed all day in Father Strickland’s’ chapel and he prayed with me.”")]), _vm._v(" "), _c('p', [_vm._v("Meiga kissed her husband on the lips.")]), _vm._v(" "), _c('p', [_vm._v("“You worried about me, old girl?”")]), _vm._v(" "), _c('p', [_vm._v("“Do you want me to rear this little tom boy up by myself?”")]), _vm._v(" "), _c('p', [_vm._v("Saige then whispered in her grandfather’s ear.")]), _vm._v(" "), _c('p', [_vm._v("“She told me gramps that you were the love of her life.”")]), _vm._v(" "), _c('p', [_vm._v("“Oh, did she now?”")]), _vm._v(" "), _c('p', [_vm._v("Gerrold then put his arms around his wife and squeezed her buttocks. Then, both Helewise and Roseabella ran into Armando’s arms, almost knocking him down!")]), _vm._v(" "), _c('p', [_vm._v("“Armando, I have not worried about anyone so much in my life.”")]), _vm._v(" "), _c('p', [_vm._v("“I will always make it back to you my wife and to you little mouse.”")]), _vm._v(" "), _c('p', [_vm._v("“Did everyone make it back?”")]), _vm._v(" "), _c('p', [_vm._v("“I’m sorry to say we have five dead and five injured. We also brought back a young lad who was a slave and prisoner.”")]), _vm._v(" "), _c('p', [_vm._v("“Oh, Armando that poor soul, how old is he?”")]), _vm._v(" "), _c('p', [_vm._v("“I don’t know for sure, maybe twelve.”")]), _vm._v(" "), _c('p', [_vm._v("“Has he been bittern, Armando?”")]), _vm._v(" "), _c('p', [_vm._v("“No bite marks and he has been in the sun all day.”")]), _vm._v(" "), _c('p', [_vm._v("“How many vampires were put down? One hundred and fifty.”")]), _vm._v(" "), _c('p', [_vm._v("“Brother, I’m so proud of you. Did you get every one of them?”")]), _vm._v(" "), _c('p', [_vm._v("“Slow down Helewise, we will talk later. First, I need to see to my men and horses.”")]), _vm._v(" "), _c('p', [_vm._v("“Of course, brother, we will help you.”")]), _vm._v(" "), _c('p', [_vm._v("Roseabella and Helewise helped the medicine woman to wrap the wounds from the old bedsheets they cut up today.")]), _vm._v(" "), _c('p', [_vm._v("“Tomorrow,” Roseabella said, “Helewise, we must go to the families of the dead. And how will the wives and children live without them?”")]), _vm._v(" "), _c('p', [_vm._v("“Armando will keep them in coin and food. Some are young and will remarry.”")]), _vm._v(" "), _c('p', [_vm._v("Armando was tired but he and Roseabella showed up for the last meal of the day.")]), _vm._v(" "), _c('p', [_vm._v("“Oh, Armando you look a lot better with all that blood removed.”")]), _vm._v(" "), _c('p', [_vm._v("“Pour me a glass of wine sister and I will fill you in on all the details of our hunt.”")]), _vm._v(" "), _c('p', [_vm._v("After Helewise was satisfied with Armando’s events, she hugged her brother.")]), _vm._v(" "), _c('p', [_vm._v("“I’m so proud of you Armando.”")]), _vm._v(" "), _c('p', [_vm._v("“And so am I, my husband.”")]), _vm._v(" "), _c('p', [_vm._v("“You girls are making me blush!”")]), _vm._v(" "), _c('p', [_vm._v("“But you did leave out the part about putting every vamp down.”")]), _vm._v(" "), _c('p', [_vm._v("“Yes, I guess I forgot. Twenty vampires escaped, according to the boy and the empty caskets.”")]), _vm._v(" "), _c('p', [_vm._v("“They sleep in the caskets?”")]), _vm._v(" "), _c('p', [_vm._v("“Yes, according to the boy, the Elders and Morgania.”")]), _vm._v(" "), _c('p', [_vm._v("“Who the hell is Morgania?”")]), _vm._v(" "), _c('p', [_vm._v("“She, I’m told, is a beautiful and evil female vampire.”")]), _vm._v(" "), _c('p', [_vm._v("“But how did they escape?”")]), _vm._v(" "), _c('p', [_vm._v("“With all the fighting and screaming upstairs, they escaped through a tunnel in the cellar.”")]), _vm._v(" "), _c('p', [_vm._v("“Why didn’t you go after them?”")]), _vm._v(" "), _c('p', [_vm._v("“Helewise, how can you even ask your brother that? In the dark tunnels they would have been slaughtered.”")]), _vm._v(" "), _c('p', [_vm._v("“We left Helewise, so we could be home before darkness.”")]), _vm._v(" "), _c('p', [_vm._v("“I’m sorry Armando, please forgive me.”")]), _vm._v(" "), _c('p', [_vm._v("“Little mouse, if we took you, you’d be in the tunnels now as one of them.”")]), _vm._v(" "), _c('p', [_vm._v("“Remember our promise Armando, to each other.”")]), _vm._v(" "), _c('p', [_vm._v("“What promise?” Gretta who sat in silence asked.")]), _vm._v(" "), _c('p', [_vm._v("“It’s just between me and my brother.”")]), _vm._v(" "), _c('p', [_vm._v("“Dinner is now served.” Said one of Meiga’s assistants.")]), _vm._v(" "), _c('p', [_vm._v("“Where is Meiga?”")]), _vm._v(" "), _c('p', [_vm._v("“I gave her time off with her husband. And they are taking in the boy Hatmanu.”")]), _vm._v(" "), _c('p', [_vm._v("Both Gretta and Ardelean asked at the same time.")]), _vm._v(" "), _c('p', [_vm._v("“Who is Hatmanu?”")]), _vm._v(" "), _c('p', [_vm._v("“He is the young, brave boy who was a slave and prisoner to the vampires.”")]), _vm._v(" "), _c('p', [_vm._v("“My god Armando, how did he survive?”")]), _vm._v(" "), _c('p', [_vm._v("“I don’t know yet but vampires also like to use human prisoners to do their dirty jobs.”")]), _vm._v(" "), _c('p', [_vm._v("“I would kill myself before I would clean up from those dirty creatures!”")]), _vm._v(" "), _c('p', [_vm._v("“Oh, Gretta,” said Ardelean, “my sweet little sister, you don’t have a clue how to clean up after yourself!”")]), _vm._v(" "), _c('p', [_vm._v("“Now, look who is talking, you can’t even get dressed in the mornings on your own and you don’t pick up after yourself, Ardelean.”")]), _vm._v(" "), _c('p', [_vm._v("“Oh my, you both would make poor slaves.” Said Roseabella.")]), _vm._v(" "), _c('p', [_vm._v("“We’re sorry sister, we won’t upset you anymore.”")]), _vm._v(" "), _c('p', [_vm._v("“You girls are doing well with your training and horseback riding. Tomorrow, we’ll learn survival course, how to hunt and fish, light a fire and how to cook.”")]), _vm._v(" "), _c('p', [_vm._v("“And will you show us, Helewise?”")]), _vm._v(" "), _c('p', [_vm._v("Helewise looked Ardelean in the eyes and said.")]), _vm._v(" "), _c('p', [_vm._v("“I can show you how to survive but not how to cook!”")]), _vm._v(" "), _c('p', [_vm._v("“Ok, so we won’t survive if we starve.” Announced Gretta.")]), _vm._v(" "), _c('p', [_vm._v("“So Roseabella, how much longer will your sisters be staying with us?”")]), _vm._v(" "), _c('p', [_vm._v("“They will be returning with my brother after his visit.”")]), _vm._v(" "), _c('p', [_vm._v("“Your brother is coming for a visit?”")]), _vm._v(" "), _c('p', [_vm._v("“Yes, he will learn spear throwing from Saige.”")]), _vm._v(" "), _c('p', [_vm._v("“And why would he learn from her if he can learn from his sisters?”")]), _vm._v(" "), _c('p', [_vm._v("“Saige is the best and when you two get together with Edder, you all fight!”")]), _vm._v(" "), _c('p', [_vm._v("“But,”")]), _vm._v(" "), _c('p', [_vm._v("“No buts about it. Edder will enjoy his stay and you will return with him. In three weeks’ time, you will come to my eighteenth birthday and you will also carry on with your training. After my party, you will fight Helewise until one of you is on the ground with a sword to the throat. Now if you’ll excuse me, I’m tired and in need of sleep.”")]), _vm._v(" "), _c('p', [_vm._v("“So do I, my wife.”")]), _vm._v(" "), _c('p', [_vm._v("The three girls then looked at each other and said.")]), _vm._v(" "), _c('p', [_vm._v("“I think we’re in trouble and I’ll drink to that.”")]), _vm._v(" "), _c('p', [_vm._v("“Armando, you mean so much to me. Please don’t take chances.”")]), _vm._v(" "), _c('p', [_vm._v("“I don’t take chances on my army’s lives. My sister needs guidance. She needs to stop and think before plundering in.”")]), _vm._v(" "), _c('p', [_vm._v("“Yes, you are right but she is ready in her training. Helewise will make a good slayer and you will guide her.”")]), _vm._v(" "), _c('p', [_vm._v("“Saige, this is Hatmanu, he will be staying with us for a while.”")]), _vm._v(" "), _c('p', [_vm._v("“You were a slave and a prisoner. She tied you to your bed in the daytime and treated you bad at night. Tonight, she was going to kill you to get back at Garrett. And feed your body to the wild dogs after she fed from you.”")]), _vm._v(" "), _c('p', [_vm._v("“How do you know this?”")]), _vm._v(" "), _c('p', [_vm._v("“We’ve seen each other in our dreams, Hatmanu. You are my day dreamer?”")]), _vm._v(" "), _c('p', [_vm._v("“Yes, I only slept at daylight. Night time, I clean up after the dirty filthy creatures.”")]), _vm._v(" "), _c('p', [_vm._v("“Why did they keep you alive?”")]), _vm._v(" "), _c('p', [_vm._v("“If it wasn’t for my friend Garrett, I would be dead. He gave me my own room and gave me food that wasn’t rotten, where other vampires just wanted my blood to feed.”")]), _vm._v(" "), _c('p', [_vm._v("“Garrett was Sir Armando’s cousin before he changed. He looks like Armando. He could pass for his brother, only the eyes are different. Sir Armando’s eyes, Hatmanu, are blue and Garrett’s are turned black with evil.”")]), _vm._v(" "), _c('p', [_vm._v("“Ok, come along children it’s been a long day; we need food and sleep.”")]), _vm._v(" "), _c('p', [_vm._v("Meiga gave Hatmanu some hot chicken soup, bread, cheese and ginger cookies. Meiga had never seen anybody eat so fast before.")]), _vm._v(" "), _c('p', [_vm._v("“Have some more cookies and cheese, young man.”")]), _vm._v(" "), _c('p', [_vm._v("The hot tub of water was waiting for him.")]), _vm._v(" "), _c('p', [_vm._v("“Where did you live before you got captured by the vampires?”")]), _vm._v(" "), _c('p', [_vm._v("“I ran away from the orphanage. I’ve been living on the streets for years.”")]), _vm._v(" "), _c('p', [_vm._v("“You poor boy, you will be protected with us by my husband. But you must take a bath, Hatmanu.”")]), _vm._v(" "), _c('p', [_vm._v("“I have not taken a bath in years.”")]), _vm._v(" "), _c('p', [_vm._v("“I can tell that, my boy and you need one desperately.”")]), _vm._v(" "), _c('p', [_vm._v("“Why?”")]), _vm._v(" "), _c('p', [_vm._v("“Because you smell terrible.”")]), _vm._v(" "), _c('p', [_vm._v("“Ok, if it makes you happy.”")]), _vm._v(" "), _c('p', [_vm._v("Hatmanu stripped from his clothes and jumped into the tub. Meiga washed his dirty hair which was crawling with lice. She scraped his scalp until they were all dead. She dressed him in her husbands’ clothes that were now too small for him. Then made a bed for him by the fireplace.")]), _vm._v(" "), _c('p', [_vm._v("“You are fed, bathed and warm.” Meiga tucked him in and kissed him on the forehead. “You’ve had a tough time of it but now you are safe.”")]), _vm._v(" "), _c('p', [_vm._v("In two days, Roseabella’s brother Edder came for a visit.")]), _vm._v(" "), _c('p', [_vm._v("“It’s so good to see my sister. Roseabella, have you gained weight?”")]), _vm._v(" "), _c('p', [_vm._v("“Is it so noticeable?”")]), _vm._v(" "), _c('p', [_vm._v("“Edder, our sister is with child!”")]), _vm._v(" "), _c('p', [_vm._v("Edder took Roseabella up in his arms and swung her around.")]), _vm._v(" "), _c('p', [_vm._v("“Ok, my brother put me down, you are making me dizzy.”")]), _vm._v(" "), _c('p', [_vm._v("“Please have a boy, I’m tired of you girls.”")]), _vm._v(" "), _c('p', [_vm._v("“Well today, another girl quite young will train you with a spear.”")]), _vm._v(" "), _c('p', [_vm._v("“A girl that young can’t train a man like me!”")]), _vm._v(" "), _c('p', [_vm._v("“You can tell me that when we dine tonight. Now, you girls will train Hatmanu. Teach him everything you know.”")]), _vm._v(" "), _c('p', [_vm._v("“How old is he?”")]), _vm._v(" "), _c('p', [_vm._v("“I don’t know. He stayed with Meiga and her family last night.”")]), _vm._v(" "), _c('p', [_vm._v("“Who is this boy?”")]), _vm._v(" "), _c('p', [_vm._v("“Hatmanu was brought back from the vampire slaughter two days ago.”")]), _vm._v(" "), _c('p', [_vm._v("“We heard about the killings but not about a boy.”")]), _vm._v(" "), _c('p', [_vm._v("“He was a slave living with vampires.”")]), _vm._v(" "), _c('p', [_vm._v("“My god, what a terrible life.”")]), _vm._v(" "), _c('p', [_vm._v("“Yes, it was. Meiga has him cleaned up and he’s a different boy now than the one brought back two days ago. Ok everyone, finish your breakfast and meet me in the court yard.”")]), _vm._v(" "), _c('p', [_vm._v("“Good morning, Saige.”")]), _vm._v(" "), _c('p', [_vm._v("“Morning my lady.”")]), _vm._v(" "), _c('p', [_vm._v("“And how is Hatmanu?”")]), _vm._v(" "), _c('p', [_vm._v("“He’s good and he don’t smell bad anymore.”")]), _vm._v(" "), _c('p', [_vm._v("“The poor thing.”")]), _vm._v(" "), _c('p', [_vm._v("“Lady Roseabella, I have to tell you something about Hatmanu. Only reason they kept him alive was because of Garrett.”")]), _vm._v(" "), _c('p', [_vm._v("“What do you mean, Saige?”")]), _vm._v(" "), _c('p', [_vm._v("“He said Garrett befriended the boy, gave him good food when he was around and told the others, he would kill them if Hatmanu was harmed or changed into a vampire. When Garrett was away for days, he was treated badly by Morgania. We connected in our dreams sometimes, not a vision but in my dreams. She was going to drink all his blood and feed his body to wild dogs before Garrett returned.”")]), _vm._v(" "), _c('p', [_vm._v("“Morgania was one of the elders?”")]), _vm._v(" "), _c('p', [_vm._v("“Yes, she slept down in the basement with them in her casket. Morgania wants Garrett’s respect and love. But Garrett has no feelings for her.”")]), _vm._v(" "), _c('p', [_vm._v("“Then, there is some good left in him Saige.”")]), _vm._v(" "), _c('p', [_vm._v("“We can never trust him, my lady.”")]), _vm._v(" "), _c('p', [_vm._v("“Ok, today I want you to train my brother Edder with the spear.”")]), _vm._v(" "), _c('p', [_vm._v("“I would be honored, my lady.”")]), _vm._v(" "), _c('p', [_vm._v("“I’m keeping my sisters busy showing what they know to Hatmanu. Fresh air will do him good; he’s been sleeping too much. In comfort no doubt.”")]), _vm._v(" "), _c('p', [_vm._v("“Edder, I would like you to meet my friend Saige.” (My god everyone’s going to laugh at me, is this a joke?)")]), _vm._v(" "), _c('p', [_vm._v("“I will leave you to your practice.”")]), _vm._v(" "), _c('p', [_vm._v("“Armando, I have to talk to you.”")]), _vm._v(" "), _c('p', [_vm._v("“What is it, my wife?”")]), _vm._v(" "), _c('p', [_vm._v("“It’s about Hatmanu, the only reason he was alive is because of Garrett.”")]), _vm._v(" "), _c('p', [_vm._v("“Garrett?”")]), _vm._v(" "), _c('p', [_vm._v("“Yes, he kept him safe and when he wasn’t there, he threatened to kill anyone who harmed him. Garrett and Morgania have a relationship. She wants more but Garrett does not.”")]), _vm._v(" "), _c('p', [_vm._v("“Of course not because he wants what I got. Maybe she’ll kill him for us.”")]), _vm._v(" "), _c('p', [_vm._v("“We’re not that lucky, Armando.”")]), _vm._v(" "), _c('p', [_vm._v("He then put his hand on her stomach.")]), _vm._v(" "), _c('p', [_vm._v("“How is our little one?”")]), _vm._v(" "), _c('p', [_vm._v("“He’s making his mother fat.”")]), _vm._v(" "), _c('p', [_vm._v("“You’re not fat, just a little tummy.”")]), _vm._v(" "), _c('p', [_vm._v("“My brother noticed my weight gain before he knew I was with child.”")]), _vm._v(" "), _c('p', [_vm._v("“Here, my love, is a glass of lemon tea.”")]), _vm._v(" "), _c('p', [_vm._v("“Thank you, Armando.”")]), _vm._v(" "), _c('p', [_vm._v("“Your sisters are fond of my wine.”")]), _vm._v(" "), _c('p', [_vm._v("“Too fond like two little fish.”")]), _vm._v(" "), _c('p', [_vm._v("“They are enjoying their stay. They might not want to go home.”")]), _vm._v(" "), _c('p', [_vm._v("“But they are going, like it or not. I can’t take any more arguing.”")]), _vm._v(" "), _c('p', [_vm._v("“Here’s Edder. Would you like some wine?”")]), _vm._v(" "), _c('p', [_vm._v("“Yes please.”")]), _vm._v(" "), _c('p', [_vm._v("“I will be back with a glass.”")]), _vm._v(" "), _c('p', [_vm._v("“So brother, how was your spear training?”")]), _vm._v(" "), _c('p', [_vm._v("“My god, never have I seen anyone so fast before. The way she holds herself is like a warrior.”")]), _vm._v(" "), _c('p', [_vm._v("“She turns after her grandfather; he’s been training her since she was old enough to walk.”")]), _vm._v(" "), _c('p', [_vm._v("“Here’s your wine, Edder.”")]), _vm._v(" "), _c('p', [_vm._v("“Let’s drink to my future nephew!”")]), _vm._v(" "), _c('p', [_vm._v("“He doesn’t drink, dear brother and I’m afraid he won’t drink until he has grown up!”")]), _vm._v(" "), _c('p', [_vm._v("“So Armando, any plans to kill the old vampires?”")]), _vm._v(" "), _c('p', [_vm._v("“They might be old but very strong and smart. They are used to luxury, so I don’t think they are living in caves.”")]), _vm._v(" "), _c('p', [_vm._v("“Where could they be? Who could they be with?”")]), _vm._v(" "), _c('p', [_vm._v("“The vampire Morgania.”")]), _vm._v(" "), _c('p', [_vm._v("“Oh, right, the smart one who got away.”")]), _vm._v(" "), _c('p', [_vm._v("“Maybe they left the country. Or they could be out tonight making replacements. If they are, then we need to search every abandon building.”")]), _vm._v(" "), _c('p', [_vm._v("“How did Hatmanu do today, girls?”")]), _vm._v(" "), _c('p', [_vm._v("“He caught on fast. He’s a little shy and jumpy.”")]), _vm._v(" "), _c('p', [_vm._v("“And so would you Ardelean, if you lived with vamps for two years.”")]), _vm._v(" "), _c('p', [_vm._v("“I’m just telling Roseabella what I noticed about the poor lad. You’re the one who’s got a crush on him.”")]), _vm._v(" "), _c('p', [_vm._v("“I do not have a crush on him, he needs friends.”")]), _vm._v(" "), _c('p', [_vm._v("“How old is he anyway?”")]), _vm._v(" "), _c('p', [_vm._v("“He thinks he’s twelve. He’d been living on the streets when the vamps captured him.”")]), _vm._v(" "), _c('p', [_vm._v("“Wherever you are Hatmanu, I hope they treat you well. I’m glad they are all dead. What are you doing on my ship, Morgania?”")]), _vm._v(" "), _c('p', [_vm._v("“Your ship?”")]), _vm._v(" "), _c('p', [_vm._v("“My parents bought it for me before I was changed into a vamp.”")]), _vm._v(" "), _c('p', [_vm._v("“Well, I’m looking for new living quarters for the Elders.”")]), _vm._v(" "), _c('p', [_vm._v("“I had to kill six of my sailors already, they came on my ship last night who were turned to vamps.”")]), _vm._v(" "), _c('p', [_vm._v("“Why would you kill our kind?”")]), _vm._v(" "), _c('p', [_vm._v("“They make useless fucking sailors!”")]), _vm._v(" "), _c('p', [_vm._v("“I like your sense of humor, Garrett. If you don’t take us on your boat, the Elders will kill you and your sailors.”")]), _vm._v(" "), _c('p', [_vm._v("“Let them try.”")]), _vm._v(" "), _c('p', [_vm._v("“We are too strong for you to kill us, Garrett. I could kill you now if I wanted to.”")]), _vm._v(" "), _c('p', [_vm._v("“Why don’t you try, Morgania?”")]), _vm._v(" "), _c('p', [_vm._v("She hit Garrett down on the deck so fast, he never had a chance with a knife touching his throat.")]), _vm._v(" "), _c('p', [_vm._v("“Do you want to die now?”")]), _vm._v(" "), _c('p', [_vm._v("“What do you want from me?”")]), _vm._v(" "), _c('p', [_vm._v("“I like you Garrett, we are good together. And I turned you, so we could live forever!” (If she knew how much I despised her she would end me now)")]), _vm._v(" "), _c('p', [_vm._v("“Ok, let me up Morgania, you and the Elders can stay down the bottom of the ship where we keep our supplies. We’ll go to another port. And you and the Elders do not touch my sailors. Unless they can work on the boat in the daylight.”")]), _vm._v(" "), _c('p', [_vm._v("“And how will we feed?”")]), _vm._v(" "), _c('p', [_vm._v("“Why not raw fish?”")]), _vm._v(" "), _c('p', [_vm._v("“Very funny, Garrett.”")]), _vm._v(" "), _c('p', [_vm._v("“When it’s dark, you can use the row boat, do not bring back any new vampires.”")]), _vm._v(" "), _c('p', [_vm._v("“You need to feed as well, Garrett.”")]), _vm._v(" "), _c('p', [_vm._v("“I have skins of pigs and cows’ blood on ice below deck.”")]), _vm._v(" "), _c('p', [_vm._v("“Ice this time of year?”")]), _vm._v(" "), _c('p', [_vm._v("“Yes, we take it from ice bergs and cover it in saw dust. It lasts for months.”")]), _vm._v(" "), _c('p', [_vm._v("“You go get the Elders and tell them these are my rules.”")]), _vm._v(" "), _c('p', [_vm._v("“They’re at the castle digging up their money and jewels. They are very rich Garrett; we could sail to a new country and start over.”")]), _vm._v(" "), _c('p', [_vm._v("“And then feed on the homeless and the convicts at our new port. Do not change them that is why you are hunted down. Too many fucking brainless vampires!”")]), _vm._v(" "), _c('p', [_vm._v("“Yes, I will talk to the others, Garrett; you are right, we need to make changes to survive. I will go get the others.”")]), _vm._v(" "), _c('p', [_vm._v("“I will learn from the Elders how to be strong and the fastest and the best fighter of all, then I will kill them all!” (Morgania, I will throw you in the sunlight and watch you burn and scream)")]), _vm._v(" "), _c('p', [_vm._v("“It’s been a month Armando, since my brother and two sisters left.”")]), _vm._v(" "), _c('p', [_vm._v("“Do you miss them, Roseabella?”")]), _vm._v(" "), _c('p', [_vm._v("“Yes, but not their niggling. They are coming tomorrow for my party.”")]), _vm._v(" "), _c('p', [_vm._v("“You will be eighteen, my love, having your first birthday party!”")]), _vm._v(" "), _c('p', [_vm._v("“Oh Armando, if I knew I was going to be this fat, there wouldn’t be a party.”")]), _vm._v(" "), _c('p', [_vm._v("“My wife, I love your big beautiful breasts and I love to kiss your hard rounded belly, which is not that big.”")]), _vm._v(" "), _c('p', [_vm._v("“Thank you, Armando.”")]), _vm._v(" "), _c('p', [_vm._v("“Wait, I just felt a movement just for a second.”")]), _vm._v(" "), _c('p', [_vm._v("“I do love being pregnant Armando, I can’t wait to feel the baby kicking and moving inside of me. Everyone tells me how lucky I am, not to be having morning sickness.”")]), _vm._v(" "), _c('p', [_vm._v("“I’m glad too, I couldn’t bear seeing you miserable.”")]), _vm._v(" "), _c('p', [_vm._v("“So, your sister has everything under control?”")]), _vm._v(" "), _c('p', [_vm._v("“Yes, she does.”")]), _vm._v(" "), _c('p', [_vm._v("“She must let my sister’s help decorate.”")]), _vm._v(" "), _c('p', [_vm._v("“I’m sure she will.”")]), _vm._v(" "), _c('p', [_vm._v("“They don’t always see eye to eye.”")]), _vm._v(" "), _c('p', [_vm._v("“It’s been a month, people change.”")]), _vm._v(" "), _c('p', [_vm._v("“I do hope so. Armando, I would like Gerrold, Meiga, Saige and Hatmanu to attend my party. He’s a good friend of yours, Armando and high up in rank. Saige turned eleven last week and she needs to dress up like a girl sometimes and learn to dance.”")]), _vm._v(" "), _c('p', [_vm._v("“Yes, you are right my love, I will drop them off an invitation.”")]), _vm._v(" "), _c('p', [_vm._v("“Yes and make sure all four names are on it. Armando, do you think the vampires are gone for good?”")]), _vm._v(" "), _c('p', [_vm._v("“I don’t know, there’s been no killings lately. They could have left the country. But there is still Garrett who’s out there waiting for his chance. I don’t want to upset you in your condition Roseabella but we must not let our guard down.”")]), _vm._v(" "), _c('p', [_vm._v("“Yes of course dear. I’m going to take a nap; would you like to join me, husband?”")]), _vm._v(" "), _c('p', [_vm._v("“Certainly, I can’t wait to get my hands on your big breasts. We must hurry, its growing hard already.”")]), _vm._v(" "), _c('p', [_vm._v("Her parents arrived at lunch time.")]), _vm._v(" "), _c('p', [_vm._v("“Why don’t you and the girls go for a nap mother, it’s going to be a long day for everyone.”")]), _vm._v(" "), _c('p', [_vm._v("“You are right Roseabella, I am tired.”")]), _vm._v(" "), _c('p', [_vm._v("“I take two naps a day, mother.”")]), _vm._v(" "), _c('p', [_vm._v("“You look so healthy, my dear. And I am so glad you don’t have the morning sickness. I lived on dried-out bread and milk for three months with all my children, after that I couldn’t stop eating.”")]), _vm._v(" "), _c('p', [_vm._v("“Mother, I have such a big appetite. I’m afraid I’m going to gain so much weight, that I’ll never lose it.”")]), _vm._v(" "), _c('p', [_vm._v("“Oh, you will with all the training you will be doing again.”")]), _vm._v(" "), _c('p', [_vm._v("“I still do training with the women mother and ride my horse Cloud.”")]), _vm._v(" "), _c('p', [_vm._v("“It’s not proper for a young lady with child doing those things.”")]), _vm._v(" "), _c('p', [_vm._v("“I don’t overdo it mother, no more hitting the ground or kicking. Just walking my laps and spear throwing.”")]), _vm._v(" "), _c('p', [_vm._v("“Cut out the spear throwing, daughter.”")]), _vm._v(" "), _c('p', [_vm._v("“Yes mother and don’t you think the girls are doing a good job with their training?”")]), _vm._v(" "), _c('p', [_vm._v("“They dress up as same as their brother, how are they ever going to find a husband?”")]), _vm._v(" "), _c('p', [_vm._v("“Mother, they are still young.”")]), _vm._v(" "), _c('p', [_vm._v("“Ardelean will be 15 next month and Gretta thirteen; tonight, we must look for some suitable young man for her. She is always bored and picking on poor Gretta!”")]), _vm._v(" "), _c('p', [_vm._v("“Yes, I noticed that too mother. Those two need some time apart.”")]), _vm._v(" "), _c('p', [_vm._v("“Yes, I could use a break.”")]), _vm._v(" "), _c('p', [_vm._v("“I will see you tonight mother, at the party.”")]), _vm._v(" "), _c('p', [_vm._v("Roseabella laid down on top of her bed and fell asleep instantly.")]), _vm._v(" "), _c('p', [_vm._v("“Soon Roseabella, we will be together just the three of us. Happy birthday, my love.”")]), _vm._v(" "), _c('p', [_vm._v("She woke up, frightened.")]), _vm._v(" "), _c('p', [_vm._v("“You will not have me and my baby. We belong to Armando.”")]), _vm._v(" "), _c('p', [_vm._v("“Who are you talking to, Roseabella?”")]), _vm._v(" "), _c('p', [_vm._v("“I had a nightmare and sometimes I talk in my sleep.”")]), _vm._v(" "), _c('p', [_vm._v("“Are you alright?”")]), _vm._v(" "), _c('p', [_vm._v("“Yes and I can’t remember my dream. Lie back and get some rest, tonight we are going to do some dancing!”")]), _vm._v(" "), _c('p', [_vm._v("“Yes, can’t wait.”")]), _vm._v(" "), _c('p', [_vm._v("Roseabella’s family were waiting with other guests in the ballroom.")]), _vm._v(" "), _c('p', [_vm._v("“Roseabella, you look wonderful in that dress.”")]), _vm._v(" "), _c('p', [_vm._v("“The seamstress had to make it a little bit bigger in the stomach and around my breasts.”")]), _vm._v(" "), _c('p', [_vm._v("“Your breasts, my dear, look wonderful too.”")]), _vm._v(" "), _c('p', [_vm._v("“You, Armando, are a good husband.”")]), _vm._v(" "), _c('p', [_vm._v("Helewise and everyone sung out:")]), _vm._v(" "), _c('p', [_vm._v("“Happy birthday Roseabella!”")]), _vm._v(" "), _c('p', [_vm._v("Everyone gathered around her.")]), _vm._v(" "), _c('p', [_vm._v("“I would like to make a toast to my beautiful daughter Roseabella. You make us proud, daughter and we are looking forward to becoming grandparents.”")]), _vm._v(" "), _c('p', [_vm._v("Meiga brought over a goblet of lemon tea.")]), _vm._v(" "), _c('p', [_vm._v("“Thank you, father and also you, Meiga for the lemon tea.”")]), _vm._v(" "), _c('p', [_vm._v("“Glad to make it for you, my dear.”")]), _vm._v(" "), _c('p', [_vm._v("“How’s young Hatmanu doing? If he’s too much, some others can take him in.”")]), _vm._v(" "), _c('p', [_vm._v("“He’s no bother my lady, he cleans up after himself. He gets on good with Saige and has a job looking after the horses. My husband taught him to ride. Not a day goes by that he doesn’t go riding.”")]), _vm._v(" "), _c('p', [_vm._v("“I love your dress, Meiga.”")]), _vm._v(" "), _c('p', [_vm._v("“My husband went into town this morning and took Saige and Hatmanu with him. They all came back with new clothes and this dress for me. At first, I was mad for spending coin. But after everyone was all dressed up, I had me a cry my lady. I was so proud of my family, everyone looking so smart.”")]), _vm._v(" "), _c('p', [_vm._v("“Yes, they certainly do Meiga. Saige looks so pretty in that dress and with her hair done up like that, makes her look so mature.”")]), _vm._v(" "), _c('p', [_vm._v("“It was a hard time getting her into a dress, my lady. Hatmanu is such a good-looking young man. After I cleaned him up, I couldn’t believe my eyes. He has blond hair and good features.”")]), _vm._v(" "), _c('p', [_vm._v("“He and Saige could pass for brother and sister.”")]), _vm._v(" "), _c('p', [_vm._v("“That’s what I thought too, my lady. If you will excuse me my lady, I will go and keep the children away from the wine.”")]), _vm._v(" "), _c('p', [_vm._v("“Roseabella, you look like a queen tonight.”")]), _vm._v(" "), _c('p', [_vm._v("“Thank you, Edder.”")]), _vm._v(" "), _c('p', [_vm._v("“I miss you so much around our castle, Roseabella. My father takes me out more. But when I’m home, I am always separating the girls. They are always fighting.”")]), _vm._v(" "), _c('p', [_vm._v("“You don’t have to worry much longer; mother is looking for a husband for Ardelean.”")]), _vm._v(" "), _c('p', [_vm._v("“Already?”")]), _vm._v(" "), _c('p', [_vm._v("“Yes, she can’t take any more of the arguing either. She is looking for some rich person tonight.”")]), _vm._v(" "), _c('p', [_vm._v("“Poor Ardelean.”")]), _vm._v(" "), _c('p', [_vm._v("“May I have everyone’s attention please, the music will begin. The first dance is for my brother and his wife, Roseabella.”")]), _vm._v(" "), _c('p', [_vm._v("Armando took her hand and led her to the dance floor. He spun her around the dance floor so gently. He lifted up his arms to the new steps. Then hooked his arms in hers and went around in a circle, then they changed arms and went in a circle again. When the music stopped, everyone clapped.")]), _vm._v(" "), _c('p', [_vm._v("“Thank you, my beautiful wife.”")]), _vm._v(" "), _c('p', [_vm._v("“Thank you, Armando you are a good dancer.”")]), _vm._v(" "), _c('p', [_vm._v("“May I have this dance with my daughter?”")]), _vm._v(" "), _c('p', [_vm._v("“Of course and I shall dance with the Duchess.”")]), _vm._v(" "), _c('p', [_vm._v("Helewise was dancing with Edder.")]), _vm._v(" "), _c('p', [_vm._v("“You look very pretty, Helewise.”")]), _vm._v(" "), _c('p', [_vm._v("“Thank you. And you are a good dancer, Edder.”")]), _vm._v(" "), _c('p', [_vm._v("“I learn fast, just a few days ago my mother taught me. And I’m glad she did, I didn’t want the other men keeping you on the dance floor.”")]), _vm._v(" "), _c('p', [_vm._v("“Are you flirting with me, Edder?”")]), _vm._v(" "), _c('p', [_vm._v("“I don’t know, am I?”")]), _vm._v(" "), _c('p', [_vm._v("“Edder, you are a breath of fresh air!”")]), _vm._v(" "), _c('p', [_vm._v("“Are you flirting with me now, Helewise?”")]), _vm._v(" "), _c('p', [_vm._v("“You make me laugh Edder, you are not stuffy like some men. All they talk about is how rich they’re going to be and how many horses they have.”")]), _vm._v(" "), _c('p', [_vm._v("“Talking of horses, would you accompany me tomorrow for a ride before we leave?”")]), _vm._v(" "), _c('p', [_vm._v("“Sounds wonderful.”")]), _vm._v(" "), _c('p', [_vm._v("Someone else cut in on the dance. Edder went over to Gretta.")]), _vm._v(" "), _c('p', [_vm._v("“Would you like to dance, little sister?”")]), _vm._v(" "), _c('p', [_vm._v("“I certainly would, I hate standing here while my sister hasn’t gotten off the dance floor.”")]), _vm._v(" "), _c('p', [_vm._v("They all lined up on the dance floor. Men and women opposite each other. The man and the woman at the beginning would start first. And he would then dance her around in circles in a fast speed to the end of the line and the next couple in the line would do the same. When the music stopped, everyone was out of breath.")]), _vm._v(" "), _c('p', [_vm._v("“I’m not much of a dancer, Saige. Edder showed me a few moves today.”")]), _vm._v(" "), _c('p', [_vm._v("“I’m not either, Gretta kept me up all night showing me.”")]), _vm._v(" "), _c('p', [_vm._v("“You want to give it a try?”")]), _vm._v(" "), _c('p', [_vm._v("“I guess so. This dance doesn’t look so hard.”")]), _vm._v(" "), _c('p', [_vm._v("Hatmanu took her on the dance floor. He looked at the men and followed. Saige looked at the ladies and did the same thing.")]), _vm._v(" "), _c('p', [_vm._v("“I’d rather be horseback riding, Saige.”")]), _vm._v(" "), _c('p', [_vm._v("“Yes me too. But it’s not so bad. I like the jumping and waltzing around fast.”")]), _vm._v(" "), _c('p', [_vm._v("Hatmanu twirled her around, she looked like a young angel.")]), _vm._v(" "), _c('p', [_vm._v("“Thank you Hatmanu.”")]), _vm._v(" "), _c('p', [_vm._v("“Hatmanu, I didn’t know you could dance.”")]), _vm._v(" "), _c('p', [_vm._v("“I just learned a few steps today.”")]), _vm._v(" "), _c('p', [_vm._v("Gretta took him by the hand and pulled him to the dance floor.")]), _vm._v(" "), _c('p', [_vm._v("“You sure are quick on your feet for a beginner.”")]), _vm._v(" "), _c('p', [_vm._v("“Thanks Gretta. You are a skilled dancer yourself.”")]), _vm._v(" "), _c('p', [_vm._v("“Mother taught us to dance a few months ago when we found out about Roseabella’s birthday party. I am glad you got an invite, Hatmanu.”")]), _vm._v(" "), _c('p', [_vm._v("“I didn’t want to go but I did not want to disappoint Meiga. She’s been so good to me.”")]), _vm._v(" "), _c('p', [_vm._v("“I’m glad you came.”")]), _vm._v(" "), _c('p', [_vm._v("“So am I. It’s not so bad when you got friends around you.”")]), _vm._v(" "), _c('p', [_vm._v("The music stopped.")]), _vm._v(" "), _c('p', [_vm._v("“Everyone, finger foods are laid out on the table. Help yourself to the food and fill your goblets with more wine and stronger spirits. Helewise, I would like to thank you for a wonderful party. It couldn’t be lovelier. Thanks, Roseabella, your sisters and Saige helped with the decorations.”")]), _vm._v(" "), _c('p', [_vm._v("“How did you get those flowers strung up everywhere?”")]), _vm._v(" "), _c('p', [_vm._v("“Saige showed us how to wrap grape vines around them.”")]), _vm._v(" "), _c('p', [_vm._v("“What a good idea, we can do the same for your birthday.”")]), _vm._v(" "), _c('p', [_vm._v("“Yes of course.”")]), _vm._v(" "), _c('p', [_vm._v("“Helewise, would you like to dance again?”")]), _vm._v(" "), _c('p', [_vm._v("“Yes, I would Edder.” (I think she will break my brother’s heart. She is a spoiled child who will always want her own way)")]), _vm._v(" "), _c('p', [_vm._v("Gretta was having a good time, Hatmanu looked red in the face from dancing with her for so long.")]), _vm._v(" "), _c('p', [_vm._v("“Darling I’m getting tired; would you mind if I sneaked off?”")]), _vm._v(" "), _c('p', [_vm._v("“Only if you don’t take me with you. Helewise is here to keep everyone entertained. Let’s say goodnight to your parents and take a plate of food with us.”")]), _vm._v(" "), _c('p', [_vm._v("“You are right, I’m still hungry.”")]), _vm._v(" "), _c('p', [_vm._v("“Lady Roseabella, I have a birthday gift for you.”")]), _vm._v(" "), _c('p', [_vm._v("“Oh, Saige you didn’t have to.”")]), _vm._v(" "), _c('p', [_vm._v("“I wanted to. I made it myself.”")]), _vm._v(" "), _c('p', [_vm._v("Roseabella unwrapped the piece of cloth.")]), _vm._v(" "), _c('p', [_vm._v("“Oh, Saige you made this for me? It’s such a beautiful cross.”")]), _vm._v(" "), _c('p', [_vm._v("“My grandfather taught me how to whittle and on the back side I carved your name and burned the letters afterwards.”")]), _vm._v(" "), _c('p', [_vm._v("“It’s beautiful, how did you get the rawhide red?”")]), _vm._v(" "), _c('p', [_vm._v("“I soaked it in beet juice and dried it over the fire.”")]), _vm._v(" "), _c('p', [_vm._v("“You are a special girl, Saige. You must remember that always even if I’m not around.”")]), _vm._v(" "), _c('p', [_vm._v("“Where will you be?”")]), _vm._v(" "), _c('p', [_vm._v("“I don’t know for sure, we could be visiting new places.”")]), _vm._v(" "), _c('p', [_vm._v("“Have you dreamed about Garrett again? Please tell me, my lady.”")]), _vm._v(" "), _c('p', [_vm._v("“Yes, Saige he told me he’ll be coming soon for me and the baby. Armando must not know, he worries too much already. And I will put up a good fight and kill him myself.”")]), _vm._v(" "), _c('p', [_vm._v("“Keep your cross on and wear it every day. I will have a vision after the baby is born, I’m sure.”")]), _vm._v(" "), _c('p', [_vm._v("“Good night, my little angel.”")]), _vm._v(" "), _c('p', [_vm._v("“Thank you so much for inviting my family. My grandparents were honored.”")]), _vm._v(" "), _c('p', [_vm._v("“Good night, Saige.”")]), _vm._v(" "), _c('p', [_vm._v("“I see you have a big plateful.”")]), _vm._v(" "), _c('p', [_vm._v("“We are eating for three, you, baby and me.”")]), _vm._v(" "), _c('p', [_vm._v("Hatmanu hid away on the balcony from Gretta, he had enough dancing and it was so hot in this dress up clothes. He noticed the guards were playing cards or asleep, they must think we are no longer in danger. No vampire sightings. Hatmanu looked out at the beautiful fields. And he saw someone.")]), _vm._v(" "), _c('p', [_vm._v("As the man came closer; “My god, its Garrett. Why, why now? Don’t make me go back with you.”")]), _vm._v(" "), _c('p', [_vm._v("He stood there, smiled and waved goodbye. Hatmanu smiled back and said.")]), _vm._v(" "), _c('p', [_vm._v("“Goodbye Garrett, you were my only friend when I needed one. I have a new family now.”")]), _vm._v(" "), _c('p', [_vm._v("“Who are you talking to?”")]), _vm._v(" "), _c('p', [_vm._v("“Oh Saige, I thought you were Gretta. I had to get away. How can those men dance in these clothes?”")]), _vm._v(" "), _c('p', [_vm._v("“They must get used to it. So, who were you talking to?”")]), _vm._v(" "), _c('p', [_vm._v("“No one.”")]), _vm._v(" "), _c('p', [_vm._v("“You were saying goodbye to someone.”")]), _vm._v(" "), _c('p', [_vm._v("“I was not.”")]), _vm._v(" "), _c('p', [_vm._v("“And why are you lying to me, Hatmanu?”")]), _vm._v(" "), _c('p', [_vm._v("“Keep your voice down, for gods’ sake. I was saying goodbye to Garrett. He was outside the gate.”")]), _vm._v(" "), _c('p', [_vm._v("“Why didn’t you call the guards?”")]), _vm._v(" "), _c('p', [_vm._v("“He came and waved good bye. He looked happy for me.”")]), _vm._v(" "), _c('p', [_vm._v("“He wants Roseabella and her baby.”")]), _vm._v(" "), _c('p', [_vm._v("“Garrett would not do that!”")]), _vm._v(" "), _c('p', [_vm._v("“Yes, he would, he wants a blood line to carry on until eternity. And with his cousin’s child, he will have it.”")]), _vm._v(" "), _c('p', [_vm._v("“No, you are wrong. I think he’s leaving Transylvania.”")]), _vm._v(" "), _c('p', [_vm._v("“For Roseabella’s sake, I hope you are right.”")]), _vm._v(" "), _c('p', [_vm._v("“Young Hatmanu, what a sight you make standing on the ballroom’s balcony. All dressed up, running away from girls. You have grown a foot since I last saw you. Now, I know who killed all the vampires. My cousin is becoming a great slayer. I’m getting stronger every day and faster.")]), _vm._v(" "), _c('p', [_vm._v("I have a private island picked out for your wife and son. My sailors and carpenters are there now, building me an estate. Your family will learn to love me. I’ll take good care of them. I’ll be back for them on Roseabella’s next birthday.”")]), _vm._v(" "), _c('p', [_vm._v("“Armando, it’s been four months since my family came for a visit.”")]), _vm._v(" "), _c('p', [_vm._v("“Yes, it’s been a while.”")]), _vm._v(" "), _c('p', [_vm._v("“In two months, I will give birth.”")]), _vm._v(" "), _c('p', [_vm._v("“And that’s what they are waiting for my dear. They know you need your rest and quietness.”")]), _vm._v(" "), _c('p', [_vm._v("“Armando, why are you laughing?”")]), _vm._v(" "), _c('p', [_vm._v("“I was thinking about Gretta. On your birthday party, poor Hatmanu was trying to get off the dance floor. Gretta kept pulling him back. The poor devil was sore and hot, I thought he was going to pass out.”")]), _vm._v(" "), _c('p', [_vm._v("“Oh, Armando if I don’t stop laughing, I’m going to pee in my bloomers.”")]), _vm._v(" "), _c('p', [_vm._v("“Ok my dear, I have work to do. And what are you going to do for the rest of the day?”")]), _vm._v(" "), _c('p', [_vm._v("“Oh, Meiga is going to teach me how to knit a baby blanket.”")]), _vm._v(" "), _c('p', [_vm._v("“You my darling, don’t seem like the knitting type.”")]), _vm._v(" "), _c('p', [_vm._v("“Why Armando, I’ll knit a baby’s blanket and a blanket for you, my husband.”")]), _vm._v(" "), _c('p', [_vm._v("“I’ll look forward to that my dear when the snow comes.”")]), _vm._v(" "), _c('p', [_vm._v("“I’m not catching on, am I Meiga?”")]), _vm._v(" "), _c('p', [_vm._v("“It takes a lot of practice, my lady.”")]), _vm._v(" "), _c('p', [_vm._v("“Now ribble it out again and start over. This time, just put on ten stitches. Good, now take them off with your other needle.”")]), _vm._v(" "), _c('p', [_vm._v("“Like this?”")]), _vm._v(" "), _c('p', [_vm._v("“Yes, my lady. Now, take them off on the other needle again. My lady, you are doing fine. Keep on going, you’ll soon have a scarf for Armando for Christmas.”")]), _vm._v(" "), _c('p', [_vm._v("“Thanks for having patience with me, Meiga.”")]), _vm._v(" "), _c('p', [_vm._v("“I know you’re an outside girl but winter can be long and it’s nice to keep you busy while you’re waiting to give birth.”")]), _vm._v(" "), _c('p', [_vm._v("“Meiga, can you order some tea and scones for us to snack on? And some of that raspberry jam and clotted cream? I’d get up but I feel too heavy to.”")]), _vm._v(" "), _c('p', [_vm._v("“Yes, my lady I’ll be right back.”")]), _vm._v(" "), _c('p', [_vm._v("“Meiga, what happened to the maid?”")]), _vm._v(" "), _c('p', [_vm._v("“Nowhere to be seen. Let me pour your tea.”")]), _vm._v(" "), _c('p', [_vm._v("Meiga split opened the scone and heaped on raspberry jam and cream.")]), _vm._v(" "), _c('p', [_vm._v("“Oh my god, this is so good. The scone is melting in my mouth, Meiga you are such a good cook. Can I have another one?”")]), _vm._v(" "), _c('p', [_vm._v("“Take your time my lady, you won’t want to get gas.”")]), _vm._v(" "), _c('p', [_vm._v("“I wish I could eat slowly; I am such a pig.”")]), _vm._v(" "), _c('p', [_vm._v("“My lady, you are blooming. I have never seen such a pleasant woman with child. You have only weight on your stomach. It shows Roseabella, you are going to have a big healthy boy.”")]), _vm._v(" "), _c('p', [_vm._v("“I’ll eat to that!”")]), _vm._v(" "), _c('p', [_vm._v("Ardelean enjoyed all the young men’s attention that they were showering on her. Her mother decided they needed a few dinner parties since the vampires disappeared.")]), _vm._v(" "), _c('p', [_vm._v("“Do you like any of those young men, Ardelean?”")]), _vm._v(" "), _c('p', [_vm._v("“Some I do mother but there’s not the right one yet.”")]), _vm._v(" "), _c('p', [_vm._v("“What do you call the right one, daughter?”")]), _vm._v(" "), _c('p', [_vm._v("“Well mother, he’s got to be handsome, in good shape, rich and of course, a good rider. One thing I left out mother, he’s got to be a good warrior.”")]), _vm._v(" "), _c('p', [_vm._v("“My dear, you are going to look for an older gentleman.”")]), _vm._v(" "), _c('p', [_vm._v("“And that’s what I want mother, someone like Armando. He swept Roseabella off her feet in two hours. It was love at first sight.”")]), _vm._v(" "), _c('p', [_vm._v("“You’re telling me that those young men coming here every day, you have no interest in?”")]), _vm._v(" "), _c('p', [_vm._v("“I like their gifts, mother and rides in their carriages.”")]), _vm._v(" "), _c('p', [_vm._v("“I give up on you, daughter. Older men won’t be interested in you until you are seventeen. They’ll waste no time on a girl your age.”")]), _vm._v(" "), _c('p', [_vm._v("“Oh mother, any rich man will want me old or young.”")]), _vm._v(" "), _c('p', [_vm._v("“There will not be any more days out with those young men!”")]), _vm._v(" "), _c('p', [_vm._v("“Why not?”")]), _vm._v(" "), _c('p', [_vm._v("“You are using them and making a name for yourself.”")]), _vm._v(" "), _c('p', [_vm._v("“Mother please, I just like having fun, and I won’t marry until love at first sight.”")]), _vm._v(" "), _c('p', [_vm._v("“Oh my sister, no one has offered for your hand in marriage.”")]), _vm._v(" "), _c('p', [_vm._v("“Yes, they have asked me my hand in marriage when I turn seventeen. I will not have a long-term engagement with any man.”")]), _vm._v(" "), _c('p', [_vm._v("“And you are wasting mother’s time when she is trying to get rid of you.”")]), _vm._v(" "), _c('p', [_vm._v("“You are jealous Gretta because I’m getting so many men interested in me.”")]), _vm._v(" "), _c('p', [_vm._v("“They just want our father’s money Ardelean, haven’t you caught on yet?”")]), _vm._v(" "), _c('p', [_vm._v("“And you Gretta, are the worst sister anyone could have.”")]), _vm._v(" "), _c('p', [_vm._v("Roseabella was now in her ninth month of the pregnancy; her feet and hands were swollen. She kept away from salty foods.")]), _vm._v(" "), _c('p', [_vm._v("“How are you feeling, wife?”")]), _vm._v(" "), _c('p', [_vm._v("“I have a little pain down below in my back.”")]), _vm._v(" "), _c('p', [_vm._v("“Should I get the midwife?”")]), _vm._v(" "), _c('p', [_vm._v("“No, it’s nothing, it comes and goes. You need to train your new men.”")]), _vm._v(" "), _c('p', [_vm._v("“Send out a rider when you are ready to give birth.”")]), _vm._v(" "), _c('p', [_vm._v("“Of course, I will. Go now!”")]), _vm._v(" "), _c('p', [_vm._v("Roseabella was feeling restless and overweight.")]), _vm._v(" "), _c('p', [_vm._v("“It’s time little one to come into this world.”")]), _vm._v(" "), _c('p', [_vm._v("“Sorry to interrupt you my lady, your family is here to see you.”")]), _vm._v(" "), _c('p', [_vm._v("Her mother, father, two sisters and her brother walked in through the door.")]), _vm._v(" "), _c('p', [_vm._v("“Oh, my dear daughter we could not stay away any longer.”")]), _vm._v(" "), _c('p', [_vm._v("“And I’m so happy to see all of you.”")]), _vm._v(" "), _c('p', [_vm._v("“Roseabella, your stomach is so huge.”")]), _vm._v(" "), _c('p', [_vm._v("“Thank you Gretta, you know how to make a person happy.”")]), _vm._v(" "), _c('p', [_vm._v("“Yeah Gretta, our sister knows how big she is.”")]), _vm._v(" "), _c('p', [_vm._v("“Thank you too, Ardelean. You two really know how to cheer a person up. You two go and see Saige and get caught up with your training.”")]), _vm._v(" "), _c('p', [_vm._v("“What can we do for you, daughter?”")]), _vm._v(" "), _c('p', [_vm._v("“Oh, I’m sorry mother and father, why don’t we take a walk around the castle, I need some exercise. Where is Edder? He did not come?”")]), _vm._v(" "), _c('p', [_vm._v("“Yes, he did but he met up with Helewise on the way in, he’s taking a liking to her.”")]), _vm._v(" "), _c('p', [_vm._v("“It’s just puppy love, mother.”")]), _vm._v(" "), _c('p', [_vm._v("“Your brother is seventeen and Helewise is sixteen.”")]), _vm._v(" "), _c('p', [_vm._v("“Men don’t marry, mother until they’re twenty anymore.”")]), _vm._v(" "), _c('p', [_vm._v("“I hope you are right. He could do a lot worse though.” Mentioned father. “I’ll go and have a chat with Armando, if you will excuse me.”")]), _vm._v(" "), _c('p', [_vm._v("“Men always run away from problems.”")]), _vm._v(" "), _c('p', [_vm._v("“Mother, did you find it hard giving birth?”")]), _vm._v(" "), _c('p', [_vm._v("“No, I didn’t and that’s why I had four.”")]), _vm._v(" "), _c('p', [_vm._v("“I’m so glad you came, mother. Why is there water running down my legs?”")]), _vm._v(" "), _c('p', [_vm._v("“Your water has broken.”")]), _vm._v(" "), _c('p', [_vm._v("“What does that mean?”")]), _vm._v(" "), _c('p', [_vm._v("“It means you’re in labor! Let’s get you back in bed, my darling and it will be all over soon.”")]), _vm._v(" "), _c('p', [_vm._v("Roseabella laid down in her bed with a blanket folded up under her. She kept a thin blanket on top of her.")]), _vm._v(" "), _c('p', [_vm._v("“The baby is in the right position, it won’t be long now.”")]), _vm._v(" "), _c('p', [_vm._v("“Is Armando outside the door?”")]), _vm._v(" "), _c('p', [_vm._v("“Yes, he is out there with your father and brother. Your two sisters and Helewise are over there in the corner.”")]), _vm._v(" "), _c('p', [_vm._v("“It hurts so much.”")]), _vm._v(" "), _c('p', [_vm._v("“Take deep breaths, breath in through your nose and let it out slowly. That’s a good girl. In and out.”")]), _vm._v(" "), _c('p', [_vm._v("Roseabella was crying out in pain for six hours.")]), _vm._v(" "), _c('p', [_vm._v("“I need to push, mother.”")]), _vm._v(" "), _c('p', [_vm._v("“Ok, first you sit up. Helewise, put all the pillows behind her back.”")]), _vm._v(" "), _c('p', [_vm._v("“Why me?”")]), _vm._v(" "), _c('p', [_vm._v("“You’re the oldest.”")]), _vm._v(" "), _c('p', [_vm._v("So, Helewise put the pillows behind Roseabella’s back and stood by her side.")]), _vm._v(" "), _c('p', [_vm._v("“Roseabella, you can do this. Take hold of my hand and push!”")]), _vm._v(" "), _c('p', [_vm._v("Roseabella squeezed Helewise’s hand when she had a pushing pain.")]), _vm._v(" "), _c('p', [_vm._v("“I can see the head. Sit her up more, Helewise and get behind her back.”")]), _vm._v(" "), _c('p', [_vm._v("Roseabella gave a big scream and a big push and out came a big crying boy. Her sisters came over to the bed and were crying, Helewise started to cry and then her mother. When Armando came into the room, everyone was crying.")]), _vm._v(" "), _c('p', [_vm._v("“What’s wrong?”")]), _vm._v(" "), _c('p', [_vm._v("The midwife told him that nothing was wrong and that he had a healthy son.")]), _vm._v(" "), _c('p', [_vm._v("“Why is everyone crying?”")]), _vm._v(" "), _c('p', [_vm._v("“Sometimes babies make women emotional.”")]), _vm._v(" "), _c('p', [_vm._v("Armando went over to his wife and kissed her on the lips.")]), _vm._v(" "), _c('p', [_vm._v("“I don’t want to put you through this again.”")]), _vm._v(" "), _c('p', [_vm._v("Her crying turned to a smile. The midwife gave Roseabella her baby and he went directly to her nipple.")]), _vm._v(" "), _c('p', [_vm._v("“What a big baby, he must be ten pounds.”")]), _vm._v(" "), _c('p', [_vm._v("The bed was changed, Roseabella was in a warm night gown and went to sleep with the baby on her breast. Her mother put the baby in its cradle after feeding. Her mother said:")]), _vm._v(" "), _c('p', [_vm._v("“You have done well, my girl. I am so proud of you.”")]), _vm._v(" "), _c('p', [_vm._v("“You go and get some sleep, Duchess. I’ll take over.”")]), _vm._v(" "), _c('p', [_vm._v("“You are a devoted husband, Armando and you’re going to make a good father.”")]), _vm._v(" "), _c('p', [_vm._v("As the weeks went by, the baby was growing like a weed. They named him Josiah Grosu, after his two dead brothers.")]), _vm._v(" "), _c('p', [_vm._v("“You are such a good baby, my little Josiah, you only cry when you are hungry, which is every two hours.”")]), _vm._v(" "), _c('p', [_vm._v("“A big eater like his mother.”")]), _vm._v(" "), _c('p', [_vm._v("“I’m not a big eater like I was.”")]), _vm._v(" "), _c('p', [_vm._v("“You are right my darling but you are breast feeding and you both need nourishment.”")]), _vm._v(" "), _c('p', [_vm._v("“Meiga keeps me going in healthy foods. I am feeling my strength coming back.”")]), _vm._v(" "), _c('p', [_vm._v("“That’s good Roseabella but don’t overdo it.”")]), _vm._v(" "), _c('p', [_vm._v("“Of course not, Armando. I and Saige are going to try out the invention the men at the wood shop made for Josiah.”")]), _vm._v(" "), _c('p', [_vm._v("Roseabella laid the baby in the pusher; thick wool blankets were put down in under the baby. It had wheels on the bottom and a high up wooden handle to push the baby.")]), _vm._v(" "), _c('p', [_vm._v("“We are going to have an early spring; the sun is so warm today. We’re going outside for a little walk around the court yard.”")]), _vm._v(" "), _c('p', [_vm._v("Roseabella put an extra blanket on top of the baby.")]), _vm._v(" "), _c('p', [_vm._v("“My lady, let’s go over to the strawberry patch; I need to uncover my strawberry plants.”")]), _vm._v(" "), _c('p', [_vm._v("Saige uncovered the plants and saw new leaves.")]), _vm._v(" "), _c('p', [_vm._v("“How wonderful, there are new plants growing everywhere! Gramps is going to transplant the new growths in new beds.”")]), _vm._v(" "), _c('p', [_vm._v("“And does this mean we are going to have more strawberry cakes and pies?”")]), _vm._v(" "), _c('p', [_vm._v("“Yes, my lady.”")]), _vm._v(" "), _c('p', [_vm._v("“How is Helewise doing with the training?”")]), _vm._v(" "), _c('p', [_vm._v("“She has the women well trained. They are looking forward to the spear throwing on horseback again. So am I.”")]), _vm._v(" "), _c('p', [_vm._v("“I’m going to need a sitter for Josiah. Someone he feels comfortable with.”")]), _vm._v(" "), _c('p', [_vm._v("“I can do it.”")]), _vm._v(" "), _c('p', [_vm._v("“We need you Saige to help with training. Your grandmother will help me find a suitable woman. She knows everyone in the village.”")]), _vm._v(" "), _c('p', [_vm._v("On their walk around the court yard, everyone stopped to take a look at the baby.")]), _vm._v(" "), _c('p', [_vm._v("“He’s the splitting image of his father. Look at them blue eyes. So quiet and handsome.”")]), _vm._v(" "), _c('p', [_vm._v("Josiah spent a lot of time outside with the nanny when Roseabella trained. She needed him to be in close distance all the time.")]), _vm._v(" "), _c('p', [_vm._v("“Armando, Josiah will be six months old on my birthday. Two things to celebrate. Could we just keep my birthday party private this year? We could invite family.”")]), _vm._v(" "), _c('p', [_vm._v("“Whatever you want darling. I’m not in to dressing up and partying anymore either.”")]), _vm._v(" "), _c('p', [_vm._v("“We’ll have to tell Helewise before invitations go out.”")]), _vm._v(" "), _c('p', [_vm._v("“Of course.”")]), _vm._v(" "), _c('p', [_vm._v("“And I would like it to be outside by the flower garden, Josiah loves it outside. He pulls himself up now on the chairs and rolls around everywhere. We’ll put down some rugs for him and he’ll be happy.”")]), _vm._v(" "), _c('p', [_vm._v("Josiah was laughing as Armando spun him around the room.")]), _vm._v(" "), _c('p', [_vm._v("“Armando he just fed, if he gets sick, you’ll have to clean up.”")]), _vm._v(" "), _c('p', [_vm._v("“What did he have today?”")]), _vm._v(" "), _c('p', [_vm._v("“He had breast milk and mashed vegetables.”")]), _vm._v(" "), _c('p', [_vm._v("“My little man is eating solids.”")]), _vm._v(" "), _c('p', [_vm._v("“Dada.”")]), _vm._v(" "), _c('p', [_vm._v("“My god, he just called me Dada.”")]), _vm._v(" "), _c('p', [_vm._v("“Yes, he did Armando.”")]), _vm._v(" "), _c('p', [_vm._v("“And what about Mom? Momma? Say it, Josiah!”")]), _vm._v(" "), _c('p', [_vm._v("He kept looking at his father.")]), _vm._v(" "), _c('p', [_vm._v("“Dada.”")]), _vm._v(" "), _c('p', [_vm._v("“Your first word, I love you Josiah, you make me a proud father. He must be hungry; he’s chewing on my chin.”")]), _vm._v(" "), _c('p', [_vm._v("“He’s not hungry, he’s cutting teeth.”")]), _vm._v(" "), _c('p', [_vm._v("“You’re going to get something else to chew on. Give him the big wooden spoon. Here, you go chew on this. See you later wife, I must talk to Helewise.”")]), _vm._v(" "), _c('p', [_vm._v("“Helewise, I would like to talk to you.”")]), _vm._v(" "), _c('p', [_vm._v("“Ok brother, talk away.”")]), _vm._v(" "), _c('p', [_vm._v("“Could you put down the sword?”")]), _vm._v(" "), _c('p', [_vm._v("“Alright, what is it?”")]), _vm._v(" "), _c('p', [_vm._v("“Roseabella doesn’t want a big party this year.”")]), _vm._v(" "), _c('p', [_vm._v("“Why not, you know I love to throw parties.”")]), _vm._v(" "), _c('p', [_vm._v("“She wants you and her and family. She wants it outside by the flower garden.”")]), _vm._v(" "), _c('p', [_vm._v("“How boring.”")]), _vm._v(" "), _c('p', [_vm._v("“We want it that way, to celebrate Josiah’s half year old and nineteenth year for Roseabella.”")]), _vm._v(" "), _c('p', [_vm._v("“Ok, ok! In two weeks then.”")]), _vm._v(" "), _c('p', [_vm._v("“Roseabella is very fond of Gerrold and Meiga’s family, please invite all four.”")]), _vm._v(" "), _c('p', [_vm._v("“Yes, the more the merrier.”")]), _vm._v(" "), _c('p', [_vm._v("The day of the party, Helewise had men set up tables and chairs around the flower garden. A big tent was set up for the buffet. Flowers were hung all around the tables and chairs. A bird bath was set up for the baby to enjoy and a feeder next to it. Roseabella and the baby were sat down on blankets and rugs.")]), _vm._v(" "), _c('p', [_vm._v("The baby was playing with some wooden toys and was happy. The trees around the garden gave them shade. Roseabella looked up and saw her family walking toward her. She picked up the baby and ran toward them.")]), _vm._v(" "), _c('p', [_vm._v("“Roseabella, you look wonderful. What are you feeding my grandson? He has grown so much and those rosy cheeks. Let me take him, my daughter; he looks too heavy for you.”")]), _vm._v(" "), _c('p', [_vm._v("“I’m used to it, father.”")]), _vm._v(" "), _c('p', [_vm._v("“You are a big boy and look at you smiling at your grandpa! We miss the two of you so much.”")]), _vm._v(" "), _c('p', [_vm._v("“Let me hold him, father.”")]), _vm._v(" "), _c('p', [_vm._v("The duke lifted him into Gretta’s arms.")]), _vm._v(" "), _c('p', [_vm._v("“Oh, Josiah you are so cuddly and warm.”")]), _vm._v(" "), _c('p', [_vm._v("“Let me have him now.”")]), _vm._v(" "), _c('p', [_vm._v("“I just got him, Ardelean.”")]), _vm._v(" "), _c('p', [_vm._v("“Let your sister take him up just for a minute.”")]), _vm._v(" "), _c('p', [_vm._v("“Why is he drooling on me? He’s cutting more teeth. Take him back, he’s making my new dress wet.”")]), _vm._v(" "), _c('p', [_vm._v("“Come to Grandpa, come on Josiah, let’s go see your father. What a nice day for an outdoor birthday.”")]), _vm._v(" "), _c('p', [_vm._v("Armando put the baby on his blanket to play with his toys.")]), _vm._v(" "), _c('p', [_vm._v("“Would you like some wine duke?”")]), _vm._v(" "), _c('p', [_vm._v("“I sure would.”")]), _vm._v(" "), _c('p', [_vm._v("“Here you go.”")]), _vm._v(" "), _c('p', [_vm._v("“This wine is a little different.”")]), _vm._v(" "), _c('p', [_vm._v("“Yes, it’s a new batch, we added blackberries to it.”")]), _vm._v(" "), _c('p', [_vm._v("“It has an incredible taste and a nice color to it. This year seems so peaceful.”")]), _vm._v(" "), _c('p', [_vm._v("“It’s been quiet lately but I’ll never let down my guard with my cousin out there waiting to take my family.”")]), _vm._v(" "), _c('p', [_vm._v("“Here comes Helewise and Edder. I was wondering where he disappeared to. I think he has a crush on your sister.”")]), _vm._v(" "), _c('p', [_vm._v("“I see she is fond of him too. My sister needs friends her own age, lately we have been busy with the baby and she feels left out.”")]), _vm._v(" "), _c('p', [_vm._v("“Why don’t you let her come back with us for a few days? My wife has a few tea parties for Edder and the girls, gives them chances to meet people their own age. They like to play games and cards. On bright sunny days, we let them outside the gate to play cricket. We still have guards watching them.”")]), _vm._v(" "), _c('p', [_vm._v("“Yes, your Duke. I think that would be a wonderful idea.”")]), _vm._v(" "), _c('p', [_vm._v("“Why don’t all of you come? It’s been a year and a half since Roseabella’s had a visit.”")]), _vm._v(" "), _c('p', [_vm._v("“Maybe you’re right, we all need a change of scenery.”")]), _vm._v(" "), _c('p', [_vm._v("“Roseabella, it’s your birthday. I want you to sit down and have a drink of wine with your mother and your sisters. The nanny is going to put Josiah in the baby pusher and show him the baby ducks and chicks.”")]), _vm._v(" "), _c('p', [_vm._v("“Would you like that my baby?”")]), _vm._v(" "), _c('p', [_vm._v("“He will enjoy it, my lady.”")]), _vm._v(" "), _c('p', [_vm._v("“He’s growing up so fast, mother. Sometimes, I want him to stay a baby, safe with me.”")]), _vm._v(" "), _c('p', [_vm._v("“Roseabella, when you start to feel like that it means it’s time to have another baby.”")]), _vm._v(" "), _c('p', [_vm._v("“It’s too soon, mother.”")]), _vm._v(" "), _c('p', [_vm._v("“I had four, don’t forget.”")]), _vm._v(" "), _c('p', [_vm._v("“How’s your search for a husband for Ardelean?”")]), _vm._v(" "), _c('p', [_vm._v("“She’s not interested in boys her own age. And most boys are immature at that age.”")]), _vm._v(" "), _c('p', [_vm._v("“She will be sixteen next month, mother. Older men will take notice by then.”")]), _vm._v(" "), _c('p', [_vm._v("“You are right, what’s the rush? You were almost seventeen.”")]), _vm._v(" "), _c('p', [_vm._v("“Happy birthday, sister.”")]), _vm._v(" "), _c('p', [_vm._v("“Thank you Edder, it’s so good you made it.”")]), _vm._v(" "), _c('p', [_vm._v("“How could I not make it to my favorite sister’s birthday?”")]), _vm._v(" "), _c('p', [_vm._v("“We heard that Edder.”")]), _vm._v(" "), _c('p', [_vm._v("“Oh, Gretta you’re always eavesdropping.”")]), _vm._v(" "), _c('p', [_vm._v("“I do not!”")]), _vm._v(" "), _c('p', [_vm._v("“Come, sit down and have a goblet of wine. Everyone, let’s drink to my special sister Roseabella.”")]), _vm._v(" "), _c('p', [_vm._v("“Meiga, it’s so nice you made it.”")]), _vm._v(" "), _c('p', [_vm._v("“I wouldn’t miss it for the world.”")]), _vm._v(" "), _c('p', [_vm._v("Everyone joined in and threw horseshoes. Men against the women. They played for two hours and the score was a tie.")]), _vm._v(" "), _c('p', [_vm._v("“Ok your turn, Saige. Relax and aim.”")]), _vm._v(" "), _c('p', [_vm._v("Saige tossed the horse shoe up in the air and it landed wrapping around the pole. All the women jumped and clapped for joy. Everyone had more wine and went in the tent for food.")]), _vm._v(" "), _c('p', [_vm._v("“Those strawberries are so sweet. Where did you get them?”")]), _vm._v(" "), _c('p', [_vm._v("“They’re from Saige’s garden.”")]), _vm._v(" "), _c('p', [_vm._v("“You have a green thumb, my dear.”")]), _vm._v(" "), _c('p', [_vm._v("The tables were laid out with shrimp, scallops, smoked salmon, cold fried chicken, potato salad, beet salad and green salad with slices of lamb and pork. On the dessert table were strawberry and raspberry tarts, ginger bread cookies, sweet corn bread and apple tarts.")]), _vm._v(" "), _c('p', [_vm._v("“Momma, Momma,” she looked around at her son, he had a bunch of flowers for her in his little chubby hand, “thank you my baby. Would you like some food? Mommy’s going to mash up some food for you and the nurse maid will feed you. And then you can have a bath. Mommy and Daddy will tuck you in.”")]), _vm._v(" "), _c('p', [_vm._v("Hatmanu, Gretta and Saige started up a new game of horse shoes just the three of them. Ardelean and Helewise were talking about dating.")]), _vm._v(" "), _c('p', [_vm._v("“I’m looking forward for an older man at least ten years older than me. Men my age are so hyper and immature.”")]), _vm._v(" "), _c('p', [_vm._v("“Yes, some can be but your brother seems mature though and he’s fun.”")]), _vm._v(" "), _c('p', [_vm._v("“My brother Edder? We don’t see him much now; he travels a lot with father.”")]), _vm._v(" "), _c('p', [_vm._v("“Does he have a lot of lady friends?”")]), _vm._v(" "), _c('p', [_vm._v("“He received a few invitations but he told my mother they are not the women for him.”")]), _vm._v(" "), _c('p', [_vm._v("“What kind of woman is he interested in?”")]), _vm._v(" "), _c('p', [_vm._v("“He likes hunting, fishing and riding. She would have to be all of the above.”")]), _vm._v(" "), _c('p', [_vm._v("“Happy birthday to the love of my life.”")]), _vm._v(" "), _c('p', [_vm._v("Roseabella turned around and saw the most beautiful pony, with a red ribbon around her neck.")]), _vm._v(" "), _c('p', [_vm._v("“For you darling, from me. She is Cloud and Spirit’s foal.”")]), _vm._v(" "), _c('p', [_vm._v("“She is magnificent. Black and white like her parents. Thank you, Armando, I would like to train her myself.”")]), _vm._v(" "), _c('p', [_vm._v("“I thought you would.”")]), _vm._v(" "), _c('p', [_vm._v("“Armando, you made a good breed with that one. Long legs, long body will be a fine runner.”")]), _vm._v(" "), _c('p', [_vm._v("“Thank you, Duke.”")]), _vm._v(" "), _c('p', [_vm._v("“Happy birthday Roseabella, I and Saige made this birthday cake for you.”")]), _vm._v(" "), _c('p', [_vm._v("The cake was four tiers high, white icing decorated with mint leaves and raspberries.")]), _vm._v(" "), _c('p', [_vm._v("“Oh, what a beautiful job you did, let’s all have some. I can’t wait!”")]), _vm._v(" "), _c('p', [_vm._v("“You have the first piece, my lady.”")]), _vm._v(" "), _c('p', [_vm._v("“Thank you, yum, yum, it’s delicious. We must save some for Josiah.”")]), _vm._v(" "), _c('p', [_vm._v("“Thanks everyone for coming, we’ll see you tomorrow. We’re going to tuck in the baby. See you at breakfast.”")]), _vm._v(" "), _c('p', [_vm._v("“They are so happy together.”")]), _vm._v(" "), _c('p', [_vm._v("“That’s what I want.”")]), _vm._v(" "), _c('p', [_vm._v("“To be swept off your feet by a rich man and to have your freedom and make your own decisions? I want to travel the world before I settle down.”")]), _vm._v(" "), _c('p', [_vm._v("“My parents will never let me travel unless I had a husband.”")]), _vm._v(" "), _c('p', [_vm._v("“When I’m twenty-one, I am of age to make my own decisions.”")]), _vm._v(" "), _c('p', [_vm._v("Roseabella and Armando kissed the baby’s cheeks good night.")]), _vm._v(" "), _c('p', [_vm._v("“Sweet dreams, little one.”")]), _vm._v(" "), _c('p', [_vm._v("Roseabella showed Armando how grateful she was for her horse. She pushed him down on the bed, undressed him and herself. She crawled up on top of him and straddled him.")]), _vm._v(" "), _c('p', [_vm._v("“You my love, are no longer shy.”")]), _vm._v(" "), _c('p', [_vm._v("“I like to try new things.”")]), _vm._v(" "), _c('p', [_vm._v("He was rocking her back and forth, up and down.")]), _vm._v(" "), _c('p', [_vm._v("They both screamed in pleasure.")]), _vm._v(" "), _c('p', [_vm._v("“That was wonderful, I think we just made a baby.”")]), _vm._v(" "), _c('p', [_vm._v("“Roseabella, your parents would like us to spend some time with them and bring my sister along. I think it would be good for Helewise. She needs some time away from our castle. Your father thought it was a good idea. He wants to show off his grandson to his friends. And we get to play cricket.”")]), _vm._v(" "), _c('p', [_vm._v("“You know how to play?”")]), _vm._v(" "), _c('p', [_vm._v("“No, I don’t but it sounds like a good game.”")]), _vm._v(" "), _c('p', [_vm._v("“It is. Lots of running and batting.”")]), _vm._v(" "), _c('p', [_vm._v("“Sounds good, you, Josiah and the nanny leave with your parents. I have to go to the village to look at a horse. I’ll be there to dine with you all and show off my horse.”")]), _vm._v(" "), _c('p', [_vm._v("Garrett sent a note to Armando:")]), _vm._v(" "), _c('p', [_vm._v("“Dear Sir Armando, a new breed of horses came in today. A color I’ve not seen before. Red ginger color with white stockings. Only a year old. Come soon, I have other offers.”")]), _vm._v(" "), _c('p', [_vm._v("Garrett knew his cousin’s love for horses. No man can turn down coin and that’s why I have my informant from the castle. Roseabella and her son, which will soon be my son, will be traveling to her home with her parents and family.")]), _vm._v(" "), _c('p', [_vm._v("The stupid Duke only has six guards with him. Sunlight won’t keep away thieves and murderers. My humans, who I trained, will kidnap Roseabella, the baby and one of her sisters. Her sister will help with Josiah on our journey.")]), _vm._v(" "), _c('p', [_vm._v("None of Roseabella’s family will be harmed, I will not give her reason to dislike me. I’ll be waiting in a cove out of sight. My men will row them to me. With good weather and a few stops on the way for a few supplies for my new family and fresh blood for me. And we should be in our new destination.")]), _vm._v(" "), _c('p', [_vm._v("My estate is on an island that is hidden. One of my sailors was shipwrecked there for months. He eventually built a raft and was picked up half-dead. When he was hired on, he had memory loss. The night we had a hurricane, he steered us in the island for protection. His memory came back in time to save all our lives.")]), _vm._v(" "), _c('p', [_vm._v("The island was perfect and private. This is where I’ll live out my life with my family. My genes will live to eternity by Josiah. The estate is livable but in time it will be finished. I have ten horses and a pony for my son. I love the words (my son). In a few hours, my family will be safely aboard my ship.")]), _vm._v(" "), _c('p', [_vm._v("“Roseabella, I think it’s better if we go tomorrow after I get my horse.”")]), _vm._v(" "), _c('p', [_vm._v("“Armando my darling, I’m packed and so is Helewise, it’s a bright sunny day. No vampire attacks in over a year. My father has guards, we cannot live the rest of our lives in fear. Go get the beautiful red hours with white stockings.”")]), _vm._v(" "), _c('p', [_vm._v("“Roseabella, if anything happens to you and Josiah, I would have nothing to live for.”")]), _vm._v(" "), _c('p', [_vm._v("“My husband, we will see you tonight at dinner.”")]), _vm._v(" "), _c('p', [_vm._v("Armando gave her and the baby a kiss good bye.")]), _vm._v(" "), _c('p', [_vm._v("“I can’t wait to see that red horse, my daughter!”")]), _vm._v(" "), _c('p', [_vm._v("“And the white stockings as well father! She’s going to be a beauty; will he breed her with Spirit?”")]), _vm._v(" "), _c('p', [_vm._v("“Yes, he would be a good choice with his speed.”")]), _vm._v(" "), _c('p', [_vm._v("“Since when did you get interested in horses, Roseabella?”")]), _vm._v(" "), _c('p', [_vm._v("“Since the first day Armando lifted me on Cloud. It was an experience I’ll never forget. Armando told me I was born for riding.”")]), _vm._v(" "), _c('p', [_vm._v("“You are sweetheart, I see the way you cross the fields, you and the horse are like one. And you taught your sisters.”")]), _vm._v(" "), _c('p', [_vm._v("“They do love riding father.”")]), _vm._v(" "), _c('p', [_vm._v("“It’s the only time they don’t quarrel,” said mother.")]), _vm._v(" "), _c('p', [_vm._v("“I heard that, mother!”")]), _vm._v(" "), _c('p', [_vm._v("“How can you?”")]), _vm._v(" "), _c('p', [_vm._v("“You have the window open in the carriage. I’m riding my horse outside the window.”")]), _vm._v(" "), _c('p', [_vm._v("“Why is the carriage stopping?”")]), _vm._v(" "), _c('p', [_vm._v("“There’s a tree up ahead blown down, father.”")]), _vm._v(" "), _c('p', [_vm._v("“Then get men working on it.”")]), _vm._v(" "), _c('p', [_vm._v("“Right away, father dear.”")]), _vm._v(" "), _c('p', [_vm._v("“That girl is always eavesdropping.”")]), _vm._v(" "), _c('p', [_vm._v("“She’s the youngest father and the day she leaves, a part of your heart will too.”")]), _vm._v(" "), _c('p', [_vm._v("“When did you get so smart?”")]), _vm._v(" "), _c('p', [_vm._v("“I was always smart, father you just didn’t notice.”")]), _vm._v(" "), _c('p', [_vm._v("“Everyone out! Put up your hands!”")]), _vm._v(" "), _c('p', [_vm._v("“What’s happening?”")]), _vm._v(" "), _c('p', [_vm._v("“Keep your mouth shut, Duke.”")]), _vm._v(" "), _c('p', [_vm._v("“What do you want?”")]), _vm._v(" "), _c('p', [_vm._v("The duke was then gagged and his arms tied around his back.")]), _vm._v(" "), _c('p', [_vm._v("“We’re here to take your two daughters and grandson.”")]), _vm._v(" "), _c('p', [_vm._v("“You will not touch my brother’s family.”")]), _vm._v(" "), _c('p', [_vm._v("“And who are you my dear?”")]), _vm._v(" "), _c('p', [_vm._v("“I’m Armando’s sister.”")]), _vm._v(" "), _c('p', [_vm._v("“Gag her and tie her up as well.”")]), _vm._v(" "), _c('p', [_vm._v("“You just try it!”")]), _vm._v(" "), _c('p', [_vm._v("Helewise was out with her spear and threw it at his throat. The spear came out on the other side of his neck. Edder was out with his spear when he was knocked unconscious. Helewise was then thrown to the ground and tied up.")]), _vm._v(" "), _c('p', [_vm._v("“Momma be still or they will hurt you.”")]), _vm._v(" "), _c('p', [_vm._v("“Why are you doing this? Please don’t take my children. My husband can pay you all the coin you want.”")]), _vm._v(" "), _c('p', [_vm._v("“We are already being paid all the coin we want.”")]), _vm._v(" "), _c('p', [_vm._v("“We’ll pay you more and jewels.”")]), _vm._v(" "), _c('p', [_vm._v("“Why don’t we take her money and get the hell out of this village?”")]), _vm._v(" "), _c('p', [_vm._v("“You stupid bugger, you can’t run from a vampire.”")]), _vm._v(" "), _c('p', [_vm._v("“Mother, tell Armando the kidnapper is Garrett!”")]), _vm._v(" "), _c('p', [_vm._v("“Keep your mouth shut or I’ll shut it for you.”")]), _vm._v(" "), _c('p', [_vm._v("“Don’t you touch her, Armando will rip you apart! My girls, this can’t be happening. Gretta, my baby and my oldest, remember I love you. And we will find you.”")]), _vm._v(" "), _c('p', [_vm._v("After hugs and kisses from their mother and sister, they were lead away with the guards’ horses.")]), _vm._v(" "), _c('p', [_vm._v("“If anyone follows, your youngest will be murdered.”")]), _vm._v(" "), _c('p', [_vm._v("“Please don’t hurt them!”")]), _vm._v(" "), _c('p', [_vm._v("Duchess Bella removed her husband’s gag and ropes.")]), _vm._v(" "), _c('p', [_vm._v("“I’m so sorry Bella, this has happened. Let’s get everyone home, me and my men will track them down.”")]), _vm._v(" "), _c('p', [_vm._v("“You can’t do that, they will kill Gretta.”")]), _vm._v(" "), _c('p', [_vm._v("“I’m taking twice as many men.”")]), _vm._v(" "), _c('p', [_vm._v("“Can you promise me they won’t kill Gretta?”")]), _vm._v(" "), _c('p', [_vm._v("“No sorry, I can’t promise you for sure.”")]), _vm._v(" "), _c('p', [_vm._v("“Then don’t, she is safe with Roseabella, didn’t you hear them, he will kill anyone who touches her. And if we do as they say, they have no reason to kill her!”")]), _vm._v(" "), _c('p', [_vm._v("“I can’t let them get away.”")]), _vm._v(" "), _c('p', [_vm._v("“You will not put our daughter’s life in danger.”")]), _vm._v(" "), _c('p', [_vm._v("The duchess went over to her son who was coming to.")]), _vm._v(" "), _c('p', [_vm._v("“Oh, my son I’m so glad you are alive.”")]), _vm._v(" "), _c('p', [_vm._v("“Mother, did they take Roseabella and Josiah?”")]), _vm._v(" "), _c('p', [_vm._v("“Yes, they did and my baby girl.”")]), _vm._v(" "), _c('p', [_vm._v("“Why would they take them? Is it for ransom?”")]), _vm._v(" "), _c('p', [_vm._v("“I wish it was that easy.”")]), _vm._v(" "), _c('p', [_vm._v("“What do you mean, mother?”")]), _vm._v(" "), _c('p', [_vm._v("“Armando’s cousin Garrett is the master of this kidnapping.”")]), _vm._v(" "), _c('p', [_vm._v("“Oh my god no! Mother, you have to untie Helewise.”")]), _vm._v(" "), _c('p', [_vm._v("“Yes of course.”")]), _vm._v(" "), _c('p', [_vm._v("Edder went to Ardelean. She was white as snow and eyes swollen from crying.")]), _vm._v(" "), _c('p', [_vm._v("“Are you hurt? Ardelean, can you hear me?”")]), _vm._v(" "), _c('p', [_vm._v("She nodded her head.")]), _vm._v(" "), _c('p', [_vm._v("“Get into the coach. Mother, help Helewise inside the carriage. Father, get in beside mother. No father, first we have to remove the tree.”")]), _vm._v(" "), _c('p', [_vm._v("“I’ll help you Edder, I’m not hurt.”")]), _vm._v(" "), _c('p', [_vm._v("“Ok one, two, three lift it to the side. Again one, two, three, lift it once more. One, two, three lift, we did it! Ok, everyone inside. I’m going to drive the horses. Father, we must get a search party out as soon as possible.”")]), _vm._v(" "), _c('p', [_vm._v("“No, my son he will kill Gretta if anyone follows.”")]), _vm._v(" "), _c('p', [_vm._v("“We can’t do nothing!”")]), _vm._v(" "), _c('p', [_vm._v("“You will do what your father told you Edder, we will not risk Gretta’s life! We’ll leave the decision up to Armando. Give me the rug to cover your sister, she is in shock.”")]), _vm._v(" "), _c('p', [_vm._v("Armando went straight to the stables in the village.")]), _vm._v(" "), _c('p', [_vm._v("“Sir Armando, what do I have the privilege of your visit today?”")]), _vm._v(" "), _c('p', [_vm._v("“I’m here to look at the red horse with the white stockings.”")]), _vm._v(" "), _c('p', [_vm._v("“I don’t have a red horse.”")]), _vm._v(" "), _c('p', [_vm._v("“You sent me a message yesterday by your man, telling me you had a new horse for sale.”")]), _vm._v(" "), _c('p', [_vm._v("“I’m sorry Armando, for your inconvenience but I did not send a message and as you can see, I have no red horse.”")]), _vm._v(" "), _c('p', [_vm._v("“What’s wrong Armando, you’re as white as a ghost.”")]), _vm._v(" "), _c('p', [_vm._v("“I have to go now before it’s too late! Please God, just let this be a mix up. Maybe a message from another stable? Come on Spirit, we must get to Roseabella before it’s too late.”")]), _vm._v(" "), _c('p', [_vm._v("Armando rode Spirit almost to the ground, when he reached the Duke’s men’s bodies.")]), _vm._v(" "), _c('p', [_vm._v("“Dear Jesus, what have I done to my family? Maybe they got away!”")]), _vm._v(" "), _c('p', [_vm._v("He gave his horse some water and took off again to the Duke’s castle.")]), _vm._v(" "), _c('p', [_vm._v("“Oh Gretta, I’m so sorry this is happening to you.”")]), _vm._v(" "), _c('p', [_vm._v("“I won’t let any harm come to you. I will kill him the first chance I get.”")]), _vm._v(" "), _c('p', [_vm._v("“And I will help you, I’m not scared.”")]), _vm._v(" "), _c('p', [_vm._v("“Why does he want you and the baby?”")]), _vm._v(" "), _c('p', [_vm._v("“Armando’s cousin Garrett is a vampire. He didn’t want to become one. Hatmanu said Garrett couldn’t stand being around them but Garrett still has a thirst for blood at night. He can’t have kids of his own.”")]), _vm._v(" "), _c('p', [_vm._v("“Why not?”")]), _vm._v(" "), _c('p', [_vm._v("“Vampires can’t produce.”")]), _vm._v(" "), _c('p', [_vm._v("“That’s good to know.”")]), _vm._v(" "), _c('p', [_vm._v("“Garrett wants Josiah because he shares Armando’s blood line. Josiah’s bloodline will be passed down for centuries and Garrett will live to see it all.”")]), _vm._v(" "), _c('p', [_vm._v("“Why did he take us and not just the baby?”")]), _vm._v(" "), _c('p', [_vm._v("“He doesn’t want to separate a child from his mother. And we will be living with other vampires.”")]), _vm._v(" "), _c('p', [_vm._v("“Will he change you?”")]), _vm._v(" "), _c('p', [_vm._v("“I don’t think so, not yet anyway, he’ll have to wait until Josiah is grown up.”")]), _vm._v(" "), _c('p', [_vm._v("“What about me?”")]), _vm._v(" "), _c('p', [_vm._v("“No, he won’t because I need you. I will threaten to kill myself.”")]), _vm._v(" "), _c('p', [_vm._v("“I will help you and the baby as much as I can. He slept through it all. I’m glad he didn’t see everyone so upset. We must pray for our brother, that he is alive.”")]), _vm._v(" "), _c('p', [_vm._v("“He was breathing Gretta, before we left.”")]), _vm._v(" "), _c('p', [_vm._v("“Oh, that’s a relief!”")]), _vm._v(" "), _c('p', [_vm._v("“Helewise put her spear right through that man’s neck. She was a fighter.”")]), _vm._v(" "), _c('p', [_vm._v("“She could have gotten herself and others killed. Helewise doesn’t think things through.”")]), _vm._v(" "), _c('p', [_vm._v("“They’re slowing down. Now, I’m getting scared sister.”")]), _vm._v(" "), _c('p', [_vm._v("“Promise me one thing.”")]), _vm._v(" "), _c('p', [_vm._v("“What’s that?”")]), _vm._v(" "), _c('p', [_vm._v("“You keep your mouth shut and don’t argue with them.”")]), _vm._v(" "), _c('p', [_vm._v("“Everyone out, you Roseabella, you little girl.”")]), _vm._v(" "), _c('p', [_vm._v("Roseabella looked at her sister with her finger across her lips. Good girl. At that moment, Josiah woke from his long nap with smiles for everyone.")]), _vm._v(" "), _c('p', [_vm._v("“What a cute baby you have, my lady.”")]), _vm._v(" "), _c('p', [_vm._v("“What big brute he is also.”")]), _vm._v(" "), _c('p', [_vm._v("“We’re not going to hurt anyone; you little girl, get in the boat first. Now it’s your turn my lady, give the baby to your sister, so you won’t drop him.”")]), _vm._v(" "), _c('p', [_vm._v("Roseabella was unsure about that. She walked right to the boat, laid the baby into Gretta’s arms and jumped into the boat.")]), _vm._v(" "), _c('p', [_vm._v("The baby started to fuss because he was hungry.")]), _vm._v(" "), _c('p', [_vm._v("“He’s hungry.”")]), _vm._v(" "), _c('p', [_vm._v("“Will this do?”")]), _vm._v(" "), _c('p', [_vm._v("Gretta pulled out a handful of ginger bread cookies from her pocket.")]), _vm._v(" "), _c('p', [_vm._v("“Saige gave them to me, for me and Josiah’s ride to our castle.”")]), _vm._v(" "), _c('p', [_vm._v("“Thank you, Gretta.”")]), _vm._v(" "), _c('p', [_vm._v("“Saige said its Josiah’s favorite.” (Saige is the only one who can help us)")]), _vm._v(" "), _c('p', [_vm._v("“Is there anything for the baby to drink?”")]), _vm._v(" "), _c('p', [_vm._v("“Yes, Garrett made sure the baby had water.” (Thank God, she didn’t want to breast feed in front of all of them). She gave Josiah breast milk a few times each day.")]), _vm._v(" "), _c('p', [_vm._v("After being at sea for one hour, Roseabella noticed a ship.")]), _vm._v(" "), _c('p', [_vm._v("“Isn’t she a beauty?”")]), _vm._v(" "), _c('p', [_vm._v("“She is that. Hey what’s that smell?”")]), _vm._v(" "), _c('p', [_vm._v("“My son has soiled his nappy.”")]), _vm._v(" "), _c('p', [_vm._v("“Thank God, we’re here. Hey little bugger, let’s get you changed. We grabbed a few bags that looked like they were for women.”")]), _vm._v(" "), _c('p', [_vm._v("Gretta climbed up first and took the baby from her sister’s arms, then she climbed over.")]), _vm._v(" "), _c('p', [_vm._v("“The cabin boy will show you to your room, be careful going down the stairs, and grab a hold of the rail. Everything you need is there.”")]), _vm._v(" "), _c('p', [_vm._v("After they entered, the door was locked. Roseabella looked around the room, it had two beds and a crib for Josiah. A small tub full of warm water for the baby, two more tubs of warm water in the water closet. A small table with two chairs and a basketful of food.")]), _vm._v(" "), _c('p', [_vm._v("“I’ll change the baby’s nappy, you put some food on the table, we need to eat and keep our strength up.”")]), _vm._v(" "), _c('p', [_vm._v("“Does baby’s always smell that bad?”")]), _vm._v(" "), _c('p', [_vm._v("“Only since he’s been eating solids.”")]), _vm._v(" "), _c('p', [_vm._v("Roseabella couldn’t find anywhere to put it, so she opened a little window and threw it out.")]), _vm._v(" "), _c('p', [_vm._v("“Let’s get you sat up in this little tub, so Mommy and Aunt Gretta can eat. The food is not bad. I like the cheese and the cold sausage and the bread is soft and the cold cuts are tender. What’s for dessert?”")]), _vm._v(" "), _c('p', [_vm._v("“Looks like plum pudding and rum sauce.”")]), _vm._v(" "), _c('p', [_vm._v("“Pass some over.”")]), _vm._v(" "), _c('p', [_vm._v("Roseabella scrubbed her son and Gretta dried him off.")]), _vm._v(" "), _c('p', [_vm._v("“Let’s get a clean nappy on you and give you your supper.”")]), _vm._v(" "), _c('p', [_vm._v("Roseabella cut up some meat into shreds, small pieces of butter, bread and cheese. The baby cried for seconds.")]), _vm._v(" "), _c('p', [_vm._v("“He loves his food.”")]), _vm._v(" "), _c('p', [_vm._v("“Yes, he certainly does. Can you mash up some pudding for him?”")]), _vm._v(" "), _c('p', [_vm._v("“Can I feed him the pudding? You sit back and enjoy your tea.”")]), _vm._v(" "), _c('p', [_vm._v("“Oh Gretta, I’m so glad I’m not alone.”")]), _vm._v(" "), _c('p', [_vm._v("She gave her sister a big hug and a kiss on her head. And for a minute, they hugged and cried. Then little Josiah said, “Momma?”")]), _vm._v(" "), _c('p', [_vm._v("“We are going to get through this. Now, open your mouth for dessert. Is it good? How about a little water to wash it down? You want some more pudding?”")]), _vm._v(" "), _c('p', [_vm._v("Gretta washed Josiah’s face and hands.")]), _vm._v(" "), _c('p', [_vm._v("“Put his nightshirt on him. Let’s put you in your crib. Look! That mean man Garrett has new toys for you. That’s a good boy, play with your toys. He is such a good baby, Roseabella. Are you alright? I was talking to you.”")]), _vm._v(" "), _c('p', [_vm._v("“I’m sorry I was thinking about Armando, what a shock he’s going to have and the guilt that he will put on his shoulders.”")]), _vm._v(" "), _c('p', [_vm._v("“He’s going to find us Roseabella, if anyone can, it will be Armando.”")]), _vm._v(" "), _c('p', [_vm._v("“Yes, you are right, we will think positive.”")]), _vm._v(" "), _c('p', [_vm._v("Josiah fell asleep in his crib.")]), _vm._v(" "), _c('p', [_vm._v("“Why don’t we take a nap ourselves, it will do us good.”")]), _vm._v(" "), _c('p', [_vm._v("Armando’s sister ran into his arms.")]), _vm._v(" "), _c('p', [_vm._v("“Oh, Armando I’m so sorry. They took Josiah, Roseabella and her sister Gretta!”")]), _vm._v(" "), _c('p', [_vm._v("“Who did?”")]), _vm._v(" "), _c('p', [_vm._v("“Garrett’s men, I killed one before I was knocked off my horse and tied up. They knocked out Edder and gagged and tied up the Duke.”")]), _vm._v(" "), _c('p', [_vm._v("“How many men are looking for them? I must get a fresh horse and pick up their trail.”")]), _vm._v(" "), _c('p', [_vm._v("“No one is gone, Armando. If they see anyone following, they will kill Gretta.”")]), _vm._v(" "), _c('p', [_vm._v("“He played me for a fool.”")]), _vm._v(" "), _c('p', [_vm._v("“What do you mean?”")]), _vm._v(" "), _c('p', [_vm._v("“There was no red horse for sale. It was a set up. It’s all my fault, I lost my family over a fucking horse.”")]), _vm._v(" "), _c('p', [_vm._v("“Armando, we need to make plans. They must be off the road for the night. We leave first thing in the morning and pick up their trail. They left in their carriage they brought with them. But I can recognize it again, I heard the top man say, no one touches Roseabella or the baby or he will be torn apart by Garrett.”")]), _vm._v(" "), _c('p', [_vm._v("“Ok, I need to think.”")]), _vm._v(" "), _c('p', [_vm._v("“Come in Armando, have food, talk to her family, they lost two daughters and their grandson.”")]), _vm._v(" "), _c('p', [_vm._v("“How did he get humans to do this?”")]), _vm._v(" "), _c('p', [_vm._v("“They said they were paid well with coin. The Duchess offered more coin and jewels, one wanted to take it but the other one in charge said, you cannot cross a vampire and live. His men had training Armando, we never saw them coming.”")]), _vm._v(" "), _c('p', [_vm._v("Roseabella was sleeping soundly when she heard a knock on the door. The door opened and the cabin boy came in.")]), _vm._v(" "), _c('p', [_vm._v("“My master would like the three of you to be on deck in two hours. You will be escorted to the captain’s cabin to dine. There are clothes in the closet if you have need of them. There are blankets in the closet to wrap up the baby, it gets cold on the ocean at night.”")]), _vm._v(" "), _c('p', [_vm._v("“What is your name, young man?”")]), _vm._v(" "), _c('p', [_vm._v("“They call me boy.”")]), _vm._v(" "), _c('p', [_vm._v("“That’s not a name.”")]), _vm._v(" "), _c('p', [_vm._v("“That’s the only one I have.”")]), _vm._v(" "), _c('p', [_vm._v("“Ok, thank you boy.”")]), _vm._v(" "), _c('p', [_vm._v("“I’ll be back in two hours to help with the baby.”")]), _vm._v(" "), _c('p', [_vm._v("“Why did you ask him his name?”")]), _vm._v(" "), _c('p', [_vm._v("“He could be useful when Garrett sleeps by day. And he’s your age, so try and befriend him. When the ship stops in different ports for supplies, we could escape.”")]), _vm._v(" "), _c('p', [_vm._v("“Good thinking Roseabella, I will get him eating out of my hand.”")]), _vm._v(" "), _c('p', [_vm._v("“You don’t have to go that far little sister. Let’s see what taste in clothes cousin Garrett has.”")]), _vm._v(" "), _c('p', [_vm._v("“Wow, I’ve never seen anything so pretty. They’re made from silk like your wedding dress. They are quite lovely.”")]), _vm._v(" "), _c('p', [_vm._v("“We will wear our own dresses; we will not submit that easy. Now let’s get cleaned up and we can do each other’s hair before Josiah wakes up. You must not threaten him, we don’t know what kind of temper he has. You will answer his question truthfully, not sarcastically. He looks a lot like Armando, only thing different is the eyes, they are black.”")]), _vm._v(" "), _c('p', [_vm._v("“How do you know this?”")]), _vm._v(" "), _c('p', [_vm._v("“I saw a painting of him in the castle. He and Armando were best friends and Helewise thought of him as a brother.”")]), _vm._v(" "), _c('p', [_vm._v("“Then why would he do this to Armando?”")]), _vm._v(" "), _c('p', [_vm._v("“Let’s hope we can bring him around to his senses. Let me do the talking. Speak when spoken to. Now we’re dressed, I’ll do your hair first.”")]), _vm._v(" "), _c('p', [_vm._v("When they both had each other’s hair done, they woke up Josiah and dressed him in warm clothes. They both put their mink furs around their shoulders.")]), _vm._v(" "), _c('p', [_vm._v("“The boy is here knocking again. You can come in.”")]), _vm._v(" "), _c('p', [_vm._v("“Roseabella, we finally meet in the flesh.”")]), _vm._v(" "), _c('p', [_vm._v("Garrett could not take his eyes of her.")]), _vm._v(" "), _c('p', [_vm._v("“Dada?”")]), _vm._v(" "), _c('p', [_vm._v("“This is Josiah. What a perfect child.”")]), _vm._v(" "), _c('p', [_vm._v("The baby put up his arms to be lifted in Garrett’s arms.")]), _vm._v(" "), _c('p', [_vm._v("“May I Roseabella, he will be perfectly safe.”")]), _vm._v(" "), _c('p', [_vm._v("“Yes, you may Garrett.”")]), _vm._v(" "), _c('p', [_vm._v("Josiah was kicking his legs and laughing with joy in Garrett’s arms.")]), _vm._v(" "), _c('p', [_vm._v("“He thinks you are his father. My husband and you could pass for brothers.”")]), _vm._v(" "), _c('p', [_vm._v("“That makes me happy. And from this moment, I am the boy’s father. No one will tell him the difference.”")]), _vm._v(" "), _c('p', [_vm._v("“It’s what I expected from you, Garrett.”")]), _vm._v(" "), _c('p', [_vm._v("“This is the first time I’ve had happiness since I was turned into a vampire.”")]), _vm._v(" "), _c('p', [_vm._v("Garrett laid down the baby in a play yard full of toys.")]), _vm._v(" "), _c('p', [_vm._v("“Now Roseabella, you will introduce me to this beautiful young woman.”")]), _vm._v(" "), _c('p', [_vm._v("“This Garrett, is my baby sister Gretta.”")]), _vm._v(" "), _c('p', [_vm._v("He took Gretta’s hand and kissed it. (His lips feel like ice).")]), _vm._v(" "), _c('p', [_vm._v("“Nice to meet you, sir.”")]), _vm._v(" "), _c('p', [_vm._v("“Would you ladies like some wine?”")]), _vm._v(" "), _c('p', [_vm._v("“Yes, we would, my sister is allowed to have one goblet full.”")]), _vm._v(" "), _c('p', [_vm._v("“And you my dear?”")]), _vm._v(" "), _c('p', [_vm._v("“Yes please. This wine is good, it tastes like Armando’s.”")]), _vm._v(" "), _c('p', [_vm._v("“I’m glad you like it, Gretta. How old are you, my dear?”")]), _vm._v(" "), _c('p', [_vm._v("“I’ll be fourteen next month.”")]), _vm._v(" "), _c('p', [_vm._v("“No sea sickness so far?”")]), _vm._v(" "), _c('p', [_vm._v("“No sir.”")]), _vm._v(" "), _c('p', [_vm._v("“What about you, Roseabella?”")]), _vm._v(" "), _c('p', [_vm._v("“So far so good.”")]), _vm._v(" "), _c('p', [_vm._v("“Knock on the door.”")]), _vm._v(" "), _c('p', [_vm._v("“Enter.”")]), _vm._v(" "), _c('p', [_vm._v("“Master, your meal is ready.”")]), _vm._v(" "), _c('p', [_vm._v("“You may send them in with the food.”")]), _vm._v(" "), _c('p', [_vm._v("A silver tray was laid down in front of the women, Gretta opened her eyes in surprise; on her plate was a huge lobster.")]), _vm._v(" "), _c('p', [_vm._v("“I love lobster!”")]), _vm._v(" "), _c('p', [_vm._v("Roseabella had the same.")]), _vm._v(" "), _c('p', [_vm._v("“The claws and tail are cracked open, so you can get at it without the juice flying. I got a female with red eggs. Do you eat the eggs?”")]), _vm._v(" "), _c('p', [_vm._v("“Yes, that’s my favorite part.”")]), _vm._v(" "), _c('p', [_vm._v("“And you Roseabella, what is your favorite part?”")]), _vm._v(" "), _c('p', [_vm._v("“The tail dipped into this hot butter.” (Roseabella didn’t have any appetite. She pretended she was enjoying it. Just try to be happy and keep my sister and baby alive)")]), _vm._v(" "), _c('p', [_vm._v("“It tastes so sweet and juicy.”")]), _vm._v(" "), _c('p', [_vm._v("The next course was a white fried fish they never tasted before.")]), _vm._v(" "), _c('p', [_vm._v("“This is nice and flakey. I’m going to mash some fish with cream potatoes for Josiah.”")]), _vm._v(" "), _c('p', [_vm._v("“Let me do that, you haven’t finished your meal yet and there’s dessert.”")]), _vm._v(" "), _c('p', [_vm._v("Garrett mashed up Josiah’s food and fed it to him so gently.")]), _vm._v(" "), _c('p', [_vm._v("“What a big eater you are, my boy.”")]), _vm._v(" "), _c('p', [_vm._v("“He likes seconds.”")]), _vm._v(" "), _c('p', [_vm._v("“Seconds? Ok, let’s mash up some more. I’m going to have more food picked up for you, my boy.”")]), _vm._v(" "), _c('p', [_vm._v("Dessert was brought in, sponge cake with strawberries and raspberries on top with cream.”")]), _vm._v(" "), _c('p', [_vm._v("“That is good, can I feed my nephew some, he loves berries.”")]), _vm._v(" "), _c('p', [_vm._v("“You may, Gretta.”")]), _vm._v(" "), _c('p', [_vm._v("Josiah licked his lips after every spoonful.")]), _vm._v(" "), _c('p', [_vm._v("“Do all babies eat so much?”")]), _vm._v(" "), _c('p', [_vm._v("“No, he’s the biggest one out of all the children his age. He is the smartest one too, he can roll over and pull himself up.”")]), _vm._v(" "), _c('p', [_vm._v("“You love your nephew, don’t you?”")]), _vm._v(" "), _c('p', [_vm._v("“Yes, sir very much.”")]), _vm._v(" "), _c('p', [_vm._v("“Thank you so much for the wonderful meal, Garrett and feeding my son.”")]), _vm._v(" "), _c('p', [_vm._v("“You mean our son.”")]), _vm._v(" "), _c('p', [_vm._v("He looked into Roseabella’s eyes with coldness.")]), _vm._v(" "), _c('p', [_vm._v("“We will get along fine if you remember that. Now, we will take a walk around deck. It’s a beautiful night, a full moon and stars everywhere.”")]), _vm._v(" "), _c('p', [_vm._v("The sky was amazing, she couldn’t stop looking at them. He’s looking up at the stars too.")]), _vm._v(" "), _c('p', [_vm._v("“Look, a shooting star.”")]), _vm._v(" "), _c('p', [_vm._v("“Where?”")]), _vm._v(" "), _c('p', [_vm._v("“Over there!”")]), _vm._v(" "), _c('p', [_vm._v("“Wow, it’s the first shooting star I’ve ever seen.”")]), _vm._v(" "), _c('p', [_vm._v("“You will see more on our adventures, Gretta.”")]), _vm._v(" "), _c('p', [_vm._v("Josiah started yawning and looking for his mother’s breast.")]), _vm._v(" "), _c('p', [_vm._v("“What’s he doing?”")]), _vm._v(" "), _c('p', [_vm._v("“I give him the breast in the night time when he is sleepy.”")]), _vm._v(" "), _c('p', [_vm._v("“You are one lucky boy, my son.”")]), _vm._v(" "), _c('p', [_vm._v("“May we be excused to meet the baby’s needs?”")]), _vm._v(" "), _c('p', [_vm._v("“Of course, my dear. Thank you for a wonderful night,” said Garrett, “I feel like I’m coming alive.”")]), _vm._v(" "), _c('p', [_vm._v("He kissed the baby’s head, “Goodnight, my son.”")]), _vm._v(" "), _c('p', [_vm._v("Josiah waved his hand at Garrett saying, “Dada.”")]), _vm._v(" "), _c('p', [_vm._v("Garrett went back to his cabin and wept red tears.")]), _vm._v(" "), _c('p', [_vm._v("“Thank you, Armando, for your family, I will take good care of them.”")]), _vm._v(" "), _c('p', [_vm._v("“Roseabella, why are you crying?”")]), _vm._v(" "), _c('p', [_vm._v("“I had to sit there and pretend he’s Garrett’s son and Armando doesn’t exist. Josiah thinks Garrett’s his father. The man is not only a vampire but he is delusional. We are dealing with a crazy vampire.”")]), _vm._v(" "), _c('p', [_vm._v("“Roseabella, you are scaring me, please calm down.”")]), _vm._v(" "), _c('p', [_vm._v("“I’m sorry Gretta, I miss my husband so much. This is our first night apart since he brought me to his castle.”")]), _vm._v(" "), _c('p', [_vm._v("“We did well tonight, Roseabella, pretending. He was good to Josiah.”")]), _vm._v(" "), _c('p', [_vm._v("“Yes, he could be a lot worse. We could be scrubbing down the deck! Vampires don’t produce, so they don’t—you know, have sex either?”")]), _vm._v(" "), _c('p', [_vm._v("“I’m afraid they do.”")]), _vm._v(" "), _c('p', [_vm._v("“Will he force you?”")]), _vm._v(" "), _c('p', [_vm._v("“If he does, I’ll put a stake through his heart. If we had one, I packed a few.”")]), _vm._v(" "), _c('p', [_vm._v("“Roseabella, you were a mother to us when we were small, thank you. You taught me how to fight and we’ll both kill him when we get the chance.”")]), _vm._v(" "), _c('p', [_vm._v("“Let’s all get ready for bed.”")]), _vm._v(" "), _c('p', [_vm._v("Roseabella could not sleep.")]), _vm._v(" "), _c('p', [_vm._v("“Armando, I miss you so much, you have to find us. Garrett will never take your place with me. He already has taken your place as Josiah’s father.”")]), _vm._v(" "), _c('p', [_vm._v("Armando, Helewise, Duke and Edder left at daylight. Some of the Duke’s men left to collect the bodies in a wagon and bring them to the castle.")]), _vm._v(" "), _c('p', [_vm._v("“Why would they take the dead man with them?”")]), _vm._v(" "), _c('p', [_vm._v("“So no one in the village could recognize him.”")]), _vm._v(" "), _c('p', [_vm._v("“They took my spear too.”")]), _vm._v(" "), _c('p', [_vm._v("“We will get some made.”")]), _vm._v(" "), _c('p', [_vm._v("“You were so fast that man didn’t see it coming. Let’s follow the carriages tracks.”")]), _vm._v(" "), _c('p', [_vm._v("The track ended on a field with a burnt down carriage.")]), _vm._v(" "), _c('p', [_vm._v("“Their horse tracks, lets follow them.”")]), _vm._v(" "), _c('p', [_vm._v("The horse tracks ended by a brook where the Duke’s horses were grazing. Armando crossed the brook and found the trail again.")]), _vm._v(" "), _c('p', [_vm._v("“This way, follow me.”")]), _vm._v(" "), _c('p', [_vm._v("They came to an old stable.")]), _vm._v(" "), _c('p', [_vm._v("“Young man who owns those horses?”")]), _vm._v(" "), _c('p', [_vm._v("“He never gave me a name, sir.”")]), _vm._v(" "), _c('p', [_vm._v("“Is that their horses, Helewise?”")]), _vm._v(" "), _c('p', [_vm._v("“Yes, all of them.”")]), _vm._v(" "), _c('p', [_vm._v("“When will he be back?”")]), _vm._v(" "), _c('p', [_vm._v("“He gave me enough coin to room them for six months.”")]), _vm._v(" "), _c('p', [_vm._v("“This is not happening, what did this man look like?”")]), _vm._v(" "), _c('p', [_vm._v("“His head was covered, six feet tall maybe, a scar on his chin.”")]), _vm._v(" "), _c('p', [_vm._v("“He was the man in charge Armando, six feet tall and a scar on his chin, I will always remember his face.”")]), _vm._v(" "), _c('p', [_vm._v("“Did they say where they were going?”")]), _vm._v(" "), _c('p', [_vm._v("“I ask and they said to mind my own business.”")]), _vm._v(" "), _c('p', [_vm._v("“Armando, let’s split up. The Duke and Edder, I and you; we’ll go to different villages and ask questions. Someone had to see them. They could be in one of the Inns now.”")]), _vm._v(" "), _c('p', [_vm._v("“Ok, we will meet back here in 5 hours.”")]), _vm._v(" "), _c('p', [_vm._v("Helewise and Armando went to two villages, spoke to people on the streets, in shops and checked all the Inns. No one had seen two girls and a baby. Where has he taken her?")]), _vm._v(" "), _c('p', [_vm._v("“We must go meet up with the others. Maybe they had better luck.”")]), _vm._v(" "), _c('p', [_vm._v("“Did you find out anything, Duke?”")]), _vm._v(" "), _c('p', [_vm._v("“Nothing.”")]), _vm._v(" "), _c('p', [_vm._v("“How can they disappear?”")]), _vm._v(" "), _c('p', [_vm._v("“We must head back to our castle, get some supplies and coin and go to more villages tomorrow.”")]), _vm._v(" "), _c('p', [_vm._v("“Ok, we must check in with Gerrold. He is good at getting information. We’ll take him along.”")]), _vm._v(" "), _c('p', [_vm._v("When Armando and Helewise made it back to the castle, they were exhausted. Armando told Gerrold what took place yesterday, he was in shock.")]), _vm._v(" "), _c('p', [_vm._v("“Garrett is responsible for taking your wife and child? Why would he do this to you?”")]), _vm._v(" "), _c('p', [_vm._v("“Being a vampire has his brain fucked up. We’ll get our supplies ready tonight, weapons and a few men.”")]), _vm._v(" "), _c('p', [_vm._v("“I’ll take your horses to the stable. Hatmanu will take care of them. You need food and rest Armando, to keep up your strength. We won’t give up until we find them.”")]), _vm._v(" "), _c('p', [_vm._v("“Helewise, what are you doing home so soon?”")]), _vm._v(" "), _c('p', [_vm._v("“Meiga and Saige, I have bad news. Roseabella, Josiah and Gretta were kidnapped by men hired by Garrett.”")]), _vm._v(" "), _c('p', [_vm._v("“Almighty god, this can’t be true. Not our lady and that beautiful baby.”")]), _vm._v(" "), _c('p', [_vm._v("Meiga couldn’t stop crying.")]), _vm._v(" "), _c('p', [_vm._v("“Stop crying, Gram. Why don’t we go to the chapel and pray with Father Strickland? Come along Gran, please.”")]), _vm._v(" "), _c('p', [_vm._v("“Yes, we need to pray for their safe return.”")]), _vm._v(" "), _c('p', [_vm._v("“You two go, I’ll get one of the maids to get me a meal and bath ready.”")]), _vm._v(" "), _c('p', [_vm._v("“Father Strickland, Garrett’s men kidnapped Roseabella and the babe.”")]), _vm._v(" "), _c('p', [_vm._v("“How could he do that in sunlight?”")]), _vm._v(" "), _c('p', [_vm._v("“He hired humans to take them to him. Why would he do this to Armando who loved him as a brother?”")]), _vm._v(" "), _c('p', [_vm._v("“Jealousy can make a man do stupid things, Meiga. Let’s pray to God for their safety.”")]), _vm._v(" "), _c('p', [_vm._v("After prayers, Meiga left to pack food for the men to take with them on the search.")]), _vm._v(" "), _c('p', [_vm._v("“Father Strickland, why didn’t I have a vision, it’s not fair. She would be safe with her family. She made me not to be afraid of my visions. What a disappointment I am to her.”")]), _vm._v(" "), _c('p', [_vm._v("“Saige, God works in mysterious ways. There’s a reason for everything, my girl. Go to your room and think about Roseabella and Armando, something will come to you.”")]), _vm._v(" "), _c('p', [_vm._v("“Yes, Father I need to be alone and think about them. Good day Father.”")]), _vm._v(" "), _c('p', [_vm._v("“God be with you, my child.”")]), _vm._v(" "), _c('p', [_vm._v("“I can’t believe Garrett would take the babe, Roseabella and Gretta. Did he ever mention them, Hatmanu?”")]), _vm._v(" "), _c('p', [_vm._v("“No, he said he hated being around his own kind. He missed his life as a human.”")]), _vm._v(" "), _c('p', [_vm._v("“We will need horses ready at first daylight.”")]), _vm._v(" "), _c('p', [_vm._v("“Yes sir.”")]), _vm._v(" "), _c('p', [_vm._v("“And after you’re finished, Saige might need a friend. She thinks a lot of Roseabella.”")]), _vm._v(" "), _c('p', [_vm._v("“I’m so sorry Roseabella, I couldn’t stop him and I failed you!”")]), _vm._v(" "), _c('p', [_vm._v("“It’s the first shooting star I have ever seen.”")]), _vm._v(" "), _c('p', [_vm._v("“You will see a lot more of them on the deck every night, Gretta.”")]), _vm._v(" "), _c('p', [_vm._v("“Oh dear, thank you lord, for giving me this vision. Grandfather, I’m so glad I found you.”")]), _vm._v(" "), _c('p', [_vm._v("“What is it Saige?”")]), _vm._v(" "), _c('p', [_vm._v("“I see them, they are on a big ship with Garrett.”")]), _vm._v(" "), _c('p', [_vm._v("“Armando needs to know your insight, your visions.”")]), _vm._v(" "), _c('p', [_vm._v("“Yes, gramps you are right, we can’t keep it from him anymore.”")]), _vm._v(" "), _c('p', [_vm._v("“Come in! What is it, Gerrold?”")]), _vm._v(" "), _c('p', [_vm._v("“I don’t know how to tell you this.”")]), _vm._v(" "), _c('p', [_vm._v("“Out with it man, I don’t have all night!”")]), _vm._v(" "), _c('p', [_vm._v("“Saige had a vision. She saw Roseabella and the babe on a big ship with Garrett.”")]), _vm._v(" "), _c('p', [_vm._v("“Is this a fucking joke?”")]), _vm._v(" "), _c('p', [_vm._v("“This is not her first vision; your wife was helping her how to cope with them.”")]), _vm._v(" "), _c('p', [_vm._v("“My wife was helping a child with nightmares.”")]), _vm._v(" "), _c('p', [_vm._v("“Lady Roseabella said you wouldn’t believe us. So, she never told you.”")]), _vm._v(" "), _c('p', [_vm._v("“And you are lying, child.”")]), _vm._v(" "), _c('p', [_vm._v("“I saw the vampires in the barn.”")]), _vm._v(" "), _c('p', [_vm._v("“She was the one who gave me the information.”")]), _vm._v(" "), _c('p', [_vm._v("“I had a vision of a castle full of vampires. I also had a vision of crosses and holy water to keep the vampires away.”")]), _vm._v(" "), _c('p', [_vm._v("“My god, what are you?”")]), _vm._v(" "), _c('p', [_vm._v("“She is an angel sent to us from God, Armando to save your family from Garrett and himself.”")]), _vm._v(" "), _c('p', [_vm._v("“And what is that supposed to mean?”")]), _vm._v(" "), _c('p', [_vm._v("“There is still some good in Garrett, Armando. There’s a purpose for everything and miracles. Hatmanu is one miracle, if it wasn’t for Saige, he’d still be tied up in a room and still a slave, living amongst vampires.”")]), _vm._v(" "), _c('p', [_vm._v("“If this is true Saige, then why is your vision too late?”")]), _vm._v(" "), _c('p', [_vm._v("She left in tears.")]), _vm._v(" "), _c('p', [_vm._v("“Your wife is on a ship Armando, I suggest we find out which one.”")]), _vm._v(" "), _c('p', [_vm._v("And Gerrold left. Armando laid down on his bed. This is too much to take in. He drifted off to sleep.")]), _vm._v(" "), _c('p', [_vm._v("“Oh Armando, how much I miss your arms around me. We’re on a boat Armando, please find me.”")]), _vm._v(" "), _c('p', [_vm._v("“Roseabella, I’m so sorry, I’ll find you, my love.”")]), _vm._v(" "), _c('p', [_vm._v("Armando went to the kitchen, hoping to find Saige.")]), _vm._v(" "), _c('p', [_vm._v("“Saige, will you ever forgive me? I know now your visions are true and Garrett is confused with reality. If you have any more visions, come to me at once.”")]), _vm._v(" "), _c('p', [_vm._v("“Yes, Sir Armando and I will forgive you.”")]), _vm._v(" "), _c('p', [_vm._v("“We must check the log book at the docks and every ship date, entering and leaving. And name of ships and owners.”")]), _vm._v(" "), _c('p', [_vm._v("Gerrold and Armando and some of his men checked the village where he was to buy the red horse.")]), _vm._v(" "), _c('p', [_vm._v("“Did you see two young women and a baby getting on a ship yesterday?”")]), _vm._v(" "), _c('p', [_vm._v("“I see people every day coming and going.”")]), _vm._v(" "), _c('p', [_vm._v("“Do you have a ship registered under Garrett Welnach?”")]), _vm._v(" "), _c('p', [_vm._v("“Who wants to know?”")]), _vm._v(" "), _c('p', [_vm._v("“I’m his cousin and he kidnapped my wife and child and her sister.”")]), _vm._v(" "), _c('p', [_vm._v("“No name under Garrett Welnach. But the boat is under his parents’ name. He came in a few months ago and took full ownership of his parents’ ship. He anchored off a little way for a few days. And then left. He left two months ago, according to the book.”")]), _vm._v(" "), _c('p', [_vm._v("“Could he have anchored his ship close by and no one would see it?”")]), _vm._v(" "), _c('p', [_vm._v("“Yes, there are a few coves around with deep water. He would have to go back and forth in row boat.”")]), _vm._v(" "), _c('p', [_vm._v("“Are there any ships to rent to us with a captain?”")]), _vm._v(" "), _c('p', [_vm._v("“The two over there haven’t moved for a while.”")]), _vm._v(" "), _c('p', [_vm._v("It didn’t come cheap for a boat and captain. Armando was prepared to pay whatever it took. Gerrold made sure he wasn’t taken advantage of, in his state of mind.")]), _vm._v(" "), _c('p', [_vm._v("“Now we must find out what route they took.”")]), _vm._v(" "), _c('p', [_vm._v("“How do we find that out? The log book doesn’t know where he went.”")]), _vm._v(" "), _c('p', [_vm._v("“We know what his crew looked like?”")]), _vm._v(" "), _c('p', [_vm._v("“Only one of them. We should have brought Helewise, she got a look at all the men.”")]), _vm._v(" "), _c('p', [_vm._v("“Bring her tomorrow, if needed.”")]), _vm._v(" "), _c('p', [_vm._v("Armando and Gerrold went around and bought supplies to last a month’s voyage. Everywhere they went, they found no information on his family.")]), _vm._v(" "), _c('p', [_vm._v("The next day, Helewise traveled with them.")]), _vm._v(" "), _c('p', [_vm._v("“Armando, if you were a vampire, what would you need to travel over an ocean?”")]), _vm._v(" "), _c('p', [_vm._v("“I guess it would be lots of blood.”")]), _vm._v(" "), _c('p', [_vm._v("“You are right.”")]), _vm._v(" "), _c('p', [_vm._v("“Where would you get blood besides humans?”")]), _vm._v(" "), _c('p', [_vm._v("“What are you getting at Helewise?”")]), _vm._v(" "), _c('p', [_vm._v("“Garrett can’t go killing off his own crew. Unless he has prisoners in the strong hold on the ship. And he doesn’t like vampires. He wants to spend his life, well some life years with humans, so we check the meat slaughter house. To see if anybody had been there for fresh blood.”")]), _vm._v(" "), _c('p', [_vm._v("“You could be right Helewise, it won’t hurt to try.”")]), _vm._v(" "), _c('p', [_vm._v("“Good day sir, what can I help you with today?”")]), _vm._v(" "), _c('p', [_vm._v("“My brother and I are looking for some salted meat for a journey on our ship. We would also like some blood to make blood pudding for our crew. Have you done this thing before?”")]), _vm._v(" "), _c('p', [_vm._v("“Yes, for a while there, we couldn’t keep it on hand.”")]), _vm._v(" "), _c('p', [_vm._v("“Do you know who bought the blood?”")]), _vm._v(" "), _c('p', [_vm._v("“I don’t remember but by God, he looked like your friend there. He came in at night, white skin and black eyes, he gave me the creeps.”")]), _vm._v(" "), _c('p', [_vm._v("“Did you ask him what he wanted it for?”")]), _vm._v(" "), _c('p', [_vm._v("“For a long journey, he told me.”")]), _vm._v(" "), _c('p', [_vm._v("“Was anyone else with him?”")]), _vm._v(" "), _c('p', [_vm._v("“Yes, sometimes a man showed up with him or he was alone.”")]), _vm._v(" "), _c('p', [_vm._v("“Was he tall, lean and a scar on his chin?”")]), _vm._v(" "), _c('p', [_vm._v("“Come to think of it, he did have a scar on his chin and he was bragging about going to the Inn down the road to get a few prostitutes before he hit the sea.”")]), _vm._v(" "), _c('p', [_vm._v("“Did they say what way they were headed?”")]), _vm._v(" "), _c('p', [_vm._v("“No, only depending on good weather, it would take two months.”")]), _vm._v(" "), _c('p', [_vm._v("“When was the last time you saw the man with the scar?”")]), _vm._v(" "), _c('p', [_vm._v("“Last week he came in, that was the first time in a year.”")]), _vm._v(" "), _c('p', [_vm._v("“He was here last week?”")]), _vm._v(" "), _c('p', [_vm._v("“Yes, he needed blood and meat.”")]), _vm._v(" "), _c('p', [_vm._v("“He still didn’t say what route they were taking?”")]), _vm._v(" "), _c('p', [_vm._v("“No but he was talking about a big drunk and the women he was going to have.”")]), _vm._v(" "), _c('p', [_vm._v("“Thank you for your time. Now, we know it’s a two months journey. Let’s go to the next town. There’s an Inn there with prostitutes.”")]), _vm._v(" "), _c('p', [_vm._v("“How do you know that, Gerrold?”")]), _vm._v(" "), _c('p', [_vm._v("“Your brother and Garrett spent a lot of time there. Maybe the women will remember you brother!” (Armando thought about the good times Garrett and himself had)")]), _vm._v(" "), _c('p', [_vm._v("“You are not going in a whore house, sister.”")]), _vm._v(" "), _c('p', [_vm._v("“Why not?”")]), _vm._v(" "), _c('p', [_vm._v("“I’m the one who got the information from the meat man.”")]), _vm._v(" "), _c('p', [_vm._v("“Let her go in Armando, she can handle her own.”")]), _vm._v(" "), _c('p', [_vm._v("“Oh Armando, how degrading for a woman to live like this. Some are younger than me.”")]), _vm._v(" "), _c('p', [_vm._v("“Let’s order drinks and we’ll ask the server some questions.”")]), _vm._v(" "), _c('p', [_vm._v("“Here you go, three ales.”")]), _vm._v(" "), _c('p', [_vm._v("“Keep the change. Last week or a few days ago, did you serve a man who was about six feet, lean built and a scar on his chin? And he came in before maybe with a man who looks like my brother but has white skin and black eyes.”")]), _vm._v(" "), _c('p', [_vm._v("“That scary man with all the money?”")]), _vm._v(" "), _c('p', [_vm._v("“Yes, please tell us.”")]), _vm._v(" "), _c('p', [_vm._v("Helewise gave him some more coin.")]), _vm._v(" "), _c('p', [_vm._v("“This might refresh your memory.”")]), _vm._v(" "), _c('p', [_vm._v("“You are so kind. Well let me see, he went off with two new recruits.”")]), _vm._v(" "), _c('p', [_vm._v("“Just like that?”")]), _vm._v(" "), _c('p', [_vm._v("“Yes, now I remember the man with the scar on his chin picked them out and we haven’t seen the men since a few days ago.”")]), _vm._v(" "), _c('p', [_vm._v("“Do you know where they are headed?”")]), _vm._v(" "), _c('p', [_vm._v("“No, I don’t but the girls might.”")]), _vm._v(" "), _c('p', [_vm._v("“Which one was scar chin with?”")]), _vm._v(" "), _c('p', [_vm._v("“Ask Rueba, they were fighting over her. But your man won.”")]), _vm._v(" "), _c('p', [_vm._v("“Helewise, I’ll take care of Rueba, you stay here sister, and don’t move.”")]), _vm._v(" "), _c('p', [_vm._v("“You must be Rueba?”")]), _vm._v(" "), _c('p', [_vm._v("“Hello good-looking, how did you know my name?”")]), _vm._v(" "), _c('p', [_vm._v("“I was told the prettiest girl at this Inn was named Rueba.”")]), _vm._v(" "), _c('p', [_vm._v("“You are a sweet talker.”")]), _vm._v(" "), _c('p', [_vm._v("“My friend told me you were the best.”")]), _vm._v(" "), _c('p', [_vm._v("“You’re making me blush.”")]), _vm._v(" "), _c('p', [_vm._v("“What was your friend’s name?”")]), _vm._v(" "), _c('p', [_vm._v("“He has many names; you know what I mean? He likes to throw around money. He was here last week; you might remember him.”")]), _vm._v(" "), _c('p', [_vm._v("“Maybe I might.”")]), _vm._v(" "), _c('p', [_vm._v("“Will this help?”")]), _vm._v(" "), _c('p', [_vm._v("“It sure will!”")]), _vm._v(" "), _c('p', [_vm._v("“He is six feet, lean and is a sailor and has a scar on his chin.”")]), _vm._v(" "), _c('p', [_vm._v("“Oh, that one, the big tipper.”")]), _vm._v(" "), _c('p', [_vm._v("“Yes, that’s him. Did he say where he was sailing out to?”")]), _vm._v(" "), _c('p', [_vm._v("“He might have.”")]), _vm._v(" "), _c('p', [_vm._v("Armando gave her a few more coins.")]), _vm._v(" "), _c('p', [_vm._v("“He said he was heading south where it stayed warm all year round.”")]), _vm._v(" "), _c('p', [_vm._v("“That’s all?”")]), _vm._v(" "), _c('p', [_vm._v("“He might have—a few more of them coins might trigger it. They found a private island hidden from view.”")]), _vm._v(" "), _c('p', [_vm._v("“That’s it?”")]), _vm._v(" "), _c('p', [_vm._v("“Yelp.”")]), _vm._v(" "), _c('p', [_vm._v("“Now, come on upstairs honey and I’ll show you a good time.”")]), _vm._v(" "), _c('p', [_vm._v("Armando heard a crash.")]), _vm._v(" "), _c('p', [_vm._v("When Armando turned around, Helewise had a knife up to a man’s throat.")]), _vm._v(" "), _c('p', [_vm._v("“What’s going on?”")]), _vm._v(" "), _c('p', [_vm._v("“This dirty bastard asks me what I charged.”")]), _vm._v(" "), _c('p', [_vm._v("Gerrold came inside the door and Armando was laughing.")]), _vm._v(" "), _c('p', [_vm._v("“What did I miss? Armando, I left her alone for one minute, I swear to water the grass.”")]), _vm._v(" "), _c('p', [_vm._v("“He thinks Helewise is a prostitute. Don’t you laugh too! This young woman is my sister and if you come near her again, I’ll cut off your head.”")]), _vm._v(" "), _c('p', [_vm._v("He was gone in a flash.")]), _vm._v(" "), _c('p', [_vm._v("“We better get going, soon it will be dark.”")]), _vm._v(" "), _c('p', [_vm._v("“So, what did you get out of her?”")]), _vm._v(" "), _c('p', [_vm._v("“All she knew was he’s headed to a warm private island toward south. An island no one else can see.”")]), _vm._v(" "), _c('p', [_vm._v("“That tells us a lot.”")]), _vm._v(" "), _c('p', [_vm._v("“Ok Armando, we head south to warm weather all year round, where we know will be warm all year round!”")]), _vm._v(" "), _c('p', [_vm._v("“I just thought of something!”")]), _vm._v(" "), _c('p', [_vm._v("“What, Armando?”")]), _vm._v(" "), _c('p', [_vm._v("“They have Josiah who needs fresh fruit and vegetables and fresh meat. The women won’t eat rotten food like the sailors do. They need to stop in different ports for supplies. People might know where they’re going.”")]), _vm._v(" "), _c('p', [_vm._v("“There’re not that stupid to give out information.”")]), _vm._v(" "), _c('p', [_vm._v("“When men go to port, they go for drink and women. Money makes men brag when drunk and don’t forget a new supply of blood. Gerrold, go and let the captain know we are leaving in a weeks’ time.”")]), _vm._v(" "), _c('p', [_vm._v("Morgania was staying upstairs of the Inn, the sun was setting and she had thick black curtains. When she opened, the curtain for a little peek in the shade.")]), _vm._v(" "), _c('p', [_vm._v("“This can’t be Garrett walking around in daylight! He’s tanned and the hair is a little lighter brown.”")]), _vm._v(" "), _c('p', [_vm._v("Armando felt like someone was watching him, he looked up and saw a small opening in a curtain.")]), _vm._v(" "), _c('p', [_vm._v("“It’s not Garrett, his eyes are a blue color.”")]), _vm._v(" "), _c('p', [_vm._v("“Armando, what are you looking at?”")]), _vm._v(" "), _c('p', [_vm._v("“I saw a curtain move.”")]), _vm._v(" "), _c('p', [_vm._v("“So what, let’s go.”")]), _vm._v(" "), _c('p', [_vm._v("“That’s got to be Garrett’s cousin Armando! They could pass for brothers. That bastard Garrett left in his ship without me. He told me I never had a chance to revenge his cousin because Armando keeps his castle too well-guarded. But I have made a few new vampires since then, Garrett and they are trained by me. We’ll see you in a few days Armando, your blood will be mine. I might turn you like your cousin Garrett. Then together, we can hunt him down.”")]), _vm._v(" "), _c('p', [_vm._v("“Father Strickland! I had another vision. Where are you, father?”")]), _vm._v(" "), _c('p', [_vm._v("“Calm down child, I’m over here.”")]), _vm._v(" "), _c('p', [_vm._v("“I had another vision, father and it was terrible.”")]), _vm._v(" "), _c('p', [_vm._v("“Take your time and start at the beginning.”")]), _vm._v(" "), _c('p', [_vm._v("“It was Morgania, the woman vampire who captured Hatmanu.”")]), _vm._v(" "), _c('p', [_vm._v("“What about her?”")]), _vm._v(" "), _c('p', [_vm._v("“She has a new army of vampires. She’s coming to attack us. The gates were on fires and they made it inside.”")]), _vm._v(" "), _c('p', [_vm._v("“There, there now child, we must talk to Armando and your grandfather.”")]), _vm._v(" "), _c('p', [_vm._v("“Will you go with me, Father?”")]), _vm._v(" "), _c('p', [_vm._v("“Yes of course. Armando is not the same since his family went missing.”")]), _vm._v(" "), _c('p', [_vm._v("Armando, Gerrold and Hatmanu were wiping down the horses.")]), _vm._v(" "), _c('p', [_vm._v("“Good evening father, it’s a little late for riding.”")]), _vm._v(" "), _c('p', [_vm._v("“I’m not here to go riding, Armando.”")]), _vm._v(" "), _c('p', [_vm._v("“Gramps you’re back! I’m so glad you are safe.”")]), _vm._v(" "), _c('p', [_vm._v("“What’s wrong, Saige?”")]), _vm._v(" "), _c('p', [_vm._v("Saige looked at the priest.")]), _vm._v(" "), _c('p', [_vm._v("“Saige had another vision.”")]), _vm._v(" "), _c('p', [_vm._v("“Is it of Roseabella?”")]), _vm._v(" "), _c('p', [_vm._v("“No, I’m afraid not. It’s worse in a way.”")]), _vm._v(" "), _c('p', [_vm._v("“What could be worse than my family being taken away from me?”")]), _vm._v(" "), _c('p', [_vm._v("“Calm down Armando, I pray for your family every day.”")]), _vm._v(" "), _c('p', [_vm._v("Saige said, “They’re coming, Sir Armando.”")]), _vm._v(" "), _c('p', [_vm._v("“Who child, are you talking about?”")]), _vm._v(" "), _c('p', [_vm._v("“Morgania and the new vampires she turned. They are trained and got inside the gates.”")]), _vm._v(" "), _c('p', [_vm._v("“How could they get in?”")]), _vm._v(" "), _c('p', [_vm._v("“They caught the gates on fire.”")]), _vm._v(" "), _c('p', [_vm._v("“Dear Jesus,” said Armando, “what else can go wrong? How much time do we have, Saige?”")]), _vm._v(" "), _c('p', [_vm._v("“Two days.”")]), _vm._v(" "), _c('p', [_vm._v("“Father, ring the church bells; you must tell everyone to gather in the court yard.”")]), _vm._v(" "), _c('p', [_vm._v("“Good idea, Armando.”")]), _vm._v(" "), _c('p', [_vm._v("He said to Saige, “How many vampires does she have?”")]), _vm._v(" "), _c('p', [_vm._v("“I saw forty with weapons.”")]), _vm._v(" "), _c('p', [_vm._v("“She’s coming for me,” said Hatmanu, “I’ll kill myself before she gets me.”")]), _vm._v(" "), _c('p', [_vm._v("“Hush Hatmanu, we trained you well. You’re not a defenseless child anymore. Show her how strong you became.”")]), _vm._v(" "), _c('p', [_vm._v("“I’m sorry that I shame you. I will kill her myself if she harms Saige or Meiga.”")]), _vm._v(" "), _c('p', [_vm._v("“Now, that’s the man I know.”")]), _vm._v(" "), _c('p', [_vm._v("“Hatmanu, you must not tell anyone about Saige’s visions.”")]), _vm._v(" "), _c('p', [_vm._v("“Yes of course, Father Strickland.”")]), _vm._v(" "), _c('p', [_vm._v("“Saige, are you ok?”")]), _vm._v(" "), _c('p', [_vm._v("“Yes.”")]), _vm._v(" "), _c('p', [_vm._v("“Saige is our angel sent from God to help protect us from this venom. Saige, go get some food for you and Hatmanu, people will meet soon.”")]), _vm._v(" "), _c('p', [_vm._v("“Everyone be quiet. We have some important news to tell you. Armando and Gerrold heard today in the village that there’s going to be an attack on us in two days by vampires.”")]), _vm._v(" "), _c('p', [_vm._v("At first, everyone was speechless.")]), _vm._v(" "), _c('p', [_vm._v("“We’re going to die, we’re going to die!”")]), _vm._v(" "), _c('p', [_vm._v("Every old woman and young child were crying. Father Strickland rung his bell, he sometimes carried around villages who did not have a church.")]), _vm._v(" "), _c('p', [_vm._v("“Master Armando would like to speak with you.”")]), _vm._v(" "), _c('p', [_vm._v("“My people, this should not be a surprise. We’ve been training for this day now for over a year. We have new weapons, the spear thrower. My seventeen-year-old sister Helewise speared a man who was one of the kidnappers, who took my family. Helewise speared him right through the neck.")]), _vm._v(" "), _c('p', [_vm._v("Older women and younger children will remain inside the castle with their crosses around their necks. There will be holy water all around the top of the castle, stored in tubs, baskets, everything you can gather that can hold water, bring it tomorrow. We will be waiting for them. Aim for the heart and they will turn to ashes. If you can’t strike the heart, chop off their heads. Tomorrow, we train to do battle.”")]), _vm._v(" "), _c('p', [_vm._v("“Can you please tell me how you got information about the vampires? You damn well didn’t know about it today. So, what’s going on?”")]), _vm._v(" "), _c('p', [_vm._v("“Helewise, nothing’s going on.”")]), _vm._v(" "), _c('p', [_vm._v("“Don’t lie to me, Armando.”")]), _vm._v(" "), _c('p', [_vm._v("“Ok, Father Strickland has a friend who has the insight. His friend sees visions.”")]), _vm._v(" "), _c('p', [_vm._v("“You are kidding me, right?”")]), _vm._v(" "), _c('p', [_vm._v("“That’s what I said too at first.”")]), _vm._v(" "), _c('p', [_vm._v("“So, you brother believe in this crap?”")]), _vm._v(" "), _c('p', [_vm._v("“Yes, I do. Father’s friend showed us three places where the vampires were staying and we slaughtered them.”")]), _vm._v(" "), _c('p', [_vm._v("“Who is this friend, Armando?”")]), _vm._v(" "), _c('p', [_vm._v("“Only Father Strickland can tell you that but he won’t, he doesn’t want to put his friend’s life in danger. He told me his friend is an angel from God, sent to protect the human race against vampires.”")]), _vm._v(" "), _c('p', [_vm._v("“If no vampires show up in two nights, I will knock you to the ground for lying to me.”")]), _vm._v(" "), _c('p', [_vm._v("“I swear Helewise, on my son and Roseabella’s life.”")]), _vm._v(" "), _c('p', [_vm._v("“I don’t know what to say, it must be true because I know you would never swear on their lives.”")]), _vm._v(" "), _c('p', [_vm._v("Helewise then ran into her brother’s arms.")]), _vm._v(" "), _c('p', [_vm._v("“Oh Armando, I miss them too. I miss Josiah’s sloppy wet kisses and Roseabella’s fighting skills.”")]), _vm._v(" "), _c('p', [_vm._v("“When this war is over, we’re going to find them even if it’s the last thing I do.”")]), _vm._v(" "), _c('p', [_vm._v("“It’s been two weeks now since we left our home Roseabella.”")]), _vm._v(" "), _c('p', [_vm._v("“I do know that, Gretta.”")]), _vm._v(" "), _c('p', [_vm._v("“When are we going to stop for supplies?”")]), _vm._v(" "), _c('p', [_vm._v("“Pretty soon, the baby has run out of fresh fruit. Gretta, how is your friendship going with the boy?”")]), _vm._v(" "), _c('p', [_vm._v("“All he talks about is what a great guy Garrett is.”")]), _vm._v(" "), _c('p', [_vm._v("“In what way?”")]), _vm._v(" "), _c('p', [_vm._v("“He told me Garrett found him a year ago going through garbage looking for some food for his family. He said his father ran off; his mother lost her job because of sickness. He also has two brothers and two sisters younger than him. And Garrett gave him money for his family and offered him a job.”")]), _vm._v(" "), _c('p', [_vm._v("“He must have a name then.”")]), _vm._v(" "), _c('p', [_vm._v("“His father was a violent man. Boy do this, boy do that. Do you want another slap boy?”")]), _vm._v(" "), _c('p', [_vm._v("“That poor kid, I’m glad Garrett helped him.”")]), _vm._v(" "), _c('p', [_vm._v("“It doesn’t make sense, we’re prisoners on this ship by Garrett and his entire crew worships him.”")]), _vm._v(" "), _c('p', [_vm._v("“Yes, I know Gretta, sometimes I feel like jumping overboard.”")]), _vm._v(" "), _c('p', [_vm._v("“Don’t say that Roseabella, don’t leave me all alone.”")]), _vm._v(" "), _c('p', [_vm._v("“Are we turning and slowing down?”")]), _vm._v(" "), _c('p', [_vm._v("“I’ll check on deck.”")]), _vm._v(" "), _c('p', [_vm._v("“Be careful, Gretta.”")]), _vm._v(" "), _c('p', [_vm._v("“Why are we slowing down, boy?”")]), _vm._v(" "), _c('p', [_vm._v("“We are going in to a port and picking up supplies.”")]), _vm._v(" "), _c('p', [_vm._v("“And are you going in?”")]), _vm._v(" "), _c('p', [_vm._v("“No not this time.”")]), _vm._v(" "), _c('p', [_vm._v("“Why not?” asked Gretta.")]), _vm._v(" "), _c('p', [_vm._v("“Too much poverty.”")]), _vm._v(" "), _c('p', [_vm._v("“What do you mean?”")]), _vm._v(" "), _c('p', [_vm._v("The boy said, “I went to one, and I was just a hungry child, homeless living on the streets begging for coin. There was dirt and trash everywhere.”")]), _vm._v(" "), _c('p', [_vm._v("Gretta said, “This one could be different.”")]), _vm._v(" "), _c('p', [_vm._v("“The other men say the same but they like to go for a drink and prostitutes.”")]), _vm._v(" "), _c('p', [_vm._v("“And you don’t like to do that?”")]), _vm._v(" "), _c('p', [_vm._v("“No, I don’t, I save all my money to send home to my family.”")]), _vm._v(" "), _c('p', [_vm._v("“Can you please tell me your real name? Your mother must have given you one.”")]), _vm._v(" "), _c('p', [_vm._v("“Yes, she did.”")]), _vm._v(" "), _c('p', [_vm._v("“Ok, tell me then, don’t leave me guessing.”")]), _vm._v(" "), _c('p', [_vm._v("“My name is Rueband.”")]), _vm._v(" "), _c('p', [_vm._v("“Rueband is a good name.”")]), _vm._v(" "), _c('p', [_vm._v("“Yes but could you call me boy around other people.”")]), _vm._v(" "), _c('p', [_vm._v("“Yes, I will and how old are you?”")]), _vm._v(" "), _c('p', [_vm._v("“Why do you ask so many questions?”")]), _vm._v(" "), _c('p', [_vm._v("“What else am I supposed to do on this ship? We’re here against our will. My sister was taken away from her husband who she loves. A baby who will never know his real father. And me taken from my mother, father, sister and brother.”")]), _vm._v(" "), _c('p', [_vm._v("“Please, please don’t cry, Gretta, I’d help you if I could.”")]), _vm._v(" "), _c('p', [_vm._v("“You mean that?”")]), _vm._v(" "), _c('p', [_vm._v("“Yes.”")]), _vm._v(" "), _c('p', [_vm._v("“Can you be my friend?”")]), _vm._v(" "), _c('p', [_vm._v("“Yes, we will be good friends.”")]), _vm._v(" "), _c('p', [_vm._v("“Thank you, Rueband.”")]), _vm._v(" "), _c('p', [_vm._v("“How did it go, Gretta?”")]), _vm._v(" "), _c('p', [_vm._v("“His name is Rueband and we’re becoming best friends. Most ports are slums and the men pick up the supplies, then drink and spend time with prostitutes.”")]), _vm._v(" "), _c('p', [_vm._v("“He told you all this in thirty minutes?”")]), _vm._v(" "), _c('p', [_vm._v("“Yes, he did and more besides. He told me he sends all his money home to his family.”")]), _vm._v(" "), _c('p', [_vm._v("“That’s good of him but how does that help us.”")]), _vm._v(" "), _c('p', [_vm._v("“Don’t you see, we can put a message in with his money; with Armando’s name on it.”")]), _vm._v(" "), _c('p', [_vm._v("“My sister, you are amazing.”")]), _vm._v(" "), _c('p', [_vm._v("“Tonight, you must ask Garrett, can Rueband play cards with you. And I will encourage him to say yes.”")]), _vm._v(" "), _c('p', [_vm._v("“I wouldn’t mind a game of cards. Do you have any money?”")]), _vm._v(" "), _c('p', [_vm._v("“You’re not playing poker.”")]), _vm._v(" "), _c('p', [_vm._v("“What about gin?”")]), _vm._v(" "), _c('p', [_vm._v("“Ok, Roseabella as long as it’s not fish.”")]), _vm._v(" "), _c('p', [_vm._v("“Let’s all three of us go up on deck for some fresh air and see what port their pulling into.”")]), _vm._v(" "), _c('p', [_vm._v("Helewise had all her trained women spread out. They were carrying their spears. Real swords this time and a bow and arrows, tied on their backs. Extra men were up on the lookout. Guards posted all around the top of the walls. Saige was standing by Helewise.")]), _vm._v(" "), _c('p', [_vm._v("“You are a good jumper, could you run and jump like those vampires? If you knock them to the ground, I could stake them.”")]), _vm._v(" "), _c('p', [_vm._v("Then, they heard shouting.")]), _vm._v(" "), _c('p', [_vm._v("“Fire! The gates on fire!”")]), _vm._v(" "), _c('p', [_vm._v("One of the guards came falling down with an arrow in his neck. Then, another one screamed out in pain.")]), _vm._v(" "), _c('p', [_vm._v("“Ok, we aim all together and shoot!”")]), _vm._v(" "), _c('p', [_vm._v("No one was down but some wounded. Saige and Helewise climbed up to the top of the walls.")]), _vm._v(" "), _c('p', [_vm._v("“Wait, let’s dip our arrows in holy water. You take the one on the left and I’ll take the right.”")]), _vm._v(" "), _c('p', [_vm._v("Saige’s arrow went through his heart and he turned to ashes. Helewise’s arrow struck his stomach. The holy water had him screaming, smoke was coming from his gut.")]), _vm._v(" "), _c('p', [_vm._v("“Put out the fire! Throw down the buckets of water.”")]), _vm._v(" "), _c('p', [_vm._v("Smoke was rising up everywhere from the gate, no one could see.")]), _vm._v(" "), _c('p', [_vm._v("Morgania saw her chance.")]), _vm._v(" "), _c('p', [_vm._v("“You men throw up the rope with the hook on it, over there by the smoke.”")]), _vm._v(" "), _c('p', [_vm._v("The hook was thrown and struck!")]), _vm._v(" "), _c('p', [_vm._v("“Now climb, you shit heads.”")]), _vm._v(" "), _c('p', [_vm._v("Three made it over. Guards fought them with their swords. The vampires were faster, three of Armando’s men were down. Armando ran for the vampire, jumping and kicked him down. Then, Gerrold had his chance; took his axe and chopped off his head.")]), _vm._v(" "), _c('p', [_vm._v("“We got one, two more to go.”")]), _vm._v(" "), _c('p', [_vm._v("Armando was on his own with this one, strike for strike with their swords. The vampire hit Armando’s sword out of his hand.")]), _vm._v(" "), _c('p', [_vm._v("Armando then backed up, the vampire took a swing at him. (This is it, I will never see you, my wife)")]), _vm._v(" "), _c('p', [_vm._v("“I get to kill Sir Armando, now you are mine.”")]), _vm._v(" "), _c('p', [_vm._v("The sword then dropped out of the vampire’s hand. Armando saw a spear, looked over and Helewise gave him a thumbs up. More were coming over and jumping to the ground. The twins rushed them and knocked them down.")]), _vm._v(" "), _c('p', [_vm._v("Speared them through the heart before they got a chance to get back up.")]), _vm._v(" "), _c('p', [_vm._v("One had Hatmanu to the ground, ready to feed. Hatmanu took out his cross and put it on the vampire’s forehead. The vampire screeched and turn to ashes. Hatmanu rolled away from the ashes. When he looked up, he saw Father Strickland with a stake in his hand.")]), _vm._v(" "), _c('p', [_vm._v("“I’ve been practicing too, my boy.”")]), _vm._v(" "), _c('p', [_vm._v("Helewise was backed against two vampires, Saige threw her spear from fifty feet, one vampire went down and the other vampire looked at the ashes. This gave Helewise a chance; with a hard strike to his neck and its head dropped to the ground. Gerrold was attacked from behind and knocked to the ground. The vampire lifted Gerrold’s head off the ground with his two hands.")]), _vm._v(" "), _c('p', [_vm._v("“I’m going to bite your throat.”")]), _vm._v(" "), _c('p', [_vm._v("“No, you won’t.” as Hatmanu stabbed the vampire through his back and went through his heart.")]), _vm._v(" "), _c('p', [_vm._v("“Move, Gerrold before the ashes burn you.”")]), _vm._v(" "), _c('p', [_vm._v("“Hatmanu, thanks son.”")]), _vm._v(" "), _c('p', [_vm._v("“You’re welcome.”")]), _vm._v(" "), _c('p', [_vm._v("Another woman in Helewise’s group was pushed down and knocked out. Saige jumped from the top of the wall and landed on the vampire’s back. She didn’t have a weapon. The vamp went down with Saige as they were both knocked to the ground. The vampire then jumped on her saying:")]), _vm._v(" "), _c('p', [_vm._v("“What a pretty little girl, does your blood taste as sweet as your looks?”")]), _vm._v(" "), _c('p', [_vm._v("Saige took out her cross from her shirt.")]), _vm._v(" "), _c('p', [_vm._v("“God wants you to have this” and his face was then on fire. And this is when a stake went through his heart.")]), _vm._v(" "), _c('p', [_vm._v("Saige moved away from the ashes. One of the twins were down, bleeding from her leg and arms.")]), _vm._v(" "), _c('p', [_vm._v("“No one fucks with my sister.” The twin sister then took her spear and before the vampire could turn around, it was too late; it was chopped in the neck with such force that sent it flying.")]), _vm._v(" "), _c('p', [_vm._v("Saige heard a banging over the castle wall.")]), _vm._v(" "), _c('p', [_vm._v("“Let me in, let me in.”")]), _vm._v(" "), _c('p', [_vm._v("“They will never let you in.”")]), _vm._v(" "), _c('p', [_vm._v("Morgania looked around and saw a little girl.")]), _vm._v(" "), _c('p', [_vm._v("“Well, look at you, a girl soldier.”")]), _vm._v(" "), _c('p', [_vm._v("“I’ve been waiting for you, Morgania for eleven years.”")]), _vm._v(" "), _c('p', [_vm._v("“How do you know my name?”")]), _vm._v(" "), _c('p', [_vm._v("“I know everything about you. You’re two hundred years old. Your favorite victims are young children and you torture them. That’s why Garrett could not stomach you.”")]), _vm._v(" "), _c('p', [_vm._v("“And how do you know all of this, you are a child.”")]), _vm._v(" "), _c('p', [_vm._v("“A child sent from God to wipe out your race.”")]), _vm._v(" "), _c('p', [_vm._v("Morgania ran for Saige. Saige was too fast, she jumped up and landed behind Morgania.")]), _vm._v(" "), _c('p', [_vm._v("“Behind you!”")]), _vm._v(" "), _c('p', [_vm._v("“I like your moves, girl.”")]), _vm._v(" "), _c('p', [_vm._v("She ran for Saige again. Morgania was knocked down, this time with a kick to the chin.")]), _vm._v(" "), _c('p', [_vm._v("“Now you are making me fucking mad.”")]), _vm._v(" "), _c('p', [_vm._v("She jumped up on her feet and this time took out her knife. Saige then kicked up her leg and the knife went flying. Saige was grabbed from behind and the other vampire said:")]), _vm._v(" "), _c('p', [_vm._v("“Morgania, you can’t fight a little girl?”")]), _vm._v(" "), _c('p', [_vm._v("“This is no little girl; she has the strength of ten men.”")]), _vm._v(" "), _c('p', [_vm._v("“Will her blood make us stronger?”")]), _vm._v(" "), _c('p', [_vm._v("The male vamp went flying over Saige’s shoulder.")]), _vm._v(" "), _c('p', [_vm._v("“I told you she was strong. She can’t handle the two of us, let’s charge at the same time.”")]), _vm._v(" "), _c('p', [_vm._v("Saige took out her stake, threw it and it went straight through his heart. Morgania had her hands around Saige’s throat and raised her off the ground. Saige couldn’t breathe.")]), _vm._v(" "), _c('p', [_vm._v("“Morgania, remember me?”")]), _vm._v(" "), _c('p', [_vm._v("Morgania looked around.")]), _vm._v(" "), _c('p', [_vm._v("“You got to be fucking kidding me. It’s my boy slave. You get the fuck out of here or I’ll rip your throat out. No, I’ll just take you back and tie you up again.”")]), _vm._v(" "), _c('p', [_vm._v("From behind his back, he threw a small bucket of holy water in her face.")]), _vm._v(" "), _c('p', [_vm._v("“You’re not so pretty now, are you?”")]), _vm._v(" "), _c('p', [_vm._v("Morgania dropped her hands from Saige’s neck and screamed.")]), _vm._v(" "), _c('p', [_vm._v("“That’s for turning Garrett and this is for me.”")]), _vm._v(" "), _c('p', [_vm._v("She looked at him, he ran toward her with his spike and with both hands, he plunged it into her heart. He went to Saige and hugged her.")]), _vm._v(" "), _c('p', [_vm._v("“We’re family now. We’ll always watch each other’s back.”")]), _vm._v(" "), _c('p', [_vm._v("Everyone was running and jumping for joy.")]), _vm._v(" "), _c('p', [_vm._v("“We won. We won.”")]), _vm._v(" "), _c('p', [_vm._v("They were all dead or ran off with their tail between their legs.")]), _vm._v(" "), _c('p', [_vm._v("“How many did we lose?”")]), _vm._v(" "), _c('p', [_vm._v("“Ten men dead, ten injured. And Saige, one of the twins has lost a lot of blood.”")]), _vm._v(" "), _c('p', [_vm._v("“I will go to her now.”")]), _vm._v(" "), _c('p', [_vm._v("The twin was lying in bed, bandages were wrapped on her arms and legs.")]), _vm._v(" "), _c('p', [_vm._v("“How’s your sister?”")]), _vm._v(" "), _c('p', [_vm._v("“She lost a lot of blood, unconscious and is burning up.”")]), _vm._v(" "), _c('p', [_vm._v("Saige asked, “Have her cuts been stitched yet?”")]), _vm._v(" "), _c('p', [_vm._v("“Yes.”")]), _vm._v(" "), _c('p', [_vm._v("“Ok, I’ll stay with her so you can go get cleaned up. You have blood all over you. Vamp blood smells. Go to my room and wash up.”")]), _vm._v(" "), _c('p', [_vm._v("“Ok,” said the twin, “thanks.”")]), _vm._v(" "), _c('p', [_vm._v("Saige prayed, “Dear god, this woman is a great warrior. She helped save her people today. We need her for many more battles to come. Can you leave her behind with us?”")]), _vm._v(" "), _c('p', [_vm._v("Saige put her hands on the woman’s heart.")]), _vm._v(" "), _c('p', [_vm._v("“You’re awake! Everyone is so worried about you.”")]), _vm._v(" "), _c('p', [_vm._v("“Where is my sister?”")]), _vm._v(" "), _c('p', [_vm._v("“She is gone to wash off the vampire blood.”")]), _vm._v(" "), _c('p', [_vm._v("“So, she’s alive?”")]), _vm._v(" "), _c('p', [_vm._v("“Yes, of course.”")]), _vm._v(" "), _c('p', [_vm._v("The twin said, “I felt like we were drifting apart.”")]), _vm._v(" "), _c('p', [_vm._v("“You were a good warrior today; God has kept you both together.”")]), _vm._v(" "), _c('p', [_vm._v("The twin came back from getting rid of the vampire blood.")]), _vm._v(" "), _c('p', [_vm._v("“You’re awake? I thought you were dying.”")]), _vm._v(" "), _c('p', [_vm._v("“God told me to go back, said he’s not done with me yet on earth. Something about more battles to fight.”")]), _vm._v(" "), _c('p', [_vm._v("“Sister, your temperature has you delirious.”")]), _vm._v(" "), _c('p', [_vm._v("“No, I feel good, I’m so hungry and I could use an ale. I’ll go ask Grams for some food and drink. Thank you, Saige.”")]), _vm._v(" "), _c('p', [_vm._v("“That’s what friends are for!”")]), _vm._v(" "), _c('p', [_vm._v("Everyone celebrated and drank to the dead. Even Saige and Hatmanu had wine.")]), _vm._v(" "), _c('p', [_vm._v("“You two did a wonderful job tonight killing those vampires.”")]), _vm._v(" "), _c('p', [_vm._v("“Our training paid off.”")]), _vm._v(" "), _c('p', [_vm._v("“Gerrold said next week, I and Armando leave on a ship to find his family.”")]), _vm._v(" "), _c('p', [_vm._v("“I must go to Grandfather.”")]), _vm._v(" "), _c('p', [_vm._v("“No child, you stay here and look out for your grandmother.”")]), _vm._v(" "), _c('p', [_vm._v("“What good are my visions if I can’t tell them to you?”")]), _vm._v(" "), _c('p', [_vm._v("“Oh, alright I will talk to Armando. We all need to get cleaned up and get some sleep. Wait Saige, I need to talk to you alone.”")]), _vm._v(" "), _c('p', [_vm._v("“Yes of course, Gramps.”")]), _vm._v(" "), _c('p', [_vm._v("“When Morgania had you by the throat, why didn’t you kick her or take out your cross?”")]), _vm._v(" "), _c('p', [_vm._v("“I was going to kick her to the ground and put a stake through her heart. Then, I saw Hatmanu running toward us. He needed to be the one to kill her and let his nightmares end. Gramps, he’ll be a good warrior one day.”")]), _vm._v(" "), _c('p', [_vm._v("“I am so proud of you, Granddaughter.”")]), _vm._v(" "), _c('p', [_vm._v("“How’s the patient today?”")]), _vm._v(" "), _c('p', [_vm._v("“Father Strickland, how nice of you to visit me.”")]), _vm._v(" "), _c('p', [_vm._v("“We are fond of our women fighters, you all make me feel proud, the way you protected each other. Your twin! I could not believe my eyes.”")]), _vm._v(" "), _c('p', [_vm._v("“Tell me about that father.”")]), _vm._v(" "), _c('p', [_vm._v("“Well, you were on the ground bleeding out and the vampire was going to finish you off. Your sister was not going to let that happen. She threw a spear in the vamp’s leg and with such force, the head went flying.”")]), _vm._v(" "), _c('p', [_vm._v("“My sister saved my life. She never told me. Twins have a special bond, don’t they? I think I died, there was this bright light and I was floating toward it. I heard this voice saying, go back child, where you are needed on earth, there are more battles to come. I woke up and Saige was there, she told us God kept me and my sister together.”")]), _vm._v(" "), _c('p', [_vm._v("“Our Saige is a wise child. She spends time in the church with me.”")]), _vm._v(" "), _c('p', [_vm._v("“And Father, was I dreaming or did you turn one of the vampires into ashes?”")]), _vm._v(" "), _c('p', [_vm._v("“Yes, Hatmanu just came to be one of us, I couldn’t let his life be taken away so soon.”")]), _vm._v(" "), _c('p', [_vm._v("“God has plans for you and Hatmanu.”")]), _vm._v(" "), _c('p', [_vm._v("“He does and yes, he sent you back.”")]), _vm._v(" "), _c('p', [_vm._v("Rueband and Gretta were on the deck watching the dolphins playing.")]), _vm._v(" "), _c('p', [_vm._v("“Here they come, back from the little port, lets help them with the cargo.”")]), _vm._v(" "), _c('p', [_vm._v("After the purchases was unloaded, Rueband took the meats, fruit, and vegetables down to the cook.")]), _vm._v(" "), _c('p', [_vm._v("“You are one pretty little girl, young Gretta,” said the sailor. “Your body has ripened. You’re ready for a man now, not that boy.”")]), _vm._v(" "), _c('p', [_vm._v("“Boy is more a man then the likes of you!”")]), _vm._v(" "), _c('p', [_vm._v("“I’ll show you what a real man feels like.”")]), _vm._v(" "), _c('p', [_vm._v("“Let me go, you dirty pig.”")]), _vm._v(" "), _c('p', [_vm._v("He held her against the rail of the ship. He grabbed her breast in his hands. Gretta tried to push him off but he was a big man.")]), _vm._v(" "), _c('p', [_vm._v("“Take this you animal.” And with her long nails, she savagely clawed into his face.")]), _vm._v(" "), _c('p', [_vm._v("“You little bitch,” and with his hand, he slapped her across her face. Then, Rueband was on his back in no time.")]), _vm._v(" "), _c('p', [_vm._v("“You leave her alone, you fucking drunk.”")]), _vm._v(" "), _c('p', [_vm._v("Rueband was thrown down and the cook kicked him in the stomach.")]), _vm._v(" "), _c('p', [_vm._v("“Stop it, stop it, you’re killing him.” And with her foot, Gretta gave him a swift kick in his manhood parts. He dropped to the ground. Garrett’s man in charge came over.")]), _vm._v(" "), _c('p', [_vm._v("“Are you alright, young Gretta?”")]), _vm._v(" "), _c('p', [_vm._v("“He tried to force himself on me!”")]), _vm._v(" "), _c('p', [_vm._v("“I was just having a little fun.”")]), _vm._v(" "), _c('p', [_vm._v("“The boy is hurt, he came to my rescue. He’s unconscious. He was thrown down and stuck his head on the huge piece of iron.”")]), _vm._v(" "), _c('p', [_vm._v("“Get the doctor! Go man, hurry it up. He needs blankets, go get some.” He shouted to his men. “Fuck, Garrett is going to kill you, you son of a bitch.”")]), _vm._v(" "), _c('p', [_vm._v("“Oh, he’ll be alright, just needs some toughening up.”")]), _vm._v(" "), _c('p', [_vm._v("“Take him away and tie him up.”")]), _vm._v(" "), _c('p', [_vm._v("“And who the fuck do you think you are, you vampire lover.”")]), _vm._v(" "), _c('p', [_vm._v("“Let’s have a look, everyone stand back, looks like a broken nose,” the doctor then pulled up the boy’s shirt, “could be broken ribs,” and he then examined his head. “A huge bump may be bleeding internally.”")]), _vm._v(" "), _c('p', [_vm._v("Bacia said, “Who did this to one of my men?”")]), _vm._v(" "), _c('p', [_vm._v("“He’s drunk and we got him tied up to see what his sentence will be from Garrett.”")]), _vm._v(" "), _c('p', [_vm._v("“It won’t be good. Take him on the stretcher and put him in the medical room. And you, my dear girl, have had a shock and by the looks of it, a smack in the face.”")]), _vm._v(" "), _c('p', [_vm._v("“Please,” said Gretta, “don’t let him die, he’s the only friend I got. He tried to save me from that drunk pig.”")]), _vm._v(" "), _c('p', [_vm._v("“I’ll walk you down to your room, your sister must be worried.”")]), _vm._v(" "), _c('p', [_vm._v("“Gretta, it’s about time you came back. What has happened to your face?”")]), _vm._v(" "), _c('p', [_vm._v("“Your sister and the boy were attacked by a drunken sailor.”")]), _vm._v(" "), _c('p', [_vm._v("“Oh Gretta, are you hurt anywhere else?”")]), _vm._v(" "), _c('p', [_vm._v("“No but Rueband is unconscious with a head injury, broken nose and broken ribs.”")]), _vm._v(" "), _c('p', [_vm._v("“Why would this sailor attack you?”")]), _vm._v(" "), _c('p', [_vm._v("“He was forcing himself on me. Rueband saved me and now, he’s going to die.”")]), _vm._v(" "), _c('p', [_vm._v("“Doctor, stay with my sister and son for a while. And where does Garrett sleep during the day?”")]), _vm._v(" "), _c('p', [_vm._v("“He sleeps down below where we keep our dry goods, in his casket.”")]), _vm._v(" "), _c('p', [_vm._v("“Can sunlight get in?”")]), _vm._v(" "), _c('p', [_vm._v("“No, unless you keep the door open. Don’t be long, I have patients to attend.”")]), _vm._v(" "), _c('p', [_vm._v("Roseabella walked down the steps with her candle, thinking should I leave this door open and let the sun shine on the open casket. What if it burns him a little? I’d have to push his casket over to the door, which I couldn’t do.")]), _vm._v(" "), _c('p', [_vm._v("“Garrett, Garrett, wake up.”")]), _vm._v(" "), _c('p', [_vm._v("She pounded on the casket. The lid opened up slowly.")]), _vm._v(" "), _c('p', [_vm._v("“What are you doing down below?”")]), _vm._v(" "), _c('p', [_vm._v("“You told us you would protect us; you gave me your word.”")]), _vm._v(" "), _c('p', [_vm._v("Roseabella was pounding on Garrett’s chest.")]), _vm._v(" "), _c('p', [_vm._v("“What is it? Something happen to my son?”")]), _vm._v(" "), _c('p', [_vm._v("“He’s not your son!”")]), _vm._v(" "), _c('p', [_vm._v("“What the fuck is wrong then?”")]), _vm._v(" "), _c('p', [_vm._v("Garrett sat up in his casket.")]), _vm._v(" "), _c('p', [_vm._v("“Roseabella, please tell me.”")]), _vm._v(" "), _c('p', [_vm._v("“My sister has hand prints on her face. And your cabin boy, who by the way, his name is Rueband. He has a broken nose, cracked ribs and is unconscious and may be bleeding inside his head!”")]), _vm._v(" "), _c('p', [_vm._v("“Were we attacked?”")]), _vm._v(" "), _c('p', [_vm._v("“No, it was your drunken sailor, the one with the big mouth. He tried to force himself on Gretta. Rueband tried to intervene and now, he might not make it.”")]), _vm._v(" "), _c('p', [_vm._v("“The fucking son of a bitch. He will pay Roseabella, please believe me. I had no idea he was capable of denying my orders.”")]), _vm._v(" "), _c('p', [_vm._v("“She’s just a child Garrett, the doctor is with her. He needs to be with Rueband, I have to go.”")]), _vm._v(" "), _c('p', [_vm._v("“Send down Bacia. Who attacked the young ones?”")]), _vm._v(" "), _c('p', [_vm._v("“It was Manu.”")]), _vm._v(" "), _c('p', [_vm._v("“And where the fuck were you?”")]), _vm._v(" "), _c('p', [_vm._v("“Showing the men where to pack the cargo.”")]), _vm._v(" "), _c('p', [_vm._v("“Where is he now?”")]), _vm._v(" "), _c('p', [_vm._v("“Tied up, waiting for you sir.”")]), _vm._v(" "), _c('p', [_vm._v("“Has he done this before?”")]), _vm._v(" "), _c('p', [_vm._v("“Today at the market, he was after married women and their daughters. I told him I would leave him on the island to fight off the husband when they returned but he didn’t stop. Oh Garrett, I made a bad choice when I hired him.”")]), _vm._v(" "), _c('p', [_vm._v("“You certainly did. Hang him up and get out the Cat of Nine Tails. I’ll be up when the sun goes down. And check on young Rueband.”")]), _vm._v(" "), _c('p', [_vm._v("“Who is that, sir?”")]), _vm._v(" "), _c('p', [_vm._v("“From now on, the boy is called Rueband.”")]), _vm._v(" "), _c('p', [_vm._v("“Yes sir.”")]), _vm._v(" "), _c('p', [_vm._v("“Doctor, how is he?”")]), _vm._v(" "), _c('p', [_vm._v("“His nose has stopped bleeding. I’ve bandaged his ribs. All we can do now is pray he wakes up. I’m so sorry Gretta, this happened to you and Rueband.”")]), _vm._v(" "), _c('p', [_vm._v("“Who told you his name?”")]), _vm._v(" "), _c('p', [_vm._v("“Garrett, he said from now on the boy is Rueband. Come back to us, I have a lot more to teach you about being a captain. Bacia said that’s his dream you see, to be a captain of his own ship. So, Garrett told me to teach him the ropes.”")]), _vm._v(" "), _c('p', [_vm._v("“Is the bump on his head gone down?”")]), _vm._v(" "), _c('p', [_vm._v("“A little, I need more ice brought up from below, it keeps the swelling down.”")]), _vm._v(" "), _c('p', [_vm._v("“Yes doctor.”")]), _vm._v(" "), _c('p', [_vm._v("“Gretta?”")]), _vm._v(" "), _c('p', [_vm._v("“Yes, Bacia?”")]), _vm._v(" "), _c('p', [_vm._v("“Garrett will punish him for what he’s done to you and Rueband. We’ll feed him to the sharks. Maybe after the cat of nine tails.”")]), _vm._v(" "), _c('p', [_vm._v("“How did you get this job doctor? Did you know you were working for a vampire?”")]), _vm._v(" "), _c('p', [_vm._v("“At first, I didn’t. He visited me a few times, only at night. At the time, I was out of work and he knew I was looking for work.”")]), _vm._v(" "), _c('p', [_vm._v("“What happened to your other job?”")]), _vm._v(" "), _c('p', [_vm._v("“People don’t like changes; medical staff goes only by the book. There was this child whose lungs were full of infection and her throat was swollen together. It was Scarlett fever. You feel the soft spot there in your throat?”")]), _vm._v(" "), _c('p', [_vm._v("Gretta put her finger there and it was hollow and soft.")]), _vm._v(" "), _c('p', [_vm._v("“Yes, I can.”")]), _vm._v(" "), _c('p', [_vm._v("“The child could no longer breathe. I had to make a choice to let her die or try to save her life.”")]), _vm._v(" "), _c('p', [_vm._v("“Please go on, doctor.”")]), _vm._v(" "), _c('p', [_vm._v("“I cut the soft spot in her throat and opened it up with my two fingers and she started to breathe. And I couldn’t keep my two fingers there all night. I started to panic. I needed something hollow for her to breathe through.”")]), _vm._v(" "), _c('p', [_vm._v("“What did you do then, doctor?”")]), _vm._v(" "), _c('p', [_vm._v("“In a vase on the table were dry flowers. I knew the flowers quite will, my brother and I would use the stems to shoot beans through. I told the mother to bring me the dry plant. And with a hot knife I sterilized over the candle, I cut off the top and bottom and put candle wax around one end. I did this with one hand and made sure the wax wasn’t blocking the entrance. The plant tube was put in her throat between my fingers.”")]), _vm._v(" "), _c('p', [_vm._v("“And what happened then, doctor?”")]), _vm._v(" "), _c('p', [_vm._v("“I cleaned her tube daily, made up an herb mixture and rubbed it on the inside of her swollen throat. Two days later, the swelling had gone down, so I took out the tube and she could breathe on her own.”")]), _vm._v(" "), _c('p', [_vm._v("“That is a miracle, doctor!”")]), _vm._v(" "), _c('p', [_vm._v("“I thought so too! I was fired from my job because we weren’t ready for risky surgery.”")]), _vm._v(" "), _c('p', [_vm._v("“But you saved her life. If you didn’t risk it, she would be dead.”")]), _vm._v(" "), _c('p', [_vm._v("“And a year later, there was a doctor who was famous for coming up with a new airway to the throat.”")]), _vm._v(" "), _c('p', [_vm._v("“How could they do this to you?”")]), _vm._v(" "), _c('p', [_vm._v("“So, for two years I drank and drank. Garrett asked me to be a doctor on his ship, he offered me more money than I could spend in a life time. He told me that I would start fresh on his ship. He told me I would see to his wife and son and his crew. He told me we were going to a private island where he will build me my own hospital. He convinced me, so here I am!”")]), _vm._v(" "), _c('p', [_vm._v("“And I’m so glad you are, Doctor. If Rueband is not awake soon, what will you do?”")]), _vm._v(" "), _c('p', [_vm._v("“If worse comes to worse, the pressure and bleeding must be released from his brain.”")]), _vm._v(" "), _c('p', [_vm._v("“How will you do that?”")]), _vm._v(" "), _c('p', [_vm._v("“You don’t want to know. You better get back to your sister and have your meal.”")]), _vm._v(" "), _c('p', [_vm._v("“Yes, I’ll be back later to check on him.”")]), _vm._v(" "), _c('p', [_vm._v("After their meal inside the quarters, there was a knock on the door which made them jump.")]), _vm._v(" "), _c('p', [_vm._v("“Who is it?”")]), _vm._v(" "), _c('p', [_vm._v("“It’s me, Garrett.”")]), _vm._v(" "), _c('p', [_vm._v("“Come in. My sweet Gretta. What has he done to that beautiful face?”")]), _vm._v(" "), _c('p', [_vm._v("“I will live, Garrett. What’s a fat lip and a few bruises, compared to what he did to Rueband?”")]), _vm._v(" "), _c('p', [_vm._v("“Please don’t cry, Gretta, we are doing everything possible for him.”")]), _vm._v(" "), _c('p', [_vm._v("“What if he dies? I never got the chance to tell him how I appreciated our friendship. He jumped in to help me!”")]), _vm._v(" "), _c('p', [_vm._v("“If you want to come on deck to see the prisoner get his punishment, I will escort you.”")]), _vm._v(" "), _c('p', [_vm._v("“I certainly would.”")]), _vm._v(" "), _c('p', [_vm._v("“And you, Roseabella?”")]), _vm._v(" "), _c('p', [_vm._v("“It’s not a place for Josiah.”")]), _vm._v(" "), _c('p', [_vm._v("“I can get someone to look after him.”")]), _vm._v(" "), _c('p', [_vm._v("“No, thank you. My son will not be left with strangers.”")]), _vm._v(" "), _c('p', [_vm._v("“As you wish. Are you ready, Gretta?”")]), _vm._v(" "), _c('p', [_vm._v("“Yes, Garrett.”")]), _vm._v(" "), _c('p', [_vm._v("“You broke the rules when you laid your filthy hands on young Gretta, you will also receive punishment for Rueband.”")]), _vm._v(" "), _c('p', [_vm._v("“Who in the hell is Rueband?”")]), _vm._v(" "), _c('p', [_vm._v("“Rueband is my cabin boy’s name.”")]), _vm._v(" "), _c('p', [_vm._v("“Garrett!”")]), _vm._v(" "), _c('p', [_vm._v("Gretta ran up to him.")]), _vm._v(" "), _c('p', [_vm._v("“I just remembered the day we were taken from our family.”")]), _vm._v(" "), _c('p', [_vm._v("“Yes, Gretta?”")]), _vm._v(" "), _c('p', [_vm._v("“My mother offered him double the coin and her jewels.”")]), _vm._v(" "), _c('p', [_vm._v("“Go on.”")]), _vm._v(" "), _c('p', [_vm._v("“He said yes, he’d be glad to but Bacia told him, if you double cross a vampire, he will sure to find you and he will rip you apart limb by limb. And Garrett, I want to show the men that I’m not some defenseless young girl. My sister taught me never to back down. Could I give him his first lashes?”")]), _vm._v(" "), _c('p', [_vm._v("“You amaze me, Gretta. Go, young lady and strike him down.”")]), _vm._v(" "), _c('p', [_vm._v("The sailor said, “I’ll get you for this, you fucking little bitch.”")]), _vm._v(" "), _c('p', [_vm._v("Gretta walked away four feet with the Cat of Nine Tails in her hands.")]), _vm._v(" "), _c('p', [_vm._v("“This one is for forcing a woman against her will.” He screeched out as the cut struck his back. “This one is for Rueband.” She lashed him ten times and turned around and looked at the men and said, “Remember to show women respect.” She then left to go help Roseabella with the baby.")]), _vm._v(" "), _c('p', [_vm._v("“Are you ok, Gretta?”")]), _vm._v(" "), _c('p', [_vm._v("“Yes, I just needed a hug from Josiah.”")]), _vm._v(" "), _c('p', [_vm._v("“What happened up there?”")]), _vm._v(" "), _c('p', [_vm._v("“All the training we had day after day, cut in. I gave him ten lashes with the Cat of Nine Tails.”")]), _vm._v(" "), _c('p', [_vm._v("“Gretta, I’m so proud of you for being so strong.”")]), _vm._v(" "), _c('p', [_vm._v("“Thank you so much, sister. I’m going to visit Rueband for a while. When I come back, you are going on deck to get some fresh air. Roseabella, you’ve been in this room all day.”")]), _vm._v(" "), _c('p', [_vm._v("“Gretta, you’re growing up so fast.”")]), _vm._v(" "), _c('p', [_vm._v("“Are there any changes, doctor?”")]), _vm._v(" "), _c('p', [_vm._v("“No, all we can do is wait.”")]), _vm._v(" "), _c('p', [_vm._v("“What are you doing?”")]), _vm._v(" "), _c('p', [_vm._v("“Putting a little bit of water inside his lips and on his tongue. It will keep his body from being dehydrated.”")]), _vm._v(" "), _c('p', [_vm._v("“How old were you when you knew you wanted to be a doctor?”")]), _vm._v(" "), _c('p', [_vm._v("“Ten years old. I brought home wounded animals and mended them. I knew then.”")]), _vm._v(" "), _c('p', [_vm._v("“I won’t be long, Gretta. A few walks around the deck and I’ll be back.”")]), _vm._v(" "), _c('p', [_vm._v("“I’m going to take a nap.”")]), _vm._v(" "), _c('p', [_vm._v("Roseabella ran around the deck over and over.")]), _vm._v(" "), _c('p', [_vm._v("“You’re going to kill yourself if you don’t stop.”")]), _vm._v(" "), _c('p', [_vm._v("With deep breaths, she slowed down and walked around.")]), _vm._v(" "), _c('p', [_vm._v("“Roseabella, I’m sorry for what happened to your sister. It will not happen again.”")]), _vm._v(" "), _c('p', [_vm._v("“Garrett, she could have been raped today. My god Garrett, it makes me sick inside. And that dear boy who thinks only of his family, he keeps them fed and clothed. His father treated him like a dog. He didn’t have a chance to be a kid and now he might not have a chance to become a man. I can’t be with Gretta every minute of the day. The baby sleeps most of daylight and I can’t leave him. You Garrett, sleep twelve-hours of daylight in your casket.”")]), _vm._v(" "), _c('p', [_vm._v("“Don’t cry, Roseabella.”")]), _vm._v(" "), _c('p', [_vm._v("She sobbed and sobbed in Garrett’s arms.")]), _vm._v(" "), _c('p', [_vm._v("“I will take you back now, I need to speak to the doctor about Rueband’s condition.”")]), _vm._v(" "), _c('p', [_vm._v("“I’d like to see him also. He’s been so polite to us and Josiah adores him.”")]), _vm._v(" "), _c('p', [_vm._v("“As you wish.”")]), _vm._v(" "), _c('p', [_vm._v("“Lady Roseabella, how are you?”")]), _vm._v(" "), _c('p', [_vm._v("“I’ve been better.”")]), _vm._v(" "), _c('p', [_vm._v("“Yes of course, it’s been a terrible day for your sister and this young man.”")]), _vm._v(" "), _c('p', [_vm._v("“Are there any changes, doctor?”")]), _vm._v(" "), _c('p', [_vm._v("“No changes. No worse no better, he’s the same. And the longer he sleeps and less movement will keep the brain from bleeding.”")]), _vm._v(" "), _c('p', [_vm._v("“Do you think he is still bleeding inside?”")]), _vm._v(" "), _c('p', [_vm._v("“I don’t know. All we can do is keep his mouth moist with water.”")]), _vm._v(" "), _c('p', [_vm._v("“You go have a meal, doctor.” Said Garrett, “I’ll stay with him tonight while you rest.”")]), _vm._v(" "), _c('p', [_vm._v("“Ok Garrett, call me if there are any changes.”")]), _vm._v(" "), _c('p', [_vm._v("“Roseabella, you need sleep. Go to bed, our son is an early riser.” (Why does he keep calling him that?)")]), _vm._v(" "), _c('p', [_vm._v("“Yes, goodnight Garrett.”")]), _vm._v(" "), _c('p', [_vm._v("She banged and banged on my casket. She makes me proud. No one will ever harm her family again.")]), _vm._v(" "), _c('p', [_vm._v("Gretta spent most of her day sitting by Rueband’s bed.")]), _vm._v(" "), _c('p', [_vm._v("“Please wake up, Rueband. The weeks have been so long. The doctor said you are becoming thin. We dribble broth down your throat but that’s not enough nourishment. The doctor said you are in a deep sleep or brain dead. You are not brain dead, Rueband. You jumped in and tried to save me, Rueband. I’d like to teach you how to dance. We’ll dance all around the deck.”")]), _vm._v(" "), _c('p', [_vm._v("Gretta put her lips against Rueband’s dry lips. Then she laid her head against his chest. Gretta felt her hair being smoothed down. She looked at Rueband and he was looking at her.")]), _vm._v(" "), _c('p', [_vm._v("“Gretta, where am I?”")]), _vm._v(" "), _c('p', [_vm._v("“Doctor Baruue, come quickly, Rueband is awake.”")]), _vm._v(" "), _c('p', [_vm._v("“Young man, it’s about time you came back to the living.”")]), _vm._v(" "), _c('p', [_vm._v("“What happened?”")]), _vm._v(" "), _c('p', [_vm._v("“You had a head injury. You’ve been asleep for two weeks.”")]), _vm._v(" "), _c('p', [_vm._v("“Are you joking with me, doctor?”")]), _vm._v(" "), _c('p', [_vm._v("“No my lad, we’ve been by your side for two weeks.”")]), _vm._v(" "), _c('p', [_vm._v("“Gretta, what happened?”")]), _vm._v(" "), _c('p', [_vm._v("“You fell down and hit your head.”")]), _vm._v(" "), _c('p', [_vm._v("“I don’t remember that.”")]), _vm._v(" "), _c('p', [_vm._v("“Head injuries can cause memory loss.”")]), _vm._v(" "), _c('p', [_vm._v("“I’ve been asleep for two weeks?”")]), _vm._v(" "), _c('p', [_vm._v("“We just told you that!”")]), _vm._v(" "), _c('p', [_vm._v("“Drink this Rueband, your body needs fluids.”")]), _vm._v(" "), _c('p', [_vm._v("“I could eat a horse, I’m so hungry.”")]), _vm._v(" "), _c('p', [_vm._v("“I’m so glad you’re hungry. Gretta, go to the cook and tell him Rueband is hungry.”")]), _vm._v(" "), _c('p', [_vm._v("Doctor told Rueband, “She’s been by your side for two weeks.”")]), _vm._v(" "), _c('p', [_vm._v("“We are good friends doctor.”")]), _vm._v(" "), _c('p', [_vm._v("“I’d say you are best of friends.”")]), _vm._v(" "), _c('p', [_vm._v("After getting the gates rebuilt, Armando made plans to find his wife and child.")]), _vm._v(" "), _c('p', [_vm._v("“We haven’t had any vampire attacks in three weeks. Gerrold, you are to stay here; you’re the only one capable of being in charge when I am gone. You must keep the guards on day and night. Helewise and the twins are traveling with me.”")]), _vm._v(" "), _c('p', [_vm._v("“Armando, what about Saige? She thinks you need her and her visions.”")]), _vm._v(" "), _c('p', [_vm._v("“She is your granddaughter Gerrold, you and Meiga have to make that decision.”")]), _vm._v(" "), _c('p', [_vm._v("“Armando, her mind’s made up; Saige will travel with you.”")]), _vm._v(" "), _c('p', [_vm._v("The twins, Marga and Ragga were excited about their trip to find Armando’s family.")]), _vm._v(" "), _c('p', [_vm._v("“Ragga, you still won’t overdo it!”")]), _vm._v(" "), _c('p', [_vm._v("“It’s been three weeks, Marga, I feel as good as new.”")]), _vm._v(" "), _c('p', [_vm._v("“We have not been on a big ship before. We are lucky Helewise chose us.”")]), _vm._v(" "), _c('p', [_vm._v("“You are right, she’s not as snobby as she used to be. Young Saige will be coming with us. What a warrior she is for the age of twelve.”")]), _vm._v(" "), _c('p', [_vm._v("“I like the kid; her grandparents did a good job with her.”")]), _vm._v(" "), _c('p', [_vm._v("“Ok you girls, we are leaving in two days. We need practice today.”")]), _vm._v(" "), _c('p', [_vm._v("“Of course Helewise, but the other women are upset they never got chosen!”")]), _vm._v(" "), _c('p', [_vm._v("“Well girls, the ship can only sleep so many. And besides, our castle could be attacked again. So, Gerrold’s going to need them.”")]), _vm._v(" "), _c('p', [_vm._v("The ship was loaded with salt meat, salt fish, hard bread, smoked meat and smoked fish. Kegs of water and ale and all the weapons they could store. Forty-three of them walked up the plank to the ship.")]), _vm._v(" "), _c('p', [_vm._v("“We are ready captain, to set sail.”")]), _vm._v(" "), _c('p', [_vm._v("“I don’t like women passengers on my ship.”")]), _vm._v(" "), _c('p', [_vm._v("“We are not just women passengers; we are vampire slayers.”")]), _vm._v(" "), _c('p', [_vm._v("“Oh god, now we have crazy women on board.”")]), _vm._v(" "), _c('p', [_vm._v("Armando said, “Calm down sister, you will get to show him tomorrow when you practice.”")]), _vm._v(" "), _c('p', [_vm._v("“Where are we headed?”")]), _vm._v(" "), _c('p', [_vm._v("“South Australia.”")]), _vm._v(" "), _c('p', [_vm._v("“How long, Armando?”")]), _vm._v(" "), _c('p', [_vm._v("“We were hoping two months but now it is hurricane season, so we could be looking at six months.”")]), _vm._v(" "), _c('p', [_vm._v("“On this boat for six months?”")]), _vm._v(" "), _c('p', [_vm._v("“We’ll be stopping in small ports along the way.”")]), _vm._v(" "), _c('p', [_vm._v("“Oh Armando, I will be right beside you all the way.”")]), _vm._v(" "), _c('p', [_vm._v("“Helewise, I am so proud of you. You fought beside the men and put down a lot of vampires.”")]), _vm._v(" "), _c('p', [_vm._v("“Do you think Garrett’s property will be protected by vampires?”")]), _vm._v(" "), _c('p', [_vm._v("“No, not all vampires, they wouldn’t be useful in daylight.”")]), _vm._v(" "), _c('p', [_vm._v("“That’s one good thing we have going for us.”")]), _vm._v(" "), _c('p', [_vm._v("The next few days were windy and high waves. Helewise and the twins had their heads down in buckets.")]), _vm._v(" "), _c('p', [_vm._v("“Don’t know if I can take much more of this.”")]), _vm._v(" "), _c('p', [_vm._v("“Me either. You getting any better, Helewise.”")]), _vm._v(" "), _c('p', [_vm._v("“No, still sick as a dog.”")]), _vm._v(" "), _c('p', [_vm._v("Armando walked into the girl’s room; they were sharing.")]), _vm._v(" "), _c('p', [_vm._v("“Where’s Saige?”")]), _vm._v(" "), _c('p', [_vm._v("“She got her sea legs. Nothing stops that girl.”")]), _vm._v(" "), _c('p', [_vm._v("“The doctor has made ginger tea. You must drink it after every time you throw up. And you must eat only hard bread.”")]), _vm._v(" "), _c('p', [_vm._v("“Thank you, Sir Armando, we’ll try anything if it stops us from throwing up.”")]), _vm._v(" "), _c('p', [_vm._v("After Armando left, Helewise said.")]), _vm._v(" "), _c('p', [_vm._v("“Who’s going to try it first?”")]), _vm._v(" "), _c('p', [_vm._v("“I will, thank you Marga.”")]), _vm._v(" "), _c('p', [_vm._v("“So, what does it taste like?”")]), _vm._v(" "), _c('p', [_vm._v("“Hot water, ginger root and something else, honey I think. It’s not that bad. Let me pour you some.”")]), _vm._v(" "), _c('p', [_vm._v("“Ok, let’s drink to getting our sea legs.”")]), _vm._v(" "), _c('p', [_vm._v("“You know Marga, we wanted to lose weight.”")]), _vm._v(" "), _c('p', [_vm._v("“Yeah, what about it?”")]), _vm._v(" "), _c('p', [_vm._v("“We’ve lost weight and more besides.”")]), _vm._v(" "), _c('p', [_vm._v("“You’re right, my pants are loose. So have you, Helewise and you don’t need to lose any weight.”")]), _vm._v(" "), _c('p', [_vm._v("They finished their tea and all fell asleep. They slept for eight hours. Saige said:")]), _vm._v(" "), _c('p', [_vm._v("“Is everyone ok? You’ve been asleep all day.”")]), _vm._v(" "), _c('p', [_vm._v("“We have?”")]), _vm._v(" "), _c('p', [_vm._v("“Yes, I have been checking on you.”")]), _vm._v(" "), _c('p', [_vm._v("“Ragga, we haven’t thrown up in eight hours.”")]), _vm._v(" "), _c('p', [_vm._v("“You are right. Saige, can you pour us some more of the tea.”")]), _vm._v(" "), _c('p', [_vm._v("“It smells like Gram’s ginger cookies.”")]), _vm._v(" "), _c('p', [_vm._v("“I’m starting to feel hungry.”")]), _vm._v(" "), _c('p', [_vm._v("“Why don’t I ask cook to make ginger bread cookies for you?”")]), _vm._v(" "), _c('p', [_vm._v("“Oh Saige, that would be wonderful because I can’t stomach that hard bread.”")]), _vm._v(" "), _c('p', [_vm._v("“I’ll be back later with the cookies.”")]), _vm._v(" "), _c('p', [_vm._v("“Thanks Saige, we owe you one.”")]), _vm._v(" "), _c('p', [_vm._v("“Sir, have you ever made ginger cookies?”")]), _vm._v(" "), _c('p', [_vm._v("“Yes, I have.”")]), _vm._v(" "), _c('p', [_vm._v("“Could you make some for my friends, the three girls who are sea sick? The ginger tea has done wonders and now they are hungry. But too scared to eat.”")]), _vm._v(" "), _c('p', [_vm._v("“What a good idea, I’ll make a big batch. Some of the men are also sea sick. Give me an hour and they will be ready.”")]), _vm._v(" "), _c('p', [_vm._v("“How are your roommates doing, Saige?” asked Armando.")]), _vm._v(" "), _c('p', [_vm._v("“The tea worked and now they are hungry, with just only hard bread for the day. They said they can’t stomach anymore of the hard bread, so cook is making ginger bread cookies.”")]), _vm._v(" "), _c('p', [_vm._v("“Well, I’ll be. A good idea. You’re not homesick, are you Saige?”")]), _vm._v(" "), _c('p', [_vm._v("“I do miss my grandparents but I am enjoying all the fresh air from the sea.”")]), _vm._v(" "), _c('p', [_vm._v("“You are one special girl, Saige.”")]), _vm._v(" "), _c('p', [_vm._v("“Thank you, Sir Armando.”")]), _vm._v(" "), _c('p', [_vm._v("“Who’s ready for some cookies?”")]), _vm._v(" "), _c('p', [_vm._v("“Yummy! They smell delicious. There’re good but not as good as Meiga’s.”")]), _vm._v(" "), _c('p', [_vm._v("“Don’t overdo it, you haven’t eaten in days. Don’t want you to get diarrhea.”")]), _vm._v(" "), _c('p', [_vm._v("“My god, no. Maybe we’ll eat three and save some for later.”")]), _vm._v(" "), _c('p', [_vm._v("“You’re not the only ones sea sick, so cook made enough for some of the men.”")]), _vm._v(" "), _c('p', [_vm._v("“That’s good, they can’t make fun of us.”")]), _vm._v(" "), _c('p', [_vm._v("“I’m going to get more ginger tea.” Said Saige.")]), _vm._v(" "), _c('p', [_vm._v("“Can you ask cook to add some extra honey?”")]), _vm._v(" "), _c('p', [_vm._v("“Ok, be right back.”")]), _vm._v(" "), _c('p', [_vm._v("“What a good kid, when God sent me back from heaven, she was the first person I saw. She looked like an angel.”")]), _vm._v(" "), _c('p', [_vm._v("“You were delirious and dreaming, you never met God.”")]), _vm._v(" "), _c('p', [_vm._v("“God told me I was still needed on earth to fight more battles.”")]), _vm._v(" "), _c('p', [_vm._v("“God or not, we are happy you came back to the living.”")]), _vm._v(" "), _c('p', [_vm._v("“Thanks, Helewise. That means a lot to me.”")]), _vm._v(" "), _c('p', [_vm._v("“You’re welcome, now anyone up for a game of cards?”")]), _vm._v(" "), _c('p', [_vm._v("“What about gin?”")]), _vm._v(" "), _c('p', [_vm._v("“Ok. Thanks for the hot tea, Saige. Would you like to play cards with us?”")]), _vm._v(" "), _c('p', [_vm._v("“Not right now, there are whales following our ship, I’ll see you later.”")]), _vm._v(" "), _c('p', [_vm._v("“Wait for us, we want to see.”")]), _vm._v(" "), _c('p', [_vm._v("“Ok, maybe some fresh air will do you good.”")]), _vm._v(" "), _c('p', [_vm._v("“Look at the size of them and look at all the spray coming from their heads. Over there are mothers and babies.”")]), _vm._v(" "), _c('p', [_vm._v("“I wish I could draw like my cousin. What a picture it would make.”")]), _vm._v(" "), _c('p', [_vm._v("“I’m starting to feel more like myself.”")]), _vm._v(" "), _c('p', [_vm._v("“So do I!”")]), _vm._v(" "), _c('p', [_vm._v("“Me too!”")]), _vm._v(" "), _c('p', [_vm._v("“Cook said if the cookies stay down, you can have some chicken soup.”")]), _vm._v(" "), _c('p', [_vm._v("“What about some dumplings to go with it?”")]), _vm._v(" "), _c('p', [_vm._v("“You girls are pushing it.” Ragga gave Saige a big hug. So did Marga.")]), _vm._v(" "), _c('p', [_vm._v("“We think of you as our young sister, Saige. And if you didn’t dump those slop pails for us, we would still be sick. We’re here for you anytime of the day.”")]), _vm._v(" "), _c('p', [_vm._v("Helewise said, “I’d like to thank you too, Saige.”")]), _vm._v(" "), _c('p', [_vm._v("“You are all welcome.”")]), _vm._v(" "), _c('p', [_vm._v("“What’s the bell ringing for?”")]), _vm._v(" "), _c('p', [_vm._v("“Our meal is ready.”")]), _vm._v(" "), _c('p', [_vm._v("“Good, I could eat a horse.”")]), _vm._v(" "), _c('p', [_vm._v("Three weeks later, Armando and some men entered a port for drinking water and fresh fruit and meat.")]), _vm._v(" "), _c('p', [_vm._v("“Is this what you would call a slum village?” asked one of his men.")]), _vm._v(" "), _c('p', [_vm._v("“It doesn’t look promising.” Said Armando.")]), _vm._v(" "), _c('p', [_vm._v("“What fur is that clothing made from?”")]), _vm._v(" "), _c('p', [_vm._v("“Deer hide.” Said the captain.")]), _vm._v(" "), _c('p', [_vm._v("“They look so soft but they’re not up to date, are they?”")]), _vm._v(" "), _c('p', [_vm._v("“They live off the land, they are not proud people. And what’s those long yellow things?”")]), _vm._v(" "), _c('p', [_vm._v("“They’re called bananas.”")]), _vm._v(" "), _c('p', [_vm._v("“Are they any good?”")]), _vm._v(" "), _c('p', [_vm._v("“All fruit here is good and bananas are the best.”")]), _vm._v(" "), _c('p', [_vm._v("“Let’s take some back for the women.”")]), _vm._v(" "), _c('p', [_vm._v("“Look over there, a dog and her puppies. Jesus, what a size of a dog. Looks like part German Sheppard and part sheep dog.”")]), _vm._v(" "), _c('p', [_vm._v("“Could I buy one, Sir Armando?”")]), _vm._v(" "), _c('p', [_vm._v("“What are we going to do with a dog on our ship?”")]), _vm._v(" "), _c('p', [_vm._v("“They are good rat hunters and when trained, make good fighters and guard dogs.”")]), _vm._v(" "), _c('p', [_vm._v("“Do we have rats?”")]), _vm._v(" "), _c('p', [_vm._v("“One or two.”")]), _vm._v(" "), _c('p', [_vm._v("“Alright, get one for my sister too.”")]), _vm._v(" "), _c('p', [_vm._v("“I’ll pick it out myself.”")]), _vm._v(" "), _c('p', [_vm._v("Armando put up two fingers for two puppies, which was four coins. “I’ll have the one with mixed colors.”")]), _vm._v(" "), _c('p', [_vm._v("“I’ll take the black one, sir.”")]), _vm._v(" "), _c('p', [_vm._v("“Do any of these people speak our language?”")]), _vm._v(" "), _c('p', [_vm._v("“Only a few. That one over there is the chief, we’ll try him and I do speak some of their language.”")]), _vm._v(" "), _c('p', [_vm._v("So, the captain asked him if he sold supplies to a sailor with a scar on his chin, a tall man.")]), _vm._v(" "), _c('p', [_vm._v("“They came from Transylvania about eight weeks ago and the men stopped for supplies.”")]), _vm._v(" "), _c('p', [_vm._v("“Did they say where they were going?”")]), _vm._v(" "), _c('p', [_vm._v("“More money for that information, Armando.”")]), _vm._v(" "), _c('p', [_vm._v("“They’re going to a private island.”")]), _vm._v(" "), _c('p', [_vm._v("“What the hell does that mean?”")]), _vm._v(" "), _c('p', [_vm._v("“He does not know.”")]), _vm._v(" "), _c('p', [_vm._v("“Everyone, make for the roll boats.”")]), _vm._v(" "), _c('p', [_vm._v("The women were waiting on deck for the men’s return.")]), _vm._v(" "), _c('p', [_vm._v("“Any news on Garret’s ship, Armando?”")]), _vm._v(" "), _c('p', [_vm._v("“They stopped by here eight weeks ago.”")]), _vm._v(" "), _c('p', [_vm._v("“Do you think they made it to their destination?”")]), _vm._v(" "), _c('p', [_vm._v("“Not in this weather.”")]), _vm._v(" "), _c('p', [_vm._v("“And what’s under your jacket making that noise?”")]), _vm._v(" "), _c('p', [_vm._v("“A gift for you, ladies.”")]), _vm._v(" "), _c('p', [_vm._v("“Oh Armando, she’s beautiful.”")]), _vm._v(" "), _c('p', [_vm._v("“Sir Armando, thank you so much.”")]), _vm._v(" "), _c('p', [_vm._v("“He loves licking you.”")]), _vm._v(" "), _c('p', [_vm._v("“Romane has the brother.”")]), _vm._v(" "), _c('p', [_vm._v("Romane brought over the puppy.")]), _vm._v(" "), _c('p', [_vm._v("“He’s black as tar.”")]), _vm._v(" "), _c('p', [_vm._v("“Have you picked a name yet?”")]), _vm._v(" "), _c('p', [_vm._v("“Yes, his name is Black.”")]), _vm._v(" "), _c('p', [_vm._v("“Our dog has so many colors, we will decide later.”")]), _vm._v(" "), _c('p', [_vm._v("“Let’s get some water and food then.”")]), _vm._v(" "), _c('p', [_vm._v("“Helewise, we need some old pieces of rags for him, so he doesn’t do his dirt on you.”")]), _vm._v(" "), _c('p', [_vm._v("“You’re right, he can’t go overboard to do it. Look at them play together.”")]), _vm._v(" "), _c('p', [_vm._v("“The bells are ringing for the last meal of the day. Where are we going to put her?”")]), _vm._v(" "), _c('p', [_vm._v("“There’s a big bucket in our room.”")]), _vm._v(" "), _c('p', [_vm._v("“Good idea. We’ll bring her back left overs.”")]), _vm._v(" "), _c('p', [_vm._v("“I brought you girls a treat. They say it’s the best tasting fruit.”")]), _vm._v(" "), _c('p', [_vm._v("“It looks like large fingers.”")]), _vm._v(" "), _c('p', [_vm._v("“You crack off the top and peel it down.”")]), _vm._v(" "), _c('p', [_vm._v("“It’s the best thing I have ever tasted. How many did you bring back?”")]), _vm._v(" "), _c('p', [_vm._v("“One for everyone.”")]), _vm._v(" "), _c('p', [_vm._v("“Oh Armando, can we have the men’s share?”")]), _vm._v(" "), _c('p', [_vm._v("“You’ll have to fight them for it!”")]), _vm._v(" "), _c('p', [_vm._v("“Why is the puppy crying?”")]), _vm._v(" "), _c('p', [_vm._v("“We did feed her.”")]), _vm._v(" "), _c('p', [_vm._v("“Someone is knocking at the door. Who is it?”")]), _vm._v(" "), _c('p', [_vm._v("“Romane.”")]), _vm._v(" "), _c('p', [_vm._v("“Come in. What do you want?”")]), _vm._v(" "), _c('p', [_vm._v("“Black won’t stop crying. My roommates are not too happy.”")]), _vm._v(" "), _c('p', [_vm._v("“Our pup is crying too. Bring him over and put him in the basket.”")]), _vm._v(" "), _c('p', [_vm._v("“They are licking each other; they are lonely for their mother.”")]), _vm._v(" "), _c('p', [_vm._v("“They are yawning now, let’s see what happens.”")]), _vm._v(" "), _c('p', [_vm._v("“Look, they are cuddled up asleep. Black can stay here until he gets a little bit older.”")]), _vm._v(" "), _c('p', [_vm._v("“Thanks girls. I’ll see you and the pups on deck tomorrow.”")]), _vm._v(" "), _c('p', [_vm._v("“Don’t you think Romane is cute?”")]), _vm._v(" "), _c('p', [_vm._v("“Not bad. What do you think, Helewise?”")]), _vm._v(" "), _c('p', [_vm._v("“He’s not my type.”")]), _vm._v(" "), _c('p', [_vm._v("“Could we sleep now while the puppies are sleeping?”")]), _vm._v(" "), _c('p', [_vm._v("“Ok Saige, good night.”")]), _vm._v(" "), _c('p', [_vm._v("Morning came early with two puppies crying for food. Saige put them down on their rugs to relieve themselves.")]), _vm._v(" "), _c('p', [_vm._v("“Good pups, give me some kisses.” Saige took the pups up and hugged them. “Are you little ones hungry? Here is some mashed up food for you. That’s a big appetite for little puppies. Now, who’s banging on the door this early in the morning?”")]), _vm._v(" "), _c('p', [_vm._v("“Everyone on deck, we are being followed by pirates.”")]), _vm._v(" "), _c('p', [_vm._v("“We’ll be right there. Now, we’ll show the captain we are not crazy women. Where’s their ship?” Armando pointed where the ship was following them. “How do you know they are pirates?”")]), _vm._v(" "), _c('p', [_vm._v("“The captain recognizes the ship.”")]), _vm._v(" "), _c('p', [_vm._v("“Will they attack?”")]), _vm._v(" "), _c('p', [_vm._v("“We will soon find out.”")]), _vm._v(" "), _c('p', [_vm._v("“Their ship is closing in!”")]), _vm._v(" "), _c('p', [_vm._v("“Everyone, get your weapons ready!”")]), _vm._v(" "), _c('p', [_vm._v("“We mean you no harm,” said the pirates, “we want your cargo.”")]), _vm._v(" "), _c('p', [_vm._v("“And we are not giving you anything.”")]), _vm._v(" "), _c('p', [_vm._v("“We want your weapons and coin.”")]), _vm._v(" "), _c('p', [_vm._v("“You will get our weapons inside your chest, if you don’t leave.”")]), _vm._v(" "), _c('p', [_vm._v("“We are pirates of the sea; you don’t stand a chance.”")]), _vm._v(" "), _c('p', [_vm._v("Now, both ships were side by side. The pirates put down long planks between the two ships, and started running toward their ship with swords in their hands.")]), _vm._v(" "), _c('p', [_vm._v("“Shoot your arrows!” The pirates started dropping in the water. More pirates followed and some made it aboard the ship. They were fast with their swords and some of Armando’s men went down.")]), _vm._v(" "), _c('p', [_vm._v("The girls ran in with their spears and four pirates went down.")]), _vm._v(" "), _c('p', [_vm._v("“Move the planks overboard.”")]), _vm._v(" "), _c('p', [_vm._v("Arrows went flying into the other ship. Men went down and the ship moved away.")]), _vm._v(" "), _c('p', [_vm._v("“We did it, Armando.” Said Helewise, “they are leaving.”")]), _vm._v(" "), _c('p', [_vm._v("“Yes, sister! Now we must help the doctor with our wounded.”")]), _vm._v(" "), _c('p', [_vm._v("“Will they attack again?”")]), _vm._v(" "), _c('p', [_vm._v("“Not in daylight. They might try after dark.”")]), _vm._v(" "), _c('p', [_vm._v("Armando lost four men, they gave a few prayers and the men were buried at sea.")]), _vm._v(" "), _c('p', [_vm._v("The next week, they spent close to a port, to wait out a storm.")]), _vm._v(" "), _c('p', [_vm._v("“Good afternoon, ladies, I came to apologize for my remarks when you first came on ship. When I saw you put down those pirates last week with your spears, I was shocked. I would like the four of you tonight to join me, to dine at my quarters. Good day to you all.”")]), _vm._v(" "), _c('p', [_vm._v("“Now, what do you say about that Marga, being invited to the captains’ quarters to dine?”")]), _vm._v(" "), _c('p', [_vm._v("“And he is a handsome man.”")]), _vm._v(" "), _c('p', [_vm._v("“What about you, Helewise?”")]), _vm._v(" "), _c('p', [_vm._v("“I don’t like the man but I’m so bored, I’ll accept.”")]), _vm._v(" "), _c('p', [_vm._v("“Of course, we are going to accept. Now, there’s only one problem.”")]), _vm._v(" "), _c('p', [_vm._v("“What’s that?”")]), _vm._v(" "), _c('p', [_vm._v("“What are we going to wear?”")]), _vm._v(" "), _c('p', [_vm._v("“Let’s get the bath tub filled up with lots of extra water. I’ll go first since I’m the youngest.”")]), _vm._v(" "), _c('p', [_vm._v("“Ok Saige, get in and I’ll wash the stiff salt water hair of yours.”")]), _vm._v(" "), _c('p', [_vm._v("“Do you have a dress, Saige?”")]), _vm._v(" "), _c('p', [_vm._v("“Yes, Grams packed my party dress.”")]), _vm._v(" "), _c('p', [_vm._v("“What about you, Marga?”")]), _vm._v(" "), _c('p', [_vm._v("“We have our church dresses.”")]), _vm._v(" "), _c('p', [_vm._v("“Ok stand up, let me wrap a towel around you, there you go. Go on the top of your bunk and dry off.”")]), _vm._v(" "), _c('p', [_vm._v("Everyone started baling out the tub, throwing it through the tiny window.")]), _vm._v(" "), _c('p', [_vm._v("“Since I’m doing most of the work, I’ll go first. Marga, can you wash my hair please and rinse it?”")]), _vm._v(" "), _c('p', [_vm._v("After everyone got cleaned up, Helewise did everyone’s hair. The twins always had their hair done up in two braids.")]), _vm._v(" "), _c('p', [_vm._v("“Ragga, your hair is so wonderful. Helewise, do the same way for me.” Said Marga.")]), _vm._v(" "), _c('p', [_vm._v("Helewise twirled her hair around her fingers and let her fingers fall down gently.")]), _vm._v(" "), _c('p', [_vm._v("“You will both have beautiful curls whey they dry.”")]), _vm._v(" "), _c('p', [_vm._v("“What about you, Saige?”")]), _vm._v(" "), _c('p', [_vm._v("“Helewise, for me could you put a bun on top and curls hanging down?”")]), _vm._v(" "), _c('p', [_vm._v("“Oh Saige, are you getting proud on us?”")]), _vm._v(" "), _c('p', [_vm._v("“No of course not! I just want to be pretty as you three.”")]), _vm._v(" "), _c('p', [_vm._v("“No rush Saige, in five years’ time the men will be chasing you around.”")]), _vm._v(" "), _c('p', [_vm._v("“My grandpa told me, if anyone comes sniffing around, he’s going to cut off their man hood.”")]), _vm._v(" "), _c('p', [_vm._v("“And I believe Gerrold would do it. Let’s get our dresses on, we look like we’re going to church.” Said the twins.")]), _vm._v(" "), _c('p', [_vm._v("“Let me see what I can do.” Helewise cut out the ruffles from the neck all the way down to the shoulders. “Now try it on.”")]), _vm._v(" "), _c('p', [_vm._v("“I feel naked and little sexy.”")]), _vm._v(" "), _c('p', [_vm._v("The next twin said, “Fix mine too, Helewise!”")]), _vm._v(" "), _c('p', [_vm._v("“What you both need now is this.” Helewise put a set of pearls around both Marga and Ragga’s neck. Then, she put on clip-on earrings to match. “You need to wear these shawls over your shoulders.”")]), _vm._v(" "), _c('p', [_vm._v("Helewise got dressed up and put on her jewelry.")]), _vm._v(" "), _c('p', [_vm._v("“Let’s take Rueba up to Romane to play with Black.”")]), _vm._v(" "), _c('p', [_vm._v("All the men stopped what they were doing.")]), _vm._v(" "), _c('p', [_vm._v("“Where did those beautiful ladies come from?”")]), _vm._v(" "), _c('p', [_vm._v("Everyone started whistling. Armando came over, all cleaned up.")]), _vm._v(" "), _c('p', [_vm._v("“Do you think I would let you ladies be alone, without an escort?”")]), _vm._v(" "), _c('p', [_vm._v("“Why do you treat me like a child, brother?”")]), _vm._v(" "), _c('p', [_vm._v("“I’m escorting all four of you and I got to say you all look pretty. Let’s go ladies.”")]), _vm._v(" "), _c('p', [_vm._v("“Good evening, Captain.”")]), _vm._v(" "), _c('p', [_vm._v("“My god, this can’t be the same women who were spearing pirates a few days ago!”")]), _vm._v(" "), _c('p', [_vm._v("“Oh Captain, you are making us blush.”")]), _vm._v(" "), _c('p', [_vm._v("“Is that so? Can I offer you all some wine?”")]), _vm._v(" "), _c('p', [_vm._v("“That would be lovely, wouldn’t it girls?”")]), _vm._v(" "), _c('p', [_vm._v("“Sure would, Captain.”")]), _vm._v(" "), _c('p', [_vm._v("The page boy poured wine for everyone except Saige. Instead, he poured her a goblet of lemons squeezed in a picture of water with honey added.")]), _vm._v(" "), _c('p', [_vm._v("“This tastes delicious.”")]), _vm._v(" "), _c('p', [_vm._v("“I’m glad you like it, my dear.”")]), _vm._v(" "), _c('p', [_vm._v("“Captain, how long will this storm last?”")]), _vm._v(" "), _c('p', [_vm._v("“Give it a day or two, we’ll be back on course again.”")]), _vm._v(" "), _c('p', [_vm._v("“Do you think my cousin Garrett, is to his destination yet?”")]), _vm._v(" "), _c('p', [_vm._v("“No, not in these storms.”")]), _vm._v(" "), _c('p', [_vm._v("“How’s the wine, girls?”")]), _vm._v(" "), _c('p', [_vm._v("“It’s delicious. It reminds me of your wine, Sir Armando.”")]), _vm._v(" "), _c('p', [_vm._v("“You are right Ragga, we brought a keg for the captain.”")]), _vm._v(" "), _c('p', [_vm._v("“I must say Armando, you make good wine.”")]), _vm._v(" "), _c('p', [_vm._v("“My brother likes to experiment with grapes and berries. We know our wines.”")]), _vm._v(" "), _c('p', [_vm._v("“And Helewise, you must find time long, my dear, on this ship.”")]), _vm._v(" "), _c('p', [_vm._v("“No, not at all Captain. We help the men with cleaning on deck and we train every day.”")]), _vm._v(" "), _c('p', [_vm._v("“Wouldn’t you rather be in a ballroom dancing?”")]), _vm._v(" "), _c('p', [_vm._v("“It’s kind of hard to go dancing in our country, don’t you think, with everyone’s doors locked up at night. Vampires looking and waiting for their victims.”")]), _vm._v(" "), _c('p', [_vm._v("“You are quite right, Helewise. Is there anyone at home waiting for your hand in marriage?”")]), _vm._v(" "), _c('p', [_vm._v("“We women slayers are too busy to get married, right Marga and Ragga?”")]), _vm._v(" "), _c('p', [_vm._v("“You are right Helewise, I’d rather cut the heads of vampires or pirates instead of cooking and cleaning for a man.”")]), _vm._v(" "), _c('p', [_vm._v("“More wine?”")]), _vm._v(" "), _c('p', [_vm._v("“Yes, of course. That wine is so smooth, Sir Armando.”")]), _vm._v(" "), _c('p', [_vm._v("“Slow down Ragga, you’re on your fourth goblet.”")]), _vm._v(" "), _c('p', [_vm._v("“And why are you counting? Marga, you are on your third glass. What was I going to say?” said Ragga. “Marga, you made me forget!”")]), _vm._v(" "), _c('p', [_vm._v("The captain then rang the dinner bell. The Paige came in with the first course. Lobster chowder.")]), _vm._v(" "), _c('p', [_vm._v("“Saige, how do you like the chowder?”")]), _vm._v(" "), _c('p', [_vm._v("“It is nice and creamy, sir.”")]), _vm._v(" "), _c('p', [_vm._v("“You are young aren’t you, to be a warrior?”")]), _vm._v(" "), _c('p', [_vm._v("“My grandfather trained me at an early age, sir.”")]), _vm._v(" "), _c('p', [_vm._v("“Her grandfather is my top man in charge.”")]), _vm._v(" "), _c('p', [_vm._v("“Armando, you were recently attacked by vampires?”")]), _vm._v(" "), _c('p', [_vm._v("“Yes, we were Captain and my sister and her girls, who were trained for battle, did a wonderful job.”")]), _vm._v(" "), _c('p', [_vm._v("“Thank you, Sir Armando.”")]), _vm._v(" "), _c('p', [_vm._v("Next course was lamb chops.")]), _vm._v(" "), _c('p', [_vm._v("“They are so tender.”")]), _vm._v(" "), _c('p', [_vm._v("“Would you like some mint jelly, Helewise?”")]), _vm._v(" "), _c('p', [_vm._v("“Yes, I’m up to new things Captain. Oh Marga and Ragga, you must try this, it is so cooling on top of the lamb.”")]), _vm._v(" "), _c('p', [_vm._v("“To me Helewise, it tastes like dessert.”")]), _vm._v(" "), _c('p', [_vm._v("“You are so funny, Marga.”")]), _vm._v(" "), _c('p', [_vm._v("“No, I’m Ragga, Captain.”")]), _vm._v(" "), _c('p', [_vm._v("“You two are so alike. How can people tell you apart?”")]), _vm._v(" "), _c('p', [_vm._v("“Only family and friends can, Captain.”")]), _vm._v(" "), _c('p', [_vm._v("“So Captain, your wife doesn’t travel with you?”")]), _vm._v(" "), _c('p', [_vm._v("“No, I am not married, Marga.”")]), _vm._v(" "), _c('p', [_vm._v("“No Captain, I’m Ragga!”")]), _vm._v(" "), _c('p', [_vm._v("“Of course and as I was saying, I am not married.” The captain kept looking at Helewise. “I’m waiting for the right one. Now, we have a surprise for dessert! Its sliced bananas, covered in brandy sauce and clotted cream.”")]), _vm._v(" "), _c('p', [_vm._v("“This tastes like nothing I’ve ever experienced before.”")]), _vm._v(" "), _c('p', [_vm._v("“You got that right, sister! Oh Captain, if only we could pick some up on our way back.”")]), _vm._v(" "), _c('p', [_vm._v("“We will try, Ragga. Oh no, I got it wrong again. Now, what about some brandy to digest that big meal?”")]), _vm._v(" "), _c('p', [_vm._v("“What is brandy?”")]), _vm._v(" "), _c('p', [_vm._v("“It is a spirit served after your evening meal.”")]), _vm._v(" "), _c('p', [_vm._v("“Yes, we would love to try it Captain.”")]), _vm._v(" "), _c('p', [_vm._v("“Helewise, would you like some?”")]), _vm._v(" "), _c('p', [_vm._v("“Why not, Captain.”")]), _vm._v(" "), _c('p', [_vm._v("“And you, Armando?”")]), _vm._v(" "), _c('p', [_vm._v("“Yes, I do like brandy in the night time.” (My darling Roseabella, how I miss you. I will find you my love) “Thanks Captain, for inviting us.”")]), _vm._v(" "), _c('p', [_vm._v("“You are welcome, Armando and you, my lovely ladies, it’s been a pleasure.”")]), _vm._v(" "), _c('p', [_vm._v("“Garrett, it’s been over two months, are we behind schedule?”")]), _vm._v(" "), _c('p', [_vm._v("“Yes of course we are, from all these south winds coming in, we need the wind behind us not in front. Tell the captain we’ll pull into the next port. My family is suffering from sea sickness.”")]), _vm._v(" "), _c('p', [_vm._v("“Roseabella, how are you feeling tonight?”")]), _vm._v(" "), _c('p', [_vm._v("“The same, I can’t believe I’m feeling so tired and sick.”")]), _vm._v(" "), _c('p', [_vm._v("“Drink this, the cook made some ginger tea with honey.”")]), _vm._v(" "), _c('p', [_vm._v("“Ok, it can’t make me any worst.”")]), _vm._v(" "), _c('p', [_vm._v("“It’s not that bad. Rueband’s going to bring some flap jacks, cook said you need to eat dry food. Josiah doesn’t seem to be affected by the wind. Look at him crawling, he’s growing up so fast. He walks around his playpen too! Pretty soon he’ll be walking. Why are you crying, Roseabella?”")]), _vm._v(" "), _c('p', [_vm._v("“Oh Gretta, Armando is missing so much of Josiah’s life. Josiah thinks Garrett is his father.”")]), _vm._v(" "), _c('p', [_vm._v("“We have to make the best of it, Roseabella, Garrett is good to us; he could have treated us a lot worse. Roseabella, I’m going to put a little note in Rueband’s money in the next port we stop.”")]), _vm._v(" "), _c('p', [_vm._v("“What if Garrett finds out and he gets in a rage?”")]), _vm._v(" "), _c('p', [_vm._v("“Garrett will be asleep when he sends it to the port.”")]), _vm._v(" "), _c('p', [_vm._v("“Who will post it?”")]), _vm._v(" "), _c('p', [_vm._v("“Bacia will make sure it goes on a ship going that way.”")]), _vm._v(" "), _c('p', [_vm._v("“Let’s keep our fingers crossed but what if Rueband won’t do it?”")]), _vm._v(" "), _c('p', [_vm._v("“He can’t read very well. I’m teaching him. I’ll just tell him it’s a note to let my poor mother know how we are.”")]), _vm._v(" "), _c('p', [_vm._v("“What exactly are you going to put on this note?”")]), _vm._v(" "), _c('p', [_vm._v("“I’m going to name the port we stopped into. They will know the direction to follow.”")]), _vm._v(" "), _c('p', [_vm._v("“You know Gretta, you are getting too wise for your age.”")]), _vm._v(" "), _c('p', [_vm._v("“You’re yawning again, my sister.”")]), _vm._v(" "), _c('p', [_vm._v("“I’ll get the door.”")]), _vm._v(" "), _c('p', [_vm._v("“Here’s everyone’s meal!”")]), _vm._v(" "), _c('p', [_vm._v("“Smells good!”")]), _vm._v(" "), _c('p', [_vm._v("“There is mashed beef soup for our little sailor. Soup and bread with cheese and roast beef for you, Gretta. For you Roseabella, is more ginger tea and these flap jacks.”")]), _vm._v(" "), _c('p', [_vm._v("“How long have we been at sea, Rueband?”")]), _vm._v(" "), _c('p', [_vm._v("“It’s been three months, my lady. The winds have slowed us down.”")]), _vm._v(" "), _c('p', [_vm._v("“Why are we stopping?”")]), _vm._v(" "), _c('p', [_vm._v("“Sir Garrett wants you to get well again. We are staying in a calmer port for a few days.”")]), _vm._v(" "), _c('p', [_vm._v("“Tell him I feel better already.”")]), _vm._v(" "), _c('p', [_vm._v("“Sir Garrett would like for you to have a few hours of rest alone. He wants me and Gretta to look after Josiah at his quarters.”")]), _vm._v(" "), _c('p', [_vm._v("“I don’t think so.”")]), _vm._v(" "), _c('p', [_vm._v("“Please Roseabella, you need rest. Josiah needs fresh air and can’t be cooped up in this cabin day and night.”")]), _vm._v(" "), _c('p', [_vm._v("“I’ll watch him like a hawk, my lady.”")]), _vm._v(" "), _c('p', [_vm._v("“Alright then, I can hardly keep my eyes open. Wrap a wool blanket around him on deck.”")]), _vm._v(" "), _c('p', [_vm._v("“I always do. Now eat your meal before you sleep.”")]), _vm._v(" "), _c('p', [_vm._v("“Did you eat your soup, young man?”")]), _vm._v(" "), _c('p', [_vm._v("“Dada.”")]), _vm._v(" "), _c('p', [_vm._v("“Yes, I’m your dad. Your mom is having some quiet time to herself. How is Roseabella, Gretta?”")]), _vm._v(" "), _c('p', [_vm._v("“She felt better as soon as the ship stopped. Cook made some ginger tea and it settled her stomach a little.”")]), _vm._v(" "), _c('p', [_vm._v("“Has she kept down any food at all?”")]), _vm._v(" "), _c('p', [_vm._v("“No, not in the last few days but when we left, she was eating flap jacks.”")]), _vm._v(" "), _c('p', [_vm._v("“The stormy weather doesn’t affect you at all, Gretta.”")]), _vm._v(" "), _c('p', [_vm._v("“No and I’m so lucky Garrett because Josiah needs me now and he can crawl.”")]), _vm._v(" "), _c('p', [_vm._v("“Show your father, down you go. What a good job you’re doing.”")]), _vm._v(" "), _c('p', [_vm._v("“Watch this, Garrett.” Gretta stood him up outside of his crib. “Show Dad how you can walk around the crib.”")]), _vm._v(" "), _c('p', [_vm._v("“My god, he’s doing it. What a strong boy you are. Don’t you think, Rueband?”")]), _vm._v(" "), _c('p', [_vm._v("“Yes, Sir Garrett and he has a good grip too.”")]), _vm._v(" "), _c('p', [_vm._v("“Has he been sick, Gretta because he looks thinner?”")]), _vm._v(" "), _c('p', [_vm._v("“Oh no, Roseabella said he’s losing his baby fat. That happens when they crawl and walk.”")]), _vm._v(" "), _c('p', [_vm._v("“Has he had dessert?”")]), _vm._v(" "), _c('p', [_vm._v("“No, Garrett.”")]), _vm._v(" "), _c('p', [_vm._v("“Well, let’s see what we have under this cloth. Some ginger bread cookies.”")]), _vm._v(" "), _c('p', [_vm._v("“They were his favorite at the castle. They’re shaped like stars. How did cook do that?”")]), _vm._v(" "), _c('p', [_vm._v("“He must have cut out the shape.”")]), _vm._v(" "), _c('p', [_vm._v("“He loves them, Garrett. Try one, Rueband. It smells like ginger tea.”")]), _vm._v(" "), _c('p', [_vm._v("“Oh,” said Rueband, “they are good. Could we send my mother the recipe, Sir Garrett?”")]), _vm._v(" "), _c('p', [_vm._v("“Why not? Does anyone else smell that terrible smell?”")]), _vm._v(" "), _c('p', [_vm._v("“I smell it too, Sir Garrett.”")]), _vm._v(" "), _c('p', [_vm._v("“Oh no, he shit his nappy and we didn’t bring spares. I don’t want to wake up Roseabella.”")]), _vm._v(" "), _c('p', [_vm._v("“Dear god, does his dirty nappy always smell that bad?”")]), _vm._v(" "), _c('p', [_vm._v("“Yes sir!”")]), _vm._v(" "), _c('p', [_vm._v("“You two stay with him, open the window, I’ll sneak in and get a nappy and won’t wake your sister.”")]), _vm._v(" "), _c('p', [_vm._v("“You better take some cookies for her just in case.”")]), _vm._v(" "), _c('p', [_vm._v("“Good idea.”")]), _vm._v(" "), _c('p', [_vm._v("“Where are those nappies?” Garrett looked everywhere.")]), _vm._v(" "), _c('p', [_vm._v("“Do you know Garrett, you could wake up the dead?”")]), _vm._v(" "), _c('p', [_vm._v("“Roseabella, I’m sorry I woke you. Josiah has shit in his nappy and Gretta didn’t bring any spares.”")]), _vm._v(" "), _c('p', [_vm._v("“In a basket under his crib.”")]), _vm._v(" "), _c('p', [_vm._v("“Oh alright. How are you feeling?”")]), _vm._v(" "), _c('p', [_vm._v("“A lot better since I drank the ginger tea.”")]), _vm._v(" "), _c('p', [_vm._v("“I have something else for you with ginger in it.”")]), _vm._v(" "), _c('p', [_vm._v("“Oh Garrett, thank you so much and they are shaped like stars. They are good, almost as good as Meiga’s. I do remember her cookies. Garrett, I’m so sorry you can’t eat any.”")]), _vm._v(" "), _c('p', [_vm._v("“No, you’re not, there are only crumbs left!”")]), _vm._v(" "), _c('p', [_vm._v("“My god I’m starving, could you get me chicken soup and bread with cheese and roast beef and some more cookies? And Garrett?”")]), _vm._v(" "), _c('p', [_vm._v("“Yes?”")]), _vm._v(" "), _c('p', [_vm._v("“Ginger cookies makes Josiah’s bowels loose. We gave him ginger cookies when we were washing him up.”")]), _vm._v(" "), _c('p', [_vm._v("“I’ll remember that for the future.”")]), _vm._v(" "), _c('p', [_vm._v("“I’m so glad you got your appetite back, Roseabella.”")]), _vm._v(" "), _c('p', [_vm._v("“Me too Gretta, ever since the weather calmed down.”")]), _vm._v(" "), _c('p', [_vm._v("“Roseabella, could I have some of Josiah’s nappies for my monthly?”")]), _vm._v(" "), _c('p', [_vm._v("“Yes of course, I forget you are a woman now.”")]), _vm._v(" "), _c('p', [_vm._v("“When was your last monthly, Roseabella?”")]), _vm._v(" "), _c('p', [_vm._v("“Well, I can’t remember. It’s about, oh lord, it can’t be.”")]), _vm._v(" "), _c('p', [_vm._v("“What can’t be?”")]), _vm._v(" "), _c('p', [_vm._v("“I think I’m with child, maybe four months.”")]), _vm._v(" "), _c('p', [_vm._v("“What are we going to do, Roseabella?”")]), _vm._v(" "), _c('p', [_vm._v("“There’s not much we can do.”")]), _vm._v(" "), _c('p', [_vm._v("“You are brave, my sister. Armando would be so proud of you. Don’t cry, Roseabella.”")]), _vm._v(" "), _c('p', [_vm._v("“How can I not cry? I’m going to have Armando’s baby by a crazy vampire who will claim it as his own.”")]), _vm._v(" "), _c('p', [_vm._v("“When you get to his estate, you will feel better. All his men respect us now. We will destroy Garrett when he is sleeping. You will be the queen of the estate and we will sail back home.”")]), _vm._v(" "), _c('p', [_vm._v("“You are right, Gretta; we will sail for home after I give birth and turn Garrett to ashes.”")]), _vm._v(" "), _c('p', [_vm._v("“Now, you’re talking!”")]), _vm._v(" "), _c('p', [_vm._v("Five months passed by, when they entered between two giant cliffs.")]), _vm._v(" "), _c('p', [_vm._v("“I can’t believe we fit through.”")]), _vm._v(" "), _c('p', [_vm._v("“I felt the same way the first time.”")]), _vm._v(" "), _c('p', [_vm._v("“I see a beach.”")]), _vm._v(" "), _c('p', [_vm._v("“We will anchor behind the cliff there and enter the beach by row boat. Gretta, go pack your things, your sister must get herself and the baby ready to go ashore.”")]), _vm._v(" "), _c('p', [_vm._v("“Oh Bacia, I can’t wait.”")]), _vm._v(" "), _c('p', [_vm._v("“Roseabella, wake up, you too little boy.”")]), _vm._v(" "), _c('p', [_vm._v("“What’s the matter?”")]), _vm._v(" "), _c('p', [_vm._v("“We are here at Garrett’s island. We need to pack our things, Bacia is taking us to Garrett’s estate.”")]), _vm._v(" "), _c('p', [_vm._v("“Why are you so happy, Gretta?”")]), _vm._v(" "), _c('p', [_vm._v("“We are going to walk on land for the first time in five months.”")]), _vm._v(" "), _c('p', [_vm._v("“You are right, my sister; it will do us all good.”")]), _vm._v(" "), _c('p', [_vm._v("“The beach looks beautiful!”")]), _vm._v(" "), _c('p', [_vm._v("“It’s nice for summer swimming, Gretta. Follow me, I’ll take Josiah for you, lady Roseabella.”")]), _vm._v(" "), _c('p', [_vm._v("“That would be good of you, Rueband.”")]), _vm._v(" "), _c('p', [_vm._v("“This walking trail leads up to Garrett’s estate.”")]), _vm._v(" "), _c('p', [_vm._v("“How much longer is this trail, Bacia?”")]), _vm._v(" "), _c('p', [_vm._v("“A few more minutes’ lady Roseabella and you will be in your new home.”")]), _vm._v(" "), _c('p', [_vm._v("Roseabella looked at the flowers and trees. Rueband opened the gate to their estate.")]), _vm._v(" "), _c('p', [_vm._v("“It looks so fashionable, not like our old castle.”")]), _vm._v(" "), _c('p', [_vm._v("“It’s big with only two floors.”")]), _vm._v(" "), _c('p', [_vm._v("“My lady, it’s nice to finally meet you. Garrett has told me so much about you and his son.”")]), _vm._v(" "), _c('p', [_vm._v("“Is that so? One day I’ll tell you my side of the story.”")]), _vm._v(" "), _c('p', [_vm._v("“You must be tired after a long voyage. I have refreshments set up for you. Please follow me. Rueband will see to your belongings.”")]), _vm._v(" "), _c('p', [_vm._v("They entered a dining room with a table laid out with food and a special chair for Josiah. His chair slid under the table.")]), _vm._v(" "), _c('p', [_vm._v("“Would you like some lemon drink? It’s made from squeezed lemons and water and honey.”")]), _vm._v(" "), _c('p', [_vm._v("“Yes please, we are thirsty from the long walk. It’s very refreshing.”")]), _vm._v(" "), _c('p', [_vm._v("“I have goats’ milk that has been boiled and cooled off.”")]), _vm._v(" "), _c('p', [_vm._v("“It’s been a while since he has had milk. And yes, he was thirsty alright.”")]), _vm._v(" "), _c('p', [_vm._v("“We have prepared a meal for you. We have slices of tomatoes, boiled eggs, cold chicken, cold ham, hot fresh bread, butter and cheese. For dessert, we have fresh fruit and cream. Please help yourselves. After your meal, I will show you to your room.”")]), _vm._v(" "), _c('p', [_vm._v("“Everything looks good, I’m going to eat some of everything. The ham is so tasty and the hot bread is so soft.”")]), _vm._v(" "), _c('p', [_vm._v("“I’ll have some too before you eat it all.”")]), _vm._v(" "), _c('p', [_vm._v("“I’m such a pig lately.”")]), _vm._v(" "), _c('p', [_vm._v("“It’s ok Roseabella, you are eating for two. I can’t believe Garrett has not mentioned you being with child.”")]), _vm._v(" "), _c('p', [_vm._v("“I just started putting on a lot of weight. I put my dress out to a bigger size, I don’t think he noticed.”")]), _vm._v(" "), _c('p', [_vm._v("“You’re going to have to tell him Roseabella, the baby is going to need a crib of his own.”")]), _vm._v(" "), _c('p', [_vm._v("“Yes, you are right, I’ll tell him tonight.”")]), _vm._v(" "), _c('p', [_vm._v("“There are so many different kinds of fruit. Josiah has finished everything on his plate. And I feel a lot better now my belly is full.”")]), _vm._v(" "), _c('p', [_vm._v("“Me too.” Said Gretta.")]), _vm._v(" "), _c('p', [_vm._v("“Would you ladies like a look around or to rest in your bedrooms?”")]), _vm._v(" "), _c('p', [_vm._v("“We’ll go to our rooms for a rest and we’ll look around with Garrett tonight.”")]), _vm._v(" "), _c('p', [_vm._v("“Follow me please, up the stairs.”")]), _vm._v(" "), _c('p', [_vm._v("“How many bedrooms are there?”")]), _vm._v(" "), _c('p', [_vm._v("“Eight rooms on this floor and five rooms on the first floor for the staff. The sailors have cabins out in the fields. You both have your own rooms across from each other. The nursery has a joining room to your room, my lady.”")]), _vm._v(" "), _c('p', [_vm._v("“Oh Roseabella, look at my room, it’s beautiful and so big. And this bed is so soft. Come look at my view, I can see the beach. Let’s have a look at yours, Roseabella. Garrett has marvelous taste. Look at the furniture, it looks so new and shiny. Your bedspread is made out of silk and so are your curtains. What a view! Come and see all the flowers.")]), _vm._v(" "), _c('p', [_vm._v("Roseabella, you lie down and have a nap, I will put Josiah down for a nap in my room with me. He’s not used to being alone yet, we’ll have a sleep in my bed. I’ll wake you up for dinner. Josiah, I think we are all going to like it here.”")]), _vm._v(" "), _c('p', [_vm._v("After the long nap, everyone felt more relaxed. The maids came in with buckets of water to fill up the tubs. Roseabella took Josiah in the tub with her.")]), _vm._v(" "), _c('p', [_vm._v("“You like it in the big tub, don’t you? Stop splashing, you little fish.”")]), _vm._v(" "), _c('p', [_vm._v("“This is heaven,” said Gretta, “I’m going to stay in this tub forever.”")]), _vm._v(" "), _c('p', [_vm._v("Roseabella and Josiah were bathed and dressed when they went to Gretta’s room.")]), _vm._v(" "), _c('p', [_vm._v("“Gretta, you are going to look like a prune. Here’s your towel. I’m starving again.”")]), _vm._v(" "), _c('p', [_vm._v("“You can’t be! I forget that you are eating for two. Ok, give me half hour and we’ll go look for some food. Roseabella why did you wear that tight dress? Your stomach looks huge!”")]), _vm._v(" "), _c('p', [_vm._v("“That’s why I’m wearing it, to see if Garrett will notice.”")]), _vm._v(" "), _c('p', [_vm._v("“He’ll notice alright.”")]), _vm._v(" "), _c('p', [_vm._v("Garrett looked up and saw them walking down the stairs. Josiah was in Gretta’s arms. (Roseabella has put on a lot of weight)")]), _vm._v(" "), _c('p', [_vm._v("“Are you rested up after your nap? And what about you, little man?”")]), _vm._v(" "), _c('p', [_vm._v("“Dada, up, up.”")]), _vm._v(" "), _c('p', [_vm._v("“I’ll take him Gretta, he is getting too big to be carried around. Would you ladies like to take a look around?”")]), _vm._v(" "), _c('p', [_vm._v("“Yes, can’t wait to see your house.”")]), _vm._v(" "), _c('p', [_vm._v("“What about you, Roseabella?”")]), _vm._v(" "), _c('p', [_vm._v("“Why not.”")]), _vm._v(" "), _c('p', [_vm._v("“Are you alright, Roseabella?”")]), _vm._v(" "), _c('p', [_vm._v("“Why wouldn’t I be?”")]), _vm._v(" "), _c('p', [_vm._v("“Follow me. This is the library; I like to read late at night. This is a small dining room for a few people. This room is for playing cards.”")]), _vm._v(" "), _c('p', [_vm._v("“This room is beautiful, Garrett.”")]), _vm._v(" "), _c('p', [_vm._v("“It’s a tea room for you women.”")]), _vm._v(" "), _c('p', [_vm._v("“What women would be having over for tea, Garrett?”")]), _vm._v(" "), _c('p', [_vm._v("“Well, there are women who came to live with their husbands who work for me. We are putting in crops. We are clearing land for our sheep, goats, pigs, and horses to graze.”")]), _vm._v(" "), _c('p', [_vm._v("“You have to pay these people, Garrett; are you rich?”")]), _vm._v(" "), _c('p', [_vm._v("“I have come across a lot of treasures. The last room is for you Josiah, a playroom. A rocking horse that was painted red and white. Four little wooden chairs and a table and wooden painted blocks. And furniture for the grownups. Let me put you up on your horse. He’s a natural, look at him rocking.”")]), _vm._v(" "), _c('p', [_vm._v("“Garrett, he loves it. Look how happy he is.”")]), _vm._v(" "), _c('p', [_vm._v("Gretta and Roseabella sat down on a couch watching Garrett play with Josiah. Garrett was like a child himself.")]), _vm._v(" "), _c('p', [_vm._v("“What energy you have my boy. Let’s all go to the dining room for our evening meal.”")]), _vm._v(" "), _c('p', [_vm._v("“Oh, good I’m starving.”")]), _vm._v(" "), _c('p', [_vm._v("Everyone sat around the big table loaded down with food.")]), _vm._v(" "), _c('p', [_vm._v("“Anyone care for a goblet of wine?”")]), _vm._v(" "), _c('p', [_vm._v("“I would love a glass.”")]), _vm._v(" "), _c('p', [_vm._v("“And what about you, Roseabella?”")]), _vm._v(" "), _c('p', [_vm._v("“No thank you but I would like some milk.”")]), _vm._v(" "), _c('p', [_vm._v("“Milk?”")]), _vm._v(" "), _c('p', [_vm._v("“Yes, please.”")]), _vm._v(" "), _c('p', [_vm._v("“Milk for you Josiah and your mother.”")]), _vm._v(" "), _c('p', [_vm._v("The first course was a seafood chowder.")]), _vm._v(" "), _c('p', [_vm._v("“This is so good. Gretta, could you pass the hot bread and butter?”")]), _vm._v(" "), _c('p', [_vm._v("Roseabella dipped her buttered bun in her chowder and shoved it in her mouth.")]), _vm._v(" "), _c('p', [_vm._v("“This bread is so soft.”")]), _vm._v(" "), _c('p', [_vm._v("“You certainly are hungry, my dear. Second course, we have fried chicken, mash potatoes and gravy.”")]), _vm._v(" "), _c('p', [_vm._v("“This is Helewise’s favorite, Meiga makes it for her twice a week.”")]), _vm._v(" "), _c('p', [_vm._v("“I remember Roseabella, I spent a lot of time eating Meiga’s fried chicken.”")]), _vm._v(" "), _c('p', [_vm._v("“This is crispy and juicy, could you cut up some pieces for Josiah Garrett? He likes mashed potatoes. The potatoes are so creamy and the gravy is nice and thick.”")]), _vm._v(" "), _c('p', [_vm._v("“Roseabella, you could save me a few pieces of chicken.”")]), _vm._v(" "), _c('p', [_vm._v("“Gretta, why are you so slow eating?”")]), _vm._v(" "), _c('p', [_vm._v("“I’m not slow, it’s you who’s eating like a pig.”")]), _vm._v(" "), _c('p', [_vm._v("“What’s gotten into you two?”")]), _vm._v(" "), _c('p', [_vm._v("“Sorry Garrett, for my manners.”")]), _vm._v(" "), _c('p', [_vm._v("“What’s for the third course?”")]), _vm._v(" "), _c('p', [_vm._v("“You’re still hungry?”")]), _vm._v(" "), _c('p', [_vm._v("“Of course, why wouldn’t I be?”")]), _vm._v(" "), _c('p', [_vm._v("“Let me see, we have a leg of lamb. Small roasted potatoes with baby carrots and green beans.”")]), _vm._v(" "), _c('p', [_vm._v("“That lamb looks delicious, don’t it Gretta?”")]), _vm._v(" "), _c('p', [_vm._v("“Yes, it does. Let me put some on your plate, sister. This enough, sister?”")]), _vm._v(" "), _c('p', [_vm._v("“No, more; the slices are thin. And some of the little potatoes and carrots and beans. Garrett, I’m so sorry you can’t eat food anymore. Can you pass the gravy? I’m going to put it all over my lamb.”")]), _vm._v(" "), _c('p', [_vm._v("“If Garrett did eat, he wouldn’t get much, would he?”")]), _vm._v(" "), _c('p', [_vm._v("“Now, I’m full. By the way, what’s for dessert?”")]), _vm._v(" "), _c('p', [_vm._v("“We have bread pudding with brandy sauce and apple pie with cream.”")]), _vm._v(" "), _c('p', [_vm._v("“Please add double cream on my pie. Could I have another glass of milk?”")]), _vm._v(" "), _c('p', [_vm._v("“Roseabella, I have never seen anyone eat so much, especially a young lady.”")]), _vm._v(" "), _c('p', [_vm._v("“I always eat like this when I’m with child.”")]), _vm._v(" "), _c('p', [_vm._v("“What did you say?”")]), _vm._v(" "), _c('p', [_vm._v("“In four months’ time, I will give birth to Armando’s child.”")]), _vm._v(" "), _c('p', [_vm._v("“Four months from now? You’ve been with child for five months on my ship?”")]), _vm._v(" "), _c('p', [_vm._v("“Yes Garrett, at first, I thought it was sea sickness but now you can see how big I am getting. Josiah will be one next month and the baby will be born in the spring.”")]), _vm._v(" "), _c('p', [_vm._v("“That is wonderful news! Let’s have some wine to celebrate, Gretta. To the mother of my children.”")]), _vm._v(" "), _c('p', [_vm._v("“Excuse me but I am suddenly very sleepy. Can you two clean up the baby and get him ready for bed? Will you please put his crib in my room? If he wakes up and I’m not there, he’ll scream his head off. Put the crib in my room now, so you won’t wake me up later. Make sure he’s asleep in your arms before you bring him to my room.”")]), _vm._v(" "), _c('p', [_vm._v("“Is there anything else, my queen?”")]), _vm._v(" "), _c('p', [_vm._v("“Only one more thing; for breakfast, I would like scrambled eggs, sausages, baked beans, ham, fried potatoes and fried bread. And don’t forget the milk and tell cook I will have my breakfast in bed. Good night, everyone.”")]), _vm._v(" "), _c('p', [_vm._v("“Good night, my love.”")]), _vm._v(" "), _c('p', [_vm._v("“Is she always like this when she is with child?”")]), _vm._v(" "), _c('p', [_vm._v("“Yes, Garrett and she’s going to get worse. You’re going to have to carry her up and down the stairs when she gets really big. Maybe Rueband can carry her down, when you are asleep Garrett. That’s if he can lift her.”")]), _vm._v(" "), _c('p', [_vm._v("“Are all expecting mothers like this?”")]), _vm._v(" "), _c('p', [_vm._v("“No, only Roseabella. Poor woman and she gets very emotional. She’s been crying a lot lately. We must not upset her; you see, stress is very hard on the baby. You must talk to the doctor to examine her. She takes three naps a day, so I will need help with Josiah.”")]), _vm._v(" "), _c('p', [_vm._v("“Of course, I will see to it tonight after Josiah’s asleep. I must move the crib right away.”")]), _vm._v(" "), _c('p', [_vm._v("“And whatever you do, don’t wake her up. When you come back, I will get his night clothes. Let’s take him to his playroom, while you move the crib.”")]), _vm._v(" "), _c('p', [_vm._v("“You like the rocking horse, don’t you? Daddy is going to get you all tired out.”")]), _vm._v(" "), _c('p', [_vm._v("“You may go now, Garrett and move the crib.” (My god, two bossy women living in this house.)")]), _vm._v(" "), _c('p', [_vm._v("“Yes of course, Gretta.”")]), _vm._v(" "), _c('p', [_vm._v("“How can a vampire make so much noise moving a crib?”")]), _vm._v(" "), _c('p', [_vm._v("“Roseabella, the damn crib can hardly fit through the door.”")]), _vm._v(" "), _c('p', [_vm._v("“Why didn’t you make the crib smaller?”")]), _vm._v(" "), _c('p', [_vm._v("“I didn’t make the crib.”")]), _vm._v(" "), _c('p', [_vm._v("“Did you make the horse?”")]), _vm._v(" "), _c('p', [_vm._v("“No.”")]), _vm._v(" "), _c('p', [_vm._v("“The blocks?”")]), _vm._v(" "), _c('p', [_vm._v("“No.”")]), _vm._v(" "), _c('p', [_vm._v("“Why not, you have all night long! You can’t carve out horses or blocks, Garrett?”")]), _vm._v(" "), _c('p', [_vm._v("“Why would I? I get people to do those things.”")]), _vm._v(" "), _c('p', [_vm._v("“But why pay coin when you can do it yourself? You can start by making a small crib for the new baby.”")]), _vm._v(" "), _c('p', [_vm._v("“Roseabella, are you telling me what to do? No one ever tells me what to do!”")]), _vm._v(" "), _c('p', [_vm._v("“I guess Armando spoiled me, he never said no.”")]), _vm._v(" "), _c('p', [_vm._v("“I am not Armando! And don’t ever mention his name again. What’s wrong now? Why are you crying?”")]), _vm._v(" "), _c('p', [_vm._v("“You’re upset with me.”")]), _vm._v(" "), _c('p', [_vm._v("“I am not.”")]), _vm._v(" "), _c('p', [_vm._v("“Why are you screaming at me?”")]), _vm._v(" "), _c('p', [_vm._v("“Calm down, I’m sorry you’re getting upset and it’s not good for the baby.”")]), _vm._v(" "), _c('p', [_vm._v("“Just leave me alone, Garrett. I need time to myself.”")]), _vm._v(" "), _c('p', [_vm._v("“The trip has made you exhausted. Good night, my dear.”")]), _vm._v(" "), _c('p', [_vm._v("“I’ll sneak in and get some baby clothes and nappies.”")]), _vm._v(" "), _c('p', [_vm._v("“Good luck.”")]), _vm._v(" "), _c('p', [_vm._v("“Oh no, you didn’t wake her, did you?”")]), _vm._v(" "), _c('p', [_vm._v("“I had to force the bloody crib through the door. I can’t go up now until she is calmed down.”")]), _vm._v(" "), _c('p', [_vm._v("“Could I go outside and get some fresh air? Garrett, I haven’t had a moment to myself.”")]), _vm._v(" "), _c('p', [_vm._v("“What about the baby?”")]), _vm._v(" "), _c('p', [_vm._v("“I won’t be long.”")]), _vm._v(" "), _c('p', [_vm._v("“Ok then, just sit outside the front yard.”")]), _vm._v(" "), _c('p', [_vm._v("“Thank you, Garrett.”")]), _vm._v(" "), _c('p', [_vm._v("“It’s just the two of us, my son. Let’s play with some blocks. Your mother is telling me to build a crib. Who does she think she is? Hopefully in four months, she will be back to herself. What’s that awful smell? Oh no, not again. Where is Gretta with the nappies? I gave the servants the night off. Let’s see how bad it is. Oh dear, it’s everywhere. You are full of it! Let’s go outside and get Gretta. Gretta, Gretta! Where are you?”")]), _vm._v(" "), _c('p', [_vm._v("“Over by the fish pond.”")]), _vm._v(" "), _c('p', [_vm._v("“Go upstairs and get nappies, he is full of shit. Oh, what a smell, too much gravy.”")]), _vm._v(" "), _c('p', [_vm._v("“No, bring him to the nursery, he’s going to need a bath. Check the kitchen for hot water, he won’t need much, we’ll have to mix it with cold. Garrett, put him in his crib.”")]), _vm._v(" "), _c('p', [_vm._v("“The crib is in your sister’s room.”")]), _vm._v(" "), _c('p', [_vm._v("“Holy shit! Put him in his playpen.”")]), _vm._v(" "), _c('p', [_vm._v("“Okay, I’ll be back with water.”")]), _vm._v(" "), _c('p', [_vm._v("“I’ll use some wash rags to clean him up a bit. What is taking him so long? Good thing they had some water in your pan. Those rags are so smelly, let’s put you in the tub with your toys.”")]), _vm._v(" "), _c('p', [_vm._v("“Here, I have two pots of water, can you check the temperature?”")]), _vm._v(" "), _c('p', [_vm._v("“They feel best kind. Pour it in slowly.”")]), _vm._v(" "), _c('p', [_vm._v("“He likes it!”")]), _vm._v(" "), _c('p', [_vm._v("“He loves baths. Splashing is his favorite thing to do.”")]), _vm._v(" "), _c('p', [_vm._v("“You got me all wet, my son.”")]), _vm._v(" "), _c('p', [_vm._v("“Shush! We can’t wake her up again.”")]), _vm._v(" "), _c('p', [_vm._v("“Good god, no!”")]), _vm._v(" "), _c('p', [_vm._v("“Now, he’s all clean. You hold him over the tub, I’ll get his towel.”")]), _vm._v(" "), _c('p', [_vm._v("“Okay. What are you doing, my son?”")]), _vm._v(" "), _c('p', [_vm._v("“Oh Garrett, he’s peeing on you.”")]), _vm._v(" "), _c('p', [_vm._v("“I know that! Put the towel around him. Let’s get him dressed, he can sleep with me. Or he can stay up all night with you.”")]), _vm._v(" "), _c('p', [_vm._v("“Stay up all night with me? Are you crazy? I’m sorry Gretta, please don’t cry. Now Josiah, why are you crying?”")]), _vm._v(" "), _c('p', [_vm._v("“You scared him when you screamed.”")]), _vm._v(" "), _c('p', [_vm._v("“My god, this is my punishment for becoming a vampire. I made three people cry tonight. Gretta, you get ready for bed, I’ll keep him with me until he’s sleepy and I’ll put him in his crib at the playroom.”")]), _vm._v(" "), _c('p', [_vm._v("“Garrett, can you take those shitty rags with you?”")]), _vm._v(" "), _c('p', [_vm._v("“Are you serious?”")]), _vm._v(" "), _c('p', [_vm._v("“I’ll put them in the bucket for you.”")]), _vm._v(" "), _c('p', [_vm._v("“I’m no bloody servant.”")]), _vm._v(" "), _c('p', [_vm._v("Garrett left the nursery with the baby and a bucket of shitty rags.")]), _vm._v(" "), _c('p', [_vm._v("Gretta went in and checked on her sister.")]), _vm._v(" "), _c('p', [_vm._v("“Roseabella, are you crying?”")]), _vm._v(" "), _c('p', [_vm._v("“No, I can’t stop laughing.”")]), _vm._v(" "), _c('p', [_vm._v("“You heard everything?”")]), _vm._v(" "), _c('p', [_vm._v("“Yes.”")]), _vm._v(" "), _c('p', [_vm._v("“Wow, now I can’t stop laughing. Josiah peed on him. It was so funny and he came outside running toward the fish pond with the baby full of shit. Josiah was covered from his neck down to his toes.")]), _vm._v(" "), _c('p', [_vm._v("Now, he’s keeping him in the nursery until he is asleep. If we keep this up, he might send us home. Get some sleep, tomorrow we’ll take a picnic to the beach. We’ll get Rueband to carry the baby to the beach. I have a lot more to tell you. But it can wait.”")]), _vm._v(" "), _c('p', [_vm._v("“Alright then, good night.”")]), _vm._v(" "), _c('p', [_vm._v("“Josiah my son, why are you not sleepy yet? You had your bath and clean clothes. You feel a little warm, are you cutting teeth again? What can I give you to chew on? Let’s go to the kitchen and find something. What about this big wooden spoon? Chew on it like this, chew, chew, put it in your mouth, feel better?")]), _vm._v(" "), _c('p', [_vm._v("I’ll look in the ice box and see if there is any milk. You were thirsty, poor boy. Ok, let’s go back to the play room. You certainly can crawl, up, up, up; oh, you want to get up on the rocking horse?")]), _vm._v(" "), _c('p', [_vm._v("Ok, hold on tight. Back and forth, back and forth, you are so good at it. You stay on your horse; I need to go to the kitchen for some nutrition. I too have to eat soon, I’m starving.")]), _vm._v(" "), _c('p', [_vm._v("Josiah, why are you on the floor crying? You fell off? Let me look at you. Nothing seems broken. Good job I laid down rugs. Let me look at your head. Holy shit, there’s a bump on your head.")]), _vm._v(" "), _c('p', [_vm._v("Don’t cry. I’ll have to wake up your mother. And she’s so moody. Let’s wrap you up and we’ll go see the doctor.”")]), _vm._v(" "), _c('p', [_vm._v("“What’s all the banging? Oh Garrett, what’s wrong?”")]), _vm._v(" "), _c('p', [_vm._v("“My son fell off his rocking horse and bumped his head.”")]), _vm._v(" "), _c('p', [_vm._v("“Bring him in and put him on the table. It’s a big bump. Take all his clothes off, so I can check for bruising.”")]), _vm._v(" "), _c('p', [_vm._v("“I never thought of that. Stop wiggling, Josiah.”")]), _vm._v(" "), _c('p', [_vm._v("“Where’s the boy’s mother?”")]), _vm._v(" "), _c('p', [_vm._v("“She is asleep and needs her rest.”")]), _vm._v(" "), _c('p', [_vm._v("“Is she sick?”")]), _vm._v(" "), _c('p', [_vm._v("“Oh no, she is with child.”")]), _vm._v(" "), _c('p', [_vm._v("“Congratulations, Sir Garrett! I don’t see any more bruising. Is there any ice we had from the ship?”")]), _vm._v(" "), _c('p', [_vm._v("“Yes, in the kitchen.”")]), _vm._v(" "), _c('p', [_vm._v("“You need to keep ice on it for an hour. Wrap it up in a cloth.”")]), _vm._v(" "), _c('p', [_vm._v("“Ok doctor, is he going to be alright?”")]), _vm._v(" "), _c('p', [_vm._v("“His eyes look clear but you must keep him awake for another three hours. When he goes to sleep, you must wake him every half hour to see if he’s responsive.”")]), _vm._v(" "), _c('p', [_vm._v("“Can you come to the house, doctor?”")]), _vm._v(" "), _c('p', [_vm._v("“Excuse me Garrett, I hear someone at the door.”")]), _vm._v(" "), _c('p', [_vm._v("From the other side of the door, “Doctor, it’s my wife, I think she’s losing the baby.”")]), _vm._v(" "), _c('p', [_vm._v("“Garrett, I’ll come to check on him later. Just do as I told you and he will be fine. Please lay your wife on the table.”")]), _vm._v(" "), _c('p', [_vm._v("“Josiah, we can’t tell your mother, she could get so upset and end up like that woman. We got to keep the cloth on your head, Josiah. I know it’s cold but it will make your bump smaller.”")]), _vm._v(" "), _c('p', [_vm._v("“Garrett, I came to check to see how you two were doing. And why do you have that big cloth on Josiah’s head?”")]), _vm._v(" "), _c('p', [_vm._v("“To keep the swelling off his bump. You see, he fell of his rocking horse.”")]), _vm._v(" "), _c('p', [_vm._v("“My god, should I wake up his mother?”")]), _vm._v(" "), _c('p', [_vm._v("“Of course not. The doctor said he’s going to be ok, if we follow the instructions. The ice must stay on for one hour. He stays awake for four hours. And after he sleeps, he needs to be awakened up every half hour to see if he is responding.”")]), _vm._v(" "), _c('p', [_vm._v("“How are we going to keep him awake? He’s yawning already.”")]), _vm._v(" "), _c('p', [_vm._v("“Why don’t we take him outside to see the fish swimming around in the pond?”")]), _vm._v(" "), _c('p', [_vm._v("“Look Josiah fish, see the fish. He likes splashing the water. Let him splash all he wants if it keeps him awake. Garrett, everything looks so beautiful with candle light.”")]), _vm._v(" "), _c('p', [_vm._v("“Rueband lights them in the evening. I like to sit outside.”")]), _vm._v(" "), _c('p', [_vm._v("“And you’re spending a lot of time with Josiah tonight.”")]), _vm._v(" "), _c('p', [_vm._v("Garrett said, “My mother and father were never around much, they like to travel. And when I got older, I demanded to be dropped off with my uncle and aunt.”")]), _vm._v(" "), _c('p', [_vm._v("“You mean Armando’s parents?”")]), _vm._v(" "), _c('p', [_vm._v("“Yes, we were close back then.”")]), _vm._v(" "), _c('p', [_vm._v("“You both look alike except for the eyes. Were your eyes always black?”")]), _vm._v(" "), _c('p', [_vm._v("“They’re black?”")]), _vm._v(" "), _c('p', [_vm._v("“Yes.”")]), _vm._v(" "), _c('p', [_vm._v("“No, they were brown like my mother’s.”")]), _vm._v(" "), _c('p', [_vm._v("“Where are your parents? Are they dead?”")]), _vm._v(" "), _c('p', [_vm._v("“No, no, they left the country after I was buried.”")]), _vm._v(" "), _c('p', [_vm._v("“They don’t know you are alive?”")]), _vm._v(" "), _c('p', [_vm._v("“No and I want to keep it that way.”")]), _vm._v(" "), _c('p', [_vm._v("“Have you had a chance to feed tonight?”")]), _vm._v(" "), _c('p', [_vm._v("“Small amounts so far.”")]), _vm._v(" "), _c('p', [_vm._v("“You won’t bite me, will you?”")]), _vm._v(" "), _c('p', [_vm._v("“Oh Gretta, you are one in a million.”")]), _vm._v(" "), _c('p', [_vm._v("“You go and feed and I will get a snack for the baby.”")]), _vm._v(" "), _c('p', [_vm._v("“Good idea, it’s going to be a late night.”")]), _vm._v(" "), _c('p', [_vm._v("Garrett woke the baby every half hour. Gretta was asleep on the couch.")]), _vm._v(" "), _c('p', [_vm._v("“Gretta, wake up. It’s almost daylight.”")]), _vm._v(" "), _c('p', [_vm._v("“What?”")]), _vm._v(" "), _c('p', [_vm._v("“Yes, let’s put the baby in your bed upstairs.”")]), _vm._v(" "), _c('p', [_vm._v("“Ok, is he ok?”")]), _vm._v(" "), _c('p', [_vm._v("“Yes, let’s go.”")]), _vm._v(" "), _c('p', [_vm._v("Roseabella felt fresh from her long nights’ sleep.")]), _vm._v(" "), _c('p', [_vm._v("“Here’s your breakfast, my lady.”")]), _vm._v(" "), _c('p', [_vm._v("“Thank you so much. I’m starved. Have my sister and baby been fed yet?”")]), _vm._v(" "), _c('p', [_vm._v("“No, my lady, they were fast asleep when I checked on them.”")]), _vm._v(" "), _c('p', [_vm._v("“Let them sleep, Josiah is cutting teeth, so he doesn’t sleep soundly.”")]), _vm._v(" "), _c('p', [_vm._v("Roseabella finished everything on her plate.")]), _vm._v(" "), _c('p', [_vm._v("“What a beautiful day.” As she stepped out on the balcony. “The flowers smell like perfume, I wonder what they are called. Everything is so different in the daylight. I can see the men clearing land. There are women hanging out clothes. There are kids feeding chickens. What a beautiful island. Garrett, why couldn’t’ you find a woman vampire and spend out your long life with her. Armando, I ache at night for you. Please find us. We need a picnic; poor Gretta needs a break.”")]), _vm._v(" "), _c('p', [_vm._v("“Gretta, wake up, you and Josiah slept through breakfast. And how’s my darling boy today? You look tired Gretta, was he up with sore gums all night?”")]), _vm._v(" "), _c('p', [_vm._v("“He needs food and milk.”")]), _vm._v(" "), _c('p', [_vm._v("“Would you like something?”")]), _vm._v(" "), _c('p', [_vm._v("“I need more sleep, wake me up when you’re ready to go to the beach.”")]), _vm._v(" "), _c('p', [_vm._v("“Ok little sister, you go back to sleep. We need a picnic to take to the beach. Enough for three adults and a baby. Pack a big blanket for us too. Josiah needs extra liquids in the hot sun.”")]), _vm._v(" "), _c('p', [_vm._v("“We have watermelon.”")]), _vm._v(" "), _c('p', [_vm._v("“What’s a watermelon?”")]), _vm._v(" "), _c('p', [_vm._v("“It’s a big fruit that is soft for him and it contains lots of juice and its sweet.”")]), _vm._v(" "), _c('p', [_vm._v("“That would be great, pack enough for everyone.”")]), _vm._v(" "), _c('p', [_vm._v("“I will tell Rueband to set up the shade. The sun will burn the baby and you.”")]), _vm._v(" "), _c('p', [_vm._v("“I must wake up Gretta. It’s about time you woke up!”")]), _vm._v(" "), _c('p', [_vm._v("“This is the most comfortable bed I have ever slept in.”")]), _vm._v(" "), _c('p', [_vm._v("“What will you wear swimming Gretta?”")]), _vm._v(" "), _c('p', [_vm._v("“There’s a swimming outfit in the closet.”")]), _vm._v(" "), _c('p', [_vm._v("“Well get to it, the day is wasting away.”")]), _vm._v(" "), _c('p', [_vm._v("“Hi Rueband.”")]), _vm._v(" "), _c('p', [_vm._v("“Hi Gretta. How was your first night in the big house?”")]), _vm._v(" "), _c('p', [_vm._v("“It was a long night.”")]), _vm._v(" "), _c('p', [_vm._v("Rueband looked at Roseabella with a shock. (Where did that big belly come from, it wasn’t there yesterday.)")]), _vm._v(" "), _c('p', [_vm._v("“I can carry the baby, lady Roseabella.”")]), _vm._v(" "), _c('p', [_vm._v("“I am with child, Rueband in case you’re wondering why I look so big.”")]), _vm._v(" "), _c('p', [_vm._v("Rueband turned red and took the baby.")]), _vm._v(" "), _c('p', [_vm._v("“Gretta, can you manage the basket?”")]), _vm._v(" "), _c('p', [_vm._v("“Yes, of course. You couldn’t fit into your swimming outfit, Roseabella?”")]), _vm._v(" "), _c('p', [_vm._v("“I didn’t try.”")]), _vm._v(" "), _c('p', [_vm._v("“You should have, it’s very loose fitting.”")]), _vm._v(" "), _c('p', [_vm._v("“I will next time. Here’s your blocks, my boy and your carved animals.”")]), _vm._v(" "), _c('p', [_vm._v("There was a canvas tied to four tall poles.")]), _vm._v(" "), _c('p', [_vm._v("“This is nice, you go for a swim and I will watch.”")]), _vm._v(" "), _c('p', [_vm._v("Rueband and Gretta ran for the water.")]), _vm._v(" "), _c('p', [_vm._v("“It’s so warm. I have never swum in the ocean before.”")]), _vm._v(" "), _c('p', [_vm._v("“What are you wearing?”")]), _vm._v(" "), _c('p', [_vm._v("“It’s a swimming outfit.”")]), _vm._v(" "), _c('p', [_vm._v("“It’s the first time I’ve seen a woman wear one.”")]), _vm._v(" "), _c('p', [_vm._v("“What do they wear then?”")]), _vm._v(" "), _c('p', [_vm._v("“Just their underclothes.”")]), _vm._v(" "), _c('p', [_vm._v("“I’ll stick to this outfit.”")]), _vm._v(" "), _c('p', [_vm._v("“Let’s dive for snails.”")]), _vm._v(" "), _c('p', [_vm._v("“I got one, what a beautiful shell.”")]), _vm._v(" "), _c('p', [_vm._v("“Inside, the meat is sweet, we cook them in a kettle of hot water over a fire. Let’s get some more.”")]), _vm._v(" "), _c('p', [_vm._v("“We need something to put them in.”")]), _vm._v(" "), _c('p', [_vm._v("“I’ll get my cap to put them in.”")]), _vm._v(" "), _c('p', [_vm._v("“We’ll take turns diving.”")]), _vm._v(" "), _c('p', [_vm._v("“My cap is full. Let’s show them to Josiah.”")]), _vm._v(" "), _c('p', [_vm._v("“Look Roseabella, we dove to the bottom and got snails.”")]), _vm._v(" "), _c('p', [_vm._v("“And you can eat them, you steam them and dip them in hot garlic butter, Lady Roseabella.”")]), _vm._v(" "), _c('p', [_vm._v("“I’ll pass Rueband.”")]), _vm._v(" "), _c('p', [_vm._v("“Can I take the baby for a little splash in the water?”")]), _vm._v(" "), _c('p', [_vm._v("“Yes but keep his cap on him.”")]), _vm._v(" "), _c('p', [_vm._v("“Let’s get your feet wet, little man.”")]), _vm._v(" "), _c('p', [_vm._v("“So, Gretta what else you got to tell me about Garrett?”")]), _vm._v(" "), _c('p', [_vm._v("“What do you mean?”")]), _vm._v(" "), _c('p', [_vm._v("“Last night, you had a few more funny stories.”")]), _vm._v(" "), _c('p', [_vm._v("“Oh that! I told Garrett you’ll get so big; he would have to carry you down the stairs in the evening. You should have seen his face. I said to him, Garrett what will we do in the day time? He said I could ask Rueband but he won’t be able to lift her.”")]), _vm._v(" "), _c('p', [_vm._v("“You never, Gretta!”")]), _vm._v(" "), _c('p', [_vm._v("“Yes, I did. Then, he asks if all pregnant women get so big. I said no, just my sister because she can’t stop eating. I wish you could see his face, I’m sure he even turned whiter.”")]), _vm._v(" "), _c('p', [_vm._v("“Can you go get the baby so we can eat, I’m starved.”")]), _vm._v(" "), _c('p', [_vm._v("“We have bread with beef and cheese between it. Boiled eggs, apple pie and bread pudding and rum sauce. Who wants cold lemon drink?”")]), _vm._v(" "), _c('p', [_vm._v("“We all will try some. It’s good, it’s tarty and sweet. Everyone, help yourselves.”")]), _vm._v(" "), _c('p', [_vm._v("She had Josiah’s all cut up for him.")]), _vm._v(" "), _c('p', [_vm._v("“Josiah has finished his food. There is one thing left called watermelon.”")]), _vm._v(" "), _c('p', [_vm._v("Rueband said, “I love it, it keeps the thirst away.”")]), _vm._v(" "), _c('p', [_vm._v("“Let’s try some. It tastes so sweet and juicy.”")]), _vm._v(" "), _c('p', [_vm._v("“You’re right, let’s see if Josiah will like it.”")]), _vm._v(" "), _c('p', [_vm._v("“He wants more.”")]), _vm._v(" "), _c('p', [_vm._v("“Of course, he does, he’s like his mother, always hungry.”")]), _vm._v(" "), _c('p', [_vm._v("“Go back to swimming, I and Josiah will take a nap.”")]), _vm._v(" "), _c('p', [_vm._v("“Let’s pick some sea shells. Do you always swim here Rueband?”")]), _vm._v(" "), _c('p', [_vm._v("“Yes, most times. When I want to be alone, I go to a little waterfall down the beach. I can’t leave Roseabella and Josiah unattended. Garrett would not like it. I’ll show you when it’s just the two of us.”")]), _vm._v(" "), _c('p', [_vm._v("“I would like that.”")]), _vm._v(" "), _c('p', [_vm._v("“Why do you have those long sticks? They feel smooth.”")]), _vm._v(" "), _c('p', [_vm._v("“Take one, we will fight.”")]), _vm._v(" "), _c('p', [_vm._v("“You’re pretty good.”")]), _vm._v(" "), _c('p', [_vm._v("“Yes, Roseabella trained me. My sister is a great warrior. She wanted me to defend myself against vampires. I can use a bow and arrow, a sword and a spear.”")]), _vm._v(" "), _c('p', [_vm._v("“What’s a spear?”")]), _vm._v(" "), _c('p', [_vm._v("“They are like these sticks but they are sharper on the end. They can go through a vampire’s heart. Rueband, the man who attacked us, I haven’t seen him.”")]), _vm._v(" "), _c('p', [_vm._v("“And you won’t. After he attacked us, Garrett gave him his lashes in front of the crew, he then fed him to the sharks. Gretta, could we practice for an hour every day, I like to keep in shape. I need you to teach me the swords.”")]), _vm._v(" "), _c('p', [_vm._v("“I’ll ask Garrett tonight. There’re up from their nap, we better get packed up.”")]), _vm._v(" "), _c('p', [_vm._v("“Rueband, thank you for your help today with Josiah on the beach.”")]), _vm._v(" "), _c('p', [_vm._v("“You are welcome, lady Roseabella.”")]), _vm._v(" "), _c('p', [_vm._v("“I’m happy Gretta has a friend, it’s not easy being taken away from your parents so young.”")]), _vm._v(" "), _c('p', [_vm._v("“I understand my lady. Gretta is going to teach me some training skills.”")]), _vm._v(" "), _c('p', [_vm._v("“Oh, she will like that!”")]), _vm._v(" "), _c('p', [_vm._v("“When did you get so smart, Roseabella?”")]), _vm._v(" "), _c('p', [_vm._v("“I was always smart father; you just didn’t notice.”")]), _vm._v(" "), _c('p', [_vm._v("“That was the last words she said to me and she said you will lose a part of your heart when Gretta leaves home.”")]), _vm._v(" "), _c('p', [_vm._v("“Yes, my husband. I heard her say that to you.”")]), _vm._v(" "), _c('p', [_vm._v("“I should have gone with Armando to look for them.”")]), _vm._v(" "), _c('p', [_vm._v("“We need you here. Ardelean’s not herself. Our son feels guilty because he didn’t protect them.”")]), _vm._v(" "), _c('p', [_vm._v("“I wonder are they alive? Are they turned into vampires? I ask myself this every day. We might never see them again.”")]), _vm._v(" "), _c('p', [_vm._v("“My dear husband, he won’t hurt them. Armando says Garrett wanted a human family. Ardelean, I didn’t see you standing there.”")]), _vm._v(" "), _c('p', [_vm._v("“I miss Gretta so much, mother. I treated her so badly, always teasing her. I even miss her jokes. This house is so lonely without her. Josiah must be getting big and we won’t see him grow up.”")]), _vm._v(" "), _c('p', [_vm._v("“Stop it Ardelean, your sister knows you love her. Siblings always fight until they are grown up and leave home. We will all be together again; we must have faith.”")]), _vm._v(" "), _c('p', [_vm._v("“Armando, we’ve been sailing for six months. I know the weather has kept us behind but do you think we are off course? We haven’t seen any ports in weeks.”")]), _vm._v(" "), _c('p', [_vm._v("“Do you want us to give up Helewise? You can get a ship back home when we stop for supplies.”")]), _vm._v(" "), _c('p', [_vm._v("“I don’t think we will see any more settlements, there’s nothing but cliffs and mountains. I think we’re lost!”")]), _vm._v(" "), _c('p', [_vm._v("“The captain knows, Helewise, where we are going. Go bother him, I can’t take your nagging.”")]), _vm._v(" "), _c('p', [_vm._v("“Well! Excuse me brother! Captain, can I have a word with you?”")]), _vm._v(" "), _c('p', [_vm._v("“Of course, you can Helewise. Ask me anything you like.”")]), _vm._v(" "), _c('p', [_vm._v("“Are we lost or off course?”")]), _vm._v(" "), _c('p', [_vm._v("“No, my dear, it’s just the hurricane season and we are behind.”")]), _vm._v(" "), _c('p', [_vm._v("“So, why haven’t we seen any settlements lately?”")]), _vm._v(" "), _c('p', [_vm._v("“You need coves, Helewise, for settlements and there’s all high cliffs and mountains but any time soon, we will run into settlements. May I walk around deck with you for a while, Helewise?”")]), _vm._v(" "), _c('p', [_vm._v("“If you like, Captain. Come along, Rueba.”")]), _vm._v(" "), _c('p', [_vm._v("“I must say that’s the biggest dog I have ever seen and I’ve seen a lot of dogs before and from different mixed breeds.”")]), _vm._v(" "), _c('p', [_vm._v("“And she is still a pup! Her brother is as tall but not so broad. She has so many colors.”")]), _vm._v(" "), _c('p', [_vm._v("“And how is her training coming along?”")]), _vm._v(" "), _c('p', [_vm._v("“She is doing quite well. It’s Saige we have to give thanks to. She talks to her like she’s a person instead of a dog.”")]), _vm._v(" "), _c('p', [_vm._v("“Helewise, you are a beautiful woman. I’ve become very fond of you. I think about you all the time. Would you have dinner with me tonight? I promise you I’ll be a perfect gentleman.”")]), _vm._v(" "), _c('p', [_vm._v("“Armando won’t allow it.”")]), _vm._v(" "), _c('p', [_vm._v("“Your brother gave me permission only if you agree and you have to bring your dog.”")]), _vm._v(" "), _c('p', [_vm._v("“I’ll only have to say attack and she’ll knock you to the ground. Not now Rueba! Ok Captain, I will have dinner with you.”")]), _vm._v(" "), _c('p', [_vm._v("“I look forward to it, Helewise.”")]), _vm._v(" "), _c('p', [_vm._v("“You’re going to have dinner with the Captain alone? Is that a good idea? What if he forces himself on you?”")]), _vm._v(" "), _c('p', [_vm._v("“Rueba’s coming with me.”")]), _vm._v(" "), _c('p', [_vm._v("“You’re taking our big dog to have dinner with the Captain? Did you hear that, Ragga?”")]), _vm._v(" "), _c('p', [_vm._v("“Of course, I heard it, I’m not deaf. I hope he has lots of food cooked.”")]), _vm._v(" "), _c('p', [_vm._v("“It was Armando’s rules, the dog is my protector.”")]), _vm._v(" "), _c('p', [_vm._v("“The dog is saving your reputation.”")]), _vm._v(" "), _c('p', [_vm._v("“That’s a good one, Marga.”")]), _vm._v(" "), _c('p', [_vm._v("“Will you two give it up? It’s a dinner invitation not a marriage proposal.”")]), _vm._v(" "), _c('p', [_vm._v("“Does he have feelings for you?”")]), _vm._v(" "), _c('p', [_vm._v("“Do you have feelings for him?”")]), _vm._v(" "), _c('p', [_vm._v("“Enough with the questions! Ok yes, he’s fond of me.”")]), _vm._v(" "), _c('p', [_vm._v("“He told you that?”")]), _vm._v(" "), _c('p', [_vm._v("“Yes, when we were walking together.”")]), _vm._v(" "), _c('p', [_vm._v("“Now it’s getting interesting, Ragga! Now, I ask you again, do you have feelings for him?”")]), _vm._v(" "), _c('p', [_vm._v("“I don’t know, he seems interesting. He travels a lot. He has a lot of stories. He’s rich, you know. He has six ships of his own in the trading goods. Three passenger ships. His father has a ship building business.”")]), _vm._v(" "), _c('p', [_vm._v("“We all know that! So, you like him?”")]), _vm._v(" "), _c('p', [_vm._v("“I didn’t say that.”")]), _vm._v(" "), _c('p', [_vm._v("“My god, what if he is going to ask you to become his wife?”")]), _vm._v(" "), _c('p', [_vm._v("“Marga has a point.”")]), _vm._v(" "), _c('p', [_vm._v("“You two are making me nervous.”")]), _vm._v(" "), _c('p', [_vm._v("“Don’t let him get you drunk and make you say yes.”")]), _vm._v(" "), _c('p', [_vm._v("“Can you both leave, so I can have my bath in private?”")]), _vm._v(" "), _c('p', [_vm._v("“Of course, Helewise and don’t keep the captain waiting!”")]), _vm._v(" "), _c('p', [_vm._v("“This bath is what I needed. What will I wear? I’ll wear the blue dress that matches my eyes.”")]), _vm._v(" "), _c('p', [_vm._v("“You look very nice, Helewise.”")]), _vm._v(" "), _c('p', [_vm._v("“Thank you, Saige. Did the twins tell you I was dining with the Captain?”")]), _vm._v(" "), _c('p', [_vm._v("“They mentioned it. You go have some fun; it’s been a long voyage.”")]), _vm._v(" "), _c('p', [_vm._v("“Are you ok, Saige? It’s a long way from home for you too.”")]), _vm._v(" "), _c('p', [_vm._v("“I do miss my grandparents and Hatmanu but I’m glad I have you three.”")]), _vm._v(" "), _c('p', [_vm._v("“And we feel the same about you, Saige. Saige, what are you doing tying a ribbon around Rueba’s neck?”")]), _vm._v(" "), _c('p', [_vm._v("“She needs to look nice too!”")]), _vm._v(" "), _c('p', [_vm._v("“Oh Helewise, I’m so glad you made it and you too, Rueba. Set Rueba over there in the corner.”")]), _vm._v(" "), _c('p', [_vm._v("Rueba took off and sat in the corner.")]), _vm._v(" "), _c('p', [_vm._v("“Would you like some wine, my dear?”")]), _vm._v(" "), _c('p', [_vm._v("“That would be lovely. It tastes so good on a hot day.”")]), _vm._v(" "), _c('p', [_vm._v("“It certainly does. Are you and your friends still training every day?”")]), _vm._v(" "), _c('p', [_vm._v("“Yes, we need to keep in shape. The man we are after is a vampire and he could have an army of them on his island.”")]), _vm._v(" "), _c('p', [_vm._v("“You must stay on this ship with me.”")]), _vm._v(" "), _c('p', [_vm._v("“Whatever for, Captain?”")]), _vm._v(" "), _c('p', [_vm._v("“Please call me Morgan.”")]), _vm._v(" "), _c('p', [_vm._v("“I couldn’t, what would everyone say?”")]), _vm._v(" "), _c('p', [_vm._v("“What about when we are alone?”")]), _vm._v(" "), _c('p', [_vm._v("“Alright then, Morgan. What were we talking about?”")]), _vm._v(" "), _c('p', [_vm._v("“Going to the island.”")]), _vm._v(" "), _c('p', [_vm._v("“Oh yes and I’m capable of destroying a few vampires. Spear them through the heart and they turn to ashes.”")]), _vm._v(" "), _c('p', [_vm._v("“You are a brave woman.”")]), _vm._v(" "), _c('p', [_vm._v("“Thank you, Morgan.”")]), _vm._v(" "), _c('p', [_vm._v("“More wine?”")]), _vm._v(" "), _c('p', [_vm._v("“Why not! You can lie down now, Rueba.”")]), _vm._v(" "), _c('p', [_vm._v("“This cousin of yours, why did he kidnap your brother’s wife and child?”")]), _vm._v(" "), _c('p', [_vm._v("“He and my brother were best friends, Garrett is mad with the world and God. He wants to be human. Armando walks around in daylight and has a family, a son, something Garrett will never have. He can live for hundreds of years and for what? No son to pass down his legacy. So, he takes what is closest to a son that he will ever have.”")]), _vm._v(" "), _c('p', [_vm._v("“Why not just take the boy?”")]), _vm._v(" "), _c('p', [_vm._v("“Garrett still has some good in him deep down. He won’t take a child from his mother’s arms.”")]), _vm._v(" "), _c('p', [_vm._v("“Will he kill you if you get in his way?”")]), _vm._v(" "), _c('p', [_vm._v("“That I’m not sure of.”")]), _vm._v(" "), _c('p', [_vm._v("“What about our crew?”")]), _vm._v(" "), _c('p', [_vm._v("“In a heartbeat!”")]), _vm._v(" "), _c('p', [_vm._v("“Would you kill him?”")]), _vm._v(" "), _c('p', [_vm._v("“For what he’s put us through, yes in a heartbeat!”")]), _vm._v(" "), _c('p', [_vm._v("“I’ve never met a woman like you before. You fascinate me.”")]), _vm._v(" "), _c('p', [_vm._v("“Thank you, Morgan. And can you defend yourself in battles, Morgan?”")]), _vm._v(" "), _c('p', [_vm._v("“I’m an excellent swords man.”")]), _vm._v(" "), _c('p', [_vm._v("“Maybe I’ll take you on some time.”")]), _vm._v(" "), _c('p', [_vm._v("“I’ll look forward to that Helewise. Come in.”")]), _vm._v(" "), _c('p', [_vm._v("“Your first course, sir.”")]), _vm._v(" "), _c('p', [_vm._v("“Yes, you may serve. Cream of chicken soup, my lady.”")]), _vm._v(" "), _c('p', [_vm._v("“Looks good, can’t wait to try it. Yes, very tasty indeed. My friends would like this.”")]), _vm._v(" "), _c('p', [_vm._v("“Do you find it stuffy sharing a small room with three women?”")]), _vm._v(" "), _c('p', [_vm._v("“At first, I did; you see, I have a huge bedroom in the castle. The castle has so many rooms and space. But now, I got used to them and I never had any true friends before. They treat me like one of their own.”")]), _vm._v(" "), _c('p', [_vm._v("“Your second course sir, is roasted duck and roasted vegetables. And for dessert, banana pie.”")]), _vm._v(" "), _c('p', [_vm._v("“Thank you, that will be all, you are dismissed.”")]), _vm._v(" "), _c('p', [_vm._v("“Where did you get more bananas?”")]), _vm._v(" "), _c('p', [_vm._v("“Well if you pick them really green, they last a long time before they ripen.”")]), _vm._v(" "), _c('p', [_vm._v("“The duck skin is so crispy and juicy, just the way I like it.”")]), _vm._v(" "), _c('p', [_vm._v("“My dear, that’s the only way to serve it. Let me refill your goblet.”")]), _vm._v(" "), _c('p', [_vm._v("“You’re not trying to get me drunk are you, Morgan?”")]), _vm._v(" "), _c('p', [_vm._v("“I would never do that to you, Helewise. Take your time and drink slowly. I’m enjoying your company Helewise and I’d like to see a lot more of you.”")]), _vm._v(" "), _c('p', [_vm._v("“You see me every day, Captain.”")]), _vm._v(" "), _c('p', [_vm._v("“I would like to court you.”")]), _vm._v(" "), _c('p', [_vm._v("“It’s not the right place to go courting on a ship full of men looking to hunt down vampires.”")]), _vm._v(" "), _c('p', [_vm._v("“You are right, my dear. Whenever we get back to civilization, could I call on you?”")]), _vm._v(" "), _c('p', [_vm._v("“If my brother agrees.”")]), _vm._v(" "), _c('p', [_vm._v("“You just made me a happy man.”")]), _vm._v(" "), _c('p', [_vm._v("“This is my favorite pie from now on. The girls are going to be jealous.”")]), _vm._v(" "), _c('p', [_vm._v("“Why don’t you take the rest back with you?”")]), _vm._v(" "), _c('p', [_vm._v("“Saige will love it!”")]), _vm._v(" "), _c('p', [_vm._v("“Roseabella, how are you feeling tonight?”")]), _vm._v(" "), _c('p', [_vm._v("“Tired, bad back and big as a whale.”")]), _vm._v(" "), _c('p', [_vm._v("“My dear, you are glowing, being with child agrees with you.”")]), _vm._v(" "), _c('p', [_vm._v("“Thank you, Garrett.”")]), _vm._v(" "), _c('p', [_vm._v("“It’s not too chilly out here for you?”")]), _vm._v(" "), _c('p', [_vm._v("“No, it cools off my swollen feet.”")]), _vm._v(" "), _c('p', [_vm._v("“The doctor said you must cut out all salt and cut back on sweets.”")]), _vm._v(" "), _c('p', [_vm._v("“Garrett, you can tell the doctor to jump off a cliff!”")]), _vm._v(" "), _c('p', [_vm._v("“Tell who to jump off a cliff?”")]), _vm._v(" "), _c('p', [_vm._v("“Are you eavesdropping, little sister?”")]), _vm._v(" "), _c('p', [_vm._v("“Of course not.”")]), _vm._v(" "), _c('p', [_vm._v("“Her doctor is who she meant.”")]), _vm._v(" "), _c('p', [_vm._v("“Why? What did he do?”")]), _vm._v(" "), _c('p', [_vm._v("“He’s worried about her swollen feet.”")]), _vm._v(" "), _c('p', [_vm._v("“She has too much weight on. Keep your feet up on this chair, they’ll swell more when hanging down.”")]), _vm._v(" "), _c('p', [_vm._v("“You’ve been spending too much time with the doctor, Gretta.”")]), _vm._v(" "), _c('p', [_vm._v("“He’s teaching me how to sew up cuts and how to set broken bones.”")]), _vm._v(" "), _c('p', [_vm._v("“Do you want to become a doctor, Gretta?” asked Garrett.")]), _vm._v(" "), _c('p', [_vm._v("“Women can’t become doctors, Garrett but I can be an assistant to a doctor.”")]), _vm._v(" "), _c('p', [_vm._v("“There are women healers.”")]), _vm._v(" "), _c('p', [_vm._v("“You are right but they will never be called a doctor. Doctor Bardue said I’m a fast learner. He said I could help out with your birthing.”")]), _vm._v(" "), _c('p', [_vm._v("“You really want to watch?”")]), _vm._v(" "), _c('p', [_vm._v("“Yes, I would, wouldn’t you, Garrett?”")]), _vm._v(" "), _c('p', [_vm._v("“I’m afraid not. I don’t like women screaming.”")]), _vm._v(" "), _c('p', [_vm._v("“My back is killing me. Garrett, can you help me to my room?”")]), _vm._v(" "), _c('p', [_vm._v("“That’s a good idea, you’d be more comfortable in bed. Take your time, no rush. Just few more to go. Why are you stopping? Is it your back? I can carry you.”")]), _vm._v(" "), _c('p', [_vm._v("“My water just broke.”")]), _vm._v(" "), _c('p', [_vm._v("“What does that mean?”")]), _vm._v(" "), _c('p', [_vm._v("“Look down at my feet.”")]), _vm._v(" "), _c('p', [_vm._v("“There’s a puddle of water there and it’s running down your legs.”")]), _vm._v(" "), _c('p', [_vm._v("“Garrett, what are you doing?”")]), _vm._v(" "), _c('p', [_vm._v("“I’m going to carry you up to your bedroom. I have strength of ten men. You lie down. Gretta will come up and I will get the doctor. Gretta, its time!”")]), _vm._v(" "), _c('p', [_vm._v("“Time for what?”")]), _vm._v(" "), _c('p', [_vm._v("“Your sister’s water broke.”")]), _vm._v(" "), _c('p', [_vm._v("“Fast as that?”")]), _vm._v(" "), _c('p', [_vm._v("“Yes and it’s all over the stairs. You go up with her and I’ll get the doctor.”")]), _vm._v(" "), _c('p', [_vm._v("“Roseabella, let me put some sheets under you. Let me undress you. Put this thin nightgown over your head, put your arms through. Ok, now I’m going to put your hair up out of your eyes.”")]), _vm._v(" "), _c('p', [_vm._v("“How do you know all this?”")]), _vm._v(" "), _c('p', [_vm._v("“I remember Momma doing it for you when you gave birth to Josiah.”")]), _vm._v(" "), _c('p', [_vm._v("“Oh, the pain in my back!”")]), _vm._v(" "), _c('p', [_vm._v("“Lie on your side and let me rub your back down below. Ok, doctor is here, Roseabella.”")]), _vm._v(" "), _c('p', [_vm._v("“I would like to check you down below and see how you’re coming along. Push up your legs, it might hurt a bit. It’s going to be a while yet. Now, let me examine your belly. Come and feel this, Gretta. The head feels up top.”")]), _vm._v(" "), _c('p', [_vm._v("“You are right. The baby has not turned yet. Is that normal?”")]), _vm._v(" "), _c('p', [_vm._v("“Sometimes, the baby will turn while the mother is in labor. Keep rubbing her back, Gretta. We will need clean towels and hot water, be back in a moment.”")]), _vm._v(" "), _c('p', [_vm._v("Garrett asked the doctor, “How is she?”")]), _vm._v(" "), _c('p', [_vm._v("“The baby is in the wrong position.”")]), _vm._v(" "), _c('p', [_vm._v("“What’s that supposed to mean?”")]), _vm._v(" "), _c('p', [_vm._v("“The baby’s feet are down where the head supposed to be.”")]), _vm._v(" "), _c('p', [_vm._v("“Can you fix it?”")]), _vm._v(" "), _c('p', [_vm._v("“No, it has to turn on its own. Let’s pray it does. She’s in for a long night. I need clean towels, soap and hot water.”")]), _vm._v(" "), _c('p', [_vm._v("“Ow, it hurts so much. It’s worse than the first time. That was a hard one, Gretta.”")]), _vm._v(" "), _c('p', [_vm._v("“Squeeze my hand when you get your next contraction.”")]), _vm._v(" "), _c('p', [_vm._v("“Gretta, here comes another one.”")]), _vm._v(" "), _c('p', [_vm._v("“Breathe through your nose and out through your mouth. In and out. In and out. You are doing well.”")]), _vm._v(" "), _c('p', [_vm._v("“Oh, I wish Armando was here to see this.”")]), _vm._v(" "), _c('p', [_vm._v("“Let me check your abdomen, and up top. It’s starting to turn.”")]), _vm._v(" "), _c('p', [_vm._v("“You hear that, Roseabella?”")]), _vm._v(" "), _c('p', [_vm._v("“Yes, here comes another one.”")]), _vm._v(" "), _c('p', [_vm._v("“Scream if you want my girl, sometimes it helps.”")]), _vm._v(" "), _c('p', [_vm._v("“Oh my god, why am I in so much pain?”")]), _vm._v(" "), _c('p', [_vm._v("“Every birth is different.”")]), _vm._v(" "), _c('p', [_vm._v("“Gretta, ask Garrett to check on Josiah.”")]), _vm._v(" "), _c('p', [_vm._v("“I’ll tell Garrett,” said the doctor, “Gretta, you keep rubbing her back.”")]), _vm._v(" "), _c('p', [_vm._v("“Why is she screaming, doc?”")]), _vm._v(" "), _c('p', [_vm._v("“The baby has only moved a little way. The baby is very big.”")]), _vm._v(" "), _c('p', [_vm._v("“What are you telling me?”")]), _vm._v(" "), _c('p', [_vm._v("“She might not be able to birth it.”")]), _vm._v(" "), _c('p', [_vm._v("“What if she can’t?”")]), _vm._v(" "), _c('p', [_vm._v("“They will both die.”")]), _vm._v(" "), _c('p', [_vm._v("“This can’t happen, I can’t lose them.”")]), _vm._v(" "), _c('p', [_vm._v("“She wanted you to check on Josiah. You might have to move him; the screaming is going to get worse.”")]), _vm._v(" "), _c('p', [_vm._v("The woman servant took Josiah to sleep in his playroom. Garrett walked back and forth the hallway.")]), _vm._v(" "), _c('p', [_vm._v("“Sir Garrett, can I get them something to drink?”")]), _vm._v(" "), _c('p', [_vm._v("“Yes, bring up some lemon drink for all of them.”")]), _vm._v(" "), _c('p', [_vm._v("“Yes sir, would you like some wine?”")]), _vm._v(" "), _c('p', [_vm._v("“No, not until this is over. Gretta, is there any change?”")]), _vm._v(" "), _c('p', [_vm._v("“Oh Garrett, she’s in so much pain. The doctors going to give her something to relax her. I need more pillows.”")]), _vm._v(" "), _c('p', [_vm._v("“I will get them.”")]), _vm._v(" "), _c('p', [_vm._v("“Gretta, Gretta, don’t leave me!”")]), _vm._v(" "), _c('p', [_vm._v("“I must go!”")]), _vm._v(" "), _c('p', [_vm._v("“I’m here Roseabella, I’ll never leave you.”")]), _vm._v(" "), _c('p', [_vm._v("“No, no, no, make it stop.”")]), _vm._v(" "), _c('p', [_vm._v("“Drink this, it will take away some of the pain. It’s been hours, she can’t take much more.”")]), _vm._v(" "), _c('p', [_vm._v("“This will make her sleep.”")]), _vm._v(" "), _c('p', [_vm._v("“What aren’t you telling me?”")]), _vm._v(" "), _c('p', [_vm._v("“Let’s move outside on the balcony. The baby is very large, she may not be able to birth it.”")]), _vm._v(" "), _c('p', [_vm._v("“Josiah was ten pounds.”")]), _vm._v(" "), _c('p', [_vm._v("“This baby is much bigger.”")]), _vm._v(" "), _c('p', [_vm._v("“Why is this happening? First kidnaped from her husband and now, she might die. Doctor, you must do something.”")]), _vm._v(" "), _c('p', [_vm._v("“I will do my best.”")]), _vm._v(" "), _c('p', [_vm._v("“Does Garrett know?”")]), _vm._v(" "), _c('p', [_vm._v("“Now, I must check to see if the baby has turned. She looks a little drowsy. It will relax her. Ok good, the baby has turned all the way. The head is down. I must check up inside her and it is still tight. You get the door.”")]), _vm._v(" "), _c('p', [_vm._v("It was Rueband.")]), _vm._v(" "), _c('p', [_vm._v("“I brought you and the doctor refreshments.”")]), _vm._v(" "), _c('p', [_vm._v("“Thank you, Rueband.”")]), _vm._v(" "), _c('p', [_vm._v("“Would you like something to eat?”")]), _vm._v(" "), _c('p', [_vm._v("“Yes, it’s going to be a long night. And tell Garrett, the baby has turned.”")]), _vm._v(" "), _c('p', [_vm._v("“Turned? Where?”")]), _vm._v(" "), _c('p', [_vm._v("“In the right position.”")]), _vm._v(" "), _c('p', [_vm._v("“Ok, see you soon. Garrett, the baby has turned in the right position.”")]), _vm._v(" "), _c('p', [_vm._v("“Oh good.”")]), _vm._v(" "), _c('p', [_vm._v("“Sir Garrett?”")]), _vm._v(" "), _c('p', [_vm._v("“Yes?”")]), _vm._v(" "), _c('p', [_vm._v("“I’m glad I’m not a woman.”")]), _vm._v(" "), _c('p', [_vm._v("“I do agree with you there!”")]), _vm._v(" "), _c('p', [_vm._v("“It’s been ten hours of screaming. What can I do, doctor?”")]), _vm._v(" "), _c('p', [_vm._v("“Pray we won’t lose them both.”")]), _vm._v(" "), _c('p', [_vm._v("“There must be something.”")]), _vm._v(" "), _c('p', [_vm._v("“Doctor, she’s pushing.”")]), _vm._v(" "), _c('p', [_vm._v("“Let me have a look. Ok, stop pushing.”")]), _vm._v(" "), _c('p', [_vm._v("“Armando, Armando, I want my husband.”")]), _vm._v(" "), _c('p', [_vm._v("“What have I done?” said Garrett, “They will die because of me.”")]), _vm._v(" "), _c('p', [_vm._v("“Okay Roseabella, now push! I see the head. Push on your next contraction. Here it comes.”")]), _vm._v(" "), _c('p', [_vm._v("Everyone waited for the cry. With a little smack on the bum, the baby started crying.")]), _vm._v(" "), _c('p', [_vm._v("“You have a baby girl! Let’s get her cleaned up. She’s not that big at all.”")]), _vm._v(" "), _c('p', [_vm._v("“I need to push again.”")]), _vm._v(" "), _c('p', [_vm._v("“That’s the after birth. Gretta, you take the baby and I’ll help with the after birth. Let me massage your stomach. It feels pretty hard.”")]), _vm._v(" "), _c('p', [_vm._v("“I need to push.”")]), _vm._v(" "), _c('p', [_vm._v("“Ok, push it out. Good lord, I see a head.”")]), _vm._v(" "), _c('p', [_vm._v("“I can’t stop, it’s too much pressure.”")]), _vm._v(" "), _c('p', [_vm._v("“Push, Roseabella! Give it all you can! It’s another girl! This one has a good set of lungs.”")]), _vm._v(" "), _c('p', [_vm._v("The babies were beside each other.")]), _vm._v(" "), _c('p', [_vm._v("“Are they healthy, doctor?”")]), _vm._v(" "), _c('p', [_vm._v("“Yes and perfect good size for twins. Now, let’s get all the after birth out of you. There we go, how are you doing? Do you feel weak?”")]), _vm._v(" "), _c('p', [_vm._v("“Yes, very tired.”")]), _vm._v(" "), _c('p', [_vm._v("“That is normal.”")]), _vm._v(" "), _c('p', [_vm._v("“Let me see my babies.”")]), _vm._v(" "), _c('p', [_vm._v("“Bring them over, Gretta. The one who is cleaned up is your first born. Only minutes apart.”")]), _vm._v(" "), _c('p', [_vm._v("“Hello girls, I thought I wasn’t going to make it but God is on our side.”")]), _vm._v(" "), _c('p', [_vm._v("“I’ll tell Garrett the news.”")]), _vm._v(" "), _c('p', [_vm._v("“What is happening? I went to check on Josiah, he was crying for his mother.”")]), _vm._v(" "), _c('p', [_vm._v("“Roseabella and the girls are doing fine.”")]), _vm._v(" "), _c('p', [_vm._v("“Did you say girls?”")]), _vm._v(" "), _c('p', [_vm._v("“Yes, she gave birth to twins.”")]), _vm._v(" "), _c('p', [_vm._v("“Twins? Twins? And they are, ok?”")]), _vm._v(" "), _c('p', [_vm._v("“Yes and I’m as shocked as you, one baby behind the other. Two of them wanted to come out the same time. Roseabella is exhausted. Send up a woman to clean up the bed and the mother. We need something to tell them apart, they are identical. Gretta, we might have different colored blankets.”")]), _vm._v(" "), _c('p', [_vm._v("After Roseabella was cleaned up and the babies in different color gowns, the doctor put the babies to her breast. The babies grabbed onto the nipple.")]), _vm._v(" "), _c('p', [_vm._v("“Is your milk coming through?”")]), _vm._v(" "), _c('p', [_vm._v("“I don’t know.”")]), _vm._v(" "), _c('p', [_vm._v("“Let’s pull the nipple out of their mouth and see. Oh yes, you have a lot of milk but might not be enough for twins. They will let you know if they are not getting enough milk. You are a strong woman. You’ve been through a lot. You were asking for Armando.”")]), _vm._v(" "), _c('p', [_vm._v("“Yes, he’s the father of my children.”")]), _vm._v(" "), _c('p', [_vm._v("“Don’t give up hope. Garrett is a good man in his own way. He doesn’t realize the hurt and loneliness you are going through. He wanted what your husband had but went about it in the wrong way.”")]), _vm._v(" "), _c('p', [_vm._v("“Doctor, I just want to go home to my family.”")]), _vm._v(" "), _c('p', [_vm._v("“One of the servants will stay with you tonight. Gretta is a bit worn out. Your sister is a remarkable young woman.”")]), _vm._v(" "), _c('p', [_vm._v("“Yes, she certainly is. And I don’t want to see Garrett.”")]), _vm._v(" "), _c('p', [_vm._v("“I’ll pass the message on.”")]), _vm._v(" "), _c('p', [_vm._v("Garrett asked, “Does she need a wet nurse?”")]), _vm._v(" "), _c('p', [_vm._v("“It’s too early to tell, so far so good. She needs her rest. She doesn’t want to see anyone.”")]), _vm._v(" "), _c('p', [_vm._v("“Why not?”")]), _vm._v(" "), _c('p', [_vm._v("“Mentally and physically, she is very delicate. She can’t be rushed and she lost a lot of blood. She needs a hot meal and liquids.”")]), _vm._v(" "), _c('p', [_vm._v("“Armando, Armando, I have a vision.”")]), _vm._v(" "), _c('p', [_vm._v("“Take your time, Saige.”")]), _vm._v(" "), _c('p', [_vm._v("“I saw her in bed and on both breasts, she fed a twin of girls.”")]), _vm._v(" "), _c('p', [_vm._v("“What are you saying?”")]), _vm._v(" "), _c('p', [_vm._v("“She gave birth to your daughters, nine months today!”")]), _vm._v(" "), _c('p', [_vm._v("“My god, our last night together we created two lives. Is she alright?”")]), _vm._v(" "), _c('p', [_vm._v("“Yes.”")]), _vm._v(" "), _c('p', [_vm._v("“Two girls, I can’t believe it. Did you see where she is?”")]), _vm._v(" "), _c('p', [_vm._v("“No, only in a beautiful bedroom. I’m sorry I didn’t see anyone else or where they are. I know she’s alright.”")]), _vm._v(" "), _c('p', [_vm._v("“Where are they? I will find you.”")]), _vm._v(" "), _c('p', [_vm._v("“Armando, why were you talking to Saige? Why do you have a smile on your face?”")]), _vm._v(" "), _c('p', [_vm._v("“We were talking about her grandparents. She is a little homesick.”")]), _vm._v(" "), _c('p', [_vm._v("“She is an only child, Armando. Saige should have stayed home, Armando.”")]), _vm._v(" "), _c('p', [_vm._v("“She has proven herself worthy.”")]), _vm._v(" "), _c('p', [_vm._v("“It’s been seven months Armando, is it possible that we passed the island?”")]), _vm._v(" "), _c('p', [_vm._v("“No, the last port we went to, they remember selling sheep, goats and horses. They said their destination was not too far away.”")]), _vm._v(" "), _c('p', [_vm._v("“How long ago was this, Armando?”")]), _vm._v(" "), _c('p', [_vm._v("“A year ago, for the horses, two months ago for more chickens and lumber.”")]), _vm._v(" "), _c('p', [_vm._v("“What does that tell us, Armando?”")]), _vm._v(" "), _c('p', [_vm._v("“If we made it here two months earlier, we could have followed their ship back to their location.”")]), _vm._v(" "), _c('p', [_vm._v("“We could go back to the port and wait for them to pick up more supplies, Armando. How can we find a hidden island, for god’s sake?”")]), _vm._v(" "), _c('p', [_vm._v("“We will continue on for a month Helewise, if we find nothing, we will go back and wait at that small village. If you are bored Helewise, go spend time with your dog or the Captain.”")]), _vm._v(" "), _c('p', [_vm._v("“I spend too much time already with the Captain.”")]), _vm._v(" "), _c('p', [_vm._v("“Does he bore you, Helewise? Are there no electric shocks between you two?”")]), _vm._v(" "), _c('p', [_vm._v("“I’m not sleeping with the man, Armando.”")]), _vm._v(" "), _c('p', [_vm._v("“I hope not, I would have to see both of you married right away.”")]), _vm._v(" "), _c('p', [_vm._v("“Then what are you talking about?”")]), _vm._v(" "), _c('p', [_vm._v("“When he kisses you, do you feel a strong connection? You will know when the right person comes along, sister. You would not hide from someone you are in love with.”")]), _vm._v(" "), _c('p', [_vm._v("“Is that how you felt about Roseabella?”")]), _vm._v(" "), _c('p', [_vm._v("“Yes. I think about her the last thing at night and the first thing in the morning.”")]), _vm._v(" "), _c('p', [_vm._v("“I’m not like you, Armando. I just want to live in style, and wine and dine in new places. I don’t want to pine away for anyone. I want companionship not passion.”")]), _vm._v(" "), _c('p', [_vm._v("“You could have both, Helewise. You are young, don’t rush into something you may feel sorry for in the long run.”")]), _vm._v(" "), _c('p', [_vm._v("“Don’t worry about me Armando, you have enough on your plate already.”")]), _vm._v(" "), _c('p', [_vm._v("“The babies are coming along nicely, Roseabella. What about you? It’s been three weeks since you gave birth.”")]), _vm._v(" "), _c('p', [_vm._v("“I feel a bit tired, doctor.”")]), _vm._v(" "), _c('p', [_vm._v("“That’s to be expected, you are breast feeding constantly.”")]), _vm._v(" "), _c('p', [_vm._v("“They take up all my time. There, there, my darling Josiah. He’s a little bit jealous of the twins.”")]), _vm._v(" "), _c('p', [_vm._v("“How is he making out with the new helper?”")]), _vm._v(" "), _c('p', [_vm._v("“He likes her and Gretta spends so many hours a day with him.”")]), _vm._v(" "), _c('p', [_vm._v("“Are you eating enough?”")]), _vm._v(" "), _c('p', [_vm._v("“Yes, doctor and drinking milk and water.”")]), _vm._v(" "), _c('p', [_vm._v("“When the twins go down for their nap, you should go out on the balcony and get some sun and fresh air. End of next week, you can take the stairs.”")]), _vm._v(" "), _c('p', [_vm._v("“That would be great doctor, I feel so isolated.”")]), _vm._v(" "), _c('p', [_vm._v("“And how is your relationship with Garrett coming along?”")]), _vm._v(" "), _c('p', [_vm._v("“You mean my kidnapper! He comes in and takes the girls up at night. When I get myself back in shape doctor, will you help us to get away from Garrett and this island?”")]), _vm._v(" "), _c('p', [_vm._v("“I wish I could my dear but he would kill me.”")]), _vm._v(" "), _c('p', [_vm._v("“Doctor, he sleeps for twelve hours per day. Can you sail a ship, doctor?”")]), _vm._v(" "), _c('p', [_vm._v("“What would I do back home, Roseabella?”")]), _vm._v(" "), _c('p', [_vm._v("“My husband’s castle and my father’s castle need a doctor. Please doctor, would you think about it?”")]), _vm._v(" "), _c('p', [_vm._v("“I can’t sail but I heard young Rueband caught on fast.”")]), _vm._v(" "), _c('p', [_vm._v("“Thank you, doctor! That’s it, Gretta must convince Rueband to get us away from Garrett!”")]), _vm._v(" "), _c('p', [_vm._v("“Did I see a smile on your face, sister?”")]), _vm._v(" "), _c('p', [_vm._v("“Oh Gretta, you’re the one I needed to see.”")]), _vm._v(" "), _c('p', [_vm._v("“Why is that?”")]), _vm._v(" "), _c('p', [_vm._v("“I have a plan to get us off this island.”")]), _vm._v(" "), _c('p', [_vm._v("“You do? Please do tell, Roseabella.”")]), _vm._v(" "), _c('p', [_vm._v("“You’re going to get Rueband to fall in love with you. He already has feelings for you. You will be fifteen this year. Do you have feelings for him?”")]), _vm._v(" "), _c('p', [_vm._v("“We are good friends and yes, I do like him. He’s a man, Roseabella; well he thinks he is because he’s going to be eighteen this year.”")]), _vm._v(" "), _c('p', [_vm._v("“Yes Gretta, the doctor said Rueband can sail a ship.”")]), _vm._v(" "), _c('p', [_vm._v("“Rueband, dear sister, will not betray Garrett.”")]), _vm._v(" "), _c('p', [_vm._v("“He will if he falls in love with you. Tell him our father will buy him his own ship for rescuing us. And when you turn eighteen, you will become his wife.”")]), _vm._v(" "), _c('p', [_vm._v("“You, Roseabella, have it all figured out.”")]), _vm._v(" "), _c('p', [_vm._v("“Gretta, please don’t have second thoughts about leaving this island. Please say something!”")]), _vm._v(" "), _c('p', [_vm._v("“I know Roseabella, you will never be happy without Armando. I will do everything I can for you. And you are right, I am not unhappy here, Roseabella. I have freedom, I work with the doctor and know all the people on this island. I help plant wheat and vegetables. Pick fruit from trees and swim in the ocean every day. I go out with the fishermen, and spend time with Rueband and Josiah. I just wish you could—”")]), _vm._v(" "), _c('p', [_vm._v("“Could what, Gretta? Learn to love Garrett! Are you out of your fucking mind! Learn to love a sick crazy blood sucking vampire?”")]), _vm._v(" "), _c('p', [_vm._v("“You made your point, Roseabella! I will do it for you and your children and when Rueband turns eighteen, I will tell him he needs to become his own man. That he will be happier with his own ship and me for his wife. His family will move in the castle with us. And when I turn seventeen, the same age as you Roseabella, when you wed Armando—”")]), _vm._v(" "), _c('p', [_vm._v("“Gretta, you don’t have to marry him, he could go back to Garrett.”")]), _vm._v(" "), _c('p', [_vm._v("“Yes, Roseabella and then he will be murdered.”")]), _vm._v(" "), _c('p', [_vm._v("“Then he won’t go back, father will give him his ship and money.”")]), _vm._v(" "), _c('p', [_vm._v("“I can’t lie to my best friend, Roseabella.”")]), _vm._v(" "), _c('p', [_vm._v("“Would you feel better if the doctor came with us? He can train you to be the best and the first female doctor. I offered him a job at Armando’s and father’s castle has a country doctor. You will learn everything from him. We can build a small hospital for the both of you.”")]), _vm._v(" "), _c('p', [_vm._v("“And did the doctor say yes, he would escape with us?”")]), _vm._v(" "), _c('p', [_vm._v("“He didn’t say no. I’ll work on the doctor, Gretta and you work on Rueband.”")]), _vm._v(" "), _c('p', [_vm._v("“As you wish.”")]), _vm._v(" "), _c('p', [_vm._v("“If the plan doesn’t work, then I will kill him while he sleeps. Garrett will not make Armando’s children his. When I get back my strength Garret, you are ashes.”")]), _vm._v(" "), _c('p', [_vm._v("“Hello Gretta, would you like to swim in the falls with me?”")]), _vm._v(" "), _c('p', [_vm._v("“I’d love to Rueband!”")]), _vm._v(" "), _c('p', [_vm._v("“I’ll wait here for you, so you can get ready.”")]), _vm._v(" "), _c('p', [_vm._v("“I won’t be long.”")]), _vm._v(" "), _c('p', [_vm._v("Rueband went into the kitchen.")]), _vm._v(" "), _c('p', [_vm._v("“Do you have any spare watermelon?”")]), _vm._v(" "), _c('p', [_vm._v("“Why yes, we do Rueband. Do you want it wrapped up?”")]), _vm._v(" "), _c('p', [_vm._v("“Yes please.”")]), _vm._v(" "), _c('p', [_vm._v("The cook said, “It takes the thirst away, doesn’t it? And it tastes good too.”")]), _vm._v(" "), _c('p', [_vm._v("“I’m ready, Rueband. I knew you would be in the kitchen.”")]), _vm._v(" "), _c('p', [_vm._v("“There is enough there for both of you.”")]), _vm._v(" "), _c('p', [_vm._v("“Thanks! See you later!”")]), _vm._v(" "), _c('p', [_vm._v("“I’ll race you, Gretta and the last one in don’t get any watermelon!”")]), _vm._v(" "), _c('p', [_vm._v("“You cheated, Rueband!”")]), _vm._v(" "), _c('p', [_vm._v("“How could I cheat, we started at the same time!”")]), _vm._v(" "), _c('p', [_vm._v("“But your shoes are made for running.”")]), _vm._v(" "), _c('p', [_vm._v("“Sorry my girl, next time we run without shoes.”")]), _vm._v(" "), _c('p', [_vm._v("“Put me down.”")]), _vm._v(" "), _c('p', [_vm._v("“Oh no, we are now going in the water the same time!”")]), _vm._v(" "), _c('p', [_vm._v("“So, you will share the watermelon with me?”")]), _vm._v(" "), _c('p', [_vm._v("“Only on one condition.”")]), _vm._v(" "), _c('p', [_vm._v("“What condition is that?”")]), _vm._v(" "), _c('p', [_vm._v("“If you let me kiss you.”")]), _vm._v(" "), _c('p', [_vm._v("She looked into his hazel eyes, they were a mix of green and brown. (Roseabella, you might get your wish)")]), _vm._v(" "), _c('p', [_vm._v("“You can kiss me, Rueband.” Their lips touched gently, he put his arms around her and touched her tongue with his. She put her arms around his neck. Their kiss became more urgent.")]), _vm._v(" "), _c('p', [_vm._v("“Oh Gretta, I want you so much.” he kept on kissing her mouth and then down to her neck. Suddenly, he was down to her cleavage.")]), _vm._v(" "), _c('p', [_vm._v("“Rueband, we must stop.”")]), _vm._v(" "), _c('p', [_vm._v("“Oh, did I scare you?”")]), _vm._v(" "), _c('p', [_vm._v("“No Rueband, you ask for a kiss and your mouth between my cleavage is a lot more.”")]), _vm._v(" "), _c('p', [_vm._v("“I’m sorry Gretta, you are right. I won’t lose control anymore.”")]), _vm._v(" "), _c('p', [_vm._v("“I did enjoy your kiss, Rueband. It was my first kiss and I’ll remember it for the rest of my life. I will write it in my diary. My first kiss by Rueband.”")]), _vm._v(" "), _c('p', [_vm._v("“And you Gretta, are my first kiss.”")]), _vm._v(" "), _c('p', [_vm._v("“I am?”")]), _vm._v(" "), _c('p', [_vm._v("“Yes, I never had much time to meet girls.”")]), _vm._v(" "), _c('p', [_vm._v("“I’m glad you waited.”")]), _vm._v(" "), _c('p', [_vm._v("“You are special to me, Gretta.”")]), _vm._v(" "), _c('p', [_vm._v("“I feel the same about you, Rueband. Now, let’s cool off in the falls.”")]), _vm._v(" "), _c('p', [_vm._v("“Let me dry you off. Your hair is so long, can I comb it?”")]), _vm._v(" "), _c('p', [_vm._v("“Yes, here’s the comb.”")]), _vm._v(" "), _c('p', [_vm._v("“You don’t have tangles like my sisters. They would hide away from Ma when she had the comb in her hands.”")]), _vm._v(" "), _c('p', [_vm._v("“Do you miss them, Rueband?”")]), _vm._v(" "), _c('p', [_vm._v("“Yes, of course I do.”")]), _vm._v(" "), _c('p', [_vm._v("“Will you ever go back and see them?”")]), _vm._v(" "), _c('p', [_vm._v("“One day, I will go back for a visit. Gretta, your hair feels like silk.”")]), _vm._v(" "), _c('p', [_vm._v("“Thanks, my sister always brushed my hair; that is when she wasn’t arguing with me. They took me because she couldn’t keep her mouth closed. She panicked and started screaming.”")]), _vm._v(" "), _c('p', [_vm._v("“Do you miss her?”")]), _vm._v(" "), _c('p', [_vm._v("“Yes, I don’t have anyone to pick on. She wants to be a queen of a castle and I want to be doctor.”")]), _vm._v(" "), _c('p', [_vm._v("“Doctor Bardue said you’re not afraid of blood. He said you are smart and you enjoy learning new things.”")]), _vm._v(" "), _c('p', [_vm._v("“He’s a good teacher. I’d like to travel with you to the small islands and take care of the sick and injured, when you have your own ship. Doctors are paid well. We could have our own little business, Rueband.”")]), _vm._v(" "), _c('p', [_vm._v("“Maybe one day we will, Gretta. Let’s get back and do a little bit of training before Garrett wakes up.”")]), _vm._v(" "), _c('p', [_vm._v("“What are you two doing?”")]), _vm._v(" "), _c('p', [_vm._v("“Just keeping in shape.”")]), _vm._v(" "), _c('p', [_vm._v("“Try not to cut each other with those swords.”")]), _vm._v(" "), _c('p', [_vm._v("“We’ve been doing this for months. Would you like to take me on?”")]), _vm._v(" "), _c('p', [_vm._v("“I don’t want you to get hurt, Gretta.”")]), _vm._v(" "), _c('p', [_vm._v("“Maybe you’re scared Garrett, a girl might beat you?”")]), _vm._v(" "), _c('p', [_vm._v("“Alright Gretta, show me what you got. You got a good arm, nice and strong. Who taught you how to fight?”")]), _vm._v(" "), _c('p', [_vm._v("“She’s lying in bed upstairs.”")]), _vm._v(" "), _c('p', [_vm._v("“She did a good job.”")]), _vm._v(" "), _c('p', [_vm._v("Gretta’s sword went flying.")]), _vm._v(" "), _c('p', [_vm._v("“Don’t ever take your eye off my sword. I must say you are pretty good.”")]), _vm._v(" "), _c('p', [_vm._v("“Thank you, Garrett.”")]), _vm._v(" "), _c('p', [_vm._v("“Now, why don’t we have our dinner? Would you like to join us Rueband?”")]), _vm._v(" "), _c('p', [_vm._v("“I would be honored to sit at your table, Sir Garrett.”")]), _vm._v(" "), _c('p', [_vm._v("“Come in and help yourselves to some wine.”")]), _vm._v(" "), _c('p', [_vm._v("“Let’s go get Josiah down first, so he can eat with us. He’s such a great kid and so fast on his feet lately.”")]), _vm._v(" "), _c('p', [_vm._v("“Geta! Uban!” He yelled out when he saw them come up.")]), _vm._v(" "), _c('p', [_vm._v("“Give me a hug and kiss. You smell like watermelon Josiah! You like watermelon, don’t you? You can go and have your dinner Rueda. Josiah will eat with us. Rueband, can you take him while I change my clothes?”")]), _vm._v(" "), _c('p', [_vm._v("“Of course. Josiah, do you want to go feed the fish?”")]), _vm._v(" "), _c('p', [_vm._v("“Splash watt.”")]), _vm._v(" "), _c('p', [_vm._v("“Yes, you can splash water. Here’s few little dry shrimps to feed the fish. Just one at a time. They’re hungry, aren’t they?”")]), _vm._v(" "), _c('p', [_vm._v("“Fish there, fish there.”")]), _vm._v(" "), _c('p', [_vm._v("“You sure are talking a lot aren’t you, Josiah? Now you’re trying to catch them! See if you’re fast enough to catch fish. You almost caught one.”")]), _vm._v(" "), _c('p', [_vm._v("“There you are,” said Gretta, “catching fish!”")]), _vm._v(" "), _c('p', [_vm._v("“Gretta, you look beautiful.”")]), _vm._v(" "), _c('p', [_vm._v("“Thank you, it’s Roseabella’s dress, my clothes are getting too small.”")]), _vm._v(" "), _c('p', [_vm._v("“Let Garrett know Gretta, he will get some made.”")]), _vm._v(" "), _c('p', [_vm._v("“Get what made Rueband?” asked Garrett.")]), _vm._v(" "), _c('p', [_vm._v("“Oh, Garrett I was telling Rueband I have to wear Roseabella’s dresses because mine are getting too small.”")]), _vm._v(" "), _c('p', [_vm._v("“And you look striking tonight. You’re becoming a woman now Gretta, soon to be fifteen. Go to the seamstress tomorrow for measurements and pick out your colors for dresses.”")]), _vm._v(" "), _c('p', [_vm._v("“I will Garrett and measurements for pants and shirts. I need pants for horseback riding.”")]), _vm._v(" "), _c('p', [_vm._v("“You horseback ride?”")]), _vm._v(" "), _c('p', [_vm._v("“Of course. And I taught Rueband as well. Roseabella taught me and Ardelean how to ride and throw a spear at the same time.”")]), _vm._v(" "), _c('p', [_vm._v("“Your sister also taught you how to slay vampires, didn’t she?”")]), _vm._v(" "), _c('p', [_vm._v("“Yes, she taught us but I never had a chance to kill one. Oh Garrett, I’m sorry, I forget you’re a vampire.”")]), _vm._v(" "), _c('p', [_vm._v("“It’s ok Gretta, I’m glad you can defend yourself. Vampires or pirates could even be shipwrecked here someday. Maybe we should all start training in the evenings. Now Josiah, let’s get your hands washed before we eat.”")]), _vm._v(" "), _c('p', [_vm._v("“Let’s have some wine, Rueband.”")]), _vm._v(" "), _c('p', [_vm._v("“I’d like some thank you. I like this one, it’s a tiny bit sweeter.”")]), _vm._v(" "), _c('p', [_vm._v("“You’re right Rueband, it’s refreshing.”")]), _vm._v(" "), _c('p', [_vm._v("“Poor Roseabella can’t drink wine.”")]), _vm._v(" "), _c('p', [_vm._v("“Why not?”")]), _vm._v(" "), _c('p', [_vm._v("“She’s breast feeding, silly. Alcohol could go in her milk.”")]), _vm._v(" "), _c('p', [_vm._v("“Not good for the twins, right? Has she decided on the names yet?”")]), _vm._v(" "), _c('p', [_vm._v("“Not yet.”")]), _vm._v(" "), _c('p', [_vm._v("“Why not?”")]), _vm._v(" "), _c('p', [_vm._v("“Both parents decide on names of their children. Armando loves Roseabella and her son, he’s a good father.”")]), _vm._v(" "), _c('p', [_vm._v("“Armando was a good father, Gretta or have you forgotten that he is no longer in our lives.”")]), _vm._v(" "), _c('p', [_vm._v("“I understand Garrett, I’m sorry.”")]), _vm._v(" "), _c('p', [_vm._v("“Let’s go, my son is hungry and afterwards, I will visit my two daughters.”")]), _vm._v(" "), _c('p', [_vm._v("“Sir Garrett, this wine is very good. It’s nice and light with a hint of honey.”")]), _vm._v(" "), _c('p', [_vm._v("“One of our pigs gave birth to eight piglets.”")]), _vm._v(" "), _c('p', [_vm._v("“Why didn’t you let me know, I could have watched her. I want to be an animal doctor also.”")]), _vm._v(" "), _c('p', [_vm._v("“Gretta, you do certainly know what you want.”")]), _vm._v(" "), _c('p', [_vm._v("“Yes I do, one day I want to travel and cure the poor and the homeless people.”")]), _vm._v(" "), _c('p', [_vm._v("“What about you, Rueband?” said Garrett.")]), _vm._v(" "), _c('p', [_vm._v("“I’m happy where I am as long as you let me sail your ships.”")]), _vm._v(" "), _c('p', [_vm._v("“Gretta, you are growing up so fast. That dress you have on matches your beautiful eyes. Now, what have they got for your dinner, my boy? Mashed vegetables, chicken and gravy. Open your mouth, that’s a good boy. Good, good, good! My god, you’re talking to me! Yes, it is good.”")]), _vm._v(" "), _c('p', [_vm._v("Gretta and Rueband had chicken soup for first course. Second course was stuffed salmon with grilled vegetables. For dessert, there was a gooseberry tart with cream.")]), _vm._v(" "), _c('p', [_vm._v("“I’m stuffed. It was delicious, Sir Garrett.”(He can’t hear me because he’s too busy looking at Gretta’s cleavage)")]), _vm._v(" "), _c('p', [_vm._v("“Did you say something, Rueband?”")]), _vm._v(" "), _c('p', [_vm._v("“Thanks for inviting me to dinner, sir.”")]), _vm._v(" "), _c('p', [_vm._v("“You are welcome. Let’s make it more often. Your sister will be eating with us next week.”")]), _vm._v(" "), _c('p', [_vm._v("“Oh good. She gets stronger every day. The girls are so pretty, aren’t they Garrett?”")]), _vm._v(" "), _c('p', [_vm._v("“Yes, they are cute, we will name them next week. She can name one. The oldest one I will name.”")]), _vm._v(" "), _c('p', [_vm._v("“Good luck.” said Gretta.")]), _vm._v(" "), _c('p', [_vm._v("“Since you have finished your dinner Josiah, we will go to the playroom. I will see you later, Gretta.”")]), _vm._v(" "), _c('p', [_vm._v("Rueband asked, “Why does he want to see you later?”")]), _vm._v(" "), _c('p', [_vm._v("“He likes to talk to me. He gets lonely. Roseabella has lost her patience with him. She can’t bear to be in the same room with him. Let’s go see the piglets.”")]), _vm._v(" "), _c('p', [_vm._v("“We also have a horse expecting.”")]), _vm._v(" "), _c('p', [_vm._v("“Which one?”")]), _vm._v(" "), _c('p', [_vm._v("“Lilly, the big gentle one.”")]), _vm._v(" "), _c('p', [_vm._v("“I’ve been riding a pregnant horse?”")]), _vm._v(" "), _c('p', [_vm._v("“You were but lately, I’ve been giving you Ginger to ride.”")]), _vm._v(" "), _c('p', [_vm._v("“Let’s check on her.”")]), _vm._v(" "), _c('p', [_vm._v("“Can we go to the falls tomorrow?”")]), _vm._v(" "), _c('p', [_vm._v("“Of course, it’s our private place.”")]), _vm._v(" "), _c('p', [_vm._v("“My darling, it’s so good to have you dine with us.”")]), _vm._v(" "), _c('p', [_vm._v("“Thank you, Garrett. It’s nice to get away for a couple of hours.”")]), _vm._v(" "), _c('p', [_vm._v("“You have lost so much weight.”")]), _vm._v(" "), _c('p', [_vm._v("“The twins are taking the fat off me.”")]), _vm._v(" "), _c('p', [_vm._v("“Is that a new dress, Gretta?” asked Roseabella.")]), _vm._v(" "), _c('p', [_vm._v("“Yes, do you like it?”")]), _vm._v(" "), _c('p', [_vm._v("“It’s very pretty.”")]), _vm._v(" "), _c('p', [_vm._v("“I’ve outgrown everything I had.”")]), _vm._v(" "), _c('p', [_vm._v("“You are getting tall and slim, little sister.”")]), _vm._v(" "), _c('p', [_vm._v("“Your sister is turning into a beautiful woman.”")]), _vm._v(" "), _c('p', [_vm._v("“She certainly is. Now Roseabella, the twins need names. The oldest one, I would like to name her Soneia.”")]), _vm._v(" "), _c('p', [_vm._v("“Don’t I have a say in that, Garrett?”")]), _vm._v(" "), _c('p', [_vm._v("“You can name the other one.”")]), _vm._v(" "), _c('p', [_vm._v("“I will name her Armenia.”")]), _vm._v(" "), _c('p', [_vm._v("“I thought you might stick his name in. The oldest is Soneia and her sister Armenia. I will get the doctor to write up birth certificates with their names and date of birth. Cook has made your favorite dish, chicken and dumplings.”")]), _vm._v(" "), _c('p', [_vm._v("“How kind of her.”")]), _vm._v(" "), _c('p', [_vm._v("“What are you having, Gretta?”")]), _vm._v(" "), _c('p', [_vm._v("“Fried chicken and fried potatoes.”")]), _vm._v(" "), _c('p', [_vm._v("“Is it as good as Meiga’s?”")]), _vm._v(" "), _c('p', [_vm._v("“It doesn’t have her secret herbs.”")]), _vm._v(" "), _c('p', [_vm._v("“Who is the biggest, Soneia or Armenia?”")]), _vm._v(" "), _c('p', [_vm._v("“They are the same.”")]), _vm._v(" "), _c('p', [_vm._v("“Really, how can you tell them apart?”")]), _vm._v(" "), _c('p', [_vm._v("“I can’t. I’ve sewed the number one and two on their clothes.”")]), _vm._v(" "), _c('p', [_vm._v("“Is there anything at all different about them?”")]), _vm._v(" "), _c('p', [_vm._v("“Soneia, since she has a name, takes a long time to feed. Armenia drinks so fast, she is always breaking wind.”")]), _vm._v(" "), _c('p', [_vm._v("“I watched a horse giving birth last night.”")]), _vm._v(" "), _c('p', [_vm._v("“Gretta, I could have come with you.”")]), _vm._v(" "), _c('p', [_vm._v("“Oh, sorry Garrett, I didn’t think you’d be interested.”")]), _vm._v(" "), _c('p', [_vm._v("“I am very interested when it comes to horses. I will take a look at her tonight. What color is she?”")]), _vm._v(" "), _c('p', [_vm._v("“It’s a he and he’s brown and white, such amazing colors. Ginger must be the father.”")]), _vm._v(" "), _c('p', [_vm._v("“I think you are right, why don’t we train the horse for you, Josiah! Would you like your own pony, my son?”")]), _vm._v(" "), _c('p', [_vm._v("“Garrett, that would be wonderful, they could grow up together. Lilly is a friendly horse and so will Spot.”")]), _vm._v(" "), _c('p', [_vm._v("“Spot? You named him Spot?”")]), _vm._v(" "), _c('p', [_vm._v("“Wait till you see him, Spot will suit him.”")]), _vm._v(" "), _c('p', [_vm._v("“Why don’t you two girls go for a little walk around the garden? I will take Josiah to the sitter to get cleaned up.”")]), _vm._v(" "), _c('p', [_vm._v("“That would be nice Garrett, I could use some exercise.”")]), _vm._v(" "), _c('p', [_vm._v("“The trees are getting tall, the flowers are lovely.” said Gretta.")]), _vm._v(" "), _c('p', [_vm._v("“How’s it going between you and Rueband?”")]), _vm._v(" "), _c('p', [_vm._v("“We are getting closer every day.”")]), _vm._v(" "), _c('p', [_vm._v("“Is he in love with you?”")]), _vm._v(" "), _c('p', [_vm._v("“He wants more than I am giving him. Is that love or lust?”")]), _vm._v(" "), _c('p', [_vm._v("“He hasn’t tried to force you!”")]), _vm._v(" "), _c('p', [_vm._v("“No, he’s not like that. When I say stop, he stops.”")]), _vm._v(" "), _c('p', [_vm._v("“He has feelings for you, that’s for sure. How do you feel about him, Gretta?”")]), _vm._v(" "), _c('p', [_vm._v("“When we kiss, I get butterflies in my heart and stomach.”")]), _vm._v(" "), _c('p', [_vm._v("“You’re in trouble.”")]), _vm._v(" "), _c('p', [_vm._v("“Why?”")]), _vm._v(" "), _c('p', [_vm._v("“He could be your first love and only love.”")]), _vm._v(" "), _c('p', [_vm._v("“He’s jealous of Garrett.”")]), _vm._v(" "), _c('p', [_vm._v("“In what way?”")]), _vm._v(" "), _c('p', [_vm._v("“He doesn’t like me spending time alone with Garrett in the night time. And the way Garrett looks at me when I wear low cut dresses.”")]), _vm._v(" "), _c('p', [_vm._v("“My god, we have to get you off this island soon.”")]), _vm._v(" "), _c('p', [_vm._v("“Armando, Armando, where are you?”")]), _vm._v(" "), _c('p', [_vm._v("“Over here Saige, what’s wrong?”")]), _vm._v(" "), _c('p', [_vm._v("“The vision I had was not good.”")]), _vm._v(" "), _c('p', [_vm._v("“You must tell me Saige, good or bad.”")]), _vm._v(" "), _c('p', [_vm._v("“The pirates’ ship we fought with.”")]), _vm._v(" "), _c('p', [_vm._v("“Yes, what about it.”")]), _vm._v(" "), _c('p', [_vm._v("“Some are vampires, some are not turned but they work for the Elders. The one Garret didn’t kill is on his way to the island to kill Garrett. We have passed the island. Gretta’s on a beach in a deep-water cove. There are two giant cliffs with enough space for a ship to go through. You must turn back.”")]), _vm._v(" "), _c('p', [_vm._v("“Will you recognize the cliffs?”")]), _vm._v(" "), _c('p', [_vm._v("“Yes, Armando I will.”")]), _vm._v(" "), _c('p', [_vm._v("“Why are we turning around? I am the Captain here!”")]), _vm._v(" "), _c('p', [_vm._v("Armando said, “Your first mate did what I asked him. We’ve gone too far.”")]), _vm._v(" "), _c('p', [_vm._v("“How do you know this?”")]), _vm._v(" "), _c('p', [_vm._v("“My wife has been gone for almost a year. We go back and you get paid regardless what direction we take!”")]), _vm._v(" "), _c('p', [_vm._v("“As you wish, Armando.”")]), _vm._v(" "), _c('p', [_vm._v("“Three weeks passed and still no sight of this island, Saige.”")]), _vm._v(" "), _c('p', [_vm._v("“Have faith Armando, we are getting close, I can feel it.”")]), _vm._v(" "), _c('p', [_vm._v("“Garrett, Garrett, wake up please, for gods’ sake, wake up.”")]), _vm._v(" "), _c('p', [_vm._v("“This better be important.”")]), _vm._v(" "), _c('p', [_vm._v("“One of four fishermen didn’t return last night. We though he might have drowned but we found his body parts in his boat this morning on the beach. His neck had bite marks on him.”")]), _vm._v(" "), _c('p', [_vm._v("“This can’t be happening. All I put into this. They have found me.”")]), _vm._v(" "), _c('p', [_vm._v("“We killed eighteen vampires that night Garrett, only two did not return to their caskets.”")]), _vm._v(" "), _c('p', [_vm._v("“You must not waste any time. All the women and children will go to the estate. All the men will guard the outside. Get extra supplies and water to my estate. Make sure everyone has weapons, make as many spikes as you can. The door must be barred up on the inside. All the windows and shutters must be locked. Get me Roseabella.”")]), _vm._v(" "), _c('p', [_vm._v("“Yes sir!”")]), _vm._v(" "), _c('p', [_vm._v("“Garrett what’s so important that we can’t wait until dinner?”")]), _vm._v(" "), _c('p', [_vm._v("“A body came ashore on the beach this morning.”")]), _vm._v(" "), _c('p', [_vm._v("“Who was it?”")]), _vm._v(" "), _c('p', [_vm._v("“A fisherman. He was ripped apart by vampires.”")]), _vm._v(" "), _c('p', [_vm._v("“Sweet Jesus, what are we going to do?”")]), _vm._v(" "), _c('p', [_vm._v("“Women and children are on their way to the estate. My men will be ready and waiting. You and Gretta must protect the woman and children inside. They won’t be here until its dark. Rueband will have to help protect our babies. Get your weapons ready. Roseabella?”")]), _vm._v(" "), _c('p', [_vm._v("“What?”")]), _vm._v(" "), _c('p', [_vm._v("“I’m so sorry for all of this.”")]), _vm._v(" "), _c('p', [_vm._v("“Who are these vampires that are after you, Garrett?”")]), _vm._v(" "), _c('p', [_vm._v("“The only two we didn’t kill, Morgania and an Elder.”")]), _vm._v(" "), _c('p', [_vm._v("“How well are your men trained?”")]), _vm._v(" "), _c('p', [_vm._v("“I have taught them.”")]), _vm._v(" "), _c('p', [_vm._v("“Do you have bows and arrows?”")]), _vm._v(" "), _c('p', [_vm._v("“A barn full and axes and spears I made for you and your sister.”")]), _vm._v(" "), _c('p', [_vm._v("“How many spears?”")]), _vm._v(" "), _c('p', [_vm._v("“A dozen.”")]), _vm._v(" "), _c('p', [_vm._v("“Not enough. And swords?”")]), _vm._v(" "), _c('p', [_vm._v("“Every man has a sword.”")]), _vm._v(" "), _c('p', [_vm._v("“Half of your men will be waiting on top of the trail with bows and arrows. Do we have a priest on this island?”")]), _vm._v(" "), _c('p', [_vm._v("“Yes, we do.”")]), _vm._v(" "), _c('p', [_vm._v("“Ok, we’re going to need holy water. Why didn’t we know about the priest?”")]), _vm._v(" "), _c('p', [_vm._v("“He’s a heavy drinker, he only buries the dead and marries couples. He doesn’t know I’m a vampire.”")]), _vm._v(" "), _c('p', [_vm._v("“I’ll talk to him and find out if there is any holiness left in him. And if the doors and shutters are barred, you could get up early. It could be dark enough. Garrett, what will they do to the babies?”")]), _vm._v(" "), _c('p', [_vm._v("“Young vampires will drink from them; the Elder might keep them until they are older.”")]), _vm._v(" "), _c('p', [_vm._v("“Why older, so he can keep them for his own use? What about me and Gretta?”")]), _vm._v(" "), _c('p', [_vm._v("“He may keep you for feeding the twins. Gretta, he will change.”")]), _vm._v(" "), _c('p', [_vm._v("“I must talk to the priest! Father, open up please! Are you in there?”")]), _vm._v(" "), _c('p', [_vm._v("“Hold on to your horses. Lady Roseabella, we finally meet. Your husband said you have no faith.”")]), _vm._v(" "), _c('p', [_vm._v("“My husband has no faith. Do you believe in God, father?”")]), _vm._v(" "), _c('p', [_vm._v("“Yes, why wouldn’t I?”")]), _vm._v(" "), _c('p', [_vm._v("“When it gets dark out father, we are going to be attacked by vampires.”")]), _vm._v(" "), _c('p', [_vm._v("“There are no vampires on this island.”")]), _vm._v(" "), _c('p', [_vm._v("“A fisherman was found bitten and torn apart this morning on the beach.”")]), _vm._v(" "), _c('p', [_vm._v("“God help us all.”")]), _vm._v(" "), _c('p', [_vm._v("“That’s where you come in, Father.”")]), _vm._v(" "), _c('p', [_vm._v("“Me? What am I to do?”")]), _vm._v(" "), _c('p', [_vm._v("“You are going to bless tubs and tubs of water. Holy water burns their skin. How many crosses do you have?”")]), _vm._v(" "), _c('p', [_vm._v("“Six small ones, big ones on the walls.”")]), _vm._v(" "), _c('p', [_vm._v("“Take the big ones down and bring all you got to the estate. Hurry up, you must start blessing water. Rueband, help the priest with all the crosses. Nail the big one on the doors of our home. Don’t let the priest drink until all the water is blessed. Get some men and fill up barrels and tubs of water. Everyone bring their water skin bag and the women will fill them up.”")]), _vm._v(" "), _c('p', [_vm._v("“Yes, my lady.”")]), _vm._v(" "), _c('p', [_vm._v("“Rueband, you are to stay inside with us and protect the children. You must aim for their hearts or cut off their heads.”")]), _vm._v(" "), _c('p', [_vm._v("“I know. Gretta taught me well.”")]), _vm._v(" "), _c('p', [_vm._v("“I have to go and find a wet nurse for the twins.”")]), _vm._v(" "), _c('p', [_vm._v("The women and children came inside and were told to find beds for the babies and children.")]), _vm._v(" "), _c('p', [_vm._v("“Rueda, can you find me a clean wet nurse with extra milk?”")]), _vm._v(" "), _c('p', [_vm._v("“Yes, my lady, my sister has a new born and she complains that she is soaked with milk.”")]), _vm._v(" "), _c('p', [_vm._v("“Bring her and her baby to the nursery. My beautiful little girls, I love you so much and my little Josiah, you are the most precious son any mother could want. Rueda and her sister will be having a sleep over with you tonight. Come in! Rueda said that you have a lot of milk.”")]), _vm._v(" "), _c('p', [_vm._v("“Yes, my lady.”")]), _vm._v(" "), _c('p', [_vm._v("“Keep my twins fed and you will be paid highly. Rueba, take care of my son. I’ll be fighting outside with the men tonight. Do not leave this room after dark. Bring up extra food, there will be holy water brought up. It’s blessed by the priest. If vampires get in, throw the holy water in their faces. I will bring you both up crosses to wear around your neck. And the crosses can also burn a vampire. Do not open the windows or shutters for anyone. A vampire cannot come in unless he is invited.”")]), _vm._v(" "), _c('p', [_vm._v("“We will pray to God, my lady for his protection.”")]), _vm._v(" "), _c('p', [_vm._v("“Please do, we need all the help we can get.”")]), _vm._v(" "), _c('p', [_vm._v("“Roseabella, your place is inside with your family.”")]), _vm._v(" "), _c('p', [_vm._v("“Garrett, I’m faster and trained more than any of your men.”")]), _vm._v(" "), _c('p', [_vm._v("“You’re a woman and a mother.”")]), _vm._v(" "), _c('p', [_vm._v("“That’s why I am fighting them outside the estate doors. You go to the cliff with your men and shoot those arrows.”")]), _vm._v(" "), _c('p', [_vm._v("“And you’re not giving the orders.”")]), _vm._v(" "), _c('p', [_vm._v("“While you were sleeping, I gave the orders! We have holy water around the estate, inside and outside. Crosses hung on all the doors.”")]), _vm._v(" "), _c('p', [_vm._v("“How did you come up with these ideas? Holy water and crosses.”")]), _vm._v(" "), _c('p', [_vm._v("“God sent us an angel. And Armando used it when he destroyed your haunted castle.”")]), _vm._v(" "), _c('p', [_vm._v("“And who is this angel?”")]), _vm._v(" "), _c('p', [_vm._v("“You of all people will never find out. Father Strickland thinks you still have some good left in you, Garrett.”")]), _vm._v(" "), _c('p', [_vm._v("“Roseabella, too much bad has taken over the good, I’m afraid.”")]), _vm._v(" "), _c('p', [_vm._v("“You’ve done a good job with this island, Garrett. The only thing you need is a woman who will love you back.”")]), _vm._v(" "), _c('p', [_vm._v("“No, you will learn to love and respect me! And after this attack is over, you will come to my bed.”")]), _vm._v(" "), _c('p', [_vm._v("“I will stab you through your heart Garrett, if you touch me.”")]), _vm._v(" "), _c('p', [_vm._v("“You can try, my dear but I will bed you soon.”")]), _vm._v(" "), _c('p', [_vm._v("“It’s getting dark, Garrett; your men are waiting for you.”")]), _vm._v(" "), _c('p', [_vm._v("“Any sight of them, Bacia?”")]), _vm._v(" "), _c('p', [_vm._v("“Not yet, sir.”")]), _vm._v(" "), _c('p', [_vm._v("“How many men do we have?”")]), _vm._v(" "), _c('p', [_vm._v("“Twenty down here and twenty up to the estate. What are you looking at, Sir Garrett?”")]), _vm._v(" "), _c('p', [_vm._v("“I have sharp vision and a ship has just sailed through the cliffs. Everyone get ready and wait until I say shoot your arrows.”")]), _vm._v(" "), _c('p', [_vm._v("“What a good island to hide out our goods, Captain. There won’t be any ships to raid, if we become one of them blood suckers. Never see sunlight again. It’s going to be hard battling in the dark.”")]), _vm._v(" "), _c('p', [_vm._v("“He’s already got half of my crew turned. We picked the wrong ship to take over. We wait just as the sun goes down; they will feed off people from the island tonight. Poor devils, they should fight like we do with swords and die a normal death.”")]), _vm._v(" "), _c('p', [_vm._v("“How many men have you killed on raids, Captain?”")]), _vm._v(" "), _c('p', [_vm._v("“I have never killed a man unless he has a weapon to fight back. I am not a coward. That old man the Elder, what a fucking ugly man. His face is big and ugly. There’s hardly any skin on it.”")]), _vm._v(" "), _c('p', [_vm._v("“Oh Captain, we won’t look like that will we, if he bites us.”")]), _vm._v(" "), _c('p', [_vm._v("“Jesus Christ, I hope not. Imagine knocking on your mother’s door. It would give her a heart attack. Everybody aboard the row boats. Since I’m the captain, I should stay with my ship.”")]), _vm._v(" "), _c('p', [_vm._v("“No, the Elder does not trust you. We all leave the same time.”")]), _vm._v(" "), _c('p', [_vm._v("“Ok then, I will meet you on shore.”")]), _vm._v(" "), _c('p', [_vm._v("“Armando, I see the two high cliffs over there, the same ones that were in my vision.”")]), _vm._v(" "), _c('p', [_vm._v("“You are right. We will anchor outside the cliffs. We don’t want them to see us coming.”")]), _vm._v(" "), _c('p', [_vm._v("“There should be two ships there. We must hurry, the sun is gone down.”")]), _vm._v(" "), _c('p', [_vm._v("“Why are we stopping, Armando?”")]), _vm._v(" "), _c('p', [_vm._v("“Saige thought she saw an end of a ship going between two high cliffs.”")]), _vm._v(" "), _c('p', [_vm._v("“Are you sure, Saige?”")]), _vm._v(" "), _c('p', [_vm._v("“Yes, Helewise.”")]), _vm._v(" "), _c('p', [_vm._v("“We will all get in the row boats and bring all your weapons. Helewise and Saige, let everyone know we’re going ashore and wear your crosses.”")]), _vm._v(" "), _c('p', [_vm._v("“You think vampires are sailing on ships now?”")]), _vm._v(" "), _c('p', [_vm._v("“Garrett is a vampire and he will have others like him.”")]), _vm._v(" "), _c('p', [_vm._v("“I forgot that, Armando. Let’s go Saige.”")]), _vm._v(" "), _c('p', [_vm._v("“They’re getting out of their boats, wait until they get closer to us. I see the Elder, he’s one big ugly bastard. My god, was he ever human, Sir Garrett?”")]), _vm._v(" "), _c('p', [_vm._v("“Yes, he’s a thousand years old. The oldest one left and we killed his brother.”")]), _vm._v(" "), _c('p', [_vm._v("“How does he know this?”")]), _vm._v(" "), _c('p', [_vm._v("“You take on more power as you get older. He knows I ended their lives.”")]), _vm._v(" "), _c('p', [_vm._v("“If I get bittern Garrett, will you please kill me?”")]), _vm._v(" "), _c('p', [_vm._v("“If that’s what you wish. Ok, they’re coming up the trail. Everyone, shoot!”")]), _vm._v(" "), _c('p', [_vm._v("The vampires and the pirates were not expecting a defense so soon. Arrows kept coming down on them.")]), _vm._v(" "), _c('p', [_vm._v("“Good shooting Garrett, you got two down.”")]), _vm._v(" "), _c('p', [_vm._v("“Keep shooting, don’t let them on our land. They’re running to the end looking for other trails. They have ropes with hooks on them. Go, take five men and get over there.”")]), _vm._v(" "), _c('p', [_vm._v("The vampires were faster and they could climb up the cliffs. Garrett’s men were surrounded by vampires.")]), _vm._v(" "), _c('p', [_vm._v("“Aim for the heart or chop off their heads. Throw your holy water in their faces. It will slow them down.”")]), _vm._v(" "), _c('p', [_vm._v("One of the vampire’s face was burning and he was screeching. Another man crept up behind him and chopped off his head. One of Garrett’s men was down with his throat torn out. Garrett took down two more. They turned to ashes.")]), _vm._v(" "), _c('p', [_vm._v("“Garrett! They took down my men. The Elden is gone toward the estate.”")]), _vm._v(" "), _c('p', [_vm._v("“Stay here, I’m going to kill him. Keep using holy water on them.” (Roseabella was right, holy water could burn their skin)")]), _vm._v(" "), _c('p', [_vm._v("Garrett flew over the brush, he had new powers that did not exist until now. Roseabella’s holding her own with her sword. Some of her men were down and the vampires were feeding on them. Garrett came in behind one and chopped off his head. Roseabella took the other one down. More vampires jumped out in front of them with their long fangs waiting for prey.")]), _vm._v(" "), _c('p', [_vm._v("“Garrett, the woman is mine!” Roseabella looked around and saw a monster.")]), _vm._v(" "), _c('p', [_vm._v("“Jesus Christ Garrett, will you look like that in a few years?”")]), _vm._v(" "), _c('p', [_vm._v("“No, my dear, only in a thousand. Roseabella, you take the others, this ugly mother fucker is mine.”")]), _vm._v(" "), _c('p', [_vm._v("Roseabella took another spear and ran for a vampire who had down one of her men. Her spear went through his heart.")]), _vm._v(" "), _c('p', [_vm._v("“Move away, he’s burning into ashes.”")]), _vm._v(" "), _c('p', [_vm._v("“My god, you are right, lady Roseabella.”")]), _vm._v(" "), _c('p', [_vm._v("She had only five men left.")]), _vm._v(" "), _c('p', [_vm._v("“Take out your spears and stand with me in a circle. Stab the vamps that come near you.”")]), _vm._v(" "), _c('p', [_vm._v("They were so outnumbered.")]), _vm._v(" "), _c('p', [_vm._v("“Take your crosses if you have one on.”")]), _vm._v(" "), _c('p', [_vm._v("Roseabella took out the small one Saige gave her on her eighteenth birthday. She kept it between her bosom ever since. The vampires backed away.")]), _vm._v(" "), _c('p', [_vm._v("“Charge!” Roseabella put her spear through his heart. One of her men charged but was cut down from behind. Only two of them had on crosses, another man went down.")]), _vm._v(" "), _c('p', [_vm._v("“Do you need any help, sister-in-law?”")]), _vm._v(" "), _c('p', [_vm._v("Helewise, Saige and the twins joined in. Helewise ran and jumped down the vamp who was going to attack her and chopped off his head with her axe.")]), _vm._v(" "), _c('p', [_vm._v("“Good chop, Helewise!”")]), _vm._v(" "), _c('p', [_vm._v("“Thanks, Marga.”")]), _vm._v(" "), _c('p', [_vm._v("“Look behind you, Ragga!”")]), _vm._v(" "), _c('p', [_vm._v("“I got her back.” Said Marga.")]), _vm._v(" "), _c('p', [_vm._v("“Helewise, put your cross outside of your neck. Saige, he’s running toward you with a sword.”")]), _vm._v(" "), _c('p', [_vm._v("Saige ran toward the vampire and jumped over his head.")]), _vm._v(" "), _c('p', [_vm._v("“Over here, bloodsucker.” The vampire turned around and suddenly Ragga was behind him with her axe. One chop and the head went flying.")]), _vm._v(" "), _c('p', [_vm._v("“Good team work, girls.”")]), _vm._v(" "), _c('p', [_vm._v("“Thanks, Roseabella!”")]), _vm._v(" "), _c('p', [_vm._v("“You two men, go help your men on the beach.”")]), _vm._v(" "), _c('p', [_vm._v("One vampire took off toward the two men. Saige took out her arrow and shot him through the neck. He went down wounded and she ran after him and took off his head. Helewise took out her spear and it went through his stomach, the vampire got up slowly and made a run for it.")]), _vm._v(" "), _c('p', [_vm._v("Marga and Ragga shot arrow after arrow, the vampire went down this time and burned to ashes.")]), _vm._v(" "), _c('p', [_vm._v("Garrett was exhausted. He had wounds everywhere.")]), _vm._v(" "), _c('p', [_vm._v("The Elder asked, “Where did those female fighters come from?”")]), _vm._v(" "), _c('p', [_vm._v("“I have no idea.”")]), _vm._v(" "), _c('p', [_vm._v("“I will change them to be my warriors. And you, Garrett, will die for taking my brother’s life.”")]), _vm._v(" "), _c('p', [_vm._v("“Your brother was even uglier than you.”")]), _vm._v(" "), _c('p', [_vm._v("“You will pay for that.” With his sword, he sliced through Garrett’s arm that held his sword. Garrett’s sword hit the ground.")]), _vm._v(" "), _c('p', [_vm._v("“Now, you are going to burn to ashes.”")]), _vm._v(" "), _c('p', [_vm._v("“Hey, you ugly giant!”")]), _vm._v(" "), _c('p', [_vm._v("“Watch your mouth, little girl. I can turn you or rip off your head.”")]), _vm._v(" "), _c('p', [_vm._v("“Over here, gargoyle monster!”")]), _vm._v(" "), _c('p', [_vm._v("“Well, well, twins. Which one of you should I take to my bed first? I think I will take the two of you the same time.”")]), _vm._v(" "), _c('p', [_vm._v("The old vampire was then knocked to the ground. In a flash, he was on his feet again.")]), _vm._v(" "), _c('p', [_vm._v("“You! I will keep until you have grown into a woman. You, my dear, have powers I seek. I wanted to taste the blood of an angel. Your blood will make me young again.”")]), _vm._v(" "), _c('p', [_vm._v("“God sent me to destroy you!” With her cross in her hand, Saige walked up to the Elder.")]), _vm._v(" "), _c('p', [_vm._v("“Get that away from me.” And with her other hand, she threw her bag of holy water into his eyes.")]), _vm._v(" "), _c('p', [_vm._v("“You little bitch. I’m going to bite out your throat.” The other four warriors ran at him with their holy water. His face and hands were burning. The Elder made a plunge and landed on Saige. Four spears went into the old vampire. Two went through his heart.")]), _vm._v(" "), _c('p', [_vm._v("“NO. NO. NO. I will not die.”")]), _vm._v(" "), _c('p', [_vm._v("“Too late, old man. You’re starting to burn.” The Elder turned to burning ashes.")]), _vm._v(" "), _c('p', [_vm._v("“We must help Garrett,” said Saige, “he’s bleeding to death.”")]), _vm._v(" "), _c('p', [_vm._v("“He’s a vampire and he kidnapped Lady Roseabella, her sister and her son.”")]), _vm._v(" "), _c('p', [_vm._v("“Garrett didn’t harm them, he made mistakes by forcing a woman to give up the man she loves. He wanted a real family who was related to him. Garrett,” said Saige, “Father Strickland said you still have good in you. What you did for all these people who didn’t have a life until you brought them to this island. Help me get him inside, he needs to be stitched up. He has wounds everywhere and has lost a lot of blood.”")]), _vm._v(" "), _c('p', [_vm._v("Roseabella stepped forward, “My husband will make the choice if you live or die.”")]), _vm._v(" "), _c('p', [_vm._v("“Gretta, open up!”")]), _vm._v(" "), _c('p', [_vm._v("“Have you been bitten? How do I know for sure?”")]), _vm._v(" "), _c('p', [_vm._v("“Go open the curtain and shutter a little bit. We can’t come in unless you invite the five of us in!”")]), _vm._v(" "), _c('p', [_vm._v("“The five of you? You mean the men?” Gretta opened one of the shutters just a little inch. “Oh my god, I can’t believe it! I must be dreaming!”")]), _vm._v(" "), _c('p', [_vm._v("“What’s wrong, Gretta?”")]), _vm._v(" "), _c('p', [_vm._v("“Oh Rueband, help me move all the furniture from the door.”")]), _vm._v(" "), _c('p', [_vm._v("“No Gretta, there’s vampires out there.”")]), _vm._v(" "), _c('p', [_vm._v("“No, they are all dead. Rueband, my friends are out there.”")]), _vm._v(" "), _c('p', [_vm._v("“Your friends? What are you talking about?”")]), _vm._v(" "), _c('p', [_vm._v("“Look through the window. There are four pretty girls out there! Now, can you help me? Hurry up, Rueband, Garrett is hurt badly.")]), _vm._v(" "), _c('p', [_vm._v("How did you get here?”")]), _vm._v(" "), _c('p', [_vm._v("“On a ship. How else would we get here, Gretta?”")]), _vm._v(" "), _c('p', [_vm._v("“I’m so glad to see you all. Saige, you look so grown up.”")]), _vm._v(" "), _c('p', [_vm._v("“So do you, Gretta!”")]), _vm._v(" "), _c('p', [_vm._v("“Rueband, let’s get him in his bed.”")]), _vm._v(" "), _c('p', [_vm._v("“Not his casket?”")]), _vm._v(" "), _c('p', [_vm._v("“No, his windows are all boarded up. We need the seamstress to sew him up. My god, he looks like death. Can you hear me, Garrett?” Only a whisper was heard.")]), _vm._v(" "), _c('p', [_vm._v("“I’ll get the seamstress but—”")]), _vm._v(" "), _c('p', [_vm._v("“But what?”")]), _vm._v(" "), _c('p', [_vm._v("“Nothing, she’ll have no other choice.”")]), _vm._v(" "), _c('p', [_vm._v("“Rueband?”")]), _vm._v(" "), _c('p', [_vm._v("“Yes, my lady?”")]), _vm._v(" "), _c('p', [_vm._v("“He’s going to need human blood, what will we do?”")]), _vm._v(" "), _c('p', [_vm._v("“Stitch him up first and we’ll decide later.” Garrett was stripped from his bloody clothes.")]), _vm._v(" "), _c('p', [_vm._v("“A nice body for a vampire.”")]), _vm._v(" "), _c('p', [_vm._v("“You’re right Ragga, look at all those muscles and look how big his—”")]), _vm._v(" "), _c('p', [_vm._v("“Marga, Ragga, get out the both of you! Go get something to eat and drink.”")]), _vm._v(" "), _c('p', [_vm._v("“Let’s go, you coming Helewise?”")]), _vm._v(" "), _c('p', [_vm._v("“Yes, I need something strong to drink.”")]), _vm._v(" "), _c('p', [_vm._v("Before they left, Roseabella said, “Girls, I’m so happy to see you all. You did a wonderful job today; we took down an Elder. And Helewise, go to the nursery and visit your nephew and two other additions to our family.”")]), _vm._v(" "), _c('p', [_vm._v("“You got pets like we do? Our dogs are fighting vampires with Armando. Go see for yourself! Oh, alright let’s go see my precious nephew, it’s been a year.”")]), _vm._v(" "), _c('p', [_vm._v("“Who’s there?”")]), _vm._v(" "), _c('p', [_vm._v("“I’m Helewise, Josiah’s aunt.”")]), _vm._v(" "), _c('p', [_vm._v("“Ok yes, Roseabella told us to expect you. Please come in.”")]), _vm._v(" "), _c('p', [_vm._v("“Josiah, my god how much you have gown. I’m your father’s sister, Helewise. Come give me a hug. What a big boy you are! These are my friends, Marga and Ragga.”")]), _vm._v(" "), _c('p', [_vm._v("“My twins!” Josiah ran over to the crib and pointed. “What do you see little one? Whose babies are these?”")]), _vm._v(" "), _c('p', [_vm._v("“Lady Roseabella’s twin daughters.”")]), _vm._v(" "), _c('p', [_vm._v("“But how can that be?”")]), _vm._v(" "), _c('p', [_vm._v("“Lady Roseabella was five months with child when she arrived on this island.”")]), _vm._v(" "), _c('p', [_vm._v("“And Armando don’t have a clue! Aren’t they cute Ragga?”")]), _vm._v(" "), _c('p', [_vm._v("“Yes Marga.”")]), _vm._v(" "), _c('p', [_vm._v("“And they’re identical just like us. Let’s go celebrate, Helewise.”")]), _vm._v(" "), _c('p', [_vm._v("“Should we go and see if Armando needs us?”")]), _vm._v(" "), _c('p', [_vm._v("“Rueband, Gretta’s friend said it was all over. He’s helping the doctor with the injured, taking them on the ship. And Doctor Bardue is on his way to look at Garrett.”")]), _vm._v(" "), _c('p', [_vm._v("“Well then, let’s celebrate.”")]), _vm._v(" "), _c('p', [_vm._v("“Lady Roseabella, it’s so good to see you again.”")]), _vm._v(" "), _c('p', [_vm._v("“I have missed you too, Saige. How did you ever find us?”")]), _vm._v(" "), _c('p', [_vm._v("“I saw Gretta on the beach, looking out between two cliffs and I saw you nursing two baby girls.”")]), _vm._v(" "), _c('p', [_vm._v("“Does Armando know?”")]), _vm._v(" "), _c('p', [_vm._v("“Yes, my lady. He never gave up hope in finding you.”")]), _vm._v(" "), _c('p', [_vm._v("“That must be the doctor. Come in, doctor Bardue. Doctor, can you please tell me how many men we lost?”")]), _vm._v(" "), _c('p', [_vm._v("“Garrett lost thirty men; Armando lost five. Now, I need to see Garrett. Good stitching.”")]), _vm._v(" "), _c('p', [_vm._v("“You have to thank the seamstress.”")]), _vm._v(" "), _c('p', [_vm._v("“His blood is very low. He will die if he’s not fed.”")]), _vm._v(" "), _c('p', [_vm._v("“What about pigs’ blood?”")]), _vm._v(" "), _c('p', [_vm._v("“It won’t restore him. He needs the real thing.”")]), _vm._v(" "), _c('p', [_vm._v("“I will give him my blood.”")]), _vm._v(" "), _c('p', [_vm._v("“You will not, Gretta.”")]), _vm._v(" "), _c('p', [_vm._v("“He’s been good to me. He’s not a bad person, just a confused one. I have made up my mind. Can you cut my vein, Doctor Bardue and let Garrett feed?”")]), _vm._v(" "), _c('p', [_vm._v("“Doctor, will Gretta turn?”")]), _vm._v(" "), _c('p', [_vm._v("“No, we will let the blood drop into his mouth. He won’t be able to bite her. We need Rueband, so she won’t get weak.”")]), _vm._v(" "), _c('p', [_vm._v("“Will he agree to this?”")]), _vm._v(" "), _c('p', [_vm._v("“Rueband owes Garrett his life! If that’s not enough blood, then I’ll be third. On second thought, Gretta, I will open up your vein and let it drop in a cup. We can spoon it in his mouth.”")]), _vm._v(" "), _c('p', [_vm._v("“Yes, doctor.”")]), _vm._v(" "), _c('p', [_vm._v("“Saige, can you go find Rueband?”")]), _vm._v(" "), _c('p', [_vm._v("“Yes of course.”")]), _vm._v(" "), _c('p', [_vm._v("“Roseabella, you look tired and your milk is leaking through your shirt, you’re going to need to go nurse the twins or you are going to be in great pain. I will look after your sister; she is in no harm.”")]), _vm._v(" "), _c('p', [_vm._v("“Ok doctor. I love you Gretta, I’ll be back.”")]), _vm._v(" "), _c('p', [_vm._v("“Garrett, can you hear me? Garrett, wake up. You need to open your mouth. There you are, Rueband. I need help opening his jaws.”")]), _vm._v(" "), _c('p', [_vm._v("“No, that’s too dangerous.” said Saige.")]), _vm._v(" "), _c('p', [_vm._v("“How do you know that, little girl?”")]), _vm._v(" "), _c('p', [_vm._v("“Let me speak to him alone.”")]), _vm._v(" "), _c('p', [_vm._v("“We don’t have time for that, child.”")]), _vm._v(" "), _c('p', [_vm._v("“Let Saige talk to him alone.”")]), _vm._v(" "), _c('p', [_vm._v("“Roseabella, you need to breast feed.”")]), _vm._v(" "), _c('p', [_vm._v("“The twins are full with the wet nurse’s milk.”")]), _vm._v(" "), _c('p', [_vm._v("“And what good is this child going to make?”")]), _vm._v(" "), _c('p', [_vm._v("“All the difference in the world doctor.”")]), _vm._v(" "), _c('p', [_vm._v("“God, is this man who now is a vampire ready to come home? Garrett is not like the other vampires. He doesn’t feed on human blood. He drinks the blood of animals instead. He became lost when Morgania turned him. He killed many Elders because he wanted the killing to stop.")]), _vm._v(" "), _c('p', [_vm._v("He has three friends who are willing to give him their blood. Do you want his human soul, my god or is he needed to fight more battles and bring prosperity to his people on this island?")]), _vm._v(" "), _c('p', [_vm._v("Garrett, can you hear me? You are chosen to live amongst humans, the way you are doing now. You will become a warrior and fight alongside of your cousin, Armando and his wife. There are other vampires in our towns and countries. Wake up Garrett and see your angel.”")]), _vm._v(" "), _c('p', [_vm._v("“Who are you?”")]), _vm._v(" "), _c('p', [_vm._v("“My name is Saige. I’m the granddaughter of Gerrold and Meiga.”")]), _vm._v(" "), _c('p', [_vm._v("“Why did God send me back?”")]), _vm._v(" "), _c('p', [_vm._v("“He has his reasons. God took my mother and sent me down to earth. You must do as he wishes of you, Garrett. The people on this island depend on you. You have the strength of ten men. We need you to join our team. We are vampire slayers.”")]), _vm._v(" "), _c('p', [_vm._v("“Armando is going to kill me the first chance he gets.”")]), _vm._v(" "), _c('p', [_vm._v("“I will talk to Armando. Roseabella and the children will go back with us. They are not yours, Garrett. You will ask for forgiveness. There are three people outside who are waiting to give blood to you. You do have people who care. And God made you strong, so you don’t need their blood. You need rest, we will talk tomorrow. You can go in now.”")]), _vm._v(" "), _c('p', [_vm._v("“Garrett, you are alive and well. How can that be?”")]), _vm._v(" "), _c('p', [_vm._v("“I just needed rest. Vampires can take a lot of beatings.”")]), _vm._v(" "), _c('p', [_vm._v("“We were going to give you our blood, Garrett.”")]), _vm._v(" "), _c('p', [_vm._v("“You keep your blood, Rueband and I’ll stick to pig’s blood.”")]), _vm._v(" "), _c('p', [_vm._v("“Garrett, I’m so happy you’re ok.” and Gretta ran to give him a big hug.")]), _vm._v(" "), _c('p', [_vm._v("“Garrett, we have a lot of work to do, you lost thirty men.” said Gretta. “The children and women are safe. When you’re better, we’ll go back to Transylvania and find more men.”")]), _vm._v(" "), _c('p', [_vm._v("“Gretta, you are free now. You must go back to your family.”")]), _vm._v(" "), _c('p', [_vm._v("“I will Garrett, when I’m ready. I love this island and doctor Bardue still has a lot to teach me.”")]), _vm._v(" "), _c('p', [_vm._v("“Roseabella will not allow you to stay.”")]), _vm._v(" "), _c('p', [_vm._v("Armando opened up his wife’s bedroom door and saw two cribs. In one was his son. Josiah was a baby last time he saw him. Now, he was one year and a half. What a handsome little boy.")]), _vm._v(" "), _c('p', [_c('em', [_vm._v("Garrett took a year from my son’s life from me. He will pay for this")]), _vm._v(". In the next crib, he saw his two little daughters.")]), _vm._v(" "), _c('p', [_vm._v("“You’re so beautiful, my little girls. You look like your mother.” Roseabella woke up from a scary dream, where Armando was leaving her behind.")]), _vm._v(" "), _c('p', [_vm._v("“I came for the children, Roseabella. You belong to Garrett.”")]), _vm._v(" "), _c('p', [_vm._v("“No, no, no, my darling girl. I’m here now. I have found you.”")]), _vm._v(" "), _c('p', [_vm._v("“Oh Armando, are you real?”")]), _vm._v(" "), _c('p', [_vm._v("“Yes, I am Roseabella.” He took her into his arms and rocked her like she was a baby. “Oh Roseabella, I thought I’d never see you again. It’s been the worst year of my life. A piece of me has been lost.”")]), _vm._v(" "), _c('p', [_vm._v("“Oh Armando, I love you so much. You found us. I thought I would have to kill him soon, if you didn’t show up.”")]), _vm._v(" "), _c('p', [_vm._v("“Did he hurt you? Force you into his bed?”")]), _vm._v(" "), _c('p', [_vm._v("“No Armando, I was five months pregnant with child when we arrived. I’m just starting to get my strength back since the birth of the twins. He hasn’t had a chance.”")]), _vm._v(" "), _c('p', [_vm._v("“I can’t wait to put my sword through his heart.”")]), _vm._v(" "), _c('p', [_vm._v("“He’s lost a lot of blood and might not make it.”")]), _vm._v(" "), _c('p', [_vm._v("“He’ll live long enough for my revenge.”")]), _vm._v(" "), _c('p', [_vm._v("“Love me Armando, I need you so much.”")]), _vm._v(" "), _c('p', [_vm._v("“Oh Roseabella, I’ve dreamed of this day for so long.”")]), _vm._v(" "), _c('p', [_vm._v("Armando and Roseabella were so hungry for each other, they blocked out the world for a while.")]), _vm._v(" "), _c('p', [_vm._v("“Oh Armando, it’s been so long how I ached for you.”")]), _vm._v(" "), _c('p', [_vm._v("“Roseabella, you will not leave my side again.”")]), _vm._v(" "), _c('p', [_vm._v("“Good morning Ragga, Marga and you dear sister. Good morning, Sir Armando. You look happy, brother. I’m so glad for you.”")]), _vm._v(" "), _c('p', [_vm._v("“What have you three been doing this morning?”")]), _vm._v(" "), _c('p', [_vm._v("“We have taken the women and children back to their cottages. Thirty women are widows.”")]), _vm._v(" "), _c('p', [_vm._v("“What did Garrett try to accomplish here?”")]), _vm._v(" "), _c('p', [_vm._v("“He accomplished a lot. There are fields of corn, wheat, cabbage, potatoes, and trees with fruit hanging off them. Livestock horses, pigs’ sheep, ducks and chickens. An ocean full of fish. It’s the most beautiful place I have ever seen. Armando, I’m so sorry he put us through hell. All the people here respect him so much. He took people off the street and gave them a reason to live.”")]), _vm._v(" "), _c('p', [_vm._v("“Helewise, he took my wife and son from me. My son thinks Garrett is his father. I’m on my way to kill him.”")]), _vm._v(" "), _c('p', [_vm._v("“What about all these women and children?”")]), _vm._v(" "), _c('p', [_vm._v("“They can carry on without him. They got a ship to travel on. They can pick up more men. Get ready to leave tomorrow. We need livestock, fresh fruit and vegetables. Tell the men to go out fishing and salt it. Marga, we need barrels of water. Ragga, help my wife pack.”")]), _vm._v(" "), _c('p', [_vm._v("“Armando, where are you going?”")]), _vm._v(" "), _c('p', [_vm._v("“Helewise, go and do as I tell you.”")]), _vm._v(" "), _c('p', [_vm._v("“Armando, we have been waiting for you.”")]), _vm._v(" "), _c('p', [_vm._v("“We? Saige, there is no we! You must go now, Saige.”")]), _vm._v(" "), _c('p', [_vm._v("“I cannot let you kill him, Armando.”")]), _vm._v(" "), _c('p', [_vm._v("“Why would you protect this crazy fucking vampire?”")]), _vm._v(" "), _c('p', [_vm._v("“Garrett is ashamed of what he has done to you and your wife.”")]), _vm._v(" "), _c('p', [_vm._v("“Ashamed? That’s all he feels, ashamed? He kidnapped my pregnant wife and son. For that, he must die.”")]), _vm._v(" "), _c('p', [_vm._v("“Armando, Garrett has been forgiven by God.”")]), _vm._v(" "), _c('p', [_vm._v("“What are you telling me, Saige?”")]), _vm._v(" "), _c('p', [_vm._v("“God has spoken to both Garrett and me.”")]), _vm._v(" "), _c('p', [_vm._v("“God can forgive you, my cousin but I’m not.” Armando took out his sword and laid it against Garrett’s chest.")]), _vm._v(" "), _c('p', [_vm._v("“I will leave you two alone.”")]), _vm._v(" "), _c('p', [_vm._v("“Armando, God knows nothing. I’m so sorry for what I did. I didn’t want to be a vampire. I also didn’t want to die. And if I killed off the Elders and start over somewhere safe, I could feel human again with your children. I couldn’t separate Roseabella from her child and family. I took Gretta to help out Roseabella on the ship. Now I look back on it, Armando, it was a sick thing to do. I’m sorry for putting Roseabella through the lonely life without you. I want to die now, I can’t face my mistakes. Please Armando, I want to end it all. Put your sword through my heart.”")]), _vm._v(" "), _c('p', [_vm._v("“I have too many people for some reason that want you alive. We are leaving tomorrow away from this island and you! Do not ever come near my family again. If you do, I will hang you up to burn in the sun.”")]), _vm._v(" "), _c('p', [_vm._v("“They are your family, Armando; I know that now. I promise I will stay away from your family.”")]), _vm._v(" "), _c('h2', [_c('strong', [_vm._v("Welcome Home")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "01em !important"
    }
  }, [_vm._v("“What’s wrong, Meiga?”")]), _vm._v(" "), _c('p', [_vm._v("“Father, it’s been almost two years now.”")]), _vm._v(" "), _c('p', [_vm._v("“Don’t give up yet, Meiga. We weren’t given an angel, so God can take her back. There’s been a lot of storms to slow them down.”")]), _vm._v(" "), _c('p', [_vm._v("“We miss her so much, father, she’s all we got. I feel I let her mother down again.”")]), _vm._v(" "), _c('p', [_vm._v("“Meiga, your daughter is so proud of you the way young Saige is loved and reared up.”")]), _vm._v(" "), _c('p', [_vm._v("“Father, come quick; we have visitors. Meiga, Gerrold wants you at the front gate.”")]), _vm._v(" "), _c('p', [_vm._v("“No more vamps, father?”")]), _vm._v(" "), _c('p', [_vm._v("“Not with the sun shining.”")]), _vm._v(" "), _c('p', [_vm._v("The gates were opened up. Saige jumped off her horse.")]), _vm._v(" "), _c('p', [_vm._v("“Gramps, Gran, I’m back.”")]), _vm._v(" "), _c('p', [_vm._v("“Oh, my baby girl, how I missed you.”")]), _vm._v(" "), _c('p', [_vm._v("“Gramps, any more vampire attacks?”")]), _vm._v(" "), _c('p', [_vm._v("Gerrold took his granddaughter off her feet and hugged her and swung her around.")]), _vm._v(" "), _c('p', [_vm._v("“You have grown, our Saige.”")]), _vm._v(" "), _c('p', [_vm._v("“Thank you, our lord Jesus Christ, for bringing them home to us safe.”")]), _vm._v(" "), _c('p', [_vm._v("“It’s good to see you, Father Strickland.”")]), _vm._v(" "), _c('p', [_vm._v("“And you, our angel.”")])])])])
}]}

/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(86),
  /* template */
  __webpack_require__(87),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 86 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 87 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('p', [_vm._v("Thank you for reading this sample. Here are other books you might like.")]), _c('div', [_c('div', {
    attrs: {
      "id": "textcafe-gallery-widget-container"
    }
  }), _vm._v(" "), _c('script', {
    attrs: {
      "type": "application/javascript"
    }
  }, [_vm._v("\n      TextCafeWidget.config({\n          'type':'related',\n          'id':'9798886937848',\n          'coverImageWidth': '30',\n          'hideDescriptions': true\n      });\n      var textCafeGalleryWidget = TextCafeWidget.widgets.galleryWidget.new({selector:'#textcafe-gallery-widget-container'});\n      textCafeGalleryWidget.render();\n    ")])])])
}]}

/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["Vuetify"] = factory();
	else
		root["Vuetify"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/dist/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 29);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["d"] = createSimpleFunctional;
/* harmony export (immutable) */ __webpack_exports__["e"] = createSimpleTransition;
/* harmony export (immutable) */ __webpack_exports__["b"] = createJavaScriptTransition;
/* harmony export (immutable) */ __webpack_exports__["f"] = directiveConfig;
/* harmony export (immutable) */ __webpack_exports__["a"] = addOnceEventListener;
/* harmony export (immutable) */ __webpack_exports__["g"] = getObjectValueByPath;
/* harmony export (immutable) */ __webpack_exports__["c"] = createRange;
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function createSimpleFunctional(c) {
  var el = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'div';

  return {
    functional: true,

    render: function render(h, _ref) {
      var data = _ref.data,
          children = _ref.children;

      data.staticClass = (c + ' ' + (data.staticClass || '')).trim();

      return h(el, data, children);
    }
  };
}

function createSimpleTransition(name) {
  var origin = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'top center 0';
  var mode = arguments[2];

  return {
    functional: true,

    props: {
      origin: {
        type: String,
        default: origin
      }
    },

    render: function render(h, context) {
      context.data = context.data || {};
      context.data.props = { name: name };
      context.data.on = context.data.on || {};

      if (mode) context.data.props.mode = mode;

      context.data.on.beforeEnter = function (el) {
        el.style.transformOrigin = origin;
        el.style.webkitTransformOrigin = origin;
      };

      return h('transition', context.data, context.children);
    }
  };
}

function createJavaScriptTransition(name, functions) {
  var css = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  var mode = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'in-out';

  return {
    functional: true,

    props: {
      css: {
        type: Boolean,
        default: css
      },
      mode: {
        type: String,
        default: mode
      }
    },

    render: function render(h, context) {
      var data = {
        props: _extends({}, context.props, {
          name: name
        }),
        on: functions
      };

      return h('transition', data, context.children);
    }
  };
}

function directiveConfig(binding) {
  var defaults = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return Object.assign({}, defaults, binding.modifiers, { value: binding.arg }, binding.value || {});
}

function addOnceEventListener(el, event, cb) {
  var once = function once() {
    cb();
    el.removeEventListener(event, once, false);
  };

  el.addEventListener(event, once, false);
}

function getObjectValueByPath(obj, path) {
  // credit: http://stackoverflow.com/questions/6491463/accessing-nested-javascript-objects-with-string-key#comment55278413_6491621
  if (!path || path.constructor !== String) return;
  path = path.replace(/\[(\w+)\]/g, '.$1'); // convert indexes to properties
  path = path.replace(/^\./, ''); // strip a leading dot
  var a = path.split('.');
  for (var i = 0, n = a.length; i < n; ++i) {
    var k = a[i];
    if (obj instanceof Object && k in obj) {
      obj = obj[k];
    } else {
      return;
    }
  }
  return obj;
}

function createRange(length) {
  return [].concat(_toConsumableArray(Array.from({ length: length }, function (v, k) {
    return k;
  })));
}

/***/ }),
/* 1 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    dark: Boolean,
    light: Boolean
  }
});

/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      isActive: !!this.value
    };
  },


  props: {
    value: {
      required: false
    }
  },

  watch: {
    value: function value(val) {
      this.isActive = !!val;
    },
    isActive: function isActive(val) {
      !!val !== this.value && this.$emit('input', val);
    }
  }
});

/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_contextualable__ = __webpack_require__(8);



/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_contextualable__["a" /* default */]],

  props: {
    disabled: Boolean,
    fa: Boolean,
    mdi: Boolean,
    large: Boolean,
    left: Boolean,
    medium: Boolean,
    right: Boolean,
    xLarge: Boolean
  },

  render: function render(h, _ref) {
    var props = _ref.props,
        data = _ref.data,
        _ref$children = _ref.children,
        children = _ref$children === undefined ? [] : _ref$children;

    if (props.fa || props.mdi) console.warn('The v-icon prop \'fa\' and \'mdi\' will be deprecated in the next release. Use \'fa\' or \'mdi\' prefix in icon name instead.');
    var iconName = '';
    var iconType = 'material-icons';

    if (children.length) {
      iconName = children.pop().text;
    } else if (data.domProps && data.domProps.textContent) {
      iconName = data.domProps.textContent;
      delete data.domProps.textContent;
    } else if (data.domProps && data.domProps.innerHTML) {
      iconName = data.domProps.innerHTML;
      delete data.domProps.innerHTML;
    }

    var thirdPartyIcon = iconName.indexOf('-') > -1;
    if (thirdPartyIcon) iconType = iconName.slice(0, iconName.indexOf('-'));

    // To keep things backwards compatible for now
    iconType = props.fa ? 'fa' : props.mdi ? 'mdi' : iconType;

    data.staticClass = (iconType + ' icon ' + (data.staticClass || '')).trim();
    data.attrs = data.attrs || {};

    var classes = {
      'icon--large': props.large,
      'icon--left': props.left,
      'icon--medium': props.medium,
      'icon--right': props.right,
      'icon--x-large': props.xLarge,
      'primary--text': props.primary,
      'secondary--text': props.secondary,
      'success--text': props.success,
      'info--text': props.info,
      'warning--text': props.warning,
      'error--text': props.error,
      'theme--dark': props.dark,
      'theme--light': props.light
    };

    var iconClasses = Object.keys(classes).filter(function (k) {
      return classes[k];
    }).join(' ');
    iconClasses && (data.staticClass += ' ' + iconClasses);

    // To keep things backwards compatible for now
    if (props.fa || props.mdi) {
      var comparison = props.fa ? 'fa' : 'mdi';

      if (iconName.indexOf(' ') > -1) data.staticClass += ' ' + comparison + '-' + iconName;else data.staticClass += ' ' + comparison + '-' + iconName.split(' ').join('-');
    }

    if (thirdPartyIcon) data.staticClass += ' ' + iconName;
    if (props.disabled) data.attrs.disabled = props.disabled;
    !(thirdPartyIcon || props.fa || props.mdi) && children.push(iconName);

    return h('i', data, children);
  }
});

/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__badge__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__click_outside__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__resize__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ripple__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__scroll__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__tooltip__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__touch__ = __webpack_require__(81);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Badge", function() { return __WEBPACK_IMPORTED_MODULE_0__badge__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ClickOutside", function() { return __WEBPACK_IMPORTED_MODULE_1__click_outside__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Ripple", function() { return __WEBPACK_IMPORTED_MODULE_3__ripple__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Resize", function() { return __WEBPACK_IMPORTED_MODULE_2__resize__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Scroll", function() { return __WEBPACK_IMPORTED_MODULE_4__scroll__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Tooltip", function() { return __WEBPACK_IMPORTED_MODULE_5__tooltip__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Touch", function() { return __WEBPACK_IMPORTED_MODULE_6__touch__["a"]; });










/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_contextualable__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_positionable__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_route_link__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_themeable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_toggleable__ = __webpack_require__(2);






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-btn',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_contextualable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_route_link__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_positionable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_themeable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixins_toggleable__["a" /* default */]],

  props: {
    activeClass: {
      type: String,
      default: 'btn--active'
    },
    block: Boolean,
    fab: Boolean,
    flat: Boolean,
    icon: Boolean,
    large: Boolean,
    loading: Boolean,
    outline: Boolean,
    ripple: {
      type: [Boolean, Object],
      default: true
    },
    round: Boolean,
    small: Boolean,
    tag: {
      type: String,
      default: 'button'
    },
    type: {
      type: String,
      default: 'button'
    }
  },

  computed: {
    classes: function classes() {
      return {
        'btn': true,
        'btn--absolute': this.absolute,
        'btn--active': this.isActive,
        'btn--block': this.block,
        'btn--bottom': this.bottom,
        'btn--disabled': this.disabled,
        'btn--flat': this.flat,
        'btn--floating': this.fab,
        'btn--fixed': this.fixed,
        'btn--hover': this.hover,
        'btn--icon': this.icon,
        'btn--large': this.large,
        'btn--left': this.left,
        'btn--loader': this.loading,
        'btn--outline': this.outline,
        'btn--raised': !this.flat,
        'btn--right': this.right,
        'btn--round': this.round,
        'btn--small': this.small,
        'btn--top': this.top,
        'theme--dark': this.dark,
        'theme--light': this.light,
        'primary': this.primary && !this.outline,
        'secondary': this.secondary && !this.outline,
        'success': this.success && !this.outline,
        'info': this.info && !this.outline,
        'warning': this.warning && !this.outline,
        'error': this.error && !this.outline,
        'primary--text': this.primary && (this.outline || this.flat),
        'secondary--text': this.secondary && (this.outline || this.flat),
        'success--text': this.success && (this.outline || this.flat),
        'info--text': this.info && (this.outline || this.flat),
        'warning--text': this.warning && (this.outline || this.flat),
        'error--text': this.error && (this.outline || this.flat)
      };
    }
  },

  methods: {
    // Prevent focus to match md spec
    click: function click(e) {
      !this.fab && e.detail && this.$el.blur();

      this.$emit('click', e);
    },
    genContent: function genContent() {
      return this.$createElement('div', { 'class': 'btn__content' }, [this.$slots.default]);
    },
    genLoader: function genLoader() {
      var children = [];

      if (!this.$slots.loader) {
        children.push(this.$createElement('v-progress-circular', {
          props: {
            indeterminate: true,
            size: 26
          }
        }));
      } else {
        children.push(this.$slots.loader);
      }

      return this.$createElement('span', { 'class': 'btn__loading' }, children);
    }
  },

  render: function render(h) {
    var _generateRouteLink = this.generateRouteLink(),
        tag = _generateRouteLink.tag,
        data = _generateRouteLink.data;

    var children = [this.genContent()];

    tag === 'button' && (data.attrs.type = this.type);
    this.loading && children.push(this.genLoader());

    return h(tag, data, children);
  }
});

/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export VCarouselTransition */
/* unused harmony export VCarouselReverseTransition */
/* unused harmony export VTabTransition */
/* unused harmony export VTabReverseTransition */
/* unused harmony export VMenuTransition */
/* unused harmony export VFabTransition */
/* unused harmony export VDialogTransition */
/* unused harmony export VDialogBottomTransition */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return VFadeTransition; });
/* unused harmony export VScaleTransition */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return VSlideXTransition; });
/* unused harmony export VSlideXReverseTransition */
/* unused harmony export VSlideYTransition */
/* unused harmony export VSlideYReverseTransition */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return VExpandTransition; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__expand_transition__ = __webpack_require__(71);




// Component specific transitions
var VCarouselTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('carousel-transition');
var VCarouselReverseTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('carousel-reverse-transition');
var VTabTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('tab-transition');
var VTabReverseTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('tab-reverse-transition');
var VMenuTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('menu-transition');
var VFabTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('fab-transition', 'center center', 'out-in');

// Generic transitions
var VDialogTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('dialog-transition');
var VDialogBottomTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('dialog-bottom-transition');
var VFadeTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('fade-transition');
var VScaleTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('scale-transition');
var VSlideXTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('slide-x-transition');
var VSlideXReverseTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('slide-x-reverse-transition');
var VSlideYTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('slide-y-transition');
var VSlideYReverseTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('slide-y-reverse-transition');

// JavaScript transitions
var VExpandTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["b" /* createJavaScriptTransition */])('expand-transition', __WEBPACK_IMPORTED_MODULE_1__expand_transition__["a" /* default */]);

/* harmony default export */ __webpack_exports__["d"] = ({
  VCarouselTransition: VCarouselTransition,
  VCarouselReverseTransition: VCarouselReverseTransition,
  VDialogTransition: VDialogTransition,
  VDialogBottomTransition: VDialogBottomTransition,
  VFabTransition: VFabTransition,
  VFadeTransition: VFadeTransition,
  VMenuTransition: VMenuTransition,
  VScaleTransition: VScaleTransition,
  VSlideXTransition: VSlideXTransition,
  VSlideXReverseTransition: VSlideXReverseTransition,
  VSlideYTransition: VSlideYTransition,
  VSlideYReverseTransition: VSlideYReverseTransition,
  VTabReverseTransition: VTabReverseTransition,
  VTabTransition: VTabTransition,
  VExpandTransition: VExpandTransition
});

/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__themeable__ = __webpack_require__(1);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_0__themeable__["a" /* default */]],

  data: function data() {
    return {
      errorBucket: [],
      focused: false,
      tabFocused: false,
      lazyValue: this.value
    };
  },


  props: {
    appendIcon: String,
    appendIconCb: Function,
    disabled: Boolean,
    error: Boolean,
    errorMessages: {
      type: [String, Array],
      default: function _default() {
        return [];
      }
    },
    hint: String,
    hideDetails: Boolean,
    label: String,
    persistentHint: Boolean,
    placeholder: String,
    prependIcon: String,
    prependIconCb: Function,
    required: Boolean,
    rules: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    tabindex: {
      default: 0
    },
    value: {
      required: false
    }
  },

  computed: {
    hasError: function hasError() {
      return this.validations.length || this.error;
    },
    inputGroupClasses: function inputGroupClasses() {
      return Object.assign({
        'input-group': true,
        'input-group--focused': this.focused,
        'input-group--dirty': this.isDirty,
        'input-group--tab-focused': this.tabFocused,
        'input-group--disabled': this.disabled,
        'input-group--error': this.hasError,
        'input-group--append-icon': this.appendIcon,
        'input-group--prepend-icon': this.prependIcon,
        'input-group--required': this.required,
        'input-group--hide-details': this.hideDetails,
        'input-group--placeholder': !!this.placeholder,
        'theme--dark': this.dark,
        'theme--light': this.light
      }, this.classes);
    },
    isDirty: function isDirty() {
      return this.inputValue;
    },
    modifiers: function modifiers() {
      var modifiers = {
        lazy: false,
        number: false,
        trim: false
      };

      if (!this.$vnode.data.directives) {
        return modifiers;
      }

      var model = this.$vnode.data.directives.find(function (i) {
        return i.name === 'model';
      });

      if (!model) {
        return modifiers;
      }

      return Object.assign(modifiers, model.modifiers);
    },
    validations: function validations() {
      return (!Array.isArray(this.errorMessages) ? [this.errorMessages] : this.errorMessages).concat(this.errorBucket);
    }
  },

  watch: {
    rules: function rules() {
      this.validate();
    }
  },

  mounted: function mounted() {
    this.validate();
  },


  methods: {
    genLabel: function genLabel() {
      return this.$createElement('label', {
        attrs: {
          for: this.$attrs.id
        }
      }, this.$slots.label || this.label);
    },
    genMessages: function genMessages() {
      var _this = this;

      var messages = [];

      if ((this.hint && this.focused || this.hint && this.persistentHint) && this.validations.length === 0) {
        messages = [this.genHint()];
      } else if (this.validations.length) {
        messages = this.validations.map(function (i) {
          return _this.genError(i);
        });
      }

      return this.$createElement('transition-group', {
        'class': 'input-group__messages',
        props: {
          tag: 'div',
          name: 'slide-y-transition'
        }
      }, messages);
    },
    genHint: function genHint() {
      return this.$createElement('div', {
        'class': 'input-group__hint',
        key: this.hint,
        domProps: { innerHTML: this.hint }
      });
    },
    genError: function genError(error) {
      return this.$createElement('div', {
        'class': 'input-group__error',
        key: error
      }, error);
    },
    genIcon: function genIcon(type) {
      var _class;

      var icon = this[type + 'Icon'];
      var cb = this[type + 'IconCb'];
      var hasCallback = typeof cb === 'function';

      return this.$createElement('v-icon', {
        'class': (_class = {}, _defineProperty(_class, 'input-group__' + type + '-icon', true), _defineProperty(_class, 'input-group__icon-cb', hasCallback), _class),
        on: {
          click: function click(e) {
            hasCallback && cb(e);
          }
        }
      }, icon);
    },
    genInputGroup: function genInputGroup(input) {
      var _this2 = this;

      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      var children = [];
      var wrapperChildren = [];
      var detailsChildren = [];

      data = Object.assign({}, {
        'class': this.inputGroupClasses,
        attrs: {
          tabindex: this.tabindex
        },
        on: {
          blur: function blur() {
            return _this2.tabFocused = false;
          },
          click: function click() {
            return _this2.tabFocused = false;
          },
          keyup: function keyup(e) {
            if ([9, 16].includes(e.keyCode)) {
              _this2.tabFocused = true;
            }
          },
          keydown: function keydown(e) {
            if (!_this2.toggle) return;

            if ([13, 32].includes(e.keyCode)) {
              e.preventDefault();
              _this2.toggle();
            }
          }
        }
      }, data);

      if (this.$slots.label || this.label) {
        children.push(this.genLabel());
      }

      wrapperChildren.push(input);

      if (this.prependIcon) {
        wrapperChildren.unshift(this.genIcon('prepend'));
      }

      if (this.appendIcon) {
        wrapperChildren.push(this.genIcon('append'));
      }

      children.push(this.$createElement('div', {
        'class': 'input-group__input'
      }, wrapperChildren));

      detailsChildren.push(this.genMessages());
      this.counter && detailsChildren.push(this.genCounter());

      children.push(this.$createElement('div', {
        'class': 'input-group__details'
      }, detailsChildren));

      return this.$createElement('div', data, children);
    },
    validate: function validate() {
      var _this3 = this;

      this.errorBucket = [];

      this.rules.forEach(function (rule) {
        var valid = typeof rule === 'function' ? rule(_this3.value) : rule;

        if (valid !== true) {
          _this3.errorBucket.push(valid);
        }
      });
    }
  }
});

/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    primary: Boolean,
    secondary: Boolean,
    success: Boolean,
    info: Boolean,
    warning: Boolean,
    error: Boolean
  }
});

/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    append: Boolean,
    disabled: Boolean,
    exact: Boolean,
    href: [String, Object],
    to: [String, Object],
    nuxt: Boolean,
    replace: Boolean,
    router: Boolean,
    ripple: {
      type: Boolean,
      default: true
    },
    tag: String
  },

  methods: {
    click: function click() {},
    generateRouteLink: function generateRouteLink() {
      var exact = this.exact;
      var tag = void 0;

      var data = {
        attrs: { disabled: this.disabled },
        class: this.classes,
        props: {},
        directives: [{
          name: 'ripple',
          value: this.ripple || false
        }],
        on: Object.assign({
          click: this.click
        }, this.$listeners || {})
      };

      if (typeof this.exact === 'undefined') {
        exact = this.to === '/' || this.to === Object(this.to) && this.to.path === '/';
      }

      if (this.to) {
        tag = this.nuxt ? 'nuxt-link' : 'router-link';
        data.props.to = this.to;
        data.props.exact = exact;
        data.props.activeClass = this.activeClass;
        data.props.append = this.append;
        data.props.replace = this.replace;
      } else {
        tag = this.href && 'a' || this.tag || 'a';

        if (tag === 'a') {
          data.attrs.href = this.href || 'javascript:;';
        }
      }

      return { tag: tag, data: data };
    }
  }
});

/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      isBooted: false
    };
  },


  watch: {
    isActive: function isActive() {
      this.isBooted = true;
    }
  },

  methods: {
    showLazyContent: function showLazyContent(content) {
      return this.lazy && this.isBooted || !this.lazy ? content : null;
    }
  }
});

/***/ }),
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export VListTileActionText */
/* unused harmony export VListTileAvatar */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return VListTileContent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return VListTileTitle; });
/* unused harmony export VListTileSubTitle */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VList__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VListGroup__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__VListTile__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__VListTileAction__ = __webpack_require__(21);







var VListTileActionText = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('list__tile__action-text', 'span');
var VListTileAvatar = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('list__tile__avatar', 'v-avatar');
var VListTileContent = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('list__tile__content', 'div');
var VListTileTitle = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('list__tile__title', 'div');
var VListTileSubTitle = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('list__tile__sub-title', 'div');

/* harmony default export */ __webpack_exports__["c"] = ({
  VList: __WEBPACK_IMPORTED_MODULE_1__VList__["a" /* default */],
  VListTile: __WEBPACK_IMPORTED_MODULE_3__VListTile__["a" /* default */],
  VListGroup: __WEBPACK_IMPORTED_MODULE_2__VListGroup__["a" /* default */],
  VListTileAction: __WEBPACK_IMPORTED_MODULE_4__VListTileAction__["a" /* default */],
  VListTileActionText: VListTileActionText,
  VListTileAvatar: VListTileAvatar,
  VListTileContent: VListTileContent,
  VListTileTitle: VListTileTitle,
  VListTileSubTitle: VListTileSubTitle
});

/***/ }),
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    absolute: Boolean,
    bottom: Boolean,
    fixed: Boolean,
    left: Boolean,
    right: Boolean,
    top: Boolean
  }
});

/***/ }),
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  props: {
    flat: Boolean,
    height: {
      type: String,
      default: 'auto'
    },
    hover: Boolean,
    img: String,
    raised: Boolean,
    tile: Boolean
  },

  render: function render(h, _ref) {
    var data = _ref.data,
        props = _ref.props,
        children = _ref.children;

    data.staticClass = ('card ' + (data.staticClass || '')).trim();
    data.style = data.style || {};
    data.style.height = props.height;

    if (props.dark) data.staticClass += ' theme--dark';
    if (props.flat) data.staticClass += ' card--flat';
    if (props.horizontal) data.staticClass += ' card--horizontal';
    if (props.hover) data.staticClass += ' card--hover';
    if (props.light) data.staticClass += ' theme--light';
    if (props.raised) data.staticClass += ' card--raised';
    if (props.tile) data.staticClass += ' card--tile';

    if (props.img) {
      data.style.background = 'url(' + props.img + ') center center / cover no-repeat';
    }

    return h('div', data, children);
  }
});

/***/ }),
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      isSaving: false
    };
  },


  props: {
    actions: Boolean,
    autosave: Boolean,
    landscape: Boolean,
    noTitle: Boolean,
    scrollable: Boolean,
    value: {
      required: true
    },
    light: {
      type: Boolean,
      default: true
    },
    dark: Boolean
  },

  methods: {
    save: function save() {},
    cancel: function cancel() {},
    genSlot: function genSlot() {
      return this.$scopedSlots.default({
        save: this.save,
        cancel: this.cancel
      });
    }
  }
});

/***/ }),
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    contentClass: {
      default: ''
    }
  },

  mounted: function mounted() {
    var _this = this;

    this.$vuetify.load(function () {
      if (_this._isDestroyed) return;

      var app = document.querySelector('[data-app]');

      if (!app) {
        return console.warn('Application is missing <v-app> component.');
      }

      app.insertBefore(_this.$refs.content, app.firstChild);
    });
  },
  beforeDestroy: function beforeDestroy() {
    if (!this.$refs.content) return;

    // IE11 Fix
    try {
      this.$refs.content.parentNode.removeChild(this.$refs.content);
    } catch (e) {}
  }
});

/***/ }),
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      overlay: null,
      overlayOffset: 0,
      overlayTransitionDuration: 500
    };
  },


  props: {
    hideOverlay: Boolean
  },

  beforeDestroy: function beforeDestroy() {
    this.removeOverlay();
  },


  methods: {
    genOverlay: function genOverlay() {
      var _this = this;

      if (!this.isActive || this.hideOverlay || this.isActive && this.overlay) return;

      this.overlay = document.createElement('div');
      this.overlay.className = 'overlay';
      this.overlay.onclick = function () {
        if (_this.permanent) return;else if (!_this.persistent) _this.isActive = false;else if (_this.isMobile) _this.isActive = false;
      };

      if (this.absolute) this.overlay.className += ' overlay--absolute';

      this.hideScroll();

      if (this.absolute) {
        // Required for IE11
        var parent = this.$el.parentNode;
        parent.insertBefore(this.overlay, parent.firstChild);
      } else {
        document.querySelector('[data-app]').appendChild(this.overlay);
      }

      this.overlay.clientHeight; // Force repaint
      requestAnimationFrame(function () {
        _this.overlay.className += ' overlay--active';
      });

      return true;
    },
    removeOverlay: function removeOverlay() {
      var _this2 = this;

      if (!this.overlay) {
        return this.showScroll();
      }

      this.overlay.classList.remove('overlay--active');

      setTimeout(function () {
        // IE11 Fix
        try {
          _this2.overlay.parentNode.removeChild(_this2.overlay);
          _this2.overlay = null;
          _this2.showScroll();
        } catch (e) {}
      }, this.overlayTransitionDuration);
    },
    hideScroll: function hideScroll() {
      // Check documentElement first for IE11
      // this.overlayOffset = document.documentElement &&
      //   document.documentElement.scrollTop ||
      //   document.body.scrollTop

      // document.body.style.top = `-${this.overlayOffset}px`
      // document.body.style.position = 'fixed'
      document.documentElement.style.overflow = 'hidden';
    },
    showScroll: function showScroll() {
      document.documentElement.removeAttribute('style');

      // if (!this.overlayOffset) return
      // document.body.scrollTop = this.overlayOffset
      // document.documentElement.scrollTop = this.overlayOffset
    }
  }
});

/***/ }),
/* 17 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-list',

  provide: function provide() {
    return {
      listClick: this.listClick,
      listClose: this.listClose
    };
  },


  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  data: function data() {
    return {
      uid: null,
      groups: []
    };
  },


  props: {
    dense: Boolean,
    subheader: Boolean,
    threeLine: Boolean,
    twoLine: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'list': true,
        'list--two-line': this.twoLine,
        'list--dense': this.dense,
        'list--three-line': this.threeLine,
        'list--subheader': this.subheader,
        'theme--dark dark--bg': this.dark,
        'theme--light light--bg': this.light
      };
    }
  },

  watch: {
    uid: function uid() {
      var _this = this;

      this.$children.filter(function (i) {
        return i.$options._componentTag === 'v-list-group';
      }).forEach(function (i) {
        return i.toggle(_this.uid);
      });
    }
  },

  methods: {
    listClick: function listClick(uid, force) {
      if (force) {
        this.uid = uid;
      } else {
        this.uid = this.uid === uid ? null : uid;
      }
    },
    listClose: function listClose(uid) {
      if (this.uid === uid) {
        this.uid = null;
      }
    }
  },

  render: function render(h) {
    var data = {
      'class': this.classes,
      attrs: { 'data-uid': this._uid }
    };

    return h('ul', data, [this.$slots.default]);
  }
});

/***/ }),
/* 18 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_route_link__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__directives__ = __webpack_require__(4);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-list-tile',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_route_link__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__["a" /* default */]],

  directives: {
    Ripple: __WEBPACK_IMPORTED_MODULE_2__directives__["Ripple"]
  },

  inheritAttrs: false,

  props: {
    activeClass: {
      type: String,
      default: 'list__tile--active'
    },
    avatar: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'list__tile': true,
        'list__tile--avatar': this.avatar,
        'list__tile--disabled': this.disabled
      };
    }
  },

  render: function render(h) {
    var _generateRouteLink = this.generateRouteLink(),
        tag = _generateRouteLink.tag,
        data = _generateRouteLink.data;

    data.attrs = Object.assign({}, data.attrs, this.$attrs);

    return h('li', {
      attrs: {
        disabled: this.disabled
      }
    }, [h(tag, data, [this.$slots.default])]);
  }
});

/***/ }),
/* 19 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function directive(e, el, binding, v) {
  var cb = function cb() {
    return true;
  };

  if (binding.value) cb = binding.value;

  if (v.context.isActive && e && e.target && e.target !== el && !el.contains(e.target) && cb(e)) {
    v.context.isActive = false;
  }
}

/* harmony default export */ __webpack_exports__["a"] = ({
  bind: function bind(el, binding, v) {
    v.context.$vuetify.load(function () {
      var outside = document.querySelector('[data-app]');
      var click = function click(e) {
        return directive(e, el, binding, v);
      };
      outside.addEventListener('click', click, false);
      el._clickOutside = click;
    });
  },
  unbind: function unbind(el) {
    var outside = document.querySelector('[data-app]');
    outside && outside.removeEventListener('click', el._clickOutside, false);
  }
});

/***/ }),
/* 20 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function style(el, value) {
  ['transform', 'webkitTransform'].forEach(function (i) {
    el.style[i] = value;
  });
}

var ripple = {
  show: function show(e, el, _ref) {
    var _ref$value = _ref.value,
        value = _ref$value === undefined ? {} : _ref$value;

    var container = document.createElement('span');
    var animation = document.createElement('span');

    container.appendChild(animation);
    container.className = 'ripple__container';

    if (value.class) {
      container.className += ' ' + value.class;
    }

    var size = el.clientWidth > el.clientHeight ? el.clientWidth : el.clientHeight;
    animation.className = 'ripple__animation';
    animation.style.width = size * (value.center ? 1 : 2) + 'px';
    animation.style.height = animation.style.width;

    el.appendChild(container);
    var computed = window.getComputedStyle(el);
    if (computed.position !== 'absolute' && computed.position !== 'fixed') el.style.position = 'relative';

    var offset = el.getBoundingClientRect();
    var x = value.center ? '50%' : e.clientX - offset.left + 'px';
    var y = value.center ? '50%' : e.clientY - offset.top + 'px';

    animation.classList.add('ripple__animation--enter');
    animation.classList.add('ripple__animation--visible');
    style(animation, 'translate(-50%, -50%) translate(' + x + ', ' + y + ') scale3d(0.01,0.01,0.01)');
    animation.dataset.activated = Date.now();

    setTimeout(function () {
      animation.classList.remove('ripple__animation--enter');
      style(animation, 'translate(-50%, -50%) translate(' + x + ', ' + y + ')  scale3d(0.99,0.99,0.99)');
    }, 0);
  },

  hide: function hide(el) {
    var ripples = el.getElementsByClassName('ripple__animation');

    if (ripples.length === 0) return;
    var animation = ripples[ripples.length - 1];
    var diff = Date.now() - Number(animation.dataset.activated);
    var delay = 400 - diff;

    delay = delay < 0 ? 0 : delay;

    setTimeout(function () {
      animation.classList.remove('ripple__animation--visible');

      setTimeout(function () {
        // Need to figure out a new way to do this
        try {
          if (ripples.length < 1) el.style.position = null;
          animation.parentNode && el.removeChild(animation.parentNode);
        } catch (e) {}
      }, 300);
    }, delay);
  }
};

function directive(el, binding, v) {
  if (binding.value === false) return;

  if ('ontouchstart' in window) {
    el.addEventListener('touchend', function () {
      return ripple.hide(el);
    }, false);
    el.addEventListener('touchcancel', function () {
      return ripple.hide(el);
    }, false);
  }

  el.addEventListener('mousedown', function (e) {
    return ripple.show(e, el, binding);
  }, false);
  el.addEventListener('mouseup', function () {
    return ripple.hide(el);
  }, false);
  el.addEventListener('mouseleave', function () {
    return ripple.hide(el);
  }, false);
}

function unbind(el, binding) {
  el.removeEventListener('touchstart', function (e) {
    return ripple.show(e, el, binding);
  }, false);
  el.removeEventListener('mousedown', function (e) {
    return ripple.show(e, el, binding);
  }, false);
  el.removeEventListener('touchend', function () {
    return ripple.hide(el);
  }, false);
  el.removeEventListener('touchcancel', function () {
    return ripple.hide(el);
  }, false);
  el.removeEventListener('mouseup', function () {
    return ripple.hide(el);
  }, false);
  el.removeEventListener('mouseleave', function () {
    return ripple.hide(el);
  }, false);
}

/* harmony default export */ __webpack_exports__["a"] = ({
  bind: directive,
  unbind: unbind
});

/***/ }),
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  name: 'list-tile-action',

  render: function render(h, _ref) {
    var data = _ref.data,
        children = _ref.children;

    data.staticClass = data.staticClass ? 'list__tile__action ' + (data.staticClass || '') : 'list__tile__action';
    if ((children || []).length > 1) data.staticClass += ' list__tile__action--stack';

    return h('div', data, children);
  }
});

/***/ }),
/* 22 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_activator__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_detachable__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_generators__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_position__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_utils__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_toggleable__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mixins_keyable__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__directives__ = __webpack_require__(4);










/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-menu',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_activator__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_detachable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_generators__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__mixins_keyable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_position__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixins_utils__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__mixins_toggleable__["a" /* default */]],

  directives: {
    ClickOutside: __WEBPACK_IMPORTED_MODULE_7__directives__["ClickOutside"]
  },

  data: function data() {
    return {
      autoIndex: null,
      dimensions: {
        activator: {
          top: 0, left: 0,
          bottom: 0, right: 0,
          width: 0, height: 0,
          offsetTop: 0, scrollHeight: 0
        },
        content: {
          top: 0, left: 0,
          bottom: 0, right: 0,
          width: 0, height: 0,
          offsetTop: 0, scrollHeight: 0
        },
        list: null,
        selected: null
      },
      direction: { vert: 'bottom', horiz: 'right' },
      isContentActive: false,
      isBooted: false,
      maxHeightAutoDefault: '200px',
      resizeTimeout: {},
      startIndex: 3,
      stopIndex: 0,
      tileLength: 0,
      window: {},
      absoluteX: 0,
      absoluteY: 0,
      hasJustFocused: false,
      focusedTimeout: {}
    };
  },


  props: {
    top: Boolean,
    left: Boolean,
    bottom: Boolean,
    right: Boolean,
    fullWidth: Boolean,
    auto: Boolean,
    offsetX: Boolean,
    offsetY: Boolean,
    disabled: Boolean,
    maxHeight: {
      default: 'auto'
    },
    nudgeTop: {
      type: Number,
      default: 0
    },
    nudgeBottom: {
      type: Number,
      default: 0
    },
    nudgeLeft: {
      type: Number,
      default: 0
    },
    nudgeRight: {
      type: Number,
      default: 0
    },
    nudgeWidth: {
      type: Number,
      default: 0
    },
    openOnClick: {
      type: Boolean,
      default: true
    },
    openOnHover: {
      type: Boolean,
      default: false
    },
    lazy: Boolean,
    closeOnClick: {
      type: Boolean,
      default: true
    },
    closeOnContentClick: {
      type: Boolean,
      default: true
    },
    activator: {
      default: null
    },
    origin: {
      type: String,
      default: 'top left'
    },
    transition: {
      type: String,
      default: 'menu-transition'
    },
    positionX: {
      type: Number,
      default: null
    },
    positionY: {
      type: Number,
      default: null
    },
    positionAbsolutely: {
      type: Boolean,
      default: false
    },
    maxWidth: [Number, String],
    minWidth: [Number, String]
  },

  computed: {
    calculatedMinWidth: function calculatedMinWidth() {
      var minWidth = parseInt(this.minWidth) || this.dimensions.activator.width + this.nudgeWidth + (this.auto ? 16 : 0);

      if (!this.maxWidth) return minWidth;

      var maxWidth = parseInt(this.maxWidth);

      return maxWidth < minWidth ? maxWidth : minWidth;
    },
    styles: function styles() {
      return {
        maxHeight: this.auto ? '200px' : isNaN(this.maxHeight) ? this.maxHeight : this.maxHeight + 'px',
        minWidth: this.calculatedMinWidth + 'px',
        maxWidth: parseInt(this.maxWidth) + 'px',
        top: this.calcTop() + 'px',
        left: this.calcLeft() + 'px'
      };
    },
    hasActivator: function hasActivator() {
      return !!this.$slots.activator || this.activator;
    }
  },

  watch: {
    activator: function activator(newActivator, oldActivator) {
      this.removeActivatorEvents(oldActivator);
      this.addActivatorEvents(newActivator);
    },
    disabled: function disabled(val) {
      val && this.deactivate();
    },
    hasJustFocused: function hasJustFocused(val) {
      var _this = this;

      if (!val) return;

      clearTimeout(this.focusedTimeout);
      this.focusedTimeout = setTimeout(function () {
        return _this.hasJustFocused = false;
      }, 550);
    },
    isActive: function isActive(val) {
      if (this.disabled) return;

      val && this.activate() || this.deactivate();
    },
    windowResizeHandler: function windowResizeHandler() {
      this.isBooted = false;
    }
  },

  mounted: function mounted() {
    window.addEventListener('resize', this.onResize, { passive: true });
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', this.onResize, { passive: true });
    window.removeEventListener('resize', this.windowResizeHandler);
  },


  methods: {
    activate: function activate() {
      if (typeof window === 'undefined') return;
      this.isBooted = true;
      this.getTiles();
      this.updateDimensions();
      requestAnimationFrame(this.startTransition);
      this.$emit('activate');
    },
    deactivate: function deactivate() {
      this.isContentActive = false;
      this.$emit('deactivate');
    },
    onResize: function onResize() {
      clearTimeout(this.resizeTimeout);
      if (!this.isActive) return;
      this.resizeTimeout = setTimeout(this.updateDimensions, 200);
    },
    startTransition: function startTransition() {
      var _this2 = this;

      requestAnimationFrame(function () {
        return _this2.isContentActive = true;
      });
      requestAnimationFrame(this.calculateScroll);
    }
  },

  render: function render(h) {
    var _this3 = this;

    var data = {
      'class': 'menu',
      style: {
        display: this.fullWidth ? 'block' : 'inline-block'
      },
      directives: [{
        name: 'click-outside',
        value: function value() {
          return _this3.closeOnClick;
        }
      }],
      on: {
        keydown: function keydown(e) {
          if (e.keyCode === 27) _this3.isActive = false;else _this3.changeListIndex(e);
        }
      }
    };

    return h('div', data, [this.genActivator(), this.genTransition()]);
  }
});

/***/ }),
/* 23 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_transitions__ = __webpack_require__(6);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-progress-linear',

  components: {
    VFadeTransition: __WEBPACK_IMPORTED_MODULE_0__components_transitions__["b" /* VFadeTransition */],
    VSlideXTransition: __WEBPACK_IMPORTED_MODULE_0__components_transitions__["c" /* VSlideXTransition */]
  },

  props: {
    active: {
      type: Boolean,
      default: true
    },
    buffer: Boolean,
    bufferValue: Number,
    error: Boolean,
    height: {
      type: [Number, String],
      default: 7
    },
    indeterminate: Boolean,
    info: Boolean,
    secondary: Boolean,
    success: Boolean,
    query: Boolean,
    warning: Boolean,
    value: {
      type: [Number, String],
      default: 0
    },
    colorFront: {
      type: String,
      default: null
    },
    colorBack: {
      type: String,
      default: null
    }
  },

  computed: {
    classes: function classes() {
      return {
        'progress-linear--query': this.query,
        'progress-linear--secondary': this.secondary,
        'progress-linear--success': this.success,
        'progress-linear--info': this.info,
        'progress-linear--warning': this.warning,
        'progress-linear--error': this.error
      };
    },
    styles: function styles() {
      var styles = {};

      if (!this.active) {
        styles.height = 0;
      }

      if (this.buffer) {
        styles.width = this.bufferValue + '%';
      }

      return styles;
    },
    bufferStyles: function bufferStyles() {
      var styles = {};

      if (!this.active) {
        styles.height = 0;
      }

      return styles;
    }
  },

  methods: {
    genDeterminate: function genDeterminate(h) {
      return h('div', {
        ref: 'front',
        class: ['progress-linear__bar__determinate', this.colorFront],
        style: { width: this.value + '%' }
      });
    },
    genBar: function genBar(h, name) {
      return h('div', {
        class: ['progress-linear__bar__indeterminate', name, this.colorFront]
      });
    },
    genIndeterminate: function genIndeterminate(h) {
      return h('div', {
        ref: 'front',
        class: {
          'progress-linear__bar__indeterminate': true,
          'progress-linear__bar__indeterminate--active': this.active
        }
      }, [this.genBar(h, 'long'), this.genBar(h, 'short')]);
    }
  },

  render: function render(h) {
    var fade = h('v-fade-transition', [this.indeterminate && this.genIndeterminate(h)]);
    var slide = h('v-slide-x-transition', [!this.indeterminate && this.genDeterminate(h)]);

    var bar = h('div', { class: ['progress-linear__bar', this.colorBack], style: this.styles }, [fade, slide]);

    return h('div', {
      class: ['progress-linear', this.classes],
      style: { height: this.height + 'px' },
      on: this.$listeners
    }, [bar]);
  }
});

/***/ }),
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_autocomplete__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_filterable__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_generators__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_input__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_cards_VCard__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_selection_controls_VCheckbox__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_icons_VIcon__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_lists_VList__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_lists_VListTile__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_lists_VListTileAction__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_lists__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_menus_VMenu__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__directives_click_outside__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__util_helpers__ = __webpack_require__(0);



















/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-select',

  components: {
    VCard: __WEBPACK_IMPORTED_MODULE_4__components_cards_VCard__["a" /* default */],
    VCheckbox: __WEBPACK_IMPORTED_MODULE_5__components_selection_controls_VCheckbox__["a" /* default */],
    VIcon: __WEBPACK_IMPORTED_MODULE_6__components_icons_VIcon__["a" /* default */],
    VList: __WEBPACK_IMPORTED_MODULE_7__components_lists_VList__["a" /* default */],
    VListTile: __WEBPACK_IMPORTED_MODULE_8__components_lists_VListTile__["a" /* default */],
    VListTileAction: __WEBPACK_IMPORTED_MODULE_9__components_lists_VListTileAction__["a" /* default */],
    VListTileContent: __WEBPACK_IMPORTED_MODULE_10__components_lists__["a" /* VListTileContent */],
    VListTileTitle: __WEBPACK_IMPORTED_MODULE_10__components_lists__["b" /* VListTileTitle */],
    VMenu: __WEBPACK_IMPORTED_MODULE_11__components_menus_VMenu__["a" /* default */]
  },

  directives: {
    clickOutside: __WEBPACK_IMPORTED_MODULE_12__directives_click_outside__["a" /* default */]
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_autocomplete__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_input__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_filterable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_generators__["a" /* default */]],

  data: function data() {
    return {
      content: {},
      hasFocused: false,
      inputValue: this.multiple && !this.value ? [] : this.value,
      isBooted: false,
      lastItem: 20,
      isActive: false,
      searchInputValue: this.searchInput
    };
  },


  props: {
    appendIcon: {
      type: String,
      default: 'arrow_drop_down'
    },
    auto: Boolean,
    autocomplete: Boolean,
    bottom: Boolean,
    chips: Boolean,
    close: Boolean,
    debounce: {
      type: Number,
      default: 200
    },
    items: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    filter: Function,
    itemText: {
      type: String,
      default: 'text'
    },
    itemValue: {
      type: String,
      default: 'value'
    },
    itemDisabled: {
      type: String,
      default: 'disabled'
    },
    maxHeight: {
      type: [Number, String],
      default: 300
    },
    minWidth: {
      type: [Boolean, Number, String],
      default: false
    },
    multiple: Boolean,
    multiLine: Boolean,
    offset: Boolean,
    searchInput: null,
    singleLine: Boolean,
    top: Boolean,
    returnObject: Boolean,
    overflow: Boolean,
    segmented: Boolean,
    editable: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'input-group--text-field input-group--select': true,
        'input-group--auto': this.auto,
        'input-group--overflow': this.overflow,
        'input-group--segmented': this.segmented,
        'input-group--editable': this.editable,
        'input-group--autocomplete': this.autocomplete,
        'input-group--single-line': this.singleLine || this.isDropdown,
        'input-group--multi-line': this.multiLine,
        'input-group--chips': this.chips,
        'input-group--multiple': this.multiple
      };
    },
    computedContentClass: function computedContentClass() {
      var children = [this.auto ? 'menu__content--auto' : '', this.isDropdown ? 'menu__content--dropdown' : ''];

      return children.join(' ');
    },
    filteredItems: function filteredItems() {
      var items = this.autocomplete && this.searchValue ? this.filterSearch() : this.items;

      return !this.auto ? items.slice(0, this.lastItem) : items;
    },
    hasError: function hasError() {
      return this.validations.length || this.error || this.hasFocused && !this.focused && !this.isDirty && this.required;
    },
    isDirty: function isDirty() {
      return this.selectedItems.length;
    },
    isDropdown: function isDropdown() {
      return this.segmented || this.overflow || this.editable;
    },

    searchValue: {
      get: function get() {
        return this.searchInput || this.searchInputValue;
      },
      set: function set(val) {
        this.searchInputValue = val;
        this.$emit('update:searchInput', val);
      }
    },
    selectedItems: function selectedItems() {
      var _this = this;

      if (this.inputValue === null || typeof this.inputValue === 'undefined') return [];

      return this.items.filter(function (i) {
        if (!_this.multiple) {
          return _this.getValue(i) === _this.getValue(_this.inputValue);
        } else {
          // Always return Boolean
          return _this.inputValue.find(function (j) {
            return _this.getValue(j) === _this.getValue(i);
          }) !== undefined;
        }
      });
    }
  },

  watch: {
    inputValue: function inputValue(val) {
      this.$emit('input', val);
    },
    value: function value(val) {
      this.inputValue = val;
      this.validate();
      if (this.autocomplete || this.editable) {
        this.$nextTick(this.$refs.menu.updateDimensions);
      }
    },
    isActive: function isActive(val) {
      this.isBooted = true;
      this.lastItem += !val ? 20 : 0;

      if (!val) this.blur();else this.focus();
    },
    isBooted: function isBooted() {
      var _this2 = this;

      this.$nextTick(function () {
        if (_this2.content) {
          _this2.content.addEventListener('scroll', _this2.onScroll, false);
        }
      });
    },
    searchValue: function searchValue() {
      this.$refs.menu.listIndex = -1;
    }
  },

  mounted: function mounted() {
    var _this3 = this;

    this.$vuetify.load(function () {
      if (_this3._isDestroyed) return;

      _this3.content = _this3.$refs.menu.$refs.content;
    });
  },
  beforeDestroy: function beforeDestroy() {
    if (this.isBooted) {
      if (this.content) {
        this.content.removeEventListener('scroll', this.onScroll, false);
      }
    }
  },


  methods: {
    blur: function blur() {
      var _this4 = this;

      this.$nextTick(function () {
        _this4.focused = false;
        _this4.hasFocused = true;
        _this4.searchValue = null;
        _this4.$el.blur();
      });
    },
    focus: function focus() {
      var _this5 = this;

      this.focused = true;
      this.$refs.input && (this.autocomplete || this.editable) && this.$refs.input.focus();

      if (this.editable && this.inputValue !== null && typeof this.inputValue !== 'undefined') {
        this.$nextTick(function () {
          _this5.$refs.input.value = _this5.getValue(_this5.inputValue);
        });
      }
    },
    genLabel: function genLabel() {
      if (this.searchValue && !this.focused && this.isDirty) return null;

      var data = {};

      if (this.id) data.attrs = { for: this.id };

      return this.$createElement('label', data, this.label);
    },
    getPropertyFromItem: function getPropertyFromItem(item, field) {
      if (item !== Object(item)) return item;

      var value = Object(__WEBPACK_IMPORTED_MODULE_13__util_helpers__["g" /* getObjectValueByPath */])(item, field);

      return typeof value === 'undefined' ? item : value;
    },
    getText: function getText(item) {
      return this.getPropertyFromItem(item, this.itemText);
    },
    getValue: function getValue(item) {
      return this.getPropertyFromItem(item, this.itemValue);
    },
    onScroll: function onScroll() {
      var _this6 = this;

      if (!this.isActive) {
        requestAnimationFrame(function () {
          return _this6.content.scrollTop = 0;
        });
      } else {
        var showMoreItems = this.content.scrollHeight - (this.content.scrollTop + this.content.clientHeight) < 200;

        if (showMoreItems) {
          this.lastItem += 20;
        }
      }
    },
    selectItem: function selectItem(item) {
      var _this7 = this;

      if (!this.multiple) {
        this.inputValue = this.returnObject ? item : this.getValue(item);
      } else {
        var inputValue = this.inputValue.slice();
        var i = this.inputValue.findIndex(function (i) {
          return _this7.getValue(i) === _this7.getValue(item);
        });

        i !== -1 && inputValue.splice(i, 1) || inputValue.push(item);
        this.inputValue = inputValue.map(function (i) {
          return _this7.returnObject ? i : _this7.getValue(i);
        });
      }

      if (this.autocomplete || this.editable) {
        this.$nextTick(function () {
          _this7.searchValue = null;
          _this7.$refs.input && _this7.$refs.input.focus();
        });
      }

      this.$emit('change', this.inputValue);
    }
  },

  render: function render(h) {
    var _this8 = this;

    return this.genInputGroup([this.genSelectionsAndSearch(), this.genMenu()], {
      ref: 'activator',
      directives: [{
        name: 'click-outside',
        value: function value() {
          return _this8.isActive = false;
        }
      }],
      on: {
        keydown: this.onKeyDown // Located in mixins/autocomplete.js
      }
    });
  }
});

/***/ }),
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    noDataText: {
      type: String,
      default: 'No data available'
    }
  }
});

/***/ }),
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_selectable__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__directives_ripple__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_transitions__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_icons_VIcon__ = __webpack_require__(3);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-checkbox',

  components: {
    VFadeTransition: __WEBPACK_IMPORTED_MODULE_2__components_transitions__["b" /* VFadeTransition */],
    VIcon: __WEBPACK_IMPORTED_MODULE_3__components_icons_VIcon__["a" /* default */]
  },

  directives: {
    Ripple: __WEBPACK_IMPORTED_MODULE_1__directives_ripple__["a" /* default */]
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_selectable__["a" /* default */]],

  data: function data() {
    return {
      inputIndeterminate: this.indeterminate
    };
  },


  props: {
    indeterminate: Boolean
  },

  computed: {
    classes: function classes() {
      return this.addColorClassChecks({
        'checkbox': true,
        'input-group--selection-controls': true,
        'input-group--active': this.isActive
      });
    },
    icon: function icon() {
      if (this.inputIndeterminate) {
        return 'indeterminate_check_box';
      } else if (this.isActive) {
        return 'check_box';
      } else {
        return 'check_box_outline_blank';
      }
    }
  },

  render: function render(h) {
    var transition = h('v-fade-transition', [h('v-icon', {
      'class': {
        'icon--checkbox': this.icon === 'check_box'
      },
      key: this.icon
    }, this.icon)]);

    var ripple = h('div', {
      'class': 'input-group--selection-controls__ripple',
      on: Object.assign({}, {
        click: this.toggle
      }, this.$listeners),
      directives: [{
        name: 'ripple',
        value: { center: true }
      }]
    });

    var data = {
      attrs: {
        role: 'checkbox',
        'aria-checked': this.inputIndeterminate && 'mixed' || this.isActive && 'true' || 'false',
        'aria-label': this.label
      }
    };

    return this.genInputGroup([transition, ripple], data);
  }
});

/***/ }),
/* 27 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colorable__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__input__ = __webpack_require__(7);



/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_1__input__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0__colorable__["a" /* default */]],

  model: {
    prop: 'inputValue',
    event: 'change'
  },

  props: {
    inputValue: null,
    falseValue: null,
    trueValue: null
  },

  computed: {
    isActive: function isActive() {
      if (Array.isArray(this.inputValue)) {
        return this.inputValue.indexOf(this.value) !== -1;
      }

      if (!this.trueValue || !this.falseValue) {
        return this.value ? this.value === this.inputValue : Boolean(this.inputValue);
      }

      return this.inputValue === this.trueValue;
    }
  },

  watch: {
    indeterminate: function indeterminate(val) {
      this.inputIndeterminate = val;
    }
  },

  methods: {
    genLabel: function genLabel() {
      return this.$createElement('label', {
        on: { click: this.toggle },
        attrs: {
          for: this.$attrs.id
        }
      }, this.$slots.label || this.label);
    },
    toggle: function toggle() {
      if (this.disabled) {
        return;
      }

      var input = this.inputValue;
      if (Array.isArray(input)) {
        input = input.slice();
        var i = input.indexOf(this.value);

        if (i === -1) {
          input.push(this.value);
        } else {
          input.splice(i, 1);
        }
      } else if (this.trueValue || this.falseValue) {
        input = input === this.trueValue ? this.falseValue : this.trueValue;
      } else if (this.value) {
        input = this.value === this.inputValue ? null : this.value;
      } else {
        input = !input;
      }

      this.$emit('change', input);
    }
  }
});

/***/ }),
/* 28 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    color: String
  },
  methods: {
    addColorClassChecks: function addColorClassChecks(classes) {
      var parts = this.color ? this.color.trim().split(' ') : [''];
      var color = parts[0] + '--text';
      if (parts.length > 1) color += ' text--' + parts[1];
      classes[color] = !!this.color;
      return classes;
    }
  }
});

/***/ }),
/* 29 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__package_json__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__package_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__package_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__directives__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_load__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_semver__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_semver___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_semver__);
__webpack_require__(30);







function plugin(Vue) {
  Object.keys(__WEBPACK_IMPORTED_MODULE_1__components__["a" /* default */]).forEach(function (key) {
    Vue.component(key, __WEBPACK_IMPORTED_MODULE_1__components__["a" /* default */][key]);
  });

  Object.keys(__WEBPACK_IMPORTED_MODULE_2__directives__).forEach(function (key) {
    Vue.directive(key, __WEBPACK_IMPORTED_MODULE_2__directives__[key]);
  });

  Vue.prototype.$vuetify = {
    load: __WEBPACK_IMPORTED_MODULE_3__util_load__["a" /* default */]
  };
}

function checkVueVersion() {
  var vueDep = __WEBPACK_IMPORTED_MODULE_0__package_json__["devDependencies"].vue;
  if (!__WEBPACK_IMPORTED_MODULE_4_semver___default.a.satisfies(window.Vue.version, vueDep)) {
    console.warn('Vuetify requires Vue version ' + vueDep);
  }
}

if (typeof window !== 'undefined' && window.Vue) {
  if (window.Vue.version) {
    checkVueVersion();
  }
  window.Vue.use(plugin);
}

/* harmony default export */ __webpack_exports__["default"] = (plugin);

/***/ }),
/* 30 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 31 */
/***/ (function(module, exports) {

module.exports = {
	"name": "vuetify",
	"version": "0.14.10",
	"author": {
		"name": "John Leider",
		"email": "john.j.leider@gmail.com"
	},
	"license": "MIT",
	"homepage": "http://vuetifyjs.com",
	"main": "dist/vuetify.js",
	"types": "index.d.ts",
	"scripts": {
		"watch": "cross-env TARGET=dev webpack --config build/config.js --progress --hide-modules --watch",
		"dev": "cross-env NODE_ENV=development webpack-dev-server --config build/webpack.dev.config.js --open --hot",
		"build": "rimraf dist && cross-env NODE_ENV=production node build/build.js --progress --hide-modules",
		"debug-build": "node --inspect --debug-brk build/build.js",
		"test": "cross-env NODE_ENV=test jest --no-cache --verbose",
		"test-coverage": "cross-env NODE_ENV=test jest --no-cache --coverage --verbose",
		"lint": "eslint --ext .js,.vue src"
	},
	"description": "Vue.js 2 Semantic Component Framework",
	"devDependencies": {
		"autoprefixer": "^6.6.0",
		"avoriaz": "^3.2.0",
		"babel-cli": "^6.24.1",
		"babel-core": "^6.24.1",
		"babel-eslint": "^7.1.1",
		"babel-jest": "^20.0.3",
		"babel-loader": "^7.1.1",
		"babel-plugin-add-filehash": "^6.9.4",
		"babel-plugin-module-resolver": "^2.7.1",
		"babel-plugin-transform-async-to-generator": "^6.24.1",
		"babel-plugin-transform-runtime": "^6.23.0",
		"babel-preset-env": "^1.5.1",
		"babel-preset-es2015": "^6.24.1",
		"babel-preset-stage-2": "^6.24.1",
		"chalk": "^1.1.3",
		"chromedriver": "^2.21.2",
		"cross-env": "^3.1.3",
		"cross-spawn": "^4.0.2",
		"css-loader": "^0.23.1",
		"css-mqpacker": "^6.0.1",
		"cssnano": "^3.10.0",
		"eslint": "^3.7.1",
		"eslint-config-standard": "^6.1.0",
		"eslint-config-vue": "^2.0.2",
		"eslint-friendly-formatter": "^2.0.5",
		"eslint-loader": "^1.6.1",
		"eslint-plugin-html": "^1.3.0",
		"eslint-plugin-promise": "^3.4.0",
		"eslint-plugin-pug": "^1.0.0",
		"eslint-plugin-standard": "^3.0.1",
		"eslint-plugin-vue": "^2.1.0",
		"eventsource-polyfill": "^0.9.6",
		"extract-text-webpack-plugin": "^3.0.0",
		"friendly-errors-webpack-plugin": "^1.6.1",
		"function-bind": "^1.0.2",
		"jest": "^20.0.4",
		"jest-cli": "^20.0.4",
		"jest-css-modules": "^1.1.0",
		"jest-serializer-html": "^4.0.0",
		"jest-vue-preprocessor": "^0.2.0",
		"lolex": "^1.4.0",
		"nightwatch": "^0.9.8",
		"opn": "^4.0.2",
		"optimize-css-assets-webpack-plugin": "^2.0.0",
		"optimize-js-plugin": "^0.0.4",
		"ora": "^0.3.0",
		"phantomjs-prebuilt": "^2.1.3",
		"postcss-loader": "^1.2.1",
		"precss": "^1.4.0",
		"pug": "^2.0.0-beta3",
		"pug-loader": "^2.3.0",
		"ress": "^1.1.1",
		"rimraf": "^2.5.4",
		"selenium-server": "2.53.1",
		"semver": "^5.3.0",
		"serialize-javascript": "^1.3.0",
		"shelljs": "^0.7.4",
		"style-loader": "^0.13.1",
		"stylus": "^0.54.5",
		"stylus-loader": "^2.1.1",
		"uglifyjs-webpack-plugin": "^0.4.6",
		"vue": "^2.4.1",
		"vue-loader": "^10.1.0",
		"vue-router": "^2.7.0",
		"vue-server-renderer": "^2.4.1",
		"vue-template-compiler": "^2.4.1",
		"webpack": "^3.2.0",
		"webpack-bundle-size-analyzer": "^2.7.0",
		"webpack-dev-server": "^2.6.1",
		"webpack-merge": "^4.1.0"
	},
	"dependencies": {},
	"engines": {
		"node": ">= 4.0.0",
		"npm": ">= 3.0.0"
	},
	"jest": {
		"verbose": false,
		"roots": [
			"<rootDir>/src"
		],
		"moduleFileExtensions": [
			"js",
			"vue"
		],
		"moduleDirectories": [
			"node_modules"
		],
		"moduleNameMapper": {
			"src/(.*)": "<rootDir>/src/$1"
		},
		"transform": {
			".*\\.(vue)$": "<rootDir>/node_modules/jest-vue-preprocessor",
			"\\.(styl)$": "<rootDir>/node_modules/jest-css-modules",
			".*\\.(vue|js)$": "<rootDir>/node_modules/babel-jest"
		},
		"transformIgnorePatterns": [
			"node_modules/(?!vue-router)"
		],
		"snapshotSerializers": [
			"jest-serializer-html"
		]
	}
};

/***/ }),
/* 32 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__alerts__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__app__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__avatars__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__bottom_nav__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__breadcrumbs__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__buttons__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__cards__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__carousel__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__chips__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__pickers__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__dialogs__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__dividers__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__expansion_panel__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__footer__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__grid__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__icons__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__lists__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__menus__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__navigation_drawer__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__toolbar__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__pagination__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__parallax__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__progress__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__selects__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__selection_controls__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__sliders__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__subheaders__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__steppers__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__tables__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__tabs__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__text_fields__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__transitions__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__snackbars__ = __webpack_require__(129);


































/* harmony default export */ __webpack_exports__["a"] = (Object.assign({}, __WEBPACK_IMPORTED_MODULE_0__alerts__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__app__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__avatars__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__bottom_nav__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__breadcrumbs__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__buttons__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__cards__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7__carousel__["a" /* default */], __WEBPACK_IMPORTED_MODULE_8__chips__["a" /* default */], __WEBPACK_IMPORTED_MODULE_9__pickers__["a" /* default */], __WEBPACK_IMPORTED_MODULE_10__dialogs__["a" /* default */], __WEBPACK_IMPORTED_MODULE_11__dividers__["a" /* default */], __WEBPACK_IMPORTED_MODULE_12__expansion_panel__["a" /* default */], __WEBPACK_IMPORTED_MODULE_13__footer__["a" /* default */], __WEBPACK_IMPORTED_MODULE_14__grid__["a" /* default */], __WEBPACK_IMPORTED_MODULE_15__icons__["a" /* default */], __WEBPACK_IMPORTED_MODULE_16__lists__["c" /* default */], __WEBPACK_IMPORTED_MODULE_17__menus__["a" /* default */], __WEBPACK_IMPORTED_MODULE_18__navigation_drawer__["a" /* default */], __WEBPACK_IMPORTED_MODULE_19__toolbar__["a" /* default */], __WEBPACK_IMPORTED_MODULE_20__pagination__["a" /* default */], __WEBPACK_IMPORTED_MODULE_21__parallax__["a" /* default */], __WEBPACK_IMPORTED_MODULE_22__progress__["a" /* default */], __WEBPACK_IMPORTED_MODULE_23__selects__["a" /* default */], __WEBPACK_IMPORTED_MODULE_24__selection_controls__["a" /* default */], __WEBPACK_IMPORTED_MODULE_25__sliders__["a" /* default */], __WEBPACK_IMPORTED_MODULE_26__subheaders__["a" /* default */], __WEBPACK_IMPORTED_MODULE_27__steppers__["a" /* default */], __WEBPACK_IMPORTED_MODULE_28__tables__["a" /* default */], __WEBPACK_IMPORTED_MODULE_29__tabs__["a" /* default */], __WEBPACK_IMPORTED_MODULE_30__text_fields__["a" /* default */], __WEBPACK_IMPORTED_MODULE_31__transitions__["d" /* default */], __WEBPACK_IMPORTED_MODULE_32__snackbars__["a" /* default */]));

/***/ }),
/* 33 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VAlert__ = __webpack_require__(34);


/* harmony default export */ __webpack_exports__["a"] = ({
  VAlert: __WEBPACK_IMPORTED_MODULE_0__VAlert__["a" /* default */]
});

/***/ }),
/* 34 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_contextualable__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_transitionable__ = __webpack_require__(35);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-alert',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_contextualable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_transitionable__["a" /* default */]],

  props: {
    dismissible: Boolean,
    hideIcon: Boolean,
    icon: String
  },

  computed: {
    classes: function classes() {
      return {
        'alert': true,
        'alert--dismissible': this.dismissible,
        'error': this.error,
        'info': this.info,
        'primary': this.primary,
        'secondary': this.secondary,
        'success': this.success,
        'warning': this.warning
      };
    },
    mdIcon: function mdIcon() {
      switch (true) {
        case !!this.icon:
          return this.icon;
        case this.error:
          return 'warning';
        case this.info:
          return 'info';
        case this.success:
          return 'check_circle';
        case this.warning:
          return 'priority_high';
      }
    }
  },

  render: function render(h) {
    var _this = this;

    var children = [h('div', this.$slots.default)];

    if (!this.hideIcon && this.mdIcon) {
      children.unshift(h('v-icon', {
        'class': 'alert__icon'
      }, this.mdIcon));
    }

    if (this.dismissible) {
      var close = h('a', {
        'class': 'alert__dismissible',
        domProps: { href: 'javascript:;' },
        on: { click: function click() {
            return _this.$emit('input', false);
          } }
      }, [h('v-icon', {
        props: { right: true }
      }, 'cancel')]);

      children.push(close);
    }

    var alert = h('div', {
      'class': this.classes,
      directives: [{
        name: 'show',
        value: this.isActive
      }],
      on: this.$listeners
    }, children);

    if (!this.transition) return alert;

    return h('transition', {
      props: {
        name: this.transition,
        origin: this.origin,
        mode: this.mode
      }
    }, [alert]);
  }
});

/***/ }),
/* 35 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    mode: String,
    origin: String,
    transition: String
  }
});

/***/ }),
/* 36 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VApp__ = __webpack_require__(37);


/* harmony default export */ __webpack_exports__["a"] = ({
  VApp: __WEBPACK_IMPORTED_MODULE_0__VApp__["a" /* default */]
});

/***/ }),
/* 37 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  props: {
    fixedFooter: Boolean,
    footer: Boolean,
    id: {
      type: String,
      default: 'app'
    },
    toolbar: Boolean
  },

  render: function render(h, _ref) {
    var props = _ref.props,
        data = _ref.data,
        children = _ref.children;

    data.staticClass = ('application ' + (data.staticClass || '')).trim();
    data.staticClass += ' application--' + (props.dark ? 'dark' : 'light');

    props.footer && (data.staticClass += ' application--footer');
    props.fixedFooter && (data.staticClass += ' application--footer-fixed');
    props.toolbar && (data.staticClass += ' application--toolbar');

    data.attrs = { 'data-app': true };
    data.domProps = { id: props.id };

    return h('div', data, children);
  }
});

/***/ }),
/* 38 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export VAvatar */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);


var VAvatar = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('avatar');

/* harmony default export */ __webpack_exports__["a"] = ({
  VAvatar: VAvatar
});

/***/ }),
/* 39 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VBottomNav__ = __webpack_require__(40);


/* harmony default export */ __webpack_exports__["a"] = ({
  VBottomNav: __WEBPACK_IMPORTED_MODULE_0__VBottomNav__["a" /* default */]
});

/***/ }),
/* 40 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  props: {
    absolute: Boolean,
    shift: Boolean,
    value: { required: false }
  },

  render: function render(h, _ref) {
    var data = _ref.data,
        props = _ref.props,
        children = _ref.children;

    data.staticClass = ('bottom-nav ' + (data.staticClass || '')).trim();

    if (props.absolute) data.staticClass += ' bottom-nav--absolute';
    if (props.shift) data.staticClass += ' bottom-nav--shift';
    if (props.value) data.staticClass += ' bottom-nav--active';

    return h('div', data, children);
  }
});

/***/ }),
/* 41 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VBreadcrumbs__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VBreadcrumbsItem__ = __webpack_require__(43);



/* harmony default export */ __webpack_exports__["a"] = ({
  VBreadcrumbs: __WEBPACK_IMPORTED_MODULE_0__VBreadcrumbs__["a" /* default */],
  VBreadcrumbsItem: __WEBPACK_IMPORTED_MODULE_1__VBreadcrumbsItem__["a" /* default */]
});

/***/ }),
/* 42 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-breadcrumbs',

  provide: function provide() {
    return {
      divider: this.divider
    };
  },


  props: {
    divider: {
      type: String,
      default: '/'
    },
    icons: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'breadcrumbs': true,
        'breadcrumbs--with-icons': this.icons
      };
    }
  },

  render: function render(h) {
    return h('ul', {
      'class': this.classes,
      props: { items: this.items }
    }, this.$slots.default);
  }
});

/***/ }),
/* 43 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_route_link__ = __webpack_require__(9);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-breadcrumbs-item',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_route_link__["a" /* default */]],

  inject: ['divider'],

  props: {
    activeClass: {
      type: String,
      default: 'breadcrumbs__item--active'
    }
  },

  computed: {
    classes: function classes() {
      var classes = _defineProperty({
        'breadcrumbs__item': true
      }, this.activeClass, !this.disabled);

      return classes;
    }
  },

  render: function render(h) {
    var _generateRouteLink = this.generateRouteLink(),
        tag = _generateRouteLink.tag,
        data = _generateRouteLink.data;

    return h('li', {
      attrs: { 'data-divider': this.divider }
    }, [h(tag, data, this.$slots.default)]);
  }
});

/***/ }),
/* 44 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VBtn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VBtnToggle__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VSpeedDial__ = __webpack_require__(46);




/* harmony default export */ __webpack_exports__["a"] = ({
  VBtn: __WEBPACK_IMPORTED_MODULE_0__VBtn__["a" /* default */],
  VBtnToggle: __WEBPACK_IMPORTED_MODULE_1__VBtnToggle__["a" /* default */],
  VSpeedDial: __WEBPACK_IMPORTED_MODULE_2__VSpeedDial__["a" /* default */]
});

/***/ }),
/* 45 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_buttons_VBtn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_icons_VIcon__ = __webpack_require__(3);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-btn-toggle',

  model: {
    prop: 'inputValue',
    event: 'change'
  },

  props: {
    inputValue: {
      required: false
    },
    items: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    mandatory: Boolean,
    multiple: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'btn-toggle': true,
        'btn-toggle--selected': this.inputValue && (!this.multiple || this.inputValue.length)
      };
    }
  },

  methods: {
    isSelected: function isSelected(item) {
      if (!this.multiple) {
        return this.inputValue === item.value;
      }

      return this.inputValue.includes(item.value);
    },
    updateValue: function updateValue(item) {
      if (!this.multiple) {
        if (this.mandatory && this.inputValue === item.value) return;
        return this.$emit('change', this.inputValue === item.value ? null : item.value);
      }

      var items = this.inputValue.slice();

      var i = items.indexOf(item.value);
      if (i > -1) {
        items.length >= 1 && !this.mandatory && items.splice(i, 1);
      } else {
        items.push(item.value);
      }

      this.$emit('change', items);
    }
  },

  render: function render(h) {
    var _this = this;

    var buttons = this.items.map(function (item, index) {
      var children = [];

      item.text && children.push(h('span', item.text));
      item.icon && children.push(h(__WEBPACK_IMPORTED_MODULE_1__components_icons_VIcon__["a" /* default */], item.icon));

      return h(__WEBPACK_IMPORTED_MODULE_0__components_buttons_VBtn__["a" /* default */], {
        key: index,
        props: {
          flat: true
        },
        on: {
          click: function click(e) {
            e.stopPropagation();
            _this.updateValue(item);
          }
        },
        attrs: {
          'data-selected': _this.isSelected(item),
          'data-index': index,
          'data-only-child': _this.isSelected(item) && (!_this.multiple || _this.inputValue.length === 1)
        }
      }, children);
    });

    return h('div', { class: this.classes }, buttons);
  }
});

/***/ }),
/* 46 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_toggleable__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_positionable__ = __webpack_require__(12);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-speed-dial',

  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_positionable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0__mixins_toggleable__["a" /* default */]],

  props: {
    direction: {
      type: String,
      default: 'top',
      validator: function validator(val) {
        return ['top', 'right', 'bottom', 'left'].includes(val);
      }
    },
    hover: Boolean,
    transition: {
      type: String,
      default: 'scale-transition'
    }
  },

  computed: {
    classes: function classes() {
      return _defineProperty({
        'speed-dial': true,
        'speed-dial--top': this.top,
        'speed-dial--right': this.right,
        'speed-dial--bottom': this.bottom,
        'speed-dial--left': this.left,
        'speed-dial--absolute': this.absolute,
        'speed-dial--fixed': this.fixed
      }, 'speed-dial--direction-' + this.direction, true);
    }
  },

  render: function render(h) {
    var _this = this;

    var children = [];
    var data = {
      'class': this.classes,
      directives: [{
        name: 'click-outside'
      }],
      on: {
        click: function click() {
          return _this.isActive = !_this.isActive;
        }
      }
    };

    if (this.hover) {
      data.on.mouseenter = function () {
        return _this.isActive = true;
      };
      data.on.mouseleave = function () {
        return _this.isActive = false;
      };
    }

    if (this.isActive) {
      children = (this.$slots.default || []).map(function (b, i) {
        b.key = i;

        return b;
      });
    }

    var list = h('transition-group', {
      'class': 'speed-dial__list',
      props: {
        name: this.transition,
        tag: 'div'
      }
    }, children);

    return h('div', data, [this.$slots.activator, list]);
  }
});

/***/ }),
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VCard__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VCardMedia__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__VCardTitle__ = __webpack_require__(49);





var VCardActions = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('card__actions');
var VCardText = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('card__text');

/* harmony default export */ __webpack_exports__["a"] = ({
  VCard: __WEBPACK_IMPORTED_MODULE_1__VCard__["a" /* default */],
  VCardActions: VCardActions,
  VCardMedia: __WEBPACK_IMPORTED_MODULE_2__VCardMedia__["a" /* default */],
  VCardText: VCardText,
  VCardTitle: __WEBPACK_IMPORTED_MODULE_3__VCardTitle__["a" /* default */]
});

/***/ }),
/* 48 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-card-media',

  props: {
    contain: Boolean,
    height: {
      type: [Number, String],
      default: 'auto'
    },
    src: {
      type: String
    }
  },

  render: function render(h) {
    var data = {
      'class': 'card__media',
      style: {
        height: !isNaN(this.height) ? this.height + 'px' : this.height
      },
      on: this.$listeners
    };

    var children = [];

    if (this.src) {
      children.push(h('div', {
        'class': 'card__media__background',
        style: {
          background: 'url(' + this.src + ') center center / ' + (this.contain ? 'contain' : 'cover') + ' no-repeat'
        }
      }));
    }

    children.push(h('div', {
      'class': 'card__media__content'
    }, this.$slots.default));

    return h('div', data, children);
  }
});

/***/ }),
/* 49 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  props: {
    primaryTitle: Boolean
  },

  render: function render(h, _ref) {
    var data = _ref.data,
        props = _ref.props,
        children = _ref.children;

    data.staticClass = ('card__title ' + (data.staticClass || '')).trim();

    if (props.primaryTitle) data.staticClass += ' card__title--primary';

    return h('div', data, children);
  }
});

/***/ }),
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VCarousel__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VCarouselItem__ = __webpack_require__(52);



/* harmony default export */ __webpack_exports__["a"] = ({
  VCarousel: __WEBPACK_IMPORTED_MODULE_0__VCarousel__["a" /* default */],
  VCarouselItem: __WEBPACK_IMPORTED_MODULE_1__VCarouselItem__["a" /* default */]
});

/***/ }),
/* 51 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_bootable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_buttons_VBtn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_icons_VIcon__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_themeable__ = __webpack_require__(1);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-carousel',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_bootable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_themeable__["a" /* default */]],

  data: function data() {
    return {
      current: null,
      items: [],
      slideInterval: {},
      reverse: false
    };
  },


  props: {
    cycle: {
      type: Boolean,
      default: true
    },
    icon: {
      type: String,
      default: 'fiber_manual_record'
    },
    interval: {
      type: Number,
      default: 6000
    },
    leftControlIcon: {
      type: [Boolean, String],
      default: 'chevron_left'
    },
    rightControlIcon: {
      type: [Boolean, String],
      default: 'chevron_right'
    }
  },

  computed: {
    defaultState: function defaultState() {
      return {
        current: null,
        reverse: false
      };
    }
  },

  watch: {
    current: function current() {
      var _this = this;

      // Evaluate items when current changes to account for
      // dynamic changing of children
      this.items = this.$children.filter(function (i) {
        return i.$el.classList && i.$el.classList.contains('carousel__item');
      });

      this.items.forEach(function (i) {
        return i.open(_this.items[_this.current]._uid, _this.reverse);
      });

      !this.isBooted && this.cycle && this.restartInterval();
      this.isBooted = true;
    },
    cycle: function cycle(val) {
      val && this.restartInterval() || clearInterval(this.slideInterval);
    }
  },

  mounted: function mounted() {
    this.init();
  },


  methods: {
    genControls: function genControls() {
      return this.$createElement('div', {
        staticClass: 'carousel__controls'
      }, this.genItems());
    },
    genIcon: function genIcon(direction, icon, fn) {
      if (!icon) return null;

      return this.$createElement('div', {
        staticClass: 'carousel__' + direction
      }, [this.$createElement(__WEBPACK_IMPORTED_MODULE_1__components_buttons_VBtn__["a" /* default */], {
        props: {
          icon: true,
          dark: this.dark || !this.light,
          light: this.light
        },
        on: { click: fn }
      }, [this.$createElement(__WEBPACK_IMPORTED_MODULE_2__components_icons_VIcon__["a" /* default */], icon)])]);
    },
    genItems: function genItems() {
      var _this2 = this;

      return this.items.map(function (item, index) {
        return _this2.$createElement(__WEBPACK_IMPORTED_MODULE_1__components_buttons_VBtn__["a" /* default */], {
          class: {
            'carousel__controls__item': true,
            'carousel__controls__item--active': index === _this2.current
          },
          props: {
            icon: true,
            dark: _this2.dark || !_this2.light,
            light: _this2.light
          },
          key: index,
          on: { click: _this2.select.bind(_this2, index) }
        }, [_this2.$createElement(__WEBPACK_IMPORTED_MODULE_2__components_icons_VIcon__["a" /* default */], _this2.icon)]);
      });
    },
    restartInterval: function restartInterval() {
      clearInterval(this.slideInterval);
      this.$nextTick(this.startInterval);
    },
    init: function init() {
      this.current = 0;
    },
    next: function next() {
      this.reverse = false;

      if (this.current + 1 === this.items.length) {
        return this.current = 0;
      }

      this.current++;
    },
    prev: function prev() {
      this.reverse = true;

      if (this.current - 1 < 0) {
        return this.current = this.items.length - 1;
      }

      this.current--;
    },
    select: function select(index) {
      this.reverse = index < this.current;
      this.current = index;
    },
    startInterval: function startInterval() {
      this.slideInterval = setInterval(this.next, this.interval);
    }
  },

  render: function render(h) {
    return h('div', {
      staticClass: 'carousel',
      directives: [{
        name: 'touch',
        value: {
          left: this.next,
          right: this.prev
        }
      }]
    }, [this.genIcon('left', this.leftControlIcon, this.prev), this.genIcon('right', this.rightControlIcon, this.next), this.genControls(), this.$slots.default]);
  }
});

/***/ }),
/* 52 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-carousel-item',

  data: function data() {
    return {
      active: false,
      reverse: false
    };
  },


  props: {
    src: {
      type: String,
      required: true
    },

    transition: {
      type: String,
      default: 'tab-transition'
    },

    reverseTransition: {
      type: String,
      default: 'tab-reverse-transition'
    }
  },

  computed: {
    computedTransition: function computedTransition() {
      return this.reverse ? this.reverseTransition : this.transition;
    },
    styles: function styles() {
      return {
        backgroundImage: 'url(' + this.src + ')'
      };
    }
  },

  methods: {
    open: function open(id, reverse) {
      this.active = this._uid === id;
      this.reverse = reverse;
    }
  },

  render: function render(h) {
    var item = h('div', {
      class: {
        'carousel__item': true,
        'reverse': this.reverse
      },
      style: this.styles,
      on: this.$listeners,
      directives: [{
        name: 'show',
        value: this.active
      }]
    }, [this.$slots.default]);

    return h('transition', { props: { name: this.computedTransition } }, [item]);
  }
});

/***/ }),
/* 53 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VChip__ = __webpack_require__(54);


/* harmony default export */ __webpack_exports__["a"] = ({
  VChip: __WEBPACK_IMPORTED_MODULE_0__VChip__["a" /* default */]
});

/***/ }),
/* 54 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_toggleable__ = __webpack_require__(2);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-chip',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_toggleable__["a" /* default */]],

  props: {
    close: Boolean,
    label: Boolean,
    outline: Boolean,
    small: Boolean,
    value: {
      type: Boolean,
      default: true
    }
  },

  computed: {
    classes: function classes() {
      return {
        'chip': true,
        'chip--label': this.label,
        'chip--outline': this.outline,
        'chip--small': this.small,
        'chip--removable': this.close
      };
    }
  },

  render: function render(h) {
    var _this = this;

    var children = [this.$slots.default];
    var data = {
      'class': this.classes,
      attrs: { tabindex: -1 },
      directives: [{
        name: 'show',
        value: this.isActive
      }],
      on: this.$listeners
    };

    if (this.close) {
      children.push(h('a', {
        'class': 'chip__close',
        domProps: { href: 'javascript:;' },
        on: {
          click: function click(e) {
            e.stopPropagation();

            _this.$emit('input', false);
          }
        }
      }, [h('v-icon', { props: { right: true } }, 'cancel')]));
    }

    return h('span', data, children);
  }
});

/***/ }),
/* 55 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VDatePicker__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VTimePicker__ = __webpack_require__(61);



/* harmony default export */ __webpack_exports__["a"] = ({
  VDatePicker: __WEBPACK_IMPORTED_MODULE_0__VDatePicker__["a" /* default */],
  VTimePicker: __WEBPACK_IMPORTED_MODULE_1__VTimePicker__["a" /* default */]
});

/***/ }),
/* 56 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_date_title__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_date_header__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_date_table__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_date_years__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_picker__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_helpers__ = __webpack_require__(0);







var defaultDateFormat = function defaultDateFormat(val) {
  return new Date(val).toISOString().substr(0, 10);
};

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-date-picker',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_date_title__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_date_header__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_date_table__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_date_years__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixins_picker__["a" /* default */]],

  data: function data() {
    return {
      tableDate: new Date(),
      originalDate: this.value,
      currentDay: null,
      currentMonth: null,
      currentYear: null,
      isSelected: false,
      isReversing: false,
      narrowDays: []
    };
  },


  props: {
    locale: {
      type: String,
      default: 'en-us'
    },
    dateFormat: {
      type: Function,
      default: defaultDateFormat
    },
    titleDateFormat: {
      type: Object,
      default: function _default() {
        return { weekday: 'short', month: 'short', day: 'numeric' };
      }
    },
    headerDateFormat: {
      type: Object,
      default: function _default() {
        return { month: 'long', year: 'numeric' };
      }
    },
    formattedValue: {
      required: false
    },
    allowedDates: {
      type: [Array, Object, Function],
      default: function _default() {
        return null;
      }
    },
    firstDayOfWeek: {
      type: [String, Number],
      default: 0
    },
    yearIcon: String
  },

  computed: {
    firstAllowedDate: function firstAllowedDate() {
      var date = new Date();
      date.setHours(12, 0, 0, 0);

      if (this.allowedDates) {
        var millisecondOffset = 1 * 24 * 60 * 60 * 1000;
        var valid = new Date(date);
        for (var i = 0; i < 31; i++) {
          if (this.isAllowed(valid)) return valid;

          valid.setTime(valid.getTime() + millisecondOffset);
        }
      }

      return date;
    },

    inputDate: {
      get: function get() {
        if (!this.value) return this.firstAllowedDate;
        if (this.value instanceof Date) return this.value;
        if (!isNaN(this.value) || typeof this.value === 'string' && this.value.indexOf(':') !== -1) return new Date(this.value);

        return new Date(this.value + 'T12:00:00');
      },
      set: function set(val) {
        this.$emit('input', val ? defaultDateFormat(val) : this.originalDate);
        this.$emit('update:formattedValue', val ? this.dateFormat(val) : this.dateFormat(this.originalDate));
      }
    },
    day: function day() {
      return this.inputDate.getDate();
    },
    month: function month() {
      return this.inputDate.getMonth();
    },
    year: function year() {
      return this.inputDate.getFullYear();
    },
    tableMonth: function tableMonth() {
      return this.tableDate.getMonth();
    },
    tableYear: function tableYear() {
      return this.tableDate.getFullYear();
    },
    computedTransition: function computedTransition() {
      return this.isReversing ? 'v-tab-reverse-transition' : 'v-tab-transition';
    }
  },

  watch: {
    isSelected: function isSelected(val) {
      var _this = this;

      val && this.$nextTick(function () {
        _this.$refs.years.scrollTop = _this.$refs.years.scrollHeight / 2 - 125;
      });
    },
    tableDate: function tableDate(val, prev) {
      this.isReversing = val < prev;
    },
    value: function value(val) {
      if (val) this.tableDate = this.inputDate;
    }
  },

  methods: {
    save: function save() {
      if (this.originalDate) {
        this.originalDate = this.value;
      } else {
        this.originalDate = this.inputDate;
      }

      if (this.$parent && this.$parent.isActive) this.$parent.isActive = false;
    },
    cancel: function cancel() {
      this.inputDate = this.originalDate;
      if (this.$parent && this.$parent.isActive) this.$parent.isActive = false;
    },
    isAllowed: function isAllowed(date) {
      if (!this.allowedDates) return true;

      if (Array.isArray(this.allowedDates)) {
        return !!this.allowedDates.find(function (allowedDate) {
          var d = new Date(allowedDate);
          d.setHours(12, 0, 0, 0);

          return d - date === 0;
        });
      } else if (this.allowedDates instanceof Function) {
        return this.allowedDates(date);
      } else if (this.allowedDates instanceof Object) {
        var min = new Date(this.allowedDates.min);
        min.setHours(12, 0, 0, 0);
        var max = new Date(this.allowedDates.max);
        max.setHours(12, 0, 0, 0);

        return date >= min && date <= max;
      }

      return true;
    }
  },

  created: function created() {
    var _this2 = this;

    var date = new Date();
    date.setDate(date.getDate() - date.getDay() + parseInt(this.firstDayOfWeek));

    Object(__WEBPACK_IMPORTED_MODULE_5__util_helpers__["c" /* createRange */])(7).forEach(function () {
      var narrow = date.toLocaleString(_this2.locale, { weekday: 'narrow' });
      _this2.narrowDays.push(narrow);

      date.setDate(date.getDate() + 1);
    });
  },
  mounted: function mounted() {
    this.currentDay = this.tableDate.getDate();
    this.currentMonth = this.tableDate.getMonth();
    this.currentYear = this.tableDate.getFullYear();
    this.tableDate = this.inputDate;
  },
  render: function render(h) {
    var children = [];

    !this.noTitle && children.push(this.genTitle());

    if (!this.isSelected) {
      var bodyChildren = [];

      bodyChildren.push(this.genHeader());
      bodyChildren.push(this.genTable());

      children.push(h('div', {
        'class': 'picker__body'
      }, bodyChildren));
    } else {
      children.push(this.genYears());
    }

    this.$scopedSlots.default && children.push(this.genSlot());

    return h('v-card', {
      'class': {
        'picker picker--date': true,
        'picker--landscape': this.landscape,
        'picker--dark': this.dark,
        'picker--light': this.light && !this.dark
      }
    }, children);
  }
});

/***/ }),
/* 57 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genYearIcon: function genYearIcon() {
      return this.yearIcon ? this.$createElement('v-icon', {
        props: {
          dark: true
        }
      }, this.yearIcon) : null;
    },
    genTitle: function genTitle() {
      var _this = this;

      var date = new Date(this.year, this.month, this.day);
      date = date.toLocaleString(this.locale, this.titleDateFormat);

      if (this.landscape) {
        if (date.indexOf(',') > -1) date = date.replace(',', ',<br>');else if (date.indexOf(' ') > -1) date = date.replace(' ', '<br>');
      }

      var text = this.$createElement('transition', {
        props: {
          name: 'slide-x-transition',
          mode: 'out-in'
        }
      }, [this.$createElement('div', {
        domProps: { innerHTML: date },
        key: date
      })]);

      return this.$createElement('div', {
        'class': 'picker__title'
      }, [this.$createElement('div', {
        'class': {
          'picker--date__title-year': true,
          'active': this.isSelected
        },
        on: {
          click: function click(e) {
            e.stopPropagation();
            _this.isSelected = true;
          }
        }
      }, [this.year, this.genYearIcon()]), this.$createElement('div', {
        'class': {
          'picker--date__title-date': true,
          'active': !this.isSelected
        },
        on: {
          click: function click(e) {
            e.stopPropagation();
            _this.isSelected = false;
          }
        }
      }, [text])]);
    }
  }
});

/***/ }),
/* 58 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genHeader: function genHeader() {
      return this.$createElement('div', {
        'class': 'picker--date__header'
      }, [this.genSelector()]);
    },
    genBtn: function genBtn(change, children) {
      var _this = this;

      return this.$createElement('v-btn', {
        props: {
          dark: this.dark,
          icon: true
        },
        nativeOn: {
          click: function click(e) {
            e.stopPropagation();
            _this.tableDate = new Date(_this.tableYear, change);
          }
        }
      }, children);
    },
    genSelector: function genSelector() {
      var date = new Date(this.tableYear, this.tableMonth);
      var header = this.$createElement('div', {
        'class': 'picker--date__header-selector-date'
      }, [this.$createElement(this.computedTransition, [this.$createElement('strong', {
        key: this.tableMonth
      }, date.toLocaleString(this.locale, this.headerDateFormat))])]);

      return this.$createElement('div', {
        'class': 'picker--date__header-selector'
      }, [this.genBtn(this.tableMonth - 1, [this.$createElement('v-icon', 'chevron_left')]), header, this.genBtn(this.tableMonth + 1, [this.$createElement('v-icon', 'chevron_right')])]);
    }
  }
});

/***/ }),
/* 59 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    wheelScroll: function wheelScroll(e) {
      e.preventDefault();

      var month = this.tableMonth;

      if (e.deltaY < 0) month++;else month--;

      this.tableDate = new Date(this.tableYear, month);
    },
    touch: function touch(value) {
      this.tableDate = new Date(this.tableYear, this.tableMonth + value);
    },
    genTable: function genTable() {
      var _this = this;

      var children = [];
      var data = {
        'class': 'picker--date__table',
        directives: [{
          name: 'touch',
          value: {
            left: function left(e) {
              return e.offsetX < -15 && _this.touch(1);
            },
            right: function right(e) {
              return e.offsetX > 15 && _this.touch(-1);
            }
          }
        }]
      };

      if (this.scrollable) {
        data.on = { wheel: this.wheelScroll };
      }

      children.push(this.$createElement('table', {
        key: this.tableMonth
      }, [this.genTHead(), this.genTBody()]));

      return this.$createElement('div', data, [this.$createElement(this.computedTransition, children)]);
    },
    genTHead: function genTHead() {
      var _this2 = this;

      var days = this.narrowDays.map(function (day) {
        return _this2.$createElement('th', day);
      });
      return this.$createElement('thead', this.genTR(days));
    },
    genTBody: function genTBody() {
      var _this3 = this;

      var children = [];
      var rows = [];
      var length = new Date(this.tableYear, this.tableMonth + 1, 0).getDate();

      var day = new Date(this.tableYear, this.tableMonth).getDay() - parseInt(this.firstDayOfWeek);

      for (var i = 0; i < day; i++) {
        rows.push(this.$createElement('td'));
      }

      var _loop = function _loop(_i) {
        var date = new Date(_this3.tableYear, _this3.tableMonth, _i, 12, 0, 0, 0);
        rows.push(_this3.$createElement('td', [_this3.$createElement('button', {
          'class': {
            'btn btn--floating btn--small btn--flat': true,
            'btn--active': _this3.isActive(_i),
            'btn--current': _this3.isCurrent(_i),
            'btn--light': _this3.dark,
            'btn--disabled': !_this3.isAllowed(date)
          },
          attrs: {
            type: 'button'
          },
          domProps: {
            innerHTML: '<span class="btn__content">' + _i + '</span>'
          },
          on: {
            click: function click() {
              var day = _i < 10 ? '0' + _i : _i;
              var tableYear = _this3.tableYear;
              var tableMonth = _this3.tableMonth + 1;
              tableMonth = tableMonth < 10 ? '0' + tableMonth : tableMonth;

              _this3.inputDate = tableYear + '-' + tableMonth + '-' + day + 'T12:00:00';
              _this3.$nextTick(function () {
                return _this3.autosave && _this3.save();
              });
            }
          }
        })]));

        if (rows.length % 7 === 0) {
          children.push(_this3.genTR(rows));
          rows = [];
        }
      };

      for (var _i = 1; _i <= length; _i++) {
        _loop(_i);
      }

      if (rows.length) {
        children.push(this.genTR(rows));
      }

      children.length < 6 && children.push(this.genTR([this.$createElement('td', { domProps: { innerHTML: '&nbsp;' } })]));

      return this.$createElement('tbody', children);
    },
    genTR: function genTR() {
      var children = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      return [this.$createElement('tr', data, children)];
    },
    isActive: function isActive(i) {
      return this.tableYear === this.year && this.tableMonth === this.month && this.day === i;
    },
    isCurrent: function isCurrent(i) {
      return this.currentYear === this.tableYear && this.currentMonth === this.tableMonth && this.currentDay === i;
    }
  }
});

/***/ }),
/* 60 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genYears: function genYears() {
      return this.$createElement('ul', {
        'class': 'picker--date__years',
        ref: 'years'
      }, this.genYearItems());
    },
    genYearItems: function genYearItems() {
      var _this = this;

      var children = [];

      var _loop = function _loop(i, length) {
        children.push(_this.$createElement('li', {
          'class': {
            active: _this.year === i
          },
          on: {
            click: function click(e) {
              e.stopPropagation();

              var tableMonth = _this.tableMonth + 1;
              var day = _this.day;
              tableMonth = tableMonth < 10 ? '0' + tableMonth : tableMonth;
              day = day < 10 ? '0' + day : day;

              _this.inputDate = i + '-' + tableMonth + '-' + day;
              _this.isSelected = false;
            }
          }
        }, i));
      };

      for (var i = this.year + 100, length = this.year - 100; i > length; i--) {
        _loop(i, length);
      }
      return children;
    }
  }
});

/***/ }),
/* 61 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_picker__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_time_title__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_time_body__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_helpers__ = __webpack_require__(0);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-time-picker',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_picker__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_time_body__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_time_title__["a" /* default */]],

  data: function data() {
    return {
      isDragging: false,
      rotate: 0,
      originalTime: this.value,
      period: 'am',
      selectingHour: true,
      ranges: {
        hours: Object(__WEBPACK_IMPORTED_MODULE_3__util_helpers__["c" /* createRange */])(24),
        minutes: Object(__WEBPACK_IMPORTED_MODULE_3__util_helpers__["c" /* createRange */])(60)
      }
    };
  },


  props: {
    format: {
      type: String,
      default: 'ampm',
      validator: function validator(val) {
        return ['ampm', '24hr'].includes(val);
      }
    },
    allowedHours: {
      type: [Array, Object, Function],
      default: function _default() {
        return null;
      }
    },
    allowedMinutes: {
      type: [Array, Object, Function],
      default: function _default() {
        return null;
      }
    }
  },

  computed: {
    is24hr: function is24hr() {
      return this.format !== 'ampm';
    },
    is24hrAfter12: function is24hrAfter12() {
      return this.selectingHour && this.is24hr && this.hour >= 12;
    },
    divider: function divider() {
      return this.selectingHour ? 12 : 60;
    },
    degrees: function degrees() {
      return this.degreesPerUnit * Math.PI / 180;
    },
    degreesPerUnit: function degreesPerUnit() {
      return 360 / this.divider;
    },

    inputTime: {
      get: function get() {
        if (this.value && !(this.value instanceof Date)) {
          if (!this.is24hr) {
            this.period = this.value.match(/pm/) ? 'pm' : 'am';
          }

          return this.value;
        }
        var value = new Date();

        if (this.value instanceof Date) {
          value = this.value;
        }

        var hour = value.getHours();
        var minute = value.getMinutes();
        var period = '';

        if (!this.is24hr) {
          hour = hour > 12 ? hour - 12 : hour;
          period = hour > 12 ? 'pm' : 'am';
        }

        period && (this.period = period);

        hour = this.firstAllowed('hour', hour);
        minute = this.firstAllowed('minute', minute);

        return hour + ':' + minute + period;
      },
      set: function set(val) {
        return this.$emit('input', val);
      }
    },
    timeArray: function timeArray() {
      return this.inputTime.replace(/(am|pm)/, '').split(':');
    },

    hour: {
      get: function get() {
        return parseInt(this.timeArray[0]);
      },
      set: function set(val) {
        if (!this.is24hr) {
          val = val > 12 ? val - 12 : val < 1 ? 12 : val;
        } else {
          val = val < 10 ? '0' + val : val > 23 ? '00' : val;
        }

        this.inputTime = val + ':' + this.minute + (!this.is24hr ? this.period : '');
      }
    },
    minute: {
      get: function get() {
        var minute = parseInt(this.timeArray[1]);

        return minute < 10 ? '0' + minute : minute > 59 ? '00' : minute;
      },
      set: function set(val) {
        val = val < 10 ? '0' + parseInt(val) : val > 59 ? '00' : val;
        var hour = this.hour;

        if (this.is24hr && hour < 10) {
          hour = '0' + hour;
        }

        this.inputTime = hour + ':' + val + (!this.is24hr ? this.period : '');
      }
    },
    clockHand: function clockHand() {
      if (this.selectingHour) return this.degreesPerUnit * this.hour;
      return this.degreesPerUnit * this.minute;
    },
    radius: function radius() {
      return this.clockSize / 2;
    },

    clockSize: {
      get: function get() {
        return this.size;
      },
      set: function set(val) {
        this.size = val;
      }
    },
    size: function size() {
      return this.landscape ? 250 : 280;
    }
  },

  watch: {
    period: function period(val) {
      var hour = !!this.allowedHours && this.selectingHour ? this.firstAllowed('hour', this.hour - 1) : this.hour;
      this.inputTime = hour + ':' + this.minute + val;
    },
    value: function value(val) {
      if (this.isSaving) {
        this.originalTime = this.inputTime;
        this.isSaving = false;
      }
    }
  },

  methods: {
    save: function save() {
      if (this.originalTime) {
        this.originalTime = this.value;
      } else {
        this.inputTime = this.inputTime;
        this.originalTime = this.inputTime;
      }

      if (this.$parent && this.$parent.isActive) this.$parent.isActive = false;
    },
    cancel: function cancel() {
      this.inputTime = this.originalTime;
      if (this.$parent && this.$parent.isActive) this.$parent.isActive = false;
    },
    isAllowed: function isAllowed(type, value) {
      var allowed = this['allowed' + (type.charAt(0).toUpperCase() + type.slice(1)) + 's'];

      if (!allowed) return true;

      if (Array.isArray(allowed)) {
        return !!allowed.find(function (v) {
          return v === value;
        });
      } else if (allowed instanceof Function) {
        return allowed(value);
      } else if (allowed === Object(allowed)) {
        var range = type === 'minute' ? this.ranges.minutes : this.ranges.hours;
        var mod = type === 'minute' ? 60 : 24;

        if (allowed.min === String(allowed.min)) {
          allowed.min = this.convert12to24hr(allowed.min);
        }

        if (allowed.max === String(allowed.max)) {
          allowed.max = this.convert12to24hr(allowed.max);
        }

        var steps = allowed.max - allowed.min;
        value = type === 'hour' && !this.is24hr && this.period === 'pm' ? value + 12 : value;

        for (var i = 0; i <= steps; i++) {
          var index = (allowed.min + i) % mod;
          if (range[index] === value) return true;
        }

        return false;
      }

      return true;
    },
    convert12to24hr: function convert12to24hr(input) {
      input = input.toLowerCase();
      var pm = input.indexOf('pm') !== -1;
      var hour = parseInt(input.slice(0, input.indexOf(pm ? 'pm' : 'am')));

      return pm ? hour + 12 : hour;
    },
    generateRange: function generateRange(type, start) {
      var range = type === 'hour' ? this.ranges.hours : this.ranges.minutes;
      var offset = 1;

      if (type === 'hour' && !this.is24hr) {
        range = range.slice(1, 13);
        offset = 0;
      }

      return range.slice(start + offset, range.length).concat(range.slice(0, start + offset));
    },
    firstAllowed: function firstAllowed(type, value) {
      var _this = this;

      var allowed = this['allowed' + (type.charAt(0).toUpperCase() + type.slice(1)) + 's'];

      if (!allowed) return value;

      var range = this.generateRange(type, value);

      var first = range.find(function (v) {
        return _this.isAllowed(type, v);
      });

      return first || value;
    }
  },

  render: function render(h) {
    var children = [this.genBody()];

    !this.noTitle && children.unshift(this.genTitle());
    this.$scopedSlots.default && children.push(this.genSlot());

    return h('v-card', {
      'class': {
        'picker picker--time': true,
        'picker--landscape': this.landscape,
        'picker--dark': this.dark,
        'picker--light': this.light && !this.dark,
        'picker--time--hours': this.selectingHour
      }
    }, children);
  }
});

/***/ }),
/* 62 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genTitle: function genTitle() {
      var children = [this.genTime()];

      if (this.format === 'ampm') {
        children.push(this.genAMPM());
      }

      return this.$createElement('div', {
        'class': 'picker__title'
      }, children);
    },
    genTime: function genTime() {
      var _this = this;

      var hour = this.hour;

      if (this.is24hr && hour < 10) {
        hour = '0' + hour;
      }

      return this.$createElement('div', {
        'class': 'picker--time__title'
      }, [this.$createElement('span', {
        'class': { active: this.selectingHour },
        on: {
          click: function click() {
            return _this.selectingHour = true;
          }
        }
      }, hour), this.$createElement('span', {
        'class': { active: !this.selectingHour },
        on: {
          click: function click() {
            return _this.selectingHour = false;
          }
        }
      }, ':' + this.minute)]);
    },
    genAMPM: function genAMPM() {
      return this.$createElement('div', [this.genPeriod('am'), this.genPeriod('pm')]);
    },
    genPeriod: function genPeriod(period) {
      var _this2 = this;

      return this.$createElement('span', {
        'class': { active: this.period === period },
        on: { click: function click() {
            return _this2.period = period;
          } }
      }, period.toUpperCase());
    }
  }
});

/***/ }),
/* 63 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      hasChanged: false
    };
  },

  methods: {
    genBody: function genBody() {
      var _this = this;

      var children = [this.genHand(this.selectingHour ? 'hour' : 'minute')];
      var data = {
        'class': 'picker--time__clock',
        on: {
          mousedown: this.onMouseDown,
          mouseup: this.onMouseUp,
          mouseleave: function mouseleave() {
            _this.isDragging && _this.onMouseUp();
          },
          touchstart: this.onMouseDown,
          touchend: this.onMouseUp,
          mousemove: this.onDragMove,
          touchmove: this.onDragMove
        },
        key: this.selectingHour ? 'hour' : 'minute',
        ref: 'clock'
      };

      this.selectingHour && children.push(this.genHours()) || children.push(this.genMinutes());

      if (this.scrollable) {
        data.on.wheel = function (e) {
          e.preventDefault();

          var diff = e.wheelDelta > 0 ? 1 : -1;
          var changing = _this.selectingHour ? 'changeHour' : 'changeMinute';

          _this[changing](diff);
        };
      }

      return this.$createElement('div', {
        'class': 'picker__body'
      }, [this.$createElement('v-fade-transition', {
        props: { mode: 'out-in' }
      }, [this.$createElement('div', data, children)])]);
    },
    genHand: function genHand(type) {
      var scale = this.is24hrAfter12 ? 'scaleY(0.6)' : '';
      return [this.$createElement('div', {
        'class': 'picker--time__clock-hand ' + type,
        style: {
          transform: 'rotate(' + this.clockHand + 'deg) ' + scale
        }
      })];
    },
    genHours: function genHours() {
      var hours = this.is24hr ? 24 : 12;
      var children = [];
      var start = 0;

      if (hours === 12) {
        hours++;
        start = 1;
      }

      for (var i = start; i < hours; i++) {
        children.push(this.$createElement('span', {
          'class': {
            'active': i === this.hour,
            'disabled': !this.isAllowed('hour', i)
          },
          style: this.getTransform(i),
          domProps: { innerHTML: '<span>' + i + '</span>' }
        }));
      }

      return children;
    },
    genMinutes: function genMinutes() {
      var children = [];

      for (var i = 0; i < 60; i = i + 5) {
        var num = i;

        if (num < 10) num = '0' + num;
        if (num === 60) num = '00';

        children.push(this.$createElement('span', {
          'class': {
            'active': num.toString() === this.minute.toString(),
            'disabled': !this.isAllowed('minute', i)
          },
          style: this.getTransform(i),
          domProps: { innerHTML: '<span>' + num + '</span>' }
        }));
      }

      return children;
    },
    getTransform: function getTransform(i) {
      var _getPosition = this.getPosition(i),
          x = _getPosition.x,
          y = _getPosition.y;

      return { transform: 'translate(' + x + 'px, ' + y + 'px)' };
    },
    getPosition: function getPosition(i) {
      var radiusPercentage = this.selectingHour && this.is24hr && i >= 12 ? 0.5 : 0.8;
      var r = this.radius * radiusPercentage;
      i = this.selectingHour && this.is24hr ? i % 12 : i;
      return {
        x: Math.round(Math.sin(i * this.degrees) * r),
        y: Math.round(-Math.cos(i * this.degrees) * r)
      };
    },
    changeHour: function changeHour(time) {
      var _this2 = this;

      var range = this.generateRange('hour', this.hour);

      time < 0 && (range = range.reverse().slice(1));
      this.hour = range.find(function (h) {
        return _this2.allowedHours ? _this2.isAllowed('hour', h) : true;
      });

      return true;
    },
    changeMinute: function changeMinute(time) {
      var _this3 = this;

      var current = Number(this.minute);
      var range = this.generateRange('minute', current);

      time < 0 && (range = range.reverse().slice(1));
      var minute = range.find(function (m) {
        return _this3.allowedMinutes ? _this3.isAllowed('minute', m) : true;
      });

      this.minute = minute < 10 ? '0' + minute : minute;

      return true;
    },
    onMouseDown: function onMouseDown(e) {
      e.preventDefault();

      this.isDragging = true;
      this.onDragMove(e);
    },
    onMouseUp: function onMouseUp() {
      this.isDragging = false;
      !this.selectingHour && this.autosave && this.save();
      if (this.hasChanged) {
        this.selectingHour = false;
        this.hasChanged = false;
      }
    },
    onDragMove: function onDragMove(e) {
      e.preventDefault();
      if (!this.isDragging && e.type !== 'click') return;

      var rect = this.$refs.clock.getBoundingClientRect();
      var center = { x: rect.width / 2, y: 0 - rect.width / 2 };
      var clientY = 'touches' in e ? e.touches[0].clientY : e.clientY;
      var clientX = 'touches' in e ? e.touches[0].clientX : e.clientX;
      var coords = {
        y: rect.top - clientY,
        x: clientX - rect.left
      };

      var selecting = this.selectingHour ? 'hour' : 'minute';
      var value = Math.round(this.angle(center, coords) / this.degreesPerUnit);

      if (this.selectingHour && this.is24hr) {
        var insideClick = this.euclidean(center, coords) / this.radius < 0.65;
        value = insideClick ? value + 12 : value;

        // Necessary to fix edge case when selecting left part of 0 and 12
        value = this.angle(center, coords) >= 345 ? (value + 12) % 24 : value;
      }

      if (this.isAllowed(selecting, value)) {
        this[selecting] = value;
        this.hasChanged = true;
      }
    },
    euclidean: function euclidean(p0, p1) {
      var dx = Math.abs(p1.x - p0.x);
      var dy = Math.abs(p1.y - p0.y);

      return Math.sqrt(dx * dx + dy * dy);
    },
    angle: function angle(center, p1) {
      var p0 = {
        x: center.x,
        y: center.y + Math.sqrt(Math.abs(p1.x - center.x) * Math.abs(p1.x - center.x) + Math.abs(p1.y - center.y) * Math.abs(p1.y - center.y))
      };

      var value = 2 * Math.atan2(p1.y - p0.y, p1.x - p0.x);
      return Math.abs(value * 180 / Math.PI);
    }
  }
});

/***/ }),
/* 64 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VDialog__ = __webpack_require__(65);


/* harmony default export */ __webpack_exports__["a"] = ({
  VDialog: __WEBPACK_IMPORTED_MODULE_0__VDialog__["a" /* default */]
});

/***/ }),
/* 65 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_bootable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_detachable__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_overlayable__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_toggleable__ = __webpack_require__(2);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-dialog',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_bootable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_detachable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_overlayable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_toggleable__["a" /* default */]],

  props: {
    disabled: Boolean,
    persistent: Boolean,
    fullscreen: Boolean,
    fullWidth: Boolean,
    lazy: Boolean,
    origin: {
      type: String,
      default: 'center center'
    },
    width: {
      type: [String, Number],
      default: 290
    },
    scrollable: Boolean,
    transition: {
      type: [String, Boolean],
      default: 'dialog-transition'
    }
  },

  computed: {
    classes: function classes() {
      return {
        'dialog': true,
        'dialog--active': this.isActive,
        'dialog--persistent': this.persistent,
        'dialog--fullscreen': this.fullscreen,
        'dialog--stacked-actions': this.stackedActions && !this.fullscreen,
        'dialog--scrollable': this.scrollable
      };
    }
  },

  watch: {
    isActive: function isActive(val) {
      if (val) {
        !this.fullscreen && !this.hideOverlay && this.genOverlay();
        this.fullscreen && this.hideScroll();
      } else {
        if (!this.fullscreen) this.removeOverlay();else this.showScroll();
      }
    }
  },

  mounted: function mounted() {
    var _this = this;

    this.isBooted = this.isActive;
    this.$vuetify.load(function () {
      return _this.isActive && _this.genOverlay();
    });
  },


  methods: {
    closeConditional: function closeConditional(e) {
      // close dialog if !persistent and clicked outside
      return !this.persistent;
    }
  },

  render: function render(h) {
    var _this2 = this;

    var children = [];
    var data = {
      'class': this.classes,
      ref: 'dialog',
      directives: [{ name: 'click-outside', value: this.closeConditional }, { name: 'show', value: this.isActive }]
    };

    if (!this.fullscreen) {
      data.style = {
        width: isNaN(this.width) ? this.width : this.width + 'px'
      };
    }

    if (this.$slots.activator) {
      children.push(h('div', {
        'class': 'dialog__activator',
        on: {
          click: function click(e) {
            e.stopPropagation();
            if (!_this2.disabled) _this2.isActive = !_this2.isActive;
          }
        }
      }, [this.$slots.activator]));
    }

    var dialog = h('transition', {
      props: {
        name: this.transition || '', // If false, show nothing
        origin: this.origin
      }
    }, [h('div', data, this.showLazyContent(this.$slots.default))]);

    children.push(h('div', {
      'class': ('dialog__content ' + this.contentClass).trim(),
      ref: 'content'
    }, [dialog]));

    return h('div', {
      'class': 'dialog__container',
      style: {
        display: !this.$slots.activator && 'none' || this.fullWidth ? 'block' : 'inline-block'
      }
    }, children);
  }
});

/***/ }),
/* 66 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VDivider__ = __webpack_require__(67);


/* harmony default export */ __webpack_exports__["a"] = ({
  VDivider: __WEBPACK_IMPORTED_MODULE_0__VDivider__["a" /* default */]
});

/***/ }),
/* 67 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  props: {
    inset: Boolean
  },

  render: function render(h, _ref) {
    var props = _ref.props,
        data = _ref.data,
        children = _ref.children;

    data.staticClass = ('divider ' + (data.staticClass || '')).trim();

    if (props.dark) data.staticClass += ' theme--dark';
    if (props.inset) data.staticClass += ' divider--inset';
    if (props.light) data.staticClass += ' theme--light';

    return h('hr', data);
  }
});

/***/ }),
/* 68 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VExpansionPanel__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VExpansionPanelContent__ = __webpack_require__(70);



/* harmony default export */ __webpack_exports__["a"] = ({
  VExpansionPanel: __WEBPACK_IMPORTED_MODULE_0__VExpansionPanel__["a" /* default */],
  VExpansionPanelContent: __WEBPACK_IMPORTED_MODULE_1__VExpansionPanelContent__["a" /* default */]
});

/***/ }),
/* 69 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-expansion-panel',

  props: {
    expand: Boolean
  },

  computed: {
    params: function params() {
      return {
        expand: this.expand
      };
    }
  },

  render: function render(h) {
    return h('ul', {
      'class': 'expansion-panel'
    }, this.$slots.default);
  }
});

/***/ }),
/* 70 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_transitions__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__ = __webpack_require__(2);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-expansion-panel-content',

  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__["a" /* default */]],

  data: function data() {
    return {
      height: 'auto'
    };
  },


  props: {
    ripple: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'expansion-panel__header': true,
        'expansion-panel__header--active': this.isActive
      };
    }
  },

  methods: {
    closeConditional: function closeConditional(e) {
      return this.$parent.$el.contains(e.target) && !this.$parent.expand && !this.$el.contains(e.target);
    },
    toggle: function toggle() {
      this.isActive = !this.isActive;
    },
    genHeader: function genHeader(h) {
      var _this = this;

      return h('div', {
        class: this.classes,
        directives: [{
          name: 'click-outside',
          value: this.closeConditional
        }, {
          name: 'ripple',
          value: this.ripple
        }],
        on: {
          click: function click() {
            _this.isActive = !_this.isActive;
          }
        }
      }, [this.$slots.header]);
    },
    genBody: function genBody(h) {
      return h('div', {
        ref: 'body',
        class: 'expansion-panel__body',
        directives: [{
          name: 'show',
          value: this.isActive
        }]
      }, [this.$slots.default]);
    }
  },

  render: function render(h) {
    var children = [];

    this.$slots.header && children.push(this.genHeader(h));
    children.push(h(__WEBPACK_IMPORTED_MODULE_0__components_transitions__["a" /* VExpandTransition */], [this.genBody(h)]));

    return h('li', children);
  }
});

/***/ }),
/* 71 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);


/* harmony default export */ __webpack_exports__["a"] = ({
  enter: function enter(el, done) {
    // Remove initial transition
    el.style.transition = 'none';
    Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["a" /* addOnceEventListener */])(el, 'transitionend', done);

    // Get height that is to be scrolled
    el.style.overflow = 'hidden';
    el.style.height = null;
    el.style.display = 'block';
    var height = el.clientHeight + 'px';
    el.style.height = 0;
    el.style.transition = null;

    setTimeout(function () {
      return el.style.height = height;
    }, 50);
  },
  afterEnter: function afterEnter(el) {
    el.style.height = 'auto';
    el.style.overflow = null;
  },
  leave: function leave(el, done) {
    // Remove initial transition
    el.style.transition = 'none';
    Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["a" /* addOnceEventListener */])(el, 'transitionend', done);

    // Set height before we transition to 0
    el.style.overflow = 'hidden';
    el.style.height = el.clientHeight + 'px';
    el.style.transition = null;

    setTimeout(function () {
      return el.style.height = 0;
    }, 50);
  }
});

/***/ }),
/* 72 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VFooter__ = __webpack_require__(73);


/* harmony default export */ __webpack_exports__["a"] = ({
  VFooter: __WEBPACK_IMPORTED_MODULE_0__VFooter__["a" /* default */]
});

/***/ }),
/* 73 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  props: {
    absolute: Boolean,
    fixed: Boolean
  },

  render: function render(h, _ref) {
    var data = _ref.data,
        props = _ref.props,
        children = _ref.children;

    data.staticClass = ('footer ' + (data.staticClass || '')).trim();

    if (props.absolute) data.staticClass += ' footer--absolute';
    if (props.fixed) data.staticClass += ' footer--fixed';

    return h('footer', data, children);
  }
});

/***/ }),
/* 74 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);


var Grid = function Grid(name) {
  return {
    functional: true,

    props: {
      id: String
    },

    render: function render(h, _ref) {
      var props = _ref.props,
          data = _ref.data,
          children = _ref.children;

      data.staticClass = (name + ' ' + (data.staticClass || '')).trim();

      if (data.attrs) {
        data.staticClass += ' ' + Object.keys(data.attrs).join(' ');
        delete data.attrs;
      }

      if (props.id) {
        data.domProps = data.domProps || {};
        data.domProps.id = props.id;
      }

      return h('div', data, children);
    }
  };
};

var VContainer = Grid('container');
var VFlex = Grid('flex');
var VLayout = Grid('layout');
var VSpacer = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('spacer');

/* harmony default export */ __webpack_exports__["a"] = ({
  VContainer: VContainer,
  VFlex: VFlex,
  VLayout: VLayout,
  VSpacer: VSpacer
});

/***/ }),
/* 75 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VIcon__ = __webpack_require__(3);


/* harmony default export */ __webpack_exports__["a"] = ({
  VIcon: __WEBPACK_IMPORTED_MODULE_0__VIcon__["a" /* default */]
});

/***/ }),
/* 76 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_transitions__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__ = __webpack_require__(2);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-list-group',

  inject: ['listClick', 'listClose'],

  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__["a" /* default */]],

  data: function data() {
    return {
      isBooted: this.value
    };
  },


  props: {
    group: String,
    lazy: Boolean,
    noAction: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'list--group__header': true,
        'list--group__header--active': this.isActive,
        'list--group__header--no-action': this.noAction
      };
    }
  },

  watch: {
    isActive: function isActive() {
      this.isBooted = true;

      if (!this.isActive) {
        this.listClose(this._uid);
      }
    },
    $route: function $route(to) {
      var isActive = this.matchRoute(to.path);

      if (this.group) {
        if (isActive && this.isActive !== isActive) {
          this.listClick(this._uid);
        }
        this.isActive = isActive;
      }
    }
  },

  mounted: function mounted() {
    if (this.group) {
      this.isActive = this.matchRoute(this.$route.path);
    }

    if (this.isActive) {
      this.listClick(this._uid);
    }
  },


  methods: {
    click: function click() {
      var _this = this;

      if (!this.$refs.item.querySelector('.list__tile--disabled')) {
        requestAnimationFrame(function () {
          return _this.listClick(_this._uid);
        });
      }
    },
    toggle: function toggle(uid) {
      this.isActive = this._uid === uid;
    },
    matchRoute: function matchRoute(to) {
      if (!this.group) return false;
      return to.match(this.group) !== null;
    }
  },

  render: function render(h) {
    var group = h('ul', {
      'class': 'list list--group',
      directives: [{
        name: 'show',
        value: this.isActive
      }],
      ref: 'group'
    }, [this.lazy && !this.isBooted ? null : this.$slots.default]);

    var item = h('div', {
      'class': this.classes,
      on: Object.assign({}, { click: this.click }, this.$listeners),
      ref: 'item'
    }, [this.$slots.item]);

    var transition = h(__WEBPACK_IMPORTED_MODULE_0__components_transitions__["a" /* VExpandTransition */], [group]);

    return h('div', { 'class': 'list--group__container' }, [item, transition]);
  }
});

/***/ }),
/* 77 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);


function directive(el, binding) {
  var config = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["f" /* directiveConfig */])(binding, {
    icon: false,
    left: false,
    bottom: false,
    overlap: false,
    visible: true
  });

  if (!config.visible || binding.expression && !binding.value) {
    return unbind(el);
  }

  if (config.overlap) el.classList.add('badge--overlap');
  if (config.icon) el.classList.add('badge--icon');
  if (config.left) el.classList.add('badge--left');
  if (config.bottom) el.classList.add('badge--bottom');

  el.dataset.badge = config.value;
  el.classList.add('badge');
}

function unbind(el) {
  el.removeAttribute('data-badge');
  el.classList.remove('badge');
}

/* harmony default export */ __webpack_exports__["a"] = ({
  bind: directive,
  updated: directive,
  componentUpdated: directive,
  unbind: unbind
});

/***/ }),
/* 78 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function inserted(el, binding) {
  var debounce = function debounce(cb) {
    return setTimeout(cb, 50);
  };
  var onResize = function onResize() {
    clearTimeout(debounce);
    debounce(binding.value);
  };

  window.addEventListener('resize', onResize, { passive: true });
  el._onResize = onResize;
}

function unbind(el, binding) {
  window.removeEventListener('resize', el._onResize);
}

/* harmony default export */ __webpack_exports__["a"] = ({
  inserted: inserted,
  unbind: unbind
});

/***/ }),
/* 79 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function inserted(el, binding) {
  var callback = typeof binding.value === 'function' ? binding.value : binding.value.callback;
  var options = binding.value.options || { passive: true };
  var target = binding.value.target || window;
  if (target === 'undefined') return;

  if (target !== window) {
    target = document.querySelector(target);
  }

  target.addEventListener('scroll', callback, options);

  el._onScroll = {
    target: target,
    options: options
  };
}

function unbind(el, binding) {
  var _el$_onScroll = el._onScroll,
      target = _el$_onScroll.target,
      options = _el$_onScroll.options;


  target.removeEventListener('scroll', binding.callback, options);
}

/* harmony default export */ __webpack_exports__["a"] = ({
  inserted: inserted,
  unbind: unbind
});

/***/ }),
/* 80 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);


function directive(el, binding) {
  var config = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["f" /* directiveConfig */])(binding, {
    top: true,
    visible: true
  });

  if (!config.visible || binding.expression && !binding.value) {
    return unbind(el);
  }

  unbind(el, binding, config);

  el.dataset.tooltip = config.html;
  el.dataset['tooltipLocation'] = config.value;
}

function unbind(el) {
  el.removeAttribute('data-tooltip');
  el.removeAttribute('data-tooltip-location');
}

/* harmony default export */ __webpack_exports__["a"] = ({
  bind: directive,
  updated: directive,
  componentUpdated: directive,
  unbind: unbind
});

/***/ }),
/* 81 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var touchstart = function touchstart(event, wrapper) {
  var touch = event.changedTouches[0];
  wrapper.touchstartX = touch.clientX;
  wrapper.touchstartY = touch.clientY;

  wrapper.start && wrapper.start(Object.assign(event, wrapper));
};

var touchend = function touchend(event, wrapper) {
  var touch = event.changedTouches[0];
  wrapper.touchendX = touch.clientX;
  wrapper.touchendY = touch.clientY;

  wrapper.end && wrapper.end(Object.assign(event, wrapper));

  handleGesture(wrapper);
};

var touchmove = function touchmove(event, wrapper) {
  var touch = event.changedTouches[0];
  wrapper.touchmoveX = touch.clientX;
  wrapper.touchmoveY = touch.clientY;

  wrapper.move && wrapper.move(Object.assign(event, wrapper));
};

var handleGesture = function handleGesture(wrapper) {
  var touchstartX = wrapper.touchstartX,
      touchendX = wrapper.touchendX,
      touchstartY = wrapper.touchstartY,
      touchendY = wrapper.touchendY;

  wrapper.offsetX = touchendX - touchstartX;
  wrapper.offsetY = touchendY - touchstartY;

  if (touchendX < touchstartX) {
    wrapper.left && wrapper.left(wrapper);
  }
  if (touchendX > touchstartX) {
    wrapper.right && wrapper.right(wrapper);
  }
  if (touchendY < touchstartY) {
    wrapper.up && wrapper.up(wrapper);
  }
  if (touchendY > touchstartY) {
    wrapper.down && wrapper.down(wrapper);
  }
};

function inserted(el, _ref) {
  var value = _ref.value;

  var wrapper = {
    touchstartX: 0,
    touchstartY: 0,
    touchendX: 0,
    touchendY: 0,
    touchmoveX: 0,
    touchmoveY: 0,
    offsetX: 0,
    offsetY: 0,
    left: value.left,
    right: value.right,
    up: value.up,
    down: value.down,
    start: value.start,
    move: value.move,
    end: value.end
  };

  var target = value.parent ? el.parentNode : el;
  var options = value.options || {};

  target.addEventListener('touchstart', function (e) {
    return touchstart(e, wrapper);
  }, options);
  target.addEventListener('touchend', function (e) {
    return touchend(e, wrapper);
  }, options);
  target.addEventListener('touchmove', function (e) {
    return touchmove(e, wrapper);
  }, options);
}

function unbind(el, _ref2) {
  var value = _ref2.value;

  var target = value.parent ? el.parentNode : el;

  if (!target) return;

  target.removeEventListener('touchstart', touchstart);
  target.removeEventListener('touchend', touchend);
  target.removeEventListener('touchmove', touchmove);
}

/* harmony default export */ __webpack_exports__["a"] = ({
  inserted: inserted,
  unbind: unbind
});

/***/ }),
/* 82 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VMenu_js__ = __webpack_require__(22);


/* harmony default export */ __webpack_exports__["a"] = ({
  VMenu: __WEBPACK_IMPORTED_MODULE_0__VMenu_js__["a" /* default */]
});

/***/ }),
/* 83 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    getActivator: function getActivator() {
      if (this.activator) return this.activator;
      return this.$refs.activator.children ? this.$refs.activator.children[0] : this.$refs.activator;
    },
    activatorClickHandler: function activatorClickHandler(e) {
      if (this.disabled) return;else if (this.openOnClick && !this.isActive) {
        this.isActive = true;
        this.absoluteX = e.clientX;
        this.absoluteY = e.clientY;
      } else if (this.closeOnClick && this.isActive) this.isActive = false;
    },
    mouseEnterHandler: function mouseEnterHandler(e) {
      if (this.disabled || this.hasJustFocused) return;
      this.hasJustFocused = true;
      this.isActive = true;
    },
    mouseLeaveHandler: function mouseLeaveHandler(e) {
      if (this.isContentActive) return;
      this.isActive = false;
    },
    addActivatorEvents: function addActivatorEvents() {
      var activator = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      if (!activator) return;
      activator.addEventListener('click', this.activatorClickHandler);
    },
    removeActivatorEvents: function removeActivatorEvents() {
      var activator = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      if (!activator) return;
      activator.removeEventListener('click', this.activatorClickHandler);
    }
  }
});

/***/ }),
/* 84 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genActivator: function genActivator() {
      if (!this.$slots.activator) return null;

      var options = {
        'class': {
          'menu__activator--active': this.hasJustFocused || this.isActive
        },
        staticClass: 'menu__activator',
        ref: 'activator',
        slot: 'activator',
        on: {}
      };

      if (this.openOnHover) {
        options.on['mouseenter'] = this.mouseEnterHandler;
        options.on['mouseleave'] = this.mouseLeaveHandler;
      } else if (this.openOnClick) {
        options.on['click'] = this.activatorClickHandler;
      }

      return this.$createElement('div', options, this.$slots.activator);
    },
    genTransition: function genTransition() {
      return this.$createElement('transition', {
        props: {
          name: this.transition,
          origin: this.origin
        }
      }, [this.genContent()]);
    },
    genContent: function genContent() {
      var _this = this;

      var booted = this.lazy && this.isBooted || !this.lazy;
      return this.$createElement('div', {
        'class': ('menu__content ' + this.contentClass).trim(),
        ref: 'content',
        style: this.styles,
        directives: [{
          name: 'show',
          value: this.isContentActive
        }],
        on: {
          click: function click(e) {
            e.stopPropagation();
            if (e.target.getAttribute('disabled')) return;
            if (_this.closeOnContentClick) _this.isActive = false;
          },
          mouseleave: function mouseleave(e) {
            _this.openOnHover && (_this.isActive = false);
          }
        }
      }, [booted ? this.$slots.default : null]);
    }
  }
});

/***/ }),
/* 85 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    // Revisit this
    calculateScroll: function calculateScroll() {
      if (this.selectedIndex === null) return;

      var scrollTop = 0;

      if (this.selectedIndex >= this.stopIndex) {
        scrollTop = this.$refs.content.scrollHeight;
      } else if (this.selectedIndex > this.startIndex) {
        scrollTop = this.selectedIndex * 48 - 56;
      }

      this.$refs.content.scrollTop = scrollTop;
    },
    calcLeftAuto: function calcLeftAuto() {
      var a = this.dimensions.activator;

      return parseInt(a.left - 16);
    },
    calcTopAuto: function calcTopAuto() {
      if (!this.hasActivator) return this.calcTop(true);

      var selectedIndex = Array.from(this.tiles).findIndex(function (n) {
        return n.classList.contains('list__tile--active');
      });

      if (selectedIndex === -1) {
        this.selectedIndex = null;

        return this.calcTop(true);
      }

      this.selectedIndex = selectedIndex;
      var actingIndex = selectedIndex;

      var offsetPadding = 1;
      // #708 Stop index should vary by tile length
      this.stopIndex = this.tiles.length > 4 ? this.tiles.length - 4 : this.tiles.length;

      if (selectedIndex > this.startIndex && selectedIndex < this.stopIndex) {
        actingIndex = 2;
        offsetPadding = 41;
      } else if (selectedIndex >= this.stopIndex) {
        offsetPadding = 9;
        actingIndex = selectedIndex - this.stopIndex;
      }

      return this.calcTop(true) + offsetPadding - actingIndex * 48;
    },
    calcLeft: function calcLeft() {
      if (this.auto) return this.calcLeftAuto();

      var a = this.dimensions.activator;
      var c = this.dimensions.content;
      var left = this.left ? a.right - c.width : a.left;

      if (this.offsetX) left += this.left ? -a.width : a.width;
      if (this.nudgeLeft) left += this.nudgeLeft;
      if (this.nudgeRight) left -= this.nudgeRight;

      return this.calcXOverflow(left);
    },
    calcTop: function calcTop(force) {
      if (this.auto && !force) return this.calcTopAuto();

      var a = this.dimensions.activator;
      var c = this.dimensions.content;
      var top = this.top ? a.bottom - c.height : a.top;

      if (this.offsetY) top += this.top ? -a.height : a.height;
      if (this.nudgeTop) top -= this.nudgeTop;
      if (this.nudgeBottom) top += this.nudgeBottom;

      var defined = typeof window !== 'undefined';
      var pageYOffset = defined ? window.pageYOffset : 0;

      return this.calcYOverflow(top) + pageYOffset;
    },
    calcXOverflow: function calcXOverflow(left) {
      var hasWindow = typeof window !== 'undefined';
      var innerWidth = hasWindow ? window.innerWidth : 0;
      var maxWidth = Math.max(this.dimensions.content.width, this.calculatedMinWidth, parseInt(this.maxWidth) || 0);
      var totalWidth = left + maxWidth;
      var availableWidth = totalWidth - innerWidth;

      if ((!this.left || this.right) && availableWidth > 0) {
        left = innerWidth - maxWidth - (innerWidth > 1024 ? 30 : 12) // Account for scrollbar
        ;
      } else if (this.left && left < 0) left = 12;

      return left;
    },
    calcYOverflow: function calcYOverflow(top) {
      var totalHeight = top + this.dimensions.content.height;
      var defined = typeof window !== 'undefined';
      var innerHeight = defined ? window.innerHeight : 0;

      if (this.top && top < 0) top = 12;else if ((!this.top || this.bottom) && innerHeight < totalHeight) {
        top = innerHeight - this.dimensions.content.height;
      }

      return top < 12 ? 12 : top;
    },
    sneakPeek: function sneakPeek(cb) {
      var _this = this;

      requestAnimationFrame(function () {
        var el = _this.$refs.content;
        var currentDisplay = el.style.display;

        el.style.display = 'inline-block';
        cb();
        el.style.display = currentDisplay;
      });
    },
    absolutePosition: function absolutePosition() {
      return {
        offsetTop: 0,
        scrollHeight: 0,
        top: this.positionY || this.absoluteY,
        bottom: this.positionY || this.absoluteY,
        left: this.positionX || this.absoluteX,
        right: this.positionX || this.absoluteX,
        height: 0,
        width: 0
      };
    },
    updateDimensions: function updateDimensions() {
      var _this2 = this;

      this.sneakPeek(function () {
        _this2.dimensions = {
          activator: !_this2.hasActivator || _this2.positionAbsolutely ? _this2.absolutePosition() : _this2.measure(_this2.getActivator()),
          content: _this2.measure(_this2.$refs.content)
        };
      });
    }
  }
});

/***/ }),
/* 86 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    measure: function measure(el, selector) {
      var getParent = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

      el = selector ? el.querySelector(selector) : el;

      if (!el) return null;

      var _el$getBoundingClient = el.getBoundingClientRect(),
          top = _el$getBoundingClient.top,
          bottom = _el$getBoundingClient.bottom,
          left = _el$getBoundingClient.left,
          right = _el$getBoundingClient.right,
          height = _el$getBoundingClient.height,
          width = _el$getBoundingClient.width;

      return {
        offsetTop: el.offsetTop,
        scrollHeight: el.scrollHeight,
        top: top, bottom: bottom, left: left, right: right, height: height, width: width
      };
    }
  }
});

/***/ }),
/* 87 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      listIndex: -1,
      isUsingKeys: false,
      tiles: []
    };
  },

  watch: {
    isActive: function isActive(val) {
      if (!val) this.listIndex = -1;
    },
    listIndex: function listIndex(next, prev) {
      // For infinite scroll and autocomplete, re-evaluate children
      this.getTiles();

      if (next in this.tiles) {
        this.tiles[next].classList.add('list__tile--highlighted');
        this.$refs.content.scrollTop = next * 48;
      }

      prev in this.tiles && this.tiles[prev].classList.remove('list__tile--highlighted');
    }
  },

  methods: {
    changeListIndex: function changeListIndex(e) {
      [40, 38, 13].includes(e.keyCode) && e.preventDefault();
      e.keyCode === 32 && !this.isActive && e.preventDefault();

      if (this.listIndex === -1) this.setActiveListIndex();
      if ([27, 9].includes(e.keyCode)) return this.isActive = false;else if (!this.isActive && [13, 32].includes(e.keyCode)) {
        return this.isActive = true;
      }

      if (e.keyCode === 40 && this.listIndex < this.tiles.length - 1) {
        this.listIndex++;
      } else if (e.keyCode === 38 && this.listIndex > 0) {
        this.listIndex--;
      } else if (e.keyCode === 13 && this.listIndex !== -1) {
        this.tiles[this.listIndex].click();
      }
    },
    getTiles: function getTiles() {
      this.tiles = this.$refs.content.querySelectorAll('.list__tile');
    },
    setActiveListIndex: function setActiveListIndex() {
      var _this = this;

      this.tiles.forEach(function (t, i) {
        if (t.classList.contains('list__tile--active')) {
          _this.listIndex = i;
          return;
        }
      });
    }
  }
});

/***/ }),
/* 88 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VNavigationDrawer__ = __webpack_require__(89);


/* harmony default export */ __webpack_exports__["a"] = ({
  VNavigationDrawer: __WEBPACK_IMPORTED_MODULE_0__VNavigationDrawer__["a" /* default */]
});

/***/ }),
/* 89 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_overlayable__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_themeable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__directives__ = __webpack_require__(4);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-navigation-drawer',

  directives: {
    Resize: __WEBPACK_IMPORTED_MODULE_2__directives__["Resize"]
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_overlayable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_themeable__["a" /* default */]],

  data: function data() {
    return {
      isActive: this.value,
      isBooted: false,
      isMobile: false,
      touchArea: {
        left: 0,
        right: 0
      }
    };
  },


  props: {
    absolute: Boolean,
    clipped: Boolean,
    disableRouteWatcher: Boolean,
    enableResizeWatcher: Boolean,
    height: String,
    floating: Boolean,
    miniVariant: Boolean,
    mobileBreakPoint: {
      type: Number,
      default: 1024
    },
    permanent: Boolean,
    persistent: Boolean,
    right: Boolean,
    temporary: Boolean,
    touchless: Boolean,
    value: { required: false }
  },

  computed: {
    calculatedHeight: function calculatedHeight() {
      return this.height || '100%';
    },
    classes: function classes() {
      return {
        'navigation-drawer': true,
        'navigation-drawer--absolute': this.absolute,
        'navigation-drawer--clipped': this.clipped,
        'navigation-drawer--close': !this.isActive,
        'navigation-drawer--floating': this.floating,
        'navigation-drawer--is-booted': this.isBooted,
        'navigation-drawer--is-mobile': this.isMobile,
        'navigation-drawer--mini-variant': this.miniVariant,
        'navigation-drawer--open': this.isActive,
        'navigation-drawer--permanent': this.permanent,
        'navigation-drawer--persistent': this.persistent,
        'navigation-drawer--right': this.right,
        'navigation-drawer--temporary': this.temporary,
        'theme--dark': this.dark,
        'theme--light': this.light
      };
    },
    showOverlay: function showOverlay() {
      return !this.permanent && this.isActive && (this.temporary || this.isMobile);
    }
  },

  watch: {
    $route: function $route() {
      if (!this.disableRouteWatcher) {
        this.isActive = !this.closeConditional();
      }
    },
    isActive: function isActive(val) {
      this.$emit('input', val);
      this.showOverlay && val && this.genOverlay() || this.removeOverlay();
      this.$el.scrollTop = 0;
    },
    isMobile: function isMobile(val) {
      !val && this.removeOverlay();
    },
    permanent: function permanent(val) {
      this.$emit('input', val);
    },
    value: function value(val) {
      if (this.permanent) return;
      if (val !== this.isActive) this.isActive = val;
    }
  },

  mounted: function mounted() {
    this.$vuetify.load(this.init);
  },


  methods: {
    init: function init() {
      var _this = this;

      this.checkIfMobile();
      setTimeout(function () {
        return _this.isBooted = true;
      }, 0);

      if (this.permanent) this.isActive = true;else if (this.isMobile) this.isActive = false;else if (!this.value && (this.persistent || this.temporary)) this.isActive = false;
    },
    checkIfMobile: function checkIfMobile() {
      this.isMobile = window.innerWidth < parseInt(this.mobileBreakPoint);
    },
    closeConditional: function closeConditional() {
      return !this.permanent && (this.temporary || this.isMobile);
    },
    onResize: function onResize() {
      var _this2 = this;

      clearTimeout(this.resizeTimeout);

      if (!this.enableResizeWatcher || this.permanent || this.temporary) return;

      this.resizeTimeout = setTimeout(function () {
        _this2.checkIfMobile();
        _this2.isActive = !_this2.isMobile;
      }, 200);
    },
    swipeRight: function swipeRight(e) {
      if (this.isActive && !this.right) return;
      this.calculateTouchArea();

      if (Math.abs(e.touchendX - e.touchstartX) < 100) return;else if (!this.right && e.touchstartX <= this.touchArea.left) this.isActive = true;else if (this.right && this.isActive) this.isActive = false;
    },
    swipeLeft: function swipeLeft(e) {
      if (this.isActive && this.right) return;
      this.calculateTouchArea();

      if (Math.abs(e.touchendX - e.touchstartX) < 100) return;else if (this.right && e.touchstartX >= this.touchArea.right) this.isActive = true;else if (!this.right && this.isActive) this.isActive = false;
    },
    calculateTouchArea: function calculateTouchArea() {
      if (!this.$el.parentNode) return;
      var parentRect = this.$el.parentNode.getBoundingClientRect();

      this.touchArea = {
        left: parentRect.left + 50,
        right: parentRect.right - 50
      };
    },
    genDirectives: function genDirectives() {
      var directives = [{
        name: 'click-outside',
        value: this.closeConditional
      }, {
        name: 'resize',
        value: this.onResize
      }];

      !this.touchless && directives.push({
        name: 'touch',
        value: {
          parent: true,
          left: this.swipeLeft,
          right: this.swipeRight
        }
      });

      return directives;
    }
  },

  render: function render(h) {
    var _this3 = this;

    var data = {
      'class': this.classes,
      style: { height: this.calculatedHeight },
      directives: this.genDirectives(),
      on: Object.assign({}, {
        click: function click() {
          return _this3.$emit('update:miniVariant', false);
        }
      }, this.$listeners)
    };

    return h('aside', data, [this.$slots.default, h('div', { 'class': 'navigation-drawer__border' })]);
  }
});

/***/ }),
/* 90 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VSystemBar__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VToolbar__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__VToolbarSideIcon__ = __webpack_require__(93);






var VToolbarTitle = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('toolbar__title');
var VToolbarItems = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('toolbar__items');

/* harmony default export */ __webpack_exports__["a"] = ({
  VSystemBar: __WEBPACK_IMPORTED_MODULE_1__VSystemBar__["a" /* default */],
  VToolbar: __WEBPACK_IMPORTED_MODULE_2__VToolbar__["a" /* default */],
  VToolbarItems: VToolbarItems,
  VToolbarTitle: VToolbarTitle,
  VToolbarSideIcon: __WEBPACK_IMPORTED_MODULE_3__VToolbarSideIcon__["a" /* default */]
});

/***/ }),
/* 91 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  props: {
    lightsOut: Boolean,
    status: Boolean,
    window: Boolean
  },

  render: function render(h, _ref) {
    var data = _ref.data,
        props = _ref.props,
        children = _ref.children;

    data.staticClass = ('system-bar ' + (data.staticClass || '')).trim();

    if (props.dark) data.staticClass += ' theme--dark';
    if (props.light) data.staticClass += ' theme--light';
    if (props.status) data.staticClass += ' system-bar--status';
    if (props.window) data.staticClass += ' system-bar--window';
    if (props.lightsOut) data.staticClass += ' system-bar--lights-out';

    return h('div', data, children);
  }
});

/***/ }),
/* 92 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-toolbar',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  data: function data() {
    return {
      isExtended: false,
      isScrolling: false,
      marginTop: 0,
      previousScroll: null,
      target: null
    };
  },

  props: {
    absolute: Boolean,
    card: Boolean,
    dense: Boolean,
    extended: Boolean,
    fixed: Boolean,
    flat: Boolean,
    floating: Boolean,
    prominent: Boolean,
    scrollOffScreen: Boolean,
    scrollTarget: String,
    scrollThreshHold: {
      type: Number,
      default: 100
    }
  },

  computed: {
    classes: function classes() {
      return {
        'toolbar': true,
        'elevation-0': this.flat,
        'toolbar--absolute': this.absolute,
        'toolbar--card': this.card,
        'toolbar--dense': this.dense,
        'toolbar--fixed': this.fixed,
        'toolbar--floating': this.floating,
        'toolbar--prominent': this.prominent,
        'toolbar--extended': this.isExtended,
        'theme--dark': this.dark,
        'theme--light': this.light
      };
    },
    styles: function styles() {
      return {
        marginTop: this.marginTop
      };
    }
  },

  watch: {
    isScrolling: function isScrolling(val) {
      if (!val) this.marginTop = 0;else this.marginTop = -this.$refs.content.clientHeight - 6 + 'px';
    }
  },

  methods: {
    onScroll: function onScroll() {
      if (typeof window === 'undefined') return;

      if (!this.target) {
        this.target = this.scrollTarget ? document.querySelector(this.scrollTarget) : window;
      }

      var currentScroll = this.scrollTarget ? this.target.scrollTop : this.target.pageYOffset || document.documentElement.scrollTop;

      if (currentScroll < this.scrollThreshHold) return;

      if (this.previousScroll === null) {
        this.previousScroll = currentScroll;
      }

      this.isScrolling = this.previousScroll < currentScroll;

      this.previousScroll = currentScroll;
    }
  },

  render: function render(h) {
    this.isExtended = this.extended || !!this.$slots.extension;
    var children = [];
    var data = {
      'class': this.classes,
      style: this.styles,
      on: this.$listeners
    };

    if (this.scrollOffScreen) {
      data.directives = [{
        name: 'scroll',
        value: {
          callback: this.onScroll,
          target: this.scrollTarget
        }
      }];
    }

    children.push(h('div', {
      'class': 'toolbar__content',
      ref: 'content'
    }, this.$slots.default));

    if (this.isExtended) {
      children.push(h('div', {
        'class': 'toolbar__extension'
      }, this.$slots.extension));
    }

    return h('nav', data, children);
  }
});

/***/ }),
/* 93 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_buttons_VBtn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_icons_VIcon__ = __webpack_require__(3);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-toolbar-side-icon',

  functional: true,

  render: function render(h, _ref) {
    var slots = _ref.slots,
        listeners = _ref.listeners,
        props = _ref.props;

    var data = {
      staticClass: 'toolbar__side-icon',
      props: Object.assign(props, {
        icon: true
      }),
      on: listeners
    };

    var defaultSlot = slots().default;

    return h(__WEBPACK_IMPORTED_MODULE_0__components_buttons_VBtn__["a" /* default */], data, defaultSlot || [h(__WEBPACK_IMPORTED_MODULE_1__components_icons_VIcon__["a" /* default */], 'menu')]);
  }
});

/***/ }),
/* 94 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VPagination__ = __webpack_require__(95);


/* harmony default export */ __webpack_exports__["a"] = ({
  VPagination: __WEBPACK_IMPORTED_MODULE_0__VPagination__["a" /* default */]
});

/***/ }),
/* 95 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_icons_VIcon__ = __webpack_require__(3);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-pagination',

  props: {
    circle: Boolean,
    disabled: Boolean,
    length: {
      type: Number,
      default: 0,
      validator: function validator(val) {
        return val % 1 === 0;
      }
    },
    value: {
      type: Number,
      default: 0
    },
    prevIcon: {
      type: String,
      default: 'chevron_left'
    },
    nextIcon: {
      type: String,
      default: 'chevron_right'
    }
  },

  watch: {
    value: function value() {
      this.init();
    }
  },

  computed: {
    classes: function classes() {
      return {
        'pagination': true,
        'pagination--circle': this.circle,
        'pagination--disabled': this.disabled
      };
    },
    items: function items() {
      if (this.length <= 5) {
        return this.range(1, this.length);
      }

      var min = this.value - 3;
      min = min > 0 ? min : 1;

      var max = min + 6;
      max = max <= this.length ? max : this.length;

      if (max === this.length) {
        min = this.length - 6;
      }

      var range = this.range(min, max);

      if (this.value >= 4 && this.length > 6) {
        range.splice(0, 2, 1, '...');
      }

      if (this.value + 3 < this.length && this.length > 6) {
        range.splice(range.length - 2, 2, '...', this.length);
      }

      return range;
    }
  },

  mounted: function mounted() {
    this.$vuetify.load.call(this, this.init);
  },


  methods: {
    init: function init() {
      var _this = this;

      this.selected = null;

      // Change this
      setTimeout(function () {
        return _this.selected = _this.value;
      }, 100);
    },
    next: function next(e) {
      e.preventDefault();
      this.$emit('input', this.value + 1);
      this.$emit('next');
    },
    previous: function previous(e) {
      e.preventDefault();
      this.$emit('input', this.value - 1);
      this.$emit('previous');
    },
    range: function range(from, to) {
      var range = [];

      from = from > 0 ? from : 1;

      for (var i = from; i <= to; i++) {
        range.push(i);
      }

      return range;
    },
    genIcon: function genIcon(h, icon, disabled, fn) {
      return h('li', [h('a', {
        class: {
          'pagination__navigation': true,
          'pagination__navigation--disabled': disabled
        },
        attrs: { href: '#!' },
        on: { click: fn }
      }, [h(__WEBPACK_IMPORTED_MODULE_0__components_icons_VIcon__["a" /* default */], [icon])])]);
    },
    genItem: function genItem(h, i) {
      var _this2 = this;

      return h('a', {
        class: {
          'pagination__item': true,
          'pagination__item--active': i === this.value
        },
        attrs: { href: '#!' },
        on: {
          click: function click(e) {
            e.preventDefault();
            _this2.$emit('input', i);
          }
        }
      }, [i]);
    },
    genItems: function genItems(h) {
      var _this3 = this;

      return this.items.map(function (i) {
        return h('li', [isNaN(i) && h('span', { class: 'pagination__more' }, [i]) || _this3.genItem(h, i)]);
      });
    }
  },

  render: function render(h) {
    var children = [this.genIcon(h, this.prevIcon, this.value === 1, this.previous), this.genItems(h), this.genIcon(h, this.nextIcon, this.value === this.length, this.next)];

    return h('ul', { class: this.classes }, children);
  }
});

/***/ }),
/* 96 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VParallax__ = __webpack_require__(97);


/* harmony default export */ __webpack_exports__["a"] = ({
  VParallax: __WEBPACK_IMPORTED_MODULE_0__VParallax__["a" /* default */]
});

/***/ }),
/* 97 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_translatable__ = __webpack_require__(98);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-parallax',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_translatable__["a" /* default */]],

  props: {
    height: {
      type: [String, Number],
      default: 500
    },
    src: String
  },

  computed: {
    styles: function styles() {
      return {
        display: 'block',
        transform: 'translate3d(-50%, ' + this.parallax + 'px, 0)'
      };
    }
  },

  methods: {
    init: function init() {
      var _this = this;

      if (!this.$refs.img) return;

      if (this.$refs.img.complete) {
        this.translate();
        this.listeners();
      } else {
        this.$refs.img.addEventListener('load', function () {
          _this.translate();
          _this.listeners();
        }, false);
      }
    },
    objHeight: function objHeight() {
      return this.$refs.img.naturalHeight;
    },
    elOffsetTop: function elOffsetTop() {
      return this.$el.offsetTop;
    }
  },

  render: function render(h) {
    var container = h('div', {
      staticClass: 'parallax__image-container'
    }, [h('img', {
      staticClass: 'parallax__image',
      style: this.styles,
      attrs: {
        src: this.src
      },
      ref: 'img'
    })]);

    var content = h('div', {
      staticClass: 'parallax__content'
    }, this.$slots.default);

    return h('div', {
      staticClass: 'parallax',
      style: {
        height: parseInt(this.normalizedHeight) + 'px'
      },
      on: this.$listeners
    }, [container, content]);
  }
});

/***/ }),
/* 98 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      parallax: null,
      parallaxDist: null,
      percentScrolled: null,
      scrollTop: null,
      windowHeight: null,
      windowBottom: null
    };
  },


  computed: {
    normalizedHeight: function normalizedHeight() {
      return Number(this.height.toString().replace(/(^[0-9]*$)/, '$1'));
    },
    imgHeight: function imgHeight() {
      return this.objHeight();
    }
  },

  mounted: function mounted() {
    this.$vuetify.load(this.init);
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('scroll', this.translate, false);
    window.removeEventListener('resize', this.translate, false);
  },


  methods: {
    listeners: function listeners() {
      window.addEventListener('scroll', this.translate, false);
      window.addEventListener('resize', this.translate, false);
    },
    translate: function translate() {
      this.calcDimensions();

      this.percentScrolled = (this.windowBottom - this.elOffsetTop) / (this.normalizedHeight + this.windowHeight);

      this.parallax = Math.round(this.parallaxDist * this.percentScrolled);

      if (this.translated) {
        this.translated();
      }
    },
    calcDimensions: function calcDimensions() {
      var offset = this.$el.getBoundingClientRect();

      this.scrollTop = window.pageYOffset;
      this.parallaxDist = this.imgHeight - this.normalizedHeight;
      this.elOffsetTop = offset.top + this.scrollTop;
      this.windowHeight = window.innerHeight;
      this.windowBottom = this.scrollTop + this.windowHeight;
    }
  }
});

/***/ }),
/* 99 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VProgressLinear__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VProgressCircular__ = __webpack_require__(100);



/* harmony default export */ __webpack_exports__["a"] = ({
  VProgressLinear: __WEBPACK_IMPORTED_MODULE_0__VProgressLinear__["a" /* default */],
  VProgressCircular: __WEBPACK_IMPORTED_MODULE_1__VProgressCircular__["a" /* default */]
});

/***/ }),
/* 100 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _this = this;

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-progress-circular',

  props: {
    button: Boolean,

    fill: {
      type: String,
      default: function _default() {
        return _this.indeterminate ? 'none' : 'transparent';
      }
    },

    indeterminate: Boolean,

    rotate: {
      type: Number,
      default: 0
    },

    size: {
      type: [Number, String],
      default: 32
    },

    width: {
      type: Number,
      default: 4
    },

    value: {
      type: Number,
      default: 0
    }
  },

  computed: {
    calculatedSize: function calculatedSize() {
      var size = Number(this.size);

      if (this.button) {
        size += 8;
      }

      return size;
    },
    circumference: function circumference() {
      return 2 * Math.PI * this.radius;
    },
    classes: function classes() {
      return {
        'progress-circular': true,
        'progress-circular--indeterminate': this.indeterminate,
        'progress-circular--button': this.button
      };
    },
    cxy: function cxy() {
      return this.indeterminate && !this.button ? 50 : this.calculatedSize / 2;
    },
    normalizedValue: function normalizedValue() {
      if (this.value < 0) {
        return 0;
      }

      if (this.value > 100) {
        return 100;
      }

      return this.value;
    },
    radius: function radius() {
      return this.indeterminate && !this.button ? 20 : (this.calculatedSize - this.width) / 2;
    },
    strokeDashArray: function strokeDashArray() {
      return Math.round(this.circumference * 1000) / 1000;
    },
    strokeDashOffset: function strokeDashOffset() {
      return (100 - this.normalizedValue) / 100 * this.circumference + 'px';
    },
    styles: function styles() {
      return {
        height: this.calculatedSize + 'px',
        width: this.calculatedSize + 'px'
      };
    },
    svgSize: function svgSize() {
      return this.indeterminate ? false : this.calculatedSize;
    },
    svgStyles: function svgStyles() {
      return {
        transform: 'rotate(' + this.rotate + 'deg)'
      };
    },
    viewBox: function viewBox() {
      return this.indeterminate ? '25 25 50 50' : false;
    }
  },

  methods: {
    genCircle: function genCircle(h, name, offset) {
      return h('circle', {
        class: 'progress-circular__' + name,
        attrs: {
          fill: 'transparent',
          cx: this.cxy,
          cy: this.cxy,
          r: this.radius,
          'stroke-width': this.width,
          'stroke-dasharray': this.strokeDashArray,
          'stroke-dashoffset': offset
        }
      });
    },
    genSvg: function genSvg(h) {
      var children = [!this.indeterminate && this.genCircle(h, 'underlay', 0), this.genCircle(h, 'overlay', this.strokeDashOffset)];

      return h('svg', {
        style: this.svgStyles,
        attrs: {
          xmlns: 'http://www.w3.org/2000/svg',
          height: this.svgSize,
          width: this.svgSize,
          viewBox: this.viewBox
        }
      }, children);
    }
  },

  render: function render(h) {
    var info = h('div', { class: 'progress-circular__info' }, [this.$slots.default]);
    var svg = this.genSvg(h);

    return h('div', {
      class: this.classes,
      style: this.styles,
      on: this.$listeners
    }, [svg, info]);
  }
});

/*
<template lang="pug">
  div(
    class="progress-circular"
    v-bind:class="classes"
    v-bind:style="styles"
    v-on="$listeners"
  )
    svg(
      xmlns="http://www.w3.org/2000/svg"
      v-bind:height="svgSize"
      v-bind:width="svgSize"
      v-bind:viewBox="viewBox"
      v-bind:style="svgStyles"
    )
      circle(
        class="progress-circular__underlay"
        fill="transparent"
        v-bind:cx="cxy"
        v-bind:cy="cxy"
        v-bind:r="radius"
        v-bind:stroke-width="width"
        v-bind:stroke-dasharray="strokeDashArray"
        v-bind:stroke-dashoffset="0"
        v-if="!indeterminate"
      )
      circle(
        class="progress-circular__overlay"
        v-bind:fill="fill"
        v-bind:cx="cxy"
        v-bind:cy="cxy"
        v-bind:r="radius"
        v-bind:stroke-width="width"
        v-bind:stroke-dasharray="strokeDashArray"
        v-bind:stroke-dashoffset="strokeDashOffset"
      )
    div(class="progress-circular__info")
      slot
</template>
*/

/***/ }),
/* 101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VSelect__ = __webpack_require__(24);


/* harmony default export */ __webpack_exports__["a"] = ({
  VSelect: __WEBPACK_IMPORTED_MODULE_0__VSelect__["a" /* default */]
});

/***/ }),
/* 102 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    filterSearch: function filterSearch() {
      var _this = this;

      return this.items.filter(function (i) {
        var text = _this.getText(i);
        if (typeof text !== 'string') return false;

        return text.toLowerCase().indexOf(_this.searchValue.toLowerCase()) !== -1;
      });
    },
    onKeyDown: function onKeyDown(e) {
      this.$refs.menu.changeListIndex(e);
    }
  }
});

/***/ }),
/* 103 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);


/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genMenu: function genMenu() {
      var _this = this;

      var offsetY = this.autocomplete || this.offset || this.isDropdown;
      var data = {
        ref: 'menu',
        props: {
          activator: this.$refs.activator,
          auto: this.auto,
          closeOnClick: false,
          closeOnContentClick: !this.multiple,
          contentClass: this.computedContentClass,
          disabled: this.disabled,
          maxHeight: this.maxHeight,
          nudgeTop: this.isDropdown ? 22 : offsetY ? 38 : 0,
          offsetY: offsetY,
          value: this.isActive
        },
        on: { input: function input(val) {
            return _this.isActive = val;
          } }
      };

      this.minWidth && (data.props.minWidth = this.minWidth);

      return this.$createElement('v-menu', data, [this.genList()]);
    },
    genSelectionsAndSearch: function genSelectionsAndSearch() {
      var _this2 = this;

      var input = void 0;

      if (this.autocomplete || this.editable) {
        input = this.$createElement('input', {
          'class': 'input-group--select__autocomplete',
          domProps: { value: this.searchValue },
          on: { input: function input(e) {
              return _this2.searchValue = e.target.value;
            } },
          attrs: { tabindex: -1 },
          ref: 'input',
          key: 'input'
        });
      }

      var selections = this.isDirty && (!this.editable || this.editable && !this.focused) ? this.genSelections() : [];
      input && selections.push(input);
      var group = this.$createElement('div', selections);

      return this.$createElement('div', {
        'class': 'input-group__selections',
        style: { 'overflow': 'hidden' },
        ref: 'activator'
      }, [group]);
    },
    genSelections: function genSelections() {
      var _this3 = this;

      var children = [];
      var chips = this.chips;
      var slots = this.$scopedSlots.selection;
      var length = this.selectedItems.length;

      this.selectedItems.forEach(function (item, i) {
        if (slots) {
          children.push(_this3.genSlotSelection(item));
        } else if (chips) {
          children.push(_this3.genChipSelection(item));
        } else {
          children.push(_this3.genCommaSelection(item, i < length - 1));
        }
      });

      return children;
    },
    genSlotSelection: function genSlotSelection(item) {
      return this.$scopedSlots.selection({ parent: this, item: item });
    },
    genChipSelection: function genChipSelection(item) {
      var _this4 = this;

      return this.$createElement('v-chip', {
        'class': 'chip--select-multi',
        props: { close: true },
        on: {
          input: function input() {
            return _this4.selectItem(item);
          },
          click: function click(e) {
            return e.stopPropagation();
          }
        },
        key: this.getValue(item)
      }, this.getText(item));
    },
    genCommaSelection: function genCommaSelection(item, comma) {
      return this.$createElement('div', {
        'class': 'input-group__selections__comma',
        key: JSON.stringify(this.getValue(item)) // Item may be an object
      }, '' + this.getText(item) + (comma ? ', ' : ''));
    },
    genList: function genList() {
      var _this5 = this;

      var children = this.filteredItems.map(function (o) {
        if (o.header) return _this5.genHeader(o);
        if (o.divider) return _this5.genDivider(o);else return _this5.genTile(o);
      });

      if (!children.length) {
        children.push(this.genTile(this.noDataText, true));
      }

      return this.$createElement('v-card', [this.$createElement('v-list', {
        ref: 'list'
      }, children)]);
    },
    genHeader: function genHeader(item) {
      return this.$createElement('v-subheader', {
        props: item
      }, item.header);
    },
    genDivider: function genDivider(item) {
      return this.$createElement('v-divider', {
        props: item
      });
    },
    genTile: function genTile(item, disabled) {
      var _this6 = this;

      var active = this.selectedItems.indexOf(item) !== -1;

      if (typeof disabled === 'undefined') {
        disabled = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["g" /* getObjectValueByPath */])(item, this.itemDisabled);
      }

      var data = {
        on: { click: function click(e) {
            return _this6.selectItem(item);
          } },
        props: {
          avatar: item === Object(item) && 'avatar' in item,
          ripple: true,
          value: active
        }
      };

      if (disabled) {
        data.props.disabled = disabled;
      }

      if (this.$scopedSlots.item) {
        return this.$createElement('v-list-tile', data, [this.$scopedSlots.item({ parent: this, item: item })]);
      }

      return this.$createElement('v-list-tile', data, [this.genAction(item, active), this.genContent(item)]);
    },
    genAction: function genAction(item, active) {
      var _this7 = this;

      if (!this.multiple) return null;

      var data = {
        'class': {
          'list__tile__action--select-multi': this.multiple
        },
        on: {
          click: function click(e) {
            e.stopPropagation();
            _this7.selectItem(item);
          }
        }
      };

      return this.$createElement('v-list-tile-action', data, [this.$createElement('v-checkbox', { props: { inputValue: active } })]);
    },
    genContent: function genContent(item) {
      return this.$createElement('v-list-tile-content', [this.$createElement('v-list-tile-title', this.getText(item))]);
    }
  }
});

/***/ }),
/* 104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VCheckbox__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VRadio__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VSwitch__ = __webpack_require__(106);




/* harmony default export */ __webpack_exports__["a"] = ({
  VCheckbox: __WEBPACK_IMPORTED_MODULE_0__VCheckbox__["a" /* default */],
  VRadio: __WEBPACK_IMPORTED_MODULE_1__VRadio__["a" /* default */],
  VSwitch: __WEBPACK_IMPORTED_MODULE_2__VSwitch__["a" /* default */]
});

/***/ }),
/* 105 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_input__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_colorable__ = __webpack_require__(28);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'radio',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_input__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_colorable__["a" /* default */]],

  model: {
    prop: 'inputValue',
    event: 'change'
  },

  props: {
    inputValue: [String, Number]
  },

  computed: {
    isActive: function isActive() {
      return this.inputValue === this.value;
    },
    classes: function classes() {
      return this.addColorClassChecks({
        'radio': true,
        'input-group--selection-controls': true,
        'input-group--active': this.isActive
      });
    },
    icon: function icon() {
      return this.isActive ? 'radio_button_checked' : 'radio_button_unchecked';
    }
  },

  methods: {
    genLabel: function genLabel() {
      return this.$createElement('label', {
        on: { click: this.toggle }
      }, this.label);
    },
    toggle: function toggle() {
      if (!this.disabled) {
        this.$emit('change', this.value);
      }
    }
  },

  render: function render(h) {
    var transition = h('v-fade-transition', {}, [h('v-icon', {
      'class': {
        'icon--radio': this.isActive
      },
      key: this.icon
    }, this.icon)]);

    var ripple = h('div', {
      'class': 'input-group--selection-controls__ripple',
      on: Object.assign({}, {
        click: this.toggle
      }, this.$listeners),
      directives: [{
        name: 'ripple',
        value: { center: true }
      }]
    });

    return this.genInputGroup([transition, ripple]);
  }
});

/***/ }),
/* 106 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_selectable__ = __webpack_require__(27);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'switch',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_selectable__["a" /* default */]],

  computed: {
    classes: function classes() {
      return {
        'input-group--selection-controls switch': true
      };
    },
    rippleClasses: function rippleClasses() {
      return {
        'input-group--selection-controls__ripple': true,
        'input-group--selection-controls__ripple--active': this.isActive
      };
    },
    containerClasses: function containerClasses() {
      return this.addColorClassChecks({
        'input-group--selection-controls__container': true,
        'input-group--selection-controls__container--light': this.light,
        'input-group--selection-controls__container--disabled': this.disabled
      });
    },
    toggleClasses: function toggleClasses() {
      return {
        'input-group--selection-controls__toggle': true,
        'input-group--selection-controls__toggle--active': this.isActive
      };
    }
  },

  render: function render(h) {
    var ripple = h('div', {
      'class': this.rippleClasses,
      on: Object.assign({}, {
        click: this.toggle
      }, this.$listeners),
      directives: [{
        name: 'ripple',
        value: { center: true }
      }]
    });

    var container = h('div', {
      'class': this.containerClasses
    }, [h('div', { 'class': this.toggleClasses }), ripple]);

    return this.genInputGroup([container]);
  }
});

/***/ }),
/* 107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VSlider__ = __webpack_require__(108);


/* harmony default export */ __webpack_exports__["a"] = ({
  VSlider: __WEBPACK_IMPORTED_MODULE_0__VSlider__["a" /* default */]
});

/***/ }),
/* 108 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_input__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_helpers__ = __webpack_require__(0);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-slider',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_input__["a" /* default */]],

  data: function data() {
    return {
      app: {},
      isActive: false,
      inputWidth: 0
    };
  },


  props: {
    inverted: Boolean,
    min: {
      type: [Number, String],
      default: 0
    },
    max: {
      type: [Number, String],
      default: 100
    },
    step: {
      type: [Number, String],
      default: null
    },
    thumbLabel: Boolean,
    value: [Number, String],
    vertical: Boolean,
    snap: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'input-group input-group--slider': true,
        'input-group--active': this.isActive,
        'input-group--dirty': this.inputWidth > 0,
        'input-group--disabled': this.disabled,
        'input-group--ticks': !this.disabled && this.step
      };
    },

    inputValue: {
      get: function get() {
        return this.value;
      },
      set: function set(val) {
        var min = this.min,
            max = this.max,
            step = this.step,
            snap = this.snap;

        val = val < min ? min : val > max ? max : val;
        if (Math.ceil(val) !== Math.ceil(this.lazyValue)) {
          this.inputWidth = this.calculateWidth(val);
        }

        var value = snap ? Math.round(val / step) * step : parseInt(val);
        this.lazyValue = value;

        if (value !== this.value) {
          this.$emit('input', value);
        }
      }
    },
    interval: function interval() {
      return 100 / (this.max - this.min) * this.step;
    },
    thumbContainerClasses: function thumbContainerClasses() {
      return {
        'slider__thumb-container': true,
        'slider__thumb-container--label': this.thumbLabel
      };
    },
    thumbStyles: function thumbStyles() {
      return {
        left: this.inputWidth + '%'
      };
    },
    tickContainerStyles: function tickContainerStyles() {
      return {
        transform: 'translate3d(0, -50%, 0)'
      };
    },
    trackStyles: function trackStyles() {
      var scaleX = this.calculateScale(1 - this.inputWidth / 100);
      var translateX = this.inputWidth < 1 && !this.isActive ? 8 + 'px' : 0;
      return {
        transform: 'scaleX(' + scaleX + ') translateX(' + translateX + ')'
      };
    },
    trackFillStyles: function trackFillStyles() {
      var inputWidth = this.inputWidth;
      var scaleX = this.calculateScale(inputWidth / 100);
      var translateX = inputWidth > 99 && !this.thumbLabel ? -8 + 'px' : 0;
      return {
        transform: 'scaleX(' + scaleX + ') translateX(' + translateX + ')'
      };
    },
    numTicks: function numTicks() {
      return parseInt((this.max - this.min) / this.step);
    }
  },

  watch: {
    value: function value() {
      this.inputValue = this.value;
    }
  },

  mounted: function mounted() {
    var _this = this;

    this.inputValue = this.value;
    this.$nextTick(function () {
      _this.inputWidth = _this.calculateWidth(_this.inputValue);
    });

    // Without a v-app, iOS does not work with body selectors
    this.app = document.querySelector('[data-app]') || console.warn('The v-slider component requires the present of v-app or a non-body wrapping element with the [data-app] attribute.');
  },


  methods: {
    calculateWidth: function calculateWidth(val) {
      if (this.snap) {
        val = Math.round(val / this.step) * this.step;
      }

      val = (val - this.min) / (this.max - this.min) * 100;

      return val < 0.15 ? 0 : val;
    },
    calculateScale: function calculateScale(scale) {
      if (scale < 0.02 && !this.thumbLabel) {
        return 0;
      }

      return this.disabled ? scale - 0.015 : scale;
    },
    onMouseDown: function onMouseDown(e) {
      var options = { passive: true };
      this.isActive = true;

      if ('touches' in e) {
        this.app.addEventListener('touchmove', this.onMouseMove, options);
        Object(__WEBPACK_IMPORTED_MODULE_1__util_helpers__["a" /* addOnceEventListener */])(this.app, 'touchend', this.onMouseUp);
      } else {
        this.app.addEventListener('mousemove', this.onMouseMove, options);
        Object(__WEBPACK_IMPORTED_MODULE_1__util_helpers__["a" /* addOnceEventListener */])(this.app, 'mouseup', this.onMouseUp);
      }
    },
    onMouseUp: function onMouseUp() {
      var options = { passive: true };
      this.isActive = false;
      this.app.removeEventListener('touchmove', this.onMouseMove, options);
      this.app.removeEventListener('mousemove', this.onMouseMove, options);
    },
    onMouseMove: function onMouseMove(e) {
      var _$refs$track$getBound = this.$refs.track.getBoundingClientRect(),
          offsetLeft = _$refs$track$getBound.left,
          trackWidth = _$refs$track$getBound.width;

      var clientX = 'touches' in e ? e.touches[0].clientX : e.clientX;
      var left = (clientX - offsetLeft) / trackWidth * 100;

      left = left < 0 ? 0 : left > 100 ? 100 : left;

      this.inputValue = this.min + left / 100 * (this.max - this.min);
    },
    onKeyDown: function onKeyDown(e) {
      if (!e.keyCode === 37 && !e.keyCode === 39) return;

      var direction = e.keyCode === 37 && -1 || e.keyCode === 39 && 1 || 0;
      var multiplier = e.shiftKey && 3 || e.ctrlKey && 2 || 1;
      var amount = this.snap && this.step || 1;

      this.inputValue = this.inputValue + direction * amount * multiplier;
    },
    sliderMove: function sliderMove(e) {
      if (!this.isActive) {
        this.onMouseMove(e);
      }
    },
    genThumbLabel: function genThumbLabel(h) {
      return h('v-scale-transition', {
        props: { origin: 'bottom center' }
      }, [h('div', {
        'class': 'slider__thumb--label__container',
        directives: [{
          name: 'show',
          value: this.isActive
        }]
      }, [h('div', { 'class': 'slider__thumb--label' }, [h('span', {}, parseInt(this.inputValue))])])]);
    },
    genThumbContainer: function genThumbContainer(h) {
      var children = [];
      children.push(h('div', { 'class': 'slider__thumb' }));

      this.thumbLabel && children.push(this.genThumbLabel(h));

      return h('div', {
        'class': this.thumbContainerClasses,
        style: this.thumbStyles,
        on: {
          touchstart: this.onMouseDown,
          mousedown: this.onMouseDown
        },
        ref: 'thumb'
      }, children);
    },
    genSteps: function genSteps(h) {
      var _this2 = this;

      var ticks = Object(__WEBPACK_IMPORTED_MODULE_1__util_helpers__["c" /* createRange */])(this.numTicks + 1).map(function (i) {
        var span = h('span', {
          class: 'slider__tick',
          style: {
            left: i * (100 / _this2.numTicks) + '%'
          }
        });

        return span;
      });

      return h('div', {
        'class': 'slider__ticks-container',
        style: this.tickContainerStyles
      }, ticks);
    },
    genTrackContainer: function genTrackContainer(h) {
      var children = [h('div', {
        'class': 'slider__track',
        style: this.trackStyles
      }), h('div', {
        'class': 'slider__track-fill',
        style: this.trackFillStyles
      })];

      return h('div', {
        'class': 'slider__track__container',
        ref: 'track'
      }, children);
    }
  },

  render: function render(h) {
    var children = [];

    children.push(this.genTrackContainer(h));
    this.step && children.push(this.genSteps(h));
    children.push(this.genThumbContainer(h));

    var slider = h('div', { 'class': 'slider' }, children);

    return this.genInputGroup([slider], {
      attrs: {
        role: 'slider',
        tabindex: this.tabindex
      },
      on: Object.assign({}, {
        mouseup: this.sliderMove,
        keydown: this.onKeyDown
      }, this.$listeners),
      directives: [{
        name: 'click-outside'
      }]
    });
  }
});

/***/ }),
/* 109 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VSubheader__ = __webpack_require__(110);


/* harmony default export */ __webpack_exports__["a"] = ({
  VSubheader: __WEBPACK_IMPORTED_MODULE_0__VSubheader__["a" /* default */]
});

/***/ }),
/* 110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  props: {
    inset: Boolean
  },

  render: function render(h, _ref) {
    var data = _ref.data,
        children = _ref.children,
        props = _ref.props;

    data.staticClass = ('subheader ' + (data.staticClass || '')).trim();

    if (props.inset) data.staticClass += ' subheader--inset';
    if (props.light) data.staticClass += ' theme--light';
    if (props.dark) data.staticClass += ' theme--dark';

    return h('li', data, children);
  }
});

/***/ }),
/* 111 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VStepper__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VStepperStep__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__VStepperContent__ = __webpack_require__(114);





var VStepperHeader = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('stepper__header');

/* harmony default export */ __webpack_exports__["a"] = ({
  VStepper: __WEBPACK_IMPORTED_MODULE_1__VStepper__["a" /* default */],
  VStepperContent: __WEBPACK_IMPORTED_MODULE_3__VStepperContent__["a" /* default */],
  VStepperHeader: VStepperHeader,
  VStepperStep: __WEBPACK_IMPORTED_MODULE_2__VStepperStep__["a" /* default */]
});

/***/ }),
/* 112 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-stepper',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  provide: function provide() {
    return {
      stepClick: this.stepClick
    };
  },
  data: function data() {
    return {
      inputValue: null,
      isBooted: false,
      steps: [],
      content: [],
      isReverse: false
    };
  },


  props: {
    nonLinear: Boolean,
    altLabels: Boolean,
    vertical: Boolean,
    value: [Number, String]
  },

  computed: {
    classes: function classes() {
      return {
        'stepper': true,
        'stepper--is-booted': this.isBooted,
        'stepper--vertical': this.vertical,
        'stepper--alt-labels': this.altLabels,
        'stepper--non-linear': this.nonLinear,
        'theme--dark': this.dark,
        'theme--light': this.light
      };
    }
  },

  watch: {
    inputValue: function inputValue(val, prev) {
      var _this = this;

      this.isReverse = Number(val) < Number(prev);
      this.steps.forEach(function (i) {
        return i.toggle(_this.inputValue);
      });
      this.content.forEach(function (i) {
        return i.toggle(_this.inputValue, _this.isReverse);
      });

      this.$emit('input', this.inputValue);
      prev && (this.isBooted = true);
    },
    value: function value() {
      this.inputValue = this.value;
    }
  },

  mounted: function mounted() {
    this.$vuetify.load(this.init);
  },


  methods: {
    init: function init() {
      var _this2 = this;

      this.$children.forEach(function (i) {
        if (i.$options._componentTag === 'v-stepper-step') {
          _this2.steps.push(i);
        } else if (i.$options._componentTag === 'v-stepper-content') {
          i.isVertical = _this2.vertical;
          _this2.content.push(i);
        }
      });

      this.inputValue = this.value || this.steps[0].step || 1;
    },
    stepClick: function stepClick(step) {
      this.inputValue = step;
    }
  },

  render: function render(h) {
    return h('div', {
      'class': this.classes
    }, this.$slots.default);
  }
});

/***/ }),
/* 113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-stepper-step',

  inject: ['stepClick'],

  data: function data() {
    return {
      isActive: false,
      isInactive: true
    };
  },


  props: {
    complete: Boolean,
    completeIcon: {
      type: String,
      default: 'check'
    },
    editIcon: {
      type: String,
      default: 'edit'
    },
    errorIcon: {
      type: String,
      default: 'warning'
    },
    editable: Boolean,
    rules: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    step: [Number, String]
  },

  computed: {
    classes: function classes() {
      return {
        'stepper__step': true,
        'stepper__step--active': this.isActive,
        'stepper__step--editable': this.editable,
        'stepper__step--inactive': this.isInactive,
        'stepper__step--error': this.hasError,
        'stepper__step--complete': this.complete
      };
    },
    hasError: function hasError() {
      return this.rules.some(function (i) {
        return i() !== true;
      });
    }
  },

  methods: {
    click: function click(e) {
      e.stopPropagation();

      if (this.editable) {
        this.stepClick(this.step);
      }
    },
    toggle: function toggle(step) {
      this.isActive = step.toString() === this.step.toString();
      this.isInactive = Number(step) < Number(this.step);
    }
  },

  render: function render(h) {
    var data = {
      'class': this.classes,
      directives: [{
        name: 'ripple',
        value: this.editable
      }],
      on: { click: this.click }
    };
    var stepContent = void 0;

    if (this.hasError) {
      stepContent = [h('v-icon', {}, this.errorIcon)];
    } else if (this.complete) {
      if (this.editable) {
        stepContent = [h('v-icon', {}, this.editIcon)];
      } else {
        stepContent = [h('v-icon', {}, this.completeIcon)];
      }
    } else {
      stepContent = this.step;
    }

    var step = h('span', { 'class': 'stepper__step__step' }, stepContent);
    var label = h('div', { 'class': 'stepper__label' }, this.$slots.default);

    return h('div', data, [step, label]);
  }
});

/***/ }),
/* 114 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-stepper-content',

  data: function data() {
    return {
      height: 0,
      isActive: false,
      isReverse: false,
      isVertical: false
    };
  },


  props: {
    step: {
      type: [Number, String],
      required: true
    }
  },

  computed: {
    classes: function classes() {
      return {
        'stepper__content': true
      };
    },
    computedTransition: function computedTransition() {
      return this.isReverse ? 'v-tab-reverse-transition' : 'v-tab-transition';
    },
    styles: function styles() {
      if (!this.isVertical) return {};

      return {
        height: !isNaN(this.height) ? this.height + 'px' : this.height
      };
    },
    wrapperClasses: function wrapperClasses() {
      return {
        'stepper__wrapper': true
      };
    }
  },

  watch: {
    isActive: function isActive() {
      if (!this.isVertical) {
        return;
      }

      if (this.isActive) {
        this.enter();
      } else {
        this.leave();
      }
    }
  },

  mounted: function mounted() {
    this.$refs.wrapper.addEventListener('transitionend', this.onTransition, false);
  },
  beforeDestroy: function beforeDestroy() {
    this.$refs.wrapper.removeEventListener('transitionend', this.onTransition, false);
  },


  methods: {
    onTransition: function onTransition() {
      if (!this.isActive) return;

      this.height = 'auto';
    },
    enter: function enter() {
      var _this = this;

      var scrollHeight = 0;

      // Render bug with height
      setTimeout(function () {
        scrollHeight = _this.$refs.wrapper.scrollHeight;
      }, 0);

      this.height = 0;

      // Give the collapsing element time to collapse
      setTimeout(function () {
        return _this.height = scrollHeight || 'auto';
      }, 450);
    },
    leave: function leave() {
      var _this2 = this;

      this.height = this.$refs.wrapper.clientHeight;
      setTimeout(function () {
        return _this2.height = 0;
      }, 0);
    },
    toggle: function toggle(step, reverse) {
      this.isActive = step.toString() === this.step.toString();
      this.isReverse = reverse;
    }
  },

  render: function render(h) {
    var contentData = {
      'class': this.classes
    };
    var wrapperData = {
      'class': this.wrapperClasses,
      style: this.styles,
      ref: 'wrapper'
    };

    if (!this.isVertical) {
      contentData.directives = [{
        name: 'show',
        value: this.isActive
      }];
    }

    var wrapper = h('div', wrapperData, [this.$slots.default]);
    var content = h('div', contentData, [wrapper]);

    return h(this.computedTransition, {
      on: this.$listeners
    }, [content]);
  }
});

/***/ }),
/* 115 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export VTableOverflow */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VDataTable__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VEditDialog__ = __webpack_require__(121);




var VTableOverflow = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('table__overflow');

/* harmony default export */ __webpack_exports__["a"] = ({
  VDataTable: __WEBPACK_IMPORTED_MODULE_1__VDataTable__["a" /* default */],
  VEditDialog: __WEBPACK_IMPORTED_MODULE_2__VEditDialog__["a" /* default */],
  VTableOverflow: VTableOverflow
});

/***/ }),
/* 116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_head__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_body__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_foot__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_progress__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_filterable__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_themeable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_buttons_VBtn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_icons_VIcon__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_progress_VProgressLinear__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_selects_VSelect__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__util_helpers__ = __webpack_require__(0);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };















/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-datatable',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_head__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_body__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixins_filterable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_foot__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_progress__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__mixins_themeable__["a" /* default */]],

  components: {
    VBtn: __WEBPACK_IMPORTED_MODULE_6__components_buttons_VBtn__["a" /* default */],
    VIcon: __WEBPACK_IMPORTED_MODULE_7__components_icons_VIcon__["a" /* default */],
    VProgressLinear: __WEBPACK_IMPORTED_MODULE_8__components_progress_VProgressLinear__["a" /* default */],
    VSelect: __WEBPACK_IMPORTED_MODULE_9__components_selects_VSelect__["a" /* default */],
    // Importing does not work properly
    'v-table-overflow': Object(__WEBPACK_IMPORTED_MODULE_10__util_helpers__["d" /* createSimpleFunctional */])('table__overflow')
  },

  data: function data() {
    return {
      all: false,
      searchLength: 0,
      defaultPagination: {
        page: 1,
        rowsPerPage: 5,
        descending: false,
        totalItems: 0
      }
    };
  },


  props: {
    headers: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    headerText: {
      type: String,
      default: 'text'
    },
    hideActions: Boolean,
    noResultsText: {
      type: String,
      default: 'No matching records found'
    },
    rowsPerPageItems: {
      type: Array,
      default: function _default() {
        return [5, 10, 25, { text: 'All', value: -1 }];
      }
    },
    rowsPerPageText: {
      type: String,
      default: 'Rows per page:'
    },
    selectAll: [Boolean, String],
    search: {
      required: false
    },
    filter: {
      type: Function,
      default: function _default(val, search) {
        return val !== null && ['undefined', 'boolean'].indexOf(typeof val === 'undefined' ? 'undefined' : _typeof(val)) === -1 && val.toString().toLowerCase().indexOf(search) !== -1;
      }
    },
    customFilter: {
      type: Function,
      default: function _default(items, search, filter) {
        search = search.toString().toLowerCase();
        return items.filter(function (i) {
          return Object.keys(i).some(function (j) {
            return filter(i[j], search);
          });
        });
      }
    },
    customSort: {
      type: Function,
      default: function _default(items, index, isDescending) {
        if (index === null) return items;

        return items.sort(function (a, b) {
          var sortA = Object(__WEBPACK_IMPORTED_MODULE_10__util_helpers__["g" /* getObjectValueByPath */])(a, index);
          var sortB = Object(__WEBPACK_IMPORTED_MODULE_10__util_helpers__["g" /* getObjectValueByPath */])(b, index);

          if (isDescending) {
            var _ref = [sortB, sortA];
            sortA = _ref[0];
            sortB = _ref[1];
          }

          // Check if both are numbers
          if (!isNaN(sortA) && !isNaN(sortB)) {
            return sortA - sortB;
          }

          // Check if both cannot be evaluated
          if (sortA === null && sortB === null) {
            return 0;
          }

          var _map = [sortA, sortB].map(function (s) {
            return (s || '').toString().toLocaleLowerCase();
          });

          var _map2 = _slicedToArray(_map, 2);

          sortA = _map2[0];
          sortB = _map2[1];


          if (sortA > sortB) return 1;
          if (sortA < sortB) return -1;

          return 0;
        });
      }
    },
    value: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    items: {
      type: Array,
      required: true,
      default: function _default() {
        return [];
      }
    },
    totalItems: {
      type: Number,
      default: null
    },
    loading: {
      type: [Boolean, String],
      default: false
    },
    selectedKey: {
      type: String,
      default: 'id'
    },
    pagination: {
      type: Object,
      default: null
    }
  },

  computed: {
    classes: function classes() {
      return {
        'datatable table': true,
        'datatable--select-all': this.selectAll !== false,
        'theme--dark': this.dark,
        'theme--light': this.light
      };
    },
    computedPagination: function computedPagination() {
      return this.pagination || this.defaultPagination;
    },
    hasSelectAll: function hasSelectAll() {
      return this.selectAll !== undefined && this.selectAll !== false;
    },
    itemsLength: function itemsLength() {
      if (this.search) return this.searchLength;
      return this.totalItems || this.items.length;
    },
    indeterminate: function indeterminate() {
      return this.hasSelectAll && this.someItems && !this.everyItem;
    },
    everyItem: function everyItem() {
      var _this = this;

      return this.filteredItems.length && this.filteredItems.every(function (i) {
        return _this.isSelected(i);
      });
    },
    someItems: function someItems() {
      var _this2 = this;

      return this.filteredItems.some(function (i) {
        return _this2.isSelected(i);
      });
    },
    getPage: function getPage() {
      var rowsPerPage = this.computedPagination.rowsPerPage;


      return rowsPerPage === Object(rowsPerPage) ? rowsPerPage.value : rowsPerPage;
    },
    pageStart: function pageStart() {
      return this.getPage === -1 ? 0 : (this.computedPagination.page - 1) * this.getPage;
    },
    pageStop: function pageStop() {
      return this.getPage === -1 ? this.itemsLength : this.computedPagination.page * this.getPage;
    },
    filteredItems: function filteredItems() {
      if (this.totalItems) return this.items;

      var items = this.items.slice();
      var hasSearch = typeof this.search !== 'undefined' && this.search !== null;

      if (hasSearch) {
        items = this.customFilter(items, this.search, this.filter);
        this.searchLength = items.length;
      }

      items = this.customSort(items, this.computedPagination.sortBy, this.computedPagination.descending);

      return this.hideActions && !this.pagination ? items : items.slice(this.pageStart, this.pageStop);
    },
    selected: function selected() {
      var _this3 = this;

      var selected = {};
      this.value.forEach(function (i) {
        return selected[i[_this3.selectedKey]] = true;
      });
      return selected;
    }
  },

  watch: {
    indeterminate: function indeterminate(val) {
      if (val) this.all = true;
    },
    someItems: function someItems(val) {
      if (!val) this.all = false;
    },
    search: function search() {
      this.updatePagination({ page: 1 });
    },
    everyItem: function everyItem(val) {
      if (val) this.all = true;
    }
  },

  methods: {
    updatePagination: function updatePagination(val) {
      var pagination = this.pagination || this.defaultPagination;
      var updatedPagination = Object.assign({}, pagination, val);

      if (this.pagination) {
        this.$emit('update:pagination', updatedPagination);
      } else {
        this.defaultPagination = updatedPagination;
      }
    },
    isSelected: function isSelected(item) {
      return this.selected[item[this.selectedKey]];
    },
    sort: function sort(index) {
      var _computedPagination = this.computedPagination,
          sortBy = _computedPagination.sortBy,
          descending = _computedPagination.descending;

      if (sortBy === null) {
        this.updatePagination({ sortBy: index, descending: false });
      } else if (sortBy === index && !descending) {
        this.updatePagination({ descending: true });
      } else if (sortBy !== index) {
        this.updatePagination({ sortBy: index, descending: false });
      } else {
        this.updatePagination({ sortBy: null, descending: null });
      }
    },
    needsTR: function needsTR(row) {
      return row.length && row.find(function (c) {
        return c.tag === 'td';
      });
    },
    genTR: function genTR(children) {
      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      return this.$createElement('tr', data, children);
    },
    toggle: function toggle(value) {
      var _this4 = this;

      var selected = Object.assign({}, this.selected);
      this.filteredItems.forEach(function (i) {
        return selected[i[_this4.selectedKey]] = value;
      });

      this.$emit('input', this.items.filter(function (i) {
        return selected[i[_this4.selectedKey]];
      }));
    }
  },

  created: function created() {
    var firstSortable = this.headers.find(function (h) {
      return !('sortable' in h) || h.sortable;
    });

    this.defaultPagination.sortBy = firstSortable ? firstSortable.value : null;

    if (!this.rowsPerPageItems.length) {
      console.warn('The prop \'rows-per-page-items\' in v-data-table can not be empty.');
    } else {
      this.defaultPagination.rowsPerPage = this.rowsPerPageItems[0];
    }

    this.updatePagination(Object.assign({}, this.defaultPagination, this.pagination));
  },
  render: function render(h) {
    return h('v-table-overflow', {}, [h('table', {
      'class': this.classes
    }, [this.genTHead(), this.genTProgress(), this.genTBody(), this.genTFoot()])]);
  }
});

/***/ }),
/* 117 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genTHead: function genTHead() {
      var _this = this;

      var children = [];

      if (this.$scopedSlots.headers) {
        var row = this.$scopedSlots.headers({
          headers: this.headers,
          indeterminate: this.indeterminate,
          all: this.all
        });

        children = this.needsTR(row) ? this.genTR(row) : row;
      } else {
        var _row = this.headers.map(function (o) {
          return _this.genHeader(o);
        });
        var checkbox = this.$createElement('v-checkbox', {
          props: {
            dark: this.dark,
            light: this.light,
            color: this.selectAll === true && '' || this.selectAll,
            hideDetails: true,
            inputValue: this.all,
            indeterminate: this.indeterminate
          },
          on: { change: this.toggle }
        });

        this.hasSelectAll && _row.unshift(this.$createElement('th', [checkbox]));

        children = this.genTR(_row);
      }

      return this.$createElement('thead', [children]);
    },
    genHeader: function genHeader(header) {
      var array = [this.$scopedSlots.headerCell ? this.$scopedSlots.headerCell({ header: header }) : header[this.headerText]];

      return this.$createElement.apply(this, ['th'].concat(_toConsumableArray(this.genHeaderData(header, array))));
    },
    genHeaderData: function genHeaderData(header, children) {
      var _this2 = this;

      var classes = ['column'];
      var data = {};
      var pagination = this.computedPagination;

      if ('sortable' in header && header.sortable || !('sortable' in header)) {
        data.on = { click: function click() {
            return _this2.sort(header.value);
          } };
        if (!('value' in header)) {
          console.warn('Data table headers must have a value property that corresponds to a value in the v-model array');
        }

        classes.push('sortable');
        var icon = this.$createElement('v-icon', 'arrow_upward');
        if (header.align && header.align === 'left') {
          children.push(icon);
        } else {
          children.unshift(icon);
        }

        var beingSorted = pagination.sortBy === header.value;
        if (beingSorted) {
          classes.push('active');
          classes.push(pagination.descending ? 'desc' : 'asc');
        }
      }

      classes.push('text-xs-' + (header.align || 'right'));
      data.class = classes;

      return [data, children];
    }
  }
});

/***/ }),
/* 118 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genTBody: function genTBody() {
      var children = [];

      if (!this.itemsLength) {
        children.push(this.genEmptyBody(this.noDataText));
      } else if (!this.filteredItems.length) {
        children.push(this.genEmptyBody(this.noResultsText));
      } else {
        children.push(this.genFilteredItems());
      }

      return this.$createElement('tbody', children);
    },
    genFilteredItems: function genFilteredItems() {
      var _this = this;

      return this.filteredItems.map(function (item, index) {
        var props = { item: item, index: index };
        var key = _this.selectedKey;

        Object.defineProperty(props, 'selected', {
          get: function get() {
            return _this.selected[item[_this.selectedKey]];
          },
          set: function set(value) {
            var selected = _this.value.slice();
            if (value) selected.push(item);else selected = selected.filter(function (i) {
              return i[key] !== item[key];
            });

            _this.$emit('input', selected);
          }
        });

        var row = _this.$scopedSlots.items(props);

        return _this.needsTR(row) ? _this.genTR(row, {
          attrs: { active: _this.isSelected(item) }
        }) : row;
      });
    },
    genEmptyBody: function genEmptyBody(text) {
      return this.genTR([this.$createElement('td', {
        'class': 'text-xs-center',
        attrs: { colspan: '100%' }
      }, text)]);
    }
  }
});

/***/ }),
/* 119 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genPrevIcon: function genPrevIcon() {
      var _this = this;

      return this.$createElement('v-btn', {
        props: {
          disabled: this.computedPagination.page === 1,
          icon: true,
          flat: true,
          dark: this.dark,
          light: this.light
        },
        on: {
          click: function click() {
            var page = _this.computedPagination.page;
            _this.updatePagination({ page: page - 1 });
          }
        }
      }, [this.$createElement('v-icon', 'chevron_left')]);
    },
    genNextIcon: function genNextIcon() {
      var _this2 = this;

      var pagination = this.computedPagination;
      var disabled = pagination.rowsPerPage < 0 || pagination.page * pagination.rowsPerPage >= this.itemsLength || this.pageStop < 0;

      return this.$createElement('v-btn', {
        props: {
          disabled: disabled,
          icon: true,
          flat: true,
          dark: this.dark,
          light: this.light
        },
        on: {
          click: function click() {
            var page = _this2.computedPagination.page;
            _this2.updatePagination({ page: page + 1 });
          }
        }
      }, [this.$createElement('v-icon', 'chevron_right')]);
    },
    genSelect: function genSelect() {
      var _this3 = this;

      return this.$createElement('div', {
        'class': 'datatable__actions__select'
      }, [this.rowsPerPageText, this.$createElement('v-select', {
        props: {
          items: this.rowsPerPageItems,
          value: this.computedPagination.rowsPerPage,
          hideDetails: true,
          auto: true,
          minWidth: '75px'
        },
        on: {
          input: function input(val) {
            _this3.updatePagination({
              page: 1,
              rowsPerPage: val
            });
          }
        }
      })]);
    },
    genPagination: function genPagination() {
      var pagination = '–';

      if (this.itemsLength) {
        var stop = this.itemsLength < this.pageStop || this.pageStop < 0 ? this.itemsLength : this.pageStop;

        pagination = this.$scopedSlots.pageText ? this.$scopedSlots.pageText({
          pageStart: this.pageStart + 1,
          pageStop: stop,
          itemsLength: this.itemsLength
        }) : this.pageStart + 1 + '-' + stop + ' of ' + this.itemsLength;
      }

      return this.$createElement('div', {
        'class': 'datatable__actions__pagination'
      }, [pagination]);
    },
    genActions: function genActions() {
      return [this.$createElement('div', {
        'class': 'datatable__actions'
      }, [this.genSelect(), this.genPagination(), this.genPrevIcon(), this.genNextIcon()])];
    },
    genTFoot: function genTFoot() {
      var children = [];

      if (this.$slots.footer) {
        var footer = this.$slots.footer;
        var row = this.needsTR(footer) ? this.genTR(footer) : footer;

        children.push(row);
      }

      if (!this.hideActions) {
        children.push(this.genTR([this.$createElement('td', {
          attrs: { colspan: '100%' }
        }, this.genActions())]));
      }

      if (!children.length) return null;
      return this.$createElement('tfoot', children);
    }
  }
});

/***/ }),
/* 120 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      color: ''
    };
  },


  watch: {
    loading: function loading(val) {
      if (val) this.color = val;
    }
  },

  methods: {
    genTProgress: function genTProgress() {
      var loader = this.$createElement('v-progress-linear', {
        props: {
          primary: this.color === 'primary',
          secondary: this.color === 'secondary',
          success: this.color === 'success',
          info: this.color === 'info',
          warning: this.color === 'warning',
          error: this.color === 'error',
          indeterminate: true,
          height: 3,
          active: !!this.loading
        }
      });

      var col = this.$createElement('th', {
        class: 'column',
        attrs: {
          colspan: '100%'
        }
      }, [loader]);

      return this.$createElement('thead', {
        class: 'datatable__progress'
      }, [this.genTR([col])]);
    }
  }
});

/***/ }),
/* 121 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-edit-dialog',

  data: function data() {
    return {
      isActive: false,
      isSaving: false
    };
  },


  props: {
    cancelText: {
      default: 'Cancel'
    },
    large: Boolean,
    lazy: Boolean,
    saveText: {
      default: 'Save'
    },
    transition: {
      type: String,
      default: 'slide-x-reverse-transition'
    }
  },

  watch: {
    isActive: function isActive(val) {
      val && this.$emit('open') && setTimeout(this.focus, 50); // Give DOM time to paint

      if (!val) {
        !this.isSaving && this.$emit('cancel');
        this.isSaving && this.$emit('close');
        this.isSaving = false;
      }
    }
  },

  methods: {
    cancel: function cancel() {
      this.isActive = false;
    },
    focus: function focus() {
      var input = this.$refs.content.querySelector('input');
      input && input.focus();
    },
    save: function save() {
      this.isSaving = true;
      this.isActive = false;
      this.$emit('save');
    },
    genButton: function genButton(fn, text) {
      return this.$createElement('v-btn', {
        props: {
          flat: true,
          primary: true,
          light: true
        },
        on: { click: fn }
      }, text);
    },
    genActions: function genActions() {
      return this.$createElement('div', {
        'class': 'small-dialog__actions',
        directives: [{
          name: 'show',
          value: this.large
        }]
      }, [this.genButton(this.cancel, this.cancelText), this.genButton(this.save, this.saveText)]);
    },
    genContent: function genContent() {
      var _this = this;

      return this.$createElement('div', {
        'class': 'small-dialog__content',
        on: {
          keydown: function keydown(e) {
            e.keyCode === 27 && _this.cancel();
            e.keyCode === 13 && _this.save();
          }
        },
        ref: 'content'
      }, [this.$slots.input]);
    }
  },

  render: function render(h) {
    var _this2 = this;

    return h('v-menu', {
      'class': 'small-dialog',
      props: {
        transition: this.transition,
        origin: 'top right',
        right: true,
        value: this.isActive,
        closeOnContentClick: false,
        lazy: this.lazy
      },
      on: {
        input: function input(val) {
          return _this2.isActive = val;
        }
      }
    }, [h('a', {
      domProps: { href: 'javascript:;' },
      slot: 'activator'
    }, this.$slots.default), this.genContent(), this.genActions()]);
  }
});

/***/ }),
/* 122 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VTabs__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VTabsItem__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__VTabsContent__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__VTabsBar__ = __webpack_require__(126);






var VTabsSlider = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('tabs__slider', 'li');

var VTabsItems = {
  name: 'v-tabs-items',

  render: function render(h) {
    return h('div', { 'class': { 'tabs__items': true } }, [this.$slots.default]);
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  VTabsItem: __WEBPACK_IMPORTED_MODULE_2__VTabsItem__["a" /* default */],
  VTabsItems: VTabsItems,
  VTabs: __WEBPACK_IMPORTED_MODULE_1__VTabs__["a" /* default */],
  VTabsContent: __WEBPACK_IMPORTED_MODULE_3__VTabsContent__["a" /* default */],
  VTabsBar: __WEBPACK_IMPORTED_MODULE_4__VTabsBar__["a" /* default */],
  VTabsSlider: VTabsSlider
});

/***/ }),
/* 123 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__directives__ = __webpack_require__(4);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-tabs',

  directives: {
    Resize: __WEBPACK_IMPORTED_MODULE_1__directives__["Resize"]
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  provide: function provide() {
    var _this = this;

    return {
      slider: this.slider,
      tabClick: this.tabClick,
      isScrollable: function isScrollable() {
        return _this.scrollable;
      },
      isMobile: function isMobile() {
        return _this.isMobile;
      }
    };
  },
  data: function data() {
    return {
      activators: [],
      activeIndex: null,
      isMobile: false,
      reverse: false,
      target: null,
      tabsSlider: null,
      targetEl: null,
      tabsContainer: null
    };
  },


  props: {
    centered: Boolean,
    fixed: Boolean,
    grow: Boolean,
    icons: Boolean,
    mobileBreakPoint: {
      type: [Number, String],
      default: 1024
    },
    value: String,
    scrollable: {
      type: Boolean,
      default: true
    }
  },

  computed: {
    classes: function classes() {
      return {
        'tabs': true,
        'tabs--centered': this.centered,
        'tabs--fixed': this.fixed,
        'tabs--grow': this.grow,
        'tabs--icons': this.icons,
        'tabs--mobile': this.isMobile,
        'tabs--scroll-bars': this.scrollable,
        'theme--dark': this.dark,
        'theme--light': this.light
      };
    }
  },

  watch: {
    value: function value() {
      this.tabClick(this.value);
    },
    activeIndex: function activeIndex() {
      this.updateTabs();
      this.$emit('input', this.target);
      this.isBooted = true;
    }
  },

  mounted: function mounted() {
    var _this2 = this;

    this.$vuetify.load(function () {
      var activators = _this2.$slots.activators;

      if (!activators || !activators.length || !activators[0].componentInstance) return;

      var bar = activators[0].componentInstance.$children;
      // // This is a workaround to detect if link is active
      // // when being used as a router or nuxt link
      var i = bar.findIndex(function (t) {
        return t.$el.firstChild.classList.contains('tabs__item--active');
      });

      var tab = _this2.value || (bar[i !== -1 ? i : 0] || {}).action;

      tab && _this2.tabClick(tab) && _this2.onResize();
    });
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', this.resize, { passive: true });
  },


  methods: {
    onResize: function onResize() {
      this.isMobile = window.innerWidth < this.mobileBreakPoint;
      this.slider();
    },
    slider: function slider(el) {
      var _this3 = this;

      this.tabsSlider = this.tabsSlider || this.$el.querySelector('.tabs__slider');

      this.tabsContainer = this.tabsContainer || this.$el.querySelector('.tabs__container');

      if (!this.tabsSlider || !this.tabsContainer) return;

      this.targetEl = el || this.targetEl;

      if (!this.targetEl || !this.tabsContainer) return;

      // Gives DOM time to paint when
      // processing slider for
      // dynamic tabs
      this.$nextTick(function () {
        // #684 Calculate width as %
        var width = _this3.targetEl.scrollWidth / _this3.tabsContainer.clientWidth * 100;

        _this3.tabsSlider.style.width = width + '%';
        _this3.tabsSlider.style.left = _this3.targetEl.offsetLeft + 'px';
      });
    },
    tabClick: function tabClick(target) {
      var _this4 = this;

      var setActiveIndex = function setActiveIndex(index) {
        if (_this4.activeIndex === index) {
          // #762 update tabs display
          // In case tabs count got changed but activeIndex didn't
          _this4.updateTabs();
        } else {
          _this4.activeIndex = index;
        }
      };

      this.target = target;

      var content = this.$refs.content;
      if (!content) {
        setActiveIndex(target);
        return;
      }

      this.$nextTick(function () {
        var nextIndex = content.$children.findIndex(function (i) {
          return i.id === target;
        });
        _this4.reverse = nextIndex < _this4.activeIndex;
        setActiveIndex(nextIndex);
      });
    },
    updateTabs: function updateTabs() {
      var _this5 = this;

      var activators = this.$slots.activators;
      var content = this.$refs.content;

      if (!activators || !activators.length || activators.length && !activators[0].componentInstance) return;

      activators[0].componentInstance.$children.filter(function (i) {
        return i.$options._componentTag === 'v-tabs-item';
      }).forEach(function (i) {
        return i.toggle(_this5.target);
      });

      content && content.$children.forEach(function (i) {
        return i.toggle(_this5.target, _this5.reverse, _this5.isBooted);
      });
    }
  },

  render: function render(h) {
    var content = [];
    var slot = [];
    var iter = this.$slots.default || [];

    iter.forEach(function (c) {
      if (!c.componentOptions) slot.push(c);else if (c.componentOptions.tag === 'v-tabs-content') content.push(c);else slot.push(c);
    });

    var tabs = content.length ? h('v-tabs-items', {
      ref: 'content'
    }, content) : null;

    return h('div', {
      'class': this.classes,
      directives: [{
        name: 'resize',
        value: this.onResize
      }]
    }, [slot, this.$slots.activators, tabs]);
  }
});

/***/ }),
/* 124 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_route_link__ = __webpack_require__(9);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-tabs-item',

  inject: ['slider', 'tabClick'],

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_route_link__["a" /* default */]],

  data: function data() {
    return {
      isActive: false
    };
  },


  props: {
    activeClass: {
      type: String,
      default: 'tabs__item--active'
    }
  },

  computed: {
    classes: function classes() {
      var classes = {
        'tabs__item': true,
        'tabs__item--disabled': this.disabled
      };

      classes[this.activeClass] = !this.to && this.isActive;

      return classes;
    },
    action: function action() {
      var to = this.to || this.href;

      if (!to || to === Object(to)) return this._uid;

      return to.replace('#', '');
    }
  },

  watch: {
    $route: function $route() {
      this.to && this.callSlider();
    }
  },

  mounted: function mounted() {
    this.callSlider();
  },


  methods: {
    callSlider: function callSlider() {
      var _this = this;

      setTimeout(function () {
        _this.$el.firstChild.classList.contains('tabs__item--active') && _this.slider(_this.$el);
      }, 0);
    },
    click: function click(e) {
      e.preventDefault();

      if (!this.to && !this.href) return;

      if (!this.to) {
        this.tabClick(this.action);
      }

      this.callSlider();
    },
    toggle: function toggle(action) {
      var _this2 = this;

      this.isActive = this.action === action;

      this.$nextTick(function () {
        _this2.isActive && _this2.slider(_this2.$el);
      });
    }
  },

  render: function render(h) {
    var _generateRouteLink = this.generateRouteLink(),
        tag = _generateRouteLink.tag,
        data = _generateRouteLink.data;

    return h('li', {
      'class': 'tabs__li'
    }, [h(tag, data, this.$slots.default)]);
  }
});

/***/ }),
/* 125 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_bootable__ = __webpack_require__(10);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-tabs-content',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_bootable__["a" /* default */]],

  data: function data() {
    return {
      isActive: false,
      reverse: false
    };
  },


  props: {
    id: {
      type: String,
      required: true
    },
    lazy: Boolean,
    transition: {
      type: String,
      default: 'v-tab-transition'
    },
    reverseTransition: {
      type: String,
      default: 'v-tab-reverse-transition'
    }
  },

  computed: {
    computedTransition: function computedTransition() {
      return this.reverse ? this.reverseTransition : this.transition;
    }
  },

  methods: {
    toggle: function toggle(target, reverse, showTransition) {
      this.$el.style.transition = !showTransition ? 'none' : null;
      this.reverse = reverse;
      this.isActive = this.id === target;
    }
  },

  render: function render(h) {
    return h(this.computedTransition, {}, [h('div', {
      'class': 'tabs__content',
      domProps: { id: this.id },
      directives: [{
        name: 'show',
        value: this.isActive
      }],
      on: this.$listeners
    }, this.lazy && this.isBooted || !this.lazy ? this.$slots.default : null)]);
  }
});

/***/ }),
/* 126 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_icons_VIcon__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__directives__ = __webpack_require__(4);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-tabs-bar',

  directives: {
    Resize: __WEBPACK_IMPORTED_MODULE_1__directives__["Resize"]
  },

  inject: ['isScrollable', 'isMobile'],

  data: function data() {
    return {
      isOverflowing: false,
      scrollOffset: 0,
      itemOffset: 0,
      startX: 0
    };
  },


  computed: {
    classes: function classes() {
      return {
        'tabs__bar': true
      };
    },
    containerClasses: function containerClasses() {
      return {
        'tabs__container': true
      };
    },
    wrapperClasses: function wrapperClasses() {
      return {
        'tabs__wrapper': true,
        'tabs__wrapper--scrollable': this.isScrollable(),
        'tabs__wrapper--overflow': this.isOverflowing
      };
    },
    containerStyles: function containerStyles() {
      return {
        'transform': 'translateX(' + -this.scrollOffset + 'px)'
      };
    },
    leftIconVisible: function leftIconVisible() {
      return !this.isMobile() && this.isScrollable() && this.isOverflowing && this.scrollOffset > 0;
    },
    rightIconVisible: function rightIconVisible() {
      if (this.isMobile() || !this.isScrollable() || !this.isOverflowing) return;

      // Check one scroll ahead to know the width of right-most item
      var container = this.$refs.container;
      var item = this.newOffsetRight(this.scrollOffset, this.itemOffset);
      var itemWidth = item && container.children[item.index].clientWidth || 0;
      var scrollOffset = this.scrollOffset + container.clientWidth;

      return container.scrollWidth - scrollOffset > itemWidth * 0.30;
    }
  },

  methods: {
    genContainer: function genContainer() {
      return this.$createElement('ul', {
        'class': this.containerClasses,
        'style': this.containerStyles,
        ref: 'container'
      }, this.$slots.default);
    },
    genIcon: function genIcon(direction) {
      var capitalize = direction.charAt(0).toUpperCase() + direction.slice(1);
      return this.$createElement(__WEBPACK_IMPORTED_MODULE_0__components_icons_VIcon__["a" /* default */], {
        props: _defineProperty({}, '' + direction, true),
        style: { display: 'inline-flex' },
        on: {
          click: this['scroll' + capitalize]
        }
      }, 'chevron_' + direction);
    },
    genWrapper: function genWrapper() {
      return this.$createElement('div', {
        class: this.wrapperClasses,
        directives: [{
          name: 'touch',
          value: {
            start: this.start,
            move: this.move,
            end: this.end
          }
        }]
      }, [this.genContainer()]);
    },
    start: function start(e) {
      this.startX = this.scrollOffset + e.touchstartX;
      this.$refs.container.style.transition = 'none';
    },
    move: function move(e) {
      var offset = this.startX - e.touchmoveX;
      this.scrollOffset = offset;
    },
    end: function end(e) {
      this.onResize();
      var container = this.$refs.container;
      var scrollWidth = container.scrollWidth - this.$el.clientWidth / 2;
      container.style.transition = null;

      if (this.scrollOffset < 0 || !this.isOverflowing) {
        this.scrollOffset = 0;
      } else if (this.scrollOffset >= scrollWidth) {
        var lastItem = container.children[container.children.length - 1];
        this.scrollOffset = scrollWidth - lastItem.clientWidth;
      }
    },
    scrollLeft: function scrollLeft() {
      var _newOffset = this.newOffset('Left'),
          offset = _newOffset.offset,
          index = _newOffset.index;

      this.scrollOffset = offset;
      this.itemOffset = index;
    },
    scrollRight: function scrollRight() {
      var _newOffset2 = this.newOffset('Right'),
          offset = _newOffset2.offset,
          index = _newOffset2.index;

      this.scrollOffset = offset;
      this.itemOffset = index;
    },
    onResize: function onResize() {
      if (this._isDestroyed) return;

      var container = this.$refs.container;
      this.isOverflowing = container.clientWidth < container.scrollWidth;
    },
    newOffset: function newOffset(direction) {
      return this['newOffset' + direction](this.scrollOffset, this.itemOffset);
    },
    newOffsetLeft: function newOffsetLeft(currentOffset, currentIndex) {
      var container = this.$refs.container;
      var items = container.children;
      var offset = 0;

      for (var index = currentIndex - 1; index >= 0; index--) {
        if (!items[index].classList.contains('tabs__slider')) {
          var newOffset = offset + items[index].clientWidth;
          if (newOffset >= container.clientWidth) {
            return { offset: currentOffset - offset, index: index + 1 };
          }
          offset = newOffset;
        }
      }

      return { offset: 0, index: 0 };
    },
    newOffsetRight: function newOffsetRight(currentOffset, currentIndex) {
      var container = this.$refs.container;
      var items = container.children;
      var offset = currentOffset;

      for (var index = currentIndex; index < items.length; index++) {
        if (!items[index].classList.contains('tabs__slider')) {
          var newOffset = offset + items[index].clientWidth;
          if (newOffset > currentOffset + container.clientWidth) {
            return { offset: offset, index: index };
          }
          offset = newOffset;
        }
      }

      return null;
    }
  },

  render: function render(h) {
    return h('div', {
      'class': this.classes,
      directives: [{
        name: 'resize',
        value: this.onResize
      }]
    }, [this.genWrapper(), this.leftIconVisible ? this.genIcon('left') : null, this.rightIconVisible ? this.genIcon('right') : null]);
  }
});

/***/ }),
/* 127 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VTextField__ = __webpack_require__(128);


/* harmony default export */ __webpack_exports__["a"] = ({
  VTextField: __WEBPACK_IMPORTED_MODULE_0__VTextField__["a" /* default */]
});

/***/ }),
/* 128 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_input__ = __webpack_require__(7);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-text-field',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_input__["a" /* default */]],

  inheritAttrs: false,

  data: function data() {
    return {
      hasFocused: false,
      inputHeight: null
    };
  },


  props: {
    autofocus: Boolean,
    autoGrow: Boolean,
    counter: Boolean,
    fullWidth: Boolean,
    max: [Number, String],
    min: [Number, String],
    multiLine: Boolean,
    placeholder: String,
    prefix: String,
    rows: {
      default: 5
    },
    singleLine: Boolean,
    solo: Boolean,
    suffix: String,
    textarea: Boolean,
    type: {
      type: String,
      default: 'text'
    }
  },

  computed: {
    classes: function classes() {
      return {
        'input-group--text-field': true,
        'input-group--single-line': this.singleLine,
        'input-group--solo': this.solo,
        'input-group--multi-line': this.multiLine,
        'input-group--full-width': this.fullWidth,
        'input-group--prefix': this.prefix,
        'input-group--suffix': this.suffix,
        'input-group--textarea': this.textarea
      };
    },
    hasError: function hasError() {
      return this.validations.length || this.errorMessages.length > 0 || !this.counterIsValid() || !this.validateIsValid() || this.error;
    },
    count: function count() {
      var inputLength = void 0;
      if (this.inputValue) inputLength = this.inputValue.toString().length;else inputLength = 0;
      var min = inputLength;

      if (this.counterMin !== 0 && inputLength < this.counterMin) {
        min = this.counterMin;
      }

      return min + ' / ' + this.counterMax;
    },
    counterMin: function counterMin() {
      var parsedMin = parseInt(this.min, 10);
      return isNaN(parsedMin) ? 0 : parsedMin;
    },
    counterMax: function counterMax() {
      var parsedMax = parseInt(this.max, 10);
      return isNaN(parsedMax) ? 25 : parsedMax;
    },

    inputValue: {
      get: function get() {
        return this.value;
      },
      set: function set(val) {
        if (this.modifiers.trim) {
          val = val.trim();
        }

        if (this.modifiers.number) {
          val = Number(val);
        }

        if (!this.modifiers.lazy) {
          this.$emit('input', val);
        }

        this.lazyValue = val;
      }
    },
    isDirty: function isDirty() {
      return this.lazyValue !== null && typeof this.lazyValue !== 'undefined' && this.lazyValue.toString().length > 0 || this.placeholder;
    }
  },

  watch: {
    focused: function focused(val) {
      this.hasFocused = true;
    },
    value: function value() {
      this.lazyValue = this.value;
      this.validate();
      this.multiLine && this.autoGrow && this.calculateInputHeight();
    }
  },

  mounted: function mounted() {
    var _this = this;

    this.$vuetify.load(function () {
      _this.multiLine && _this.autoGrow && _this.calculateInputHeight();
      _this.autofocus && _this.focus();
    });
  },


  methods: {
    calculateInputHeight: function calculateInputHeight() {
      var _this2 = this;

      this.inputHeight = null;

      this.$nextTick(function () {
        var height = _this2.$refs.input.scrollHeight;
        var minHeight = _this2.rows * 24;
        var inputHeight = height < minHeight ? minHeight : height;
        _this2.inputHeight = inputHeight;
      });
    },
    onChange: function onChange(e) {
      this.lazyValue = e.target.value;
      this.$emit('change', this.lazyValue || null);
    },
    onInput: function onInput(e) {
      this.inputValue = e.target.value;
      this.multiLine && this.autoGrow && this.calculateInputHeight();
    },
    blur: function blur(e) {
      var _this3 = this;

      this.validate();
      this.$nextTick(function () {
        return _this3.focused = false;
      });
      this.$emit('blur', e);
    },
    focus: function focus(e) {
      this.focused = true;
      this.$refs.input.focus();
      this.$emit('focus', e);
    },
    genCounter: function genCounter() {
      return this.$createElement('div', {
        'class': {
          'input-group__counter': true,
          'input-group__counter--error': !this.counterIsValid()
        }
      }, this.count);
    },
    genInput: function genInput() {
      var tag = this.multiLine || this.textarea ? 'textarea' : 'input';

      var data = {
        style: {
          'height': this.inputHeight && this.inputHeight + 'px'
        },
        domProps: {
          autofocus: this.autofocus,
          disabled: this.disabled,
          required: this.required,
          value: this.lazyValue
        },
        attrs: _extends({}, this.$attrs, {
          tabindex: this.tabindex,
          'aria-label': !this.$attrs.id && this.label // Label `for` will be set if we have an id
        }),
        on: _extends({}, this.$listeners, {
          blur: this.blur,
          input: this.onInput,
          focus: this.focus
        }),
        ref: 'input'
      };

      if (this.placeholder) data.domProps.placeholder = this.placeholder;

      if (!this.counter) {
        if (![undefined, null].includes(this.max)) data.attrs.max = this.max;
        if (![undefined, null].includes(this.min)) data.attrs.min = this.min;
      }

      if (!this.textarea && !this.multiLine) {
        data.domProps.type = this.type;
      } else {
        data.domProps.rows = this.rows;
      }

      var children = [this.$createElement(tag, data)];

      this.prefix && children.unshift(this.genFix('prefix'));
      this.suffix && children.push(this.genFix('suffix'));

      return children;
    },
    genFix: function genFix(type) {
      return this.$createElement('span', {
        'class': 'input-group--text-field__' + type
      }, this[type]);
    },

    counterIsValid: function counterIsValid() {
      var val = this.inputValue && this.inputValue.toString() || '';

      return !this.counter || val.length >= this.counterMin && val.length <= this.counterMax;
    },
    validateIsValid: function validateIsValid() {
      return !this.required || this.required && this.isDirty || !this.hasFocused || this.hasFocused && this.focused;
    }
  },

  render: function render() {
    return this.genInputGroup(this.genInput(), { attrs: { tabindex: false } });
  }
});

/***/ }),
/* 129 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VSnackbar__ = __webpack_require__(130);


/* harmony default export */ __webpack_exports__["a"] = ({
  VSnackbar: __WEBPACK_IMPORTED_MODULE_0__VSnackbar__["a" /* default */]
});

/***/ }),
/* 130 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_contextualable__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__ = __webpack_require__(2);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-snackbar',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_contextualable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__["a" /* default */]],

  data: function data() {
    return {
      activeTimeout: {}
    };
  },


  props: {
    absolute: Boolean,
    bottom: Boolean,
    left: Boolean,
    multiLine: Boolean,
    right: Boolean,
    top: Boolean,
    timeout: {
      type: Number,
      default: 6000
    },
    vertical: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'snack': true,
        'snack--active': this.isActive,
        'snack--absolute': this.absolute,
        'snack--bottom': this.bottom || !this.top,
        'snack--left': this.left,
        'snack--multi-line': this.multiLine && !this.vertical,
        'snack--right': this.right,
        'snack--top': this.top,
        'snack--vertical': this.vertical,
        'primary': this.primary,
        'secondary': this.secondary,
        'success': this.success,
        'info': this.info,
        'warning': this.warning,
        'error': this.error
      };
    },
    computedTransition: function computedTransition() {
      return this.top ? 'v-slide-y-transition' : 'v-slide-y-reverse-transition';
    }
  },

  watch: {
    isActive: function isActive() {
      var _this = this;

      clearTimeout(this.activeTimeout);

      if (this.isActive && this.timeout) {
        this.activeTimeout = setTimeout(function () {
          _this.isActive = false;
        }, this.timeout);
      }
    }
  },

  render: function render(h) {
    var children = [];

    if (this.isActive) {
      children.push(h('div', {
        'class': 'snack__content'
      }, this.$slots.default));
    }

    return h('div', {
      'class': this.classes,
      on: this.$listeners
    }, [h(this.computedTransition, children)]);
  }
});

/***/ }),
/* 131 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function load(cb) {
  var i = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

  if (document.readyState === 'complete') {
    return setTimeout(cb, 0);
  }

  if (document.readyState === 'interactive' && i <= 10) {
    return setTimeout(function () {
      return load(cb, i + 1);
    }, 200);
  }

  window.addEventListener('load', cb);
}

/* harmony default export */ __webpack_exports__["a"] = (load);

/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {exports = module.exports = SemVer;

// The debug function is excluded entirely from the minified version.
/* nomin */ var debug;
/* nomin */ if (typeof process === 'object' &&
    /* nomin */ process.env &&
    /* nomin */ process.env.NODE_DEBUG &&
    /* nomin */ /\bsemver\b/i.test(process.env.NODE_DEBUG))
  /* nomin */ debug = function() {
    /* nomin */ var args = Array.prototype.slice.call(arguments, 0);
    /* nomin */ args.unshift('SEMVER');
    /* nomin */ console.log.apply(console, args);
    /* nomin */ };
/* nomin */ else
  /* nomin */ debug = function() {};

// Note: this is the semver.org version of the spec that it implements
// Not necessarily the package version of this code.
exports.SEMVER_SPEC_VERSION = '2.0.0';

var MAX_LENGTH = 256;
var MAX_SAFE_INTEGER = Number.MAX_SAFE_INTEGER || 9007199254740991;

// The actual regexps go on exports.re
var re = exports.re = [];
var src = exports.src = [];
var R = 0;

// The following Regular Expressions can be used for tokenizing,
// validating, and parsing SemVer version strings.

// ## Numeric Identifier
// A single `0`, or a non-zero digit followed by zero or more digits.

var NUMERICIDENTIFIER = R++;
src[NUMERICIDENTIFIER] = '0|[1-9]\\d*';
var NUMERICIDENTIFIERLOOSE = R++;
src[NUMERICIDENTIFIERLOOSE] = '[0-9]+';


// ## Non-numeric Identifier
// Zero or more digits, followed by a letter or hyphen, and then zero or
// more letters, digits, or hyphens.

var NONNUMERICIDENTIFIER = R++;
src[NONNUMERICIDENTIFIER] = '\\d*[a-zA-Z-][a-zA-Z0-9-]*';


// ## Main Version
// Three dot-separated numeric identifiers.

var MAINVERSION = R++;
src[MAINVERSION] = '(' + src[NUMERICIDENTIFIER] + ')\\.' +
                   '(' + src[NUMERICIDENTIFIER] + ')\\.' +
                   '(' + src[NUMERICIDENTIFIER] + ')';

var MAINVERSIONLOOSE = R++;
src[MAINVERSIONLOOSE] = '(' + src[NUMERICIDENTIFIERLOOSE] + ')\\.' +
                        '(' + src[NUMERICIDENTIFIERLOOSE] + ')\\.' +
                        '(' + src[NUMERICIDENTIFIERLOOSE] + ')';

// ## Pre-release Version Identifier
// A numeric identifier, or a non-numeric identifier.

var PRERELEASEIDENTIFIER = R++;
src[PRERELEASEIDENTIFIER] = '(?:' + src[NUMERICIDENTIFIER] +
                            '|' + src[NONNUMERICIDENTIFIER] + ')';

var PRERELEASEIDENTIFIERLOOSE = R++;
src[PRERELEASEIDENTIFIERLOOSE] = '(?:' + src[NUMERICIDENTIFIERLOOSE] +
                                 '|' + src[NONNUMERICIDENTIFIER] + ')';


// ## Pre-release Version
// Hyphen, followed by one or more dot-separated pre-release version
// identifiers.

var PRERELEASE = R++;
src[PRERELEASE] = '(?:-(' + src[PRERELEASEIDENTIFIER] +
                  '(?:\\.' + src[PRERELEASEIDENTIFIER] + ')*))';

var PRERELEASELOOSE = R++;
src[PRERELEASELOOSE] = '(?:-?(' + src[PRERELEASEIDENTIFIERLOOSE] +
                       '(?:\\.' + src[PRERELEASEIDENTIFIERLOOSE] + ')*))';

// ## Build Metadata Identifier
// Any combination of digits, letters, or hyphens.

var BUILDIDENTIFIER = R++;
src[BUILDIDENTIFIER] = '[0-9A-Za-z-]+';

// ## Build Metadata
// Plus sign, followed by one or more period-separated build metadata
// identifiers.

var BUILD = R++;
src[BUILD] = '(?:\\+(' + src[BUILDIDENTIFIER] +
             '(?:\\.' + src[BUILDIDENTIFIER] + ')*))';


// ## Full Version String
// A main version, followed optionally by a pre-release version and
// build metadata.

// Note that the only major, minor, patch, and pre-release sections of
// the version string are capturing groups.  The build metadata is not a
// capturing group, because it should not ever be used in version
// comparison.

var FULL = R++;
var FULLPLAIN = 'v?' + src[MAINVERSION] +
                src[PRERELEASE] + '?' +
                src[BUILD] + '?';

src[FULL] = '^' + FULLPLAIN + '$';

// like full, but allows v1.2.3 and =1.2.3, which people do sometimes.
// also, 1.0.0alpha1 (prerelease without the hyphen) which is pretty
// common in the npm registry.
var LOOSEPLAIN = '[v=\\s]*' + src[MAINVERSIONLOOSE] +
                 src[PRERELEASELOOSE] + '?' +
                 src[BUILD] + '?';

var LOOSE = R++;
src[LOOSE] = '^' + LOOSEPLAIN + '$';

var GTLT = R++;
src[GTLT] = '((?:<|>)?=?)';

// Something like "2.*" or "1.2.x".
// Note that "x.x" is a valid xRange identifer, meaning "any version"
// Only the first item is strictly required.
var XRANGEIDENTIFIERLOOSE = R++;
src[XRANGEIDENTIFIERLOOSE] = src[NUMERICIDENTIFIERLOOSE] + '|x|X|\\*';
var XRANGEIDENTIFIER = R++;
src[XRANGEIDENTIFIER] = src[NUMERICIDENTIFIER] + '|x|X|\\*';

var XRANGEPLAIN = R++;
src[XRANGEPLAIN] = '[v=\\s]*(' + src[XRANGEIDENTIFIER] + ')' +
                   '(?:\\.(' + src[XRANGEIDENTIFIER] + ')' +
                   '(?:\\.(' + src[XRANGEIDENTIFIER] + ')' +
                   '(?:' + src[PRERELEASE] + ')?' +
                   src[BUILD] + '?' +
                   ')?)?';

var XRANGEPLAINLOOSE = R++;
src[XRANGEPLAINLOOSE] = '[v=\\s]*(' + src[XRANGEIDENTIFIERLOOSE] + ')' +
                        '(?:\\.(' + src[XRANGEIDENTIFIERLOOSE] + ')' +
                        '(?:\\.(' + src[XRANGEIDENTIFIERLOOSE] + ')' +
                        '(?:' + src[PRERELEASELOOSE] + ')?' +
                        src[BUILD] + '?' +
                        ')?)?';

var XRANGE = R++;
src[XRANGE] = '^' + src[GTLT] + '\\s*' + src[XRANGEPLAIN] + '$';
var XRANGELOOSE = R++;
src[XRANGELOOSE] = '^' + src[GTLT] + '\\s*' + src[XRANGEPLAINLOOSE] + '$';

// Tilde ranges.
// Meaning is "reasonably at or greater than"
var LONETILDE = R++;
src[LONETILDE] = '(?:~>?)';

var TILDETRIM = R++;
src[TILDETRIM] = '(\\s*)' + src[LONETILDE] + '\\s+';
re[TILDETRIM] = new RegExp(src[TILDETRIM], 'g');
var tildeTrimReplace = '$1~';

var TILDE = R++;
src[TILDE] = '^' + src[LONETILDE] + src[XRANGEPLAIN] + '$';
var TILDELOOSE = R++;
src[TILDELOOSE] = '^' + src[LONETILDE] + src[XRANGEPLAINLOOSE] + '$';

// Caret ranges.
// Meaning is "at least and backwards compatible with"
var LONECARET = R++;
src[LONECARET] = '(?:\\^)';

var CARETTRIM = R++;
src[CARETTRIM] = '(\\s*)' + src[LONECARET] + '\\s+';
re[CARETTRIM] = new RegExp(src[CARETTRIM], 'g');
var caretTrimReplace = '$1^';

var CARET = R++;
src[CARET] = '^' + src[LONECARET] + src[XRANGEPLAIN] + '$';
var CARETLOOSE = R++;
src[CARETLOOSE] = '^' + src[LONECARET] + src[XRANGEPLAINLOOSE] + '$';

// A simple gt/lt/eq thing, or just "" to indicate "any version"
var COMPARATORLOOSE = R++;
src[COMPARATORLOOSE] = '^' + src[GTLT] + '\\s*(' + LOOSEPLAIN + ')$|^$';
var COMPARATOR = R++;
src[COMPARATOR] = '^' + src[GTLT] + '\\s*(' + FULLPLAIN + ')$|^$';


// An expression to strip any whitespace between the gtlt and the thing
// it modifies, so that `> 1.2.3` ==> `>1.2.3`
var COMPARATORTRIM = R++;
src[COMPARATORTRIM] = '(\\s*)' + src[GTLT] +
                      '\\s*(' + LOOSEPLAIN + '|' + src[XRANGEPLAIN] + ')';

// this one has to use the /g flag
re[COMPARATORTRIM] = new RegExp(src[COMPARATORTRIM], 'g');
var comparatorTrimReplace = '$1$2$3';


// Something like `1.2.3 - 1.2.4`
// Note that these all use the loose form, because they'll be
// checked against either the strict or loose comparator form
// later.
var HYPHENRANGE = R++;
src[HYPHENRANGE] = '^\\s*(' + src[XRANGEPLAIN] + ')' +
                   '\\s+-\\s+' +
                   '(' + src[XRANGEPLAIN] + ')' +
                   '\\s*$';

var HYPHENRANGELOOSE = R++;
src[HYPHENRANGELOOSE] = '^\\s*(' + src[XRANGEPLAINLOOSE] + ')' +
                        '\\s+-\\s+' +
                        '(' + src[XRANGEPLAINLOOSE] + ')' +
                        '\\s*$';

// Star ranges basically just allow anything at all.
var STAR = R++;
src[STAR] = '(<|>)?=?\\s*\\*';

// Compile to actual regexp objects.
// All are flag-free, unless they were created above with a flag.
for (var i = 0; i < R; i++) {
  debug(i, src[i]);
  if (!re[i])
    re[i] = new RegExp(src[i]);
}

exports.parse = parse;
function parse(version, loose) {
  if (version instanceof SemVer)
    return version;

  if (typeof version !== 'string')
    return null;

  if (version.length > MAX_LENGTH)
    return null;

  var r = loose ? re[LOOSE] : re[FULL];
  if (!r.test(version))
    return null;

  try {
    return new SemVer(version, loose);
  } catch (er) {
    return null;
  }
}

exports.valid = valid;
function valid(version, loose) {
  var v = parse(version, loose);
  return v ? v.version : null;
}


exports.clean = clean;
function clean(version, loose) {
  var s = parse(version.trim().replace(/^[=v]+/, ''), loose);
  return s ? s.version : null;
}

exports.SemVer = SemVer;

function SemVer(version, loose) {
  if (version instanceof SemVer) {
    if (version.loose === loose)
      return version;
    else
      version = version.version;
  } else if (typeof version !== 'string') {
    throw new TypeError('Invalid Version: ' + version);
  }

  if (version.length > MAX_LENGTH)
    throw new TypeError('version is longer than ' + MAX_LENGTH + ' characters')

  if (!(this instanceof SemVer))
    return new SemVer(version, loose);

  debug('SemVer', version, loose);
  this.loose = loose;
  var m = version.trim().match(loose ? re[LOOSE] : re[FULL]);

  if (!m)
    throw new TypeError('Invalid Version: ' + version);

  this.raw = version;

  // these are actually numbers
  this.major = +m[1];
  this.minor = +m[2];
  this.patch = +m[3];

  if (this.major > MAX_SAFE_INTEGER || this.major < 0)
    throw new TypeError('Invalid major version')

  if (this.minor > MAX_SAFE_INTEGER || this.minor < 0)
    throw new TypeError('Invalid minor version')

  if (this.patch > MAX_SAFE_INTEGER || this.patch < 0)
    throw new TypeError('Invalid patch version')

  // numberify any prerelease numeric ids
  if (!m[4])
    this.prerelease = [];
  else
    this.prerelease = m[4].split('.').map(function(id) {
      if (/^[0-9]+$/.test(id)) {
        var num = +id;
        if (num >= 0 && num < MAX_SAFE_INTEGER)
          return num;
      }
      return id;
    });

  this.build = m[5] ? m[5].split('.') : [];
  this.format();
}

SemVer.prototype.format = function() {
  this.version = this.major + '.' + this.minor + '.' + this.patch;
  if (this.prerelease.length)
    this.version += '-' + this.prerelease.join('.');
  return this.version;
};

SemVer.prototype.toString = function() {
  return this.version;
};

SemVer.prototype.compare = function(other) {
  debug('SemVer.compare', this.version, this.loose, other);
  if (!(other instanceof SemVer))
    other = new SemVer(other, this.loose);

  return this.compareMain(other) || this.comparePre(other);
};

SemVer.prototype.compareMain = function(other) {
  if (!(other instanceof SemVer))
    other = new SemVer(other, this.loose);

  return compareIdentifiers(this.major, other.major) ||
         compareIdentifiers(this.minor, other.minor) ||
         compareIdentifiers(this.patch, other.patch);
};

SemVer.prototype.comparePre = function(other) {
  if (!(other instanceof SemVer))
    other = new SemVer(other, this.loose);

  // NOT having a prerelease is > having one
  if (this.prerelease.length && !other.prerelease.length)
    return -1;
  else if (!this.prerelease.length && other.prerelease.length)
    return 1;
  else if (!this.prerelease.length && !other.prerelease.length)
    return 0;

  var i = 0;
  do {
    var a = this.prerelease[i];
    var b = other.prerelease[i];
    debug('prerelease compare', i, a, b);
    if (a === undefined && b === undefined)
      return 0;
    else if (b === undefined)
      return 1;
    else if (a === undefined)
      return -1;
    else if (a === b)
      continue;
    else
      return compareIdentifiers(a, b);
  } while (++i);
};

// preminor will bump the version up to the next minor release, and immediately
// down to pre-release. premajor and prepatch work the same way.
SemVer.prototype.inc = function(release, identifier) {
  switch (release) {
    case 'premajor':
      this.prerelease.length = 0;
      this.patch = 0;
      this.minor = 0;
      this.major++;
      this.inc('pre', identifier);
      break;
    case 'preminor':
      this.prerelease.length = 0;
      this.patch = 0;
      this.minor++;
      this.inc('pre', identifier);
      break;
    case 'prepatch':
      // If this is already a prerelease, it will bump to the next version
      // drop any prereleases that might already exist, since they are not
      // relevant at this point.
      this.prerelease.length = 0;
      this.inc('patch', identifier);
      this.inc('pre', identifier);
      break;
    // If the input is a non-prerelease version, this acts the same as
    // prepatch.
    case 'prerelease':
      if (this.prerelease.length === 0)
        this.inc('patch', identifier);
      this.inc('pre', identifier);
      break;

    case 'major':
      // If this is a pre-major version, bump up to the same major version.
      // Otherwise increment major.
      // 1.0.0-5 bumps to 1.0.0
      // 1.1.0 bumps to 2.0.0
      if (this.minor !== 0 || this.patch !== 0 || this.prerelease.length === 0)
        this.major++;
      this.minor = 0;
      this.patch = 0;
      this.prerelease = [];
      break;
    case 'minor':
      // If this is a pre-minor version, bump up to the same minor version.
      // Otherwise increment minor.
      // 1.2.0-5 bumps to 1.2.0
      // 1.2.1 bumps to 1.3.0
      if (this.patch !== 0 || this.prerelease.length === 0)
        this.minor++;
      this.patch = 0;
      this.prerelease = [];
      break;
    case 'patch':
      // If this is not a pre-release version, it will increment the patch.
      // If it is a pre-release it will bump up to the same patch version.
      // 1.2.0-5 patches to 1.2.0
      // 1.2.0 patches to 1.2.1
      if (this.prerelease.length === 0)
        this.patch++;
      this.prerelease = [];
      break;
    // This probably shouldn't be used publicly.
    // 1.0.0 "pre" would become 1.0.0-0 which is the wrong direction.
    case 'pre':
      if (this.prerelease.length === 0)
        this.prerelease = [0];
      else {
        var i = this.prerelease.length;
        while (--i >= 0) {
          if (typeof this.prerelease[i] === 'number') {
            this.prerelease[i]++;
            i = -2;
          }
        }
        if (i === -1) // didn't increment anything
          this.prerelease.push(0);
      }
      if (identifier) {
        // 1.2.0-beta.1 bumps to 1.2.0-beta.2,
        // 1.2.0-beta.fooblz or 1.2.0-beta bumps to 1.2.0-beta.0
        if (this.prerelease[0] === identifier) {
          if (isNaN(this.prerelease[1]))
            this.prerelease = [identifier, 0];
        } else
          this.prerelease = [identifier, 0];
      }
      break;

    default:
      throw new Error('invalid increment argument: ' + release);
  }
  this.format();
  this.raw = this.version;
  return this;
};

exports.inc = inc;
function inc(version, release, loose, identifier) {
  if (typeof(loose) === 'string') {
    identifier = loose;
    loose = undefined;
  }

  try {
    return new SemVer(version, loose).inc(release, identifier).version;
  } catch (er) {
    return null;
  }
}

exports.diff = diff;
function diff(version1, version2) {
  if (eq(version1, version2)) {
    return null;
  } else {
    var v1 = parse(version1);
    var v2 = parse(version2);
    if (v1.prerelease.length || v2.prerelease.length) {
      for (var key in v1) {
        if (key === 'major' || key === 'minor' || key === 'patch') {
          if (v1[key] !== v2[key]) {
            return 'pre'+key;
          }
        }
      }
      return 'prerelease';
    }
    for (var key in v1) {
      if (key === 'major' || key === 'minor' || key === 'patch') {
        if (v1[key] !== v2[key]) {
          return key;
        }
      }
    }
  }
}

exports.compareIdentifiers = compareIdentifiers;

var numeric = /^[0-9]+$/;
function compareIdentifiers(a, b) {
  var anum = numeric.test(a);
  var bnum = numeric.test(b);

  if (anum && bnum) {
    a = +a;
    b = +b;
  }

  return (anum && !bnum) ? -1 :
         (bnum && !anum) ? 1 :
         a < b ? -1 :
         a > b ? 1 :
         0;
}

exports.rcompareIdentifiers = rcompareIdentifiers;
function rcompareIdentifiers(a, b) {
  return compareIdentifiers(b, a);
}

exports.major = major;
function major(a, loose) {
  return new SemVer(a, loose).major;
}

exports.minor = minor;
function minor(a, loose) {
  return new SemVer(a, loose).minor;
}

exports.patch = patch;
function patch(a, loose) {
  return new SemVer(a, loose).patch;
}

exports.compare = compare;
function compare(a, b, loose) {
  return new SemVer(a, loose).compare(b);
}

exports.compareLoose = compareLoose;
function compareLoose(a, b) {
  return compare(a, b, true);
}

exports.rcompare = rcompare;
function rcompare(a, b, loose) {
  return compare(b, a, loose);
}

exports.sort = sort;
function sort(list, loose) {
  return list.sort(function(a, b) {
    return exports.compare(a, b, loose);
  });
}

exports.rsort = rsort;
function rsort(list, loose) {
  return list.sort(function(a, b) {
    return exports.rcompare(a, b, loose);
  });
}

exports.gt = gt;
function gt(a, b, loose) {
  return compare(a, b, loose) > 0;
}

exports.lt = lt;
function lt(a, b, loose) {
  return compare(a, b, loose) < 0;
}

exports.eq = eq;
function eq(a, b, loose) {
  return compare(a, b, loose) === 0;
}

exports.neq = neq;
function neq(a, b, loose) {
  return compare(a, b, loose) !== 0;
}

exports.gte = gte;
function gte(a, b, loose) {
  return compare(a, b, loose) >= 0;
}

exports.lte = lte;
function lte(a, b, loose) {
  return compare(a, b, loose) <= 0;
}

exports.cmp = cmp;
function cmp(a, op, b, loose) {
  var ret;
  switch (op) {
    case '===':
      if (typeof a === 'object') a = a.version;
      if (typeof b === 'object') b = b.version;
      ret = a === b;
      break;
    case '!==':
      if (typeof a === 'object') a = a.version;
      if (typeof b === 'object') b = b.version;
      ret = a !== b;
      break;
    case '': case '=': case '==': ret = eq(a, b, loose); break;
    case '!=': ret = neq(a, b, loose); break;
    case '>': ret = gt(a, b, loose); break;
    case '>=': ret = gte(a, b, loose); break;
    case '<': ret = lt(a, b, loose); break;
    case '<=': ret = lte(a, b, loose); break;
    default: throw new TypeError('Invalid operator: ' + op);
  }
  return ret;
}

exports.Comparator = Comparator;
function Comparator(comp, loose) {
  if (comp instanceof Comparator) {
    if (comp.loose === loose)
      return comp;
    else
      comp = comp.value;
  }

  if (!(this instanceof Comparator))
    return new Comparator(comp, loose);

  debug('comparator', comp, loose);
  this.loose = loose;
  this.parse(comp);

  if (this.semver === ANY)
    this.value = '';
  else
    this.value = this.operator + this.semver.version;

  debug('comp', this);
}

var ANY = {};
Comparator.prototype.parse = function(comp) {
  var r = this.loose ? re[COMPARATORLOOSE] : re[COMPARATOR];
  var m = comp.match(r);

  if (!m)
    throw new TypeError('Invalid comparator: ' + comp);

  this.operator = m[1];
  if (this.operator === '=')
    this.operator = '';

  // if it literally is just '>' or '' then allow anything.
  if (!m[2])
    this.semver = ANY;
  else
    this.semver = new SemVer(m[2], this.loose);
};

Comparator.prototype.toString = function() {
  return this.value;
};

Comparator.prototype.test = function(version) {
  debug('Comparator.test', version, this.loose);

  if (this.semver === ANY)
    return true;

  if (typeof version === 'string')
    version = new SemVer(version, this.loose);

  return cmp(version, this.operator, this.semver, this.loose);
};


exports.Range = Range;
function Range(range, loose) {
  if ((range instanceof Range) && range.loose === loose)
    return range;

  if (!(this instanceof Range))
    return new Range(range, loose);

  this.loose = loose;

  // First, split based on boolean or ||
  this.raw = range;
  this.set = range.split(/\s*\|\|\s*/).map(function(range) {
    return this.parseRange(range.trim());
  }, this).filter(function(c) {
    // throw out any that are not relevant for whatever reason
    return c.length;
  });

  if (!this.set.length) {
    throw new TypeError('Invalid SemVer Range: ' + range);
  }

  this.format();
}

Range.prototype.format = function() {
  this.range = this.set.map(function(comps) {
    return comps.join(' ').trim();
  }).join('||').trim();
  return this.range;
};

Range.prototype.toString = function() {
  return this.range;
};

Range.prototype.parseRange = function(range) {
  var loose = this.loose;
  range = range.trim();
  debug('range', range, loose);
  // `1.2.3 - 1.2.4` => `>=1.2.3 <=1.2.4`
  var hr = loose ? re[HYPHENRANGELOOSE] : re[HYPHENRANGE];
  range = range.replace(hr, hyphenReplace);
  debug('hyphen replace', range);
  // `> 1.2.3 < 1.2.5` => `>1.2.3 <1.2.5`
  range = range.replace(re[COMPARATORTRIM], comparatorTrimReplace);
  debug('comparator trim', range, re[COMPARATORTRIM]);

  // `~ 1.2.3` => `~1.2.3`
  range = range.replace(re[TILDETRIM], tildeTrimReplace);

  // `^ 1.2.3` => `^1.2.3`
  range = range.replace(re[CARETTRIM], caretTrimReplace);

  // normalize spaces
  range = range.split(/\s+/).join(' ');

  // At this point, the range is completely trimmed and
  // ready to be split into comparators.

  var compRe = loose ? re[COMPARATORLOOSE] : re[COMPARATOR];
  var set = range.split(' ').map(function(comp) {
    return parseComparator(comp, loose);
  }).join(' ').split(/\s+/);
  if (this.loose) {
    // in loose mode, throw out any that are not valid comparators
    set = set.filter(function(comp) {
      return !!comp.match(compRe);
    });
  }
  set = set.map(function(comp) {
    return new Comparator(comp, loose);
  });

  return set;
};

// Mostly just for testing and legacy API reasons
exports.toComparators = toComparators;
function toComparators(range, loose) {
  return new Range(range, loose).set.map(function(comp) {
    return comp.map(function(c) {
      return c.value;
    }).join(' ').trim().split(' ');
  });
}

// comprised of xranges, tildes, stars, and gtlt's at this point.
// already replaced the hyphen ranges
// turn into a set of JUST comparators.
function parseComparator(comp, loose) {
  debug('comp', comp);
  comp = replaceCarets(comp, loose);
  debug('caret', comp);
  comp = replaceTildes(comp, loose);
  debug('tildes', comp);
  comp = replaceXRanges(comp, loose);
  debug('xrange', comp);
  comp = replaceStars(comp, loose);
  debug('stars', comp);
  return comp;
}

function isX(id) {
  return !id || id.toLowerCase() === 'x' || id === '*';
}

// ~, ~> --> * (any, kinda silly)
// ~2, ~2.x, ~2.x.x, ~>2, ~>2.x ~>2.x.x --> >=2.0.0 <3.0.0
// ~2.0, ~2.0.x, ~>2.0, ~>2.0.x --> >=2.0.0 <2.1.0
// ~1.2, ~1.2.x, ~>1.2, ~>1.2.x --> >=1.2.0 <1.3.0
// ~1.2.3, ~>1.2.3 --> >=1.2.3 <1.3.0
// ~1.2.0, ~>1.2.0 --> >=1.2.0 <1.3.0
function replaceTildes(comp, loose) {
  return comp.trim().split(/\s+/).map(function(comp) {
    return replaceTilde(comp, loose);
  }).join(' ');
}

function replaceTilde(comp, loose) {
  var r = loose ? re[TILDELOOSE] : re[TILDE];
  return comp.replace(r, function(_, M, m, p, pr) {
    debug('tilde', comp, _, M, m, p, pr);
    var ret;

    if (isX(M))
      ret = '';
    else if (isX(m))
      ret = '>=' + M + '.0.0 <' + (+M + 1) + '.0.0';
    else if (isX(p))
      // ~1.2 == >=1.2.0 <1.3.0
      ret = '>=' + M + '.' + m + '.0 <' + M + '.' + (+m + 1) + '.0';
    else if (pr) {
      debug('replaceTilde pr', pr);
      if (pr.charAt(0) !== '-')
        pr = '-' + pr;
      ret = '>=' + M + '.' + m + '.' + p + pr +
            ' <' + M + '.' + (+m + 1) + '.0';
    } else
      // ~1.2.3 == >=1.2.3 <1.3.0
      ret = '>=' + M + '.' + m + '.' + p +
            ' <' + M + '.' + (+m + 1) + '.0';

    debug('tilde return', ret);
    return ret;
  });
}

// ^ --> * (any, kinda silly)
// ^2, ^2.x, ^2.x.x --> >=2.0.0 <3.0.0
// ^2.0, ^2.0.x --> >=2.0.0 <3.0.0
// ^1.2, ^1.2.x --> >=1.2.0 <2.0.0
// ^1.2.3 --> >=1.2.3 <2.0.0
// ^1.2.0 --> >=1.2.0 <2.0.0
function replaceCarets(comp, loose) {
  return comp.trim().split(/\s+/).map(function(comp) {
    return replaceCaret(comp, loose);
  }).join(' ');
}

function replaceCaret(comp, loose) {
  debug('caret', comp, loose);
  var r = loose ? re[CARETLOOSE] : re[CARET];
  return comp.replace(r, function(_, M, m, p, pr) {
    debug('caret', comp, _, M, m, p, pr);
    var ret;

    if (isX(M))
      ret = '';
    else if (isX(m))
      ret = '>=' + M + '.0.0 <' + (+M + 1) + '.0.0';
    else if (isX(p)) {
      if (M === '0')
        ret = '>=' + M + '.' + m + '.0 <' + M + '.' + (+m + 1) + '.0';
      else
        ret = '>=' + M + '.' + m + '.0 <' + (+M + 1) + '.0.0';
    } else if (pr) {
      debug('replaceCaret pr', pr);
      if (pr.charAt(0) !== '-')
        pr = '-' + pr;
      if (M === '0') {
        if (m === '0')
          ret = '>=' + M + '.' + m + '.' + p + pr +
                ' <' + M + '.' + m + '.' + (+p + 1);
        else
          ret = '>=' + M + '.' + m + '.' + p + pr +
                ' <' + M + '.' + (+m + 1) + '.0';
      } else
        ret = '>=' + M + '.' + m + '.' + p + pr +
              ' <' + (+M + 1) + '.0.0';
    } else {
      debug('no pr');
      if (M === '0') {
        if (m === '0')
          ret = '>=' + M + '.' + m + '.' + p +
                ' <' + M + '.' + m + '.' + (+p + 1);
        else
          ret = '>=' + M + '.' + m + '.' + p +
                ' <' + M + '.' + (+m + 1) + '.0';
      } else
        ret = '>=' + M + '.' + m + '.' + p +
              ' <' + (+M + 1) + '.0.0';
    }

    debug('caret return', ret);
    return ret;
  });
}

function replaceXRanges(comp, loose) {
  debug('replaceXRanges', comp, loose);
  return comp.split(/\s+/).map(function(comp) {
    return replaceXRange(comp, loose);
  }).join(' ');
}

function replaceXRange(comp, loose) {
  comp = comp.trim();
  var r = loose ? re[XRANGELOOSE] : re[XRANGE];
  return comp.replace(r, function(ret, gtlt, M, m, p, pr) {
    debug('xRange', comp, ret, gtlt, M, m, p, pr);
    var xM = isX(M);
    var xm = xM || isX(m);
    var xp = xm || isX(p);
    var anyX = xp;

    if (gtlt === '=' && anyX)
      gtlt = '';

    if (xM) {
      if (gtlt === '>' || gtlt === '<') {
        // nothing is allowed
        ret = '<0.0.0';
      } else {
        // nothing is forbidden
        ret = '*';
      }
    } else if (gtlt && anyX) {
      // replace X with 0
      if (xm)
        m = 0;
      if (xp)
        p = 0;

      if (gtlt === '>') {
        // >1 => >=2.0.0
        // >1.2 => >=1.3.0
        // >1.2.3 => >= 1.2.4
        gtlt = '>=';
        if (xm) {
          M = +M + 1;
          m = 0;
          p = 0;
        } else if (xp) {
          m = +m + 1;
          p = 0;
        }
      } else if (gtlt === '<=') {
        // <=0.7.x is actually <0.8.0, since any 0.7.x should
        // pass.  Similarly, <=7.x is actually <8.0.0, etc.
        gtlt = '<';
        if (xm)
          M = +M + 1;
        else
          m = +m + 1;
      }

      ret = gtlt + M + '.' + m + '.' + p;
    } else if (xm) {
      ret = '>=' + M + '.0.0 <' + (+M + 1) + '.0.0';
    } else if (xp) {
      ret = '>=' + M + '.' + m + '.0 <' + M + '.' + (+m + 1) + '.0';
    }

    debug('xRange return', ret);

    return ret;
  });
}

// Because * is AND-ed with everything else in the comparator,
// and '' means "any version", just remove the *s entirely.
function replaceStars(comp, loose) {
  debug('replaceStars', comp, loose);
  // Looseness is ignored here.  star is always as loose as it gets!
  return comp.trim().replace(re[STAR], '');
}

// This function is passed to string.replace(re[HYPHENRANGE])
// M, m, patch, prerelease, build
// 1.2 - 3.4.5 => >=1.2.0 <=3.4.5
// 1.2.3 - 3.4 => >=1.2.0 <3.5.0 Any 3.4.x will do
// 1.2 - 3.4 => >=1.2.0 <3.5.0
function hyphenReplace($0,
                       from, fM, fm, fp, fpr, fb,
                       to, tM, tm, tp, tpr, tb) {

  if (isX(fM))
    from = '';
  else if (isX(fm))
    from = '>=' + fM + '.0.0';
  else if (isX(fp))
    from = '>=' + fM + '.' + fm + '.0';
  else
    from = '>=' + from;

  if (isX(tM))
    to = '';
  else if (isX(tm))
    to = '<' + (+tM + 1) + '.0.0';
  else if (isX(tp))
    to = '<' + tM + '.' + (+tm + 1) + '.0';
  else if (tpr)
    to = '<=' + tM + '.' + tm + '.' + tp + '-' + tpr;
  else
    to = '<=' + to;

  return (from + ' ' + to).trim();
}


// if ANY of the sets match ALL of its comparators, then pass
Range.prototype.test = function(version) {
  if (!version)
    return false;

  if (typeof version === 'string')
    version = new SemVer(version, this.loose);

  for (var i = 0; i < this.set.length; i++) {
    if (testSet(this.set[i], version))
      return true;
  }
  return false;
};

function testSet(set, version) {
  for (var i = 0; i < set.length; i++) {
    if (!set[i].test(version))
      return false;
  }

  if (version.prerelease.length) {
    // Find the set of versions that are allowed to have prereleases
    // For example, ^1.2.3-pr.1 desugars to >=1.2.3-pr.1 <2.0.0
    // That should allow `1.2.3-pr.2` to pass.
    // However, `1.2.4-alpha.notready` should NOT be allowed,
    // even though it's within the range set by the comparators.
    for (var i = 0; i < set.length; i++) {
      debug(set[i].semver);
      if (set[i].semver === ANY)
        continue;

      if (set[i].semver.prerelease.length > 0) {
        var allowed = set[i].semver;
        if (allowed.major === version.major &&
            allowed.minor === version.minor &&
            allowed.patch === version.patch)
          return true;
      }
    }

    // Version has a -pre, but it's not one of the ones we like.
    return false;
  }

  return true;
}

exports.satisfies = satisfies;
function satisfies(version, range, loose) {
  try {
    range = new Range(range, loose);
  } catch (er) {
    return false;
  }
  return range.test(version);
}

exports.maxSatisfying = maxSatisfying;
function maxSatisfying(versions, range, loose) {
  return versions.filter(function(version) {
    return satisfies(version, range, loose);
  }).sort(function(a, b) {
    return rcompare(a, b, loose);
  })[0] || null;
}

exports.minSatisfying = minSatisfying;
function minSatisfying(versions, range, loose) {
  return versions.filter(function(version) {
    return satisfies(version, range, loose);
  }).sort(function(a, b) {
    return compare(a, b, loose);
  })[0] || null;
}

exports.validRange = validRange;
function validRange(range, loose) {
  try {
    // Return '*' instead of '' so that truthiness works.
    // This will throw if it's invalid anyway
    return new Range(range, loose).range || '*';
  } catch (er) {
    return null;
  }
}

// Determine if version is less than all the versions possible in the range
exports.ltr = ltr;
function ltr(version, range, loose) {
  return outside(version, range, '<', loose);
}

// Determine if version is greater than all the versions possible in the range.
exports.gtr = gtr;
function gtr(version, range, loose) {
  return outside(version, range, '>', loose);
}

exports.outside = outside;
function outside(version, range, hilo, loose) {
  version = new SemVer(version, loose);
  range = new Range(range, loose);

  var gtfn, ltefn, ltfn, comp, ecomp;
  switch (hilo) {
    case '>':
      gtfn = gt;
      ltefn = lte;
      ltfn = lt;
      comp = '>';
      ecomp = '>=';
      break;
    case '<':
      gtfn = lt;
      ltefn = gte;
      ltfn = gt;
      comp = '<';
      ecomp = '<=';
      break;
    default:
      throw new TypeError('Must provide a hilo val of "<" or ">"');
  }

  // If it satisifes the range it is not outside
  if (satisfies(version, range, loose)) {
    return false;
  }

  // From now on, variable terms are as if we're in "gtr" mode.
  // but note that everything is flipped for the "ltr" function.

  for (var i = 0; i < range.set.length; ++i) {
    var comparators = range.set[i];

    var high = null;
    var low = null;

    comparators.forEach(function(comparator) {
      if (comparator.semver === ANY) {
        comparator = new Comparator('>=0.0.0')
      }
      high = high || comparator;
      low = low || comparator;
      if (gtfn(comparator.semver, high.semver, loose)) {
        high = comparator;
      } else if (ltfn(comparator.semver, low.semver, loose)) {
        low = comparator;
      }
    });

    // If the edge version comparator has a operator then our version
    // isn't outside it
    if (high.operator === comp || high.operator === ecomp) {
      return false;
    }

    // If the lowest version comparator has an operator and our version
    // is less than it then it isn't higher than the range
    if ((!low.operator || low.operator === comp) &&
        ltefn(version, low.semver)) {
      return false;
    } else if (low.operator === ecomp && ltfn(version, low.semver)) {
      return false;
    }
  }
  return true;
}

exports.prerelease = prerelease;
function prerelease(version, loose) {
  var parsed = parse(version, loose);
  return (parsed && parsed.prerelease.length) ? parsed.prerelease : null;
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(133)))

/***/ }),
/* 133 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ })
/******/ ]);
});
//# sourceMappingURL=vuetify.js.map

/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,t){ true?module.exports=t():"function"==typeof define&&define.amd?define("VueShortkey",[],t):"object"==typeof exports?exports.VueShortkey=t():e.VueShortkey=t()}("undefined"!=typeof self?self:this,function(){return function(e){function t(r){if(n[r])return n[r].exports;var o=n[r]={i:r,l:!1,exports:{}};return e[r].call(o.exports,o,o.exports,t),o.l=!0,o.exports}var n={};return t.m=e,t.c=n,t.d=function(e,n,r){t.o(e,n)||Object.defineProperty(e,n,{configurable:!1,enumerable:!0,get:r})},t.n=function(e){var n=e&&e.__esModule?function(){return e.default}:function(){return e};return t.d(n,"a",n),n},t.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},t.p="../dist/",t(t.s=0)}([function(e,t,n){"use strict";(function(r){function o(e){if(Array.isArray(e)){for(var t=0,n=Array(e.length);t<e.length;t++)n[t]=e[t];return n}return Array.from(e)}var c;n(2),n(3);var u={},i={},a=[],l=[],s=!1,f=function(e){return e="string"==typeof e?JSON.parse(e.replace(/\'/gi,'"')):e,e instanceof Array?{"":e}:e},p=function(e,t,n,r){var o=!0===n.modifiers.push,c=!0===n.modifiers.avoid,u=!0==!n.modifiers.focus,i=!0===n.modifiers.once;c?(a=a.filter(function(e){return!e===t}),a.push(t)):v({b:e,push:o,once:i,focus:u,el:r.elm})},y=function(e,t){for(var n in e){var r=u.encodeKey(e[n]),o=i[r].el.indexOf(t);i[r].el.length>1&&o>-1?i[r].el.splice(o,1):delete i[r]}};u.install=function(e,t){l=[].concat(o(t&&t.prevent?t.prevent:[])),e.directive("shortkey",{bind:function(e,t,n){var r=f(t.value);p(r,e,t,n)},update:function(e,t,n){var r=f(t.oldValue);y(r,e);var o=f(t.value);p(o,e,t,n)},unbind:function(e,t){var n=f(t.value);y(n,e)}})},u.decodeKey=function(e){return d(e)},u.encodeKey=function(e){var t={};t.shiftKey=e.includes("shift"),t.ctrlKey=e.includes("ctrl"),t.metaKey=e.includes("meta"),t.altKey=e.includes("alt");var n=d(t);return n+=e.filter(function(e){return!["shift","ctrl","meta","alt"].includes(e)}).join("")};var d=function(e){var t="";return("Shift"===e.key||e.shiftKey)&&(t+="shift"),("Control"===e.key||e.ctrlKey)&&(t+="ctrl"),("Meta"===e.key||e.metaKey)&&(t+="meta"),("Alt"===e.key||e.altKey)&&(t+="alt"),"ArrowUp"===e.key&&(t+="arrowup"),"ArrowLeft"===e.key&&(t+="arrowleft"),"ArrowRight"===e.key&&(t+="arrowright"),"ArrowDown"===e.key&&(t+="arrowdown"),"AltGraph"===e.key&&(t+="altgraph"),"Escape"===e.key&&(t+="esc"),"Enter"===e.key&&(t+="enter"),"Tab"===e.key&&(t+="tab")," "===e.key&&(t+="space"),"PageUp"===e.key&&(t+="pageup"),"PageDown"===e.key&&(t+="pagedown"),"Home"===e.key&&(t+="home"),"End"===e.key&&(t+="end"),"Delete"===e.key&&(t+="del"),"Backspace"===e.key&&(t+="backspace"),"Insert"===e.key&&(t+="insert"),"NumLock"===e.key&&(t+="numlock"),"CapsLock"===e.key&&(t+="capslock"),"Pause"===e.key&&(t+="pause"),"ContextMenu"===e.key&&(t+="contextmenu"),"ScrollLock"===e.key&&(t+="scrolllock"),"BrowserHome"===e.key&&(t+="browserhome"),"MediaSelect"===e.key&&(t+="mediaselect"),(e.key&&" "!==e.key&&1===e.key.length||/F\d{1,2}|\//g.test(e.key))&&(t+=e.key.toLowerCase()),t},h=function(e){var t=new CustomEvent("shortkey",{bubbles:!1});i[e].key&&(t.srcKey=i[e].key);var n=i[e].el;n[n.length-1].dispatchEvent(t)};u.keyDown=function(e){(!i[e].once&&!i[e].push||i[e].push&&!s)&&h(e)},r&&Object({NODE_ENV:"production"})&&function(){document.addEventListener("keydown",function(e){var t=u.decodeKey(e);if(m(t))if(e.preventDefault(),e.stopPropagation(),i[t].focus)u.keyDown(t),s=!0;else if(!s){var n=i[t].el;n[n.length-1].focus(),s=!0}},!0),document.addEventListener("keyup",function(e){var t=u.decodeKey(e);m(t)&&(e.preventDefault(),e.stopPropagation(),(i[t].once||i[t].push)&&h(t)),s=!1},!0)}();var v=function(e){var t=e.b,n=e.push,r=e.once,o=e.focus,c=e.el;for(var a in t){var l=u.encodeKey(t[a]),s=i[l]&&i[l].el?i[l].el:[];s.push(c),i[l]={push:n,once:r,focus:o,key:a,el:s}}},m=function(e){var t=!!a.find(function(e){return e===document.activeElement}),n=!!l.find(function(e){return document.activeElement&&document.activeElement.matches(e)});return!!i[e]&&!(t||n)};void 0!==e&&e.exports?e.exports=u:void 0!==(c=function(){return u}.call(t,n,t,e))&&(e.exports=c)}).call(t,n(1))},function(e,t){function n(){throw new Error("setTimeout has not been defined")}function r(){throw new Error("clearTimeout has not been defined")}function o(e){if(s===setTimeout)return setTimeout(e,0);if((s===n||!s)&&setTimeout)return s=setTimeout,setTimeout(e,0);try{return s(e,0)}catch(t){try{return s.call(null,e,0)}catch(t){return s.call(this,e,0)}}}function c(e){if(f===clearTimeout)return clearTimeout(e);if((f===r||!f)&&clearTimeout)return f=clearTimeout,clearTimeout(e);try{return f(e)}catch(t){try{return f.call(null,e)}catch(t){return f.call(this,e)}}}function u(){h&&y&&(h=!1,y.length?d=y.concat(d):v=-1,d.length&&i())}function i(){if(!h){var e=o(u);h=!0;for(var t=d.length;t;){for(y=d,d=[];++v<t;)y&&y[v].run();v=-1,t=d.length}y=null,h=!1,c(e)}}function a(e,t){this.fun=e,this.array=t}function l(){}var s,f,p=e.exports={};!function(){try{s="function"==typeof setTimeout?setTimeout:n}catch(e){s=n}try{f="function"==typeof clearTimeout?clearTimeout:r}catch(e){f=r}}();var y,d=[],h=!1,v=-1;p.nextTick=function(e){var t=new Array(arguments.length-1);if(arguments.length>1)for(var n=1;n<arguments.length;n++)t[n-1]=arguments[n];d.push(new a(e,t)),1!==d.length||h||o(i)},a.prototype.run=function(){this.fun.apply(null,this.array)},p.title="browser",p.browser=!0,p.env={},p.argv=[],p.version="",p.versions={},p.on=l,p.addListener=l,p.once=l,p.off=l,p.removeListener=l,p.removeAllListeners=l,p.emit=l,p.prependListener=l,p.prependOnceListener=l,p.listeners=function(e){return[]},p.binding=function(e){throw new Error("process.binding is not supported")},p.cwd=function(){return"/"},p.chdir=function(e){throw new Error("process.chdir is not supported")},p.umask=function(){return 0}},function(e,t){Element.prototype.matches||(Element.prototype.matches=Element.prototype.matchesSelector||Element.prototype.msMatchesSelector||Element.prototype.webkitMatchesSelector)},function(e,t){!function(){if("undefined"!=typeof window)try{var e=new window.CustomEvent("test",{cancelable:!0});if(e.preventDefault(),!0!==e.defaultPrevented)throw new Error("Could not prevent default")}catch(e){var t=function(e,t){var n,r;return t=t||{},t.bubbles=!!t.bubbles,t.cancelable=!!t.cancelable,n=document.createEvent("CustomEvent"),n.initCustomEvent(e,t.bubbles,t.cancelable,t.detail),r=n.preventDefault,n.preventDefault=function(){r.call(this);try{Object.defineProperty(this,"defaultPrevented",{get:function(){return!0}})}catch(e){this.defaultPrevented=!0}},n};t.prototype=window.Event.prototype,window.CustomEvent=t}}()}])});
//# sourceMappingURL=index.js.map

/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

(function (global, factory) {
   true ? factory(__webpack_require__(91)) :
  typeof define === 'function' && define.amd ? define(['hammerjs'], factory) :
  (factory(global.Hammer));
}(this, (function (Hammer) { 'use strict';

Hammer = 'default' in Hammer ? Hammer['default'] : Hammer;

function assign(target) {
  var sources = [], len = arguments.length - 1;
  while ( len-- > 0 ) sources[ len ] = arguments[ len + 1 ];
  for (var i = 0; i < sources.length; i++) {
    var source = sources[i];
    var keys = Object.keys(source);
    for (var i$1 = 0; i$1 < keys.length; i$1++) {
      var key = keys[i$1];
      target[key] = source[key];
    }
  }
  return target
}
function createProp() {
  return {
    type: Object,
    default: function() { return {} }
  }
}
function capitalize (str) {
  return str.charAt(0).toUpperCase() + str.slice(1)
}
var directions = ['up', 'down', 'left', 'right', 'horizontal', 'vertical', 'all'];
function guardDirections (options) {
  var dir = options.direction;
  if (typeof dir === 'string') {
    var hammerDirection = 'DIRECTION_' + dir.toUpperCase();
    if (directions.indexOf(dir) > -1 && Hammer.hasOwnProperty(hammerDirection)) {
      options.direction = Hammer[hammerDirection];
    } else {
      console.warn('[vue-touch] invalid direction: ' + dir);
    }
  }
  return options
}
var config = {
};
var customEvents = {
};
var gestures = [
  'pan','panstart','panmove','panend','pancancel','panleft','panright','panup','pandown',
  'pinch','pinchstart','pinchmove','pinchend','pinchcancel','pinchin','pinchout',
  'press','pressup',
  'rotate','rotatestart','rotatemove','rotateend','rotatecancel',
  'swipe','swipeleft','swiperight','swipeup','swipedown',
  'tap'
];
var gestureMap = {
  pan: 'pan',
  panstart: 'pan',
  panmove: 'pan',
  panend: 'pan',
  pancancel: 'pan',
  panleft: 'pan',
  panright: 'pan',
  panup: 'pan',
  pandown: 'pan',
  pinch: 'pinch',
  pinchstart: 'pinch',
  pinchmove: 'pinch',
  pinchend: 'pinch',
  pinchcancel: 'pinch',
  pinchin: 'pinch',
  pinchout: 'pinch',
  press: 'press',
  pressup: 'press',
  rotate: 'rotate',
  rotatestart: 'rotate',
  rotatemove: 'rotate',
  rotateend: 'rotate',
  rotatecancel: 'rotate',
  swipe: 'swipe',
  swipeleft: 'swipe',
  swiperight: 'swipe',
  swipeup: 'swipe',
  swipedown: 'swipe',
  tap: 'tap'
};

var Component = {
  props: {
    options: createProp(),
    tapOptions: createProp(),
    panOptions: createProp(),
    pinchOptions: createProp(),
    pressOptions: createProp(),
    rotateOptions: createProp(),
    swipeOptions: createProp(),
    tag: { type: String, default: 'div' },
    enabled: {
      default: true,
      type: [Boolean, Object],
    }
  },
  mounted: function mounted() {
    if (!this.$isServer) {
      this.hammer = new Hammer.Manager(this.$el, this.options);
      this.recognizers = {};
      this.setupBuiltinRecognizers();
      this.setupCustomRecognizers();
      this.updateEnabled(this.enabled);
    }
  },
  destroyed: function destroyed() {
    if (!this.$isServer) {
      this.hammer.destroy();
    }
  },
  watch: {
    enabled: {
      deep: true,
      handler: function handler() {
        var args = [], len = arguments.length;
        while ( len-- ) args[ len ] = arguments[ len ];
        (ref = this).updateEnabled.apply(ref, args);
        var ref;
      }
    }
  },
  methods: {
    setupBuiltinRecognizers: function setupBuiltinRecognizers()  {
      var this$1 = this;
      for (var i = 0; i < gestures.length; i++) {
        var gesture = gestures[i];
        if (this$1._events[gesture]) {
          var mainGesture = gestureMap[gesture];
          var options = assign({}, (config[mainGesture] || {}), this$1[(mainGesture + "Options")]);
          this$1.addRecognizer(mainGesture, options);
          this$1.addEvent(gesture);
        }
      }
    },
    setupCustomRecognizers: function setupCustomRecognizers() {
      var this$1 = this;
      var gestures$$1 = Object.keys(customEvents);
      for (var i = 0; i < gestures$$1.length; i++) {
        var gesture = gestures$$1[i];
        if (this$1._events[gesture]) {
          var opts = customEvents[gesture];
          var localCustomOpts = this$1[(gesture + "Options")] || {};
          var options = assign({}, opts, localCustomOpts);
          this$1.addRecognizer(gesture, options, {mainGesture: options.type});
          this$1.addEvent(gesture);
        }
      }
    },
    addRecognizer: function addRecognizer(gesture, options, ref) {
      if ( ref === void 0 ) ref = {};
      var mainGesture = ref.mainGesture;
      if (!this.recognizers[gesture]) {
        var recognizer = new Hammer[capitalize(mainGesture || gesture)](guardDirections(options));
        this.recognizers[gesture] = recognizer;
        this.hammer.add(recognizer);
        recognizer.recognizeWith(this.hammer.recognizers);
      }
    },
    addEvent: function addEvent(gesture) {
      var this$1 = this;
      this.hammer.on(gesture, function (e) { return this$1.$emit(gesture, e); });
    },
    updateEnabled: function updateEnabled(newVal, oldVal) {
      var this$1 = this;
      if (newVal === true) {
        this.enableAll();
      } else if (newVal === false) {
        this.disableAll();
      } else if (typeof newVal === 'object') {
        var keys = Object.keys(newVal);
        for (var i = 0; i < keys.length; i++) {
          var event = keys[i];
          if (this$1.recognizers[event]) {
            newVal[event]
              ? this$1.enable(event)
              : this$1.disable(event);
          }
        }
      }
    },
    enable: function enable(r) {
      var recognizer = this.recognizers[r];
      if (!recognizer.options.enable) {
        recognizer.set({ enable: true });
      }
    },
    disable: function disable(r) {
      var recognizer = this.recognizers[r];
      if (recognizer.options.enable) {
        recognizer.set({ enable: false });
      }
    },
    toggle: function toggle(r) {
      var recognizer = this.recognizers[r];
      if (recognizer) {
        recognizer.options.enable
          ? this.disable(r)
          : this.enable(r);
      }
    },
    enableAll: function enableAll(r) {
      this.toggleAll({ enable: true });
    },
    disableAll: function disableAll(r) {
      this.toggleAll({ enable: false });
    },
    toggleAll: function toggleAll(ref) {
      var this$1 = this;
      var enable = ref.enable;
      var keys = Object.keys(this.recognizers);
      for (var i = 0; i < keys.length; i++) {
        var r = this$1.recognizers[keys[i]];
        if (r.options.enable !== enable) {
          r.set({ enable: enable });
        }
      }
    },
    isEnabled: function isEnabled(r) {
      return this.recognizers[r] && this.recognizers[r].options.enable
    }
  },
  render: function render(h) {
    return h(this.tag, {}, this.$slots.default)
  }
};

var installed = false;
var vueTouch = { config: config, customEvents: customEvents };
vueTouch.install = function install(Vue, opts) {
  if ( opts === void 0 ) opts = {};
  var name = opts.name || 'v-touch';
  Vue.component(name, assign(Component, { name: name }));
  installed = true;
}.bind(vueTouch);
vueTouch.registerCustomEvent = function registerCustomEvent(event, options) {
  if ( options === void 0 ) options = {};
  if (installed) {
    console.warn(("\n      [vue-touch]: Custom Event '" + event + "' couldn't be added to vue-touch.\n      Custom Events have to be registered before installing the plugin.\n      "));
    return
  }
  options.event = event;
  customEvents[event] = options;
  Component.props[(event + "Options")] = {
    type: Object,
    default: function default$1() { return {} }
  };
}.bind(vueTouch);
vueTouch.component = Component;
if (true) {
  module.exports = vueTouch;
} else if (typeof define == "function" && define.amd) {
  define([], function(){ return vueTouch });
} else if (typeof window !== 'undefined' && window.Vue) {
  window.VueTouch = vueTouch;
  Vue.use(vueTouch);
}

})));
//# sourceMappingURL=vue-touch.js.map


/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/*! Hammer.JS - v2.0.7 - 2016-04-22
 * http://hammerjs.github.io/
 *
 * Copyright (c) 2016 Jorik Tangelder;
 * Licensed under the MIT license */
(function(window, document, exportName, undefined) {
  'use strict';

var VENDOR_PREFIXES = ['', 'webkit', 'Moz', 'MS', 'ms', 'o'];
var TEST_ELEMENT = document.createElement('div');

var TYPE_FUNCTION = 'function';

var round = Math.round;
var abs = Math.abs;
var now = Date.now;

/**
 * set a timeout with a given scope
 * @param {Function} fn
 * @param {Number} timeout
 * @param {Object} context
 * @returns {number}
 */
function setTimeoutContext(fn, timeout, context) {
    return setTimeout(bindFn(fn, context), timeout);
}

/**
 * if the argument is an array, we want to execute the fn on each entry
 * if it aint an array we don't want to do a thing.
 * this is used by all the methods that accept a single and array argument.
 * @param {*|Array} arg
 * @param {String} fn
 * @param {Object} [context]
 * @returns {Boolean}
 */
function invokeArrayArg(arg, fn, context) {
    if (Array.isArray(arg)) {
        each(arg, context[fn], context);
        return true;
    }
    return false;
}

/**
 * walk objects and arrays
 * @param {Object} obj
 * @param {Function} iterator
 * @param {Object} context
 */
function each(obj, iterator, context) {
    var i;

    if (!obj) {
        return;
    }

    if (obj.forEach) {
        obj.forEach(iterator, context);
    } else if (obj.length !== undefined) {
        i = 0;
        while (i < obj.length) {
            iterator.call(context, obj[i], i, obj);
            i++;
        }
    } else {
        for (i in obj) {
            obj.hasOwnProperty(i) && iterator.call(context, obj[i], i, obj);
        }
    }
}

/**
 * wrap a method with a deprecation warning and stack trace
 * @param {Function} method
 * @param {String} name
 * @param {String} message
 * @returns {Function} A new function wrapping the supplied method.
 */
function deprecate(method, name, message) {
    var deprecationMessage = 'DEPRECATED METHOD: ' + name + '\n' + message + ' AT \n';
    return function() {
        var e = new Error('get-stack-trace');
        var stack = e && e.stack ? e.stack.replace(/^[^\(]+?[\n$]/gm, '')
            .replace(/^\s+at\s+/gm, '')
            .replace(/^Object.<anonymous>\s*\(/gm, '{anonymous}()@') : 'Unknown Stack Trace';

        var log = window.console && (window.console.warn || window.console.log);
        if (log) {
            log.call(window.console, deprecationMessage, stack);
        }
        return method.apply(this, arguments);
    };
}

/**
 * extend object.
 * means that properties in dest will be overwritten by the ones in src.
 * @param {Object} target
 * @param {...Object} objects_to_assign
 * @returns {Object} target
 */
var assign;
if (typeof Object.assign !== 'function') {
    assign = function assign(target) {
        if (target === undefined || target === null) {
            throw new TypeError('Cannot convert undefined or null to object');
        }

        var output = Object(target);
        for (var index = 1; index < arguments.length; index++) {
            var source = arguments[index];
            if (source !== undefined && source !== null) {
                for (var nextKey in source) {
                    if (source.hasOwnProperty(nextKey)) {
                        output[nextKey] = source[nextKey];
                    }
                }
            }
        }
        return output;
    };
} else {
    assign = Object.assign;
}

/**
 * extend object.
 * means that properties in dest will be overwritten by the ones in src.
 * @param {Object} dest
 * @param {Object} src
 * @param {Boolean} [merge=false]
 * @returns {Object} dest
 */
var extend = deprecate(function extend(dest, src, merge) {
    var keys = Object.keys(src);
    var i = 0;
    while (i < keys.length) {
        if (!merge || (merge && dest[keys[i]] === undefined)) {
            dest[keys[i]] = src[keys[i]];
        }
        i++;
    }
    return dest;
}, 'extend', 'Use `assign`.');

/**
 * merge the values from src in the dest.
 * means that properties that exist in dest will not be overwritten by src
 * @param {Object} dest
 * @param {Object} src
 * @returns {Object} dest
 */
var merge = deprecate(function merge(dest, src) {
    return extend(dest, src, true);
}, 'merge', 'Use `assign`.');

/**
 * simple class inheritance
 * @param {Function} child
 * @param {Function} base
 * @param {Object} [properties]
 */
function inherit(child, base, properties) {
    var baseP = base.prototype,
        childP;

    childP = child.prototype = Object.create(baseP);
    childP.constructor = child;
    childP._super = baseP;

    if (properties) {
        assign(childP, properties);
    }
}

/**
 * simple function bind
 * @param {Function} fn
 * @param {Object} context
 * @returns {Function}
 */
function bindFn(fn, context) {
    return function boundFn() {
        return fn.apply(context, arguments);
    };
}

/**
 * let a boolean value also be a function that must return a boolean
 * this first item in args will be used as the context
 * @param {Boolean|Function} val
 * @param {Array} [args]
 * @returns {Boolean}
 */
function boolOrFn(val, args) {
    if (typeof val == TYPE_FUNCTION) {
        return val.apply(args ? args[0] || undefined : undefined, args);
    }
    return val;
}

/**
 * use the val2 when val1 is undefined
 * @param {*} val1
 * @param {*} val2
 * @returns {*}
 */
function ifUndefined(val1, val2) {
    return (val1 === undefined) ? val2 : val1;
}

/**
 * addEventListener with multiple events at once
 * @param {EventTarget} target
 * @param {String} types
 * @param {Function} handler
 */
function addEventListeners(target, types, handler) {
    each(splitStr(types), function(type) {
        target.addEventListener(type, handler, false);
    });
}

/**
 * removeEventListener with multiple events at once
 * @param {EventTarget} target
 * @param {String} types
 * @param {Function} handler
 */
function removeEventListeners(target, types, handler) {
    each(splitStr(types), function(type) {
        target.removeEventListener(type, handler, false);
    });
}

/**
 * find if a node is in the given parent
 * @method hasParent
 * @param {HTMLElement} node
 * @param {HTMLElement} parent
 * @return {Boolean} found
 */
function hasParent(node, parent) {
    while (node) {
        if (node == parent) {
            return true;
        }
        node = node.parentNode;
    }
    return false;
}

/**
 * small indexOf wrapper
 * @param {String} str
 * @param {String} find
 * @returns {Boolean} found
 */
function inStr(str, find) {
    return str.indexOf(find) > -1;
}

/**
 * split string on whitespace
 * @param {String} str
 * @returns {Array} words
 */
function splitStr(str) {
    return str.trim().split(/\s+/g);
}

/**
 * find if a array contains the object using indexOf or a simple polyFill
 * @param {Array} src
 * @param {String} find
 * @param {String} [findByKey]
 * @return {Boolean|Number} false when not found, or the index
 */
function inArray(src, find, findByKey) {
    if (src.indexOf && !findByKey) {
        return src.indexOf(find);
    } else {
        var i = 0;
        while (i < src.length) {
            if ((findByKey && src[i][findByKey] == find) || (!findByKey && src[i] === find)) {
                return i;
            }
            i++;
        }
        return -1;
    }
}

/**
 * convert array-like objects to real arrays
 * @param {Object} obj
 * @returns {Array}
 */
function toArray(obj) {
    return Array.prototype.slice.call(obj, 0);
}

/**
 * unique array with objects based on a key (like 'id') or just by the array's value
 * @param {Array} src [{id:1},{id:2},{id:1}]
 * @param {String} [key]
 * @param {Boolean} [sort=False]
 * @returns {Array} [{id:1},{id:2}]
 */
function uniqueArray(src, key, sort) {
    var results = [];
    var values = [];
    var i = 0;

    while (i < src.length) {
        var val = key ? src[i][key] : src[i];
        if (inArray(values, val) < 0) {
            results.push(src[i]);
        }
        values[i] = val;
        i++;
    }

    if (sort) {
        if (!key) {
            results = results.sort();
        } else {
            results = results.sort(function sortUniqueArray(a, b) {
                return a[key] > b[key];
            });
        }
    }

    return results;
}

/**
 * get the prefixed property
 * @param {Object} obj
 * @param {String} property
 * @returns {String|Undefined} prefixed
 */
function prefixed(obj, property) {
    var prefix, prop;
    var camelProp = property[0].toUpperCase() + property.slice(1);

    var i = 0;
    while (i < VENDOR_PREFIXES.length) {
        prefix = VENDOR_PREFIXES[i];
        prop = (prefix) ? prefix + camelProp : property;

        if (prop in obj) {
            return prop;
        }
        i++;
    }
    return undefined;
}

/**
 * get a unique id
 * @returns {number} uniqueId
 */
var _uniqueId = 1;
function uniqueId() {
    return _uniqueId++;
}

/**
 * get the window object of an element
 * @param {HTMLElement} element
 * @returns {DocumentView|Window}
 */
function getWindowForElement(element) {
    var doc = element.ownerDocument || element;
    return (doc.defaultView || doc.parentWindow || window);
}

var MOBILE_REGEX = /mobile|tablet|ip(ad|hone|od)|android/i;

var SUPPORT_TOUCH = ('ontouchstart' in window);
var SUPPORT_POINTER_EVENTS = prefixed(window, 'PointerEvent') !== undefined;
var SUPPORT_ONLY_TOUCH = SUPPORT_TOUCH && MOBILE_REGEX.test(navigator.userAgent);

var INPUT_TYPE_TOUCH = 'touch';
var INPUT_TYPE_PEN = 'pen';
var INPUT_TYPE_MOUSE = 'mouse';
var INPUT_TYPE_KINECT = 'kinect';

var COMPUTE_INTERVAL = 25;

var INPUT_START = 1;
var INPUT_MOVE = 2;
var INPUT_END = 4;
var INPUT_CANCEL = 8;

var DIRECTION_NONE = 1;
var DIRECTION_LEFT = 2;
var DIRECTION_RIGHT = 4;
var DIRECTION_UP = 8;
var DIRECTION_DOWN = 16;

var DIRECTION_HORIZONTAL = DIRECTION_LEFT | DIRECTION_RIGHT;
var DIRECTION_VERTICAL = DIRECTION_UP | DIRECTION_DOWN;
var DIRECTION_ALL = DIRECTION_HORIZONTAL | DIRECTION_VERTICAL;

var PROPS_XY = ['x', 'y'];
var PROPS_CLIENT_XY = ['clientX', 'clientY'];

/**
 * create new input type manager
 * @param {Manager} manager
 * @param {Function} callback
 * @returns {Input}
 * @constructor
 */
function Input(manager, callback) {
    var self = this;
    this.manager = manager;
    this.callback = callback;
    this.element = manager.element;
    this.target = manager.options.inputTarget;

    // smaller wrapper around the handler, for the scope and the enabled state of the manager,
    // so when disabled the input events are completely bypassed.
    this.domHandler = function(ev) {
        if (boolOrFn(manager.options.enable, [manager])) {
            self.handler(ev);
        }
    };

    this.init();

}

Input.prototype = {
    /**
     * should handle the inputEvent data and trigger the callback
     * @virtual
     */
    handler: function() { },

    /**
     * bind the events
     */
    init: function() {
        this.evEl && addEventListeners(this.element, this.evEl, this.domHandler);
        this.evTarget && addEventListeners(this.target, this.evTarget, this.domHandler);
        this.evWin && addEventListeners(getWindowForElement(this.element), this.evWin, this.domHandler);
    },

    /**
     * unbind the events
     */
    destroy: function() {
        this.evEl && removeEventListeners(this.element, this.evEl, this.domHandler);
        this.evTarget && removeEventListeners(this.target, this.evTarget, this.domHandler);
        this.evWin && removeEventListeners(getWindowForElement(this.element), this.evWin, this.domHandler);
    }
};

/**
 * create new input type manager
 * called by the Manager constructor
 * @param {Hammer} manager
 * @returns {Input}
 */
function createInputInstance(manager) {
    var Type;
    var inputClass = manager.options.inputClass;

    if (inputClass) {
        Type = inputClass;
    } else if (SUPPORT_POINTER_EVENTS) {
        Type = PointerEventInput;
    } else if (SUPPORT_ONLY_TOUCH) {
        Type = TouchInput;
    } else if (!SUPPORT_TOUCH) {
        Type = MouseInput;
    } else {
        Type = TouchMouseInput;
    }
    return new (Type)(manager, inputHandler);
}

/**
 * handle input events
 * @param {Manager} manager
 * @param {String} eventType
 * @param {Object} input
 */
function inputHandler(manager, eventType, input) {
    var pointersLen = input.pointers.length;
    var changedPointersLen = input.changedPointers.length;
    var isFirst = (eventType & INPUT_START && (pointersLen - changedPointersLen === 0));
    var isFinal = (eventType & (INPUT_END | INPUT_CANCEL) && (pointersLen - changedPointersLen === 0));

    input.isFirst = !!isFirst;
    input.isFinal = !!isFinal;

    if (isFirst) {
        manager.session = {};
    }

    // source event is the normalized value of the domEvents
    // like 'touchstart, mouseup, pointerdown'
    input.eventType = eventType;

    // compute scale, rotation etc
    computeInputData(manager, input);

    // emit secret event
    manager.emit('hammer.input', input);

    manager.recognize(input);
    manager.session.prevInput = input;
}

/**
 * extend the data with some usable properties like scale, rotate, velocity etc
 * @param {Object} manager
 * @param {Object} input
 */
function computeInputData(manager, input) {
    var session = manager.session;
    var pointers = input.pointers;
    var pointersLength = pointers.length;

    // store the first input to calculate the distance and direction
    if (!session.firstInput) {
        session.firstInput = simpleCloneInputData(input);
    }

    // to compute scale and rotation we need to store the multiple touches
    if (pointersLength > 1 && !session.firstMultiple) {
        session.firstMultiple = simpleCloneInputData(input);
    } else if (pointersLength === 1) {
        session.firstMultiple = false;
    }

    var firstInput = session.firstInput;
    var firstMultiple = session.firstMultiple;
    var offsetCenter = firstMultiple ? firstMultiple.center : firstInput.center;

    var center = input.center = getCenter(pointers);
    input.timeStamp = now();
    input.deltaTime = input.timeStamp - firstInput.timeStamp;

    input.angle = getAngle(offsetCenter, center);
    input.distance = getDistance(offsetCenter, center);

    computeDeltaXY(session, input);
    input.offsetDirection = getDirection(input.deltaX, input.deltaY);

    var overallVelocity = getVelocity(input.deltaTime, input.deltaX, input.deltaY);
    input.overallVelocityX = overallVelocity.x;
    input.overallVelocityY = overallVelocity.y;
    input.overallVelocity = (abs(overallVelocity.x) > abs(overallVelocity.y)) ? overallVelocity.x : overallVelocity.y;

    input.scale = firstMultiple ? getScale(firstMultiple.pointers, pointers) : 1;
    input.rotation = firstMultiple ? getRotation(firstMultiple.pointers, pointers) : 0;

    input.maxPointers = !session.prevInput ? input.pointers.length : ((input.pointers.length >
        session.prevInput.maxPointers) ? input.pointers.length : session.prevInput.maxPointers);

    computeIntervalInputData(session, input);

    // find the correct target
    var target = manager.element;
    if (hasParent(input.srcEvent.target, target)) {
        target = input.srcEvent.target;
    }
    input.target = target;
}

function computeDeltaXY(session, input) {
    var center = input.center;
    var offset = session.offsetDelta || {};
    var prevDelta = session.prevDelta || {};
    var prevInput = session.prevInput || {};

    if (input.eventType === INPUT_START || prevInput.eventType === INPUT_END) {
        prevDelta = session.prevDelta = {
            x: prevInput.deltaX || 0,
            y: prevInput.deltaY || 0
        };

        offset = session.offsetDelta = {
            x: center.x,
            y: center.y
        };
    }

    input.deltaX = prevDelta.x + (center.x - offset.x);
    input.deltaY = prevDelta.y + (center.y - offset.y);
}

/**
 * velocity is calculated every x ms
 * @param {Object} session
 * @param {Object} input
 */
function computeIntervalInputData(session, input) {
    var last = session.lastInterval || input,
        deltaTime = input.timeStamp - last.timeStamp,
        velocity, velocityX, velocityY, direction;

    if (input.eventType != INPUT_CANCEL && (deltaTime > COMPUTE_INTERVAL || last.velocity === undefined)) {
        var deltaX = input.deltaX - last.deltaX;
        var deltaY = input.deltaY - last.deltaY;

        var v = getVelocity(deltaTime, deltaX, deltaY);
        velocityX = v.x;
        velocityY = v.y;
        velocity = (abs(v.x) > abs(v.y)) ? v.x : v.y;
        direction = getDirection(deltaX, deltaY);

        session.lastInterval = input;
    } else {
        // use latest velocity info if it doesn't overtake a minimum period
        velocity = last.velocity;
        velocityX = last.velocityX;
        velocityY = last.velocityY;
        direction = last.direction;
    }

    input.velocity = velocity;
    input.velocityX = velocityX;
    input.velocityY = velocityY;
    input.direction = direction;
}

/**
 * create a simple clone from the input used for storage of firstInput and firstMultiple
 * @param {Object} input
 * @returns {Object} clonedInputData
 */
function simpleCloneInputData(input) {
    // make a simple copy of the pointers because we will get a reference if we don't
    // we only need clientXY for the calculations
    var pointers = [];
    var i = 0;
    while (i < input.pointers.length) {
        pointers[i] = {
            clientX: round(input.pointers[i].clientX),
            clientY: round(input.pointers[i].clientY)
        };
        i++;
    }

    return {
        timeStamp: now(),
        pointers: pointers,
        center: getCenter(pointers),
        deltaX: input.deltaX,
        deltaY: input.deltaY
    };
}

/**
 * get the center of all the pointers
 * @param {Array} pointers
 * @return {Object} center contains `x` and `y` properties
 */
function getCenter(pointers) {
    var pointersLength = pointers.length;

    // no need to loop when only one touch
    if (pointersLength === 1) {
        return {
            x: round(pointers[0].clientX),
            y: round(pointers[0].clientY)
        };
    }

    var x = 0, y = 0, i = 0;
    while (i < pointersLength) {
        x += pointers[i].clientX;
        y += pointers[i].clientY;
        i++;
    }

    return {
        x: round(x / pointersLength),
        y: round(y / pointersLength)
    };
}

/**
 * calculate the velocity between two points. unit is in px per ms.
 * @param {Number} deltaTime
 * @param {Number} x
 * @param {Number} y
 * @return {Object} velocity `x` and `y`
 */
function getVelocity(deltaTime, x, y) {
    return {
        x: x / deltaTime || 0,
        y: y / deltaTime || 0
    };
}

/**
 * get the direction between two points
 * @param {Number} x
 * @param {Number} y
 * @return {Number} direction
 */
function getDirection(x, y) {
    if (x === y) {
        return DIRECTION_NONE;
    }

    if (abs(x) >= abs(y)) {
        return x < 0 ? DIRECTION_LEFT : DIRECTION_RIGHT;
    }
    return y < 0 ? DIRECTION_UP : DIRECTION_DOWN;
}

/**
 * calculate the absolute distance between two points
 * @param {Object} p1 {x, y}
 * @param {Object} p2 {x, y}
 * @param {Array} [props] containing x and y keys
 * @return {Number} distance
 */
function getDistance(p1, p2, props) {
    if (!props) {
        props = PROPS_XY;
    }
    var x = p2[props[0]] - p1[props[0]],
        y = p2[props[1]] - p1[props[1]];

    return Math.sqrt((x * x) + (y * y));
}

/**
 * calculate the angle between two coordinates
 * @param {Object} p1
 * @param {Object} p2
 * @param {Array} [props] containing x and y keys
 * @return {Number} angle
 */
function getAngle(p1, p2, props) {
    if (!props) {
        props = PROPS_XY;
    }
    var x = p2[props[0]] - p1[props[0]],
        y = p2[props[1]] - p1[props[1]];
    return Math.atan2(y, x) * 180 / Math.PI;
}

/**
 * calculate the rotation degrees between two pointersets
 * @param {Array} start array of pointers
 * @param {Array} end array of pointers
 * @return {Number} rotation
 */
function getRotation(start, end) {
    return getAngle(end[1], end[0], PROPS_CLIENT_XY) + getAngle(start[1], start[0], PROPS_CLIENT_XY);
}

/**
 * calculate the scale factor between two pointersets
 * no scale is 1, and goes down to 0 when pinched together, and bigger when pinched out
 * @param {Array} start array of pointers
 * @param {Array} end array of pointers
 * @return {Number} scale
 */
function getScale(start, end) {
    return getDistance(end[0], end[1], PROPS_CLIENT_XY) / getDistance(start[0], start[1], PROPS_CLIENT_XY);
}

var MOUSE_INPUT_MAP = {
    mousedown: INPUT_START,
    mousemove: INPUT_MOVE,
    mouseup: INPUT_END
};

var MOUSE_ELEMENT_EVENTS = 'mousedown';
var MOUSE_WINDOW_EVENTS = 'mousemove mouseup';

/**
 * Mouse events input
 * @constructor
 * @extends Input
 */
function MouseInput() {
    this.evEl = MOUSE_ELEMENT_EVENTS;
    this.evWin = MOUSE_WINDOW_EVENTS;

    this.pressed = false; // mousedown state

    Input.apply(this, arguments);
}

inherit(MouseInput, Input, {
    /**
     * handle mouse events
     * @param {Object} ev
     */
    handler: function MEhandler(ev) {
        var eventType = MOUSE_INPUT_MAP[ev.type];

        // on start we want to have the left mouse button down
        if (eventType & INPUT_START && ev.button === 0) {
            this.pressed = true;
        }

        if (eventType & INPUT_MOVE && ev.which !== 1) {
            eventType = INPUT_END;
        }

        // mouse must be down
        if (!this.pressed) {
            return;
        }

        if (eventType & INPUT_END) {
            this.pressed = false;
        }

        this.callback(this.manager, eventType, {
            pointers: [ev],
            changedPointers: [ev],
            pointerType: INPUT_TYPE_MOUSE,
            srcEvent: ev
        });
    }
});

var POINTER_INPUT_MAP = {
    pointerdown: INPUT_START,
    pointermove: INPUT_MOVE,
    pointerup: INPUT_END,
    pointercancel: INPUT_CANCEL,
    pointerout: INPUT_CANCEL
};

// in IE10 the pointer types is defined as an enum
var IE10_POINTER_TYPE_ENUM = {
    2: INPUT_TYPE_TOUCH,
    3: INPUT_TYPE_PEN,
    4: INPUT_TYPE_MOUSE,
    5: INPUT_TYPE_KINECT // see https://twitter.com/jacobrossi/status/480596438489890816
};

var POINTER_ELEMENT_EVENTS = 'pointerdown';
var POINTER_WINDOW_EVENTS = 'pointermove pointerup pointercancel';

// IE10 has prefixed support, and case-sensitive
if (window.MSPointerEvent && !window.PointerEvent) {
    POINTER_ELEMENT_EVENTS = 'MSPointerDown';
    POINTER_WINDOW_EVENTS = 'MSPointerMove MSPointerUp MSPointerCancel';
}

/**
 * Pointer events input
 * @constructor
 * @extends Input
 */
function PointerEventInput() {
    this.evEl = POINTER_ELEMENT_EVENTS;
    this.evWin = POINTER_WINDOW_EVENTS;

    Input.apply(this, arguments);

    this.store = (this.manager.session.pointerEvents = []);
}

inherit(PointerEventInput, Input, {
    /**
     * handle mouse events
     * @param {Object} ev
     */
    handler: function PEhandler(ev) {
        var store = this.store;
        var removePointer = false;

        var eventTypeNormalized = ev.type.toLowerCase().replace('ms', '');
        var eventType = POINTER_INPUT_MAP[eventTypeNormalized];
        var pointerType = IE10_POINTER_TYPE_ENUM[ev.pointerType] || ev.pointerType;

        var isTouch = (pointerType == INPUT_TYPE_TOUCH);

        // get index of the event in the store
        var storeIndex = inArray(store, ev.pointerId, 'pointerId');

        // start and mouse must be down
        if (eventType & INPUT_START && (ev.button === 0 || isTouch)) {
            if (storeIndex < 0) {
                store.push(ev);
                storeIndex = store.length - 1;
            }
        } else if (eventType & (INPUT_END | INPUT_CANCEL)) {
            removePointer = true;
        }

        // it not found, so the pointer hasn't been down (so it's probably a hover)
        if (storeIndex < 0) {
            return;
        }

        // update the event in the store
        store[storeIndex] = ev;

        this.callback(this.manager, eventType, {
            pointers: store,
            changedPointers: [ev],
            pointerType: pointerType,
            srcEvent: ev
        });

        if (removePointer) {
            // remove from the store
            store.splice(storeIndex, 1);
        }
    }
});

var SINGLE_TOUCH_INPUT_MAP = {
    touchstart: INPUT_START,
    touchmove: INPUT_MOVE,
    touchend: INPUT_END,
    touchcancel: INPUT_CANCEL
};

var SINGLE_TOUCH_TARGET_EVENTS = 'touchstart';
var SINGLE_TOUCH_WINDOW_EVENTS = 'touchstart touchmove touchend touchcancel';

/**
 * Touch events input
 * @constructor
 * @extends Input
 */
function SingleTouchInput() {
    this.evTarget = SINGLE_TOUCH_TARGET_EVENTS;
    this.evWin = SINGLE_TOUCH_WINDOW_EVENTS;
    this.started = false;

    Input.apply(this, arguments);
}

inherit(SingleTouchInput, Input, {
    handler: function TEhandler(ev) {
        var type = SINGLE_TOUCH_INPUT_MAP[ev.type];

        // should we handle the touch events?
        if (type === INPUT_START) {
            this.started = true;
        }

        if (!this.started) {
            return;
        }

        var touches = normalizeSingleTouches.call(this, ev, type);

        // when done, reset the started state
        if (type & (INPUT_END | INPUT_CANCEL) && touches[0].length - touches[1].length === 0) {
            this.started = false;
        }

        this.callback(this.manager, type, {
            pointers: touches[0],
            changedPointers: touches[1],
            pointerType: INPUT_TYPE_TOUCH,
            srcEvent: ev
        });
    }
});

/**
 * @this {TouchInput}
 * @param {Object} ev
 * @param {Number} type flag
 * @returns {undefined|Array} [all, changed]
 */
function normalizeSingleTouches(ev, type) {
    var all = toArray(ev.touches);
    var changed = toArray(ev.changedTouches);

    if (type & (INPUT_END | INPUT_CANCEL)) {
        all = uniqueArray(all.concat(changed), 'identifier', true);
    }

    return [all, changed];
}

var TOUCH_INPUT_MAP = {
    touchstart: INPUT_START,
    touchmove: INPUT_MOVE,
    touchend: INPUT_END,
    touchcancel: INPUT_CANCEL
};

var TOUCH_TARGET_EVENTS = 'touchstart touchmove touchend touchcancel';

/**
 * Multi-user touch events input
 * @constructor
 * @extends Input
 */
function TouchInput() {
    this.evTarget = TOUCH_TARGET_EVENTS;
    this.targetIds = {};

    Input.apply(this, arguments);
}

inherit(TouchInput, Input, {
    handler: function MTEhandler(ev) {
        var type = TOUCH_INPUT_MAP[ev.type];
        var touches = getTouches.call(this, ev, type);
        if (!touches) {
            return;
        }

        this.callback(this.manager, type, {
            pointers: touches[0],
            changedPointers: touches[1],
            pointerType: INPUT_TYPE_TOUCH,
            srcEvent: ev
        });
    }
});

/**
 * @this {TouchInput}
 * @param {Object} ev
 * @param {Number} type flag
 * @returns {undefined|Array} [all, changed]
 */
function getTouches(ev, type) {
    var allTouches = toArray(ev.touches);
    var targetIds = this.targetIds;

    // when there is only one touch, the process can be simplified
    if (type & (INPUT_START | INPUT_MOVE) && allTouches.length === 1) {
        targetIds[allTouches[0].identifier] = true;
        return [allTouches, allTouches];
    }

    var i,
        targetTouches,
        changedTouches = toArray(ev.changedTouches),
        changedTargetTouches = [],
        target = this.target;

    // get target touches from touches
    targetTouches = allTouches.filter(function(touch) {
        return hasParent(touch.target, target);
    });

    // collect touches
    if (type === INPUT_START) {
        i = 0;
        while (i < targetTouches.length) {
            targetIds[targetTouches[i].identifier] = true;
            i++;
        }
    }

    // filter changed touches to only contain touches that exist in the collected target ids
    i = 0;
    while (i < changedTouches.length) {
        if (targetIds[changedTouches[i].identifier]) {
            changedTargetTouches.push(changedTouches[i]);
        }

        // cleanup removed touches
        if (type & (INPUT_END | INPUT_CANCEL)) {
            delete targetIds[changedTouches[i].identifier];
        }
        i++;
    }

    if (!changedTargetTouches.length) {
        return;
    }

    return [
        // merge targetTouches with changedTargetTouches so it contains ALL touches, including 'end' and 'cancel'
        uniqueArray(targetTouches.concat(changedTargetTouches), 'identifier', true),
        changedTargetTouches
    ];
}

/**
 * Combined touch and mouse input
 *
 * Touch has a higher priority then mouse, and while touching no mouse events are allowed.
 * This because touch devices also emit mouse events while doing a touch.
 *
 * @constructor
 * @extends Input
 */

var DEDUP_TIMEOUT = 2500;
var DEDUP_DISTANCE = 25;

function TouchMouseInput() {
    Input.apply(this, arguments);

    var handler = bindFn(this.handler, this);
    this.touch = new TouchInput(this.manager, handler);
    this.mouse = new MouseInput(this.manager, handler);

    this.primaryTouch = null;
    this.lastTouches = [];
}

inherit(TouchMouseInput, Input, {
    /**
     * handle mouse and touch events
     * @param {Hammer} manager
     * @param {String} inputEvent
     * @param {Object} inputData
     */
    handler: function TMEhandler(manager, inputEvent, inputData) {
        var isTouch = (inputData.pointerType == INPUT_TYPE_TOUCH),
            isMouse = (inputData.pointerType == INPUT_TYPE_MOUSE);

        if (isMouse && inputData.sourceCapabilities && inputData.sourceCapabilities.firesTouchEvents) {
            return;
        }

        // when we're in a touch event, record touches to  de-dupe synthetic mouse event
        if (isTouch) {
            recordTouches.call(this, inputEvent, inputData);
        } else if (isMouse && isSyntheticEvent.call(this, inputData)) {
            return;
        }

        this.callback(manager, inputEvent, inputData);
    },

    /**
     * remove the event listeners
     */
    destroy: function destroy() {
        this.touch.destroy();
        this.mouse.destroy();
    }
});

function recordTouches(eventType, eventData) {
    if (eventType & INPUT_START) {
        this.primaryTouch = eventData.changedPointers[0].identifier;
        setLastTouch.call(this, eventData);
    } else if (eventType & (INPUT_END | INPUT_CANCEL)) {
        setLastTouch.call(this, eventData);
    }
}

function setLastTouch(eventData) {
    var touch = eventData.changedPointers[0];

    if (touch.identifier === this.primaryTouch) {
        var lastTouch = {x: touch.clientX, y: touch.clientY};
        this.lastTouches.push(lastTouch);
        var lts = this.lastTouches;
        var removeLastTouch = function() {
            var i = lts.indexOf(lastTouch);
            if (i > -1) {
                lts.splice(i, 1);
            }
        };
        setTimeout(removeLastTouch, DEDUP_TIMEOUT);
    }
}

function isSyntheticEvent(eventData) {
    var x = eventData.srcEvent.clientX, y = eventData.srcEvent.clientY;
    for (var i = 0; i < this.lastTouches.length; i++) {
        var t = this.lastTouches[i];
        var dx = Math.abs(x - t.x), dy = Math.abs(y - t.y);
        if (dx <= DEDUP_DISTANCE && dy <= DEDUP_DISTANCE) {
            return true;
        }
    }
    return false;
}

var PREFIXED_TOUCH_ACTION = prefixed(TEST_ELEMENT.style, 'touchAction');
var NATIVE_TOUCH_ACTION = PREFIXED_TOUCH_ACTION !== undefined;

// magical touchAction value
var TOUCH_ACTION_COMPUTE = 'compute';
var TOUCH_ACTION_AUTO = 'auto';
var TOUCH_ACTION_MANIPULATION = 'manipulation'; // not implemented
var TOUCH_ACTION_NONE = 'none';
var TOUCH_ACTION_PAN_X = 'pan-x';
var TOUCH_ACTION_PAN_Y = 'pan-y';
var TOUCH_ACTION_MAP = getTouchActionProps();

/**
 * Touch Action
 * sets the touchAction property or uses the js alternative
 * @param {Manager} manager
 * @param {String} value
 * @constructor
 */
function TouchAction(manager, value) {
    this.manager = manager;
    this.set(value);
}

TouchAction.prototype = {
    /**
     * set the touchAction value on the element or enable the polyfill
     * @param {String} value
     */
    set: function(value) {
        // find out the touch-action by the event handlers
        if (value == TOUCH_ACTION_COMPUTE) {
            value = this.compute();
        }

        if (NATIVE_TOUCH_ACTION && this.manager.element.style && TOUCH_ACTION_MAP[value]) {
            this.manager.element.style[PREFIXED_TOUCH_ACTION] = value;
        }
        this.actions = value.toLowerCase().trim();
    },

    /**
     * just re-set the touchAction value
     */
    update: function() {
        this.set(this.manager.options.touchAction);
    },

    /**
     * compute the value for the touchAction property based on the recognizer's settings
     * @returns {String} value
     */
    compute: function() {
        var actions = [];
        each(this.manager.recognizers, function(recognizer) {
            if (boolOrFn(recognizer.options.enable, [recognizer])) {
                actions = actions.concat(recognizer.getTouchAction());
            }
        });
        return cleanTouchActions(actions.join(' '));
    },

    /**
     * this method is called on each input cycle and provides the preventing of the browser behavior
     * @param {Object} input
     */
    preventDefaults: function(input) {
        var srcEvent = input.srcEvent;
        var direction = input.offsetDirection;

        // if the touch action did prevented once this session
        if (this.manager.session.prevented) {
            srcEvent.preventDefault();
            return;
        }

        var actions = this.actions;
        var hasNone = inStr(actions, TOUCH_ACTION_NONE) && !TOUCH_ACTION_MAP[TOUCH_ACTION_NONE];
        var hasPanY = inStr(actions, TOUCH_ACTION_PAN_Y) && !TOUCH_ACTION_MAP[TOUCH_ACTION_PAN_Y];
        var hasPanX = inStr(actions, TOUCH_ACTION_PAN_X) && !TOUCH_ACTION_MAP[TOUCH_ACTION_PAN_X];

        if (hasNone) {
            //do not prevent defaults if this is a tap gesture

            var isTapPointer = input.pointers.length === 1;
            var isTapMovement = input.distance < 2;
            var isTapTouchTime = input.deltaTime < 250;

            if (isTapPointer && isTapMovement && isTapTouchTime) {
                return;
            }
        }

        if (hasPanX && hasPanY) {
            // `pan-x pan-y` means browser handles all scrolling/panning, do not prevent
            return;
        }

        if (hasNone ||
            (hasPanY && direction & DIRECTION_HORIZONTAL) ||
            (hasPanX && direction & DIRECTION_VERTICAL)) {
            return this.preventSrc(srcEvent);
        }
    },

    /**
     * call preventDefault to prevent the browser's default behavior (scrolling in most cases)
     * @param {Object} srcEvent
     */
    preventSrc: function(srcEvent) {
        this.manager.session.prevented = true;
        srcEvent.preventDefault();
    }
};

/**
 * when the touchActions are collected they are not a valid value, so we need to clean things up. *
 * @param {String} actions
 * @returns {*}
 */
function cleanTouchActions(actions) {
    // none
    if (inStr(actions, TOUCH_ACTION_NONE)) {
        return TOUCH_ACTION_NONE;
    }

    var hasPanX = inStr(actions, TOUCH_ACTION_PAN_X);
    var hasPanY = inStr(actions, TOUCH_ACTION_PAN_Y);

    // if both pan-x and pan-y are set (different recognizers
    // for different directions, e.g. horizontal pan but vertical swipe?)
    // we need none (as otherwise with pan-x pan-y combined none of these
    // recognizers will work, since the browser would handle all panning
    if (hasPanX && hasPanY) {
        return TOUCH_ACTION_NONE;
    }

    // pan-x OR pan-y
    if (hasPanX || hasPanY) {
        return hasPanX ? TOUCH_ACTION_PAN_X : TOUCH_ACTION_PAN_Y;
    }

    // manipulation
    if (inStr(actions, TOUCH_ACTION_MANIPULATION)) {
        return TOUCH_ACTION_MANIPULATION;
    }

    return TOUCH_ACTION_AUTO;
}

function getTouchActionProps() {
    if (!NATIVE_TOUCH_ACTION) {
        return false;
    }
    var touchMap = {};
    var cssSupports = window.CSS && window.CSS.supports;
    ['auto', 'manipulation', 'pan-y', 'pan-x', 'pan-x pan-y', 'none'].forEach(function(val) {

        // If css.supports is not supported but there is native touch-action assume it supports
        // all values. This is the case for IE 10 and 11.
        touchMap[val] = cssSupports ? window.CSS.supports('touch-action', val) : true;
    });
    return touchMap;
}

/**
 * Recognizer flow explained; *
 * All recognizers have the initial state of POSSIBLE when a input session starts.
 * The definition of a input session is from the first input until the last input, with all it's movement in it. *
 * Example session for mouse-input: mousedown -> mousemove -> mouseup
 *
 * On each recognizing cycle (see Manager.recognize) the .recognize() method is executed
 * which determines with state it should be.
 *
 * If the recognizer has the state FAILED, CANCELLED or RECOGNIZED (equals ENDED), it is reset to
 * POSSIBLE to give it another change on the next cycle.
 *
 *               Possible
 *                  |
 *            +-----+---------------+
 *            |                     |
 *      +-----+-----+               |
 *      |           |               |
 *   Failed      Cancelled          |
 *                          +-------+------+
 *                          |              |
 *                      Recognized       Began
 *                                         |
 *                                      Changed
 *                                         |
 *                                  Ended/Recognized
 */
var STATE_POSSIBLE = 1;
var STATE_BEGAN = 2;
var STATE_CHANGED = 4;
var STATE_ENDED = 8;
var STATE_RECOGNIZED = STATE_ENDED;
var STATE_CANCELLED = 16;
var STATE_FAILED = 32;

/**
 * Recognizer
 * Every recognizer needs to extend from this class.
 * @constructor
 * @param {Object} options
 */
function Recognizer(options) {
    this.options = assign({}, this.defaults, options || {});

    this.id = uniqueId();

    this.manager = null;

    // default is enable true
    this.options.enable = ifUndefined(this.options.enable, true);

    this.state = STATE_POSSIBLE;

    this.simultaneous = {};
    this.requireFail = [];
}

Recognizer.prototype = {
    /**
     * @virtual
     * @type {Object}
     */
    defaults: {},

    /**
     * set options
     * @param {Object} options
     * @return {Recognizer}
     */
    set: function(options) {
        assign(this.options, options);

        // also update the touchAction, in case something changed about the directions/enabled state
        this.manager && this.manager.touchAction.update();
        return this;
    },

    /**
     * recognize simultaneous with an other recognizer.
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */
    recognizeWith: function(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, 'recognizeWith', this)) {
            return this;
        }

        var simultaneous = this.simultaneous;
        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        if (!simultaneous[otherRecognizer.id]) {
            simultaneous[otherRecognizer.id] = otherRecognizer;
            otherRecognizer.recognizeWith(this);
        }
        return this;
    },

    /**
     * drop the simultaneous link. it doesnt remove the link on the other recognizer.
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */
    dropRecognizeWith: function(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, 'dropRecognizeWith', this)) {
            return this;
        }

        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        delete this.simultaneous[otherRecognizer.id];
        return this;
    },

    /**
     * recognizer can only run when an other is failing
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */
    requireFailure: function(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, 'requireFailure', this)) {
            return this;
        }

        var requireFail = this.requireFail;
        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        if (inArray(requireFail, otherRecognizer) === -1) {
            requireFail.push(otherRecognizer);
            otherRecognizer.requireFailure(this);
        }
        return this;
    },

    /**
     * drop the requireFailure link. it does not remove the link on the other recognizer.
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */
    dropRequireFailure: function(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, 'dropRequireFailure', this)) {
            return this;
        }

        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        var index = inArray(this.requireFail, otherRecognizer);
        if (index > -1) {
            this.requireFail.splice(index, 1);
        }
        return this;
    },

    /**
     * has require failures boolean
     * @returns {boolean}
     */
    hasRequireFailures: function() {
        return this.requireFail.length > 0;
    },

    /**
     * if the recognizer can recognize simultaneous with an other recognizer
     * @param {Recognizer} otherRecognizer
     * @returns {Boolean}
     */
    canRecognizeWith: function(otherRecognizer) {
        return !!this.simultaneous[otherRecognizer.id];
    },

    /**
     * You should use `tryEmit` instead of `emit` directly to check
     * that all the needed recognizers has failed before emitting.
     * @param {Object} input
     */
    emit: function(input) {
        var self = this;
        var state = this.state;

        function emit(event) {
            self.manager.emit(event, input);
        }

        // 'panstart' and 'panmove'
        if (state < STATE_ENDED) {
            emit(self.options.event + stateStr(state));
        }

        emit(self.options.event); // simple 'eventName' events

        if (input.additionalEvent) { // additional event(panleft, panright, pinchin, pinchout...)
            emit(input.additionalEvent);
        }

        // panend and pancancel
        if (state >= STATE_ENDED) {
            emit(self.options.event + stateStr(state));
        }
    },

    /**
     * Check that all the require failure recognizers has failed,
     * if true, it emits a gesture event,
     * otherwise, setup the state to FAILED.
     * @param {Object} input
     */
    tryEmit: function(input) {
        if (this.canEmit()) {
            return this.emit(input);
        }
        // it's failing anyway
        this.state = STATE_FAILED;
    },

    /**
     * can we emit?
     * @returns {boolean}
     */
    canEmit: function() {
        var i = 0;
        while (i < this.requireFail.length) {
            if (!(this.requireFail[i].state & (STATE_FAILED | STATE_POSSIBLE))) {
                return false;
            }
            i++;
        }
        return true;
    },

    /**
     * update the recognizer
     * @param {Object} inputData
     */
    recognize: function(inputData) {
        // make a new copy of the inputData
        // so we can change the inputData without messing up the other recognizers
        var inputDataClone = assign({}, inputData);

        // is is enabled and allow recognizing?
        if (!boolOrFn(this.options.enable, [this, inputDataClone])) {
            this.reset();
            this.state = STATE_FAILED;
            return;
        }

        // reset when we've reached the end
        if (this.state & (STATE_RECOGNIZED | STATE_CANCELLED | STATE_FAILED)) {
            this.state = STATE_POSSIBLE;
        }

        this.state = this.process(inputDataClone);

        // the recognizer has recognized a gesture
        // so trigger an event
        if (this.state & (STATE_BEGAN | STATE_CHANGED | STATE_ENDED | STATE_CANCELLED)) {
            this.tryEmit(inputDataClone);
        }
    },

    /**
     * return the state of the recognizer
     * the actual recognizing happens in this method
     * @virtual
     * @param {Object} inputData
     * @returns {Const} STATE
     */
    process: function(inputData) { }, // jshint ignore:line

    /**
     * return the preferred touch-action
     * @virtual
     * @returns {Array}
     */
    getTouchAction: function() { },

    /**
     * called when the gesture isn't allowed to recognize
     * like when another is being recognized or it is disabled
     * @virtual
     */
    reset: function() { }
};

/**
 * get a usable string, used as event postfix
 * @param {Const} state
 * @returns {String} state
 */
function stateStr(state) {
    if (state & STATE_CANCELLED) {
        return 'cancel';
    } else if (state & STATE_ENDED) {
        return 'end';
    } else if (state & STATE_CHANGED) {
        return 'move';
    } else if (state & STATE_BEGAN) {
        return 'start';
    }
    return '';
}

/**
 * direction cons to string
 * @param {Const} direction
 * @returns {String}
 */
function directionStr(direction) {
    if (direction == DIRECTION_DOWN) {
        return 'down';
    } else if (direction == DIRECTION_UP) {
        return 'up';
    } else if (direction == DIRECTION_LEFT) {
        return 'left';
    } else if (direction == DIRECTION_RIGHT) {
        return 'right';
    }
    return '';
}

/**
 * get a recognizer by name if it is bound to a manager
 * @param {Recognizer|String} otherRecognizer
 * @param {Recognizer} recognizer
 * @returns {Recognizer}
 */
function getRecognizerByNameIfManager(otherRecognizer, recognizer) {
    var manager = recognizer.manager;
    if (manager) {
        return manager.get(otherRecognizer);
    }
    return otherRecognizer;
}

/**
 * This recognizer is just used as a base for the simple attribute recognizers.
 * @constructor
 * @extends Recognizer
 */
function AttrRecognizer() {
    Recognizer.apply(this, arguments);
}

inherit(AttrRecognizer, Recognizer, {
    /**
     * @namespace
     * @memberof AttrRecognizer
     */
    defaults: {
        /**
         * @type {Number}
         * @default 1
         */
        pointers: 1
    },

    /**
     * Used to check if it the recognizer receives valid input, like input.distance > 10.
     * @memberof AttrRecognizer
     * @param {Object} input
     * @returns {Boolean} recognized
     */
    attrTest: function(input) {
        var optionPointers = this.options.pointers;
        return optionPointers === 0 || input.pointers.length === optionPointers;
    },

    /**
     * Process the input and return the state for the recognizer
     * @memberof AttrRecognizer
     * @param {Object} input
     * @returns {*} State
     */
    process: function(input) {
        var state = this.state;
        var eventType = input.eventType;

        var isRecognized = state & (STATE_BEGAN | STATE_CHANGED);
        var isValid = this.attrTest(input);

        // on cancel input and we've recognized before, return STATE_CANCELLED
        if (isRecognized && (eventType & INPUT_CANCEL || !isValid)) {
            return state | STATE_CANCELLED;
        } else if (isRecognized || isValid) {
            if (eventType & INPUT_END) {
                return state | STATE_ENDED;
            } else if (!(state & STATE_BEGAN)) {
                return STATE_BEGAN;
            }
            return state | STATE_CHANGED;
        }
        return STATE_FAILED;
    }
});

/**
 * Pan
 * Recognized when the pointer is down and moved in the allowed direction.
 * @constructor
 * @extends AttrRecognizer
 */
function PanRecognizer() {
    AttrRecognizer.apply(this, arguments);

    this.pX = null;
    this.pY = null;
}

inherit(PanRecognizer, AttrRecognizer, {
    /**
     * @namespace
     * @memberof PanRecognizer
     */
    defaults: {
        event: 'pan',
        threshold: 10,
        pointers: 1,
        direction: DIRECTION_ALL
    },

    getTouchAction: function() {
        var direction = this.options.direction;
        var actions = [];
        if (direction & DIRECTION_HORIZONTAL) {
            actions.push(TOUCH_ACTION_PAN_Y);
        }
        if (direction & DIRECTION_VERTICAL) {
            actions.push(TOUCH_ACTION_PAN_X);
        }
        return actions;
    },

    directionTest: function(input) {
        var options = this.options;
        var hasMoved = true;
        var distance = input.distance;
        var direction = input.direction;
        var x = input.deltaX;
        var y = input.deltaY;

        // lock to axis?
        if (!(direction & options.direction)) {
            if (options.direction & DIRECTION_HORIZONTAL) {
                direction = (x === 0) ? DIRECTION_NONE : (x < 0) ? DIRECTION_LEFT : DIRECTION_RIGHT;
                hasMoved = x != this.pX;
                distance = Math.abs(input.deltaX);
            } else {
                direction = (y === 0) ? DIRECTION_NONE : (y < 0) ? DIRECTION_UP : DIRECTION_DOWN;
                hasMoved = y != this.pY;
                distance = Math.abs(input.deltaY);
            }
        }
        input.direction = direction;
        return hasMoved && distance > options.threshold && direction & options.direction;
    },

    attrTest: function(input) {
        return AttrRecognizer.prototype.attrTest.call(this, input) &&
            (this.state & STATE_BEGAN || (!(this.state & STATE_BEGAN) && this.directionTest(input)));
    },

    emit: function(input) {

        this.pX = input.deltaX;
        this.pY = input.deltaY;

        var direction = directionStr(input.direction);

        if (direction) {
            input.additionalEvent = this.options.event + direction;
        }
        this._super.emit.call(this, input);
    }
});

/**
 * Pinch
 * Recognized when two or more pointers are moving toward (zoom-in) or away from each other (zoom-out).
 * @constructor
 * @extends AttrRecognizer
 */
function PinchRecognizer() {
    AttrRecognizer.apply(this, arguments);
}

inherit(PinchRecognizer, AttrRecognizer, {
    /**
     * @namespace
     * @memberof PinchRecognizer
     */
    defaults: {
        event: 'pinch',
        threshold: 0,
        pointers: 2
    },

    getTouchAction: function() {
        return [TOUCH_ACTION_NONE];
    },

    attrTest: function(input) {
        return this._super.attrTest.call(this, input) &&
            (Math.abs(input.scale - 1) > this.options.threshold || this.state & STATE_BEGAN);
    },

    emit: function(input) {
        if (input.scale !== 1) {
            var inOut = input.scale < 1 ? 'in' : 'out';
            input.additionalEvent = this.options.event + inOut;
        }
        this._super.emit.call(this, input);
    }
});

/**
 * Press
 * Recognized when the pointer is down for x ms without any movement.
 * @constructor
 * @extends Recognizer
 */
function PressRecognizer() {
    Recognizer.apply(this, arguments);

    this._timer = null;
    this._input = null;
}

inherit(PressRecognizer, Recognizer, {
    /**
     * @namespace
     * @memberof PressRecognizer
     */
    defaults: {
        event: 'press',
        pointers: 1,
        time: 251, // minimal time of the pointer to be pressed
        threshold: 9 // a minimal movement is ok, but keep it low
    },

    getTouchAction: function() {
        return [TOUCH_ACTION_AUTO];
    },

    process: function(input) {
        var options = this.options;
        var validPointers = input.pointers.length === options.pointers;
        var validMovement = input.distance < options.threshold;
        var validTime = input.deltaTime > options.time;

        this._input = input;

        // we only allow little movement
        // and we've reached an end event, so a tap is possible
        if (!validMovement || !validPointers || (input.eventType & (INPUT_END | INPUT_CANCEL) && !validTime)) {
            this.reset();
        } else if (input.eventType & INPUT_START) {
            this.reset();
            this._timer = setTimeoutContext(function() {
                this.state = STATE_RECOGNIZED;
                this.tryEmit();
            }, options.time, this);
        } else if (input.eventType & INPUT_END) {
            return STATE_RECOGNIZED;
        }
        return STATE_FAILED;
    },

    reset: function() {
        clearTimeout(this._timer);
    },

    emit: function(input) {
        if (this.state !== STATE_RECOGNIZED) {
            return;
        }

        if (input && (input.eventType & INPUT_END)) {
            this.manager.emit(this.options.event + 'up', input);
        } else {
            this._input.timeStamp = now();
            this.manager.emit(this.options.event, this._input);
        }
    }
});

/**
 * Rotate
 * Recognized when two or more pointer are moving in a circular motion.
 * @constructor
 * @extends AttrRecognizer
 */
function RotateRecognizer() {
    AttrRecognizer.apply(this, arguments);
}

inherit(RotateRecognizer, AttrRecognizer, {
    /**
     * @namespace
     * @memberof RotateRecognizer
     */
    defaults: {
        event: 'rotate',
        threshold: 0,
        pointers: 2
    },

    getTouchAction: function() {
        return [TOUCH_ACTION_NONE];
    },

    attrTest: function(input) {
        return this._super.attrTest.call(this, input) &&
            (Math.abs(input.rotation) > this.options.threshold || this.state & STATE_BEGAN);
    }
});

/**
 * Swipe
 * Recognized when the pointer is moving fast (velocity), with enough distance in the allowed direction.
 * @constructor
 * @extends AttrRecognizer
 */
function SwipeRecognizer() {
    AttrRecognizer.apply(this, arguments);
}

inherit(SwipeRecognizer, AttrRecognizer, {
    /**
     * @namespace
     * @memberof SwipeRecognizer
     */
    defaults: {
        event: 'swipe',
        threshold: 10,
        velocity: 0.3,
        direction: DIRECTION_HORIZONTAL | DIRECTION_VERTICAL,
        pointers: 1
    },

    getTouchAction: function() {
        return PanRecognizer.prototype.getTouchAction.call(this);
    },

    attrTest: function(input) {
        var direction = this.options.direction;
        var velocity;

        if (direction & (DIRECTION_HORIZONTAL | DIRECTION_VERTICAL)) {
            velocity = input.overallVelocity;
        } else if (direction & DIRECTION_HORIZONTAL) {
            velocity = input.overallVelocityX;
        } else if (direction & DIRECTION_VERTICAL) {
            velocity = input.overallVelocityY;
        }

        return this._super.attrTest.call(this, input) &&
            direction & input.offsetDirection &&
            input.distance > this.options.threshold &&
            input.maxPointers == this.options.pointers &&
            abs(velocity) > this.options.velocity && input.eventType & INPUT_END;
    },

    emit: function(input) {
        var direction = directionStr(input.offsetDirection);
        if (direction) {
            this.manager.emit(this.options.event + direction, input);
        }

        this.manager.emit(this.options.event, input);
    }
});

/**
 * A tap is ecognized when the pointer is doing a small tap/click. Multiple taps are recognized if they occur
 * between the given interval and position. The delay option can be used to recognize multi-taps without firing
 * a single tap.
 *
 * The eventData from the emitted event contains the property `tapCount`, which contains the amount of
 * multi-taps being recognized.
 * @constructor
 * @extends Recognizer
 */
function TapRecognizer() {
    Recognizer.apply(this, arguments);

    // previous time and center,
    // used for tap counting
    this.pTime = false;
    this.pCenter = false;

    this._timer = null;
    this._input = null;
    this.count = 0;
}

inherit(TapRecognizer, Recognizer, {
    /**
     * @namespace
     * @memberof PinchRecognizer
     */
    defaults: {
        event: 'tap',
        pointers: 1,
        taps: 1,
        interval: 300, // max time between the multi-tap taps
        time: 250, // max time of the pointer to be down (like finger on the screen)
        threshold: 9, // a minimal movement is ok, but keep it low
        posThreshold: 10 // a multi-tap can be a bit off the initial position
    },

    getTouchAction: function() {
        return [TOUCH_ACTION_MANIPULATION];
    },

    process: function(input) {
        var options = this.options;

        var validPointers = input.pointers.length === options.pointers;
        var validMovement = input.distance < options.threshold;
        var validTouchTime = input.deltaTime < options.time;

        this.reset();

        if ((input.eventType & INPUT_START) && (this.count === 0)) {
            return this.failTimeout();
        }

        // we only allow little movement
        // and we've reached an end event, so a tap is possible
        if (validMovement && validTouchTime && validPointers) {
            if (input.eventType != INPUT_END) {
                return this.failTimeout();
            }

            var validInterval = this.pTime ? (input.timeStamp - this.pTime < options.interval) : true;
            var validMultiTap = !this.pCenter || getDistance(this.pCenter, input.center) < options.posThreshold;

            this.pTime = input.timeStamp;
            this.pCenter = input.center;

            if (!validMultiTap || !validInterval) {
                this.count = 1;
            } else {
                this.count += 1;
            }

            this._input = input;

            // if tap count matches we have recognized it,
            // else it has began recognizing...
            var tapCount = this.count % options.taps;
            if (tapCount === 0) {
                // no failing requirements, immediately trigger the tap event
                // or wait as long as the multitap interval to trigger
                if (!this.hasRequireFailures()) {
                    return STATE_RECOGNIZED;
                } else {
                    this._timer = setTimeoutContext(function() {
                        this.state = STATE_RECOGNIZED;
                        this.tryEmit();
                    }, options.interval, this);
                    return STATE_BEGAN;
                }
            }
        }
        return STATE_FAILED;
    },

    failTimeout: function() {
        this._timer = setTimeoutContext(function() {
            this.state = STATE_FAILED;
        }, this.options.interval, this);
        return STATE_FAILED;
    },

    reset: function() {
        clearTimeout(this._timer);
    },

    emit: function() {
        if (this.state == STATE_RECOGNIZED) {
            this._input.tapCount = this.count;
            this.manager.emit(this.options.event, this._input);
        }
    }
});

/**
 * Simple way to create a manager with a default set of recognizers.
 * @param {HTMLElement} element
 * @param {Object} [options]
 * @constructor
 */
function Hammer(element, options) {
    options = options || {};
    options.recognizers = ifUndefined(options.recognizers, Hammer.defaults.preset);
    return new Manager(element, options);
}

/**
 * @const {string}
 */
Hammer.VERSION = '2.0.7';

/**
 * default settings
 * @namespace
 */
Hammer.defaults = {
    /**
     * set if DOM events are being triggered.
     * But this is slower and unused by simple implementations, so disabled by default.
     * @type {Boolean}
     * @default false
     */
    domEvents: false,

    /**
     * The value for the touchAction property/fallback.
     * When set to `compute` it will magically set the correct value based on the added recognizers.
     * @type {String}
     * @default compute
     */
    touchAction: TOUCH_ACTION_COMPUTE,

    /**
     * @type {Boolean}
     * @default true
     */
    enable: true,

    /**
     * EXPERIMENTAL FEATURE -- can be removed/changed
     * Change the parent input target element.
     * If Null, then it is being set the to main element.
     * @type {Null|EventTarget}
     * @default null
     */
    inputTarget: null,

    /**
     * force an input class
     * @type {Null|Function}
     * @default null
     */
    inputClass: null,

    /**
     * Default recognizer setup when calling `Hammer()`
     * When creating a new Manager these will be skipped.
     * @type {Array}
     */
    preset: [
        // RecognizerClass, options, [recognizeWith, ...], [requireFailure, ...]
        [RotateRecognizer, {enable: false}],
        [PinchRecognizer, {enable: false}, ['rotate']],
        [SwipeRecognizer, {direction: DIRECTION_HORIZONTAL}],
        [PanRecognizer, {direction: DIRECTION_HORIZONTAL}, ['swipe']],
        [TapRecognizer],
        [TapRecognizer, {event: 'doubletap', taps: 2}, ['tap']],
        [PressRecognizer]
    ],

    /**
     * Some CSS properties can be used to improve the working of Hammer.
     * Add them to this method and they will be set when creating a new Manager.
     * @namespace
     */
    cssProps: {
        /**
         * Disables text selection to improve the dragging gesture. Mainly for desktop browsers.
         * @type {String}
         * @default 'none'
         */
        userSelect: 'none',

        /**
         * Disable the Windows Phone grippers when pressing an element.
         * @type {String}
         * @default 'none'
         */
        touchSelect: 'none',

        /**
         * Disables the default callout shown when you touch and hold a touch target.
         * On iOS, when you touch and hold a touch target such as a link, Safari displays
         * a callout containing information about the link. This property allows you to disable that callout.
         * @type {String}
         * @default 'none'
         */
        touchCallout: 'none',

        /**
         * Specifies whether zooming is enabled. Used by IE10>
         * @type {String}
         * @default 'none'
         */
        contentZooming: 'none',

        /**
         * Specifies that an entire element should be draggable instead of its contents. Mainly for desktop browsers.
         * @type {String}
         * @default 'none'
         */
        userDrag: 'none',

        /**
         * Overrides the highlight color shown when the user taps a link or a JavaScript
         * clickable element in iOS. This property obeys the alpha value, if specified.
         * @type {String}
         * @default 'rgba(0,0,0,0)'
         */
        tapHighlightColor: 'rgba(0,0,0,0)'
    }
};

var STOP = 1;
var FORCED_STOP = 2;

/**
 * Manager
 * @param {HTMLElement} element
 * @param {Object} [options]
 * @constructor
 */
function Manager(element, options) {
    this.options = assign({}, Hammer.defaults, options || {});

    this.options.inputTarget = this.options.inputTarget || element;

    this.handlers = {};
    this.session = {};
    this.recognizers = [];
    this.oldCssProps = {};

    this.element = element;
    this.input = createInputInstance(this);
    this.touchAction = new TouchAction(this, this.options.touchAction);

    toggleCssProps(this, true);

    each(this.options.recognizers, function(item) {
        var recognizer = this.add(new (item[0])(item[1]));
        item[2] && recognizer.recognizeWith(item[2]);
        item[3] && recognizer.requireFailure(item[3]);
    }, this);
}

Manager.prototype = {
    /**
     * set options
     * @param {Object} options
     * @returns {Manager}
     */
    set: function(options) {
        assign(this.options, options);

        // Options that need a little more setup
        if (options.touchAction) {
            this.touchAction.update();
        }
        if (options.inputTarget) {
            // Clean up existing event listeners and reinitialize
            this.input.destroy();
            this.input.target = options.inputTarget;
            this.input.init();
        }
        return this;
    },

    /**
     * stop recognizing for this session.
     * This session will be discarded, when a new [input]start event is fired.
     * When forced, the recognizer cycle is stopped immediately.
     * @param {Boolean} [force]
     */
    stop: function(force) {
        this.session.stopped = force ? FORCED_STOP : STOP;
    },

    /**
     * run the recognizers!
     * called by the inputHandler function on every movement of the pointers (touches)
     * it walks through all the recognizers and tries to detect the gesture that is being made
     * @param {Object} inputData
     */
    recognize: function(inputData) {
        var session = this.session;
        if (session.stopped) {
            return;
        }

        // run the touch-action polyfill
        this.touchAction.preventDefaults(inputData);

        var recognizer;
        var recognizers = this.recognizers;

        // this holds the recognizer that is being recognized.
        // so the recognizer's state needs to be BEGAN, CHANGED, ENDED or RECOGNIZED
        // if no recognizer is detecting a thing, it is set to `null`
        var curRecognizer = session.curRecognizer;

        // reset when the last recognizer is recognized
        // or when we're in a new session
        if (!curRecognizer || (curRecognizer && curRecognizer.state & STATE_RECOGNIZED)) {
            curRecognizer = session.curRecognizer = null;
        }

        var i = 0;
        while (i < recognizers.length) {
            recognizer = recognizers[i];

            // find out if we are allowed try to recognize the input for this one.
            // 1.   allow if the session is NOT forced stopped (see the .stop() method)
            // 2.   allow if we still haven't recognized a gesture in this session, or the this recognizer is the one
            //      that is being recognized.
            // 3.   allow if the recognizer is allowed to run simultaneous with the current recognized recognizer.
            //      this can be setup with the `recognizeWith()` method on the recognizer.
            if (session.stopped !== FORCED_STOP && ( // 1
                    !curRecognizer || recognizer == curRecognizer || // 2
                    recognizer.canRecognizeWith(curRecognizer))) { // 3
                recognizer.recognize(inputData);
            } else {
                recognizer.reset();
            }

            // if the recognizer has been recognizing the input as a valid gesture, we want to store this one as the
            // current active recognizer. but only if we don't already have an active recognizer
            if (!curRecognizer && recognizer.state & (STATE_BEGAN | STATE_CHANGED | STATE_ENDED)) {
                curRecognizer = session.curRecognizer = recognizer;
            }
            i++;
        }
    },

    /**
     * get a recognizer by its event name.
     * @param {Recognizer|String} recognizer
     * @returns {Recognizer|Null}
     */
    get: function(recognizer) {
        if (recognizer instanceof Recognizer) {
            return recognizer;
        }

        var recognizers = this.recognizers;
        for (var i = 0; i < recognizers.length; i++) {
            if (recognizers[i].options.event == recognizer) {
                return recognizers[i];
            }
        }
        return null;
    },

    /**
     * add a recognizer to the manager
     * existing recognizers with the same event name will be removed
     * @param {Recognizer} recognizer
     * @returns {Recognizer|Manager}
     */
    add: function(recognizer) {
        if (invokeArrayArg(recognizer, 'add', this)) {
            return this;
        }

        // remove existing
        var existing = this.get(recognizer.options.event);
        if (existing) {
            this.remove(existing);
        }

        this.recognizers.push(recognizer);
        recognizer.manager = this;

        this.touchAction.update();
        return recognizer;
    },

    /**
     * remove a recognizer by name or instance
     * @param {Recognizer|String} recognizer
     * @returns {Manager}
     */
    remove: function(recognizer) {
        if (invokeArrayArg(recognizer, 'remove', this)) {
            return this;
        }

        recognizer = this.get(recognizer);

        // let's make sure this recognizer exists
        if (recognizer) {
            var recognizers = this.recognizers;
            var index = inArray(recognizers, recognizer);

            if (index !== -1) {
                recognizers.splice(index, 1);
                this.touchAction.update();
            }
        }

        return this;
    },

    /**
     * bind event
     * @param {String} events
     * @param {Function} handler
     * @returns {EventEmitter} this
     */
    on: function(events, handler) {
        if (events === undefined) {
            return;
        }
        if (handler === undefined) {
            return;
        }

        var handlers = this.handlers;
        each(splitStr(events), function(event) {
            handlers[event] = handlers[event] || [];
            handlers[event].push(handler);
        });
        return this;
    },

    /**
     * unbind event, leave emit blank to remove all handlers
     * @param {String} events
     * @param {Function} [handler]
     * @returns {EventEmitter} this
     */
    off: function(events, handler) {
        if (events === undefined) {
            return;
        }

        var handlers = this.handlers;
        each(splitStr(events), function(event) {
            if (!handler) {
                delete handlers[event];
            } else {
                handlers[event] && handlers[event].splice(inArray(handlers[event], handler), 1);
            }
        });
        return this;
    },

    /**
     * emit event to the listeners
     * @param {String} event
     * @param {Object} data
     */
    emit: function(event, data) {
        // we also want to trigger dom events
        if (this.options.domEvents) {
            triggerDomEvent(event, data);
        }

        // no handlers, so skip it all
        var handlers = this.handlers[event] && this.handlers[event].slice();
        if (!handlers || !handlers.length) {
            return;
        }

        data.type = event;
        data.preventDefault = function() {
            data.srcEvent.preventDefault();
        };

        var i = 0;
        while (i < handlers.length) {
            handlers[i](data);
            i++;
        }
    },

    /**
     * destroy the manager and unbinds all events
     * it doesn't unbind dom events, that is the user own responsibility
     */
    destroy: function() {
        this.element && toggleCssProps(this, false);

        this.handlers = {};
        this.session = {};
        this.input.destroy();
        this.element = null;
    }
};

/**
 * add/remove the css properties as defined in manager.options.cssProps
 * @param {Manager} manager
 * @param {Boolean} add
 */
function toggleCssProps(manager, add) {
    var element = manager.element;
    if (!element.style) {
        return;
    }
    var prop;
    each(manager.options.cssProps, function(value, name) {
        prop = prefixed(element.style, name);
        if (add) {
            manager.oldCssProps[prop] = element.style[prop];
            element.style[prop] = value;
        } else {
            element.style[prop] = manager.oldCssProps[prop] || '';
        }
    });
    if (!add) {
        manager.oldCssProps = {};
    }
}

/**
 * trigger dom event
 * @param {String} event
 * @param {Object} data
 */
function triggerDomEvent(event, data) {
    var gestureEvent = document.createEvent('Event');
    gestureEvent.initEvent(event, true, true);
    gestureEvent.gesture = data;
    data.target.dispatchEvent(gestureEvent);
}

assign(Hammer, {
    INPUT_START: INPUT_START,
    INPUT_MOVE: INPUT_MOVE,
    INPUT_END: INPUT_END,
    INPUT_CANCEL: INPUT_CANCEL,

    STATE_POSSIBLE: STATE_POSSIBLE,
    STATE_BEGAN: STATE_BEGAN,
    STATE_CHANGED: STATE_CHANGED,
    STATE_ENDED: STATE_ENDED,
    STATE_RECOGNIZED: STATE_RECOGNIZED,
    STATE_CANCELLED: STATE_CANCELLED,
    STATE_FAILED: STATE_FAILED,

    DIRECTION_NONE: DIRECTION_NONE,
    DIRECTION_LEFT: DIRECTION_LEFT,
    DIRECTION_RIGHT: DIRECTION_RIGHT,
    DIRECTION_UP: DIRECTION_UP,
    DIRECTION_DOWN: DIRECTION_DOWN,
    DIRECTION_HORIZONTAL: DIRECTION_HORIZONTAL,
    DIRECTION_VERTICAL: DIRECTION_VERTICAL,
    DIRECTION_ALL: DIRECTION_ALL,

    Manager: Manager,
    Input: Input,
    TouchAction: TouchAction,

    TouchInput: TouchInput,
    MouseInput: MouseInput,
    PointerEventInput: PointerEventInput,
    TouchMouseInput: TouchMouseInput,
    SingleTouchInput: SingleTouchInput,

    Recognizer: Recognizer,
    AttrRecognizer: AttrRecognizer,
    Tap: TapRecognizer,
    Pan: PanRecognizer,
    Swipe: SwipeRecognizer,
    Pinch: PinchRecognizer,
    Rotate: RotateRecognizer,
    Press: PressRecognizer,

    on: addEventListeners,
    off: removeEventListeners,
    each: each,
    merge: merge,
    extend: extend,
    assign: assign,
    inherit: inherit,
    bindFn: bindFn,
    prefixed: prefixed
});

// this prevents errors when Hammer is loaded in the presence of an AMD
//  style loader but by script tag, not by the loader.
var freeGlobal = (typeof window !== 'undefined' ? window : (typeof self !== 'undefined' ? self : {})); // jshint ignore:line
freeGlobal.Hammer = Hammer;

if (true) {
    !(__WEBPACK_AMD_DEFINE_RESULT__ = (function() {
        return Hammer;
    }).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
} else if (typeof module != 'undefined' && module.exports) {
    module.exports = Hammer;
} else {
    window[exportName] = Hammer;
}

})(window, document, 'Hammer');


/***/ }),
/* 92 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Url */
/* unused harmony export Http */
/* unused harmony export Resource */
/*!
 * vue-resource v1.5.1
 * https://github.com/pagekit/vue-resource
 * Released under the MIT License.
 */

/**
 * Promises/A+ polyfill v1.1.4 (https://github.com/bramstein/promis)
 */

var RESOLVED = 0;
var REJECTED = 1;
var PENDING = 2;

function Promise$1(executor) {

    this.state = PENDING;
    this.value = undefined;
    this.deferred = [];

    var promise = this;

    try {
        executor(function (x) {
            promise.resolve(x);
        }, function (r) {
            promise.reject(r);
        });
    } catch (e) {
        promise.reject(e);
    }
}

Promise$1.reject = function (r) {
    return new Promise$1(function (resolve, reject) {
        reject(r);
    });
};

Promise$1.resolve = function (x) {
    return new Promise$1(function (resolve, reject) {
        resolve(x);
    });
};

Promise$1.all = function all(iterable) {
    return new Promise$1(function (resolve, reject) {
        var count = 0, result = [];

        if (iterable.length === 0) {
            resolve(result);
        }

        function resolver(i) {
            return function (x) {
                result[i] = x;
                count += 1;

                if (count === iterable.length) {
                    resolve(result);
                }
            };
        }

        for (var i = 0; i < iterable.length; i += 1) {
            Promise$1.resolve(iterable[i]).then(resolver(i), reject);
        }
    });
};

Promise$1.race = function race(iterable) {
    return new Promise$1(function (resolve, reject) {
        for (var i = 0; i < iterable.length; i += 1) {
            Promise$1.resolve(iterable[i]).then(resolve, reject);
        }
    });
};

var p = Promise$1.prototype;

p.resolve = function resolve(x) {
    var promise = this;

    if (promise.state === PENDING) {
        if (x === promise) {
            throw new TypeError('Promise settled with itself.');
        }

        var called = false;

        try {
            var then = x && x['then'];

            if (x !== null && typeof x === 'object' && typeof then === 'function') {
                then.call(x, function (x) {
                    if (!called) {
                        promise.resolve(x);
                    }
                    called = true;

                }, function (r) {
                    if (!called) {
                        promise.reject(r);
                    }
                    called = true;
                });
                return;
            }
        } catch (e) {
            if (!called) {
                promise.reject(e);
            }
            return;
        }

        promise.state = RESOLVED;
        promise.value = x;
        promise.notify();
    }
};

p.reject = function reject(reason) {
    var promise = this;

    if (promise.state === PENDING) {
        if (reason === promise) {
            throw new TypeError('Promise settled with itself.');
        }

        promise.state = REJECTED;
        promise.value = reason;
        promise.notify();
    }
};

p.notify = function notify() {
    var promise = this;

    nextTick(function () {
        if (promise.state !== PENDING) {
            while (promise.deferred.length) {
                var deferred = promise.deferred.shift(),
                    onResolved = deferred[0],
                    onRejected = deferred[1],
                    resolve = deferred[2],
                    reject = deferred[3];

                try {
                    if (promise.state === RESOLVED) {
                        if (typeof onResolved === 'function') {
                            resolve(onResolved.call(undefined, promise.value));
                        } else {
                            resolve(promise.value);
                        }
                    } else if (promise.state === REJECTED) {
                        if (typeof onRejected === 'function') {
                            resolve(onRejected.call(undefined, promise.value));
                        } else {
                            reject(promise.value);
                        }
                    }
                } catch (e) {
                    reject(e);
                }
            }
        }
    });
};

p.then = function then(onResolved, onRejected) {
    var promise = this;

    return new Promise$1(function (resolve, reject) {
        promise.deferred.push([onResolved, onRejected, resolve, reject]);
        promise.notify();
    });
};

p.catch = function (onRejected) {
    return this.then(undefined, onRejected);
};

/**
 * Promise adapter.
 */

if (typeof Promise === 'undefined') {
    window.Promise = Promise$1;
}

function PromiseObj(executor, context) {

    if (executor instanceof Promise) {
        this.promise = executor;
    } else {
        this.promise = new Promise(executor.bind(context));
    }

    this.context = context;
}

PromiseObj.all = function (iterable, context) {
    return new PromiseObj(Promise.all(iterable), context);
};

PromiseObj.resolve = function (value, context) {
    return new PromiseObj(Promise.resolve(value), context);
};

PromiseObj.reject = function (reason, context) {
    return new PromiseObj(Promise.reject(reason), context);
};

PromiseObj.race = function (iterable, context) {
    return new PromiseObj(Promise.race(iterable), context);
};

var p$1 = PromiseObj.prototype;

p$1.bind = function (context) {
    this.context = context;
    return this;
};

p$1.then = function (fulfilled, rejected) {

    if (fulfilled && fulfilled.bind && this.context) {
        fulfilled = fulfilled.bind(this.context);
    }

    if (rejected && rejected.bind && this.context) {
        rejected = rejected.bind(this.context);
    }

    return new PromiseObj(this.promise.then(fulfilled, rejected), this.context);
};

p$1.catch = function (rejected) {

    if (rejected && rejected.bind && this.context) {
        rejected = rejected.bind(this.context);
    }

    return new PromiseObj(this.promise.catch(rejected), this.context);
};

p$1.finally = function (callback) {

    return this.then(function (value) {
        callback.call(this);
        return value;
    }, function (reason) {
        callback.call(this);
        return Promise.reject(reason);
    }
    );
};

/**
 * Utility functions.
 */

var ref = {};
var hasOwnProperty = ref.hasOwnProperty;
var ref$1 = [];
var slice = ref$1.slice;
var debug = false, ntick;

var inBrowser = typeof window !== 'undefined';

function Util (ref) {
    var config = ref.config;
    var nextTick = ref.nextTick;

    ntick = nextTick;
    debug = config.debug || !config.silent;
}

function warn(msg) {
    if (typeof console !== 'undefined' && debug) {
        console.warn('[VueResource warn]: ' + msg);
    }
}

function error(msg) {
    if (typeof console !== 'undefined') {
        console.error(msg);
    }
}

function nextTick(cb, ctx) {
    return ntick(cb, ctx);
}

function trim(str) {
    return str ? str.replace(/^\s*|\s*$/g, '') : '';
}

function trimEnd(str, chars) {

    if (str && chars === undefined) {
        return str.replace(/\s+$/, '');
    }

    if (!str || !chars) {
        return str;
    }

    return str.replace(new RegExp(("[" + chars + "]+$")), '');
}

function toLower(str) {
    return str ? str.toLowerCase() : '';
}

function toUpper(str) {
    return str ? str.toUpperCase() : '';
}

var isArray = Array.isArray;

function isString(val) {
    return typeof val === 'string';
}

function isFunction(val) {
    return typeof val === 'function';
}

function isObject(obj) {
    return obj !== null && typeof obj === 'object';
}

function isPlainObject(obj) {
    return isObject(obj) && Object.getPrototypeOf(obj) == Object.prototype;
}

function isBlob(obj) {
    return typeof Blob !== 'undefined' && obj instanceof Blob;
}

function isFormData(obj) {
    return typeof FormData !== 'undefined' && obj instanceof FormData;
}

function when(value, fulfilled, rejected) {

    var promise = PromiseObj.resolve(value);

    if (arguments.length < 2) {
        return promise;
    }

    return promise.then(fulfilled, rejected);
}

function options(fn, obj, opts) {

    opts = opts || {};

    if (isFunction(opts)) {
        opts = opts.call(obj);
    }

    return merge(fn.bind({$vm: obj, $options: opts}), fn, {$options: opts});
}

function each(obj, iterator) {

    var i, key;

    if (isArray(obj)) {
        for (i = 0; i < obj.length; i++) {
            iterator.call(obj[i], obj[i], i);
        }
    } else if (isObject(obj)) {
        for (key in obj) {
            if (hasOwnProperty.call(obj, key)) {
                iterator.call(obj[key], obj[key], key);
            }
        }
    }

    return obj;
}

var assign = Object.assign || _assign;

function merge(target) {

    var args = slice.call(arguments, 1);

    args.forEach(function (source) {
        _merge(target, source, true);
    });

    return target;
}

function defaults(target) {

    var args = slice.call(arguments, 1);

    args.forEach(function (source) {

        for (var key in source) {
            if (target[key] === undefined) {
                target[key] = source[key];
            }
        }

    });

    return target;
}

function _assign(target) {

    var args = slice.call(arguments, 1);

    args.forEach(function (source) {
        _merge(target, source);
    });

    return target;
}

function _merge(target, source, deep) {
    for (var key in source) {
        if (deep && (isPlainObject(source[key]) || isArray(source[key]))) {
            if (isPlainObject(source[key]) && !isPlainObject(target[key])) {
                target[key] = {};
            }
            if (isArray(source[key]) && !isArray(target[key])) {
                target[key] = [];
            }
            _merge(target[key], source[key], deep);
        } else if (source[key] !== undefined) {
            target[key] = source[key];
        }
    }
}

/**
 * Root Prefix Transform.
 */

function root (options$$1, next) {

    var url = next(options$$1);

    if (isString(options$$1.root) && !/^(https?:)?\//.test(url)) {
        url = trimEnd(options$$1.root, '/') + '/' + url;
    }

    return url;
}

/**
 * Query Parameter Transform.
 */

function query (options$$1, next) {

    var urlParams = Object.keys(Url.options.params), query = {}, url = next(options$$1);

    each(options$$1.params, function (value, key) {
        if (urlParams.indexOf(key) === -1) {
            query[key] = value;
        }
    });

    query = Url.params(query);

    if (query) {
        url += (url.indexOf('?') == -1 ? '?' : '&') + query;
    }

    return url;
}

/**
 * URL Template v2.0.6 (https://github.com/bramstein/url-template)
 */

function expand(url, params, variables) {

    var tmpl = parse(url), expanded = tmpl.expand(params);

    if (variables) {
        variables.push.apply(variables, tmpl.vars);
    }

    return expanded;
}

function parse(template) {

    var operators = ['+', '#', '.', '/', ';', '?', '&'], variables = [];

    return {
        vars: variables,
        expand: function expand(context) {
            return template.replace(/\{([^{}]+)\}|([^{}]+)/g, function (_, expression, literal) {
                if (expression) {

                    var operator = null, values = [];

                    if (operators.indexOf(expression.charAt(0)) !== -1) {
                        operator = expression.charAt(0);
                        expression = expression.substr(1);
                    }

                    expression.split(/,/g).forEach(function (variable) {
                        var tmp = /([^:*]*)(?::(\d+)|(\*))?/.exec(variable);
                        values.push.apply(values, getValues(context, operator, tmp[1], tmp[2] || tmp[3]));
                        variables.push(tmp[1]);
                    });

                    if (operator && operator !== '+') {

                        var separator = ',';

                        if (operator === '?') {
                            separator = '&';
                        } else if (operator !== '#') {
                            separator = operator;
                        }

                        return (values.length !== 0 ? operator : '') + values.join(separator);
                    } else {
                        return values.join(',');
                    }

                } else {
                    return encodeReserved(literal);
                }
            });
        }
    };
}

function getValues(context, operator, key, modifier) {

    var value = context[key], result = [];

    if (isDefined(value) && value !== '') {
        if (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean') {
            value = value.toString();

            if (modifier && modifier !== '*') {
                value = value.substring(0, parseInt(modifier, 10));
            }

            result.push(encodeValue(operator, value, isKeyOperator(operator) ? key : null));
        } else {
            if (modifier === '*') {
                if (Array.isArray(value)) {
                    value.filter(isDefined).forEach(function (value) {
                        result.push(encodeValue(operator, value, isKeyOperator(operator) ? key : null));
                    });
                } else {
                    Object.keys(value).forEach(function (k) {
                        if (isDefined(value[k])) {
                            result.push(encodeValue(operator, value[k], k));
                        }
                    });
                }
            } else {
                var tmp = [];

                if (Array.isArray(value)) {
                    value.filter(isDefined).forEach(function (value) {
                        tmp.push(encodeValue(operator, value));
                    });
                } else {
                    Object.keys(value).forEach(function (k) {
                        if (isDefined(value[k])) {
                            tmp.push(encodeURIComponent(k));
                            tmp.push(encodeValue(operator, value[k].toString()));
                        }
                    });
                }

                if (isKeyOperator(operator)) {
                    result.push(encodeURIComponent(key) + '=' + tmp.join(','));
                } else if (tmp.length !== 0) {
                    result.push(tmp.join(','));
                }
            }
        }
    } else {
        if (operator === ';') {
            result.push(encodeURIComponent(key));
        } else if (value === '' && (operator === '&' || operator === '?')) {
            result.push(encodeURIComponent(key) + '=');
        } else if (value === '') {
            result.push('');
        }
    }

    return result;
}

function isDefined(value) {
    return value !== undefined && value !== null;
}

function isKeyOperator(operator) {
    return operator === ';' || operator === '&' || operator === '?';
}

function encodeValue(operator, value, key) {

    value = (operator === '+' || operator === '#') ? encodeReserved(value) : encodeURIComponent(value);

    if (key) {
        return encodeURIComponent(key) + '=' + value;
    } else {
        return value;
    }
}

function encodeReserved(str) {
    return str.split(/(%[0-9A-Fa-f]{2})/g).map(function (part) {
        if (!/%[0-9A-Fa-f]/.test(part)) {
            part = encodeURI(part);
        }
        return part;
    }).join('');
}

/**
 * URL Template (RFC 6570) Transform.
 */

function template (options) {

    var variables = [], url = expand(options.url, options.params, variables);

    variables.forEach(function (key) {
        delete options.params[key];
    });

    return url;
}

/**
 * Service for URL templating.
 */

function Url(url, params) {

    var self = this || {}, options$$1 = url, transform;

    if (isString(url)) {
        options$$1 = {url: url, params: params};
    }

    options$$1 = merge({}, Url.options, self.$options, options$$1);

    Url.transforms.forEach(function (handler) {

        if (isString(handler)) {
            handler = Url.transform[handler];
        }

        if (isFunction(handler)) {
            transform = factory(handler, transform, self.$vm);
        }

    });

    return transform(options$$1);
}

/**
 * Url options.
 */

Url.options = {
    url: '',
    root: null,
    params: {}
};

/**
 * Url transforms.
 */

Url.transform = {template: template, query: query, root: root};
Url.transforms = ['template', 'query', 'root'];

/**
 * Encodes a Url parameter string.
 *
 * @param {Object} obj
 */

Url.params = function (obj) {

    var params = [], escape = encodeURIComponent;

    params.add = function (key, value) {

        if (isFunction(value)) {
            value = value();
        }

        if (value === null) {
            value = '';
        }

        this.push(escape(key) + '=' + escape(value));
    };

    serialize(params, obj);

    return params.join('&').replace(/%20/g, '+');
};

/**
 * Parse a URL and return its components.
 *
 * @param {String} url
 */

Url.parse = function (url) {

    var el = document.createElement('a');

    if (document.documentMode) {
        el.href = url;
        url = el.href;
    }

    el.href = url;

    return {
        href: el.href,
        protocol: el.protocol ? el.protocol.replace(/:$/, '') : '',
        port: el.port,
        host: el.host,
        hostname: el.hostname,
        pathname: el.pathname.charAt(0) === '/' ? el.pathname : '/' + el.pathname,
        search: el.search ? el.search.replace(/^\?/, '') : '',
        hash: el.hash ? el.hash.replace(/^#/, '') : ''
    };
};

function factory(handler, next, vm) {
    return function (options$$1) {
        return handler.call(vm, options$$1, next);
    };
}

function serialize(params, obj, scope) {

    var array = isArray(obj), plain = isPlainObject(obj), hash;

    each(obj, function (value, key) {

        hash = isObject(value) || isArray(value);

        if (scope) {
            key = scope + '[' + (plain || hash ? key : '') + ']';
        }

        if (!scope && array) {
            params.add(value.name, value.value);
        } else if (hash) {
            serialize(params, value, key);
        } else {
            params.add(key, value);
        }
    });
}

/**
 * XDomain client (Internet Explorer).
 */

function xdrClient (request) {
    return new PromiseObj(function (resolve) {

        var xdr = new XDomainRequest(), handler = function (ref) {
                var type = ref.type;


                var status = 0;

                if (type === 'load') {
                    status = 200;
                } else if (type === 'error') {
                    status = 500;
                }

                resolve(request.respondWith(xdr.responseText, {status: status}));
            };

        request.abort = function () { return xdr.abort(); };

        xdr.open(request.method, request.getUrl());

        if (request.timeout) {
            xdr.timeout = request.timeout;
        }

        xdr.onload = handler;
        xdr.onabort = handler;
        xdr.onerror = handler;
        xdr.ontimeout = handler;
        xdr.onprogress = function () {};
        xdr.send(request.getBody());
    });
}

/**
 * CORS Interceptor.
 */

var SUPPORTS_CORS = inBrowser && 'withCredentials' in new XMLHttpRequest();

function cors (request) {

    if (inBrowser) {

        var orgUrl = Url.parse(location.href);
        var reqUrl = Url.parse(request.getUrl());

        if (reqUrl.protocol !== orgUrl.protocol || reqUrl.host !== orgUrl.host) {

            request.crossOrigin = true;
            request.emulateHTTP = false;

            if (!SUPPORTS_CORS) {
                request.client = xdrClient;
            }
        }
    }

}

/**
 * Form data Interceptor.
 */

function form (request) {

    if (isFormData(request.body)) {
        request.headers.delete('Content-Type');
    } else if (isObject(request.body) && request.emulateJSON) {
        request.body = Url.params(request.body);
        request.headers.set('Content-Type', 'application/x-www-form-urlencoded');
    }

}

/**
 * JSON Interceptor.
 */

function json (request) {

    var type = request.headers.get('Content-Type') || '';

    if (isObject(request.body) && type.indexOf('application/json') === 0) {
        request.body = JSON.stringify(request.body);
    }

    return function (response) {

        return response.bodyText ? when(response.text(), function (text) {

            var type = response.headers.get('Content-Type') || '';

            if (type.indexOf('application/json') === 0 || isJson(text)) {

                try {
                    response.body = JSON.parse(text);
                } catch (e) {
                    response.body = null;
                }

            } else {
                response.body = text;
            }

            return response;

        }) : response;

    };
}

function isJson(str) {

    var start = str.match(/^\s*(\[|\{)/);
    var end = {'[': /]\s*$/, '{': /}\s*$/};

    return start && end[start[1]].test(str);
}

/**
 * JSONP client (Browser).
 */

function jsonpClient (request) {
    return new PromiseObj(function (resolve) {

        var name = request.jsonp || 'callback', callback = request.jsonpCallback || '_jsonp' + Math.random().toString(36).substr(2), body = null, handler, script;

        handler = function (ref) {
            var type = ref.type;


            var status = 0;

            if (type === 'load' && body !== null) {
                status = 200;
            } else if (type === 'error') {
                status = 500;
            }

            if (status && window[callback]) {
                delete window[callback];
                document.body.removeChild(script);
            }

            resolve(request.respondWith(body, {status: status}));
        };

        window[callback] = function (result) {
            body = JSON.stringify(result);
        };

        request.abort = function () {
            handler({type: 'abort'});
        };

        request.params[name] = callback;

        if (request.timeout) {
            setTimeout(request.abort, request.timeout);
        }

        script = document.createElement('script');
        script.src = request.getUrl();
        script.type = 'text/javascript';
        script.async = true;
        script.onload = handler;
        script.onerror = handler;

        document.body.appendChild(script);
    });
}

/**
 * JSONP Interceptor.
 */

function jsonp (request) {

    if (request.method == 'JSONP') {
        request.client = jsonpClient;
    }

}

/**
 * Before Interceptor.
 */

function before (request) {

    if (isFunction(request.before)) {
        request.before.call(this, request);
    }

}

/**
 * HTTP method override Interceptor.
 */

function method (request) {

    if (request.emulateHTTP && /^(PUT|PATCH|DELETE)$/i.test(request.method)) {
        request.headers.set('X-HTTP-Method-Override', request.method);
        request.method = 'POST';
    }

}

/**
 * Header Interceptor.
 */

function header (request) {

    var headers = assign({}, Http.headers.common,
        !request.crossOrigin ? Http.headers.custom : {},
        Http.headers[toLower(request.method)]
    );

    each(headers, function (value, name) {
        if (!request.headers.has(name)) {
            request.headers.set(name, value);
        }
    });

}

/**
 * XMLHttp client (Browser).
 */

function xhrClient (request) {
    return new PromiseObj(function (resolve) {

        var xhr = new XMLHttpRequest(), handler = function (event) {

                var response = request.respondWith(
                'response' in xhr ? xhr.response : xhr.responseText, {
                    status: xhr.status === 1223 ? 204 : xhr.status, // IE9 status bug
                    statusText: xhr.status === 1223 ? 'No Content' : trim(xhr.statusText)
                });

                each(trim(xhr.getAllResponseHeaders()).split('\n'), function (row) {
                    response.headers.append(row.slice(0, row.indexOf(':')), row.slice(row.indexOf(':') + 1));
                });

                resolve(response);
            };

        request.abort = function () { return xhr.abort(); };

        xhr.open(request.method, request.getUrl(), true);

        if (request.timeout) {
            xhr.timeout = request.timeout;
        }

        if (request.responseType && 'responseType' in xhr) {
            xhr.responseType = request.responseType;
        }

        if (request.withCredentials || request.credentials) {
            xhr.withCredentials = true;
        }

        if (!request.crossOrigin) {
            request.headers.set('X-Requested-With', 'XMLHttpRequest');
        }

        // deprecated use downloadProgress
        if (isFunction(request.progress) && request.method === 'GET') {
            xhr.addEventListener('progress', request.progress);
        }

        if (isFunction(request.downloadProgress)) {
            xhr.addEventListener('progress', request.downloadProgress);
        }

        // deprecated use uploadProgress
        if (isFunction(request.progress) && /^(POST|PUT)$/i.test(request.method)) {
            xhr.upload.addEventListener('progress', request.progress);
        }

        if (isFunction(request.uploadProgress) && xhr.upload) {
            xhr.upload.addEventListener('progress', request.uploadProgress);
        }

        request.headers.forEach(function (value, name) {
            xhr.setRequestHeader(name, value);
        });

        xhr.onload = handler;
        xhr.onabort = handler;
        xhr.onerror = handler;
        xhr.ontimeout = handler;
        xhr.send(request.getBody());
    });
}

/**
 * Http client (Node).
 */

function nodeClient (request) {

    var client = __webpack_require__(93);

    return new PromiseObj(function (resolve) {

        var url = request.getUrl();
        var body = request.getBody();
        var method = request.method;
        var headers = {}, handler;

        request.headers.forEach(function (value, name) {
            headers[name] = value;
        });

        client(url, {body: body, method: method, headers: headers}).then(handler = function (resp) {

            var response = request.respondWith(resp.body, {
                status: resp.statusCode,
                statusText: trim(resp.statusMessage)
            });

            each(resp.headers, function (value, name) {
                response.headers.set(name, value);
            });

            resolve(response);

        }, function (error$$1) { return handler(error$$1.response); });
    });
}

/**
 * Base client.
 */

function Client (context) {

    var reqHandlers = [sendRequest], resHandlers = [];

    if (!isObject(context)) {
        context = null;
    }

    function Client(request) {
        while (reqHandlers.length) {

            var handler = reqHandlers.pop();

            if (isFunction(handler)) {

                var response = (void 0), next = (void 0);

                response = handler.call(context, request, function (val) { return next = val; }) || next;

                if (isObject(response)) {
                    return new PromiseObj(function (resolve, reject) {

                        resHandlers.forEach(function (handler) {
                            response = when(response, function (response) {
                                return handler.call(context, response) || response;
                            }, reject);
                        });

                        when(response, resolve, reject);

                    }, context);
                }

                if (isFunction(response)) {
                    resHandlers.unshift(response);
                }

            } else {
                warn(("Invalid interceptor of type " + (typeof handler) + ", must be a function"));
            }
        }
    }

    Client.use = function (handler) {
        reqHandlers.push(handler);
    };

    return Client;
}

function sendRequest(request) {

    var client = request.client || (inBrowser ? xhrClient : nodeClient);

    return client(request);
}

/**
 * HTTP Headers.
 */

var Headers = function Headers(headers) {
    var this$1 = this;


    this.map = {};

    each(headers, function (value, name) { return this$1.append(name, value); });
};

Headers.prototype.has = function has (name) {
    return getName(this.map, name) !== null;
};

Headers.prototype.get = function get (name) {

    var list = this.map[getName(this.map, name)];

    return list ? list.join() : null;
};

Headers.prototype.getAll = function getAll (name) {
    return this.map[getName(this.map, name)] || [];
};

Headers.prototype.set = function set (name, value) {
    this.map[normalizeName(getName(this.map, name) || name)] = [trim(value)];
};

Headers.prototype.append = function append (name, value) {

    var list = this.map[getName(this.map, name)];

    if (list) {
        list.push(trim(value));
    } else {
        this.set(name, value);
    }
};

Headers.prototype.delete = function delete$1 (name) {
    delete this.map[getName(this.map, name)];
};

Headers.prototype.deleteAll = function deleteAll () {
    this.map = {};
};

Headers.prototype.forEach = function forEach (callback, thisArg) {
        var this$1 = this;

    each(this.map, function (list, name) {
        each(list, function (value) { return callback.call(thisArg, value, name, this$1); });
    });
};

function getName(map, name) {
    return Object.keys(map).reduce(function (prev, curr) {
        return toLower(name) === toLower(curr) ? curr : prev;
    }, null);
}

function normalizeName(name) {

    if (/[^a-z0-9\-#$%&'*+.^_`|~]/i.test(name)) {
        throw new TypeError('Invalid character in header field name');
    }

    return trim(name);
}

/**
 * HTTP Response.
 */

var Response = function Response(body, ref) {
    var url = ref.url;
    var headers = ref.headers;
    var status = ref.status;
    var statusText = ref.statusText;


    this.url = url;
    this.ok = status >= 200 && status < 300;
    this.status = status || 0;
    this.statusText = statusText || '';
    this.headers = new Headers(headers);
    this.body = body;

    if (isString(body)) {

        this.bodyText = body;

    } else if (isBlob(body)) {

        this.bodyBlob = body;

        if (isBlobText(body)) {
            this.bodyText = blobText(body);
        }
    }
};

Response.prototype.blob = function blob () {
    return when(this.bodyBlob);
};

Response.prototype.text = function text () {
    return when(this.bodyText);
};

Response.prototype.json = function json () {
    return when(this.text(), function (text) { return JSON.parse(text); });
};

Object.defineProperty(Response.prototype, 'data', {

    get: function get() {
        return this.body;
    },

    set: function set(body) {
        this.body = body;
    }

});

function blobText(body) {
    return new PromiseObj(function (resolve) {

        var reader = new FileReader();

        reader.readAsText(body);
        reader.onload = function () {
            resolve(reader.result);
        };

    });
}

function isBlobText(body) {
    return body.type.indexOf('text') === 0 || body.type.indexOf('json') !== -1;
}

/**
 * HTTP Request.
 */

var Request = function Request(options$$1) {

    this.body = null;
    this.params = {};

    assign(this, options$$1, {
        method: toUpper(options$$1.method || 'GET')
    });

    if (!(this.headers instanceof Headers)) {
        this.headers = new Headers(this.headers);
    }
};

Request.prototype.getUrl = function getUrl () {
    return Url(this);
};

Request.prototype.getBody = function getBody () {
    return this.body;
};

Request.prototype.respondWith = function respondWith (body, options$$1) {
    return new Response(body, assign(options$$1 || {}, {url: this.getUrl()}));
};

/**
 * Service for sending network requests.
 */

var COMMON_HEADERS = {'Accept': 'application/json, text/plain, */*'};
var JSON_CONTENT_TYPE = {'Content-Type': 'application/json;charset=utf-8'};

function Http(options$$1) {

    var self = this || {}, client = Client(self.$vm);

    defaults(options$$1 || {}, self.$options, Http.options);

    Http.interceptors.forEach(function (handler) {

        if (isString(handler)) {
            handler = Http.interceptor[handler];
        }

        if (isFunction(handler)) {
            client.use(handler);
        }

    });

    return client(new Request(options$$1)).then(function (response) {

        return response.ok ? response : PromiseObj.reject(response);

    }, function (response) {

        if (response instanceof Error) {
            error(response);
        }

        return PromiseObj.reject(response);
    });
}

Http.options = {};

Http.headers = {
    put: JSON_CONTENT_TYPE,
    post: JSON_CONTENT_TYPE,
    patch: JSON_CONTENT_TYPE,
    delete: JSON_CONTENT_TYPE,
    common: COMMON_HEADERS,
    custom: {}
};

Http.interceptor = {before: before, method: method, jsonp: jsonp, json: json, form: form, header: header, cors: cors};
Http.interceptors = ['before', 'method', 'jsonp', 'json', 'form', 'header', 'cors'];

['get', 'delete', 'head', 'jsonp'].forEach(function (method$$1) {

    Http[method$$1] = function (url, options$$1) {
        return this(assign(options$$1 || {}, {url: url, method: method$$1}));
    };

});

['post', 'put', 'patch'].forEach(function (method$$1) {

    Http[method$$1] = function (url, body, options$$1) {
        return this(assign(options$$1 || {}, {url: url, method: method$$1, body: body}));
    };

});

/**
 * Service for interacting with RESTful services.
 */

function Resource(url, params, actions, options$$1) {

    var self = this || {}, resource = {};

    actions = assign({},
        Resource.actions,
        actions
    );

    each(actions, function (action, name) {

        action = merge({url: url, params: assign({}, params)}, options$$1, action);

        resource[name] = function () {
            return (self.$http || Http)(opts(action, arguments));
        };
    });

    return resource;
}

function opts(action, args) {

    var options$$1 = assign({}, action), params = {}, body;

    switch (args.length) {

        case 2:

            params = args[0];
            body = args[1];

            break;

        case 1:

            if (/^(POST|PUT|PATCH)$/i.test(options$$1.method)) {
                body = args[0];
            } else {
                params = args[0];
            }

            break;

        case 0:

            break;

        default:

            throw 'Expected up to 2 arguments [params, body], got ' + args.length + ' arguments';
    }

    options$$1.body = body;
    options$$1.params = assign({}, options$$1.params, params);

    return options$$1;
}

Resource.actions = {

    get: {method: 'GET'},
    save: {method: 'POST'},
    query: {method: 'GET'},
    update: {method: 'PUT'},
    remove: {method: 'DELETE'},
    delete: {method: 'DELETE'}

};

/**
 * Install plugin.
 */

function plugin(Vue) {

    if (plugin.installed) {
        return;
    }

    Util(Vue);

    Vue.url = Url;
    Vue.http = Http;
    Vue.resource = Resource;
    Vue.Promise = PromiseObj;

    Object.defineProperties(Vue.prototype, {

        $url: {
            get: function get() {
                return options(Vue.url, this, this.$options.url);
            }
        },

        $http: {
            get: function get() {
                return options(Vue.http, this, this.$options.http);
            }
        },

        $resource: {
            get: function get() {
                return Vue.resource.bind(this);
            }
        },

        $promise: {
            get: function get() {
                var this$1 = this;

                return function (executor) { return new Vue.Promise(executor, this$1); };
            }
        }

    });
}

if (typeof window !== 'undefined' && window.Vue) {
    window.Vue.use(plugin);
}

/* harmony default export */ __webpack_exports__["a"] = (plugin);



/***/ }),
/* 93 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,n){if(true)module.exports=n();else if("function"==typeof define&&define.amd)define([],n);else{var t=n();for(var r in t)("object"==typeof exports?exports:e)[r]=t[r]}}("undefined"!=typeof self?self:this,(function(){return function(e){var n={};function t(r){if(n[r])return n[r].exports;var o=n[r]={i:r,l:!1,exports:{}};return e[r].call(o.exports,o,o.exports,t),o.l=!0,o.exports}return t.m=e,t.c=n,t.d=function(e,n,r){t.o(e,n)||Object.defineProperty(e,n,{enumerable:!0,get:r})},t.r=function(e){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(e,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(e,"__esModule",{value:!0})},t.t=function(e,n){if(1&n&&(e=t(e)),8&n)return e;if(4&n&&"object"==typeof e&&e&&e.__esModule)return e;var r=Object.create(null);if(t.r(r),Object.defineProperty(r,"default",{enumerable:!0,value:e}),2&n&&"string"!=typeof e)for(var o in e)t.d(r,o,function(n){return e[n]}.bind(null,o));return r},t.n=function(e){var n=e&&e.__esModule?function(){return e.default}:function(){return e};return t.d(n,"a",n),n},t.o=function(e,n){return Object.prototype.hasOwnProperty.call(e,n)},t.p="",t(t.s=0)}([function(e,n,t){"use strict";function r(e,n){var t=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);n&&(r=r.filter((function(n){return Object.getOwnPropertyDescriptor(e,n).enumerable}))),t.push.apply(t,r)}return t}function o(e){for(var n=1;n<arguments.length;n++){var t=null!=arguments[n]?arguments[n]:{};n%2?r(t,!0).forEach((function(n){i(e,n,t[n])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(t)):r(t).forEach((function(n){Object.defineProperty(e,n,Object.getOwnPropertyDescriptor(t,n))}))}return e}function i(e,n,t){return n in e?Object.defineProperty(e,n,{value:t,enumerable:!0,configurable:!0,writable:!0}):e[n]=t,e}t.r(n);var c={$vue:null,id:null,router:null,fields:{},customIdFields:{},ignoreRoutes:[],linkers:[],commands:{},disabled:!1,customResourceURL:null,set:[],require:[],ecommerce:{enabled:!1,options:null,enhanced:!1},autoTracking:{screenview:!1,shouldRouterUpdate:null,skipSamePath:!1,exception:!1,exceptionLogs:!0,page:!0,transformQueryString:!0,pageviewOnLoad:!0,pageviewTemplate:null,untracked:!0,prependBase:!0},debug:{enabled:!1,trace:!1,sendHitTask:!0},batch:{enabled:!1,delay:500,amount:2},checkDuplicatedScript:!1,disableScriptLoader:!1,beforeFirstHit:s,ready:s,untracked:[]},a=o({},c);function u(e){!function e(n,t){return Object.keys(t).forEach((function(r){var o=n[r]&&Object.prototype.toString.call(n[r]);"[object Object]"!==o&&"[object Array]"!==o?n[r]=t[r]:e(n[r],t[r])})),n}(a,e)}function f(){return a.id?[].concat(a.id):[]}var l=a;function s(){}var p=function(e){console.warn("[vue-analytics] ".concat(e))};function d(e,n){return new Promise((function(t,r){var o=document.head||document.getElementsByTagName("head")[0],i=document.createElement("script");if(i.async=!0,i.src=e,i.charset="utf-8",n){var c=document.createElement("link");c.href=n,c.rel="preconnect",o.appendChild(c)}o.appendChild(i),i.onload=t,i.onerror=r}))}function y(e){return e.name||e.replace(/-/gi,"")}function b(e,n){if(f().length>1){var t=y(n);return"".concat(t,".").concat(e)}return e}var m,v=function(e){if(e.then)return e;if("function"==typeof e){var n=e();return n.then?n:Promise.resolve(n)}return Promise.resolve(e)};function g(e){return function(e){if(Array.isArray(e)){for(var n=0,t=new Array(e.length);n<e.length;n++)t[n]=e[n];return t}}(e)||function(e){if(Symbol.iterator in Object(e)||"[object Arguments]"===Object.prototype.toString.call(e))return Array.from(e)}(e)||function(){throw new TypeError("Invalid attempt to spread non-iterable instance")}()}var h=[];function w(e){for(var n=arguments.length,t=new Array(n>1?n-1:0),r=1;r<n;r++)t[r-1]=arguments[r];"undefined"!=typeof window&&f().forEach((function(n){var r,o={m:b(e,n),a:t};window.ga?l.batch.enabled?(h.push(o),m||(m=setInterval((function(){h.length?h.splice(0,l.batch.amount).forEach((function(e){var n;(n=window).ga.apply(n,[e.m].concat(g(e.a)))})):(clearInterval(m),m=null)}),l.batch.delay))):(r=window).ga.apply(r,[b(e,n)].concat(t)):l.untracked.push(o)}))}function O(e){return(O="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}function j(){for(var e=arguments.length,n=new Array(e),t=0;t<e;t++)n[t]=arguments[t];"object"!==O(n[0])||n[0].constructor!==Object?w("set",n[0],n[1]):w("set",n[0])}function P(e,n){var t=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);n&&(r=r.filter((function(n){return Object.getOwnPropertyDescriptor(e,n).enumerable}))),t.push.apply(t,r)}return t}function S(e,n,t){return n in e?Object.defineProperty(e,n,{value:t,enumerable:!0,configurable:!0,writable:!0}):e[n]=t,e}function k(){if(window.ga||!l.debug.enabled){if(window.ga){var e=f();l.debug.enabled&&(window.ga_debug={trace:l.debug.trace}),e.forEach((function(n){var t=y(n),r=l.customIdFields[n]||{},o=e.length>1?function(e){for(var n=1;n<arguments.length;n++){var t=null!=arguments[n]?arguments[n]:{};n%2?P(t,!0).forEach((function(n){S(e,n,t[n])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(t)):P(t).forEach((function(n){Object.defineProperty(e,n,Object.getOwnPropertyDescriptor(t,n))}))}return e}({},l.fields,{},r,{name:t}):l.fields;window.ga("create",n.id||n,"auto",o)})),l.beforeFirstHit();var n=l.ecommerce;if(n.enabled){var t=n.enhanced?"ec":"ecommerce";n.options?w("require",t,n.options):w("require",t)}l.linkers.length>0&&(w("require","linker"),w("linker:autoLink",l.linkers)),l.debug.sendHitTask||j("sendHitTask",null)}}else p("Google Analytics has probably been blocked.")}var E=function(){2!=arguments.length?w("require",arguments.length<=0?void 0:arguments[0]):w("require",arguments.length<=0?void 0:arguments[0],arguments.length<=1?void 0:arguments[1])};function A(e){return(A="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}var x=function(){var e;l.set.forEach((function(e){var n=e.field,t=e.value;if(void 0===n||void 0===t)throw new Error('[vue-analytics] Wrong configuration in the plugin options.\nThe "set" array requires each item to have a "field" and a "value" property.');j(n,t)})),e=["ec","ecommerce"],l.require.forEach((function(n){if(-1!==e.indexOf(n)||-1!==e.indexOf(n.name))throw new Error("[vue-analytics] The ecommerce features are built-in in the plugin. \nFollow the ecommerce instructions available in the documentation.");if("string"!=typeof n&&"object"!==A(n))throw new Error('[vue-analytics] Wrong configuration in the plugin options. \nThe "require" array requires each item to be a string or to have a "name" and an "options" property.');var t=n.name||n;n.options?E(t,n.options):E(t)}))};function T(){for(var e=arguments.length,n=new Array(e),t=0;t<e;t++)n[t]=arguments[t];var r=n[0];if(1===n.length&&"string"==typeof r)return w("send","screenview",{screenName:r});w.apply(void 0,["send","screenview"].concat(n))}function D(e){return(D="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}function q(){for(var e=arguments.length,n=new Array(e),t=0;t<e;t++)n[t]=arguments[t];var r;n.length&&!n[0]||(n.length&&n[0].currentRoute&&(r=n[0].currentRoute),n.length&&function(e){return e.query&&e.params}(n[0])&&(r=n[0]),r?R(r):(j("page","object"===D(n[0])?n[0].page:n[0]),w.apply(void 0,["send","pageview"].concat(n))))}function R(e){if(![(n=e).name,n.path].filter(Boolean).find((function(e){return-1!==l.ignoreRoutes.indexOf(e)}))){var n,t=l.autoTracking,r=e.meta.analytics,o=(void 0===r?{}:r).pageviewTemplate||t.pageviewTemplate;if(t.screenview&&!e.name)throw new Error("[vue-analytics] Route name is mandatory when using screenview.");if(t.screenview)T(e.name);else if(o)q(o(e));else{var i=l.router,c=l.autoTracking,a=c.transformQueryString,u=c.prependBase,f=function(e){var n=Object.keys(e).reduce((function(n,t,r,o){var i=r===o.length-1,c=e[t];return null==c?n:n+="".concat(t,"=").concat(c).concat(i?"":"&")}),"");return""!==n?"?".concat(n):""}(e.query),s=i&&i.options.base,p=u&&s,d=e.path+(a?f:"");q(d=p?function(e,n){var t=n.split("/"),r=e.split("/");return""===t[0]&&"/"===e[e.length-1]&&t.shift(),r.join("/")+t.join("/")}(s,d):d)}}}function I(e){return function(e){if(Array.isArray(e)){for(var n=0,t=new Array(e.length);n<e.length;n++)t[n]=e[n];return t}}(e)||function(e){if(Symbol.iterator in Object(e)||"[object Arguments]"===Object.prototype.toString.call(e))return Array.from(e)}(e)||function(){throw new TypeError("Invalid attempt to spread non-iterable instance")}()}var L=function(){var e=!(arguments.length>0&&void 0!==arguments[0])||arguments[0];"undefined"!=typeof window&&f().forEach((function(n){window["ga-disable-".concat(n)]=e}))},_=function(){if("undefined"!=typeof document&&"undefined"!=typeof window){if(l.id){var e,n,t=[v(l.id),v(l.disabled)];if(e=l.checkDuplicatedScript,n=l.disableScriptLoader,[Boolean(window&&window.ga),e&&!(Array.prototype.slice.call(document.getElementsByTagName("script")).filter((function(e){return-1!==e.src.indexOf("analytics")||-1!==e.src.indexOf("gtag")})).length>0),!n].some(Boolean)){var r="https://www.google-analytics.com",o=l.debug.enabled?"analytics_debug":"analytics",i=l.customResourceURL?d(l.customResourceURL):d("".concat(r,"/").concat(o,".js"),r);t.push(i.catch((function(){p("An error occured! Please check your connection or disable your AD blocker")})))}return Promise.all(t).then((function(e){var n,t,r;u({id:e[0],disabled:e[1]}),L(l.disabled),k(),x(),l.untracked.forEach((function(e){w.apply(void 0,[e.m].concat(I(e.a)))})),n=l.router,t=l.autoTracking,r=l.$vue,t.page&&n&&n.onReady((function(){t.pageviewOnLoad&&n.history.ready&&R(n.currentRoute),n.afterEach((function(e,o){var i=t.skipSamePath,c=t.shouldRouterUpdate;i&&e.path===o.path||("function"!=typeof c||c(e,o))&&r.nextTick().then((function(){R(n.currentRoute)}))}))})),l.ready()})).catch((function(e){l.debug.enabled&&p(e.message)}))}p('Missing the "id" parameter. Add at least one tracking domain ID')}};var B=function(e){var n=arguments.length>1&&void 0!==arguments[1]&&arguments[1];w("send","exception",{exDescription:e,exFatal:n})},H=function(e){if(l.autoTracking.exception){window.addEventListener("error",(function(e){B(e.message)}));var n=e.config.errorHandler;e.config.errorHandler=function(e,t,r){B(e.message),l.autoTracking.exceptionLogs&&console.error(e),"function"==typeof n&&n.call(void 0,e,t,r)}}},F=B;function M(e,n){var t=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);n&&(r=r.filter((function(n){return Object.getOwnPropertyDescriptor(e,n).enumerable}))),t.push.apply(t,r)}return t}function U(e,n,t){return n in e?Object.defineProperty(e,n,{value:t,enumerable:!0,configurable:!0,writable:!0}):e[n]=t,e}var $=function(e){return"".concat(l.ecommerce.enhanced?"ec":"ecommerce",":").concat(e)},C=["addItem","addTransaction","addProduct","addImpression","setAction","addPromo","send"].reduce((function(e,n){return function(e){for(var n=1;n<arguments.length;n++){var t=null!=arguments[n]?arguments[n]:{};n%2?M(t,!0).forEach((function(n){U(e,n,t[n])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(t)):M(t).forEach((function(n){Object.defineProperty(e,n,Object.getOwnPropertyDescriptor(t,n))}))}return e}({},e,U({},n,(function(){for(var e=arguments.length,t=new Array(e),r=0;r<e;r++)t[r]=arguments[r];w.apply(void 0,[$(n)].concat(t))})))}),{}),N={event:function(){for(var e=arguments.length,n=new Array(e),t=0;t<e;t++)n[t]=arguments[t];w.apply(void 0,["send","event"].concat(n))},exception:F,page:q,query:w,require:E,set:j,social:function(){for(var e=arguments.length,n=new Array(e),t=0;t<e;t++)n[t]=arguments[t];w.apply(void 0,["send","social"].concat(n))},time:function(){for(var e=arguments.length,n=new Array(e),t=0;t<e;t++)n[t]=arguments[t];w.apply(void 0,["send","timing"].concat(n))},screenview:T,ecommerce:C,disable:function(){return L(!0)},enable:function(){return L(!1)},commands:l.commands},Q={inserted:function(e,n,t){var r=Object.keys(n.modifiers);0===r.length&&r.push("click"),r.forEach((function(r){e.addEventListener(r,(function(){var e="string"==typeof n.value?l.commands[n.value]:n.value;if(!e)throw new Error("[vue-analytics] The value passed to v-ga is not defined in the commands list.");e.apply(t.context)}))}))}};function W(e){return function(e){if(Array.isArray(e)){for(var n=0,t=new Array(e.length);n<e.length;n++)t[n]=e[n];return t}}(e)||function(e){if(Symbol.iterator in Object(e)||"[object Arguments]"===Object.prototype.toString.call(e))return Array.from(e)}(e)||function(){throw new TypeError("Invalid attempt to spread non-iterable instance")}()}function G(e,n){return function(e){if(Array.isArray(e))return e}(e)||function(e,n){if(!(Symbol.iterator in Object(e)||"[object Arguments]"===Object.prototype.toString.call(e)))return;var t=[],r=!0,o=!1,i=void 0;try{for(var c,a=e[Symbol.iterator]();!(r=(c=a.next()).done)&&(t.push(c.value),!n||t.length!==n);r=!0);}catch(e){o=!0,i=e}finally{try{r||null==a.return||a.return()}finally{if(o)throw i}}return t}(e,n)||function(){throw new TypeError("Invalid attempt to destructure non-iterable instance")}()}function z(e,n){var t=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);n&&(r=r.filter((function(n){return Object.getOwnPropertyDescriptor(e,n).enumerable}))),t.push.apply(t,r)}return t}function J(e,n,t){return n in e?Object.defineProperty(e,n,{value:t,enumerable:!0,configurable:!0,writable:!0}):e[n]=t,e}function K(e){u(function(e){for(var n=1;n<arguments.length;n++){var t=null!=arguments[n]?arguments[n]:{};n%2?z(t,!0).forEach((function(n){J(e,n,t[n])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(t)):z(t).forEach((function(n){Object.defineProperty(e,n,Object.getOwnPropertyDescriptor(t,n))}))}return e}({},arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},{$vue:e})),e.directive("ga",Q),e.prototype.$ga=e.$ga=N,H(e),_()}t.d(n,"default",(function(){return K})),t.d(n,"analyticsMiddleware",(function(){return V})),t.d(n,"onAnalyticsReady",(function(){return X})),t.d(n,"event",(function(){return Y})),t.d(n,"ecommerce",(function(){return Z})),t.d(n,"set",(function(){return ee})),t.d(n,"page",(function(){return ne})),t.d(n,"query",(function(){return te})),t.d(n,"screenview",(function(){return re})),t.d(n,"time",(function(){return oe})),t.d(n,"require",(function(){return ie})),t.d(n,"exception",(function(){return ce})),t.d(n,"social",(function(){return ae}));var V=function(e){e.subscribe((function(e){var n=e.payload;if(n&&n.meta&&n.meta.analytics){var t=n.meta.analytics;if(!Array.isArray(t))throw new Error('The "analytics" property needs to be an array');t.forEach((function(e){var n,t,r=e.shift(),o=e;if(r.includes(":")){var i=G(r.split(":"),2);r=i[0],n=i[1]}if(!(r in N))throw new Error('[vue-analytics:vuex] The type "'.concat(r,"\" doesn't exist."));if(n&&!(n in N[r]))throw new Error('[vue-analytics:vuex] The type "'.concat(r,'" has not method "').concat(n,'".'));if("ecommerce"===r&&!n)throw new Error('[vue-analytics:vuex] The type "'.concat(r,'" needs to call a method. Check documentation.'));n?(t=N[r])[n].apply(t,W(o)):N[r].apply(N,W(o))}))}}))},X=function(){return new Promise((function(e,n){var t=setInterval((function(){"undefined"!=typeof window&&window.ga&&(e(),clearInterval(t))}),10)}))},Y=N.event,Z=N.ecommerce,ee=N.set,ne=N.page,te=N.query,re=N.screenview,oe=N.time,ie=N.require,ce=N.exception,ae=N.social}])}));

/***/ })
],[16]);


// WEBPACK FOOTER //
// js/app.2ea07a0f67175a0cf450.js